'use strict';

const BASE_SET_TOTAL = 102;
const JUNGLE_SET_TOTAL = 64;
const FOSSIL_SET_TOTAL = 62;
const ROCKET_SET_TOTAL = 82;
const GYM_SET_TOTAL = 132;
const BASE_SET_TWO_TOTAL = 130;
const NEO_GENESIS_SET_TOTAL = 111;
const NEO_DISCOVERY_SET_TOTAL = 75;
const NEO_REVELATION_SET_TOTAL = 64;
const NEO_DESTINY_SET_TOTAL = 105;
const LEGENDARY_COLLECTION_SET_TOTAL = 110;
const EXPEDITION_SET_TOTAL = 165;
const AQUAPOLIS_SET_TOTAL = 147;
const SKYRIDGE_SET_TOTAL = 144;
const VS_SET_TOTAL = 141;
const WEB_SET_TOTAL = 48;
const EXPEDITION_JP_SET_TOTAL = 128;
const AQUAPOLIS_1_JP_SET_TOTAL = 92;
const AQUAPOLIS_2_JP_SET_TOTAL = 90;
const SKYRIDGE_1_JP_SET_TOTAL = 91;
const SKYRIDGE_2_JP_SET_TOTAL = 91;
const E_HOLO_SET_TOTAL = 'H32';
const CARD_HOLO_SHEETS = {
    ANIMATED_SPARKLE: 'animated-sparkle',
    ANIMATED_FIREWORKS: 'animated-fireworks',
    BASE: 'base',
    COSMOS: 'cosmos',
    COSMOS_2: 'cosmos-2',
    COSMOS_3: 'cosmos-3',
    COSMOS_4: 'cosmos-4',
    DISCO: 'disco',
    FIREWORKS: 'fireworks',
    RIPPLE: 'ripple',
    SHINING: 'shining',
    SPARKLE: 'sparkle',
    STARS: 'stars',
    SWIRL: 'swirl',
};
const CARD_TEMPLATES = {
    BASE: 'base',
    GYM: 'gym',
    NEO: 'neo',
    LEGENDARY_REVERSE: 'legendary-reverse',
    E_SERIES: 'e-series',
    VS: 'vs',
    WEB: 'web',
    TRAINER: 'trainer',
    TRAINER_E_SERIES: 'trainer-e-series',
    TRAINER_VS: 'trainer-vs',
    ENERGY: 'energy',
    ENERGY_E_SERIES: 'energy-e-series',
    ENERGY_VS: 'energy-vs',
};
const SPECIAL_CARD_TEMPLATES = {
    CRYSTAL: 'crystal',
    FOSSIL: 'fossil',
};
const CARD_TEMPLATE_SUBTYPES = {
    BABY: 'baby',
    SHINING: 'shining',
    UNOWN: 'unown',
};
const DAMAGE_MODIFIER_VALUES = {
    PLUS: '+',
    MINUS: '-',
    TIMES: 'x',
};
const ENERGY_TYPES = {
    COLORLESS: 'colorless',
    DARKNESS: 'darkness',
    FIGHTING: 'fighting',
    FIRE: 'fire',
    GRASS: 'grass',
    LIGHTNING: 'lightning',
    METAL: 'metal',
    PSYCHIC: 'psychic',
    WATER: 'water',
};
const SPECIAL_ENERGY_TYPES = {
    CRYSTAL: 'crystal',
    RAINBOW: 'rainbow',
};
const ILLUSTRATORS = {
    AKABANE: 'Takumi Akabane',
    AOKI: 'Toshinao Aoki',
    ARITA: 'Mitsuhiro Arita',
    CR_CG_GANGS: 'CR CG gangs',
    FUKUYAMA: 'Keiko Fukuyama',
    HIMENO: 'Kagemaru Himeno',
    HIRONOBU: 'Hironobu Yoshida',
    HOSHIBA: 'K. Hoshiba',
    KAZAMA: 'Hideki Kazama',
    KIMURA: 'Naoyo Kimura',
    KINEBUCHI: 'Keiji Kinebuchi',
    KIZUKI: 'Sumiyoshi Kizuki',
    KOMIYA: 'Tomokazu Komiya',
    KUSAJIMA: 'Hajime Kusajima',
    KUSUBE: 'Aya Kusube',
    MASAGO: 'Kimiya Masago',
    MORII: 'Yuka Morii',
    NISHIDA: 'Atsuko Nishida',
    NOMOTO: 'Gakuji Nomoto',
    RUSH: 'Christopher Rush',
    SUGIMORI: 'Ken Sugimori',
    SUGIYAMA: 'Hiromichi Sugiyama',
    TABATA: 'Katsura Tabata',
    TAGAWA: '"Big Mama" Tagawa',
    TANAKA: 'Miki Tanaka',
    TURVEY: 'Craig Turvey',
    YAMASHITA: 'Masako Yamashita',
    YOSHIDA: 'Shin-ichi Yoshida',
    YUYAMA: 'Kunihiko Yuyama',
};
const ILLUSTRATORS_TEAMS = {
    HOSHIBA_GANGS: `${ILLUSTRATORS.HOSHIBA}, ${ILLUSTRATORS.CR_CG_GANGS}`,
    TAGAWA_GANGS: `${ILLUSTRATORS.TAGAWA}, ${ILLUSTRATORS.CR_CG_GANGS}`,
};
const RARITY_TYPES = {
    SHINING: 'shining',
    RARE: 'rare',
    UNCOMMON: 'uncommon',
    COMMON: 'common',
};
const POKE_POWER_LABEL = 'Pokémon Power';
const POKE_BODY_LABEL = 'Poké Body';
const DONT_APPLY_WEAKNESS_BENCHED = "<em>(Don't apply Weakness and Resistance for Benched Pokémon.)</em>";
const DONT_APPLY_WEAKNESS = "<em>(Don't apply Weakness and Resistance.)</em>";
const BASIC_PKMN_LABEL = 'Basic Pokémon';
const WOTC_SHADOWLESS_COPYRIGHT = '©1995, 96, 98, 99 Nintendo, Creatures, GAMEFREAK. ©1999 Wizards.';
const WOTC_EARLY_ERA_COPYRIGHT = '©1995, 96, 98 Nintendo, Creatures, GAMEFREAK. ©1999 Wizards.';
const WOTC_LATE_ERA_COPYRIGHT = '©1995, 96, 98 Nintendo, Creatures, GAMEFREAK. ©1999-2000 Wizards.';
const WOTC_1995_2000_COPYRIGHT = '©1995-2000 Nintendo, Creatures, GAMEFREAK.';
const WOTC_1995_2001_COPYRIGHT = '©1995-2001 Nintendo, Creatures, GAMEFREAK.';
const WOTC_2002_COPYRIGHT = '©2002 Pokémon, Nintendo';
const WOTC_E_2002_COPYRIGHT = '©2002 Pokémon/Nintendo';
const WOTC_E_2003_COPYRIGHT = '©2003 Pokémon/Nintendo';
const MEDIA_FACTORY_E_COPYRIGHT = '©Pokémon';
const NEO_ERA_COPYRIGHT = WOTC_1995_2000_COPYRIGHT;
const COPYRIGHTS = {
    BASE_SET: WOTC_SHADOWLESS_COPYRIGHT,
    BASE_2_SET: WOTC_LATE_ERA_COPYRIGHT,
    JUNGLE_SET: WOTC_EARLY_ERA_COPYRIGHT,
    FOSSIL_SET: WOTC_EARLY_ERA_COPYRIGHT,
    ROCKET_SET: WOTC_LATE_ERA_COPYRIGHT,
    GYM_SET: WOTC_LATE_ERA_COPYRIGHT,
    LEGENDARY_COLLECTION_SET: WOTC_E_2002_COPYRIGHT,
    NEO_SET: NEO_ERA_COPYRIGHT,
    BEST_OF_GAME_SET: WOTC_2002_COPYRIGHT,
    EXPEDITION_SET: WOTC_E_2002_COPYRIGHT,
    AQUAPOLIS_SET: WOTC_E_2002_COPYRIGHT,
    SKYRIDGE_SET: WOTC_E_2003_COPYRIGHT,
    VS_SET: MEDIA_FACTORY_E_COPYRIGHT,
    POKE_TCG: '© 2021 PokéTCGShop Custom NFT Card',
};
const STAMP_TYPES = {
    PRERELEASE: 'prerelease',
    WINNER: 'winner',
    WIZARDS: 'wizards',
};
const POKE_SPECIAL_MOVE_TYPES = {
    POKE_BODY: 'poke-body',
    POKE_POWER: 'poke-power',
};
const BLEND_MODES = {
    NORMAL: 'normal',
    MULTIPLY: 'multiply',
    SCREEN: 'screen',
    OVERLAY: 'overlay',
    DARKEN: 'darken',
    LIGHTEN: 'lighten',
    COLOR_DODGE: 'color-dodge',
    COLOR_BURN: 'color-burn',
    HARD_LIGHT: 'hard-light',
    SOFT_LIGHT: 'soft-light',
    DIFFERENCE: 'difference',
    EXCLUSION: 'exclusion',
    HUE: 'hue',
    SATURATION: 'saturation',
    COLOR: 'color',
    LUMINOSITY: 'luminosity',
};
const SET_DESCRIPTIONS = {
    BASE: 'Base Set (Japanese: 拡張パック Expansion Pack) is the name given to the first main expansion of cards of the Pokémon Trading Card Game.',
    JUNGLE: 'Jungle (Japanese: ポケモンジャングル Pokémon Jungle) is the name given to the second main expansion of cards of the Pokémon Trading Card Game. The set continues to feature Generation I Pokémon in the card game.',
    FOSSIL: 'Fossil is the name given to the third main expansion of the Pokémon Trading Card Game. It is based on Pokémon Red, Blue, and Green, featuring Generation I Pokémon and Fossil Pokémon. The English expansion was released on October 10, 1999, while the Japanese expansion was released on June 21, 1997.',
    ROCKET: 'The Team Rocket set was the third expansion. As all Pokémon were covered, the cards went on to focus on the evil team from the Pokémon games; Team Rocket. This set introduced different varieties of Pokémon, in this case; Dark Pokémon.',
    BASE_2: 'Base Set 2 is composed of reprints of the Base Set and Jungle expansions. Base Set 2 was the first expansion to use the Galaxy Star Holofoil.',
    GYM_HEROES: "Gym Heroes (Japanese: ジム拡張第1弾 リーダーズスタジアム Gym Expansion 1 Leaders' Stadium) is the name given to the sixth main expansion of cards of the Pokémon Trading Card Game. It is the fifth main expansion of the Pokémon Card Game in Japan. The set continues to feature Generation I Pokémon in the card game.",
    GYM_CHALLENGE: 'Gym Challenge (Japanese: ジム拡張第2弾 闇からの挑戦 Gym Expansion 2 Challenge from the Darkness) is the name given to the seventh main expansion of cards of the Pokémon Trading Card Game. It is the sixth main expansion of the Pokémon Card Game in Japan. The set continues to feature Generation I Pokémon in the card game.',
    BEST_OF_GAME: 'The Best of Game is the name of a special collection of cards for the Pokémon Trading Card Game, commemorating some of the best cards to be produced by Wizards of the Coast.',
    BLACK_STAR_PROMO: 'Wizards produced a total of 53 numbered Promotional cards before they lost their license. Had they kept their rights to produce the cards longer, it is likely more Promotional cards would have been produced, as the Vending Machine cards were a collection Wizards certainly planned to bring into English. Most of these cards were speculated to have been released in Jamboree with the remainder as promotional cards. All cards were previously released as promotional cards or in special promotional sets in Japan, with the exception of Mew (#8 and #9), which appeared in the Japanese Fossil expansion.',
    LEGENDARY_COLLECTION: 'Originally named "Base 3", some of the most popular cards in the set are Charizard, Blastoise, Venusaur, and Pikachu.',
    NEO_GENESIS: 'Pokémon: Neo Genesis (Japanese: 金、銀、新世界へ... Gold, Silver, to a New World...) is the name given to the first main expansion of cards from the Neo Series of the Pokémon Trading Card Game (the neo Era in Japan). The set is the first to feature Generation II Pokémon in the card game.',
    NEO_DISCOVERY: 'Neo Discovery (Japanese: 遺跡をこえて... Crossing the Ruins...) is the name given to the second main expansion of cards from the Neo Series of the Pokémon Trading Card Game (the neo Era in Japan). The set continues to feature Generation II Pokémon in the card game.',
    NEO_REVELATION: 'Neo Revelation (Japanese: めざめる伝説 Awakening Legends) is the name given to the third main expansion of cards from the Neo Series of the Pokémon Trading Card Game (the neo Era in Japan). The set continues to feature Generation II Pokémon in the card game.',
    NEO_DESTINY: 'Neo Destiny (Japanese: 闇、そして光へ... Darkness, and to Light...) is the name given to the fourth and final main expansion of cards from the Neo Series of the Pokémon Trading Card Game (the neo Era in Japan). The set continues to feature Generation II Pokémon in the card game.',
    EXPEDITION: 'Pokémon-e: Expedition Base Set (Japanese: 基本拡張パック Base Expansion Pack) is the name given to the first main expansion of cards from the e-Card Series of the Pokémon Trading Card Game (the e-Card Era in Japan).',
    AQUAPOLIS: 'Pokémon-e: Aquapolis (Japanese: 地図にない町 The Town on No Map and 海からの風 Wind from the Sea) is the name given to the second main expansion of cards from the e-Card Series of the Pokémon Trading Card Game. It is the second and third main expansions from the e-Card Era of the Pokémon Card Game in Japan.',
    SKYRIDGE: 'Pokémon-e: Skyridge (Japanese: 裂けた大地 Split Earth and 神秘なる山 Mysterious Mountains) is the name given to the third and final main expansion of cards from the e-Card Series of the Pokémon Trading Card Game. It is the fourth and fifth main expansions from the e-Card Era of the Pokémon Card Game in Japan.',
    VS: 'Pokémon VS (Japanese: ポケモンカード★VS Pokémon Card★VS) is the only main expansion of cards from the VS Era of the Pokémon Card Game in Japan. It does not have a main expansion as an English equivalent.',
    SOUTHERN_ISLANDS: 'The Southern Islands Collection (Japanese: サザンアイランド Southern Islands) is the name given to a special set of cards for the Pokémon Trading Card Game.',
    WEB: 'Pokémon Web (Japanese: ポケモンカード★web Pokémon Card★web) is the only main expansion of cards from the web Era of the Pokémon Card Game in Japan. It does not have a main expansion as an English equivalent.',
};
const RELEASE_DATES = {
    BASE: 'January 1999',
    JUNGLE: 'June 16, 1999',
    FOSSIL: 'October 10, 1999',
    BASE_2: 'February 24, 2000',
    ROCKET: 'April 24, 2000',
    GYM_HEROES: 'August 14, 2000',
    GYM_CHALLENGE: 'October 16, 2000',
    BEST_OF_GAME: 'December 2002 - July 2003',
    BLACK_STAR_PROMO: 'July 1999 - July 2003',
    LEGENDARY_COLLECTION: 'May 24, 2002',
    NEO_GENESIS: 'December 16, 2000',
    NEO_DISCOVERY: 'June 1, 2001',
    NEO_REVELATION: 'September 21, 2001',
    NEO_DESTINY: 'February 28, 2002',
    EXPEDITION: 'September 15, 2002',
    AQUAPOLIS: 'January 15, 2003',
    SKYRIDGE: 'May 12, 2003',
    VS: 'July 19, 2001',
    WEB: 'October 20, 2001',
    SOUTHERN_ISLANDS: 'July 31, 2001',
};
const PACK_CARD_KEYS = {
    COMMON: 'C',
    UNCOMMON: 'U',
    RARE: 'R',
    HOLO_RARE_OR_SHINING: 'H/R/S',
    HOLO_OR_RARE: 'H/R',
    HOLO_OR_COMMON: 'H/C',
    HOLO_COMMON_OR_CRYSTAL: 'H/C/Y',
    ENERGY: 'E',
    REVERSE_HOLO: 'RH',
};
const TRAINER_CARD_SUBTITLES = {
    GOLDENROD_GAME_CORNER: '(Goldenrod Game Corner)',
    POKEMON_TOOL: 'Pokémon Tool',
    ROCKETS_SECRET_MACHINE: "(Rocket's Secret Machine)",
    ROCKETS_SECRET_ROBOT: "(Rocket's Secret Robot)",
    STADIUM_CARD: 'Stadium Card',
    SUPPORTER: 'Supporter',
    TECHNICAL_MACHINE: 'Technical Machine',
};
const DOT_MATRIX_POSITIONS = {
    BOTTOM_ONLY: 'bottom-only',
    LEFT_AND_BOTTOM: 'left-and-bottom',
};

const CARD_SETS = {
    BASE: {
        label: 'Base',
        value: 'base-set',
    },
    JUNGLE: {
        label: 'Jungle',
        value: 'jungle',
    },
    FOSSIL: {
        label: 'Fossil',
        value: 'fossil',
    },
    TEAM_ROCKET: {
        label: 'Team Rocket',
        value: 'team-rocket',
    },
    BASE_2: {
        label: 'Base Set 2',
        value: 'base-set-2',
    },
    GYM_HEROES: {
        label: 'Gym Heroes',
        value: 'gym-heroes',
    },
    GYM_CHALLENGE: {
        label: 'Gym Challenge',
        value: 'gym-challenge',
    },
    LEGENDARY_COLLECTION: {
        label: 'Legendary Collection',
        value: 'legendary-collection',
    },
    NEO_GENESIS: {
        label: 'Neo Genesis',
        value: 'neo-genesis',
    },
    NEO_DISCOVERY: {
        label: 'Neo Discovery',
        value: 'neo-discovery',
    },
    NEO_REVELATION: {
        label: 'Neo Revelation',
        value: 'neo-revelation',
    },
    NEO_DESTINY: {
        label: 'Neo Destiny',
        value: 'neo-destiny',
    },
    SOUTHERN_ISLANDS: {
        label: 'Southern Islands',
        value: 'southern-islands',
    },
    BLACK_STAR_PROMO: {
        label: 'Black Star Promo',
        value: 'black-star-promo',
    },
    BEST_OF_GAME: {
        label: 'Best Of Game',
        value: 'best-of-game',
    },
    EXPEDITION: {
        label: 'Expedition',
        value: 'expedition',
    },
    AQUAPOLIS: {
        label: 'Aquapolis',
        value: 'aquapolis',
    },
    SKYRIDGE: {
        label: 'Skyridge',
        value: 'skyridge',
    },
};
const CARD_SETS_JPN = {
    BASE: {
        label: 'Expansion Pack',
        value: 'base-jp',
    },
    JUNGLE: {
        label: 'Pokémon Jungle',
        value: 'pokemon-jungle',
    },
    FOSSIL: {
        label: 'Mystery of the Fossils',
        value: 'mystery-of-the-fossils',
    },
    TEAM_ROCKET: {
        label: 'Rocket Gang',
        value: 'rocket-gang',
    },
    GYM_HEROES: {
        label: "Leaders' Stadium",
        value: 'leaders-stadium',
    },
    GYM_CHALLENGE: {
        label: 'Challenge from the Darkness',
        value: 'challenge-from-the-darkness',
    },
    NEO_GENESIS: {
        label: 'Gold, Silver, to a New World...',
        value: 'gold-silver-to-a-new-world',
    },
    NEO_DISCOVERY: {
        label: 'Crossing the Ruins...',
        value: 'crossing-the-ruins',
    },
    NEO_REVELATION: {
        label: 'Awakening Legends',
        value: 'awakening-legends',
    },
    NEO_DESTINY: {
        label: 'Darkness, and to Light...',
        value: 'darkness-and-to-light',
    },
    SOUTHERN_ISLANDS: {
        label: 'Southern Islands',
        value: 'southern-islands-jp',
    },
    EXPEDITION: {
        label: 'Base Expansion Pack',
        value: 'base-expansion-pack',
    },
    AQUAPOLIS_1: {
        label: 'The Town on No Map',
        value: 'the-town-on-no-map',
    },
    AQUAPOLIS_2: {
        label: 'Wind from the Sea',
        value: 'wind-from-the-sea',
    },
    SKYRIDGE_1: {
        label: 'Split Earth',
        value: 'split-earth',
    },
    SKYRIDGE_2: {
        label: 'Mysterious Mountains',
        value: 'mysterious-mountains',
    },
    VS: {
        label: 'Pokémon VS',
        value: 'vs',
    },
    WEB: {
        label: 'Pokémon Web',
        value: 'web',
    },
    P_PROMOTIONAL_CARDS: {
        label: 'P Promotional Cards',
        value: 'p-promotional-cards',
    },
    T_PROMOTIONAL_CARDS: {
        label: 'T Promotional Cards',
        value: 't-promotional-cards',
    },
    VENDING: {
        label: 'Vending',
        value: 'vending',
    },
    GB_PROMO: {
        label: 'GB Promo',
        value: 'gb-promo',
    },
};
const ENGLISH_FIRST_EDITION_SETS = [
    CARD_SETS.BASE.value,
    CARD_SETS.FOSSIL.value,
    CARD_SETS.GYM_CHALLENGE.value,
    CARD_SETS.GYM_HEROES.value,
    CARD_SETS.JUNGLE.value,
    CARD_SETS.NEO_DESTINY.value,
    CARD_SETS.NEO_DISCOVERY.value,
    CARD_SETS.NEO_GENESIS.value,
    CARD_SETS.NEO_REVELATION.value,
    CARD_SETS.TEAM_ROCKET.value,
];
const ENGLISH_PROMO_SETS = [
    CARD_SETS.SOUTHERN_ISLANDS.value,
    CARD_SETS.BLACK_STAR_PROMO.value,
    CARD_SETS.BEST_OF_GAME.value,
];

const { COMMON, ENERGY, HOLO_OR_COMMON, HOLO_COMMON_OR_CRYSTAL, HOLO_OR_RARE, HOLO_RARE_OR_SHINING, UNCOMMON, RARE, REVERSE_HOLO, } = PACK_CARD_KEYS;
const BOOSTER_PACKS = {
    BASE: {
        cardOrder: [
            COMMON,
            COMMON,
            COMMON,
            COMMON,
            COMMON,
            ENERGY,
            ENERGY,
            HOLO_OR_RARE,
            UNCOMMON,
            UNCOMMON,
            UNCOMMON,
        ],
        packArts: 3,
    },
    JUNGLE: {
        cardOrder: [
            COMMON,
            COMMON,
            COMMON,
            COMMON,
            COMMON,
            COMMON,
            COMMON,
            HOLO_OR_RARE,
            UNCOMMON,
            UNCOMMON,
            UNCOMMON,
        ],
        packArts: 3,
    },
    FOSSIL: {
        cardOrder: [
            COMMON,
            COMMON,
            COMMON,
            COMMON,
            COMMON,
            COMMON,
            COMMON,
            HOLO_OR_RARE,
            UNCOMMON,
            UNCOMMON,
            UNCOMMON,
        ],
        packArts: 3,
    },
    ROCKET: {
        cardOrder: [
            COMMON,
            COMMON,
            COMMON,
            COMMON,
            COMMON,
            COMMON,
            COMMON,
            HOLO_OR_RARE,
            UNCOMMON,
            UNCOMMON,
            UNCOMMON,
        ],
        packArts: 4,
    },
    BASE_SET_TWO: {
        cardOrder: [
            UNCOMMON,
            UNCOMMON,
            UNCOMMON,
            COMMON,
            COMMON,
            COMMON,
            COMMON,
            COMMON,
            HOLO_OR_RARE,
            ENERGY,
            ENERGY,
        ],
        packArts: 4,
    },
    GYM_HEROES: {
        cardOrder: [
            COMMON,
            COMMON,
            COMMON,
            COMMON,
            COMMON,
            COMMON,
            HOLO_OR_RARE,
            UNCOMMON,
            UNCOMMON,
            UNCOMMON,
            ENERGY,
        ],
        packArts: 4,
    },
    GYM_CHALLENGE: {
        cardOrder: [
            COMMON,
            COMMON,
            COMMON,
            COMMON,
            COMMON,
            COMMON,
            UNCOMMON,
            UNCOMMON,
            UNCOMMON,
            HOLO_OR_RARE,
            ENERGY,
        ],
        packArts: 4,
    },
    LEGENDARY_COLLECTION: {
        cardOrder: [
            COMMON,
            COMMON,
            COMMON,
            COMMON,
            COMMON,
            ENERGY,
            ENERGY,
            HOLO_OR_RARE,
            UNCOMMON,
            UNCOMMON,
            REVERSE_HOLO,
        ],
        packArts: 4,
    },
    NEO_GENESIS: {
        cardOrder: [
            COMMON,
            COMMON,
            COMMON,
            COMMON,
            COMMON,
            COMMON,
            COMMON,
            HOLO_OR_RARE,
            UNCOMMON,
            UNCOMMON,
            UNCOMMON,
        ],
        packArts: 4,
    },
    NEO_DISCOVERY: {
        cardOrder: [
            COMMON,
            COMMON,
            COMMON,
            COMMON,
            COMMON,
            COMMON,
            COMMON,
            HOLO_OR_RARE,
            UNCOMMON,
            UNCOMMON,
            UNCOMMON,
        ],
        packArts: 4,
    },
    NEO_REVELATION: {
        cardOrder: [
            COMMON,
            COMMON,
            COMMON,
            COMMON,
            COMMON,
            COMMON,
            COMMON,
            HOLO_RARE_OR_SHINING,
            UNCOMMON,
            UNCOMMON,
            UNCOMMON,
        ],
        packArts: 4,
    },
    NEO_DESTINY: {
        cardOrder: [
            COMMON,
            COMMON,
            COMMON,
            COMMON,
            COMMON,
            COMMON,
            COMMON,
            HOLO_RARE_OR_SHINING,
            UNCOMMON,
            UNCOMMON,
            UNCOMMON,
        ],
        packArts: 4,
    },
    EXPEDITION: {
        cardOrder: [
            COMMON,
            COMMON,
            COMMON,
            COMMON,
            HOLO_OR_COMMON,
            REVERSE_HOLO,
            RARE,
            UNCOMMON,
            UNCOMMON,
        ],
        packArts: 4,
    },
    AQUAPOLIS: {
        cardOrder: [
            COMMON,
            COMMON,
            COMMON,
            COMMON,
            HOLO_COMMON_OR_CRYSTAL,
            REVERSE_HOLO,
            RARE,
            UNCOMMON,
            UNCOMMON,
        ],
        packArts: 4,
    },
    SKYRIDGE: {
        cardOrder: [
            COMMON,
            COMMON,
            COMMON,
            COMMON,
            HOLO_COMMON_OR_CRYSTAL,
            REVERSE_HOLO,
            RARE,
            UNCOMMON,
            UNCOMMON,
        ],
        packArts: 4,
    },
};

const POKEMON_IMAGES = {
    BULBASAUR: [
        {
            label: 'Evolution Box',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/bulbasaur/bulbasaur-evo-box.png',
        },
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/bulbasaur/bulbasaur-base_wifgo2.png',
        },
        {
            label: 'Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/bulbasaur/bulbasaur-gym-challenge_y0a4t9.png',
        },
    ],
    IVYSAUR: [
        {
            label: 'Evo Box / Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/ivysaur/ivysaur-base_xdhhxn.png',
        },
        {
            label: 'Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/ivysaur/ivysaur-gym-challenge_wjvhrt.png',
        },
        {
            label: 'Best Of Game',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/ivysaur/ivysaur-best-of.jpg',
        },
        {
            label: 'Southern Islands',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/ivysaur/ivysaur-southern-islands.jpg',
        },
    ],
    VENUSAUR: [
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/venusaur/venusaur-base_vtorgu.png',
        },
        {
            label: 'Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/venusaur/venusaur-gym-challenge_cb4iyc.png',
        },
        {
            label: 'Best Of Game',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/venusaur/venusaur-best-of.jpg',
        },
        {
            label: 'Animated',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/venusaur/venusaur-animated_miou3b.gif',
        },
    ],
    CHARMANDER: [
        {
            label: 'Evolution Box',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/charmander/charmander-evo-box.png',
        },
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/charmander/charmander-base-full_w8vbtq.png',
        },
        {
            label: 'Team Rocket',
            value: '',
        },
        {
            label: 'Gym Heroes',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/charmander/charmander-gym-heroes_bifcvx.png',
        },
        {
            label: 'Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/charmander/charmander-gym-challenge_qdlgrj.png',
        },
    ],
    CHARMELEON: [
        {
            label: 'Evolution Box',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/charmeleon/charmeleon-base_rzvyus.png',
        },
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/charmeleon/charmeleon-base-alt_fxcuxr.png',
        },
        {
            label: 'Team Rocket',
            value: '',
        },
        {
            label: 'Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/charmeleon/charmeleon-gym-challenge_p0utpj.png',
        },
    ],
    CHARIZARD: [
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/charizard/charizard-base_dxulih.png',
        },
        {
            label: 'Team Rocket',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/charizard/charizard-rocket_e8fmti.png',
        },
        {
            label: 'Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/charizard/charizard-gym-challenge_uzdq3o.png',
        },
        {
            label: 'Neo Destiny',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/charizard/charizard-destiny.png',
        },
        {
            label: 'Expedition A',
            value: '',
        },
        {
            label: 'Expedition B',
            value: '',
        },
        {
            label: 'Skyridge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/charizard/charizard-skyridge.png',
        },
        {
            label: 'Animated',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/charizard/charizard-animated_dyruwf.gif',
        },
    ],
    SQUIRTLE: [
        {
            label: 'Evolution Box',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/squirtle/squirtle-evo-box.png',
        },
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/squirtle/squirtle-base_z29xlu.png',
        },
        {
            label: 'Team Rocket',
            value: '',
        },
    ],
    WARTORTLE: [
        {
            label: 'Evo Box / Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/wartortle/wartortle-base_y8ehhr.png',
        },
        {
            label: 'Team Rocket',
            value: '',
        },
        {
            label: 'Southern Islands',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/wartortle/wartortle-southern-islands.jpg',
        },
    ],
    BLASTOISE: [
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/blastoise/blastoise-base_fkepro.png',
        },
        {
            label: 'Team Rocket',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/blastoise/blastoise-rocket_l1uqof.png',
        },
        {
            label: 'Animated',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/blastoise/blastoise-animated_u9avrm.gif',
        },
    ],
    CATERPIE: [
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/caterpie/caterpie-base_v5l4v1.png',
        },
        {
            label: 'Neo Discovery',
            value: '',
        },
    ],
    METAPOD: [
        {
            label: 'Evo Box / Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/metapod/metapod-base_dovsza.png',
        },
        {
            label: 'Neo Discovery',
            value: '',
        },
    ],
    BUTTERFREE: [
        {
            label: 'Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/butterfree/butterfree-jungle.png',
        },
        {
            label: 'Neo Discovery',
            value: '',
        },
        {
            label: 'Southern Islands',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/butterfree/butterfree-southern-islands.jpg',
        },
    ],
    WEEDLE: [
        {
            label: 'Evo Box / Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/weedle/weedle-gym-challenge_bpprdl.png',
        },
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/weedle/weedle-base.png',
        },
        {
            label: 'Neo Discovery',
            value: '',
        },
    ],
    KAKUNA: [
        {
            label: 'Evo Box / Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/kakuna/kakuna-gym-challenge_ima9mg.png',
        },
        {
            label: 'Base',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/kakuna/kakuna-base.png',
        },
        {
            label: 'Neo Discovery',
            value: '',
        },
    ],
    BEEDRILL: [
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/beedrill/beedrill-base_ak9oxq.png',
        },
        {
            label: 'Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/beedrill/beedrill-gym-challenge_ehtza5.png',
        },
        {
            label: 'Neo Discovery',
            value: '',
        },
    ],
    PIDGEY: [
        {
            label: 'Evo Box / Base',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/pidgey/pidgey-base_saarx4.png',
        },
        {
            label: 'Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/pidgey/pidgey-gym-challenge_armsgy.png',
        },
    ],
    PIDGEOTTO: [
        {
            label: 'Evo Box / Base',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/pidgeotto/pidgeotto-base_tr3ovx.png',
        },
        {
            label: 'Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/pidgeotto/pidgeotto-gym-challenge_slkwdm.png',
        },
    ],
    PIDGEOT: [
        {
            label: 'Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/pidgeot/pidgeot-jungle_ohubga.png',
        },
        {
            label: 'Southern Islands',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/pidgeot/pidgeot-southern-islands.jpg',
        },
        {
            label: 'Animated',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/pidgeot/pidgeot-animated_rgjgsc.gif',
        },
    ],
    RATTATA: [
        {
            label: 'Evolution Box',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/rattata/rattata-evo-box_ldokkf.png',
        },
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/rattata/rattata-base.png',
        },
        {
            label: 'Team Rocket',
            value: '',
        },
        {
            label: 'Gym Heroes',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/rattata/rattata-gym-heroes_ybfrjf.png',
        },
    ],
    RATICATE: [
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/raticate/raticate-base_m5yhpi.png',
        },
        {
            label: 'Gym Heroes',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/raticate/raticate-gym-heroes_lxtdzj.png',
        },
        {
            label: 'Gym Challenge',
            value: '',
        },
        {
            label: 'Southern Islands',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/raticate/raticate-southern-islands.jpg',
        },
    ],
    SPEAROW: [
        {
            label: 'Evolution Box',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/spearow/spearow-evo-box_ztl2vh.png',
        },
        {
            label: 'Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/spearow/spearow-jungle.jpg',
        },
        {
            label: 'Gym Heroes',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/spearow/spearow-gym-heroes_wkzrko.png',
        },
    ],
    FEAROW: [
        {
            label: 'Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/fearow/fearow-jungle.png',
        },
        {
            label: 'Gym Heroes',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/fearow/fearow-gym-heroes_xwkht6.png',
        },
    ],
    EKANS: [
        {
            label: 'Evo Box / Rocket',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/ekans/ekans-evo-box_yiqsfa.png',
        },
        {
            label: 'Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/ekans/ekans-gym-challenge_dpwbvv.png',
        },
    ],
    ARBOK: [
        {
            label: 'Fossil',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/arbok/arbok-fossil_u0pxrv.png',
        },
        {
            label: 'Team Rocket',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/arbok/arbok-rocket_px3nrj.png',
        },
        {
            label: 'Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/arbok/arbok-gym-challenge_cizapp.png',
        },
    ],
    PIKACHU: [
        {
            label: 'Evo Box / Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/pikachu/pikachu-base_zhqtgw.png',
        },
        {
            label: 'Base Set A',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/pikachu/pikachu-base-yellow.png',
        },
        {
            label: 'Base Set B',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/pikachu/pikachu-base-red.png',
        },
        {
            label: 'Neo Genesis',
            value: '',
        },
        {
            label: 'Promo - Ivy',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/pikachu/pikachu-promo-ivy_ztgth3.png',
        },
        {
            label: 'Promo - Movie',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/pikachu/pikachu-promo-movie_jois6j.png',
        },
    ],
    RAICHU: [
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/raichu/raichu-base_cv1tso.png',
        },
        {
            label: 'Fossil',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/raichu/raichu-fossil_e0gbsc.png',
        },
        {
            label: 'Team Rocket',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/raichu/raichu-rocket_s8ag2t.png',
        },
        {
            label: 'Gym Heroes',
            value: '',
        },
        {
            label: 'Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/raichu/raichu-gym-challenge_uytcrw.png',
        },
        {
            label: 'Neo Revelation',
            value: '',
        },
        {
            label: 'Neo Destiny',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/raichu/raichu-neo-destiny-shining.png',
        },
        {
            label: 'Expedition',
            value: '',
        },
        {
            label: 'Skyridge',
            value: '',
        },
        {
            label: 'Animated',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/raichu/raichu-animated_xo6pwj.gif',
        },
    ],
    SANDSHREW: [
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/sandshrew/sandshrew-base_c9cmv1.png',
        },
        {
            label: 'Gym Heroes',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/sandshrew/sandshrew-gym-heroes_mkibyj.png',
        },
    ],
    SANDSLASH: [
        {
            label: 'Fossil',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/sandslash/sandslash-fossil_mwbk7m.png',
        },
        {
            label: 'Gym Heroes',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/sandslash/sandslash-gym-heroes_vedg0l.png',
        },
    ],
    NIDORAN_F: [
        {
            label: 'Evo Box / Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/nidoran-f/nidoran-f-evo-box_t55lgk.png',
        },
        {
            label: 'Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/nidoran-f/nidoran-f-gym-challenge_i3jf94.png',
        },
    ],
    NIDORINA: [
        {
            label: 'Evo Box / Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/nidorina/nidorina-evo-box_gybcny.png',
        },
        {
            label: 'Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/nidorina/nidorina-gym-challenge_vof67m.png',
        },
    ],
    NIDOQUEEN: [
        {
            label: 'Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/nidoqueen/nidoqueen-jungle_blt17k.png',
        },
        {
            label: 'Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/nidoqueen/nidoqueen-gym-challenge_ymuhfd.png',
        },
        {
            label: 'Animated',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/nidoqueen/nidoqueen-animated_yamkba.gif',
        },
    ],
    NIDORAN_M: [
        {
            label: 'Evo Box / Base',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/nidoran-m/nidoran-m-evo-box_utwywd.png',
        },
        {
            label: 'Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/nidoran-m/nidoran-m-gym-challenge_izn3ah.png',
        },
    ],
    NIDORINO: [
        {
            label: 'Evolution Box',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/nidorino/nidorino-base_fjwb8x.png',
        },
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/nidorino/nidorino-base.png',
        },
        {
            label: 'Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/nidorino/nidorino-gym-challenge_emxii4.png',
        },
    ],
    NIDOKING: [
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/nidoking/nidoking-base_roivfp.png',
        },
        {
            label: 'Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/nidoking/nidoking-gym-challenge_tigorn.png',
        },
        {
            label: 'Animated',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/nidoking/nidoking-animated_vyjs1t.gif',
        },
    ],
    CLEFAIRY: [
        {
            label: 'Evo Box / Base',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/clefairy/clefairy-base_v5e3zm.png',
        },
        {
            label: 'Gym Heroes A',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/clefairy/clefairy-gym-heroes_y43cgw.png',
        },
        {
            label: 'Gym Heroes B',
            value: '',
        },
        {
            label: 'Neo Genesis',
            value: '',
        },
        {
            label: 'Animated',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/clefairy/clefairy-animated_quijh6.gif',
        },
    ],
    CLEFABLE: [
        {
            label: 'Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/clefable/clefable-jungle_czczyp.png',
        },
        {
            label: 'Gym Heroes',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/clefable/clefable-gym-heroes_hob1uk.png',
        },
        {
            label: 'Animated',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/clefable/clefable-animated_mshxki.gif',
        },
    ],
    VULPIX: [
        {
            label: 'Evolution Box',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/vulpix/vulpix-base_tcuwjf.png',
        },
        {
            label: 'Gym Heroes',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/vulpix/vulpix-gym-heroes_ihrim6.png',
        },
        {
            label: 'Gym Heroes',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/vulpix/vulpix-gym-heroes-alt_ro9z2s.png',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    NINETALES: [
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/ninetales/ninetales-base_hozg0q.png',
        },
        {
            label: 'Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/ninetales/ninetales-gym-challenge_orha9j.png',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
        {
            label: 'Animated',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/ninetales/ninetales-animated_qtl9u7.gif',
        },
    ],
    JIGGLYPUFF: [
        {
            label: 'Evolution Box',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/jigglypuff/jigglypuff-evo-box_kp3anu.png',
        },
        {
            label: 'Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/jigglypuff/jigglypuff-jungle_z9tvke.png',
        },
        {
            label: 'Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/jigglypuff/jigglypuff-gym-challenge_v1dtfh.png',
        },
        {
            label: 'Black Star Promo',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/jigglypuff/jigglypuff-bs-promo_cnljtu.png',
        },
        {
            label: 'Southern Islands',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/jigglypuff/jigglypuff-southern-islands.jpg',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    WIGGLYTUFF: [
        {
            label: 'Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/wigglytuff/wigglytuff-jungle_az4fmp.png',
        },
        {
            label: 'Neo Destiny A',
            value: '',
        },
        {
            label: 'Neo Destiny B',
            value: '',
        },
        {
            label: 'Animated',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/wigglytuff/wigglytuff-animated_nlw6td.gif',
        },
    ],
    ZUBAT: [
        {
            label: 'Evolution Box',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/zubat/zubat-evo-box_myergf.png',
        },
        {
            label: 'Gym Heroes A',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/zubat/zubat-gym-heroes_pttycb.png',
        },
        {
            label: 'Gym Heroes B',
            value: '',
        },
        {
            label: 'Gym Challenge',
            value: '',
        },
        {
            label: 'Neo Revelation',
            value: '',
        },
    ],
    GOLBAT: [
        {
            label: 'Fossil',
            value: '',
        },
        {
            label: 'Team Rocket',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/golbat/golbat-rocket_qrwiqv.png',
        },
        {
            label: 'Gym Heroes',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/golbat/golbat-gym-heroes_qj28p4.png',
        },
        {
            label: 'Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/golbat/golbat-gym-challenge_lzjcr1.png',
        },
        {
            label: 'Neo Revelation',
            value: '',
        },
    ],
    ODDISH: [
        {
            label: 'Evo Box / Gym Heroes',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/oddish/oddish-gym-heroes_iplepr.png',
        },
        {
            label: 'Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/oddish/oddish-jungle.jpg',
        },
        {
            label: 'Gym Heroes B',
            value: '',
        },
        {
            label: 'Gym Challenge',
            value: '',
        },
        {
            label: 'Neo Genesis',
            value: '',
        },
    ],
    GLOOM: [
        {
            label: 'Evolution Box',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/gloom/gloom-evo-box_aurdja.png',
        },
        {
            label: 'Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/gloom/gloom-jungle.png',
        },
        {
            label: 'Rocket',
            value: '',
        },
        {
            label: 'Gym Heroes A',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/gloom/gloom-gym-heroes_lsigns.png',
        },
        {
            label: 'Gym Heroes B',
            value: '',
        },
        {
            label: 'Neo Genesis',
            value: '',
        },
    ],
    VILEPLUME: [
        {
            label: 'Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/vileplume/vileplume-jungle_qdo2hm.png',
        },
        {
            label: 'Team Rocket',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/vileplume/vileplume-rocket_nihyhq.png',
        },
        {
            label: 'Gym Heroes',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/vileplume/vileplume-gym-heroes_bjkhhz.png',
        },
        {
            label: 'Southern Islands',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/vileplume/vileplume-southern-islands.jpg',
        },
        {
            label: 'Animated',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/vileplume/vileplume-animated_v7errz.gif',
        },
    ],
    PARAS: [
        {
            label: 'Evo Box / Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/paras/paras-evo-jungle_m89gq9.png',
        },
        {
            label: 'Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/paras/paras-gym-challenge_egsngp.png',
        },
        {
            label: 'Neo Revelation',
            value: '',
        },
    ],
    PARASECT: [
        {
            label: 'Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/parasect/parasect-jungle_m86jfk.png',
        },
        {
            label: 'Neo Revelation',
            value: '',
        },
    ],
    VENONAT: [
        {
            label: 'Evolution Box',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/venonat/venonat-evo-box_tmpnpr.png',
        },
        {
            label: 'Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/venonat/venonat-jungle.jpg',
        },
        {
            label: 'Gym Heroes',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/venonat/venonat-gym-heroes_nnaoul.png',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    VENOMOTH: [
        {
            label: 'Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/venomoth/venomoth-jungle_jykeez.png',
        },
        {
            label: 'Gym Heroes',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/venomoth/venomoth-gym-heroes_ijf8fv.png',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
        {
            label: 'Animated',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/venomoth/venomoth-animated_rabwfc.gif',
        },
    ],
    DIGLETT: [
        {
            label: 'Evolution Box',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/diglett/diglett-evo-box_xzvjsr.png',
        },
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/diglett/diglett-base.png',
        },
        {
            label: 'Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/diglett/diglett-gym-challenge_onopiq.png',
        },
    ],
    DUGTRIO: [
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/dugtrio/dugtrio-base.png',
        },
        {
            label: 'Team Rocket',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/dugtrio/dugtrio-rocket_r0tlyd.png',
        },
        {
            label: 'Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/dugtrio/dugtrio-gym-challenge_ikdfpi.png',
        },
    ],
    MEOWTH: [
        {
            label: 'Evo Box / Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/meowth/meowth-evo-box_wv1mzm.png',
        },
        {
            label: 'Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/meowth/meowth-jungle.jpg',
        },
        {
            label: 'GB Promo',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/meowth/meowth-gb-promo_g3mzrz.png',
        },
    ],
    PERSIAN: [
        {
            label: 'Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/persian/persian-jungle.png',
        },
        {
            label: 'Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/persian/persian-gym-challenge_bmoemj.png',
        },
        {
            label: 'Team Rocket',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/persian/persian-dark-rocket-lc.png',
        },
        {
            label: 'Black Star Promo',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/persian/persian-rocket-promo_op4c5p.png',
        },
    ],
    PSYDUCK: [
        {
            label: 'Evo Box / Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/psyduck/psyduck-evo-gym-challenge_eyahjq.png',
        },
        {
            label: 'Gym Heroes',
            value: '',
        },
        {
            label: 'Gym Challenge',
            value: '',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    GOLDUCK: [
        {
            label: 'Fossil',
            value: '',
        },
        {
            label: 'Team Rocket',
            value: '',
        },
        {
            label: 'Gym Heroes',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/golduck/golduck-gym-heroes_e2xgev.png',
        },
        {
            label: 'Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/golduck/golduck-gym-challenge_y1cor4.png',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    MANKEY: [
        {
            label: 'Evolution Box',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/mankey/mankey-evo-box_ocdkys.png',
        },
        {
            label: 'Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/mankey/mankey-jungle.jpg',
        },
        {
            label: 'Gym Heroes',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/mankey/mankey-gym-heroes_rastsc.png',
        },
    ],
    PRIMEAPE: [
        {
            label: 'Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/primeape/primeape-jungle.png',
        },
        {
            label: 'Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/primeape/primeape-gym-challenge_ynryfl.png',
        },
        {
            label: 'Southern Islands',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/primeape/primeape-southern-islands.jpg',
        },
    ],
    GROWLITHE: [
        {
            label: 'Evo Box / Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/growlithe/growlithe-base-evo-box_jkohua.png',
        },
        {
            label: 'Gym Heroes A',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/growlithe/growlithe-gym-heroes_d8mj1q.png',
        },
        {
            label: 'Gym Heroes B',
            value: '',
        },
        {
            label: 'Gym Challenge',
            value: '',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    ARCANINE: [
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/arcanine/arcanine-base_xrccff.png',
        },
        {
            label: 'Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/arcanine/arcanine-gym-challenge_xrpmjz.png',
        },
        {
            label: 'Neo Destiny',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/arcanine/arcanine-neo-destiny.png',
        },
    ],
    POLIWAG: [
        {
            label: 'Evo Box / Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/poliwag/poliwag-base-evo-box_xgquik.png',
        },
        {
            label: 'Gym Heroes',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/poliwag/poliwag-gym-heroes_shda6t.png',
        },
        {
            label: 'Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/poliwag/poliwag-gym-challenge_rrcmav.png',
        },
        {
            label: 'Neo Discovery',
            value: '',
        },
    ],
    POLIWHIRL: [
        {
            label: 'Evo Box / Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/poliwhirl/poliwhirl-base_sdzusq.png',
        },
        {
            label: 'Gym Heroes',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/poliwhirl/poliwhirl-gym-heroes_foy29y.png',
        },
        {
            label: 'Neo Discovery',
            value: '',
        },
    ],
    POLIWRATH: [
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/poliwrath/poliwrath-base_vfshy0.png',
        },
        {
            label: 'Gym Heroes',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/poliwrath/poliwrath-gym-heroes_z7uyta.png',
        },
        {
            label: 'Neo Discovery',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/poliwrath/poliwrath-discovery.png',
        },
        {
            label: 'Expedition',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/poliwrath/poliwrath-expedition.png',
        },
        {
            label: 'Skyridge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/poliwrath/poliwrath-skyridge.png',
        },
        {
            label: 'VS',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/poliwrath/poliwrath-vs.jpg',
        },
        {
            label: 'Animated',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/poliwrath/poliwrath-animated_q0si2v.gif',
        },
    ],
    ABRA: [
        {
            label: 'Evolution Box',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/abra/abra-evo-box.png',
        },
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/abra/abra-base.png',
        },
        {
            label: 'Team Rocket',
            value: '',
        },
    ],
    KADABRA: [
        {
            label: 'Evo Box / Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/kadabra/kadabra-base_ym9fmx.png',
        },
        {
            label: 'Team Rocket',
            value: '',
        },
        {
            label: 'Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/kadabra/kadabra-gym-challenge_wxuemi.png',
        },
    ],
    ALAKAZAM: [
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/alakazam/alakazam-base_nlnb17.png',
        },
        {
            label: 'Team Rocket',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/alakazam/alakazam-rocket_ybdr9y.png',
        },
        {
            label: 'Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/alakazam/alakazam-gym-challenge_ennir9.png',
        },
        {
            label: 'Animated',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/alakazam/alakazam-animated_nf4gjl.gif',
        },
    ],
    MACHOP: [
        {
            label: 'Evo Box / Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/machop/machop-evo-box_nm2jk0.png',
        },
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/machop/machop-base.png',
        },
        {
            label: 'Team Rocket',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/machop/machop-rocket_xjqc0q.png',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    MACHOKE: [
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/machoke/machoke-base_ugj0h1.png',
        },
        {
            label: 'Team Rocket',
            value: '',
        },
        {
            label: 'Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/machoke/machoke-gym-challenge_zudg4c.png',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    MACHAMP: [
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/machamp/machamp-base_imdwug.png',
        },
        {
            label: 'Team Rocket',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/machamp/machamp-rocket_gexgnp.png',
        },
        {
            label: 'Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/machamp/machamp-gym-challenge_h7dcn0.png',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
        {
            label: 'Animated',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/machamp/machamp-animated_yhkunn.gif',
        },
    ],
    BELLSPROUT: [
        {
            label: 'Evolution Box',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/bellsprout/bellsprout-evo-box.png',
        },
        {
            label: 'Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/bellsprout/bellsprout-jungle.jpg',
        },
    ],
    WEEPINBELL: [
        {
            label: 'Evolution Box',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/weepinbell/weepinbell-evo-box_q84yqz.png',
        },
        {
            label: 'Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/weepinbell/weepinbell-jungle.jpg',
        },
    ],
    VICTREEBEL: [
        {
            label: 'Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/victreebel/victreebel-jungle_dvcs8k.png',
        },
        {
            label: 'Animated',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/victreebel/victreebel-animated_cpzb7g.gif',
        },
    ],
    TENTACOOL: [
        {
            label: 'Evolution Box',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/tentacool/tentacool-evo-box_i7bicy.png',
        },
    ],
    TENTACRUEL: [
        {
            label: 'Fossil',
            value: '',
        },
        {
            label: 'Gym Heroes',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/tentacruel/tentacruel-gym-heroes_huldkd.png',
        },
        {
            label: 'Southern Islands',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/tentacruel/tentacruel-southern-islands.jpg',
        },
    ],
    GEODUDE: [
        {
            label: 'Evolution Box',
            value: '',
        },
        {
            label: 'Fossil',
            value: '',
        },
        {
            label: 'Gym Heroes A',
            value: '',
        },
        {
            label: 'Gym Heroes B',
            value: '',
        },
        {
            label: 'Gym Challenge',
            value: '',
        },
        {
            label: 'Neo Revelation',
            value: '',
        },
    ],
    GRAVELER: [
        {
            label: 'Evolution Box',
            value: '',
        },
        {
            label: 'Fossil',
            value: '',
        },
        {
            label: 'Gym Heroes',
            value: '',
        },
        {
            label: 'Gym Challenge',
            value: '',
        },
        {
            label: 'Neo Revelation',
            value: '',
        },
    ],
    GOLEM: [
        {
            label: 'Fossil',
            value: '',
        },
    ],
    PONYTA: [
        {
            label: 'Evo Box / Base',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/ponyta/ponyta-base.png',
        },
    ],
    RAPIDASH: [
        {
            label: 'Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/rapidash/rapidash-jungle.jpg',
        },
    ],
    SLOWPOKE: [
        {
            label: 'Evolution Box',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/slowpoke/slowpoke-evo-box_lhiw0f.png',
        },
        {
            label: 'Fossil',
            value: '',
        },
        {
            label: 'Team Rocket',
            value: '',
        },
        {
            label: 'Gym Heroes',
            value: '',
        },
        {
            label: 'Neo Genesis',
            value: '',
        },
    ],
    SLOWBRO: [
        {
            label: 'Fossil',
            value: '',
        },
        {
            label: 'Team Rocket',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/slowbro/slowbro-rocket_q6tlq0.png',
        },
        {
            label: 'Gym Heroes',
            value: '',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    MAGNEMITE: [
        {
            label: 'Evolution Box',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/magnemite/magnemite-base_zcxvdk.png',
        },
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/magnemite/magnemite-base.png',
        },
        {
            label: 'Team Rocket',
            value: '',
        },
        {
            label: 'Gym Heroes A',
            value: '',
        },
        {
            label: 'Gym Heroes B',
            value: '',
        },
        {
            label: 'Neo Discovery',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/magnemite/magnemite-neo-discovery.png',
        },
    ],
    MAGNETON: [
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/magneton/magneton-base_jsnwb3.png',
        },
        {
            label: 'Fossil',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/magneton/magneton-fossil_pn5w26.png',
        },
        {
            label: 'Team Rocket',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/magneton/magneton-team-rocket_nirsvg.png',
        },
        {
            label: 'Gym Heroes',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/magneton/magneton-gym-heroes_ppc2yc.png',
        },
        {
            label: 'Neo Revelation',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/magneton/magneton-neo-revelation.png',
        },
        {
            label: 'Animated',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/magneton/magneton-animated_jz8xmw.gif',
        },
    ],
    FARFETCHD: [
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/farfetchd/farfetchd-base.png',
        },
        {
            label: 'Neo Revelation',
            value: '',
        },
    ],
    DODUO: [
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/doduo/doduo-base.png',
        },
        {
            label: 'Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/doduo/doduo-gym.png',
        },
    ],
    DODRIO: [
        {
            label: 'Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/dodrio/dodrio-jungle.jpg',
        },
    ],
    SEEL: [
        {
            label: 'Evo Box / Base',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/seel/seel-base.png',
        },
        {
            label: 'Gym Heroes',
            value: '',
        },
        {
            label: 'Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/seel/seel-gym-challenge.png',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    DEWGONG: [
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/dewgong/dewgong-base.png',
        },
        {
            label: 'Gym Challenge',
            value: '',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    GRIMER: [
        {
            label: 'Evolution Box',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/grimer/grimer-base_qmyuqx.png',
        },
    ],
    MUK: [
        {
            label: 'Fossil',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/muk/muk-fossil_mvsxsy.png',
        },
        {
            label: 'Animated',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/muk/muk-animated_nprm5i.gif',
        },
    ],
    SHELLDER: [
        {
            label: 'Fossil',
            value: '',
        },
    ],
    CLOYSTER: [
        {
            label: 'Fossil',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/cloyster/cloyster-fossil.png',
        },
    ],
    GASTLY: [
        {
            label: 'Evolution Box',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/gastly/gastly-evo-box_yv5obp.png',
        },
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/gastly/gastly-base.png',
        },
        {
            label: 'Fossil',
            value: '',
        },
        {
            label: 'Gym Challenge A',
            value: '',
        },
        {
            label: 'Gym Challenge B',
            value: '',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    HAUNTER: [
        {
            label: 'Evo Box / Fossil',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/haunter/haunter-fossil_suuck2.png',
        },
        {
            label: 'Base',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/haunter/haunter-base.png',
        },
        {
            label: 'Gym Heroes',
            value: '',
        },
        {
            label: 'Gym Challenge',
            value: '',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
        {
            label: 'Animated',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/haunter/haunter-animated_zjnaea.gif',
        },
    ],
    GENGAR: [
        {
            label: 'Fossil',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/gengar/gengar-fossil_ruvetf.png',
        },
        {
            label: 'Gym Heroes',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/gengar/gengar-gym-heroes_vntnrc.png',
        },
        {
            label: 'Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/gengar/gengar-gym-challenge_x5nzwi.png',
        },
        {
            label: 'Neo Destiny',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/gengar/gengar-neo-destiny.png',
        },
        {
            label: 'Masaki Promo',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/gengar/gengar-masaki.png',
        },
        {
            label: 'Expedition',
            value: '',
        },
        {
            label: 'Skyridge',
            value: '',
        },
        {
            label: 'Animated',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/gengar/gengar-animated_orodvd.gif',
        },
    ],
    ONIX: [
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/onix/onix-base.png',
        },
        {
            label: 'Gym Heroes A',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/onix/onix-gym-heroes_tbrwri.png',
        },
        {
            label: 'Gym Heroes B',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/onix/onix-gym-heroes-b.jpg',
        },
        {
            label: 'Neo Genesis',
            value: '',
        },
        {
            label: 'Southern Islands',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/onix/onix-southern-islands.jpg',
        },
    ],
    DROWZEE: [
        {
            label: 'Evolution Box',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/drowzee/drowzee-base_coi0ni.png',
        },
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/drowzee/drowzee-base.png',
        },
    ],
    HYPNO: [
        {
            label: 'Fossil',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/hypno/hypno-fossil_fmudkr.png',
        },
        {
            label: 'Team Rocket',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/hypno/hypno-team-rocket_cjuqcr.png',
        },
        {
            label: 'Animated',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/hypno/hypno-animated_zmbrh0.gif',
        },
    ],
    KRABBY: [
        {
            label: 'Fossil',
            value: '',
        },
    ],
    KINGLER: [
        {
            label: 'Fossil',
            value: '',
        },
    ],
    VOLTORB: [
        {
            label: 'Evolution Box',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/voltorb/voltorb-evo-box_ews6ic.png',
        },
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/voltorb/voltorb-base.png',
        },
        {
            label: 'Team Rocket',
            value: '',
        },
        {
            label: 'Gym Heroes',
            value: '',
        },
        {
            label: 'Gym Challenge',
            value: '',
        },
    ],
    ELECTRODE: [
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/electrode/electrode-base_klqxao.png',
        },
        {
            label: 'Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/electrode/electrode-jungle_uboift.png',
        },
        {
            label: 'Animated',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/electrode/electrode-animated_osyhpr.gif',
        },
    ],
    EXEGGCUTE: [
        {
            label: 'Evolution Box',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/exeggcute/exeggcute-evo-box.png',
        },
        {
            label: 'Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/exeggcute/exeggcute-jungle.jpg',
        },
        {
            label: 'Gym Heroes A',
            value: '',
        },
        {
            label: 'Gym Heroes B',
            value: '',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    EXEGGUTOR: [
        {
            label: 'Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/exeggutor/exeggutor-jungle.png',
        },
        {
            label: 'Gym Heroes',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/exeggutor/exeggutor-gym-heroes.png',
        },
        {
            label: 'Southern Islands',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/exeggutor/exeggutor-southern-islands.jpg',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    CUBONE: [
        {
            label: 'Evolution Box',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/cubone/cubone-evo-box.png',
        },
        {
            label: 'Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/cubone/cubone-jungle.jpg',
        },
    ],
    MAROWAK: [
        {
            label: 'Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/marowak/marowak-jungle.png',
        },
    ],
    HITMONLEE: [
        {
            label: 'Fossil',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/hitmonlee/hitmonlee-fossil_ufbzak.png',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
        {
            label: 'Animated',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/hitmonlee/hitmonlee-animated_ksezgu.gif',
        },
    ],
    HITMONCHAN: [
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/hitmonchan/hitmonchan-base_hgzukg.png',
        },
        {
            label: 'Gym Heroes',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/hitmonchan/hitmonchan-gym-heroes_gpeaht.png',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
        {
            label: 'Animated',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/hitmonchan/hitmonchan-animated_sqfs7w.gif',
        },
    ],
    LICKITUNG: [
        {
            label: 'Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/lickitung/lickitung-jungle.png',
        },
        {
            label: 'Gym Heroes',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/lickitung/lickitung-gym-heroes.png',
        },
        {
            label: 'Soutnern Islands',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/lickitung/lickitung-southern-islands.jpg',
        },
    ],
    KOFFING: [
        {
            label: 'Evolution Box',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/koffing/koffing-evo-box_xa9see.png',
        },
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/koffing/koffing-base.png',
        },
        {
            label: 'Gym Challenge A',
            value: '',
        },
        {
            label: 'Gym Challenge B',
            value: '',
        },
    ],
    WEEZING: [
        {
            label: 'Fossil',
            value: '',
        },
        {
            label: 'Team Rocket',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/weezing/weezing-rocket_cn9nr0.png',
        },
        {
            label: 'Gym Challenge',
            value: '',
        },
    ],
    RHYHORN: [
        {
            label: 'Evolution Box',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/rhyhorn/rhyhorn-evo-box_q4frrv.png',
        },
        {
            label: 'Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/rhyhorn/rhyhorn-jungle.jpg',
        },
    ],
    RHYDON: [
        {
            label: 'Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/rhydon/rhydon-jungle.jpg',
        },
        {
            label: 'Gym Heroes',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/rhydon/rhydon-gym-heroes_ql1ufu.png',
        },
    ],
    CHANSEY: [
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/chansey/chansey-base_dxg3tw.png',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
        {
            label: 'Animated',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/chansey/chansey-animated_kiaokk.gif',
        },
    ],
    TANGELA: [
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/tangela/tangela-base.png',
        },
    ],
    KANGASKHAN: [
        {
            label: 'Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/kangaskhan/kangaskhan-jungle_qhhlu4.png',
        },
        {
            label: 'Animated',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/kangaskhan/kangaskhan-animated_dtwx5p.gif',
        },
    ],
    HORSEA: [
        {
            label: 'Evolution Box',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/horsea/horsea-evo-box_em6p15.png',
        },
        {
            label: 'Fossil',
            value: '',
        },
        {
            label: 'Gym Heroes',
            value: '',
        },
        {
            label: 'Gym Challenge',
            value: '',
        },
        {
            label: 'Neo Genesis',
            value: '',
        },
    ],
    SEADRA: [
        {
            label: 'Fossil',
            value: '',
        },
        {
            label: 'Gym Heroes',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/seadra/seadra-gym-heroes_gg44zq.png',
        },
        {
            label: 'Neo Genesis',
            value: '',
        },
    ],
    GOLDEEN: [
        {
            label: 'Evolution Box',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/goldeen/goldeen-evo-box.png',
        },
        {
            label: 'Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/goldeen/goldeen-jungle.jpg',
        },
        {
            label: 'Gym Heroes A',
            value: '',
        },
        {
            label: 'Gym Heroes B',
            value: '',
        },
        {
            label: 'Neo Revelation',
            value: '',
        },
    ],
    SEAKING: [
        {
            label: 'Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/seaking/seaking-jungle.jpg',
        },
        {
            label: 'Gym Heroes',
            value: '',
        },
        {
            label: 'Neo Revelation',
            value: '',
        },
    ],
    STARYU: [
        {
            label: 'Evo Box / Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/staryu/staryu-evo-box.png',
        },
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/staryu/staryu-base.png',
        },
        {
            label: 'Gym Heroes',
            value: '',
        },
        {
            label: 'Neo Revelation',
            value: '',
        },
    ],
    STARMIE: [
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/starmie/starmie-base.png',
        },
        {
            label: 'Gym Heroes',
            value: '',
        },
        {
            label: 'Neo Revelation',
            value: '',
        },
    ],
    MR_MIME: [
        {
            label: 'Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/mr-mime/mr-mine-jungle_txfc71.png',
        },
        {
            label: 'Animated',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/mr-mime/mr-mime-animated_adrqtj.gif',
        },
    ],
    SCYTHER: [
        {
            label: 'Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/scyther/scyther-jungle_zq0las.png',
        },
        {
            label: 'Gym Heroes',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/scyther/scyther-gym-heroes_gds256.png',
        },
        {
            label: 'Neo Discovery',
            value: '',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
        {
            label: 'Animated',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/scyther/scyther-animated_kprhlh.gif',
        },
    ],
    JYNX: [
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/jynx/jynx-base.png',
        },
        {
            label: 'Gym Heroes',
            value: '',
        },
        {
            label: 'Gym Challenge',
            value: '',
        },
        {
            label: 'Neo Revelation',
            value: '',
        },
    ],
    ELECTABUZZ: [
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/electabuzz/electabuzz-base_cheqad.png',
        },
        {
            label: 'Gym Heroes A',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/electabuzz/electabuzz-gym-heroes_t7si3r.png',
        },
        {
            label: 'Gym Heroes B',
            value: '',
        },
        {
            label: 'Neo Genesis',
            value: '',
        },
        {
            label: 'Black Star Promo',
            value: '',
        },
    ],
    MAGMAR: [
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/magmar/magmar-base.png',
        },
        {
            label: 'Fossil',
            value: '',
        },
        {
            label: 'Gym Heroes',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/magmar/magmar-gym.png',
        },
        {
            label: 'Neo Genesis',
            value: '',
        },
        {
            label: 'Black Star Promo',
            value: '',
        },
    ],
    PINSIR: [
        {
            label: 'Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/pinsir/pinsir-jungle_gykpyw.png',
        },
        {
            label: 'Gym Challenge',
            value: '',
        },
        {
            label: 'Animated',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/pinsir/pinsir-animated_vj8ck8.gif',
        },
    ],
    TAUROS: [
        {
            label: 'Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/tauros/tauros-jungle.jpg',
        },
    ],
    MAGIKARP: [
        {
            label: 'Evolution Box',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/magikarp/magikarp-base_q5o2el.png',
        },
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/magikarp/magikarp-base.png',
        },
        {
            label: 'Gym Challenge (G)',
            value: '',
        },
        {
            label: 'Gym Challenge (M)',
            value: '',
        },
        {
            label: 'Neo Revelation',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/magikarp/shining-magikarp-neo-revelation.png',
        },
    ],
    GYARADOS: [
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/gyarados/gyarados-base_ucebtg.png',
        },
        {
            label: 'Team Rocket',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/gyarados/gyarados-rocket_qzppj6.png',
        },
        {
            label: 'Gym Challenge (G)',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/gyarados/gyarados-gym-challenge_gel4sx.png',
        },
        {
            label: 'Gym Challenge (M)',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/gyarados/gyarados-gym-challenge-alt_j4xhht.png',
        },
        {
            label: 'Neo Revelation',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/gyarados/shining-gyarados-neo-revelation.png',
        },
        {
            label: 'Animated',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/gyarados/gyarados-animated_zteccg.gif',
        },
    ],
    LAPRAS: [
        {
            label: 'Fossil',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/lapras/lapras-fossil_iky0rf.png',
        },
        {
            label: 'Southern Islands',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/lapras/lapras-southern-islands.jpg',
        },
        {
            label: 'Animated',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/lapras/lapras-animated_g2psrp.gif',
        },
    ],
    DITTO: [
        {
            label: 'Fossil',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/ditto/ditto-fossil_zman2m.png',
        },
        {
            label: 'Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/ditto/ditto-gym-challenge_jlbotj.png',
        },
        {
            label: 'Animated',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/ditto/ditto-animated_anpa3i.gif',
        },
    ],
    EEVEE: [
        {
            label: 'Evo Box',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/eevee/eevee-evo-box_ts7phj.png',
        },
        {
            label: 'Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/eevee/eevee-jungle_r5v1d4.png',
        },
        {
            label: 'Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/eevee/eevee-gym-challenge_wivjie.png',
        },
        {
            label: 'Neo Discovery',
            value: '',
        },
        {
            label: 'Black Star Promo',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/eevee/eevee-bs-promo_lj0jgr.png',
        },
    ],
    VAPOREON: [
        {
            label: 'Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/vaporeon/vaporeon-jungle_x8t7ew.png',
        },
        {
            label: 'Rocket',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/vaporeon/vaporeon-rocket-lc.png',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
        {
            label: 'Animated',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/vaporeon/vaporeon-animated_sphgnm.gif',
        },
    ],
    JOLTEON: [
        {
            label: 'Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/jolteon/jolteon-jungle_cygknz.png',
        },
        {
            label: 'Team Rocket',
            value: '',
        },
        {
            label: 'Gym Challenge',
            value: '',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
        {
            label: 'Animated',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/jolteon/jolteon-animated_r5ppd6.gif',
        },
    ],
    FLAREON: [
        {
            label: 'Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/flareon/flareon-jungle_jsftvr.png',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
        {
            label: 'Animated',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/flareon/flareon-animated_upxn4c.gif',
        },
    ],
    PORYGON: [
        {
            label: 'Evo Box A',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/porygon/porygon-evo-box-1.png',
        },
        {
            label: 'Evo Box B',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/porygon/porygon-evo-box-2.png',
        },
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/porygon/porygon-base.png',
        },
        {
            label: 'Team Rocket',
            value: '',
        },
        {
            label: 'Gym Challenge',
            value: '',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    OMANYTE: [
        {
            label: 'Fossil',
            value: '',
        },
        {
            label: 'Neo Discovery',
            value: '',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    OMASTAR: [
        {
            label: 'Fossil',
            value: '',
        },
        {
            label: 'Neo Discovery',
            value: '',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    KABUTO: [
        {
            label: 'Evolution Box',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/kabuto/kabuto-base_fefjvh.png',
        },
        {
            label: 'Fossil',
            value: '',
        },
        {
            label: 'Neo Discovery',
            value: '',
        },
    ],
    KABUTOPS: [
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/kabutops/kabutops-fossil_xzmbtk.png',
        },
        {
            label: 'Neo Discovery',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/kabutops/kabutops-neo-discovery.png',
        },
        {
            label: 'Neo Destiny',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/kabutops/kabutops-neo-destiny-shining.png',
        },
        {
            label: 'Skyridge A',
            value: '',
        },
        {
            label: 'Skyridge B',
            value: '',
        },
        {
            label: 'Animated',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/kabutops/kabutops-animated_npttex.gif',
        },
    ],
    AERODACTYL: [
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/aerodactyl/aerodactyl-fossil_gtawvn.png',
        },
        {
            label: 'Neo Revelation',
            value: '',
        },
        {
            label: 'Animated',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/aerodactyl/aerodactyl-animated_jzstnd.gif',
        },
    ],
    SNORLAX: [
        {
            label: 'Jungle',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/snorlax/snorlax-jungle_uioake.png',
        },
        {
            label: 'Gym Heroes',
            value: '',
        },
        {
            label: 'Black Star Promo',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/snorlax/snorlax-bs-promo_etdjce.png',
        },
        {
            label: 'Animated',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/snorlax/snorlax-animated_vplgad.gif',
        },
    ],
    ARTICUNO: [
        {
            label: 'Fossil',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/articuno/articuno-fossil_r1q7cd.png',
        },
        {
            label: 'Animated',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/articuno/articuno-animated_p9zrrr.gif',
        },
    ],
    ZAPDOS: [
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/zapdos/zapdos-base_tx3tes.png',
        },
        {
            label: 'Fossil',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/zapdos/zapdos-fossil_hqtczv.png',
        },
        {
            label: 'Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/zapdos/zapdos-gym-challenge_wyyoib.png',
        },
        {
            label: 'Animated',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/zapdos/zapdos-animated_xjqa96.gif',
        },
    ],
    MOLTRES: [
        {
            label: 'Fossil',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/moltres/moltres-fossil_fckzyn.png',
        },
        {
            label: 'Gym Heroes (B)',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/moltres/moltres-gym-heroes-blaine_fgputt.png',
        },
        {
            label: 'Gym Heroes (R)',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/moltres/rockets-moltres-gym-heroes_iz94nj.png',
        },
        {
            label: 'Animated',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/moltres/moltres-animated_b1mnlv.gif',
        },
    ],
    DRATINI: [
        {
            label: 'Evo Box, Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/dratini/dratini-evo-box_y2exz7.png',
        },
        {
            label: 'Gym Heroes',
            value: '',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    DRAGONAIR: [
        {
            label: 'Evolution Box',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/dragonair/dragonair-base_rgckx4.png',
        },
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/dragonair/dragonair-base-full.png',
        },
        {
            label: 'Gym Heroes',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/dragonair/dragonair-gym-heroes_f0vrto.png',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    DRAGONITE: [
        {
            label: 'Fossil',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/dragonite/dragonite-fossil_mlihiv.png',
        },
        {
            label: 'Team Rocket',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/dragonite/dragonite-rocket_g8zkth.png',
        },
        {
            label: 'Neo Destiny',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/dragonite/dragonite-neo-destiny.png',
        },
        {
            label: 'Expedition',
            value: '',
        },
        {
            label: 'Animated',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/dragonite/dragonite-animated_jyh4yq.gif',
        },
    ],
    MEWTWO: [
        {
            label: 'Base Set',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/mewtwo/mewtwo-base_gqjllb.png',
        },
        {
            label: 'Gym Challenge',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/mewtwo/mewtwo-gym-challenge_ia8lxe.png',
        },
        {
            label: 'Neo Destiny',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/mewtwo/mewtwo-neo-destiny-shining.png',
        },
        {
            label: 'Expedition',
            value: '',
        },
        {
            label: 'Animated',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/mewtwo/mewtwo-animated_k31mqd.gif',
        },
    ],
    MEW: [
        {
            label: 'Black Star Promo',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/mew/mew-black-star-promo.png',
        },
        {
            label: 'Southern Islands',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/mew/mew-southern-islands.jpg',
        },
    ],
    MYSTERIOUS_FOSSIL: [
        {
            label: 'Fossil',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/mysterious-fossil/mysterious-fossil-evo-box_ojm1hf.png',
        },
    ],
};

const GEN_1_POKEMON = {
    BULBASAUR: {
        name: 'Bulbasaur',
        images: POKEMON_IMAGES.BULBASAUR,
        number: 1,
        pokemonType: 'Seed',
    },
    IVYSAUR: {
        name: 'Ivysaur',
        images: POKEMON_IMAGES.IVYSAUR,
        number: 2,
        pokemonType: 'Seed',
        stage: 1,
    },
    VENUSAUR: {
        name: 'Venusaur',
        images: POKEMON_IMAGES.VENUSAUR,
        number: 3,
        pokemonType: 'Seed',
        stage: 2,
    },
    CHARMANDER: {
        name: 'Charmander',
        images: POKEMON_IMAGES.CHARMANDER,
        number: 4,
        pokemonType: 'Flame',
    },
    CHARMELEON: {
        name: 'Charmeleon',
        images: POKEMON_IMAGES.CHARMELEON,
        number: 5,
        pokemonType: 'Flame',
        stage: 1,
    },
    CHARIZARD: {
        name: 'Charizard',
        images: POKEMON_IMAGES.CHARIZARD,
        number: 6,
        pokemonType: 'Flame',
        stage: 2,
    },
    SQUIRTLE: {
        name: 'Squirtle',
        images: POKEMON_IMAGES.SQUIRTLE,
        number: 7,
        pokemonType: 'Shellfish',
    },
    WARTORTLE: {
        name: 'Wartortle',
        images: POKEMON_IMAGES.WARTORTLE,
        number: 8,
        pokemonType: 'Shellfish',
        stage: 1,
    },
    BLASTOISE: {
        name: 'Blastoise',
        images: POKEMON_IMAGES.BLASTOISE,
        number: 9,
        pokemonType: 'Shellfish',
        stage: 2,
    },
    CATERPIE: {
        name: 'Caterpie',
        images: POKEMON_IMAGES.CATERPIE,
        number: 10,
        pokemonType: 'Worm',
    },
    METAPOD: {
        name: 'Metapod',
        images: POKEMON_IMAGES.METAPOD,
        number: 11,
        pokemonType: 'Cocoon',
        stage: 1,
    },
    BUTTERFREE: {
        name: 'Butterfree',
        images: POKEMON_IMAGES.BUTTERFREE,
        number: 12,
        pokemonType: 'Butterfly',
        stage: 2,
    },
    WEEDLE: {
        name: 'Weedle',
        images: POKEMON_IMAGES.WEEDLE,
        number: 13,
        pokemonType: 'Hairy Bug',
    },
    KAKUNA: {
        name: 'Kakuna',
        images: POKEMON_IMAGES.KAKUNA,
        number: 14,
        pokemonType: 'Cocoon',
        stage: 1,
    },
    BEEDRILL: {
        name: 'Beedrill',
        images: POKEMON_IMAGES.BEEDRILL,
        number: 15,
        pokemonType: 'Poison Bee',
        stage: 2,
    },
    PIDGEY: {
        name: 'Pidgey',
        images: POKEMON_IMAGES.PIDGEY,
        number: 16,
        pokemonType: 'Bird',
    },
    PIDGEOTTO: {
        name: 'Pidgeotto',
        images: POKEMON_IMAGES.PIDGEOTTO,
        number: 17,
        pokemonType: 'Bird',
        stage: 1,
    },
    PIDGEOT: {
        name: 'Pidgeot',
        images: POKEMON_IMAGES.PIDGEOT,
        number: 18,
        pokemonType: 'Bird',
        stage: 2,
    },
    RATTATA: {
        name: 'Rattata',
        images: POKEMON_IMAGES.RATTATA,
        number: 19,
        pokemonType: 'Rat',
    },
    RATICATE: {
        name: 'Raticate',
        images: POKEMON_IMAGES.RATICATE,
        number: 20,
        pokemonType: 'Rat',
        stage: 1,
    },
    SPEAROW: {
        name: 'Spearow',
        images: POKEMON_IMAGES.SPEAROW,
        number: 21,
        pokemonType: 'Tiny Bird',
    },
    FEAROW: {
        name: 'Fearow',
        images: POKEMON_IMAGES.FEAROW,
        number: 22,
        pokemonType: 'Beak',
        stage: 1,
    },
    EKANS: {
        name: 'Ekans',
        images: POKEMON_IMAGES.EKANS,
        number: 23,
        pokemonType: 'Snake',
    },
    ARBOK: {
        name: 'Arbok',
        images: POKEMON_IMAGES.ARBOK,
        number: 24,
        pokemonType: 'Cobra',
        stage: 1,
    },
    PIKACHU: {
        name: 'Pikachu',
        images: POKEMON_IMAGES.PIKACHU,
        number: 25,
        pokemonType: 'Mouse',
    },
    RAICHU: {
        name: 'Raichu',
        images: POKEMON_IMAGES.RAICHU,
        number: 26,
        pokemonType: 'Mouse',
        stage: 1,
    },
    SANDSHREW: {
        name: 'Sandshrew',
        images: POKEMON_IMAGES.SANDSHREW,
        number: 27,
        pokemonType: 'Mouse',
    },
    SANDSLASH: {
        name: 'Sandslash',
        images: POKEMON_IMAGES.SANDSLASH,
        number: 28,
        stage: 1,
        pokemonType: 'Mouse',
    },
    NIDORAN_F: {
        name: 'Nidoran ♀',
        images: POKEMON_IMAGES.NIDORAN_F,
        number: 29,
        pokemonType: 'Poison Pin',
    },
    NIDORINA: {
        name: 'Nidorina',
        images: POKEMON_IMAGES.NIDORINA,
        number: 30,
        pokemonType: 'Poison Pin',
        stage: 1,
    },
    NIDOQUEEN: {
        name: 'Nidoqueen',
        images: POKEMON_IMAGES.NIDOQUEEN,
        number: 31,
        pokemonType: 'Drill',
        stage: 2,
    },
    NIDORAN_M: {
        name: 'Nidoran ♂',
        images: POKEMON_IMAGES.NIDORAN_M,
        number: 32,
        pokemonType: 'Poison Pin',
    },
    NIDORINO: {
        name: 'Nidorino',
        images: POKEMON_IMAGES.NIDORINO,
        number: 33,
        pokemonType: 'Poison Pin',
        stage: 1,
    },
    NIDOKING: {
        name: 'Nidoking',
        images: POKEMON_IMAGES.NIDOKING,
        number: 34,
        pokemonType: 'Drill',
        stage: 2,
    },
    CLEFAIRY: {
        name: 'Clefairy',
        images: POKEMON_IMAGES.CLEFAIRY,
        number: 35,
        pokemonType: 'Fairy',
    },
    CLEFABLE: {
        name: 'Clefable',
        images: POKEMON_IMAGES.CLEFABLE,
        number: 36,
        pokemonType: 'Fairy',
        stage: 1,
    },
    VULPIX: {
        name: 'Vulpix',
        images: POKEMON_IMAGES.VULPIX,
        number: 37,
        pokemonType: 'Fox',
    },
    NINETALES: {
        name: 'Ninetales',
        images: POKEMON_IMAGES.NINETALES,
        number: 38,
        pokemonType: 'Fox',
        stage: 1,
    },
    JIGGLYPUFF: {
        name: 'Jigglypuff',
        images: POKEMON_IMAGES.JIGGLYPUFF,
        number: 39,
        pokemonType: 'Balloon',
    },
    WIGGLYTUFF: {
        name: 'Wigglytuff',
        images: POKEMON_IMAGES.WIGGLYTUFF,
        number: 40,
        pokemonType: 'Balloon',
        stage: 1,
    },
    ZUBAT: {
        name: 'Zubat',
        images: POKEMON_IMAGES.ZUBAT,
        number: 41,
        pokemonType: 'Bat',
    },
    GOLBAT: {
        name: 'Golbat',
        images: POKEMON_IMAGES.GOLBAT,
        number: 42,
        pokemonType: 'Bat',
        stage: 1,
    },
    ODDISH: {
        name: 'Oddish',
        images: POKEMON_IMAGES.ODDISH,
        number: 43,
        pokemonType: 'Weed',
    },
    GLOOM: {
        name: 'Gloom',
        images: POKEMON_IMAGES.GLOOM,
        number: 44,
        pokemonType: 'Weed',
        stage: 1,
    },
    VILEPLUME: {
        name: 'Vileplume',
        images: POKEMON_IMAGES.VILEPLUME,
        number: 45,
        pokemonType: 'Flower',
        stage: 2,
    },
    PARAS: {
        name: 'Paras',
        images: POKEMON_IMAGES.PARAS,
        number: 46,
        pokemonType: 'Mushroom',
    },
    PARASECT: {
        name: 'Parasect',
        images: POKEMON_IMAGES.PARASECT,
        number: 47,
        pokemonType: 'Mushroom',
        stage: 1,
    },
    VENONAT: {
        name: 'Venonat',
        images: POKEMON_IMAGES.VENONAT,
        number: 48,
        pokemonType: 'Insect',
    },
    VENOMOTH: {
        name: 'Venomoth',
        images: POKEMON_IMAGES.VENOMOTH,
        number: 49,
        pokemonType: 'Poisonmoth',
        stage: 1,
    },
    DIGLETT: {
        name: 'Diglett',
        images: POKEMON_IMAGES.DIGLETT,
        number: 50,
        pokemonType: 'Mole',
    },
    DUGTRIO: {
        name: 'Dugtrio',
        images: POKEMON_IMAGES.DUGTRIO,
        number: 51,
        pokemonType: 'Mole',
        stage: 1,
    },
    MEOWTH: {
        name: 'Meowth',
        images: POKEMON_IMAGES.MEOWTH,
        number: 52,
        pokemonType: 'Scratch Cat',
    },
    PERSIAN: {
        name: 'Persian',
        images: POKEMON_IMAGES.PERSIAN,
        number: 53,
        pokemonType: 'Classy Cat',
        stage: 1,
    },
    PSYDUCK: {
        name: 'Psyduck',
        images: POKEMON_IMAGES.PSYDUCK,
        number: 54,
        pokemonType: 'Duck',
    },
    GOLDUCK: {
        name: 'Golduck',
        images: POKEMON_IMAGES.GOLDUCK,
        number: 55,
        pokemonType: 'Duck',
        stage: 1,
    },
    MANKEY: {
        name: 'Mankey',
        images: POKEMON_IMAGES.MANKEY,
        number: 56,
        pokemonType: 'Pig Monkey',
    },
    PRIMEAPE: {
        name: 'Primeape',
        images: POKEMON_IMAGES.PRIMEAPE,
        number: 57,
        pokemonType: 'Pig Monkey',
        stage: 1,
    },
    GROWLITHE: {
        name: 'Growlithe',
        images: POKEMON_IMAGES.GROWLITHE,
        number: 58,
        pokemonType: 'Puppy',
    },
    ARCANINE: {
        name: 'Arcanine',
        images: POKEMON_IMAGES.ARCANINE,
        number: 59,
        pokemonType: 'Legendary',
        stage: 1,
    },
    POLIWAG: {
        name: 'Poliwag',
        images: POKEMON_IMAGES.POLIWAG,
        number: 60,
        pokemonType: 'Tadpole',
    },
    POLIWHIRL: {
        name: 'Poliwhirl',
        images: POKEMON_IMAGES.POLIWHIRL,
        number: 61,
        pokemonType: 'Tadpole',
        stage: 1,
    },
    POLIWRATH: {
        name: 'Poliwrath',
        images: POKEMON_IMAGES.POLIWRATH,
        number: 62,
        pokemonType: 'Tadpole',
        stage: 2,
    },
    ABRA: {
        name: 'Abra',
        images: POKEMON_IMAGES.ABRA,
        number: 63,
        pokemonType: 'Psi',
    },
    KADABRA: {
        name: 'Kadabra',
        images: POKEMON_IMAGES.KADABRA,
        number: 64,
        pokemonType: 'Psi',
        stage: 1,
    },
    ALAKAZAM: {
        name: 'Alakazam',
        images: POKEMON_IMAGES.ALAKAZAM,
        number: 65,
        pokemonType: 'Psi',
        stage: 2,
    },
    MACHOP: {
        name: 'Machop',
        images: POKEMON_IMAGES.MACHOP,
        number: 66,
        pokemonType: 'Superpower',
    },
    MACHOKE: {
        name: 'Machoke',
        images: POKEMON_IMAGES.MACHOKE,
        number: 67,
        pokemonType: 'Superpower',
        stage: 1,
    },
    MACHAMP: {
        name: 'Machamp',
        images: POKEMON_IMAGES.MACHAMP,
        number: 68,
        pokemonType: 'Superpower',
        stage: 2,
    },
    BELLSPROUT: {
        name: 'Bellsprout',
        images: POKEMON_IMAGES.BELLSPROUT,
        number: 69,
        pokemonType: 'Flower',
    },
    WEEPINBELL: {
        name: 'Weepinbell',
        images: POKEMON_IMAGES.WEEPINBELL,
        number: 70,
        pokemonType: 'Flycatcher',
        stage: 1,
    },
    VICTREEBEL: {
        name: 'Victreebel',
        images: POKEMON_IMAGES.VICTREEBEL,
        number: 71,
        pokemonType: 'Flycatcher',
        stage: 2,
    },
    TENTACOOL: {
        name: 'Tentacool',
        images: POKEMON_IMAGES.TENTACOOL,
        number: 72,
        pokemonType: 'Jellyfish',
    },
    TENTACRUEL: {
        name: 'Tentacruel',
        images: POKEMON_IMAGES.TENTACRUEL,
        number: 73,
        pokemonType: 'Jellyfish',
        stage: 1,
    },
    GEODUDE: {
        name: 'Geodude',
        images: POKEMON_IMAGES.GEODUDE,
        number: 74,
        pokemonType: 'Rock',
    },
    GRAVELER: {
        name: 'Graveler',
        images: POKEMON_IMAGES.GRAVELER,
        number: 75,
        stage: 1,
        pokemonType: 'Rock',
    },
    GOLEM: {
        name: 'Golem',
        images: POKEMON_IMAGES.GOLEM,
        number: 76,
        stage: 2,
        pokemonType: 'Megaton',
    },
    PONYTA: {
        name: 'Ponyta',
        images: POKEMON_IMAGES.PONYTA,
        number: 77,
        pokemonType: 'Fire Horse',
    },
    RAPIDASH: {
        name: 'Rapidash',
        images: POKEMON_IMAGES.RAPIDASH,
        number: 78,
        pokemonType: 'Fire Horse',
        stage: 1,
    },
    SLOWPOKE: {
        name: 'Slowpoke',
        images: POKEMON_IMAGES.SLOWPOKE,
        number: 79,
        pokemonType: 'Dopey',
    },
    SLOWBRO: {
        name: 'Slowbro',
        images: POKEMON_IMAGES.SLOWBRO,
        number: 80,
        pokemonType: 'Hermitcrab',
        stage: 1,
    },
    MAGNEMITE: {
        name: 'Magnemite',
        images: POKEMON_IMAGES.MAGNEMITE,
        number: 81,
        pokemonType: 'Magnet',
    },
    MAGNETON: {
        name: 'Magneton',
        images: POKEMON_IMAGES.MAGNETON,
        number: 82,
        pokemonType: 'Magnet',
        stage: 1,
    },
    FARFETCHD: {
        name: 'Farfetch’d',
        images: POKEMON_IMAGES.FARFETCHD,
        number: 83,
        pokemonType: 'Wild Duck',
    },
    DODUO: {
        name: 'Doduo',
        images: POKEMON_IMAGES.DODUO,
        number: 84,
        pokemonType: 'Twin Bird',
    },
    DODRIO: {
        name: 'Dodrio',
        images: POKEMON_IMAGES.DODRIO,
        number: 85,
        pokemonType: 'Triplebird',
        stage: 1,
    },
    SEEL: {
        name: 'Seel',
        images: POKEMON_IMAGES.SEEL,
        number: 86,
        pokemonType: 'Sea Lion',
    },
    DEWGONG: {
        name: 'Dewgong',
        images: POKEMON_IMAGES.DEWGONG,
        number: 87,
        pokemonType: 'Sea Lion',
        stage: 1,
    },
    GRIMER: {
        name: 'Grimer',
        images: POKEMON_IMAGES.GRIMER,
        number: 88,
        pokemonType: 'Sludge',
    },
    MUK: {
        name: 'Muk',
        images: POKEMON_IMAGES.MUK,
        number: 89,
        pokemonType: 'Sludge',
        stage: 1,
    },
    SHELLDER: {
        name: 'Shellder',
        images: POKEMON_IMAGES.SHELLDER,
        number: 90,
        pokemonType: 'Bivalve',
    },
    CLOYSTER: {
        name: 'Cloyster',
        images: POKEMON_IMAGES.CLOYSTER,
        number: 91,
        stage: 1,
        pokemonType: 'Bivalve',
    },
    GASTLY: {
        name: 'Gastly',
        images: POKEMON_IMAGES.GASTLY,
        number: 92,
        pokemonType: 'Gas',
    },
    HAUNTER: {
        name: 'Haunter',
        images: POKEMON_IMAGES.HAUNTER,
        number: 93,
        pokemonType: 'Gas',
        stage: 1,
    },
    GENGAR: {
        name: 'Gengar',
        images: POKEMON_IMAGES.GENGAR,
        number: 94,
        pokemonType: 'Shadow',
        stage: 2,
    },
    ONIX: {
        name: 'Onix',
        images: POKEMON_IMAGES.ONIX,
        number: 95,
        pokemonType: 'Rock Snake',
    },
    DROWZEE: {
        name: 'Drowzee',
        images: POKEMON_IMAGES.DROWZEE,
        number: 96,
        pokemonType: 'Hypnosis',
    },
    HYPNO: {
        name: 'Hypno',
        images: POKEMON_IMAGES.HYPNO,
        number: 97,
        pokemonType: 'Hypnosis',
        stage: 1,
    },
    KRABBY: {
        name: 'Krabby',
        images: POKEMON_IMAGES.KRABBY,
        number: 98,
        pokemonType: 'River Crab',
    },
    KINGLER: {
        name: 'Kingler',
        images: POKEMON_IMAGES.KINGLER,
        number: 99,
        stage: 1,
        pokemonType: 'Pincer',
    },
    VOLTORB: {
        name: 'Voltorb',
        images: POKEMON_IMAGES.VOLTORB,
        number: 100,
        pokemonType: 'Ball',
    },
    ELECTRODE: {
        name: 'Electrode',
        images: POKEMON_IMAGES.ELECTRODE,
        number: 101,
        pokemonType: 'Ball',
        stage: 1,
    },
    EXEGGCUTE: {
        name: 'Exeggcute',
        images: POKEMON_IMAGES.EXEGGCUTE,
        number: 102,
        pokemonType: 'Egg',
    },
    EXEGGUTOR: {
        name: 'Exeggutor',
        images: POKEMON_IMAGES.EXEGGUTOR,
        number: 103,
        pokemonType: 'Coconut',
        stage: 1,
    },
    CUBONE: {
        name: 'Cubone',
        images: POKEMON_IMAGES.CUBONE,
        number: 104,
        pokemonType: 'Lonely',
    },
    MAROWAK: {
        name: 'Marowak',
        images: POKEMON_IMAGES.MAROWAK,
        number: 105,
        pokemonType: 'Bonekeeper',
        stage: 1,
    },
    HITMONLEE: {
        name: 'Hitmonlee',
        images: POKEMON_IMAGES.HITMONLEE,
        number: 106,
        pokemonType: 'Kicking',
    },
    HITMONCHAN: {
        name: 'Hitmonchan',
        images: POKEMON_IMAGES.HITMONCHAN,
        number: 107,
        pokemonType: 'Punching',
    },
    LICKITUNG: {
        name: 'Lickitung',
        images: POKEMON_IMAGES.LICKITUNG,
        number: 108,
        pokemonType: 'Licking',
    },
    KOFFING: {
        name: 'Koffing',
        images: POKEMON_IMAGES.KOFFING,
        number: 109,
        pokemonType: 'Poison Gas',
    },
    WEEZING: {
        name: 'Weezing',
        images: POKEMON_IMAGES.WEEZING,
        number: 110,
        pokemonType: 'Poison Gas',
        stage: 1,
    },
    RHYHORN: {
        name: 'Rhyhorn',
        images: POKEMON_IMAGES.RHYHORN,
        number: 111,
        pokemonType: 'Spikes',
    },
    RHYDON: {
        name: 'Rhydon',
        images: POKEMON_IMAGES.RHYDON,
        number: 112,
        pokemonType: 'Drill',
        stage: 1,
    },
    CHANSEY: {
        name: 'Chansey',
        images: POKEMON_IMAGES.CHANSEY,
        number: 113,
        pokemonType: 'Egg',
    },
    TANGELA: {
        name: 'Tangela',
        images: POKEMON_IMAGES.TANGELA,
        number: 114,
        pokemonType: 'Vine',
    },
    KANGASKHAN: {
        name: 'Kangaskhan',
        images: POKEMON_IMAGES.KANGASKHAN,
        number: 115,
        pokemonType: 'Parent',
    },
    HORSEA: {
        name: 'Horsea',
        images: POKEMON_IMAGES.HORSEA,
        number: 116,
        pokemonType: 'Dragon',
    },
    SEADRA: {
        name: 'Seadra',
        images: POKEMON_IMAGES.SEADRA,
        number: 117,
        pokemonType: 'Dragon',
        stage: 1,
    },
    GOLDEEN: {
        name: 'Goldeen',
        images: POKEMON_IMAGES.GOLDEEN,
        number: 118,
        pokemonType: 'Goldfish',
    },
    SEAKING: {
        name: 'Seaking',
        images: POKEMON_IMAGES.SEAKING,
        number: 119,
        pokemonType: 'Goldfish',
        stage: 1,
    },
    STARYU: {
        name: 'Staryu',
        images: POKEMON_IMAGES.STARYU,
        number: 120,
        pokemonType: 'Starshape',
    },
    STARMIE: {
        name: 'Starmie',
        images: POKEMON_IMAGES.STARMIE,
        number: 121,
        pokemonType: 'Mysterious',
        stage: 1,
    },
    MR_MIME: {
        name: 'Mr. Mime',
        images: POKEMON_IMAGES.MR_MIME,
        number: 122,
        pokemonType: 'Barrier',
    },
    SCYTHER: {
        name: 'Scyther',
        images: POKEMON_IMAGES.SCYTHER,
        number: 123,
        pokemonType: 'Mantis',
    },
    JYNX: {
        name: 'Jynx',
        images: POKEMON_IMAGES.JYNX,
        number: 124,
        pokemonType: 'Human Shape',
    },
    ELECTABUZZ: {
        name: 'Electabuzz',
        images: POKEMON_IMAGES.ELECTABUZZ,
        number: 125,
        pokemonType: 'Electric',
    },
    MAGMAR: {
        name: 'Magmar',
        images: POKEMON_IMAGES.MAGMAR,
        number: 126,
        pokemonType: 'Spitfire',
    },
    PINSIR: {
        name: 'Pinsir',
        images: POKEMON_IMAGES.PINSIR,
        number: 127,
        pokemonType: 'Stagbeetle',
    },
    TAUROS: {
        name: 'Tauros',
        images: POKEMON_IMAGES.TAUROS,
        number: 128,
        pokemonType: 'Wild Bull',
    },
    MAGIKARP: {
        name: 'Magikarp',
        images: POKEMON_IMAGES.MAGIKARP,
        number: 129,
        pokemonType: 'Fish',
    },
    GYARADOS: {
        name: 'Gyarados',
        images: POKEMON_IMAGES.GYARADOS,
        number: 130,
        pokemonType: 'Atrocious',
        stage: 1,
    },
    LAPRAS: {
        name: 'Lapras',
        images: POKEMON_IMAGES.LAPRAS,
        number: 131,
        pokemonType: 'Transport',
    },
    DITTO: {
        name: 'Ditto',
        images: POKEMON_IMAGES.DITTO,
        number: 132,
        pokemonType: 'Transform',
    },
    EEVEE: {
        name: 'Eevee',
        images: POKEMON_IMAGES.EEVEE,
        number: 133,
        pokemonType: 'Evolution',
    },
    VAPOREON: {
        name: 'Vaporeon',
        images: POKEMON_IMAGES.VAPOREON,
        number: 134,
        pokemonType: 'Bubble Jet',
        stage: 1,
    },
    JOLTEON: {
        name: 'Jolteon',
        images: POKEMON_IMAGES.JOLTEON,
        number: 135,
        pokemonType: 'Lightning',
        stage: 1,
    },
    FLAREON: {
        name: 'Flareon',
        images: POKEMON_IMAGES.FLAREON,
        number: 136,
        pokemonType: 'Flame',
        stage: 1,
    },
    PORYGON: {
        name: 'Porygon',
        images: POKEMON_IMAGES.PORYGON,
        number: 137,
        pokemonType: 'Virtual',
    },
    OMANYTE: {
        name: 'Omanyte',
        images: POKEMON_IMAGES.OMANYTE,
        number: 138,
        pokemonType: 'Spiral',
        stage: 1,
    },
    OMASTAR: {
        name: 'Omastar',
        images: POKEMON_IMAGES.OMASTAR,
        number: 139,
        stage: 2,
        pokemonType: 'Spiral',
    },
    KABUTO: {
        name: 'Kabuto',
        images: POKEMON_IMAGES.KABUTO,
        number: 140,
        pokemonType: 'Shellfish',
        stage: 1,
    },
    KABUTOPS: {
        name: 'Kabutops',
        images: POKEMON_IMAGES.KABUTOPS,
        number: 141,
        pokemonType: 'Shellfish',
        stage: 2,
    },
    AERODACTYL: {
        name: 'Aerodactyl',
        images: POKEMON_IMAGES.AERODACTYL,
        number: 142,
        pokemonType: 'Fossil',
        stage: 1,
    },
    SNORLAX: {
        name: 'Snorlax',
        images: POKEMON_IMAGES.SNORLAX,
        number: 143,
        pokemonType: 'Sleeping',
    },
    ARTICUNO: {
        name: 'Articuno',
        images: POKEMON_IMAGES.ARTICUNO,
        number: 144,
        pokemonType: 'Freeze',
    },
    ZAPDOS: {
        name: 'Zapdos',
        images: POKEMON_IMAGES.ZAPDOS,
        number: 145,
        pokemonType: 'Electric',
    },
    MOLTRES: {
        name: 'Moltres',
        images: POKEMON_IMAGES.MOLTRES,
        number: 146,
        pokemonType: 'Flame',
    },
    DRATINI: {
        name: 'Dratini',
        images: POKEMON_IMAGES.DRATINI,
        number: 147,
        pokemonType: 'Dragon',
    },
    DRAGONAIR: {
        name: 'Dragonair',
        images: POKEMON_IMAGES.DRAGONAIR,
        number: 148,
        pokemonType: 'Dragon',
        stage: 1,
    },
    DRAGONITE: {
        name: 'Dragonite',
        images: POKEMON_IMAGES.DRAGONITE,
        number: 149,
        pokemonType: 'Dragon',
        stage: 2,
    },
    MEWTWO: {
        name: 'Mewtwo',
        images: POKEMON_IMAGES.MEWTWO,
        number: 150,
        pokemonType: 'Psi',
    },
    MEW: {
        name: 'Mew',
        images: POKEMON_IMAGES.MEW,
        number: 151,
        pokemonType: 'New Species',
    },
};

const GEN_2_POKEMON_IMAGES = {
    CHIKORITA: [
        {
            label: 'Evo Box / Neo Genesis A',
            value: '',
        },
        {
            label: 'Neo Genesis B',
            value: '',
        },
    ],
    BAYLEEF: [
        {
            label: 'Neo Genesis A',
            value: '',
        },
        {
            label: 'Neo Genesis B',
            value: '',
        },
    ],
    MEGANIUM: [
        {
            label: 'Neo Genesis A',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/meganium/meganium-neo-genesis-a.png',
        },
        {
            label: 'Neo Genesis B',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/meganium/meganium-neo-genesis-b.png',
        },
    ],
    CYNDAQUIL: [
        {
            label: 'Neo Genesis A',
            value: '',
        },
        {
            label: 'Neo Genesis B',
            value: '',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    QUILAVA: [
        {
            label: 'Neo Genesis A',
            value: '',
        },
        {
            label: 'Neo Genesis B',
            value: '',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    TYPHLOSION: [
        {
            label: 'Neo Genesis A',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/typhlosion/typhlosion-neo-genesis-a.png',
        },
        {
            label: 'Neo Genesis B',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/typhlosion/typhlosion-neo-genesis-b.png',
        },
        {
            label: 'Neo Destiny',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/typhlosion/typhlosion-neo-destiny.png',
        },
        {
            label: 'Expedition A',
            value: '',
        },
        {
            label: 'Expedition B',
            value: '',
        },
    ],
    TOTODILE: [
        {
            label: 'Neo Genesis A',
            value: '',
        },
        {
            label: 'Neo Genesis B',
            value: '',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    CROCONAW: [
        {
            label: 'Neo Genesis A',
            value: '',
        },
        {
            label: 'Neo Genesis B',
            value: '',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    FERALIGATR: [
        {
            label: 'Neo Genesis A',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/feraligatr/feraligatr-neo-genesis-a.png',
        },
        {
            label: 'Neo Genesis B',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/feraligatr/feraligatr-neo-genesis-b.png',
        },
        {
            label: 'Neo Destiny',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/feraligatr/feraligatr-neo-destiny.png',
        },
        {
            label: 'Expedition A',
            value: '',
        },
        {
            label: 'Expedition B',
            value: '',
        },
    ],
    SENTRET: [
        {
            label: 'Evo Box / Neo Genesis',
            value: '',
        },
        {
            label: 'Neo Discovery',
            value: '',
        },
    ],
    FURRET: [
        {
            label: 'Neo Genesis',
            value: '',
        },
    ],
    HOOTHOOT: [
        {
            label: 'Neo Genesis',
            value: '',
        },
    ],
    NOCTOWL: [
        {
            label: 'Neo Genesis',
            value: '',
        },
        {
            label: 'Neo Destiny',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/noctowl/noctowl-neo-destiny-shining.png',
        },
    ],
    LEDYBA: [
        {
            label: 'Neo Genesis',
            value: '',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
        {
            label: 'Southern Islands',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/ledyba/ledyba-southern-islands.jpg',
        },
    ],
    LEDIAN: [
        {
            label: 'Neo Genesis',
            value: '',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    SPINARAK: [
        {
            label: 'Evo Box / Neo Genesis',
            value: '',
        },
        {
            label: 'Neo Discovery',
            value: '',
        },
    ],
    ARIADOS: [
        {
            label: 'Neo Genesis',
            value: '',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    CROBAT: [
        {
            label: 'Neo Revelation',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/crobat/crobat-neo-revelation.png',
        },
        {
            label: 'Neo Destiny',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/crobat/crobat-neo-destiny.png',
        },
    ],
    CHINCHOU: [
        {
            label: 'Neo Genesis',
            value: '',
        },
        {
            label: 'Neo Revelation',
            value: '',
        },
    ],
    LANTURN: [
        {
            label: 'Neo Genesis',
            value: '',
        },
        {
            label: 'Neo Revelation',
            value: '',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    PICHU: [
        {
            label: 'Neo Genesis',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/pichu/pichu-neo-genesis.png',
        },
    ],
    CLEFFA: [
        {
            label: 'Neo Genesis',
            value: '',
        },
    ],
    IGGLYBUFF: [
        {
            label: 'Neo Discovery',
            value: '',
        },
    ],
    TOGEPI: [
        {
            label: 'Evolution Box',
            value: '',
        },
        {
            label: 'Neo Genesis',
            value: '',
        },
        {
            label: 'Southern Islands',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/togepi/togepi-southern-islands.jpg',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    TOGETIC: [
        {
            label: 'Neo Genesis',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/togetic/togetic-neo-genesis.png',
        },
        {
            label: 'Neo Destiny',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/togetic/togetic-neo-destiny.png',
        },
    ],
    NATU: [
        {
            label: 'Evo Box / Neo Genesis',
            value: '',
        },
        {
            label: 'Neo Discovery',
            value: '',
        },
    ],
    XATU: [
        {
            label: 'Neo Genesis',
            value: '',
        },
        {
            label: 'Neo Discovery',
            value: '',
        },
    ],
    MAREEP: [
        {
            label: 'Evo Box / Neo Genesis',
            value: '',
        },
        {
            label: 'Neo Discovery',
            value: '',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    FLAAFFY: [
        {
            label: 'Neo Genesis',
            value: '',
        },
        {
            label: 'Neo Revelation',
            value: '',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    AMPHAROS: [
        {
            label: 'Neo Genesis',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/ampharos/ampharos-neo-genesis.png',
        },
        {
            label: 'Neo Revelation',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/ampharos/ampharos-neo-revelation.png',
        },
        {
            label: 'Neo Destiny',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/ampharos/ampharos-neo-destiny.png',
        },
    ],
    BELLOSSOM: [
        {
            label: 'Neo Genesis',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/bellossom/bellossom-neo-genesis.png',
        },
    ],
    MARILL: [
        {
            label: 'Evolution Box',
            value: '',
        },
        {
            label: 'Neo Genesis',
            value: '',
        },
        {
            label: 'Southern Islands',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/marill/marill-southern-islands.jpg',
        },
    ],
    AZUMARILL: [
        {
            label: 'Neo Genesis',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/azumarill/azumarill-neo-genesis.png',
        },
        {
            label: 'Neo Destiny',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/azumarill/azumarill-neo-destiny.png',
        },
        {
            label: 'Aquapolis',
            value: '',
        },
    ],
    SUDOWOODO: [
        {
            label: 'Neo Genesis',
            value: '',
        },
        {
            label: 'Neo Revelation',
            value: '',
        },
    ],
    POLITOED: [
        {
            label: 'Neo Discovery',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/politoed/politoed-neo-discovery.png',
        },
    ],
    HOPPIP: [
        {
            label: 'Neo Genesis',
            value: '',
        },
        {
            label: 'Neo Discovery',
            value: '',
        },
    ],
    SKIPLOOM: [
        {
            label: 'Neo Genesis',
            value: '',
        },
        {
            label: 'Neo Revelation',
            value: '',
        },
    ],
    JUMPLUFF: [
        {
            label: 'Neo Genesis',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/jumpluff/jumpluff-neo-genesis.png',
        },
        {
            label: 'Neo Revelation',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/jumpluff/jumpluff-neo-revelation.png',
        },
    ],
    AIPOM: [
        {
            label: 'Neo Genesis',
            value: '',
        },
        {
            label: 'Neo Revelation',
            value: '',
        },
    ],
    SUNKERN: [
        {
            label: 'Neo Genesis',
            value: '',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    SUNFLORA: [
        {
            label: 'Neo Genesis',
            value: '',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    YANMA: [
        {
            label: 'Neo Discovery',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/yanma/yanma-neo-discovery.png',
        },
    ],
    WOOPER: [
        {
            label: 'Evolution Box',
            value: '',
        },
        {
            label: 'Neo Genesis',
            value: '',
        },
        {
            label: 'Neo Discovery',
            value: '',
        },
    ],
    QUAGSIRE: [
        {
            label: 'Neo Genesis',
            value: '',
        },
        {
            label: 'Neo Revelation',
            value: '',
        },
    ],
    ESPEON: [
        {
            label: 'Neo Discovery',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/espeon/espeon-neo-discovery.png',
        },
        {
            label: 'Neo Discovery B',
            value: '',
        },
        {
            label: 'Neo Destiny',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/espeon/espeon-neo-destiny.png',
        },
    ],
    UMBREON: [
        {
            label: 'Neo Discovery',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/umbreon/umbreon-neo-discovery.png',
        },
        {
            label: 'Neo Discovery B',
            value: '',
        },
    ],
    MURKROW: [
        {
            label: 'Neo Genesis',
            value: '',
        },
        {
            label: 'Neo Revelation',
            value: '',
        },
    ],
    SLOWKING: [
        {
            label: 'Neo Genesis',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/slowking/slowking-neo-genesis.png',
        },
        {
            label: 'Southern Islands',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/slowking/slowking-southern-islands.jpg',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    MISDREAVUS: [
        {
            label: 'Neo Revelation',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/misdreavus/misdreavus-neo-revelation.png',
        },
    ],
    UNOWN_A: [
        {
            label: 'Neo Discovery',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/unown-a/unown-a-neo-discovery.png',
        },
    ],
    UNOWN_B: [
        {
            label: 'Neo Revelation',
            value: '',
        },
    ],
    UNOWN_C: [
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    UNOWN_D: [
        {
            label: 'Neo Discovery',
            value: '',
        },
    ],
    UNOWN_E: [
        {
            label: 'Neo Discovery',
            value: '',
        },
    ],
    UNOWN_F: [
        {
            label: 'Neo Discovery',
            value: '',
        },
    ],
    UNOWN_G: [
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    UNOWN_H: [
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    UNOWN_I: [
        {
            label: 'Neo Discovery',
            value: '',
        },
    ],
    UNOWN_J: [
        {
            label: 'Black Star Promo',
            value: '',
        },
    ],
    UNOWN_K: [
        {
            label: 'Neo Revelation',
            value: '',
        },
    ],
    UNOWN_L: [
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    UNOWN_M: [
        {
            label: 'Neo Discovery',
            value: '',
        },
    ],
    UNOWN_N: [
        {
            label: 'Neo Discovery',
            value: '',
        },
    ],
    UNOWN_O: [
        {
            label: 'Neo Discovery',
            value: '',
        },
    ],
    UNOWN_P: [
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    UNOWN_Q: [
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    UNOWN_R: [],
    UNOWN_S: [
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    UNOWN_T: [
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    UNOWN_U: [
        {
            label: 'Neo Discovery',
            value: '',
        },
    ],
    UNOWN_V: [
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    UNOWN_W: [
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    UNOWN_X: [
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    UNOWN_Y: [
        {
            label: 'Neo Revelation',
            value: '',
        },
    ],
    UNOWN_Z: [
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    WOBBUFFET: [
        {
            label: 'Neo Discovery',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/wobbuffet/wobbuffet-neo-discovery.png',
        },
    ],
    GIRAFARIG: [
        {
            label: 'Neo Genesis',
            value: '',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    PINECO: [
        {
            label: 'Evolution Box',
            value: '',
        },
        {
            label: 'Neo Discovery',
            value: '',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    FORRETRESS: [
        {
            label: 'Neo Discovery',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/forretress/forretress-neo-discovery.png',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    DUNSPARCE: [
        {
            label: 'Neo Discovery',
            value: '',
        },
    ],
    GLIGAR: [
        {
            label: 'Neo Genesis',
            value: '',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    STEELIX: [
        {
            label: 'Neo Genesis',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/steelix/steelix-neo-genesis.png',
        },
        {
            label: 'Neo Destiny',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/steelix/steelix-neo-destiny-shining.png',
        },
        {
            label: 'Aquapolis',
            value: '',
        },
        {
            label: 'Skyridge',
            value: '',
        },
    ],
    SNUBBULL: [
        {
            label: 'Evolution Box',
            value: '',
        },
        {
            label: 'Neo Genesis',
            value: '',
        },
        {
            label: 'Neo Revelation',
            value: '',
        },
    ],
    GRANBULL: [
        {
            label: 'Neo Genesis',
            value: '',
        },
    ],
    QWILFISH: [
        {
            label: 'Neo Revelation',
            value: '',
        },
    ],
    SCIZOR: [
        {
            label: 'Best Of Game',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/scizor/scizor-best-of.png',
        },
        {
            label: 'Neo Discovery',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/scizor/scizor-neo-discovery.png',
        },
        {
            label: 'Neo Destiny',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/scizor/scizor-neo-destiny.png',
        },
        {
            label: 'Aquapolis',
            value: '',
        },
    ],
    SHUCKLE: [
        {
            label: 'Neo Genesis',
            value: '',
        },
        {
            label: 'Neo Revelation',
            value: '',
        },
    ],
    HERACROSS: [
        {
            label: 'Neo Genesis',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/heracross/heracross-neo-genesis.png',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    SNEASEL: [
        {
            label: 'Best Of Game',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/sneasel/sneasel-best-of.png',
        },
        {
            label: 'Neo Genesis',
            value: '',
        },
        {
            label: 'Neo Revelation',
            value: '',
        },
    ],
    TEDDIURSA: [
        {
            label: 'Evolution Box',
            value: '',
        },
        {
            label: 'Neo Discovery',
            value: '',
        },
    ],
    URSARING: [
        {
            label: 'Neo Discovery',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/ursaring/ursaring-neo-discovery.png',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    SLUGMA: [
        {
            label: 'Neo Revelation',
            value: '',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    MAGCARGO: [
        {
            label: 'Neo Revelation',
            value: '',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    SWINUB: [
        {
            label: 'Neo Genesis',
            value: '',
        },
        {
            label: 'Neo Revelation',
            value: '',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    PILOSWINE: [
        {
            label: 'Neo Genesis',
            value: '',
        },
        {
            label: 'Neo Revelation',
            value: '',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    CORSOLA: [
        {
            label: 'Neo Discovery',
            value: '',
        },
    ],
    REMORAID: [
        {
            label: 'Evolution Box',
            value: '',
        },
        {
            label: 'Neo Revelation',
            value: '',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    OCTILLERY: [
        {
            label: 'Neo Revelation',
            value: '',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    DELIBIRD: [
        {
            label: 'Neo Revelation',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/delibird/delibird-neo-revelation.png',
        },
    ],
    MANTINE: [
        {
            label: 'Neo Genesis',
            value: '',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    SKARMORY: [
        {
            label: 'Neo Genesis',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/skarmory/skarmory-neo-genesis.png',
        },
        {
            label: 'Neo Revelation A',
            value: '',
        },
        {
            label: 'Neo Revleation B',
            value: '',
        },
    ],
    HOUNDOUR: [
        {
            label: 'Evolution Box',
            value: '',
        },
        {
            label: 'Neo Discovery',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/houndour/houndour-neo-discovery.png',
        },
        {
            label: 'Neo Discovery B',
            value: '',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    HOUNDOOM: [
        {
            label: 'Neo Discovery',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/houndoom/houndoom-neo-discovery.png',
        },
        {
            label: 'Neo Revelation',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/houndoom/houndoom-neo-revelation.png',
        },
        {
            label: 'Neo Destiny',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/houndoom/houndoom-neo-destiny.png',
        },
        {
            label: 'Aquapolis A',
            value: '',
        },
        {
            label: 'Aquapolis B',
            value: '',
        },
    ],
    KINGDRA: [
        {
            label: 'Neo Genesis',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/kingdra/kingdra-neo-genesis.png',
        },
        {
            label: 'Neo Revelation',
            value: '',
        },
    ],
    PHANPY: [
        {
            label: 'Neo Genesis',
            value: '',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    DONPHAN: [
        {
            label: 'Neo Genesis',
            value: '',
        },
        {
            label: 'Neo Destiny',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/donphan/donphan-neo-destiny.png',
        },
    ],
    PORYGON2: [
        {
            label: 'Neo Revelation',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/porygon2/porygon2-neo-revelation.png',
        },
        {
            label: 'Neo Destiny',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/porygon2/porygon2-neo-destiny.png',
        },
    ],
    STANTLER: [
        {
            label: 'Neo Genesis',
            value: '',
        },
        {
            label: 'Neo Revelation',
            value: '',
        },
    ],
    SMEARGLE: [
        {
            label: 'Neo Discovery',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/smeargle/smeargle-neo-discovery.png',
        },
    ],
    TYROGUE: [
        {
            label: 'Neo Discovery',
            value: '',
        },
    ],
    HITMONTOP: [
        {
            label: 'Neo Discovery',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/hitmontop/hitmontop-neo-discovery.png',
        },
    ],
    SMOOCHUM: [
        {
            label: 'Neo Revelation',
            value: '',
        },
    ],
    ELEKID: [
        {
            label: 'Neo Genesis',
            value: '',
        },
    ],
    MAGBY: [
        {
            label: 'Neo Genesis',
            value: '',
        },
    ],
    MILTANK: [
        {
            label: 'Neo Genesis',
            value: '',
        },
    ],
    BLISSEY: [
        {
            label: 'Neo Revelation',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/blissey/blissey-neo-revelation.png',
        },
    ],
    RAIKOU: [
        {
            label: 'Neo Revelation A',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/raikou/raikou-neo-revelation.png',
        },
        {
            label: 'Neo Revelation B',
            value: '',
        },
    ],
    ENTEI: [
        {
            label: 'Neo Revelation A',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/entei/entei-neo-revelation.png',
        },
        {
            label: 'Neo Revelation B',
            value: '',
        },
        {
            label: 'Black Star Promo',
            value: '',
        },
    ],
    SUICUNE: [
        {
            label: 'Neo Revelation A',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/suicune/suicune-neo-revelation-a.png',
        },
        {
            label: 'Neo Revelation B',
            value: '',
        },
    ],
    LARVITAR: [
        {
            label: 'Evolution Box',
            value: '',
        },
        {
            label: 'Neo Discovery',
            value: '',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    PUPITAR: [
        {
            label: 'Neo Discovery',
            value: '',
        },
        {
            label: 'Neo Destiny',
            value: '',
        },
    ],
    TYRANITAR: [
        {
            label: 'Neo Discovery',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/tyranitar/tyranitar-neo-discovery.png',
        },
        {
            label: 'Neo Destiny A',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/tyranitar/tyranitar-neo-destiny.png',
        },
        {
            label: 'Neo Destiny B',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/tyranitar/tyranitar-neo-destiny-shining.png',
        },
        {
            label: 'Expedition',
            value: '',
        },
        {
            label: 'Aquapolis',
            value: '',
        },
    ],
    LUGIA: [
        {
            label: 'Neo Genesis',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/lugia/lugia-neo-genesis.png',
        },
        {
            label: 'Neo Revelation',
            value: '',
        },
    ],
    HO_OH: [
        {
            label: 'Neo Revelation A',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/ho-oh/ho-oh-neo-revelation.png',
        },
        {
            label: 'Neo Revelation B',
            value: '',
        },
    ],
    CELEBI: [
        {
            label: 'Neo Revelation A',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/celebi/celebi-neo-revelation-a.png',
        },
        {
            label: 'Neo Revelation B',
            value: '',
        },
        {
            label: 'Neo Destiny',
            value: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/celebi/celebi-neo-destiny-shining.png',
        },
        {
            label: 'Black Star Promo',
            value: '',
        },
    ],
};

const UNOWN_PKMN_TYPE = 'Symbol';
const UNOWN_PKMN_NUMBER = 201;
const GEN_2_POKEMON = {
    CHIKORITA: {
        name: 'Chikorita',
        images: GEN_2_POKEMON_IMAGES.CHIKORITA,
        number: 152,
        pokemonType: '',
    },
    BAYLEEF: {
        name: 'Bayleef',
        images: GEN_2_POKEMON_IMAGES.BAYLEEF,
        number: 153,
        pokemonType: '',
        stage: 1,
    },
    MEGANIUM: {
        name: 'Meganium',
        images: GEN_2_POKEMON_IMAGES.MEGANIUM,
        number: 154,
        pokemonType: 'Herb',
        stage: 2,
    },
    CYNDAQUIL: {
        name: 'Cyndaquil',
        images: GEN_2_POKEMON_IMAGES.CYNDAQUIL,
        number: 155,
        pokemonType: '',
    },
    QUILAVA: {
        name: 'Quilava',
        images: GEN_2_POKEMON_IMAGES.QUILAVA,
        number: 156,
        pokemonType: '',
        stage: 1,
    },
    TYPHLOSION: {
        name: 'Typhlosion',
        images: GEN_2_POKEMON_IMAGES.TYPHLOSION,
        number: 157,
        pokemonType: 'Volcano',
        stage: 2,
    },
    TOTODILE: {
        name: 'Totodile',
        images: GEN_2_POKEMON_IMAGES.TOTODILE,
        number: 158,
        pokemonType: '',
    },
    CROCONAW: {
        name: 'Croconaw',
        images: GEN_2_POKEMON_IMAGES.CROCONAW,
        number: 159,
        pokemonType: '',
        stage: 1,
    },
    FERALIGATR: {
        name: 'Feraligatr',
        images: GEN_2_POKEMON_IMAGES.FERALIGATR,
        number: 160,
        pokemonType: 'Big Jaw',
        stage: 2,
    },
    SENTRET: {
        name: 'Sentret',
        images: GEN_2_POKEMON_IMAGES.SENTRET,
        number: 161,
        pokemonType: '',
    },
    FURRET: {
        name: 'Furret',
        images: GEN_2_POKEMON_IMAGES.FURRET,
        number: 162,
        pokemonType: '',
        stage: 1,
    },
    HOOTHOOT: {
        name: 'Hoothoot',
        images: GEN_2_POKEMON_IMAGES.HOOTHOOT,
        number: 163,
        pokemonType: '',
    },
    NOCTOWL: {
        name: 'Noctowl',
        images: GEN_2_POKEMON_IMAGES.NOCTOWL,
        number: 164,
        pokemonType: '',
        stage: 1,
    },
    LEDYBA: {
        name: 'Ledyba',
        images: GEN_2_POKEMON_IMAGES.LEDYBA,
        number: 165,
        pokemonType: 'Five Star',
    },
    LEDIAN: {
        name: 'Ledian',
        images: GEN_2_POKEMON_IMAGES.LEDIAN,
        number: 166,
        pokemonType: '',
        stage: 1,
    },
    SPINARAK: {
        name: 'Spinarak',
        images: GEN_2_POKEMON_IMAGES.SPINARAK,
        number: 167,
        pokemonType: '',
    },
    ARIADOS: {
        name: 'Ariados',
        images: GEN_2_POKEMON_IMAGES.ARIADOS,
        number: 168,
        pokemonType: '',
        stage: 1,
    },
    CROBAT: {
        name: 'Crobat',
        images: GEN_2_POKEMON_IMAGES.CROBAT,
        number: 169,
        pokemonType: 'Bat',
        stage: 2,
    },
    CHINCHOU: {
        name: 'Chinchou',
        images: GEN_2_POKEMON_IMAGES.CHINCHOU,
        number: 170,
        pokemonType: '',
    },
    LANTURN: {
        name: 'Lanturn',
        images: GEN_2_POKEMON_IMAGES.LANTURN,
        number: 171,
        pokemonType: '',
        stage: 1,
    },
    PICHU: {
        name: 'Pichu',
        images: GEN_2_POKEMON_IMAGES.PICHU,
        number: 172,
        pokemonType: 'Tiny Mouse',
    },
    CLEFFA: {
        name: 'Cleffa',
        images: GEN_2_POKEMON_IMAGES.CLEFFA,
        number: 173,
        pokemonType: 'Starshape',
    },
    IGGLYBUFF: {
        name: 'Igglybuff',
        images: GEN_2_POKEMON_IMAGES.IGGLYBUFF,
        number: 174,
        pokemonType: '',
    },
    TOGEPI: {
        name: 'Togepi',
        images: GEN_2_POKEMON_IMAGES.TOGEPI,
        number: 175,
        pokemonType: 'Spike Ball',
    },
    TOGETIC: {
        name: 'Togetic',
        images: GEN_2_POKEMON_IMAGES.TOGETIC,
        number: 176,
        pokemonType: 'Happiness',
        stage: 1,
    },
    NATU: {
        name: 'Natu',
        images: GEN_2_POKEMON_IMAGES.NATU,
        number: 177,
        pokemonType: '',
    },
    XATU: {
        name: 'Xatu',
        images: GEN_2_POKEMON_IMAGES.XATU,
        number: 178,
        pokemonType: '',
        stage: 1,
    },
    MAREEP: {
        name: 'Mareep',
        images: GEN_2_POKEMON_IMAGES.MAREEP,
        number: 179,
        pokemonType: '',
    },
    FLAAFFY: {
        name: 'Flaaffy',
        images: GEN_2_POKEMON_IMAGES.FLAAFFY,
        number: 180,
        pokemonType: '',
        stage: 1,
    },
    AMPHAROS: {
        name: 'Ampharos',
        images: GEN_2_POKEMON_IMAGES.AMPHAROS,
        number: 181,
        pokemonType: 'Light',
        stage: 2,
    },
    BELLOSSOM: {
        name: 'Bellossom',
        images: GEN_2_POKEMON_IMAGES.BELLOSSOM,
        number: 182,
        pokemonType: 'Flower',
        stage: 2,
    },
    MARILL: {
        name: 'Marill',
        images: GEN_2_POKEMON_IMAGES.MARILL,
        number: 183,
        pokemonType: 'Aquamouse',
    },
    AZUMARILL: {
        name: 'Azumarill',
        images: GEN_2_POKEMON_IMAGES.AZUMARILL,
        number: 184,
        pokemonType: 'Aquarabbit',
        stage: 1,
    },
    SUDOWOODO: {
        name: 'Sudowoodo',
        images: GEN_2_POKEMON_IMAGES.SUDOWOODO,
        number: 185,
        pokemonType: '',
    },
    POLITOED: {
        name: 'Politoed',
        images: GEN_2_POKEMON_IMAGES.POLITOED,
        number: 186,
        pokemonType: 'Frog',
        stage: 2,
    },
    HOPPIP: {
        name: 'Hoppip',
        images: GEN_2_POKEMON_IMAGES.HOPPIP,
        number: 187,
        pokemonType: '',
    },
    SKIPLOOM: {
        name: 'Skiploom',
        images: GEN_2_POKEMON_IMAGES.SKIPLOOM,
        number: 188,
        pokemonType: '',
        stage: 1,
    },
    JUMPLUFF: {
        name: 'Jumpluff',
        images: GEN_2_POKEMON_IMAGES.JUMPLUFF,
        number: 189,
        pokemonType: 'Cottonweed',
        stage: 2,
    },
    AIPOM: {
        name: 'Aipom',
        images: GEN_2_POKEMON_IMAGES.AIPOM,
        number: 190,
        pokemonType: '',
    },
    SUNKERN: {
        name: 'Sunkern',
        images: GEN_2_POKEMON_IMAGES.SUNKERN,
        number: 191,
        pokemonType: '',
    },
    SUNFLORA: {
        name: 'Sunflora',
        images: GEN_2_POKEMON_IMAGES.SUNFLORA,
        number: 192,
        pokemonType: '',
        stage: 1,
    },
    YANMA: {
        name: 'Yanma',
        images: GEN_2_POKEMON_IMAGES.YANMA,
        number: 193,
        pokemonType: 'Clear Wing',
    },
    WOOPER: {
        name: 'Wooper',
        images: GEN_2_POKEMON_IMAGES.WOOPER,
        number: 194,
        pokemonType: '',
    },
    QUAGSIRE: {
        name: 'Quagsire',
        images: GEN_2_POKEMON_IMAGES.QUAGSIRE,
        number: 195,
        pokemonType: '',
        stage: 1,
    },
    ESPEON: {
        name: 'Espeon',
        images: GEN_2_POKEMON_IMAGES.ESPEON,
        number: 196,
        pokemonType: 'Sun',
        stage: 1,
    },
    UMBREON: {
        name: 'Umbreon',
        images: GEN_2_POKEMON_IMAGES.UMBREON,
        number: 197,
        pokemonType: 'Moonlight',
        stage: 1,
    },
    MURKROW: {
        name: 'Murkrow',
        images: GEN_2_POKEMON_IMAGES.MURKROW,
        number: 198,
        pokemonType: '',
    },
    SLOWKING: {
        name: 'Slowking',
        images: GEN_2_POKEMON_IMAGES.SLOWKING,
        number: 199,
        pokemonType: 'Royal',
        stage: 1,
    },
    MISDREAVUS: {
        name: 'Misdreavus',
        images: GEN_2_POKEMON_IMAGES.MISDREAVUS,
        number: 200,
        pokemonType: 'Screech',
    },
    UNOWN_A: {
        name: 'Unown A',
        images: GEN_2_POKEMON_IMAGES.UNOWN_A,
        number: UNOWN_PKMN_NUMBER,
        pokemonType: UNOWN_PKMN_TYPE,
    },
    UNOWN_B: {
        name: 'Unown B',
        images: GEN_2_POKEMON_IMAGES.UNOWN_B,
        number: UNOWN_PKMN_NUMBER,
        pokemonType: UNOWN_PKMN_TYPE,
    },
    UNOWN_C: {
        name: 'Unown C',
        images: GEN_2_POKEMON_IMAGES.UNOWN_C,
        number: UNOWN_PKMN_NUMBER,
        pokemonType: UNOWN_PKMN_TYPE,
    },
    UNOWN_D: {
        name: 'Unown D',
        images: GEN_2_POKEMON_IMAGES.UNOWN_D,
        number: UNOWN_PKMN_NUMBER,
        pokemonType: UNOWN_PKMN_TYPE,
    },
    UNOWN_E: {
        name: 'Unown E',
        images: GEN_2_POKEMON_IMAGES.UNOWN_E,
        number: UNOWN_PKMN_NUMBER,
        pokemonType: UNOWN_PKMN_TYPE,
    },
    UNOWN_F: {
        name: 'Unown F',
        images: GEN_2_POKEMON_IMAGES.UNOWN_F,
        number: UNOWN_PKMN_NUMBER,
        pokemonType: UNOWN_PKMN_TYPE,
    },
    UNOWN_G: {
        name: 'Unown G',
        images: GEN_2_POKEMON_IMAGES.UNOWN_G,
        number: UNOWN_PKMN_NUMBER,
        pokemonType: UNOWN_PKMN_TYPE,
    },
    UNOWN_H: {
        name: 'Unown H',
        images: GEN_2_POKEMON_IMAGES.UNOWN_H,
        number: UNOWN_PKMN_NUMBER,
        pokemonType: UNOWN_PKMN_TYPE,
    },
    UNOWN_I: {
        name: 'Unown I',
        images: GEN_2_POKEMON_IMAGES.UNOWN_I,
        number: UNOWN_PKMN_NUMBER,
        pokemonType: UNOWN_PKMN_TYPE,
    },
    UNOWN_J: {
        name: 'Unown J',
        images: GEN_2_POKEMON_IMAGES.UNOWN_J,
        number: UNOWN_PKMN_NUMBER,
        pokemonType: UNOWN_PKMN_TYPE,
    },
    UNOWN_K: {
        name: 'Unown K',
        images: GEN_2_POKEMON_IMAGES.UNOWN_K,
        number: UNOWN_PKMN_NUMBER,
        pokemonType: UNOWN_PKMN_TYPE,
    },
    UNOWN_L: {
        name: 'Unown L',
        images: GEN_2_POKEMON_IMAGES.UNOWN_L,
        number: UNOWN_PKMN_NUMBER,
        pokemonType: UNOWN_PKMN_TYPE,
    },
    UNOWN_M: {
        name: 'Unown M',
        images: GEN_2_POKEMON_IMAGES.UNOWN_M,
        number: UNOWN_PKMN_NUMBER,
        pokemonType: UNOWN_PKMN_TYPE,
    },
    UNOWN_N: {
        name: 'Unown N',
        images: GEN_2_POKEMON_IMAGES.UNOWN_N,
        number: UNOWN_PKMN_NUMBER,
        pokemonType: UNOWN_PKMN_TYPE,
    },
    UNOWN_O: {
        name: 'Unown O',
        images: GEN_2_POKEMON_IMAGES.UNOWN_O,
        number: UNOWN_PKMN_NUMBER,
        pokemonType: UNOWN_PKMN_TYPE,
    },
    UNOWN_P: {
        name: 'Unown P',
        images: GEN_2_POKEMON_IMAGES.UNOWN_P,
        number: UNOWN_PKMN_NUMBER,
        pokemonType: UNOWN_PKMN_TYPE,
    },
    UNOWN_Q: {
        name: 'Unown Q',
        images: GEN_2_POKEMON_IMAGES.UNOWN_Q,
        number: UNOWN_PKMN_NUMBER,
        pokemonType: UNOWN_PKMN_TYPE,
    },
    UNOWN_R: {
        name: 'Unown R',
        images: GEN_2_POKEMON_IMAGES.UNOWN_R,
        number: UNOWN_PKMN_NUMBER,
        pokemonType: UNOWN_PKMN_TYPE,
    },
    UNOWN_S: {
        name: 'Unown S',
        images: GEN_2_POKEMON_IMAGES.UNOWN_S,
        number: UNOWN_PKMN_NUMBER,
        pokemonType: UNOWN_PKMN_TYPE,
    },
    UNOWN_T: {
        name: 'Unown T',
        images: GEN_2_POKEMON_IMAGES.UNOWN_T,
        number: UNOWN_PKMN_NUMBER,
        pokemonType: UNOWN_PKMN_TYPE,
    },
    UNOWN_U: {
        name: 'Unown U',
        images: GEN_2_POKEMON_IMAGES.UNOWN_U,
        number: UNOWN_PKMN_NUMBER,
        pokemonType: UNOWN_PKMN_TYPE,
    },
    UNOWN_V: {
        name: 'Unown V',
        images: GEN_2_POKEMON_IMAGES.UNOWN_V,
        number: UNOWN_PKMN_NUMBER,
        pokemonType: UNOWN_PKMN_TYPE,
    },
    UNOWN_W: {
        name: 'Unown W',
        images: GEN_2_POKEMON_IMAGES.UNOWN_W,
        number: UNOWN_PKMN_NUMBER,
        pokemonType: UNOWN_PKMN_TYPE,
    },
    UNOWN_X: {
        name: 'Unown X',
        images: GEN_2_POKEMON_IMAGES.UNOWN_X,
        number: UNOWN_PKMN_NUMBER,
        pokemonType: UNOWN_PKMN_TYPE,
    },
    UNOWN_Y: {
        name: 'Unown Y',
        images: GEN_2_POKEMON_IMAGES.UNOWN_Y,
        number: UNOWN_PKMN_NUMBER,
        pokemonType: UNOWN_PKMN_TYPE,
    },
    UNOWN_Z: {
        name: 'Unown Z',
        images: GEN_2_POKEMON_IMAGES.UNOWN_Z,
        number: UNOWN_PKMN_NUMBER,
        pokemonType: UNOWN_PKMN_TYPE,
    },
    WOBBUFFET: {
        name: 'Wobbuffet',
        images: GEN_2_POKEMON_IMAGES.WOBBUFFET,
        number: 202,
        pokemonType: 'Patient',
    },
    GIRAFARIG: {
        name: 'Girafarig',
        images: GEN_2_POKEMON_IMAGES.GIRAFARIG,
        number: 203,
        pokemonType: '',
    },
    PINECO: {
        name: 'Pineco',
        images: GEN_2_POKEMON_IMAGES.PINECO,
        number: 204,
        pokemonType: '',
    },
    FORRETRESS: {
        name: 'Forretress',
        images: GEN_2_POKEMON_IMAGES.FORRETRESS,
        number: 205,
        pokemonType: 'Bagworm',
        stage: 1,
    },
    DUNSPARCE: {
        name: 'Dunsparce',
        images: GEN_2_POKEMON_IMAGES.DUNSPARCE,
        number: 206,
        pokemonType: '',
    },
    GLIGAR: {
        name: 'Gligar',
        images: GEN_2_POKEMON_IMAGES.GLIGAR,
        number: 207,
        pokemonType: '',
    },
    STEELIX: {
        name: 'Steelix',
        images: GEN_2_POKEMON_IMAGES.STEELIX,
        number: 208,
        pokemonType: 'Iron Snake',
        stage: 1,
    },
    SNUBBULL: {
        name: 'Snubbull',
        images: GEN_2_POKEMON_IMAGES.SNUBBULL,
        number: 209,
        pokemonType: '',
    },
    GRANBULL: {
        name: 'Granbull',
        images: GEN_2_POKEMON_IMAGES.GRANBULL,
        number: 210,
        pokemonType: '',
        stage: 1,
    },
    QWILFISH: {
        name: 'Qwilfish',
        images: GEN_2_POKEMON_IMAGES.QWILFISH,
        number: 211,
        pokemonType: '',
    },
    SCIZOR: {
        name: 'Scizor',
        images: GEN_2_POKEMON_IMAGES.SCIZOR,
        number: 212,
        pokemonType: 'Scissors',
        stage: 1,
    },
    SHUCKLE: {
        name: 'Shuckle',
        images: GEN_2_POKEMON_IMAGES.SHUCKLE,
        number: 213,
        pokemonType: '',
    },
    HERACROSS: {
        name: 'Heracross',
        images: GEN_2_POKEMON_IMAGES.HERACROSS,
        number: 214,
        pokemonType: 'Single Horn',
    },
    SNEASEL: {
        name: 'Sneasel',
        images: GEN_2_POKEMON_IMAGES.SNEASEL,
        number: 215,
        pokemonType: 'Sharp Claw',
    },
    TEDDIURSA: {
        name: 'Teddiursa',
        images: GEN_2_POKEMON_IMAGES.TEDDIURSA,
        number: 216,
        pokemonType: '',
    },
    URSARING: {
        name: 'Ursaring',
        images: GEN_2_POKEMON_IMAGES.URSARING,
        number: 217,
        pokemonType: 'Hibernant',
        stage: 1,
    },
    SLUGMA: {
        name: 'Slugma',
        images: GEN_2_POKEMON_IMAGES.SLUGMA,
        number: 218,
        pokemonType: '',
    },
    MAGCARGO: {
        name: 'Magcargo',
        images: GEN_2_POKEMON_IMAGES.MAGCARGO,
        number: 219,
        pokemonType: '',
        stage: 1,
    },
    SWINUB: {
        name: 'Swinub',
        images: GEN_2_POKEMON_IMAGES.SWINUB,
        number: 220,
        pokemonType: '',
    },
    PILOSWINE: {
        name: 'Piloswine',
        images: GEN_2_POKEMON_IMAGES.PILOSWINE,
        number: 221,
        pokemonType: '',
        stage: 1,
    },
    CORSOLA: {
        name: 'Corsola',
        images: GEN_2_POKEMON_IMAGES.CORSOLA,
        number: 222,
        pokemonType: '',
    },
    REMORAID: {
        name: 'Remoraid',
        images: GEN_2_POKEMON_IMAGES.REMORAID,
        number: 223,
        pokemonType: '',
    },
    OCTILLERY: {
        name: 'Octillery',
        images: GEN_2_POKEMON_IMAGES.OCTILLERY,
        number: 224,
        pokemonType: '',
        stage: 1,
    },
    DELIBIRD: {
        name: 'Delibird',
        images: GEN_2_POKEMON_IMAGES.DELIBIRD,
        number: 225,
        pokemonType: 'Delivery',
    },
    MANTINE: {
        name: 'Mantine',
        images: GEN_2_POKEMON_IMAGES.MANTINE,
        number: 226,
        pokemonType: '',
    },
    SKARMORY: {
        name: 'Skarmory',
        images: GEN_2_POKEMON_IMAGES.SKARMORY,
        number: 227,
        pokemonType: 'Armor Bird',
    },
    HOUNDOUR: {
        name: 'Houndour',
        images: GEN_2_POKEMON_IMAGES.HOUNDOUR,
        number: 228,
        pokemonType: 'Dark',
    },
    HOUNDOOM: {
        name: 'Houndoom',
        images: GEN_2_POKEMON_IMAGES.HOUNDOOM,
        number: 229,
        pokemonType: 'Dark',
        stage: 1,
    },
    KINGDRA: {
        name: 'Kingdra',
        images: GEN_2_POKEMON_IMAGES.KINGDRA,
        number: 230,
        pokemonType: 'Dragon',
        stage: 2,
    },
    PHANPY: {
        name: 'Phanpy',
        images: GEN_2_POKEMON_IMAGES.PHANPY,
        number: 231,
        pokemonType: '',
    },
    DONPHAN: {
        name: 'Donphan',
        images: GEN_2_POKEMON_IMAGES.DONPHAN,
        number: 232,
        pokemonType: '',
        stage: 1,
    },
    PORYGON2: {
        name: 'Porygon2',
        images: GEN_2_POKEMON_IMAGES.PORYGON2,
        number: 233,
        pokemonType: 'Virtual',
        stage: 1,
    },
    STANTLER: {
        name: 'Stantler',
        images: GEN_2_POKEMON_IMAGES.STANTLER,
        number: 234,
        pokemonType: '',
    },
    SMEARGLE: {
        name: 'Smeargle',
        images: GEN_2_POKEMON_IMAGES.SMEARGLE,
        number: 235,
        pokemonType: 'Painter',
    },
    TYROGUE: {
        name: 'Tyrogue',
        images: GEN_2_POKEMON_IMAGES.TYROGUE,
        number: 236,
        pokemonType: '',
    },
    HITMONTOP: {
        name: 'Hitmontop',
        images: GEN_2_POKEMON_IMAGES.HITMONTOP,
        number: 237,
        pokemonType: 'Handstand',
    },
    SMOOCHUM: {
        name: 'Smoochum',
        images: GEN_2_POKEMON_IMAGES.SMOOCHUM,
        number: 238,
        pokemonType: '',
    },
    ELEKID: {
        name: 'Elekid',
        images: GEN_2_POKEMON_IMAGES.ELEKID,
        number: 239,
        pokemonType: '',
    },
    MAGBY: {
        name: 'Magby',
        images: GEN_2_POKEMON_IMAGES.MAGBY,
        number: 240,
        pokemonType: '',
    },
    MILTANK: {
        name: 'Miltank',
        images: GEN_2_POKEMON_IMAGES.MILTANK,
        number: 241,
        pokemonType: '',
    },
    BLISSEY: {
        name: 'Blissey',
        images: GEN_2_POKEMON_IMAGES.BLISSEY,
        number: 242,
        pokemonType: 'Happiness',
        stage: 1,
    },
    RAIKOU: {
        name: 'Raikou',
        images: GEN_2_POKEMON_IMAGES.RAIKOU,
        number: 243,
        pokemonType: 'Thunder',
    },
    ENTEI: {
        name: 'Entei',
        images: GEN_2_POKEMON_IMAGES.ENTEI,
        number: 244,
        pokemonType: 'Volcano',
    },
    SUICUNE: {
        name: 'Suicune',
        images: GEN_2_POKEMON_IMAGES.SUICUNE,
        number: 245,
        pokemonType: 'Aurora',
    },
    LARVITAR: {
        name: 'Larvitar',
        images: GEN_2_POKEMON_IMAGES.LARVITAR,
        number: 246,
        pokemonType: '',
    },
    PUPITAR: {
        name: 'Pupitar',
        images: GEN_2_POKEMON_IMAGES.PUPITAR,
        number: 247,
        pokemonType: '',
        stage: 1,
    },
    TYRANITAR: {
        name: 'Tyranitar',
        images: GEN_2_POKEMON_IMAGES.TYRANITAR,
        number: 248,
        pokemonType: 'Armor',
        stage: 2,
    },
    LUGIA: {
        name: 'Lugia',
        images: GEN_2_POKEMON_IMAGES.LUGIA,
        number: 249,
        pokemonType: 'Diving',
    },
    HO_OH: {
        name: 'Ho-oh',
        images: GEN_2_POKEMON_IMAGES.HO_OH,
        number: 250,
        pokemonType: 'Rainbow',
    },
    CELEBI: {
        name: 'Celebi',
        images: GEN_2_POKEMON_IMAGES.CELEBI,
        number: 251,
        pokemonType: 'Timetravel',
    },
};

const { ARCANINE: ARCANINE$5, CHANSEY: CHANSEY$5, DROWZEE: DROWZEE$7, EEVEE: EEVEE$c, ELECTRODE: ELECTRODE$5, EXEGGCUTE: EXEGGCUTE$4, EXEGGUTOR: EXEGGUTOR$6, GLOOM: GLOOM$a, GRIMER: GRIMER$5, GROWLITHE: GROWLITHE$a, HYPNO: HYPNO$4, MAGNEMITE: MAGNEMITE$c, MAGNETON: MAGNETON$7, MUK: MUK$3, NIDOKING: NIDOKING$2, NIDORINO: NIDORINO$5, NINETALES: NINETALES$6, ONIX: ONIX$6, SCYTHER: SCYTHER$8, SEADRA: SEADRA$5, SLOWPOKE: SLOWPOKE$7, TENTACOOL: TENTACOOL$4, TENTACRUEL: TENTACRUEL$3, VICTREEBEL: VICTREEBEL$2, VILEPLUME: VILEPLUME$5, VOLTORB: VOLTORB$7, VULPIX: VULPIX$9, WEEPINBELL: WEEPINBELL$4, ZAPDOS: ZAPDOS$4, } = GEN_1_POKEMON;
const { AMPHAROS: AMPHAROS$5, ARIADOS: ARIADOS$3, AZUMARILL: AZUMARILL$2, BELLOSSOM: BELLOSSOM$2, BLISSEY: BLISSEY$1, CHINCHOU: CHINCHOU$4, ENTEI: ENTEI$4, ESPEON: ESPEON$4, FLAAFFY: FLAAFFY$8, HOUNDOOM: HOUNDOOM$6, HOUNDOUR: HOUNDOUR$9, JUMPLUFF: JUMPLUFF$3, KINGDRA: KINGDRA$3, LANTURN: LANTURN$5, LUGIA: LUGIA$2, MARILL: MARILL$6, OCTILLERY: OCTILLERY$2, PUPITAR: PUPITAR$7, REMORAID: REMORAID$3, SCIZOR: SCIZOR$5, SKIPLOOM: SKIPLOOM$4, SLOWKING: SLOWKING$4, SPINARAK: SPINARAK$4, STEELIX: STEELIX$4, SUDOWOODO: SUDOWOODO$2, SUICUNE: SUICUNE$4, TOGEPI: TOGEPI$6, TOGETIC: TOGETIC$3, TYRANITAR: TYRANITAR$6, UMBREON: UMBREON$4, } = GEN_2_POKEMON;
const holoStrength$8 = 0.7;
const AQUAPOLIS_HOLOS = [
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        evolvesFrom: FLAAFFY$8.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$8,
        id: 'aquapolis_H1_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: AMPHAROS$5.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H1',
        setTotal: E_HOLO_SET_TOTAL,
        stage: AMPHAROS$5.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        evolvesFrom: GROWLITHE$a.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$8,
        id: 'aquapolis_H2_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: ARCANINE$5.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H2',
        setTotal: E_HOLO_SET_TOTAL,
        stage: ARCANINE$5.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: SPINARAK$4.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$8,
        id: 'aquapolis_H3_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: ARIADOS$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H3',
        setTotal: E_HOLO_SET_TOTAL,
        stage: ARIADOS$3.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: MARILL$6.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$8,
        id: 'aquapolis_H4_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: AZUMARILL$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H4',
        setTotal: E_HOLO_SET_TOTAL,
        stage: AZUMARILL$2.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: GLOOM$a.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$8,
        id: 'aquapolis_H5_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: BELLOSSOM$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H5',
        setTotal: E_HOLO_SET_TOTAL,
        stage: BELLOSSOM$2.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        evolvesFrom: CHANSEY$5.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$8,
        id: 'aquapolis_H6_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: BLISSEY$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H6',
        setTotal: E_HOLO_SET_TOTAL,
        stage: BLISSEY$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        evolvesFrom: VOLTORB$7.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$8,
        id: 'aquapolis_H7_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: ELECTRODE$5.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H7',
        setTotal: E_HOLO_SET_TOTAL,
        stage: ELECTRODE$5.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$8,
        id: 'aquapolis_H8_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: ENTEI$4.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H8',
        setTotal: E_HOLO_SET_TOTAL,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        evolvesFrom: EEVEE$c.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$8,
        id: 'aquapolis_H9_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: ESPEON$4.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H9',
        setTotal: E_HOLO_SET_TOTAL,
        stage: ESPEON$4.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: EXEGGCUTE$4.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$8,
        id: 'aquapolis_H10_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: EXEGGUTOR$6.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H10',
        setTotal: E_HOLO_SET_TOTAL,
        stage: EXEGGUTOR$6.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.DARKNESS,
        energyWeakness: null,
        evolvesFrom: HOUNDOUR$9.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$8,
        id: 'aquapolis_H11_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: HOUNDOOM$6.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H11',
        setTotal: E_HOLO_SET_TOTAL,
        stage: HOUNDOOM$6.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        evolvesFrom: DROWZEE$7.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$8,
        id: 'aquapolis_H12_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: HYPNO$4.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H12',
        setTotal: E_HOLO_SET_TOTAL,
        stage: HYPNO$4.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: SKIPLOOM$4.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$8,
        id: 'aquapolis_H13_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: JUMPLUFF$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H13',
        setTotal: E_HOLO_SET_TOTAL,
        stage: JUMPLUFF$3.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: SEADRA$5.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$8,
        id: 'aquapolis_H14_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: KINGDRA$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H14',
        setTotal: E_HOLO_SET_TOTAL,
        stage: KINGDRA$3.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        evolvesFrom: CHINCHOU$4.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$8,
        id: 'aquapolis_H15_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: LANTURN$5.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H15',
        setTotal: E_HOLO_SET_TOTAL,
        stage: LANTURN$5.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.METAL,
        energyWeakness: null,
        evolvesFrom: MAGNEMITE$c.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$8,
        id: 'aquapolis_H16_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: MAGNETON$7.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H16',
        setTotal: E_HOLO_SET_TOTAL,
        stage: MAGNETON$7.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: GRIMER$5.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$8,
        id: 'aquapolis_H17_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: MUK$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H17',
        setTotal: E_HOLO_SET_TOTAL,
        stage: MUK$3.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        evolvesFrom: NIDORINO$5.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$8,
        id: 'aquapolis_H18_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: NIDOKING$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H18',
        setTotal: E_HOLO_SET_TOTAL,
        stage: NIDOKING$2.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        evolvesFrom: VULPIX$9.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$8,
        id: 'aquapolis_H19_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: NINETALES$6.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H19',
        setTotal: E_HOLO_SET_TOTAL,
        stage: NINETALES$6.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: REMORAID$3.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$8,
        id: 'aquapolis_H20_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: OCTILLERY$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H20',
        setTotal: E_HOLO_SET_TOTAL,
        stage: OCTILLERY$2.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.METAL,
        energyWeakness: null,
        evolvesFrom: SCYTHER$8.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$8,
        id: 'aquapolis_H21_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: SCIZOR$5.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H21',
        setTotal: E_HOLO_SET_TOTAL,
        stage: SCIZOR$5.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        evolvesFrom: SLOWPOKE$7.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$8,
        id: 'aquapolis_H22_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: SLOWKING$4.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H22',
        setTotal: E_HOLO_SET_TOTAL,
        stage: SLOWKING$4.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.METAL,
        energyWeakness: null,
        evolvesFrom: ONIX$6.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$8,
        id: 'aquapolis_H23_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: STEELIX$4.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H23',
        setTotal: E_HOLO_SET_TOTAL,
        stage: STEELIX$4.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$8,
        id: 'aquapolis_H24_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: SUDOWOODO$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H24',
        setTotal: E_HOLO_SET_TOTAL,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$8,
        id: 'aquapolis_H25_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: SUICUNE$4.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H25',
        setTotal: E_HOLO_SET_TOTAL,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: TENTACOOL$4.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$8,
        id: 'aquapolis_H26_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: TENTACRUEL$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H26',
        setTotal: E_HOLO_SET_TOTAL,
        stage: TENTACRUEL$3.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        evolvesFrom: TOGEPI$6.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$8,
        id: 'aquapolis_H27_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: TOGETIC$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H27',
        setTotal: E_HOLO_SET_TOTAL,
        stage: TOGETIC$3.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.DARKNESS,
        energyWeakness: null,
        evolvesFrom: PUPITAR$7.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$8,
        id: 'aquapolis_H28_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: TYRANITAR$6.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H28',
        setTotal: E_HOLO_SET_TOTAL,
        stage: TYRANITAR$6.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.DARKNESS,
        energyWeakness: null,
        evolvesFrom: EEVEE$c.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$8,
        id: 'aquapolis_H29_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: UMBREON$4.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H29',
        setTotal: E_HOLO_SET_TOTAL,
        stage: UMBREON$4.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: WEEPINBELL$4.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$8,
        id: 'aquapolis_H30_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: VICTREEBEL$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H30',
        setTotal: E_HOLO_SET_TOTAL,
        stage: VICTREEBEL$2.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: GLOOM$a.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$8,
        id: 'aquapolis_H31_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: VILEPLUME$5.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H31',
        setTotal: E_HOLO_SET_TOTAL,
        stage: VILEPLUME$5.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$8,
        id: 'aquapolis_H32_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: ZAPDOS$4.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H32',
        setTotal: E_HOLO_SET_TOTAL,
        weight: null,
    },
];
const AQUAPOLIS_CRYSTALS = [
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        evolvesFrom: SEADRA$5.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$8,
        id: 'aquapolis_148_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: KINGDRA$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 148,
        specialTemplateType: SPECIAL_CARD_TEMPLATES.CRYSTAL,
        stage: KINGDRA$3.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        evolvesFrom: NIDORINO$5.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$8,
        id: 'aquapolis_149_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: NIDOKING$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 149,
        specialTemplateType: SPECIAL_CARD_TEMPLATES.CRYSTAL,
        stage: NIDOKING$2.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$8,
        id: 'aquapolis_150_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: LUGIA$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 150,
        specialTemplateType: SPECIAL_CARD_TEMPLATES.CRYSTAL,
        weight: null,
    },
];

const { BELLSPROUT: BELLSPROUT$3, CHANSEY: CHANSEY$4, CUBONE: CUBONE$2, DODRIO: DODRIO$3, DODUO: DODUO$3, DROWZEE: DROWZEE$6, EEVEE: EEVEE$b, ELECTABUZZ: ELECTABUZZ$7, EXEGGCUTE: EXEGGCUTE$3, EXEGGUTOR: EXEGGUTOR$5, GLOOM: GLOOM$9, GOLDEEN: GOLDEEN$4, GOLDUCK: GOLDUCK$5, GRIMER: GRIMER$4, GROWLITHE: GROWLITHE$9, HITMONCHAN: HITMONCHAN$4, HORSEA: HORSEA$5, JYNX: JYNX$6, KANGASKHAN: KANGASKHAN$2, LICKITUNG: LICKITUNG$4, MAGNEMITE: MAGNEMITE$b, MANKEY: MANKEY$4, MAROWAK: MAROWAK$2, MR_MIME: MR_MIME$3, NIDORAN_M: NIDORAN_M$2, NIDORINO: NIDORINO$4, ODDISH: ODDISH$6, ONIX: ONIX$5, PARAS: PARAS$3, PARASECT: PARASECT$2, PINSIR: PINSIR$3, PONYTA: PONYTA$8, PORYGON: PORYGON$7, PSYDUCK: PSYDUCK$7, PRIMEAPE: PRIMEAPE$5, RAPIDASH: RAPIDASH$6, SCYTHER: SCYTHER$7, SEADRA: SEADRA$4, SEAKING: SEAKING$3, SLOWBRO: SLOWBRO$5, SLOWPOKE: SLOWPOKE$6, TANGELA: TANGELA$3, TENTACOOL: TENTACOOL$3, VOLTORB: VOLTORB$6, VULPIX: VULPIX$8, WEEPINBELL: WEEPINBELL$3, } = GEN_1_POKEMON;
const { AIPOM: AIPOM$2, CHINCHOU: CHINCHOU$3, DONPHAN: DONPHAN$3, ELEKID: ELEKID$1, FLAAFFY: FLAAFFY$7, FURRET: FURRET$2, HITMONTOP: HITMONTOP$3, HOPPIP: HOPPIP$4, HOUNDOOM: HOUNDOOM$5, HOUNDOUR: HOUNDOUR$8, LANTURN: LANTURN$4, LARVITAR: LARVITAR$3, MAREEP: MAREEP$5, MARILL: MARILL$5, MILTANK: MILTANK$2, PHANPY: PHANPY$3, PORYGON2: PORYGON2$2, PUPITAR: PUPITAR$6, REMORAID: REMORAID$2, SENTRET: SENTRET$2, SKIPLOOM: SKIPLOOM$3, SMEARGLE: SMEARGLE$2, SMOOCHUM: SMOOCHUM$1, SNEASEL: SNEASEL$4, SPINARAK: SPINARAK$3, QUAGSIRE: QUAGSIRE$3, TOGEPI: TOGEPI$5, TYROGUE: TYROGUE$1, WOOPER: WOOPER$3, } = GEN_2_POKEMON;
const AQUAPOLIS_NON_HOLOS = [
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        evolvesFrom: PHANPY$3.name,
        evolutionBoxImageUrl: '',
        hitPoints: null,
        id: 'aquapolis_007_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: DONPHAN$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 7,
        stage: DONPHAN$3.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.BABY,
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        evolvesTo: ELECTABUZZ$7.name,
        hitPoints: null,
        id: 'aquapolis_009_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: ELEKID$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 9,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        evolvesFrom: EXEGGCUTE$3.name,
        evolutionBoxImageUrl: '',
        hitPoints: null,
        id: 'aquapolis_013_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: EXEGGUTOR$5.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 13,
        stage: EXEGGUTOR$5.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        evolvesFrom: HOUNDOUR$8.name,
        evolutionBoxImageUrl: '',
        hitPoints: null,
        id: 'aquapolis_014_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: HOUNDOOM$5.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 14,
        stage: HOUNDOOM$5.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_018_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: JYNX$6.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 18,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: CHINCHOU$3.name,
        evolutionBoxImageUrl: '',
        hitPoints: null,
        id: 'aquapolis_020_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: LANTURN$4.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 20,
        stage: LANTURN$4.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: PARAS$3.name,
        evolutionBoxImageUrl: '',
        hitPoints: null,
        id: 'aquapolis_027_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: PARASECT$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 27,
        stage: PARASECT$2.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        evolvesFrom: PORYGON$7.name,
        evolutionBoxImageUrl: '',
        hitPoints: null,
        id: 'aquapolis_028_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: PORYGON2$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 28,
        stage: PORYGON2$2.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        evolvesFrom: MANKEY$4.name,
        evolutionBoxImageUrl: '',
        hitPoints: null,
        id: 'aquapolis_029_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: PRIMEAPE$5.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 29,
        stage: PRIMEAPE$5.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: WOOPER$3.name,
        evolutionBoxImageUrl: '',
        hitPoints: null,
        id: 'aquapolis_030_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: QUAGSIRE$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 30,
        stage: QUAGSIRE$3.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        evolvesFrom: PONYTA$8.name,
        evolutionBoxImageUrl: '',
        hitPoints: null,
        id: 'aquapolis_031_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: RAPIDASH$6.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 31,
        stage: RAPIDASH$6.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: SLOWPOKE$6.name,
        evolutionBoxImageUrl: '',
        hitPoints: null,
        id: 'aquapolis_033_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: SLOWBRO$5.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 33,
        stage: SLOWBRO$5.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_045_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: BELLSPROUT$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 45,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        evolvesFrom: DODUO$3.name,
        evolutionBoxImageUrl: '',
        hitPoints: null,
        id: 'aquapolis_046_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: DODRIO$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 46,
        stage: DODRIO$3.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        evolvesFrom: MAREEP$5.name,
        evolutionBoxImageUrl: '',
        hitPoints: null,
        id: 'aquapolis_047_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: FLAAFFY$7.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 47,
        stage: FLAAFFY$7.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        evolvesFrom: SENTRET$2.name,
        evolutionBoxImageUrl: '',
        hitPoints: null,
        id: 'aquapolis_048_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: FURRET$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 48,
        stage: FURRET$2.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: ODDISH$6.name,
        evolutionBoxImageUrl: '',
        hitPoints: null,
        id: 'aquapolis_049_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: GLOOM$9.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 49,
        stage: GLOOM$9.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: PSYDUCK$7.name,
        evolutionBoxImageUrl: '',
        hitPoints: null,
        id: 'aquapolis_050_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: GOLDUCK$5.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 50,
        stage: GOLDUCK$5.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_051_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: GROWLITHE$9.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 51,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.METAL,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_052_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: MAGNEMITE$b.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 52,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_053_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: MARILL$5.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 53,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        evolvesFrom: CUBONE$2.name,
        evolutionBoxImageUrl: '',
        hitPoints: null,
        id: 'aquapolis_054_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: MAROWAK$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 54,
        stage: MAROWAK$2.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        evolvesFrom: NIDORAN_M$2.name,
        evolutionBoxImageUrl: '',
        hitPoints: null,
        id: 'aquapolis_055_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: NIDORINO$4.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 55,
        stage: NIDORINO$4.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        evolvesFrom: LARVITAR$3.name,
        evolutionBoxImageUrl: '',
        hitPoints: null,
        id: 'aquapolis_056_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: PUPITAR$6.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 56,
        stage: PUPITAR$6.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_057_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: SCYTHER$7.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 57,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: HORSEA$5.name,
        evolutionBoxImageUrl: '',
        hitPoints: null,
        id: 'aquapolis_058_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: SEADRA$4.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 58,
        stage: SEADRA$4.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: GOLDEEN$4.name,
        evolutionBoxImageUrl: '',
        hitPoints: null,
        id: 'aquapolis_059_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: SEAKING$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 59,
        stage: SEAKING$3.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: HOPPIP$4.name,
        evolutionBoxImageUrl: '',
        hitPoints: null,
        id: 'aquapolis_060_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: SKIPLOOM$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 60,
        stage: SKIPLOOM$3.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.BABY,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        evolvesTo: JYNX$6.name,
        hitPoints: null,
        id: 'aquapolis_061_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: SMOOCHUM$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 61,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_062_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: SPINARAK$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 62,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.BABY,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        evolvesTo: '',
        hitPoints: null,
        id: 'aquapolis_063_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: TYROGUE$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 63,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_064_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: VOLTORB$6.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 64,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: BELLSPROUT$3.name,
        evolutionBoxImageUrl: '',
        hitPoints: null,
        id: 'aquapolis_065_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: WEEPINBELL$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 65,
        stage: WEEPINBELL$3.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_066_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: WOOPER$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 66,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_067_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: AIPOM$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 67,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_068_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: BELLSPROUT$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 68,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_069_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: CHANSEY$4.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 69,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_070_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: CHINCHOU$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 70,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_071_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: CHINCHOU$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 71,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_072_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: CUBONE$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 72,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_073_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: DODUO$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 73,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_074_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: DROWZEE$6.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 74,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_075_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: EEVEE$b.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 75,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_076_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: EXEGGCUTE$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 76,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_077_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: EXEGGCUTE$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 77,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_078_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: GOLDEEN$4.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 78,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_079_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: GRIMER$4.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 79,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_080_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: GROWLITHE$9.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 80,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_081_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: HITMONCHAN$4.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 81,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_082_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: HITMONTOP$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 82,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_083_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: HOPPIP$4.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 83,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_084_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: HORSEA$5.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 84,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_085_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: HORSEA$5.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 85,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_086_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: HOUNDOUR$8.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 86,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.DARKNESS,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_087_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: HOUNDOUR$8.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 87,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_088_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: KANGASKHAN$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 88,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_089_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: LARVITAR$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 89,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_090_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: LICKITUNG$4.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 90,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_091_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: MAGNEMITE$b.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 91,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_092_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: MANKEY$4.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 92,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_093_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: MAREEP$5.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 93,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_094_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: MILTANK$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 94,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_095_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: MR_MIME$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 95,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_096_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: NIDORAN_M$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 96,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_097_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: ODDISH$6.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 97,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_098_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: ONIX$5.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 98,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_099_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: PARAS$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 99,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_100_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: PHANPY$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 100,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_101_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: PINSIR$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 101,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_102_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: PONYTA$8.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 102,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_103_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: PORYGON$7.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 103,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_104_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: PSYDUCK$7.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 104,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_105_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: REMORAID$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 105,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_106_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: SCYTHER$7.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 106,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_107_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: SENTRET$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 107,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_108_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: SLOWPOKE$6.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 108,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_109_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: SMEARGLE$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 109,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.DARKNESS,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_110_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: SNEASEL$4.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 110,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_111_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: SPINARAK$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 111,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_112_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: TANGELA$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 112,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_113_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: TENTACOOL$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 113,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_114_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: TOGEPI$5.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 114,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_115_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: VOLTORB$6.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 115,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_116_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: VULPIX$8.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 116,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: null,
        id: 'aquapolis_117_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: WOOPER$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 117,
        weight: null,
    },
];

const SPECIAL_ENERGIES = {
    BOOST: {
        name: 'Boost Energy',
        descriptions: {
            default: "Boost Energy can be attached only to an Evolved Pokémon. Discard Boost Energy at the end of the turn it was attached. Boost Energy provides {CO} {CO} {CO} Energy. The Pokémon Boost Energy is attached to can't retreat. When the Pokémon Boost Energy is attached to is no longer an Evolved Pokémon, discard Boost Energy.",
        },
        images: [
            {
                label: 'Aquapolis',
                value: '',
            },
        ],
    },
    BOUNCE: {
        name: 'Bounce Energy',
        descriptions: {
            default: 'This card provides {CO} {CO} Energy. You can attach this card to your Pokémon that has basic Energy cards attached to it. When you play this card from your hand and attach it to 1 of your Pokémon, return a basic Energy card attached to that Pokémon to your hand.',
        },
        images: [
            {
                label: 'Skyridge',
                value: '',
            },
        ],
    },
    CRYSTAL: {
        name: 'Crystal Energy',
        descriptions: {
            default: 'Crystal Energy provides 1 Energy of all types (colors) of basic Energy cards attached to the Pokémon Crystal Energy is attached to. If there are no basic Energy cards attached to the Pokémon Crystal Energy is attached to, Crystal Energy provides {CO} Energy.',
        },
        images: [
            {
                label: 'Aquapolis',
                value: '',
            },
        ],
    },
    CYCLONE: {
        name: 'Cyclone Energy',
        descriptions: {
            default: 'This card provides {CO} Energy. When you play this card from your hand and attach it to your Active Pokémon, your opponent switches his or her Active Pokémon with 1 of his or her Benched Pokémon.',
        },
        images: [
            {
                label: 'Skyridge',
                value: '',
            },
        ],
    },
    DARKNESS: {
        name: 'Darkness Energy',
        descriptions: {
            default: "If the Pokémon Darkness Energy is attached to does damage with an attack (after applying Weakness and Resistance), the attack does 10 more damage. At the end of every turn, put 1 damage counter on the Pokémon Darkness Energy is attached to, unless it's {DK} or has Dark in its name. Darkness Energy provides {DK} Energy. (Doesn't count as a basic Energy card.)",
            aquapolis: "If the Pokémon Darkness Energy is attached to damages the Defending Pokémon (after applying Weakness and Resistance), the attack does 10 more damage to the Defending Pokémon. At the end of every turn, put 1 damage counter on the Pokémon Darkness Energy is attached to, unless it's {DK} or has Dark in its name. Darkness Energy provides {DK} Energy. (Doesn't count as a basic Energy card.)",
        },
        images: [
            {
                label: 'Default',
                value: '',
            },
        ],
    },
    DOUBLE_COLORLESS: {
        name: 'Double Colorless Energy',
        images: [
            {
                label: 'Base',
                value: '',
            },
        ],
    },
    FULL_HEAL: {
        name: 'Full Heal Energy',
        images: [
            {
                label: 'Default',
                value: '',
            },
        ],
    },
    METAL: {
        name: 'Metal Energy',
        descriptions: {
            default: "Damage done to the Pokémon Metal Energy is attached to is reduced by 10 (after applying Weakness and Resistance). If the Pokémon Metal Energy is attached to isn't {MT}, whenever it damages a Pokémon, reduce that damage by 10 (before applying Weakness and Resistance). Metal Energy provides {MT} Energy. (Doesn't count as a basic Energy card.)",
            expedition: "Damage done by attacks to the Pokémon Metal Energy is attached to is reduced by 10 (after applying Weakness and Resistance). If the Pokémon Metal Energy is attached to isn't {MT}, whenever it damages Pokémon by an attack, reduce that damage by 10 (after applying Weakness and Resistance). Metal Energy provides {MT} Energy. (Doesn't count as a basic Energy card.)",
        },
        images: [
            {
                label: 'Default',
                value: '',
            },
        ],
    },
    MIRACLE: {
        name: 'Miracle Energy',
        descriptions: {
            default: "You can't have more than 1 Miracle Energy in your deck. Attach Miracle Energy to 1 of your Shining or Light Pokémon. At the end of your turn, discard Miracle Energy. While in play, Miracle Energy counts as every type of Energy but provides only 2 Energy at a time.",
        },
        images: [
            {
                label: 'Default',
                value: '',
            },
        ],
    },
    POTION: {
        name: 'Potion Energy',
        images: [
            {
                label: 'Default',
                value: '',
            },
        ],
    },
    RAINBOW: {
        name: 'Rainbow Energy',
        descriptions: {
            default: "Attach Rainbow Energy to 1 of your Pokémon. While in play, Rainbow Energy counts as every type of basic Energy but only provides 1 Energy at a time. (Doesn't count as a basic Energy card when not in play.) When you attach this card from your hand to 1 of your Pokémon, it does 10 damage to that Pokémon. (Don't apply Weakness and Resistance.)",
        },
        images: [
            {
                label: 'Team Rocket',
                value: 'https://poketcgshop.s3.amazonaws.com/energy-images/rainbow-energy_jmkcvb.png',
            },
        ],
    },
    RECYCLE: {
        name: 'Recycle Energy',
        descriptions: {
            default: "Recycle Energy provides {CO} Energy. (Doesn't count as a basic Energy card.) If this card is put into your discard pile from play, return it to your hand.",
        },
        images: [
            {
                label: 'Neo Genesis',
                value: '',
            },
        ],
    },
    RETRO: {
        name: 'Retro Energy',
        descriptions: {
            default: 'This card provides {CO} Energy. When you play this card from your hand and attach it to 1 of your Evolved Pokémon, you may remove up to 2 damage counters from that Pokémon and discard the top card from it. (This counts as devolving it.)',
        },
        images: [
            {
                label: 'Skyridge',
                value: '',
            },
        ],
    },
    WARP: {
        name: 'Warp Energy',
        descriptions: {
            default: 'Warp Energy provides 1 Colorless Energy. When you attach Warp Energy from your hand to your Active Pokémon, switch your Active Pokémon with 1 of your Benched Pokémon.',
        },
        images: [
            {
                label: 'Aquapolis',
                value: '',
            },
        ],
    },
};

const AQUAPOLIS_SPECIAL_ENERGIES = [
    {
        cardTemplate: CARD_TEMPLATES.ENERGY_E_SERIES,
        description: SPECIAL_ENERGIES.DARKNESS.descriptions.default,
        energyType: ENERGY_TYPES.DARKNESS,
        id: 'aquapolis_142_en',
        name: SPECIAL_ENERGIES.DARKNESS.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 142,
    },
    {
        cardTemplate: CARD_TEMPLATES.ENERGY_E_SERIES,
        description: SPECIAL_ENERGIES.METAL.descriptions.default,
        energyType: ENERGY_TYPES.METAL,
        id: 'aquapolis_143_en',
        name: SPECIAL_ENERGIES.METAL.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 143,
    },
    {
        cardTemplate: CARD_TEMPLATES.ENERGY_E_SERIES,
        description: SPECIAL_ENERGIES.RAINBOW.descriptions.default,
        energyType: SPECIAL_ENERGY_TYPES.RAINBOW,
        id: 'aquapolis_144_en',
        name: SPECIAL_ENERGIES.RAINBOW.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 144,
    },
    {
        cardTemplate: CARD_TEMPLATES.ENERGY_E_SERIES,
        description: SPECIAL_ENERGIES.BOOST.descriptions.default,
        energyType: ENERGY_TYPES.COLORLESS,
        id: 'aquapolis_145_en',
        name: SPECIAL_ENERGIES.BOOST.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 145,
    },
    {
        cardTemplate: CARD_TEMPLATES.ENERGY_E_SERIES,
        description: SPECIAL_ENERGIES.CRYSTAL.descriptions.default,
        energyType: ENERGY_TYPES.COLORLESS,
        id: 'aquapolis_146_en',
        name: SPECIAL_ENERGIES.CRYSTAL.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 146,
    },
    {
        cardTemplate: CARD_TEMPLATES.ENERGY_E_SERIES,
        description: SPECIAL_ENERGIES.WARP.descriptions.default,
        energyType: ENERGY_TYPES.COLORLESS,
        id: 'aquapolis_147_en',
        name: SPECIAL_ENERGIES.WARP.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 147,
    },
];

const E_SERIES_TRAINERS = {
    ANCIENT_RUINS: {
        name: 'Ancient Ruins',
        image: '',
    },
    APRICORN_FOREST: {
        name: 'Apricorn Forest',
        image: '',
    },
    APRICORN_MAKER: {
        name: 'Apricorn Maker',
        image: '',
    },
    BILLS_MAINTENANCE: {
        name: `Bill's Maintenance`,
        image: '',
    },
    COPYCAT: {
        name: 'Copycat',
        image: '',
    },
    CRYSTAL_SHARD: {
        name: 'Crystal Shard',
        image: '',
    },
    DARKNESS_CUBE_01: {
        name: 'Darkness Cube 01',
        image: '',
    },
    DESERT_SHAMAN: {
        name: 'Desert Shaman',
        image: '',
    },
    DUAL_BALL: {
        name: 'Dual Ball',
        image: '',
    },
    ENERGY_REMOVAL_2: {
        name: 'Energy Removal 2',
        image: '',
    },
    ENERGY_RESTORE: {
        name: 'Energy Restore',
        image: '',
    },
    ENERGY_SEARCH: {
        name: 'Energy Search',
        image: '',
    },
    ENERGY_SWITCH: {
        name: 'Energy Switch',
        image: '',
    },
    FAST_BALL: {
        name: 'Fast Ball',
        image: '',
    },
    FIGHTING_CUBE_01: {
        name: 'Fighting Cube 01',
        image: '',
    },
    FIRE_CUBE_01: {
        name: 'Fire Cube 01',
        image: '',
    },
    FISHERMAN: {
        name: 'Fisherman',
        image: '',
    },
    FOREST_GUARDIAN: {
        name: 'Forest Guardian',
        image: '',
    },
    FRIEND_BALL: {
        name: 'Friend Ball',
        image: '',
    },
    FULL_HEAL: {
        name: 'Full Heal',
        image: '',
    },
    GRASS_CUBE_01: {
        name: 'Grass Cube 01',
        image: '',
    },
    HEALING_BERRY: {
        name: 'Healing Berry',
        image: '',
    },
    JUGGLER: {
        name: 'Juggler',
        image: '',
    },
    HYPER_POTION: {
        name: 'Hyper Potion',
        image: '',
    },
    LIGHTNING_CUBE_01: {
        name: 'Lightning Cube 01',
        image: '',
    },
    LURE_BALL: {
        name: 'Lure Ball',
        image: '',
    },
    MARYS_IMPULSE: {
        name: `Mary's Impulse`,
        image: '',
    },
    MEMORY_BERRY: {
        name: 'Memory Berry',
        image: '',
    },
    METAL_CUBE_01: {
        name: 'Metal Cube 01',
        image: '',
    },
    MIRACLE_SPHERE_ALPHA: {
        name: 'Miracle Sphere α',
        image: '',
    },
    MIRACLE_SPHERE_BETA: {
        name: 'Miracle Sphere β',
        image: '',
    },
    MIRACLE_SPHERE_GAMMA: {
        name: 'Miracle Sphere γ',
        image: '',
    },
    MIRAGE_STADIUM: {
        name: 'Mirage Stadium',
        image: '',
    },
    MULTI_TECHNICAL_MACHINE_01: {
        name: 'Multi Technical Machine 01',
        image: '',
    },
    MYSTERY_PLATE_ALPHA: {
        name: 'Mystery Plate α',
        image: '',
    },
    MYSTERY_PLATE_BETA: {
        name: 'Mystery Plate β',
        image: '',
    },
    MYSTERY_PLATE_DELTA: {
        name: 'Mystery Plate δ',
        image: '',
    },
    MYSTERY_PLATE_GAMMA: {
        name: 'Mystery Plate γ',
        image: '',
    },
    MYSTERY_ZONE: {
        name: 'Mystery Zone',
        image: '',
    },
    ORACLE: {
        name: 'Oracle',
        image: '',
    },
    POKEMON_FAN_CLUB: {
        name: 'Pokémon Fan Club',
        image: '',
    },
    POKEMON_NURSE: {
        name: 'Pokémon Nurse',
        image: '',
    },
    POKEMON_PARK: {
        name: 'Pokémon Park',
        image: '',
    },
    POKEMON_REVERSAL: {
        name: 'Pokémon Reversal',
        image: '',
    },
    POTION: {
        name: 'Potion',
        image: '',
    },
    POWER_CHARGE: {
        name: 'Power Charge',
        image: '',
    },
    POWER_PLANT: {
        name: 'Power Plant',
        image: '',
    },
    PROFESSOR_ELMS_TRAINING_METHOD: {
        name: `Professor Elm's Training Method`,
        image: '',
    },
    PROFESSOR_OAKS_RESEARCH: {
        name: `Professor Oak's Research`,
        image: '',
    },
    PSYCHIC_CUBE_01: {
        name: 'Psychic Cube 01',
        image: '',
    },
    RELIC_HUNTER: {
        name: 'Relic Hunter',
        image: '',
    },
    SEER: {
        name: 'Seer',
        image: '',
    },
    STAR_PIECE: {
        name: 'Star Piece',
        image: '',
    },
    STRENGTH_CHARM: {
        name: 'Strength Charm',
        image: '',
    },
    SUPER_ENERGY_REMOVAL_2: {
        name: 'Super Energy Removal 2',
        image: '',
    },
    SWITCH: {
        name: 'Switch',
        image: '',
    },
    TIME_SHARD: {
        name: 'Time Shard',
        image: '',
    },
    TOWN_VOLUNTEERS: {
        name: 'Town Volunteers',
        image: '',
    },
    TRAVELING_SALESMAN: {
        name: 'Traveling Salesman',
        image: '',
    },
    UNDERGROUND_EXPEDITION: {
        name: 'Underground Expedition',
        image: '',
    },
    UNDERGROUND_LAKE: {
        name: 'Underground Lake',
        image: '',
    },
    UNDERSEA_RUINS: {
        name: 'Undersea Ruins',
        image: '',
    },
    WATER_CUBE_01: {
        name: 'Water Cube 01',
        image: '',
    },
    WEAKNESS_GUARD: {
        name: 'Weakness Guard',
        image: '',
    },
};

const { APRICORN_FOREST, DARKNESS_CUBE_01, ENERGY_SWITCH, FIGHTING_CUBE_01, FIRE_CUBE_01, FOREST_GUARDIAN, GRASS_CUBE_01, HEALING_BERRY, JUGGLER, LIGHTNING_CUBE_01, MEMORY_BERRY, METAL_CUBE_01, POKEMON_FAN_CLUB, POKEMON_PARK, POWER_PLANT, PSYCHIC_CUBE_01, SEER, SUPER_ENERGY_REMOVAL_2, TIME_SHARD, TOWN_VOLUNTEERS, TRAVELING_SALESMAN, UNDERSEA_RUINS, WATER_CUBE_01, WEAKNESS_GUARD, } = E_SERIES_TRAINERS;
const AQUAPOLIS_TRAINERS = [
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'aquapolis_118_en',
        illustrator: null,
        name: APRICORN_FOREST.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 118,
        subtitle: TRAINER_CARD_SUBTITLES.STADIUM_CARD,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'aquapolis_119_en',
        illustrator: null,
        name: DARKNESS_CUBE_01.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 119,
        subtitle: TRAINER_CARD_SUBTITLES.TECHNICAL_MACHINE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'aquapolis_120_en',
        illustrator: null,
        name: ENERGY_SWITCH.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 120,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'aquapolis_121_en',
        illustrator: null,
        name: FIGHTING_CUBE_01.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 121,
        subtitle: TRAINER_CARD_SUBTITLES.TECHNICAL_MACHINE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'aquapolis_122_en',
        illustrator: null,
        name: FIRE_CUBE_01.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 122,
        subtitle: TRAINER_CARD_SUBTITLES.TECHNICAL_MACHINE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'aquapolis_123_en',
        illustrator: null,
        name: FOREST_GUARDIAN.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 123,
        subtitle: TRAINER_CARD_SUBTITLES.SUPPORTER,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'aquapolis_124_en',
        illustrator: null,
        name: GRASS_CUBE_01.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 124,
        subtitle: TRAINER_CARD_SUBTITLES.TECHNICAL_MACHINE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'aquapolis_125_en',
        illustrator: null,
        name: HEALING_BERRY.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 125,
        subtitle: TRAINER_CARD_SUBTITLES.POKEMON_TOOL,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'aquapolis_126_en',
        illustrator: null,
        name: JUGGLER.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 126,
        subtitle: TRAINER_CARD_SUBTITLES.SUPPORTER,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'aquapolis_127_en',
        illustrator: null,
        name: LIGHTNING_CUBE_01.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 127,
        subtitle: TRAINER_CARD_SUBTITLES.TECHNICAL_MACHINE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'aquapolis_128_en',
        illustrator: null,
        name: MEMORY_BERRY.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 128,
        subtitle: TRAINER_CARD_SUBTITLES.POKEMON_TOOL,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'aquapolis_129_en',
        illustrator: null,
        name: METAL_CUBE_01.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 129,
        subtitle: TRAINER_CARD_SUBTITLES.TECHNICAL_MACHINE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'aquapolis_130_en',
        illustrator: null,
        name: POKEMON_FAN_CLUB.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 130,
        subtitle: TRAINER_CARD_SUBTITLES.SUPPORTER,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'aquapolis_131_en',
        illustrator: null,
        name: POKEMON_PARK.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 131,
        subtitle: TRAINER_CARD_SUBTITLES.STADIUM_CARD,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'aquapolis_132_en',
        illustrator: null,
        name: PSYCHIC_CUBE_01.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 132,
        subtitle: TRAINER_CARD_SUBTITLES.TECHNICAL_MACHINE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'aquapolis_133_en',
        illustrator: null,
        name: SEER.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 133,
        subtitle: TRAINER_CARD_SUBTITLES.SUPPORTER,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'aquapolis_134_en',
        illustrator: null,
        name: SUPER_ENERGY_REMOVAL_2.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 134,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'aquapolis_135_en',
        illustrator: null,
        name: TIME_SHARD.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 135,
        subtitle: TRAINER_CARD_SUBTITLES.POKEMON_TOOL,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'aquapolis_136_en',
        illustrator: null,
        name: TOWN_VOLUNTEERS.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 136,
        subtitle: TRAINER_CARD_SUBTITLES.SUPPORTER,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'aquapolis_137_en',
        illustrator: null,
        name: TRAVELING_SALESMAN.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 137,
        subtitle: TRAINER_CARD_SUBTITLES.SUPPORTER,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'aquapolis_138_en',
        illustrator: null,
        name: UNDERSEA_RUINS.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 138,
        subtitle: TRAINER_CARD_SUBTITLES.STADIUM_CARD,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'aquapolis_139_en',
        illustrator: null,
        name: POWER_PLANT.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 139,
        subtitle: TRAINER_CARD_SUBTITLES.STADIUM_CARD,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'aquapolis_140_en',
        illustrator: null,
        name: WATER_CUBE_01.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 140,
        subtitle: TRAINER_CARD_SUBTITLES.TECHNICAL_MACHINE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'aquapolis_141_en',
        illustrator: null,
        name: WEAKNESS_GUARD.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 141,
    },
];

const AQUAPOLIS_CARDS = [
    {
        ...AQUAPOLIS_HOLOS[0],
        holo: false,
        id: 'aquapolis_001_en',
        setNumber: 1,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[0],
        holo: 'reverse',
        id: 'aquapolis_001_en_rh',
        setNumber: 1,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[1],
        holo: false,
        id: 'aquapolis_002_en',
        setNumber: 2,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[1],
        holo: 'reverse',
        id: 'aquapolis_002_en_rh',
        setNumber: 2,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[2],
        holo: false,
        id: 'aquapolis_003_en',
        setNumber: 3,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[2],
        holo: 'reverse',
        id: 'aquapolis_003_en_rh',
        setNumber: 3,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[3],
        holo: false,
        id: 'aquapolis_004_en',
        setNumber: 4,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[3],
        holo: 'reverse',
        id: 'aquapolis_004_en_rh',
        setNumber: 4,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[4],
        holo: false,
        id: 'aquapolis_005_en',
        setNumber: 5,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[4],
        holo: 'reverse',
        id: 'aquapolis_005_en_rh',
        setNumber: 5,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[5],
        holo: false,
        id: 'aquapolis_006_en',
        setNumber: 6,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[5],
        holo: 'reverse',
        id: 'aquapolis_006_en_rh',
        setNumber: 6,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[0],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[0],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[0].id}_rh`,
    },
    {
        ...AQUAPOLIS_HOLOS[6],
        holo: false,
        id: 'aquapolis_008_en',
        setNumber: 8,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[6],
        holo: 'reverse',
        id: 'aquapolis_008_en_rh',
        setNumber: 8,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[1],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[1],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[1].id}_rh`,
    },
    {
        ...AQUAPOLIS_HOLOS[7],
        holo: false,
        id: 'aquapolis_010_en',
        setNumber: 10,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[7],
        holo: 'reverse',
        id: 'aquapolis_010_en_rh',
        setNumber: 10,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[8],
        holo: false,
        id: 'aquapolis_011_en',
        setNumber: 11,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[8],
        holo: 'reverse',
        id: 'aquapolis_011_en_rh',
        setNumber: 11,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[9],
        holo: false,
        id: 'aquapolis_012_en',
        setNumber: 12,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[9],
        holo: 'reverse',
        id: 'aquapolis_012_en_rh',
        setNumber: 12,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[2],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[2],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[2].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[3],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[3],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[2].id}_rh`,
    },
    {
        ...AQUAPOLIS_HOLOS[10],
        holo: false,
        id: 'aquapolis_015_en',
        setNumber: 15,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[10],
        holo: 'reverse',
        id: 'aquapolis_015_en_rh',
        setNumber: 15,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[11],
        holo: false,
        id: 'aquapolis_016_en',
        setNumber: 16,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[11],
        holo: 'reverse',
        id: 'aquapolis_016_en_rh',
        setNumber: 16,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[12],
        holo: false,
        id: 'aquapolis_017_en',
        setNumber: 17,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[12],
        holo: 'reverse',
        id: 'aquapolis_017_en_rh',
        setNumber: 17,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[4],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[4],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[2].id}_rh`,
    },
    {
        ...AQUAPOLIS_HOLOS[13],
        holo: false,
        id: 'aquapolis_019_en',
        setNumber: 19,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[13],
        holo: 'reverse',
        id: 'aquapolis_019_en_rh',
        setNumber: 19,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[5],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[5],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[5].id}_rh`,
    },
    {
        ...AQUAPOLIS_HOLOS[14],
        holo: false,
        id: 'aquapolis_021_en',
        setNumber: 21,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[14],
        holo: 'reverse',
        id: 'aquapolis_021_en_rh',
        setNumber: 21,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[15],
        holo: false,
        id: 'aquapolis_022_en',
        setNumber: 22,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[15],
        holo: 'reverse',
        id: 'aquapolis_022_en_rh',
        setNumber: 22,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[16],
        holo: false,
        id: 'aquapolis_023_en',
        setNumber: 23,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[16],
        holo: 'reverse',
        id: 'aquapolis_023_en_rh',
        setNumber: 23,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[17],
        holo: false,
        id: 'aquapolis_024_en',
        setNumber: 24,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[17],
        holo: 'reverse',
        id: 'aquapolis_024_en_rh',
        setNumber: 24,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[18],
        holo: false,
        id: 'aquapolis_025_en',
        setNumber: 25,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[18],
        holo: 'reverse',
        id: 'aquapolis_025_en_rh',
        setNumber: 25,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[19],
        holo: false,
        id: 'aquapolis_026_en',
        setNumber: 26,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[19],
        holo: 'reverse',
        id: 'aquapolis_026_en_rh',
        setNumber: 26,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[6],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[6],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[6].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[7],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[7],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[7].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[8],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[8],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[8].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[9],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[9],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[9].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[10],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[10],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[10].id}_rh`,
    },
    {
        ...AQUAPOLIS_HOLOS[20],
        holo: false,
        id: 'aquapolis_032_en',
        setNumber: 32,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[20],
        holo: 'reverse',
        id: 'aquapolis_032_en_rh',
        setNumber: 32,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[11],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[11],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[11].id}_rh`,
    },
    {
        ...AQUAPOLIS_HOLOS[21],
        holo: false,
        id: 'aquapolis_034_en',
        setNumber: 34,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[21],
        holo: 'reverse',
        id: 'aquapolis_034_en_rh',
        setNumber: 34,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[22],
        holo: false,
        id: 'aquapolis_035_en',
        setNumber: 35,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[22],
        holo: 'reverse',
        id: 'aquapolis_035_en_rh',
        setNumber: 35,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[23],
        holo: false,
        id: 'aquapolis_036_en',
        setNumber: 36,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[23],
        holo: 'reverse',
        id: 'aquapolis_036_en_rh',
        setNumber: 36,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[24],
        holo: false,
        id: 'aquapolis_037_en',
        setNumber: 37,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[24],
        holo: 'reverse',
        id: 'aquapolis_037_en_rh',
        setNumber: 37,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[25],
        holo: false,
        id: 'aquapolis_038_en',
        setNumber: 38,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[25],
        holo: 'reverse',
        id: 'aquapolis_038_en_rh',
        setNumber: 38,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[26],
        holo: false,
        id: 'aquapolis_039_en',
        setNumber: 39,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[26],
        holo: 'reverse',
        id: 'aquapolis_039_en_rh',
        setNumber: 39,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[27],
        holo: false,
        id: 'aquapolis_040_en',
        setNumber: 40,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[27],
        holo: 'reverse',
        id: 'aquapolis_040_en_rh',
        setNumber: 40,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[28],
        holo: false,
        id: 'aquapolis_041_en',
        setNumber: 41,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[28],
        holo: 'reverse',
        id: 'aquapolis_041_en_rh',
        setNumber: 41,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[29],
        holo: false,
        id: 'aquapolis_042_en',
        setNumber: 42,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[29],
        holo: 'reverse',
        id: 'aquapolis_042_en_rh',
        setNumber: 42,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[30],
        holo: false,
        id: 'aquapolis_043_en',
        setNumber: 43,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[30],
        holo: 'reverse',
        id: 'aquapolis_043_en_rh',
        setNumber: 43,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[31],
        holo: false,
        id: 'aquapolis_044_en',
        setNumber: 44,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_HOLOS[31],
        holo: 'reverse',
        id: 'aquapolis_044_en_rh',
        setNumber: 44,
        setTotal: AQUAPOLIS_SET_TOTAL,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[12],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[12],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[12].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[13],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[13],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[13].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[14],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[14],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[14].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[15],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[15],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[15].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[16],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[16],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[16].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[17],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[17],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[17].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[18],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[18],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[18].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[19],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[19],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[19].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[20],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[20],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[20].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[21],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[21],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[21].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[22],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[22],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[22].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[23],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[23],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[23].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[24],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[24],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[24].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[25],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[25],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[25].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[26],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[26],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[26].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[27],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[27],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[27].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[28],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[28],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[28].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[29],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[29],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[29].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[30],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[30],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[30].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[31],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[31],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[31].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[32],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[32],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[32].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[33],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[33],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[33].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[34],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[34],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[34].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[35],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[35],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[35].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[36],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[36],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[36].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[37],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[37],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[37].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[38],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[38],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[38].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[39],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[39],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[39].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[40],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[40],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[40].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[41],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[41],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[41].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[42],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[42],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[42].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[43],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[43],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[43].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[44],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[44],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[44].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[45],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[45],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[45].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[46],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[46],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[46].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[47],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[47],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[47].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[48],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[48],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[48].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[49],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[49],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[49].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[50],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[50],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[50].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[51],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[51],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[51].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[52],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[52],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[52].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[53],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[53],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[53].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[54],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[54],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[54].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[55],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[55],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[55].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[56],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[56],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[56].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[57],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[57],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[57].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[58],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[58],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[58].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[59],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[59],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[59].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[60],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[60],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[60].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[61],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[61],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[61].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[62],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[62],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[62].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[63],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[63],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[63].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[64],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[64],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[64].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[65],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[65],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[65].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[66],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[66],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[66].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[67],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[67],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[67].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[68],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[68],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[68].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[69],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[69],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[69].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[70],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[70],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[70].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[71],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[71],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[71].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[72],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[72],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[72].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[73],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[73],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[73].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[74],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[74],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[74].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[75],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[75],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[75].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[76],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[76],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[76].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[77],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[77],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[77].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[78],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[78],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[78].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[79],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[79],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[79].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[80],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[80],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[80].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[81],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[81],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[81].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[82],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[82],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[82].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[83],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[83],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[83].id}_rh`,
    },
    {
        ...AQUAPOLIS_NON_HOLOS[84],
    },
    {
        ...AQUAPOLIS_NON_HOLOS[84],
        holo: 'reverse',
        id: `${AQUAPOLIS_NON_HOLOS[84].id}_rh`,
    },
    {
        ...AQUAPOLIS_TRAINERS[0],
    },
    {
        ...AQUAPOLIS_TRAINERS[0],
        holo: 'reverse',
        id: `${AQUAPOLIS_TRAINERS[0].id}_rh`,
    },
    {
        ...AQUAPOLIS_TRAINERS[1],
    },
    {
        ...AQUAPOLIS_TRAINERS[1],
        holo: 'reverse',
        id: `${AQUAPOLIS_TRAINERS[1].id}_rh`,
    },
    {
        ...AQUAPOLIS_TRAINERS[2],
    },
    {
        ...AQUAPOLIS_TRAINERS[2],
        holo: 'reverse',
        id: `${AQUAPOLIS_TRAINERS[2].id}_rh`,
    },
    {
        ...AQUAPOLIS_TRAINERS[3],
    },
    {
        ...AQUAPOLIS_TRAINERS[3],
        holo: 'reverse',
        id: `${AQUAPOLIS_TRAINERS[3].id}_rh`,
    },
    {
        ...AQUAPOLIS_TRAINERS[4],
    },
    {
        ...AQUAPOLIS_TRAINERS[4],
        holo: 'reverse',
        id: `${AQUAPOLIS_TRAINERS[4].id}_rh`,
    },
    {
        ...AQUAPOLIS_TRAINERS[5],
    },
    {
        ...AQUAPOLIS_TRAINERS[5],
        holo: 'reverse',
        id: `${AQUAPOLIS_TRAINERS[5].id}_rh`,
    },
    {
        ...AQUAPOLIS_TRAINERS[6],
    },
    {
        ...AQUAPOLIS_TRAINERS[6],
        holo: 'reverse',
        id: `${AQUAPOLIS_TRAINERS[6].id}_rh`,
    },
    {
        ...AQUAPOLIS_TRAINERS[7],
    },
    {
        ...AQUAPOLIS_TRAINERS[7],
        holo: 'reverse',
        id: `${AQUAPOLIS_TRAINERS[7].id}_rh`,
    },
    {
        ...AQUAPOLIS_TRAINERS[8],
    },
    {
        ...AQUAPOLIS_TRAINERS[8],
        holo: 'reverse',
        id: `${AQUAPOLIS_TRAINERS[8].id}_rh`,
    },
    {
        ...AQUAPOLIS_TRAINERS[9],
    },
    {
        ...AQUAPOLIS_TRAINERS[9],
        holo: 'reverse',
        id: `${AQUAPOLIS_TRAINERS[9].id}_rh`,
    },
    {
        ...AQUAPOLIS_TRAINERS[10],
    },
    {
        ...AQUAPOLIS_TRAINERS[10],
        holo: 'reverse',
        id: `${AQUAPOLIS_TRAINERS[10].id}_rh`,
    },
    {
        ...AQUAPOLIS_TRAINERS[11],
    },
    {
        ...AQUAPOLIS_TRAINERS[11],
        holo: 'reverse',
        id: `${AQUAPOLIS_TRAINERS[11].id}_rh`,
    },
    {
        ...AQUAPOLIS_TRAINERS[12],
    },
    {
        ...AQUAPOLIS_TRAINERS[12],
        holo: 'reverse',
        id: `${AQUAPOLIS_TRAINERS[12].id}_rh`,
    },
    {
        ...AQUAPOLIS_TRAINERS[13],
    },
    {
        ...AQUAPOLIS_TRAINERS[13],
        holo: 'reverse',
        id: `${AQUAPOLIS_TRAINERS[13].id}_rh`,
    },
    {
        ...AQUAPOLIS_TRAINERS[14],
    },
    {
        ...AQUAPOLIS_TRAINERS[14],
        holo: 'reverse',
        id: `${AQUAPOLIS_TRAINERS[14].id}_rh`,
    },
    {
        ...AQUAPOLIS_TRAINERS[15],
    },
    {
        ...AQUAPOLIS_TRAINERS[15],
        holo: 'reverse',
        id: `${AQUAPOLIS_TRAINERS[15].id}_rh`,
    },
    {
        ...AQUAPOLIS_TRAINERS[16],
    },
    {
        ...AQUAPOLIS_TRAINERS[16],
        holo: 'reverse',
        id: `${AQUAPOLIS_TRAINERS[16].id}_rh`,
    },
    {
        ...AQUAPOLIS_TRAINERS[17],
    },
    {
        ...AQUAPOLIS_TRAINERS[17],
        holo: 'reverse',
        id: `${AQUAPOLIS_TRAINERS[17].id}_rh`,
    },
    {
        ...AQUAPOLIS_TRAINERS[18],
    },
    {
        ...AQUAPOLIS_TRAINERS[18],
        holo: 'reverse',
        id: `${AQUAPOLIS_TRAINERS[18].id}_rh`,
    },
    {
        ...AQUAPOLIS_TRAINERS[19],
    },
    {
        ...AQUAPOLIS_TRAINERS[19],
        holo: 'reverse',
        id: `${AQUAPOLIS_TRAINERS[19].id}_rh`,
    },
    {
        ...AQUAPOLIS_TRAINERS[20],
    },
    {
        ...AQUAPOLIS_TRAINERS[20],
        holo: 'reverse',
        id: `${AQUAPOLIS_TRAINERS[20].id}_rh`,
    },
    {
        ...AQUAPOLIS_TRAINERS[21],
    },
    {
        ...AQUAPOLIS_TRAINERS[21],
        holo: 'reverse',
        id: `${AQUAPOLIS_TRAINERS[21].id}_rh`,
    },
    {
        ...AQUAPOLIS_TRAINERS[22],
    },
    {
        ...AQUAPOLIS_TRAINERS[22],
        holo: 'reverse',
        id: `${AQUAPOLIS_TRAINERS[22].id}_rh`,
    },
    {
        ...AQUAPOLIS_TRAINERS[23],
    },
    {
        ...AQUAPOLIS_TRAINERS[23],
        holo: 'reverse',
        id: `${AQUAPOLIS_TRAINERS[23].id}_rh`,
    },
    {
        ...AQUAPOLIS_SPECIAL_ENERGIES[0],
    },
    {
        ...AQUAPOLIS_SPECIAL_ENERGIES[0],
        holo: 'reverse',
        id: `${AQUAPOLIS_SPECIAL_ENERGIES[0].id}_rh`,
    },
    {
        ...AQUAPOLIS_SPECIAL_ENERGIES[1],
    },
    {
        ...AQUAPOLIS_SPECIAL_ENERGIES[1],
        holo: 'reverse',
        id: `${AQUAPOLIS_SPECIAL_ENERGIES[1].id}_rh`,
    },
    {
        ...AQUAPOLIS_SPECIAL_ENERGIES[2],
    },
    {
        ...AQUAPOLIS_SPECIAL_ENERGIES[2],
        holo: 'reverse',
        id: `${AQUAPOLIS_SPECIAL_ENERGIES[2].id}_rh`,
    },
    {
        ...AQUAPOLIS_SPECIAL_ENERGIES[3],
    },
    {
        ...AQUAPOLIS_SPECIAL_ENERGIES[3],
        holo: 'reverse',
        id: `${AQUAPOLIS_SPECIAL_ENERGIES[3].id}_rh`,
    },
    {
        ...AQUAPOLIS_SPECIAL_ENERGIES[4],
    },
    {
        ...AQUAPOLIS_SPECIAL_ENERGIES[4],
        holo: 'reverse',
        id: `${AQUAPOLIS_SPECIAL_ENERGIES[4].id}_rh`,
    },
    {
        ...AQUAPOLIS_SPECIAL_ENERGIES[5],
    },
    {
        ...AQUAPOLIS_SPECIAL_ENERGIES[5],
        holo: 'reverse',
        id: `${AQUAPOLIS_SPECIAL_ENERGIES[5].id}_rh`,
    },
];

const setId$i = CARD_SETS.AQUAPOLIS.value;
const setName$i = CARD_SETS.AQUAPOLIS.label;
const setTotal$f = AQUAPOLIS_SET_TOTAL;
const AQUAPOLIS_SET = {
    cardCounts: {
        holoRares: 32,
        rares: 48,
        uncommons: 48,
        commons: 51,
        secretRares: 3,
        reverseHolos: 150,
    },
    copyright: COPYRIGHTS.AQUAPOLIS_SET,
    description: SET_DESCRIPTIONS.AQUAPOLIS,
    holoSheetType: CARD_HOLO_SHEETS.COSMOS_2,
    id: setId$i,
    imageUrl: 'https://cdn.shopify.com/s/files/1/0840/1659/5249/collections/aquapolis-cat-bg.jpg',
    name: setName$i,
    packInfo: BOOSTER_PACKS.AQUAPOLIS,
    releaseDate: RELEASE_DATES.AQUAPOLIS,
    reverseHoloSheetType: CARD_HOLO_SHEETS.RIPPLE,
    setSymbol: setId$i,
    setTotal: setTotal$f,
    cards: [...AQUAPOLIS_HOLOS, ...AQUAPOLIS_CARDS, ...AQUAPOLIS_CRYSTALS],
    themeDecks: [],
};

const renderPkmnPowerDisclaimer = (pokemonName, alreadyText) => {
    const defaultPokemonName = 'this Pokémon';
    return `This power can't be used if ${pokemonName || defaultPokemonName} is ${alreadyText ? 'already ' : ''}Asleep, Confused, or Paralyzed.`;
};

const SHARED_MOVES = (name, moveId, energyCost, damage, altText, description) => {
    if (moveId === 'thunder') {
        return {
            name: 'Thunder',
            damage: 60,
            description: `Flip a coin. If tails, ${name} does 30 damage to itself.`,
            energyCost: ['lightning', 'lightning', 'lightning', 'colorless'],
        };
    }
    if (moveId === 'water-gun') {
        return {
            name: 'Water Gun',
            damage: damage,
            damageModifier: DAMAGE_MODIFIER_VALUES.PLUS,
            description: `Does ${damage} damage plus 10 more damage for each <W> Energy attached to ${name} but not used to pay for this attack's Energy cost. ${altText
                ? `You can't add more than 20 damage in this way.`
                : `Extra <W> Energy after the 2nd doesn't count.`}`,
            energyCost: energyCost,
        };
    }
    if (moveId === 'lure') {
        return {
            name: 'Lure',
            description: 'If your opponent has any Benched Pokémon, choose 1 of them and switch it with his or her Active Pokémon.',
            energyCost: energyCost,
        };
    }
    if (moveId === 'wing-attack') {
        return {
            name: 'Wing Attack',
            damage: damage,
            energyCost: energyCost,
        };
    }
    if (moveId === 'confuse-ray') {
        return {
            name: 'Confuse Ray',
            damage: damage,
            description: 'Flip a coin. If heads, the Defending Pokémon is now Confused.',
            energyCost: energyCost,
        };
    }
    if (moveId === 'double-edge') {
        return {
            name: 'Double-edge',
            damage: damage,
            description: `${name} does ${altText} damage to itself.`,
            energyCost: energyCost,
        };
    }
    if (moveId === 'sonicboom') {
        return {
            name: 'Sonicboom',
            damage: 20,
            description: "Don't apply Weakness and Resistance for this attack. <em>(Any other effects that would happen after applying Weakness and Resistance still happen.)</em>",
            energyCost: energyCost,
        };
    }
    if (moveId === 'blizzard') {
        return {
            name: 'Blizzard',
            damage: damage,
            description: `Flip a coin. If heads, this attack does 10 damage to each of your opponent's Benched Pokémon. If tails, this attack does 10 damage to each of your own Benched Pokémon. ${DONT_APPLY_WEAKNESS_BENCHED}`,
            energyCost: energyCost,
        };
    }
    if (moveId === 'slam') {
        return {
            name: 'Slam',
            damage: damage,
            damageModifier: DAMAGE_MODIFIER_VALUES.TIMES,
            description: `Flip 2 coins. This attack does ${damage} damage times the number of heads.`,
            energyCost: energyCost,
        };
    }
    if (moveId === 'slash') {
        return {
            name: 'Slash',
            damage: damage,
            energyCost: energyCost,
        };
    }
    if (moveId === 'flamethrower') {
        return {
            name: 'Flamethrower',
            damage: damage,
            description: `Discard 1 {FR} Energy card attached to ${name} in order to use this attack.`,
            energyCost: energyCost,
        };
    }
    if (moveId === 'ice-beam') {
        return {
            name: 'Ice Beam',
            damage: damage,
            description: 'Flip a coin. If heads, the Defending Pokémon is now Paralyzed.',
            energyCost: energyCost,
        };
    }
    if (moveId === 'meditate') {
        return {
            name: 'Meditate',
            damage: damage,
            damageModifier: DAMAGE_MODIFIER_VALUES.PLUS,
            description: `Does ${damage} damage plus 10 more damage for each damage counter on the Defending Pokémon.`,
            energyCost: energyCost,
        };
    }
    if (moveId === 'tackle') {
        return {
            name: 'Tackle',
            damage: damage,
            energyCost: energyCost,
        };
    }
    if (moveId === 'doubleslap') {
        return {
            name: 'Doubleslap',
            damage: damage,
            damageModifier: DAMAGE_MODIFIER_VALUES.TIMES,
            description: `Flip 2 coins. This attack does ${damage} damage times the number of heads.`,
            energyCost: energyCost,
        };
    }
    if (moveId === 'bite') {
        return {
            name: 'Bite',
            damage: damage,
            energyCost: energyCost,
        };
    }
    if (moveId === 'thunder-wave') {
        return {
            name: 'Thunder Wave',
            damage: damage,
            description: 'Flip a coin. If heads, the Defending Pokémon is now Paralyzed.',
            energyCost: energyCost,
        };
    }
    if (moveId === 'selfdestruct') {
        return {
            name: 'Selfdestruct',
            damage: damage,
            description: `Does ${altText} damage to each player’s Bench. ${DONT_APPLY_WEAKNESS_BENCHED} ${name} does ${damage} damage to itself.`,
            energyCost: energyCost,
        };
    }
    if (moveId === 'stiffen') {
        return {
            name: 'Stiffen',
            description: `Flip a coin. If heads, prevent all damage done to ${name} during your opponent's next turn. <em>(Any other effects of attacks still happen.)</em>`,
            energyCost: energyCost,
        };
    }
    if (moveId === 'whirlwind') {
        return {
            name: 'Whirlwind',
            damage: damage,
            description: 'Your opponent switches the Defending Pokémon with 1 of his or her Benched Pokémon, if any. <em>(Do the damage before switching the Pokémon.)</em>',
            energyCost: energyCost,
        };
    }
    if (moveId === 'withdraw') {
        return {
            name: 'Withdraw',
            description: `Flip a coin. If heads, prevent all damage done to ${name} during your opponent's next turn. <em>(Any other effects of attacks still happen.)</em>`,
            energyCost: energyCost,
        };
    }
    if (moveId === 'recover') {
        return {
            name: 'Recover',
            description: `Discard 1 ${altText} Energy card attached to ${name} in order to use this attack. Remove all damage counters from ${name}.`,
            energyCost: energyCost,
        };
    }
    if (moveId === 'poison-sting') {
        return {
            name: 'Poison Sting',
            damage: damage,
            description: 'Flip a coin. If heads, the Defending Pokémon is now Poisoned.',
            energyCost: energyCost,
        };
    }
    if (moveId === 'thundershock') {
        return {
            name: 'Thundershock',
            damage: damage,
            description: 'Flip a coin. If heads, the Defending Pokémon is now Paralyzed.',
            energyCost: energyCost,
        };
    }
    if (moveId === 'agility') {
        return {
            name: 'Agility',
            damage: damage,
            description: `Flip a coin. If heads, during your opponent's next turn, prevent all effects of attacks, including damage, done to ${name}.`,
            energyCost: energyCost,
        };
    }
    if (moveId === 'mega-drain') {
        return {
            name: 'Mega Drain',
            damage: damage,
            description: description,
            energyCost: energyCost,
        };
    }
};
const MOVES = {
    ABSORB: {
        name: 'Absorb',
        damage: 40,
        description: 'Remove a number of damage counters from Kabutops equal to half the damage done to the Defending Pokémon <em>(after applying Weakness and Resistance)</em> (rounded up to the nearest 10). If Kabutops has fewer damage counters than that, remove all of them.',
        energyCost: ['fighting', 'fighting', 'fighting', 'fighting'],
    },
    ACID: {
        name: 'Acid',
        damage: 20,
        description: "Flip a coin. If heads, the Defending Pokémon can't retreat during your opponent's next turn.",
        energyCost: ['grass', 'grass'],
    },
    AMBUSH: {
        name: 'Ambush',
        damage: 20,
        damageModifier: DAMAGE_MODIFIER_VALUES.PLUS,
        description: 'Flip a coin. If heads, this attack does 20 damage plus 20 more damage; if tails, this attack does 20 damage.',
        energyCost: ['colorless', 'colorless', 'colorless'],
    },
    AMNESIA: {
        name: 'Amnesia',
        description: "Choose 1 of the Defending Pokémon's attacks. That Pokémon can't use that attack during your opponent's next turn.",
        energyCost: ['water', 'water'],
    },
    AURORA_BEAM: {
        name: 'Aurora Beam',
        damage: 50,
        energyCost: ['water', 'water', 'colorless'],
    },
    BARRIER: {
        name: 'Barrier',
        description: 'Discard 1 {PS} Energy card attached to Mewtwo in order to prevent all effects of attacks, including damage, done to Mewtwo during your opponent’s next turn.',
        energyCost: ['psychic', 'psychic'],
    },
    BENCH_GUARD: {
        name: 'Bench Guard',
        description: "As long as Brock's Rhydon is Benched, whenever 1 of your Benched Pokémon is damaged, you may do 10 of that damage to Brock's Rhydon instead. <em>(If more than 1 of your Benched Pokémon is damaged at the same time, you may use this power once for each of them.)</em>",
        specialMoveType: POKE_SPECIAL_MOVE_TYPES.POKE_POWER,
    },
    BENCH_MANIPULATION: {
        name: 'Bench Manipulation',
        damage: 20,
        damageModifier: DAMAGE_MODIFIER_VALUES.TIMES,
        description: "Your opponent flips a number of coins equal to the number of Pokémon on his or her Bench. This attack does 20 damage times the number of tails. Don't apply Weakness and Resistance for this attack. <em>(Any other effects that would happen after applying Weakness and Resistance still happen.)</em>",
        energyCost: ['psychic', 'psychic', 'colorless'],
    },
    BIND: {
        name: 'Bind',
        damage: 20,
        description: 'Flip a coin. If heads, the Defending Pokémon is now Paralyzed.',
        energyCost: ['grass', 'colorless'],
    },
    BLINDING_SCYTHE: {
        name: 'Blinding Scythe',
        damage: 40,
        energyCost: ['grass', 'colorless', 'colorless'],
    },
    BODY_SLAM: {
        name: 'Body Slam',
        damage: 30,
        description: 'Flip a coin. If heads, the Defending Pokémon is now Paralyzed.',
        energyCost: ['colorless', 'colorless', 'colorless', 'colorless'],
    },
    BOYFRIENDS: {
        name: 'Boyfriends',
        damage: 20,
        damageModifier: DAMAGE_MODIFIER_VALUES.PLUS,
        description: 'Does 20 damage plus 20 more damage for each Nidoking you have in play.',
        energyCost: ['grass', 'colorless'],
    },
    BUBBLE: {
        name: 'Bubble',
        damage: 10,
        description: 'Flip a coin. If heads, the Defending Pokémon is now Paralyzed.',
        energyCost: ['water'],
    },
    BUBBLEBEAM: {
        name: 'Bubblebeam',
        damage: 50,
        description: 'Flip a coin. If heads, the Defending Pokémon is now Paralyzed.',
        energyCost: ['water', 'water', 'water', 'water'],
    },
    BUZZAP: {
        name: 'Buzzap',
        description: `At any time during your turn (before your attack), you may Knock Out Electrode and attach it to 1 of your other Pokémon. If you do, choose a type of Energy. Electrode is now an Energy card (instead of a Pokémon) that provides 2 energy of that type. This power can't be used if Electrode is Asleep, Confused, or Paralyzed.`,
        specialMoveType: POKE_SPECIAL_MOVE_TYPES.POKE_POWER,
    },
    CALL_OF_THE_NIGHT: {
        name: 'Call of the Night',
        damage: 40,
        description: 'Unless this attack Knocks Out the Defending Pokémon, flip 2 coins. If both of them are heads, your opponent shuffles his or her Active Pokémon and all cards attached to it into his or her deck.',
        energyCost: ['psychic', 'psychic', 'psychic'],
    },
    CALL_THE_BOSS: {
        name: 'Call the Boss',
        description: "When you play Giovanni's Persian from your hand, you may search your deck for the Trainer card named Giovanni, show it to your opponent, and put it into your hand. Shuffle your deck afterward.",
        specialMoveType: POKE_SPECIAL_MOVE_TYPES.POKE_POWER,
    },
    CHAIN_LIGHTNING: {
        name: 'Chain Lightning',
        damage: 20,
        description: `If the Defending Pokémon isn't Colorless, this attack does 10 damage to each Benched Pokémon of the same type as the Defending Pokémon (including your own).`,
        energyCost: ['lightning', 'lightning', 'lightning'],
    },
    CHAIN_REACTION: {
        name: 'Chain Reaction',
        description: `This power can only be used when a Pokémon evolves. Search your deck for a card that evolves from Eevee and attach it to Eevee. This counts as evolving Eevee. Shuffle your deck afterward. ${renderPkmnPowerDisclaimer('Eevee')}`,
        specialMoveType: POKE_SPECIAL_MOVE_TYPES.POKE_POWER,
    },
    CHARGE: {
        name: 'Charge',
        description: "Take up to 2 {LG} Energy cards from your discard pile and attach them to Lt. Surge's Electabuzz.",
        energyCost: ['lightning'],
    },
    CLUTCH: {
        name: 'Clutch',
        damage: 30,
        description: "The Defending Pokémon can't retreat during your opponent's next turn.",
        energyCost: ['colorless', 'colorless', 'colorless'],
    },
    COMET_PUNCH: {
        name: 'Comet Punch',
        damage: 20,
        damageModifier: DAMAGE_MODIFIER_VALUES.TIMES,
        description: 'Flip 4 coins. This attack does 20 damage times the number of heads.',
        energyCost: ['colorless', 'colorless', 'colorless', 'colorless'],
    },
    CONTINUOUS_FIREBALL: {
        name: 'Continuous Fireball',
        damage: 50,
        damageModifier: DAMAGE_MODIFIER_VALUES.TIMES,
        description: 'Flip a number of coins equal to the number of {FR} Energy cards attached to Dark Charizard. This attack does 50 damage times the number of heads. Discard a number of {FR} Energy cards attached to Dark Charizard equal to the number of heads.',
        energyCost: ['fire', 'fire'],
    },
    CONTINUOUS_STRETCH: {
        name: 'Continuous Scratch',
        damage: 10,
        damageModifier: DAMAGE_MODIFIER_VALUES.TIMES,
        description: 'Flip 4 coins. This attack does 10 damage times the number of heads.',
        energyCost: ['colorless', 'colorless'],
    },
    CONVERSION_1: {
        name: 'Conversion 1',
        description: 'If the Defending Pokémon has a Weakness, you may change it to a type of your choice other than Colorless.',
        energyCost: ['colorless'],
    },
    CONVERSION_2: {
        name: 'Conversion 2',
        description: "Change Porygon's Resistance to a type of your choice other than Colorless.",
        energyCost: ['colorless', 'colorless'],
    },
    CROSSCOUNTER: {
        name: 'Crosscounter',
        description: "If an attack does damage to Rocket's Hitmonchan during your opponent's next turn <em>(even if Rocket's Hitmonchan is Knocked Out)</em>, flip a coin. If heads, Rocket's Hitmonchan attacks your opponent's Active Pokémon for double that amount of damage. <em>(If Rocket's Hitmonchan takes 20 damage, it does 40 damage to that Pokémon.)</em>",
        energyCost: ['fighting'],
    },
    CURSE: {
        name: 'Curse',
        description: `Once during your turn <em>(before your attack)</em>, you may move 1 damage counter from 1 of your opponent's Pokémon to another (even if it would Knock Out the other Pokémon). ${renderPkmnPowerDisclaimer('Gengar')}`,
        specialMoveType: POKE_SPECIAL_MOVE_TYPES.POKE_POWER,
    },
    DAMAGE_SWAP: {
        name: 'Damage Swap',
        description: `As often as you like during your turn <em>(before your attack)</em>, you may move 1 damage counter from 1 of your Pokémon to another as long as you don't Knock Out that Pokémon. ${renderPkmnPowerDisclaimer('Alakazam')}`,
        specialMoveType: POKE_SPECIAL_MOVE_TYPES.POKE_POWER,
    },
    DARK_MIND: {
        name: 'Dark Mind',
        damage: 30,
        description: `
    If your opponent has any Benched Pokémon, choose 1 of them and this attack does 10 damage to it. ${DONT_APPLY_WEAKNESS_BENCHED}`,
        energyCost: ['psychic', 'psychic', 'psychic'],
    },
    DESTINY_BOND: {
        name: 'Destiny Bond',
        description: "Discard 1 {PS} Energy card attached to Gastly in order to use this attack. If a Pokémon Knocks Out Gastly during your opponent's next turn, Knock Out that Pokémon.",
        energyCost: ['psychic', 'colorless'],
    },
    DIG: {
        name: 'Dig',
        damage: 10,
        energyCost: ['fighting'],
    },
    DISCHARGE: {
        name: 'Discharge',
        damage: 30,
        damageModifier: DAMAGE_MODIFIER_VALUES.TIMES,
        description: "Discard all {LG} Energy cards attached to Lt. Surge's Electabuzz in order to use this attack. Flip a number of coins equal to the number of {LG} Energy cards you discarded. This attack does 30 damage times the number of heads.",
        energyCost: ['lightning'],
    },
    DIVE_BOMB: {
        name: 'Dive Bomb',
        damage: 80,
        description: 'Flip a coin. If tails, this attack does nothing.',
        energyCost: ['fire', 'fire', 'fire', 'fire'],
    },
    DO_THE_WAVE: {
        name: 'Do the Wave',
        damage: 10,
        damageModifier: DAMAGE_MODIFIER_VALUES.PLUS,
        description: 'Does 10 damage plus 10 more damage for each of your Benched Pokémon.',
        energyCost: ['colorless', 'colorless', 'colorless'],
    },
    DOUBLE_EDGE: {
        name: 'Double-edge',
        damage: 80,
        description: 'Chansey does 80 damage to itself.',
        energyCost: ['colorless', 'colorless', 'colorless', 'colorless'],
    },
    DOUBLE_KICK: {
        name: 'Double Kick',
        damage: 30,
        damageModifier: DAMAGE_MODIFIER_VALUES.TIMES,
        description: 'Flip 2 coins. This attack does 30 damage times the number of heads.',
        energyCost: ['grass', 'colorless', 'colorless'],
    },
    DRAGON_RAGE: {
        name: 'Dragon Rage',
        damage: 50,
        energyCost: ['water', 'water', 'water'],
    },
    DRAGON_TORNADO: {
        name: 'Dragon Tornado',
        damage: 40,
        description: "Unless this attack Knocks Out the Defending Pokémon, choose 1 of your opponent's Benched Pokémon and switch it with the Defending Pokémon.",
        energyCost: ['water', 'water', 'colorless', 'colorless'],
    },
    DREAM_EATER: {
        name: 'Dream Eater',
        damage: 50,
        description: "You can't use this attack unless the Defending Pokémon is Asleep.",
        energyCost: ['psychic', 'psychic'],
    },
    EARTHQUAKE: {
        name: 'Earthquake',
        damage: 70,
        description: `Does 10 damage to each of your own Benched Pokémon. ${DONT_APPLY_WEAKNESS_BENCHED}`,
        energyCost: ['fighting', 'fighting', 'fighting', 'fighting'],
    },
    ELECTRIC_SHOCK: {
        name: 'Electric Shock',
        damage: 50,
        description: 'Flip a coin. If tails, Electrode does 10 damage to itself.',
        energyCost: ['lightning', 'lightning', 'lightning'],
    },
    ELECTRO_BEAM: {
        name: 'Electro Beam',
        damage: 40,
        description: "Flip a coin. If tails, discard all Energy cards attached to Misty's Golduck.",
        energyCost: ['water', 'colorless'],
    },
    ELECTROBURN: {
        name: 'Electroburn',
        damage: 70,
        description: "Rocket's Zapdos does damage to itself equal to 10 times the number of {LG} Energy cards attached to it.",
        energyCost: ['lightning', 'lightning', 'lightning', 'colorless'],
    },
    EMBER: {
        name: 'Ember',
        damage: 30,
        description: 'Discard 1 {FR} Energy card attached to Charmander in order to use this attack.',
        energyCost: ['fire', 'colorless'],
    },
    ENERGY_BURN: {
        name: 'Energy Burn',
        description: `As often as you like during your turn (before your attack), you may turn all Energy attached to Charizard into {FR} Energy for the rest of the turn. ${renderPkmnPowerDisclaimer('Charizard')}`,
        specialMoveType: POKE_SPECIAL_MOVE_TYPES.POKE_POWER,
    },
    ENERGY_CHARGE: {
        name: 'Energy Charge',
        description: "As often as you like during your turn (before your attack), if Lt. Surge's Magneton is your Active Pokémon, you may take 1 Lightning Energy card attached to 1 of your Pokémon and attach it to Lt. Surge's Magneton. This power can't be used if Lt. Surge's Magneton is Asleep, Confused, or Paralyzed.",
        specialMoveType: POKE_SPECIAL_MOVE_TYPES.POKE_POWER,
    },
    ENERGY_TRANS: {
        name: 'Energy Trans',
        description: 'As often as you like during your turn <em>(before your attack)</em>, you may take 1 {GR} Energy card attached to 1 of your Pokémon and attach it to a different one. This power can’t be used if Venusaur is Asleep, Confused, or Paralyzed.',
        specialMoveType: POKE_SPECIAL_MOVE_TYPES.POKE_POWER,
    },
    ENTRAP: {
        name: 'Entrap',
        description: "The Defending Pokémon can't retreat during your opponent's next turn.",
        energyCost: ['darkness'],
    },
    FAIRY_POWER: {
        name: 'Fairy Power',
        description: 'Flip a coin. If heads, you may return any number of your Pokémon in play and all cards attached to them to your hand.',
        energyCost: ['colorless'],
    },
    FETCH: {
        name: 'Fetch',
        description: 'Draw a card.',
        energyCost: ['colorless'],
    },
    FICKLE_ATTACK: {
        name: 'Fickle Attack',
        damage: 40,
        description: 'Flip a coin. If tails, this attack does nothing.',
        energyCost: ['psychic', 'psychic'],
    },
    FINAL_BEAM: {
        name: 'Final Beam',
        description: "When Dark Gyarados is Knocked Out by an attack, flip a coin. If heads, this power does 20 damage for each <W> Energy attached to Dark Gyarados to the Pokémon that Knocked Out Dark Gyarados. Apply Weakness and Resistance. This power doesn't work if Dark Gyarados is Asleep, Confused, or Paralyzed.",
        specialMoveType: POKE_SPECIAL_MOVE_TYPES.POKE_POWER,
    },
    FIRE_BLAST: {
        name: 'Fire Blast',
        description: 'Discard 1 {FR} Energy card attached to Ninetales in order to use this attack.',
        damage: 80,
        energyCost: ['fire', 'fire', 'fire', 'fire'],
    },
    FIRE_PUNCH: {
        name: 'Fire Punch',
        damage: 30,
        energyCost: ['fire', 'fire'],
    },
    FIRE_SPIN: {
        name: 'Fire Spin',
        damage: 100,
        description: 'Discard 2 Energy cards attached to Charizard in order to use this attack',
        energyCost: ['fire', 'fire', 'fire', 'fire'],
    },
    FIRE_WALL: {
        name: 'Fire Wall',
        damage: 40,
        description: "If an attack does damage to Rocket's Moltres during your opponent's next turn <em>(even if Rocket's Moltres is Knocked Out)</em>, Rocket's Moltres attacks your opponent's Active Pokémon for 10 damage. <em>(Apply Weakness and Resistance.)</em>",
        energyCost: ['fire', 'fire', 'fire'],
    },
    FIRESTORM: {
        name: 'Firestorm',
        damage: 120,
        description: "Discard 3 Fire Energy cards attached to Blaine's Arcanine in order to use this attack.",
        energyCost: ['fire', 'fire', 'fire', 'fire'],
    },
    FIRST_AID: {
        name: 'First Aid',
        description: 'Remove 1 damage counter from Jigglypuff.',
        energyCost: ['colorless'],
    },
    FLAIL: {
        name: 'Flail',
        damage: 10,
        damageModifier: DAMAGE_MODIFIER_VALUES.TIMES,
        description: 'Does 10 damage times the number of damage counters on Magikarp.',
        energyCost: ['water'],
    },
    FLAME_JET: {
        name: 'Flame Jet',
        description: "Flip a coin. If heads, choose 1 of your opponent's Pokémon. This attack does 40 damage to that Pokémon. Don't apply Weakness and Resistance for this attack. (Any other effects that would happen after applying Weakness and Resistance still happen.)",
        energyCost: ['fire', 'fire'],
    },
    FLAME_TAIL: {
        name: 'Flame Tail',
        damage: 30,
        energyCost: ['fire', 'fire'],
    },
    FLARE: {
        name: 'Flare',
        damage: 20,
        energyCost: ['fire', 'colorless'],
    },
    FLEE: {
        name: 'Flee',
        description: "If an attack does damage to Misty's Tentacruel while it's your Active Pokémon, you may switch it with 1 of your Benched Pokémon, which prevents all other effects of that attack on Misty's Tentacruel. This power can't be used if Misty's Tentacruel is already Asleep, Confused, or Paralyzed.",
        specialMoveType: POKE_SPECIAL_MOVE_TYPES.POKE_POWER,
    },
    FLING: {
        name: 'Fling',
        description: "Your opponent shuffles his or her Active Pokémon and all cards attached to it into his or her deck. This attack can't be used if your opponent has no Benched Pokémon.",
        energyCost: ['fighting', 'fighting', 'fighting', 'colorless'],
    },
    FLITTER: {
        name: 'Flitter',
        description: "Choose 1 of your opponent's Pokémon. This attack does 20 damage to that Pokémon. Don't apply Weakness and Resistance for this attack. (Any other effects that would happen after applying Weakness and Resistance still happen.)",
        energyCost: ['grass', 'grass'],
    },
    FOCUS: {
        name: 'Focus',
        description: "During your next turn, Rocket's Scizor's Agility attack's base damage is doubled.",
        energyCost: ['colorless'],
    },
    FORTITUDE: {
        name: 'Fortitude',
        description: "If Giovanni's Machamp would be Knocked Out by an opponent's attack, flip a coin. If heads, Giovanni's Machamp is not Knocked Out and its remaining HP become 10 instead. This power can't be used if Giovanni's Machamp is already Asleep, Confused, or Paralyzed.",
        specialMoveType: POKE_SPECIAL_MOVE_TYPES.POKE_POWER,
    },
    FOUL_GAS: {
        name: 'Foul Gas',
        damage: 10,
        description: 'Flip a coin. If heads, the Defending Pokémon is now Poisoned; if tails, it is now Confused.',
        energyCost: ['grass', 'grass'],
    },
    FREEZE_DRY: {
        name: 'Freeze Dry',
        damage: 30,
        description: 'Flip a coin. If heads, the Defending Pokémon is now Paralyzed.',
        energyCost: ['water', 'water', 'water'],
    },
    FURY_ATTACK: {
        name: 'Fury Attack',
        damage: 10,
        damageModifier: DAMAGE_MODIFIER_VALUES.TIMES,
        description: 'Flip 2 coins. This attack does 10 damage times the number of heads.',
        energyCost: ['colorless'],
    },
    FURY_STRIKES: {
        name: 'Fury Strikes',
        description: "Your opponent puts 3 markers onto his or her Pokémon (divided as he or she chooses). (More than 1 marker can be put on the same Pokémon.) Then, this attack does 10 damage to each Pokémon for each marker on it. Don't apply Weakness and Resistance. Remove the markers at the end of the turn.",
        energyCost: ['grass', 'grass'],
    },
    GIANT_GROWTH: {
        name: 'Giant Growth',
        description: "Flip a coin. If heads, Koga's Ditto's maximum HP is now 80 and Koga's Ditto's Pound attack's base damage is 30 instead of 10. <em>(Benching Koga's Ditto ends this effect.)</em>",
        energyCost: ['colorless'],
    },
    GIANT_TAIL: {
        name: 'Giant Tail',
        damage: 70,
        description: 'Flip a coin. If tails, this attack does nothing.',
        energyCost: ['colorless', 'colorless', 'colorless', 'colorless'],
    },
    GIGASHOCK: {
        name: 'Gigashock',
        damage: 30,
        description: `Choose 3 of your opponent's Benched Pokémon and this attack does 10 damage to each of them. ${DONT_APPLY_WEAKNESS_BENCHED} If your opponent has fewer than 3 Benched Pokémon, do the damage to each of them.`,
        energyCost: ['lightning', 'lightning', 'lightning', 'lightning'],
    },
    GNAW: {
        name: 'Gnaw',
        damage: 10,
        energyCost: ['colorless'],
    },
    GROWL: {
        name: 'Growl',
        description: "If the Defending Pokémon attacks Pikachu during your opponent's next turn, any damage done by the attack is reduced by 10 <em>(after applying Weakness and Resistance). (Benching either Pokémon ends this effect.)</em>",
        energyCost: ['colorless'],
    },
    GROWTH: {
        name: 'Growth',
        description: "Flip a coin. If heads, you may attach up to 2 Grass Energy cards from your hand to Erika's Venusaur.",
        energyCost: ['grass'],
    },
    GUARD: {
        name: 'Guard',
        description: `As long as Snorlax is your Active Pokémon, the Defending Pokémon can't Retreat. This power stops working when Snorlax is affected by a Special Condition.`,
        specialMoveType: POKE_SPECIAL_MOVE_TYPES.POKE_POWER,
    },
    GUILLOTINE: {
        name: 'Guillotine',
        damage: 50,
        energyCost: ['grass', 'grass', 'colorless', 'colorless'],
    },
    HARDEN: {
        name: 'Harden',
        description: "During your opponent's next turn, whenever 30 or less damage is done to Onix <em>(after applying Weakness and Resistance)</em>, prevent that damage. <em>(Any other effects of attacks still happen.)</em>",
        energyCost: ['fighting', 'fighting'],
    },
    HAY_FEVER: {
        name: 'Hay Fever',
        description: 'No Trainer cards can be played. This power stops working while Dark Vileplume is Asleep, Confused, or Paralyzed.',
        specialMoveType: POKE_SPECIAL_MOVE_TYPES.POKE_POWER,
    },
    HEADBUTT: {
        name: 'Headbutt',
        damage: 10,
        energyCost: ['water'],
    },
    HEAL: {
        name: 'Heal',
        description: `Once during your turn <em>(before your attack)</em>, you may flip a coin. If heads, remove 1 damage counter from 1 of your Pokémon. ${renderPkmnPowerDisclaimer('Vileplume')}`,
        specialMoveType: POKE_SPECIAL_MOVE_TYPES.POKE_POWER,
    },
    HEAT_TACKLE: {
        name: 'Heat Tackle',
        damage: 40,
        description: "Blaine's Arcanine does 10 damage to itself.",
        energyCost: ['fire', 'colorless', 'colorless'],
    },
    HIGH_JUMP_KICK: {
        name: 'High Jump Kick',
        damage: 50,
        energyCost: ['fighting', 'fighting', 'fighting'],
    },
    HORRID_POLLEN: {
        name: 'Horrid Pollen',
        damage: 30,
        description: 'Flip 2 coins. If 1 is heads, the Defending Pokémon is now Asleep and Poisoned. If both are heads, the Defending Pokémon is now Confused and Poisoned. If both are tails, the Defending Pokémon is now Paralyzed and Poisoned.',
        energyCost: ['grass', 'grass', 'grass'],
    },
    HORN_DRILL: {
        name: 'Horn Drill',
        damage: 50,
        energyCost: ['grass', 'grass', 'colorless', 'colorless'],
    },
    HORN_HAZARD: {
        name: 'Horn Hazard',
        damage: 30,
        description: 'Flip a coin. If tails, this attack does nothing.',
        energyCost: ['grass'],
    },
    HURRICANE: {
        name: 'Hurricane',
        damage: 30,
        description: "Unless this attack Knocks Out the Defending Pokémon, return the Defending Pokémon and all cards attached to it to your opponent's hand.",
        energyCost: ['colorless', 'colorless', 'colorless'],
    },
    HURRICANE_PUNCH: {
        name: 'Hurricane Punch',
        damage: 30,
        damageModifier: DAMAGE_MODIFIER_VALUES.TIMES,
        description: 'Flip 4 coins. This attack does 30 damage times the number of heads.',
        energyCost: ['fighting', 'fighting', 'fighting', 'colorless'],
    },
    HYDRO_PUMP: {
        name: 'Hydro Pump',
        damage: 40,
        damageModifier: DAMAGE_MODIFIER_VALUES.PLUS,
        description: "Does 40 damage plus 10 more damage for each <W> Energy attached to Blastoise but not used to pay for this attack's energy cost. Extra <W> Energy after the 2nd doesn't count.",
        energyCost: ['water', 'water', 'water'],
    },
    HYDROCANNON: {
        name: 'Hydrocannon',
        damage: 30,
        damageModifier: DAMAGE_MODIFIER_VALUES.PLUS,
        description: "Does 30 damage plus 20 more damage for each <W> Energy attached to Dark Blastoise but not used to pay for this attack. You can't add more than 40 damage in this way.",
        energyCost: ['water', 'water'],
    },
    HYPER_BEAM: {
        name: 'Hyper Beam',
        damage: 20,
        description: 'If the Defending Pokémon has any Energy cards attached to it, choose 1 of them and discard it.',
        energyCost: ['colorless', 'colorless', 'colorless', 'colorless'],
    },
    HYPER_NEEDLE: {
        name: 'Hyper Needle',
        damage: 70,
        description: "Flip a coin. If tails, this attack does nothing. Either way, you can't use this attack again as long as Koga's Beedrill stays in play (even putting Koga's Beedrill on the Bench won't let you use it again).",
        energyCost: ['colorless', 'colorless', 'colorless'],
    },
    HYPNOBLAST: {
        name: 'Hypnoblast',
        damage: 20,
        description: 'Flip a coin. If heads, the Defending Pokemon is now Asleep.',
        energyCost: ['psychic', 'psychic'],
    },
    HYPNOSIS: {
        name: 'Hypnosis',
        description: 'The Defending Pokemon is now Asleep.',
        energyCost: ['psychic'],
    },
    INTIMIDATE: {
        name: 'Intimidate',
        description: "If the Defending Pokémon's maximum HP is 50 or less, it can't attack Giovanni's Nidoking during your opponent's next turn. <em>(Benching or evolving either Pokémon ends this effect.)</em>",
        energyCost: ['grass'],
    },
    INVISIBLE_WALL: {
        name: 'Invisible Wall',
        description: `Whenever an attack <em>(including your own)</em> does 30 or more damage to Mr. Mime <em>(after applying Weakness and Resistance)</em>, prevent that damage. <em>(Any other effects of attacks still happen.)</em> ${renderPkmnPowerDisclaimer('Mr. Mime')}`,
        specialMoveType: POKE_SPECIAL_MOVE_TYPES.POKE_POWER,
    },
    IRONGRIP: {
        name: 'Irongrip',
        damage: 20,
        description: 'Flip a coin. If heads, the Defending Pokémon is now Paralyzed.',
        energyCost: ['grass', 'grass'],
    },
    JAB: {
        name: 'Jab',
        damage: 20,
        energyCost: ['fighting'],
    },
    JELLYFISH_POISON: {
        name: 'Jellyfish Poison',
        damage: 30,
        description: 'Flip a coin. If heads, the Defending Pokémon is now Poisoned. If tails, the Defending Pokémon is now Confused.',
        energyCost: ['water', 'water', 'colorless', 'colorless'],
    },
    JUXTAPOSE: {
        name: 'Juxtapose',
        description: "Flip a coin. If heads, switch the number of damage counters on Rocket's Mewtwo with the number of damage counters on the Defending Pokemon <em>(even if it would Knock Out either Pokemon). (It's okay if 1 of the Pokemon has no damage counters on it.)</em>",
        energyCost: ['psychic'],
    },
    KARATE_CHOP: {
        name: 'Karate Chop',
        damage: 50,
        damageModifier: DAMAGE_MODIFIER_VALUES.MINUS,
        description: 'Does 50 damage minus 10 damage for each damage counter on Machoke.',
        energyCost: ['fighting', 'fighting', 'colorless'],
    },
    KERZAP: {
        name: 'Kerzap',
        damage: 20,
        damageModifier: DAMAGE_MODIFIER_VALUES.PLUS,
        description: "Flip a coin. If heads, this attack does 20 damage plus 30 more damage to the Defending Pokémon and discard all {LG} Energy cards attached to Lt. Surge's Raichu. If tails, this attack does 20 damage.",
        energyCost: ['lightning', 'lightning'],
    },
    KNOCK_DOWN: {
        name: 'Knock Down',
        damage: 20,
        damageModifier: DAMAGE_MODIFIER_VALUES.PLUS,
        description: 'Your opponent flips a coin. If tails, this attack does 20 damage plus 20 more damage; if heads, this attack does 20 damage.',
        energyCost: ['fighting', 'fighting'],
    },
    KNOCKOUT_NEEDLE: {
        name: 'Knockout Needle',
        damage: 30,
        damageModifier: DAMAGE_MODIFIER_VALUES.PLUS,
        description: 'Flip 2 coins. If both of them are heads, this attack does 30 damage plus 60 more damage. If 1 or both of them are tails, this attack does 30 damage.',
        energyCost: ['water', 'water', 'water'],
    },
    LARIAT: {
        name: 'Lariat',
        damage: 70,
        description: 'Flip a coin. If tails, this attack does nothing.',
        energyCost: ['fighting', 'fighting', 'colorless', 'colorless'],
    },
    LEECH_SEED: {
        name: 'Leech Seed',
        damage: 20,
        description: 'Unless all damage from this attack is prevented, you may remove 1 damage counter from Bulbasaur.',
        energyCost: ['grass', 'grass'],
    },
    LEEK_SLAP: {
        name: 'Leek Slap',
        damage: 30,
        description: "Flip a coin. If tails, this attack does nothing. Either way, you can't use this attack again as long as Farfetch'd stays in play (even putting Farfetch'd on the Bench won't let you use it again).",
        energyCost: ['colorless'],
    },
    LOW_KICK: {
        name: 'Low Kick',
        damage: 20,
        energyCost: ['fighting'],
    },
    LULLABY: {
        name: 'Lullaby',
        description: 'The Defending Pokémon is now Asleep.',
        energyCost: ['colorless'],
    },
    MAGNETIC_LINES: {
        name: 'Magnetic Lines',
        damage: 30,
        description: 'If the Defending Pokémon has any basic Energy cards attached to it, choose 1 of them. If your opponent has any Benched Pokémon, choose 1 of them and attach that Energy card to it.',
        energyCost: ['lightning', 'lightning'],
    },
    MAGNUM_PUNCH: {
        name: 'Magnum Punch',
        damage: 50,
        energyCost: ['fighting', 'fighting', 'colorless'],
    },
    MASS_EXPLOSION: {
        name: 'Mass Explosion',
        damage: 20,
        damageModifier: DAMAGE_MODIFIER_VALUES.TIMES,
        description: "Does 20 damage times the total number of Koffings, Weezings, and Dark Weezings in play (Apply Weakness and Resistance.). Then, this attack does 20 damage to each Koffing, Weezing, and Dark Weezing (even your own). Don't apply Weakness and Resistance.",
        energyCost: ['grass', 'colorless'],
    },
    MEGA_BURN: {
        name: 'Mega Burn',
        damage: 60,
        description: "You can't use this attack during your next turn.",
        energyCost: ['psychic', 'colorless', 'colorless', 'colorless'],
    },
    MEGA_PUNCH_30: {
        name: 'Mega Punch',
        damage: 30,
        energyCost: ['fighting', 'fighting'],
    },
    MEGA_PUNCH: {
        name: 'Mega Punch',
        damage: 50,
        energyCost: ['grass', 'grass', 'colorless', 'colorless'],
    },
    MEGA_SHOCK: {
        name: 'Mega Shock',
        damage: 50,
        description: "Flip a coin. If tails, Lt. Surge's Magneton does 20 damage to itself.",
        energyCost: ['lightning', 'lightning', 'lightning', 'colorless'],
    },
    METRONOME: {
        name: 'Metronome',
        description: 'Choose 1 of the Defending Pokémon’s attacks. Metronome copies that attack except for its Energy costs and anything else required in order to use that attack, such as discarding Energy cards. <em>(No matter what type the Defending Pokémon is, Clefairy’s type is still Colorless.)</em>',
        energyCost: ['colorless', 'colorless', 'colorless'],
    },
    METRONOME_ALT: {
        name: 'Metronome',
        description: `Choose 1 of the Defending Pokémon's attacks. Metronome copies that attack except for its Energy costs and anything else required in order to use that attack, such as discarding Energy cards. <em>(No matter what type the Defending Pokémon is, Clefable's type is still Colorless.)</em>`,
        energyCost: ['colorless'],
    },
    MIND_SHOCK: {
        name: 'Mind Shock',
        damage: 40,
        description: "Don't apply Weakness and Resistance for this attack. <em>(Any other effects that would happen after applying Weakness and Resistance still happen.)</em>",
        energyCost: ['psychic', 'psychic', 'psychic'],
    },
    MINIMIZE: {
        name: 'Minimize',
        description: `All damage done by attacks to Clefable during your opponent's next turn is reduced by 20 (after applying Weakness and Resistance).`,
        energyCost: ['colorless', 'colorless'],
    },
    MIRROR_MOVE: {
        name: 'Mirror Move',
        description: 'If Pidgeotto was attacked last turn, do the final result of that attack on Pidgeotto to the Defending Pokémon.',
        energyCost: ['colorless', 'colorless', 'colorless'],
    },
    MOON_IMPACT: {
        name: 'Moon Impact',
        damage: 30,
        energyCost: ['colorless', 'colorless', 'colorless'],
    },
    MUD_SLAP: {
        name: 'Mud Slap',
        damage: 30,
        energyCost: ['fighting', 'fighting'],
    },
    NAIL_FLICK: {
        name: 'Nail Flick',
        damage: 10,
        energyCost: ['colorless'],
    },
    NERVE_POISON: {
        name: 'Nerve Poison',
        damage: 20,
        description: 'Flip a coin. If heads, the Defending Pokémon is now Paralyzed and Poisoned.',
        energyCost: ['grass', 'grass'],
    },
    NIGHTMARE: {
        name: 'Nightmare',
        damage: 10,
        description: 'The Defending Pokémon is now Asleep.',
        energyCost: ['psychic', 'colorless'],
    },
    PAIN_AMPLIFIER: {
        name: 'Pain Amplifier',
        description: "Put a damage counter on each of your opponent's Pokémon that already has any damage counters on it.",
        energyCost: ['psychic'],
    },
    PETAL_DANCE: {
        name: 'Petal Dance',
        damage: 40,
        damageModifier: DAMAGE_MODIFIER_VALUES.TIMES,
        description: 'Flip 3 coins. This attack does 40 damage times the number of heads. Vileplume is now Confused <em>(after doing damage)</em>.',
        energyCost: ['grass', 'grass', 'grass'],
    },
    PETAL_WHIRLWIND: {
        name: 'Petal Whirlwind',
        damage: 30,
        damageModifier: DAMAGE_MODIFIER_VALUES.TIMES,
        description: 'Flip 3 coins. This attack does 30 damage times the number of heads. If you get 2 or more heads, Dark Vileplume is now Confused (after doing damage).',
        energyCost: ['grass', 'grass', 'grass'],
    },
    PHOENIX_FLAME: {
        name: 'Phoenix Flame',
        damage: 90,
        description: "Flip a coin. If tails, shuffle Blaine's Moltres and all cards attached to it into your deck <em>(after doing damage)</em>.",
        energyCost: ['fire', 'fire', 'fire', 'fire', 'fire'],
    },
    PIN_MISSILE: {
        name: 'Pin Missile',
        damage: 20,
        damageModifier: DAMAGE_MODIFIER_VALUES.TIMES,
        description: 'Flip 4 coins. This attack does 20 damage times the number of heads.',
        energyCost: ['lightning', 'lightning', 'colorless'],
    },
    PLASMA: {
        name: 'Plasma',
        damage: 20,
        description: "If there are any {LG} Energy cards in your discard pile, attach 1 of them to Rocket's Zapdos.",
        energyCost: ['lightning'],
    },
    POISONPOWDER: {
        name: 'Poisonpowder',
        damage: 20,
        description: 'The Defending Pokémon is now Poisoned',
        energyCost: ['grass', 'grass', 'grass'],
    },
    POISON_VAPOR: {
        name: 'Poison Vapor',
        damage: 10,
        description: `The Defending Pokémon is now Poisoned. This attack does 10 damage to each of your opponent's Benched Pokémon. ${DONT_APPLY_WEAKNESS_BENCHED}`,
        energyCost: ['grass', 'grass', 'grass'],
    },
    POLLEN_DEFENSE: {
        name: 'Pollen Defense',
        description: "If an attack does damage to Erika's Vileplume while it's your Active Pokémon <em>(even if it's Knocked Out)</em>, flip a coin. If heads, your opponent's Active Pokémon is now Confused. This power works even while Erika's Vileplume is Asleep, Confused, or Paralyzed.",
        specialMoveType: POKE_SPECIAL_MOVE_TYPES.POKE_POWER,
    },
    POT_SMASH: {
        name: 'Pot Smash',
        damage: 30,
        energyCost: ['colorless', 'colorless', 'colorless'],
    },
    POUND: {
        name: 'Pound',
        damage: 10,
        energyCost: ['colorless'],
    },
    PREHISTORIC_POWER: {
        name: 'Prehistoric Power',
        description: 'No more Evolution cards can be played. This power stops working while Aerodactyl is Asleep, Confused, or Paralyzed.',
        specialMoveType: POKE_SPECIAL_MOVE_TYPES.POKE_POWER,
    },
    PROPHECY: {
        name: 'Prophecy',
        description: "Look at up to 3 cards from the top of either player's deck and rearrange them as you like.",
        energyCost: ['psychic'],
    },
    PSYBURN: {
        name: 'Psyburn',
        damage: 60,
        energyCost: ['psychic', 'psychic', 'psychic', 'colorless'],
    },
    PSYCHIC: {
        name: 'Psychic',
        damage: 10,
        damageModifier: DAMAGE_MODIFIER_VALUES.PLUS,
        description: 'Does 10 damage plus 10 more damage for each Energy card attached to the Defending Pokémon.',
        energyCost: ['psychic', 'colorless'],
    },
    PSYLINK: {
        name: 'Psylink',
        description: "Sabrina's Alakazam always has a copy of every attack your {PS} Pokémon in play have (including their Energy costs and anything else required in order to use those attacks, such as discarding Energy cards). This power can't be used if Sabrina's Alakazam is Asleep, Confused, or Paralyzed.",
        specialMoveType: POKE_SPECIAL_MOVE_TYPES.POKE_POWER,
    },
    PSYPUNCH: {
        name: 'Psypunch',
        damage: 20,
        energyCost: ['psychic'],
    },
    PSYSHOCK: {
        name: 'Psyshock',
        damage: 10,
        description: 'Flip a coin. If heads, the Defending Pokémon is now Paralyzed.',
        energyCost: ['psychic'],
    },
    QUICK_ATTACK: {
        name: 'Quick Attack',
        damage: 10,
        damageModifier: DAMAGE_MODIFIER_VALUES.PLUS,
        description: 'Flip a coin. If heads, this attack does 10 damage plus 20 more damage; if tails, this attack does 10 damage.',
        energyCost: ['colorless', 'colorless'],
    },
    RAIN_DANCE: {
        name: 'Rain Dance',
        description: `As often as you like during your turn (before your attack), you may attach 1 <W> Energy card to 1 of your Pokémon. <em>(This doesn't use up your 1 Energy card attachment for the turn.)</em> ${renderPkmnPowerDisclaimer('Blastoise')}`,
        specialMoveType: POKE_SPECIAL_MOVE_TYPES.POKE_POWER,
    },
    REBELLION: {
        name: 'Rebellion',
        description: "Whenever Misty's Gyarados attacks, flip 2 coins. If both of them are tails, that attack does nothing. Instead, shuffle Misty's Gyarados and all cards attached to it into your deck. <em>(This power works even if Misty's Gyarados is Confused.)</em>",
        specialMoveType: POKE_SPECIAL_MOVE_TYPES.POKE_POWER,
    },
    REBIRTH: {
        name: 'Rebirth',
        description: "Whenever Rocket's Moltres is Knocked Out, you may return it to your hand after discarding it. This power can't be used if Rocket's Moltres is Asleep, Confused, or Paralyzed when it is Knocked Out.",
        specialMoveType: POKE_SPECIAL_MOVE_TYPES.POKE_POWER,
    },
    REEL_IN: {
        name: 'Reel In',
        description: 'When you play Dark Slowbro from your hand, choose up to 3 Basic Pokémon and/or Evolution cards from your discard pile and put them into your hand.',
        specialMoveType: POKE_SPECIAL_MOVE_TYPES.POKE_POWER,
    },
    REPEATING_DRILL: {
        name: 'Repeating Drill',
        damage: 10,
        damageModifier: DAMAGE_MODIFIER_VALUES.TIMES,
        description: 'Flip 5 coins. This attack does 10 damage times the number of heads.',
        energyCost: ['colorless', 'colorless'],
    },
    ROARING_FLAMES: {
        name: 'Roaring Flames',
        damage: 20,
        damageModifier: DAMAGE_MODIFIER_VALUES.PLUS,
        description: "Discard all {FR} energy cards attached to Blaine's Charizard. If all Energy cards attached to Blaine's Charizard provide 2 {FR} Energy, discard all of them. This attack does 20 damage plus 20 more damage for each {FR} Energy discarded in this way.",
        energyCost: ['fire'],
    },
    ROCKET_TACKLE: {
        name: 'Rocket Tackle',
        damage: 40,
        description: "Dark Blastoise does 10 damage to itself. Flip a coin. If heads, prevent all damage done to Dark Blastoise during your opponent's next turn. <em>(Any other effects of attacks still happen.)</em>",
        energyCost: ['water', 'colorless', 'colorless'],
    },
    ROCK_THROW: {
        name: 'Rock Throw',
        damage: 10,
        energyCost: ['fighting'],
    },
    ROLL_OVER: {
        name: 'Roll Over',
        damage: 30,
        description: 'Snorlax is now Asleep. Flip a coin. If heads, the Defending Pokémon is now Asleep.',
        energyCost: ['colorless', 'colorless', 'colorless', 'colorless'],
    },
    SAND_ATTACK: {
        name: 'Sand-attack',
        damage: 10,
        description: "If the Defending Pokémon tries to attack during your opponent's next turn, your opponent flips a coin. If tails, that attack does nothing.",
        energyCost: ['fighting'],
    },
    SCRATCH: {
        name: 'Scratch',
        damage: 10,
        energyCost: ['colorless'],
    },
    SCRUNCH: {
        name: 'Scrunch',
        description: 'Flip a coin. If heads, prevent all damage done to Chansey during your opponent’s next turn. <em>(Any other effects of attacks still happen.)</em>',
        energyCost: ['colorless', 'colorless'],
    },
    SEISMIC_TOSS: {
        name: 'Seismic Toss',
        damage: 60,
        energyCost: ['fighting', 'fighting', 'fighting', 'colorless'],
    },
    SHADOW_IMAGES: {
        name: 'Shadow Images',
        description: "Whenever Rocket's Scyther is attacked, your opponent flips a coin. If tails, that attack does no damage to Rocket's Scyther. <em>(Any other effects of the attack still happen.)</em> This effect lasts until Rocket's Scyther takes damage <em>(or is Benched or is evolved).</em>",
        energyCost: ['grass'],
    },
    SHAPESHIFT: {
        name: 'Shapeshift',
        description: "Once during your turn <em>(before your attack)</em>, you may attach an Evolution card from your hand to Brock's Ninetales. (This doesn't count as evolving Brock's Ninetales.) Treat Brock's Ninetales as if it were that Pokémon instead. It can't evolve, devolve, or use the Pokémon Power of that Pokémon. During your turn, you may discard the Evolution card attached to Brock's Ninetales. This power can't be used if Brock's Ninetales is Asleep, Confused, or Paralyzed. If Brock's Ninetales becomes Asleep, Confused, or Paralyzed, discard all Evolution cards attached to it.",
        specialMoveType: POKE_SPECIAL_MOVE_TYPES.POKE_POWER,
    },
    SHARP_SICKLE: {
        name: 'Sharp Sickle',
        damage: 30,
        energyCost: ['fighting', 'fighting'],
    },
    SHIFT: {
        name: 'Shift',
        description: `Once during your turn <em>(before your attack)</em>, you may change the type of Venomoth to the type of any other Pokémon in play other than Colorless. ${renderPkmnPowerDisclaimer('Venomoth')}`,
        specialMoveType: POKE_SPECIAL_MOVE_TYPES.POKE_POWER,
    },
    SING: {
        name: 'Sing',
        description: 'Flip a coin. If heads, the Defending Pokémon is now Asleep.',
        energyCost: ['colorless'],
    },
    SINKHOLE: {
        name: 'Sinkhole',
        description: `Whenever your opponent's Active Pokémon retreats, your opponent flips a coin. If tails, this power does 20 damage to that Pokémon. ${DONT_APPLY_WEAKNESS} This power stops working while Dark Dugtrio is Asleep, Confused, or Paralyzed.`,
        specialMoveType: POKE_SPECIAL_MOVE_TYPES.POKE_POWER,
    },
    SLAP: {
        name: 'Slap',
        damage: 20,
        energyCost: ['water'],
    },
    SLASH: {
        name: 'Slash',
        damage: 30,
        energyCost: ['colorless', 'colorless', 'colorless'],
    },
    SLEEPING_GAS: {
        name: 'Sleeping Gas',
        description: 'Flip a coin. If heads, the Defending Pokémon is now Asleep.',
        energyCost: ['psychic'],
    },
    SLUDGE: {
        name: 'Sludge',
        damage: 30,
        description: 'Flip a coin. If heads, the Defending Pokémon is now Poisoned.',
        energyCost: ['grass', 'grass', 'grass'],
    },
    SMASH_KICK: {
        name: 'Smash Kick',
        damage: 20,
        energyCost: ['colorless', 'colorless'],
    },
    SNEAK_ATTACK: {
        name: 'Sneak Attack',
        description: "When you play Dark Golbat from your hand, you may choose 1 of your opponent's Pokémon. If you do, Dark Golbat does 10 damage to that Pokémon. Apply Weakness and Resistance.",
        specialMoveType: POKE_SPECIAL_MOVE_TYPES.POKE_POWER,
    },
    SOLARBEAM: {
        name: 'Solarbeam',
        damage: 60,
        energyCost: ['grass', 'grass', 'grass', 'grass'],
    },
    SPECIAL_PUNCH: {
        name: 'Special Punch',
        damage: 40,
        energyCost: ['fighting', 'fighting', 'colorless'],
    },
    STAR_FREEZE: {
        name: 'Star Freeze',
        damage: 20,
        description: 'Flip a coin. If heads, the Defending Pokémon is now Paralyzed.',
        energyCost: ['water', 'colorless', 'colorless'],
    },
    STARE: {
        name: 'Stare',
        description: "Choose 1 of your opponent's Pokémon. This attack does 10 damage to that Pokémon. Don't apply Weakness and Resistance for this attack. <em>(Any other effects that would happen after applying Weakness and Resistance still happen.)</em> If that Pokémon has a Pokémon Power, that power stops working until the end of your opponent's next turn.",
        energyCost: ['grass', 'grass'],
    },
    STEP_IN: {
        name: 'Step In',
        description: 'Once during your turn <em>(before your attack)</em>, if Dragonite is on your Bench, you may switch it with your Active Pokémon.',
        specialMoveType: POKE_SPECIAL_MOVE_TYPES.POKE_POWER,
    },
    STRETCH_KICK: {
        name: 'Stretch Kick',
        description: `If your opponent has any Benched Pokémon, choose 1 of them and this attack does 20 damage to it. ${DONT_APPLY_WEAKNESS_BENCHED}`,
        energyCost: ['fighting', 'fighting'],
    },
    STRIKES_BACK: {
        name: 'Strikes Back',
        description: `Whenever your opponent's attack damages Machamp (even if Machamp is Knocked Out), this power does 10 damage to the attacking Pokémon. ${DONT_APPLY_WEAKNESS} This power can't be used if Machamp is Asleep, Confused, or Paralyzed when your opponent attacks.`,
        specialMoveType: POKE_SPECIAL_MOVE_TYPES.POKE_POWER,
    },
    STRING_SHOT: {
        name: 'String Shot',
        damage: 10,
        description: 'Flip a coin. If heads, the Defending Pokémon is now Paralyzed.',
        energyCost: ['grass'],
    },
    STUN_GAS: {
        name: 'Stun Gas',
        damage: 20,
        description: 'Flip a coin. If heads, the Defending Pokémon is now Poisoned; if tails, the Defending Pokémon is now Paralyzed.',
        energyCost: ['grass', 'grass', 'grass'],
    },
    STUN_SPORE: {
        name: 'Stun Spore',
        damage: 20,
        description: 'Flip a coin. If heads, the Defending Pokémon is now Paralyzed.',
        energyCost: ['grass', 'grass'],
    },
    SUBMISSION: {
        name: 'Submission',
        damage: 60,
        description: 'Machoke does 20 damage to itself.',
        energyCost: ['fighting', 'fighting', 'colorless', 'colorless'],
    },
    SUMMON_MINIONS: {
        name: 'Summon Minions',
        description: 'When you play Dark Dragonite from your hand, search your deck for up to 2 Basic Pokémon and put them onto your Bench. Shuffle your deck afterward.',
        specialMoveType: POKE_SPECIAL_MOVE_TYPES.POKE_POWER,
    },
    SUMMON_STORM: {
        name: 'Summon Storm',
        description: "Flip 2 coins. If both of them are heads, this attack does 20 damage to each other Pokémon <em>(even your own)</em>. Don't apply Weakness and Resistance for this attack.",
        energyCost: ['water'],
    },
    SUPER_FANG: {
        name: 'Super Fang',
        description: "Does damage to the Defending Pokémon equal to half the Defending Pokémon's remaining HP (rounded up to the nearest 10).",
        energyCost: ['colorless', 'colorless', 'colorless'],
        isVariableDamage: true,
    },
    SUPER_PSY: {
        name: 'Super Psy',
        damage: 50,
        energyCost: ['psychic', 'psychic', 'colorless'],
    },
    SUPER_REMOVAL: {
        name: 'Super Removal',
        description: "Flip a coin. If heads, choose 1 Energy card attached to each of your opponent's Pokémon that has any Energy cards and discard those Energy cards.",
        energyCost: ['psychic', 'colorless'],
    },
    SURPRISE_THUNDER: {
        name: 'Surprise Thunder',
        damage: 30,
        description: `Flip a coin. If heads, flip another coin. If the second coin is heads, this attack does 20 damage to each of your opponent's Benched Pokémon. If the second coin is tails, this attack does 10 damage to each of your opponent's Benched Pokémon. ${DONT_APPLY_WEAKNESS_BENCHED}`,
        energyCost: ['lightning', 'lightning', 'lightning'],
    },
    SWORDS_DANCE: {
        name: 'Swords Dance',
        description: "During your next turn, Scyther's Slash attack's base damage is 60 instead of 30.",
        energyCost: ['grass'],
    },
    TAKE_DOWN: {
        name: 'Take Down',
        damage: 80,
        description: 'Arcanine does 30 damage to itself.',
        energyCost: ['fire', 'fire', 'colorless', 'colorless'],
    },
    TAIL_SNAP: {
        name: 'Tail Snap',
        damage: 20,
        energyCost: ['water'],
    },
    TAKE_AWAY: {
        name: 'Take Away',
        description: "Shuffle Erika's Dragonair and all cards attached to it into your deck. Then, your opponent shuffles his or her Active Pokémon and all cards attached to it into his or her deck.",
        energyCost: ['colorless', 'colorless', 'colorless', 'colorless'],
    },
    TELEPORT_BLAST: {
        name: 'Teleport Blast',
        damage: 30,
        description: 'You may switch Dark Alakazam with 1 of your Benched Pokémon. <em>(Do the damage before switching the Pokémon.)</em>',
        energyCost: ['psychic', 'psychic', 'colorless'],
    },
    THICK_SKINNED: {
        name: 'Thick Skinned',
        description: `Snorlax can't become Asleep, Confused, Paralyzed, or Poisoned. ${renderPkmnPowerDisclaimer('Snorlax', true)}`,
        specialMoveType: POKE_SPECIAL_MOVE_TYPES.POKE_POWER,
    },
    THRASH: {
        name: 'Thrash',
        damage: 30,
        damageModifier: DAMAGE_MODIFIER_VALUES.PLUS,
        description: 'Flip a coin. If heads, this attack does 30 damage plus 10 more damage; if tails, this attack does 30 damage and Nidoking does 10 damage to itself.',
        energyCost: ['grass', 'colorless', 'colorless'],
    },
    THUNDER_JOLT: {
        name: 'Thunder Jolt',
        damage: 30,
        description: 'Flip a coin. If tails, Pikachu does 10 damage to itself.',
        energyCost: ['lightning', 'colorless'],
    },
    THUNDERBOLT: {
        name: 'Thunderbolt',
        damage: 100,
        description: 'Discard all Energy cards attached to Zapdos in order to use this attack.',
        energyCost: ['lightning', 'lightning', 'lightning', 'lightning'],
    },
    THUNDERPUNCH: {
        name: 'Thunderpunch',
        damage: 30,
        damageModifier: DAMAGE_MODIFIER_VALUES.PLUS,
        description: 'Flip a coin. If heads, this attack does 30 damage plus 10 more damage; if tails, this attack does 30 damage plus Electabuzz does 10 damage to itself.',
        energyCost: ['lightning', 'colorless'],
    },
    THUNDERSTORM: {
        name: 'Thunderstorm',
        damage: 40,
        description: `For each of your opponent's Benched Pokémon, flip a coin. If heads, this attack does 20 damage to that Pokémon. ${DONT_APPLY_WEAKNESS_BENCHED} Then, Zapdos does 10 damage times the number of tails to itself.`,
        energyCost: ['lightning', 'lightning', 'lightning', 'lightning'],
    },
    THUNDERTACKLE: {
        name: 'Thundertackle',
        damage: 40,
        description: "Flip a coin. If heads, the Defending Pokémon is now Paralyzed. If tails, Lt. Surge's Raichu does 20 damage to itself.",
        energyCost: ['lightning', 'lightning', 'colorless', 'colorless'],
    },
    TIDAL_WAVE: {
        name: 'Tidal Wave',
        damage: 70,
        energyCost: ['water', 'water', 'water', 'water'],
    },
    TOXIC: {
        name: 'Toxic',
        damage: 20,
        description: 'The Defending Pokémon is now Poisoned. It now takes 20 Poison damage instead of 10 after each player’s turn <em>(even if it was already Poisoned).</em>',
        energyCost: ['grass', 'grass', 'grass'],
    },
    TOXIC_GAS: {
        name: 'Toxic Gas',
        description: 'Ignore all Pokémon Powers other than Toxic Gases. This power stops working while Muk is Asleep, Confused, or Paralyzed.',
        specialMoveType: POKE_SPECIAL_MOVE_TYPES.POKE_POWER,
    },
    TRANSFORM: {
        name: 'Transform',
        description: "If Ditto is your Active Pokémon, treat it as if it were the same card as the Defending Pokémon, including type, Hit Points, Weakness, and so on, except Ditto can't evolve, always has this Pokémon Power, and you may treat any Energy attached to Ditto as Energy of any type. Ditto isn't a copy of any other Pokémon while Ditto is Asleep, Confused, or Paralyzed.",
        specialMoveType: POKE_SPECIAL_MOVE_TYPES.POKE_POWER,
    },
    TRANSPARENCY: {
        name: 'Transparency',
        description: 'Whenever an attack does anything to Haunter, flip a coin. If heads, prevent all effects of that attack, including damage, done to Haunter. This power stops working while Haunter is Asleep, Confused, or Paralyzed.',
        specialMoveType: POKE_SPECIAL_MOVE_TYPES.POKE_POWER,
    },
    TUMBLING_ATTACK: {
        name: 'Tumbling Attack',
        damage: 40,
        damageModifier: DAMAGE_MODIFIER_VALUES.PLUS,
        description: 'Flip a coin. If heads, this attack does 40 damage plus 30 more damage; if tails, this attack does 40 damage.',
        energyCost: ['grass', 'grass', 'grass', 'colorless'],
    },
    TWINEEDLE: {
        name: 'Twineedle',
        damage: 30,
        damageModifier: DAMAGE_MODIFIER_VALUES.TIMES,
        description: 'Flip 2 coins. This attack does 30 damage times the number of heads.',
        energyCost: ['colorless', 'colorless', 'colorless'],
    },
    VENOM_POWDER: {
        name: 'Venom Powder',
        damage: 10,
        description: 'Flip a coin. If heads, the Defending Pokémon is now Confused and Poisoned.',
        energyCost: ['grass', 'grass'],
    },
    VINE_PULL: {
        name: 'Vine Pull',
        description: "Once during your turn when Dark Ivysaur retreats, choose 1 of your opponent's Benched Pokémon and switch it with his or her Active Pokémon.",
        specialMoveType: 'poke-body',
    },
    VINE_WHIP: {
        name: 'Vine Whip',
        damage: 30,
        energyCost: ['grass', 'colorless', 'colorless'],
    },
    WHIRLPOOL: {
        name: 'Whirlpool',
        damage: 40,
        description: 'If the Defending Pokémon has any Energy cards attached to it, choose 1 of them and discard it.',
        energyCost: ['water', 'water', 'colorless', 'colorless'],
    },
    WIDE_SOLARBEAM: {
        name: 'Wide Solarbeam',
        damage: 20,
        description: `If your opponent has any Benched Pokémon, choose 2 of them (or 1 if he or she only has 1). This attack does 20 damage to each of them. ${DONT_APPLY_WEAKNESS_BENCHED}`,
        energyCost: ['grass', 'grass', 'grass', 'grass'],
    },
    WILDFIRE: {
        name: 'Wildfire',
        description: "You may discard any number of {FR} Energy cards attached to Moltres when you use this attack. If you do, discard that many cards from the top of your opponent's deck.",
        energyCost: ['fire'],
    },
    WILL_O_THE_WISP: {
        name: "Will-o'-the-wisp",
        damage: 30,
        energyCost: ['fire', 'fire'],
    },
};

const { ALAKAZAM: ALAKAZAM$4, BLASTOISE: BLASTOISE$4, CHANSEY: CHANSEY$3, CHARMELEON: CHARMELEON$8, CHARIZARD: CHARIZARD$7, CLEFAIRY: CLEFAIRY$8, GYARADOS: GYARADOS$6, HITMONCHAN: HITMONCHAN$3, IVYSAUR: IVYSAUR$8, KADABRA: KADABRA$9, MACHAMP: MACHAMP$7, MACHOKE: MACHOKE$b, MAGIKARP: MAGIKARP$9, MAGNEMITE: MAGNEMITE$a, MAGNETON: MAGNETON$6, MEWTWO: MEWTWO$4, NIDOKING: NIDOKING$1, NIDORINO: NIDORINO$3, NINETALES: NINETALES$5, PIKACHU: PIKACHU$e, POLIWHIRL: POLIWHIRL$8, POLIWRATH: POLIWRATH$5, RAICHU: RAICHU$9, VENUSAUR: VENUSAUR$5, VULPIX: VULPIX$7, WARTORTLE: WARTORTLE$6, ZAPDOS: ZAPDOS$3, } = GEN_1_POKEMON;
const baseSetHoloStrength = 0.6;
const BASE_SET_HOLOS = [
    {
        backgroundColor: '#423e84',
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/temp-images/swirl-alakazam.jpg',
        description: 'Its brain can outperform a supercomputer. Its intelligence quotient is said to be 5000.',
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        evolvesFrom: KADABRA$9.name,
        evolutionBoxImageUrl: KADABRA$9.images[0].value,
        hitPoints: 80,
        holo: true,
        holoStrength: baseSetHoloStrength,
        id: 'base_001_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 4,
        lengthInches: 11,
        moves: [
            MOVES.DAMAGE_SWAP,
            SHARED_MOVES(ALAKAZAM$4.name, 'confuse-ray', ['psychic', 'psychic', 'psychic'], 30),
        ],
        name: ALAKAZAM$4.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: ALAKAZAM$4.images[0].value,
        pokemonLevel: 42,
        pokemonNumber: ALAKAZAM$4.number,
        pokemonType: ALAKAZAM$4.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 1,
        stage: ALAKAZAM$4.stage,
        weight: 106,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/water-seel_psmkpp.jpg',
        description: 'A brutal Pokémon with pressurized water jets on its shell. They are used for high-speed tackles.',
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        evolvesFrom: WARTORTLE$6.name,
        evolutionBoxBackgroundImageSize: 55,
        evolutionBoxImageUrl: WARTORTLE$6.images[0].value,
        hitPoints: 100,
        holo: true,
        holoStrength: baseSetHoloStrength,
        id: 'base_002_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 5,
        lengthInches: 3,
        moves: [MOVES.RAIN_DANCE, MOVES.HYDRO_PUMP],
        name: BLASTOISE$4.name,
        pokemonImagePositionX: 52,
        pokemonImagePositionY: 46,
        pokemonImageSize: 37,
        pokemonImageUrl: BLASTOISE$4.images[0].value,
        pokemonLevel: 52,
        pokemonNumber: BLASTOISE$4.number,
        pokemonType: BLASTOISE$4.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 2,
        stage: BLASTOISE$4.stage,
        weight: 189,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-chansey_fmsdky.jpg',
        description: 'A rare and elusive Pokémon that is said to bring happiness to those who manage to catch it.',
        energyResistance: ENERGY_TYPES.PSYCHIC,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 120,
        holo: true,
        holoStrength: baseSetHoloStrength,
        id: 'base_003_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 3,
        lengthInches: 7,
        moves: [
            MOVES.SCRUNCH,
            SHARED_MOVES('Chansey', 'double-edge', ['colorless', 'colorless', 'colorless', 'colorless'], 80, 80),
        ],
        name: CHANSEY$3.name,
        pokemonImagePositionX: 54,
        pokemonImagePositionY: 44,
        pokemonImageSize: 46,
        pokemonImageUrl: CHANSEY$3.images[0].value,
        pokemonLevel: 55,
        pokemonNumber: CHANSEY$3.number,
        pokemonType: CHANSEY$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 3,
        weight: 76,
    },
    {
        backgroundColor: '#dd9c04',
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/temp-images/charizard-bg.jpg',
        description: 'Spits fire that is hot enough to melt boulders. Known to unintentionally cause forest fires.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: ENERGY_TYPES.WATER,
        evolvesFrom: CHARMELEON$8.name,
        evolutionBoxImageUrl: CHARMELEON$8.images[0].value,
        hitPoints: 120,
        holo: true,
        holoStrength: baseSetHoloStrength,
        id: 'base_004_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [MOVES.ENERGY_BURN, MOVES.FIRE_SPIN],
        name: CHARIZARD$7.name,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 43,
        pokemonImageSize: 51,
        pokemonImageUrl: CHARIZARD$7.images[0].value,
        pokemonLevel: 76,
        pokemonNumber: CHARIZARD$7.number,
        pokemonImageShadowColor: '#fff',
        pokemonType: CHARIZARD$7.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 4,
        stage: CHARIZARD$7.stage,
        weight: 200,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-snorlax_r7bnvv.jpg',
        description: 'Its magical and cute appeal has many admirers. It is rare and found only in certain areas.',
        energyResistance: ENERGY_TYPES.PSYCHIC,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 40,
        holo: true,
        holoStrength: baseSetHoloStrength,
        id: 'base_005_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 2,
        lengthInches: 0,
        moves: [MOVES.SING, MOVES.METRONOME],
        name: CLEFAIRY$8.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 48,
        pokemonImageSize: 43,
        pokemonImageUrl: CLEFAIRY$8.images[0].value,
        pokemonLevel: 14,
        pokemonNumber: CLEFAIRY$8.number,
        pokemonType: CLEFAIRY$8.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 5,
        weight: 17,
    },
    {
        backgroundColor: '#366190',
        backgroundImageBlendMode: BLEND_MODES.MULTIPLY,
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/temp-images/water-gyarados.jpg',
        description: 'Rarely seen in the wild. Huge and vicious, it is capable of destroying entire cities in a rage.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.GRASS,
        evolvesFrom: MAGIKARP$9.name,
        evolutionBoxImageUrl: MAGIKARP$9.images[0].value,
        hitPoints: 80,
        holo: true,
        holoStrength: baseSetHoloStrength,
        id: 'base_006_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 21,
        lengthInches: 4,
        moves: [MOVES.DRAGON_RAGE, MOVES.BUBBLEBEAM],
        name: GYARADOS$6.name,
        pokemonImagePositionX: 56,
        pokemonImagePositionY: 45,
        pokemonImageSize: 45,
        pokemonImageUrl: GYARADOS$6.images[0].value,
        pokemonLevel: 41,
        pokemonNumber: GYARADOS$6.number,
        pokemonType: GYARADOS$6.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 6,
        stage: GYARADOS$6.stage,
        weight: 518,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-pkmn-trader_soqbah.jpg',
        description: 'While seeming to do nothing, it fires punches in lightning-fast volleys that are impossible to see.',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 70,
        holo: true,
        holoStrength: baseSetHoloStrength,
        id: 'base_007_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 4,
        lengthInches: 7,
        moves: [MOVES.JAB, MOVES.SPECIAL_PUNCH],
        name: HITMONCHAN$3.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 43,
        pokemonImageSize: 31,
        pokemonImageUrl: HITMONCHAN$3.images[0].value,
        pokemonLevel: 33,
        pokemonNumber: HITMONCHAN$3.number,
        pokemonType: HITMONCHAN$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 7,
        weight: 111,
    },
    {
        backgroundColor: '#505f82',
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/temp-images/swirl-machamp.jpg',
        backgroundImageOpacity: 0.6,
        description: 'Using its amazing muscles, it throws powerful punches that can knock its victim clear over the horizon.',
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        evolvesFrom: MACHOKE$b.name,
        evolutionBoxImageUrl: MACHOKE$b.images[0].value,
        hitPoints: 100,
        holo: true,
        holoStrength: baseSetHoloStrength,
        id: 'base_008_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 5,
        lengthInches: 3,
        moves: [MOVES.STRIKES_BACK, MOVES.SEISMIC_TOSS],
        name: MACHAMP$7.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 44,
        pokemonImageSize: 39,
        pokemonImageUrl: MACHAMP$7.images[0].value,
        pokemonLevel: 67,
        pokemonNumber: MACHAMP$7.number,
        pokemonType: MACHAMP$7.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 8,
        stage: MACHAMP$7.stage,
        weight: 287,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/electrify-pikachu_monhqm.jpg',
        description: 'Formed by several Magnemites linked together. It frequently appears when sunspots flare up.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: MAGNEMITE$a.name,
        evolutionBoxBackgroundImageSize: 80,
        evolutionBoxImageUrl: MAGNEMITE$a.images[0].value,
        hitPoints: 60,
        holo: true,
        holoStrength: baseSetHoloStrength,
        id: 'base_009_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [
            SHARED_MOVES(MAGNETON$6.name, 'thunder-wave', ['lightning', 'lightning', 'colorless'], 30),
            SHARED_MOVES(MAGNETON$6.name, 'selfdestruct', ['lightning', 'lightning', 'colorless', 'colorless'], 80, 20),
        ],
        name: MAGNETON$6.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 42,
        pokemonImageSize: 40,
        pokemonImageUrl: MAGNETON$6.images[0].value,
        pokemonLevel: 28,
        pokemonNumber: MAGNETON$6.number,
        pokemonType: MAGNETON$6.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 9,
        stage: MAGNETON$6.stage,
        weight: 132,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-mew_shnlml.jpg',
        description: 'A scientist created this Pokémon after years of horrific gene-splicing and DNA engineering experiments.',
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 60,
        holo: true,
        holoStrength: baseSetHoloStrength,
        id: 'base_010_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 6,
        lengthInches: 7,
        moves: [MOVES.PSYCHIC, MOVES.BARRIER],
        name: MEWTWO$4.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 44,
        pokemonImageSize: 31,
        pokemonImageUrl: MEWTWO$4.images[0].value,
        pokemonLevel: 53,
        pokemonNumber: MEWTWO$4.number,
        pokemonType: MEWTWO$4.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 10,
        weight: 269,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-pkmn-breeder_htdred.jpg',
        description: "Uses its powerful tail in battle to smash, constrict, then break its prey's bones.",
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        evolvesFrom: NIDORINO$3.name,
        evolutionBoxBackgroundImageSize: 60,
        evolutionBoxImageUrl: NIDORINO$3.images[0].value,
        hitPoints: 90,
        holo: true,
        holoStrength: baseSetHoloStrength,
        id: 'base_011_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 4,
        lengthInches: 7,
        moves: [MOVES.THRASH, MOVES.TOXIC],
        name: NIDOKING$1.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 45,
        pokemonImageSize: 47,
        pokemonImageUrl: NIDOKING$1.images[0].value,
        pokemonLevel: 42,
        pokemonNumber: NIDOKING$1.number,
        pokemonType: NIDOKING$1.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 11,
        stage: NIDOKING$1.stage,
        weight: 137,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/flames-magmar_s5ibam.jpg',
        description: 'Very smart and very vengeful. Grabbing one of its many tails could result in a 1,000-year curse.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: ENERGY_TYPES.WATER,
        evolvesFrom: VULPIX$7.name,
        evolutionBoxBackgroundImageSize: 80,
        evolutionBoxImageUrl: VULPIX$7.images[0].value,
        hitPoints: 80,
        holo: true,
        holoStrength: baseSetHoloStrength,
        id: 'base_012_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 3,
        lengthInches: 77,
        moves: [
            SHARED_MOVES('Ninetales', 'lure', ['colorless', 'colorless']),
            MOVES.FIRE_BLAST,
        ],
        name: NINETALES$5.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 40,
        pokemonImageSize: 47,
        pokemonImageUrl: NINETALES$5.images[0].value,
        pokemonLevel: 42,
        pokemonNumber: NINETALES$5.number,
        pokemonType: NINETALES$5.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 12,
        stage: NINETALES$5.stage,
        weight: 44,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-dratini_vxrsjo.jpg',
        description: 'An adept swimmer at both the front crawl and breaststroke. Easily overtakes the best human swimmers.',
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.GRASS,
        evolvesFrom: POLIWHIRL$8.name,
        evolutionBoxImageUrl: POLIWHIRL$8.images[0].value,
        hitPoints: 90,
        holo: true,
        holoStrength: baseSetHoloStrength,
        id: 'base_013_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 4,
        lengthInches: 3,
        moves: [
            SHARED_MOVES(POLIWRATH$5.name, 'water-gun', ['water', 'water', 'colorless'], 30, true),
            MOVES.WHIRLPOOL,
        ],
        name: POLIWRATH$5.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 47,
        pokemonImageSize: 40,
        pokemonImageUrl: POLIWRATH$5.images[0].value,
        pokemonLevel: 48,
        pokemonNumber: POLIWRATH$5.number,
        pokemonType: POLIWRATH$5.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 13,
        stage: POLIWRATH$5.stage,
        weight: 119,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lights-gb-magnemite_l0aclw.jpg',
        description: 'Its long tail serves as a ground to protect itself from its own high-voltage power.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: PIKACHU$e.name,
        evolutionBoxImageUrl: PIKACHU$e.images[0].value,
        hitPoints: 80,
        holo: true,
        holoStrength: baseSetHoloStrength,
        id: 'base_014_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [
            SHARED_MOVES(RAICHU$9.name, 'agility', ['lightning', 'colorless', 'colorless'], 20),
            SHARED_MOVES(RAICHU$9.name, 'thunder'),
        ],
        name: RAICHU$9.name,
        pokemonImagePositionX: 47,
        pokemonImagePositionY: 39,
        pokemonImageSize: 54,
        pokemonImageUrl: RAICHU$9.images[0].value,
        pokemonLevel: 40,
        pokemonNumber: RAICHU$9.number,
        pokemonType: RAICHU$9.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 14,
        stage: RAICHU$9.stage,
        weight: 66,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-pidgey_ggcjcw.jpg',
        description: 'This plant blooms when it is absorbing solar energy. It stays on the move to seek sunlight.',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        evolvesFrom: IVYSAUR$8.name,
        evolutionBoxBackgroundImageSize: 80,
        evolutionBoxImageUrl: IVYSAUR$8.images[0].value,
        hitPoints: 90,
        holo: true,
        holoStrength: baseSetHoloStrength,
        id: 'base_015_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 6,
        lengthInches: 7,
        moves: [MOVES.ENERGY_TRANS, MOVES.SOLARBEAM],
        name: VENUSAUR$5.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 48,
        pokemonImageSize: 59,
        pokemonImageUrl: VENUSAUR$5.images[0].value,
        pokemonLevel: 67,
        pokemonNumber: VENUSAUR$5.number,
        pokemonType: VENUSAUR$5.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 15,
        stage: VENUSAUR$5.stage,
        weight: 221,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lightning-electabuzz_a0idex.jpg',
        description: 'A legendary bird Pokémon said to appear from clouds while wielding enormous lightning bolts.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.LIGHTNING,
        hitPoints: 90,
        holo: true,
        holoStrength: baseSetHoloStrength,
        id: 'base_016_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 5,
        lengthInches: 3,
        moves: [SHARED_MOVES('Zapdos', 'thunder'), MOVES.THUNDERBOLT],
        name: ZAPDOS$3.name,
        pokemonImagePositionX: 53,
        pokemonImagePositionY: 45,
        pokemonImageSize: 60,
        pokemonImageUrl: ZAPDOS$3.images[0].value,
        pokemonLevel: 64,
        pokemonNumber: ZAPDOS$3.number,
        pokemonType: ZAPDOS$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 16,
        weight: 116,
    },
];

const { ABRA: ABRA$6, ARCANINE: ARCANINE$4, BEEDRILL: BEEDRILL$4, BULBASAUR: BULBASAUR$3, CATERPIE: CATERPIE$2, CHARMANDER: CHARMANDER$4, CHARMELEON: CHARMELEON$7, DEWGONG: DEWGONG$4, DIGLETT: DIGLETT$6, DODUO: DODUO$2, DRAGONAIR: DRAGONAIR$9, DRATINI: DRATINI$5, DROWZEE: DROWZEE$5, DUGTRIO: DUGTRIO$4, ELECTABUZZ: ELECTABUZZ$6, ELECTRODE: ELECTRODE$4, FARFETCHD: FARFETCHD$3, GASTLY: GASTLY$7, GROWLITHE: GROWLITHE$8, GYARADOS: GYARADOS$5, HAUNTER: HAUNTER$a, IVYSAUR: IVYSAUR$7, JYNX: JYNX$5, KADABRA: KADABRA$8, KOFFING: KOFFING$6, KAKUNA: KAKUNA$5, MACHOKE: MACHOKE$a, MACHOP: MACHOP$5, MAGIKARP: MAGIKARP$8, MAGMAR: MAGMAR$7, MAGNEMITE: MAGNEMITE$9, METAPOD: METAPOD$4, NIDORAN_M: NIDORAN_M$1, NIDORINO: NIDORINO$2, ONIX: ONIX$4, PIDGEOTTO: PIDGEOTTO$4, PIDGEY: PIDGEY$2, PIKACHU: PIKACHU$d, POLIWAG: POLIWAG$5, POLIWHIRL: POLIWHIRL$7, PONYTA: PONYTA$7, PORYGON: PORYGON$6, RATTATA: RATTATA$5, RATICATE: RATICATE$5, SANDSHREW: SANDSHREW$4, SEEL: SEEL$5, SQUIRTLE: SQUIRTLE$2, STARMIE: STARMIE$4, STARYU: STARYU$5, TANGELA: TANGELA$2, VOLTORB: VOLTORB$5, VULPIX: VULPIX$6, WARTORTLE: WARTORTLE$5, WEEDLE: WEEDLE$3, } = GEN_1_POKEMON;
const BASE_SET_NON_HOLOS = [
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lights-magby_eanl2m.jpg',
        description: 'Flies at high speed and attacks using the large, venomous stingers on its forelegs and tail.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        evolvesFrom: KAKUNA$5.name,
        evolutionBoxImageUrl: KAKUNA$5.images[0].value,
        hitPoints: 80,
        id: 'base_017_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [
            MOVES.TWINEEDLE,
            SHARED_MOVES(BEEDRILL$4.name, 'poison-sting', ['grass', 'grass', 'grass'], 40),
        ],
        name: BEEDRILL$4.name,
        pokemonImagePositionX: 53,
        pokemonImagePositionY: 45,
        pokemonImageSize: 46,
        pokemonImageUrl: BEEDRILL$4.images[0].value,
        pokemonLevel: 32,
        pokemonNumber: BEEDRILL$4.number,
        pokemonType: BEEDRILL$4.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 17,
        stage: BEEDRILL$4.stage,
        weight: 65,
    },
    {
        backgroundImageUrl: '',
        description: 'A mystical Pokémon that exudes a gentle aura. Has the ability to change climate conditions.',
        energyResistance: ENERGY_TYPES.PSYCHIC,
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.COLORLESS,
        evolvesFrom: DRATINI$5.name,
        evolutionBoxImageUrl: DRATINI$5.images[0].value,
        hitPoints: 80,
        id: 'base_018_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 13,
        lengthInches: 1,
        moves: [
            SHARED_MOVES(DRAGONAIR$9.name, 'slam', ['colorless', 'colorless', 'colorless'], 30),
            MOVES.HYPER_BEAM,
        ],
        name: DRAGONAIR$9.name,
        pokemonImagePositionX: 53,
        pokemonImagePositionY: 45,
        pokemonImageSize: 70,
        pokemonImageUrl: DRAGONAIR$9.images[1].value,
        pokemonLevel: 33,
        pokemonNumber: DRAGONAIR$9.number,
        pokemonType: DRAGONAIR$9.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 18,
        stage: DRAGONAIR$9.stage,
        weight: 36,
    },
    {
        backgroundImageUrl: '',
        description: 'A team of Diglett triplets. It triggers huge earthquakes by burrowing 60 miles underground.',
        energyResistance: ENERGY_TYPES.LIGHTNING,
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.GRASS,
        evolvesFrom: DIGLETT$6.name,
        evolutionBoxImageUrl: DIGLETT$6.images[0].value,
        hitPoints: 70,
        id: 'base_019_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        lengthFeet: 2,
        lengthInches: 4,
        moves: [
            SHARED_MOVES(DUGTRIO$4.name, 'slash', ['colorless', 'colorless', 'colorless'], 30),
            MOVES.EARTHQUAKE,
        ],
        name: DUGTRIO$4.name,
        pokemonImagePositionX: 53,
        pokemonImagePositionY: 37,
        pokemonImageSize: 71,
        pokemonImageUrl: DUGTRIO$4.images[0].value,
        pokemonLevel: 36,
        pokemonNumber: DUGTRIO$4.number,
        pokemonType: DUGTRIO$4.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 19,
        stage: DUGTRIO$4.stage,
        weight: 73,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lightning-electabuzz_a0idex.jpg',
        description: 'Normally found near power plants, it can wander away and cause major blackouts in cities.',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 70,
        id: 'base_020_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 3,
        lengthInches: 7,
        moves: [
            SHARED_MOVES(ELECTABUZZ$6.name, 'thundershock', ['lightning'], 10),
            MOVES.THUNDERPUNCH,
        ],
        name: ELECTABUZZ$6.name,
        pokemonImagePositionX: 53,
        pokemonImagePositionY: 45,
        pokemonImageSize: 40,
        pokemonImageUrl: ELECTABUZZ$6.images[0].value,
        pokemonLevel: 35,
        pokemonNumber: ELECTABUZZ$6.number,
        pokemonType: ELECTABUZZ$6.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 20,
        weight: 66,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/temp-images/electrode-rays.jpg',
        description: 'It stores electrical energy under very high pressure. It often explodes with little or no provocation.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: VOLTORB$5.name,
        evolutionBoxImageUrl: VOLTORB$5.images[0].value,
        hitPoints: 80,
        id: 'base_021_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [MOVES.BUZZAP, MOVES.ELECTRIC_SHOCK],
        name: ELECTRODE$4.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 45,
        pokemonImageSize: 30,
        pokemonImageUrl: ELECTRODE$4.images[0].value,
        pokemonLevel: 40,
        pokemonNumber: ELECTRODE$4.number,
        pokemonType: ELECTRODE$4.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 21,
        stage: ELECTRODE$4.stage,
        weight: 147,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-pidgeotto_ej6gms.jpg',
        description: 'Very protective of its sprawling territory, this Pokémon will fiercely peck at any intruder.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        evolvesFrom: PIDGEY$2.name,
        evolutionBoxImageUrl: PIDGEY$2.images[0].value,
        hitPoints: 60,
        id: 'base_022_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 3,
        lengthInches: 7,
        moves: [
            SHARED_MOVES(PIDGEOTTO$4.name, 'whirlwind', ['colorless', 'colorless'], 20),
            MOVES.MIRROR_MOVE,
        ],
        name: PIDGEOTTO$4.name,
        pokemonImagePositionX: 57,
        pokemonImagePositionY: 45,
        pokemonImageSize: 42,
        pokemonImageUrl: PIDGEOTTO$4.images[0].value,
        pokemonLevel: 36,
        pokemonNumber: PIDGEOTTO$4.number,
        pokemonType: PIDGEOTTO$4.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 22,
        stage: PIDGEOTTO$4.stage,
        weight: 66,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-erikas-bulbasaur_zmljnk.jpg',
        description: 'A Pokémon that has been long admired for its beauty. It runs gracefully, as if on wings.',
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: ENERGY_TYPES.WATER,
        evolvesFrom: GROWLITHE$8.name,
        evolutionBoxImageUrl: GROWLITHE$8.images[0].value,
        hitPoints: 100,
        id: 'base_023_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 6,
        lengthInches: 3,
        moves: [
            SHARED_MOVES(ARCANINE$4.name, 'flamethrower', ['fire', 'fire', 'colorless'], 50),
            MOVES.TAKE_DOWN,
        ],
        name: ARCANINE$4.name,
        pokemonImagePositionX: 53,
        pokemonImagePositionY: 45,
        pokemonImageSize: 49,
        pokemonImageUrl: ARCANINE$4.images[0].value,
        pokemonLevel: 45,
        pokemonNumber: ARCANINE$4.number,
        pokemonType: ARCANINE$4.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 23,
        stage: ARCANINE$4.stage,
        weight: 342,
    },
    {
        backgroundImageUrl: '',
        description: 'When it swings its burning tail, it raises the temperature to unbearably high levels.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: ENERGY_TYPES.WATER,
        evolvesFrom: CHARMANDER$4.name,
        evolutionBoxImageUrl: CHARMANDER$4.images[0].value,
        hitPoints: 80,
        id: 'base_024_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 3,
        lengthInches: 7,
        moves: [
            MOVES.SLASH,
            SHARED_MOVES(CHARMELEON$7.name, 'flamethrower', ['fire', 'fire', 'colorless'], 50),
        ],
        name: CHARMELEON$7.name,
        pokemonImagePositionX: 53,
        pokemonImagePositionY: 43,
        pokemonImageSize: 71,
        pokemonImageUrl: CHARMELEON$7.images[1].value,
        pokemonLevel: 32,
        pokemonNumber: CHARMELEON$7.number,
        pokemonType: CHARMELEON$7.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 24,
        stage: CHARMELEON$7.stage,
        weight: 42,
    },
    {
        backgroundImageUrl: '',
        description: 'Stores thermal energy in its body. Swims at a steady 8 knots even in intensely cold waters.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        evolvesFrom: SEEL$5.name,
        evolutionBoxImageUrl: SEEL$5.images[0].value,
        hitPoints: 80,
        id: 'base_025_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [
            MOVES.AURORA_BEAM,
            SHARED_MOVES(GYARADOS$5.name, 'ice-beam', ['water', 'water', 'colorless', 'colorless'], 30),
        ],
        name: DEWGONG$4.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 43,
        pokemonImageSize: 67,
        pokemonImageUrl: DEWGONG$4.images[0].value,
        pokemonLevel: 42,
        pokemonNumber: DEWGONG$4.number,
        pokemonType: DEWGONG$4.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 25,
        stage: DEWGONG$4.stage,
        weight: 265,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-dratini_vxrsjo.jpg',
        description: 'Long considered a mythical Pokémon until recently, when a small colony was found living underwater.',
        energyResistance: ENERGY_TYPES.PSYCHIC,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.COLORLESS,
        hitPoints: 40,
        id: 'base_026_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 5,
        lengthInches: 11,
        moves: [MOVES.POUND],
        name: DRATINI$5.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 45,
        pokemonImageSize: 39,
        pokemonImageUrl: DRATINI$5.images[0].value,
        pokemonLevel: 10,
        pokemonNumber: DRATINI$5.number,
        pokemonType: DRATINI$5.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 26,
        weight: 7,
    },
    {
        backgroundColor: '#fff',
        backgroundImageOpacity: 0.8,
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/blotchy-lass_ngz0br.jpg',
        description: 'The sprig of green onions it holds is its weapon. This sprig is used much like a metal sword.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 50,
        id: 'base_027_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [MOVES.LEEK_SLAP, MOVES.POT_SMASH],
        name: FARFETCHD$3.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 45,
        pokemonImageSize: 31,
        pokemonImageUrl: FARFETCHD$3.images[0].value,
        pokemonLevel: 20,
        pokemonNumber: FARFETCHD$3.number,
        pokemonType: FARFETCHD$3.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 27,
        weight: 33,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-growlithe_nyginj.jpg',
        description: 'Very protective of its territory. It will bark and bite to repel intruders from its space.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: ENERGY_TYPES.WATER,
        hitPoints: 60,
        id: 'base_028_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 2,
        lengthInches: 4,
        moves: [MOVES.FLARE],
        name: GROWLITHE$8.name,
        pokemonImagePositionX: 56,
        pokemonImagePositionY: 43,
        pokemonImageSize: 44,
        pokemonImageUrl: GROWLITHE$8.images[0].value,
        pokemonLevel: 18,
        pokemonNumber: GROWLITHE$8.number,
        pokemonType: GROWLITHE$8.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 28,
        weight: 42,
    },
    {
        backgroundImageUrl: '',
        description: 'Because of its ability to slip through block walls, it is said to be from another dimension.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.PSYCHIC,
        evolvesFrom: GASTLY$7.name,
        evolutionBoxImageUrl: GASTLY$7.images[0].value,
        hitPoints: 60,
        id: 'base_029_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        lengthFeet: 5,
        lengthInches: 3,
        moves: [MOVES.HYPNOSIS, MOVES.DREAM_EATER],
        name: HAUNTER$a.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 42,
        pokemonImageSize: 67,
        pokemonImageUrl: HAUNTER$a.images[1].value,
        pokemonLevel: 22,
        pokemonNumber: HAUNTER$a.number,
        pokemonType: HAUNTER$a.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 29,
        stage: HAUNTER$a.stage,
        weight: 0.2,
    },
    {
        backgroundColor: '#25221e',
        backgroundImageOpacity: 0.3,
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-brocks-vulpix_cjhesd.jpg',
        description: 'When the bulb on its back grows large, the Pokémon seems to lose the ability to stand on its hind legs.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        evolvesFrom: BULBASAUR$3.name,
        evolutionBoxImageUrl: BULBASAUR$3.images[0].value,
        hitPoints: 60,
        id: 'base_030_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [MOVES.VINE_WHIP, MOVES.POISONPOWDER],
        name: IVYSAUR$7.name,
        pokemonImagePositionX: 56,
        pokemonImagePositionY: 45,
        pokemonImageSize: 48,
        pokemonImageUrl: IVYSAUR$7.images[0].value,
        pokemonLevel: 20,
        pokemonNumber: IVYSAUR$7.number,
        pokemonType: IVYSAUR$7.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 30,
        stage: IVYSAUR$7.stage,
        weight: 29,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lights-jynx_grozno.jpg',
        description: 'Merely by meditating, the Pokémon launches a powerful psychic energy attack.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 70,
        id: 'base_031_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 4,
        lengthInches: 7,
        moves: [
            SHARED_MOVES(JYNX$5.name, 'doubleslap', ['psychic'], 10),
            SHARED_MOVES(JYNX$5.name, 'meditate', ['psychic', 'psychic', 'colorless'], 20),
        ],
        name: JYNX$5.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 43,
        pokemonImageSize: 45,
        pokemonImageUrl: JYNX$5.images[0].value,
        pokemonLevel: 23,
        pokemonNumber: JYNX$5.number,
        pokemonType: JYNX$5.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 31,
        weight: 90,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lights-kadabra_hrrzpa.jpg',
        description: 'It emits special alpha waves from its body that induce headaches even to those just nearby.',
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        evolvesFrom: ABRA$6.name,
        evolutionBoxImageUrl: ABRA$6.images[0].value,
        hitPoints: 60,
        id: 'base_032_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 4,
        lengthInches: 3,
        moves: [
            SHARED_MOVES(KADABRA$8.name, 'recover', ['psychic', 'psychic'], null, '{PS}'),
            MOVES.SUPER_PSY,
        ],
        name: KADABRA$8.name,
        pokemonImagePositionX: 53,
        pokemonImagePositionY: 45,
        pokemonImageSize: 46,
        pokemonImageUrl: KADABRA$8.images[0].value,
        pokemonLevel: 38,
        pokemonNumber: KADABRA$8.number,
        pokemonType: KADABRA$8.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 32,
        stage: KADABRA$8.stage,
        weight: 125,
    },
    {
        backgroundImageUrl: '',
        description: 'Almost incapable of moving, this Pokémon can only harden its shell to protect itself from predators.',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        evolvesFrom: WEEDLE$3.name,
        evolutionBoxImageUrl: WEEDLE$3.images[0].value,
        hitPoints: 80,
        id: 'base_033_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        lengthFeet: 2,
        lengthInches: 0,
        moves: [
            SHARED_MOVES(KAKUNA$5.name, 'stiffen', ['colorless', 'colorless']),
            MOVES.POISONPOWDER,
        ],
        name: KAKUNA$5.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 43,
        pokemonImageSize: 67,
        pokemonImageUrl: KAKUNA$5.images[1].value,
        pokemonLevel: 23,
        pokemonNumber: KAKUNA$5.number,
        pokemonType: KAKUNA$5.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 33,
        stage: KAKUNA$5.stage,
        weight: 22,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/temp-images/machoke-mountains.jpg',
        description: 'Its muscular body is so powerful that it must wear a power-save belt to help regulate its motions.',
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        evolvesFrom: MACHOP$5.name,
        evolutionBoxImageUrl: MACHOP$5.images[0].value,
        hitPoints: 80,
        id: 'base_034_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 4,
        lengthInches: 11,
        moves: [MOVES.KARATE_CHOP, MOVES.SUBMISSION],
        name: MACHOKE$a.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 45,
        pokemonImageSize: 45,
        pokemonImageUrl: MACHOKE$a.images[0].value,
        pokemonLevel: 40,
        pokemonNumber: MACHOKE$a.number,
        pokemonType: MACHOKE$a.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 34,
        stage: MACHOKE$a.stage,
        weight: 155,
    },
    {
        backgroundImageUrl: '',
        description: 'In the distant past, it was stronger than its horribly weak descendants that exist today.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 30,
        id: 'base_035_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 11,
        moves: [
            SHARED_MOVES(MAGIKARP$8.name, 'tackle', ['colorless'], 10),
            MOVES.FLAIL,
        ],
        name: MAGIKARP$8.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 43,
        pokemonImageSize: 71,
        pokemonImageUrl: MAGIKARP$8.images[1].value,
        pokemonLevel: 8,
        pokemonNumber: MAGIKARP$8.number,
        pokemonType: MAGIKARP$8.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 35,
        weight: 22,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/flames-magmar_s5ibam.jpg',
        description: 'Its body always burns with an orange glow that enables it to hide perfectly among flames.',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: ENERGY_TYPES.WATER,
        hitPoints: 50,
        id: 'base_036_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 4,
        lengthInches: 3,
        moves: [
            MOVES.FIRE_PUNCH,
            SHARED_MOVES(MAGMAR$7.name, 'flamethrower', ['fire', 'fire', 'colorless'], 50),
        ],
        name: MAGMAR$7.name,
        pokemonImagePositionX: 52,
        pokemonImagePositionY: 45,
        pokemonImageSize: 44,
        pokemonImageUrl: MAGMAR$7.images[0].value,
        pokemonLevel: 24,
        pokemonNumber: MAGMAR$7.number,
        pokemonType: MAGMAR$7.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 36,
        weight: 98,
    },
    {
        backgroundImageUrl: '',
        description: 'An aggressive Pokémon that is quick to attack. The horn on its head secretes a powerful venom.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        evolvesFrom: NIDORAN_M$1.name,
        evolutionBoxImageUrl: NIDORAN_M$1.images[0].value,
        hitPoints: 60,
        id: 'base_037_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 11,
        moves: [MOVES.DOUBLE_KICK, MOVES.HORN_DRILL],
        name: NIDORINO$2.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 42,
        pokemonImageSize: 68,
        pokemonImageUrl: NIDORINO$2.images[1].value,
        pokemonLevel: 25,
        pokemonNumber: NIDORINO$2.number,
        pokemonType: NIDORINO$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 37,
        stage: NIDORINO$2.stage,
        weight: 43,
    },
    {
        backgroundColor: '#fff',
        backgroundImageOpacity: 0.5,
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/water-poliwhirl_oxfvdh.jpg',
        description: 'Capable of living in or out of water. When out of water, it sweats to keep its body slimy.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.GRASS,
        evolvesFrom: POLIWAG$5.name,
        evolutionBoxImageUrl: POLIWAG$5.images[0].value,
        hitPoints: 60,
        id: 'base_038_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 3,
        lengthInches: 4,
        moves: [
            MOVES.AMNESIA,
            SHARED_MOVES(POLIWHIRL$7.name, 'doubleslap', ['water', 'water', 'colorless'], 30),
        ],
        name: POLIWHIRL$7.name,
        pokemonImagePositionX: 53,
        pokemonImagePositionY: 45,
        pokemonImageSize: 52,
        pokemonImageUrl: POLIWHIRL$7.images[0].value,
        pokemonLevel: 28,
        pokemonNumber: POLIWHIRL$7.number,
        pokemonType: POLIWHIRL$7.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 38,
        stage: POLIWHIRL$7.stage,
        weight: 44,
    },
    {
        backgroundImageUrl: '',
        description: 'A Pokémon that consists entirely of programming code. Capable of moving freely in cyberspace.',
        energyResistance: ENERGY_TYPES.PSYCHIC,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 30,
        id: 'base_039_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [MOVES.CONVERSION_1, MOVES.CONVERSION_2],
        name: PORYGON$6.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 42,
        pokemonImageSize: 68,
        pokemonImageUrl: PORYGON$6.images[2].value,
        pokemonLevel: 12,
        pokemonNumber: PORYGON$6.number,
        pokemonType: PORYGON$6.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 39,
        weight: 80,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-raticate_af09tb.jpg',
        description: 'It uses its whiskers to maintain its balance. It seems to slow down if they are cut off.',
        energyResistance: ENERGY_TYPES.PSYCHIC,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: RATTATA$5.name,
        evolutionBoxImageUrl: RATTATA$5.images[0].value,
        hitPoints: 60,
        id: 'base_040_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 2,
        lengthInches: 4,
        moves: [
            SHARED_MOVES(RATICATE$5.name, 'bite', ['colorless'], 20),
            MOVES.SUPER_FANG,
        ],
        name: RATICATE$5.name,
        pokemonImagePositionX: 53,
        pokemonImagePositionY: 45,
        pokemonImageSize: 40,
        pokemonImageUrl: RATICATE$5.images[0].value,
        pokemonLevel: 41,
        pokemonNumber: RATICATE$5.number,
        pokemonType: RATICATE$5.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 40,
        stage: RATICATE$5.stage,
        weight: 41,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/water-seel_psmkpp.jpg',
        description: 'The protruding horn on its head is very hard. This horn is used for bashing through thick ice.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 60,
        id: 'base_041_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 3,
        lengthInches: 7,
        moves: [MOVES.HEADBUTT],
        name: SEEL$5.name,
        pokemonImagePositionX: 53,
        pokemonImagePositionY: 45,
        pokemonImageSize: 46,
        pokemonImageUrl: SEEL$5.images[0].value,
        pokemonLevel: 12,
        pokemonNumber: SEEL$5.number,
        pokemonType: SEEL$5.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 41,
        weight: 198,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/beach-wartortle_evqwrg.jpg',
        description: 'Often hides in water to stalk unweary prey. When swimming quickly, it moves its ears to maintain balance.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        evolvesFrom: SQUIRTLE$2.name,
        evolutionBoxImageUrl: SQUIRTLE$2.images[0].value,
        hitPoints: 70,
        id: 'base_042_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [
            SHARED_MOVES(WARTORTLE$5.name, 'withdraw', ['water', 'colorless']),
            SHARED_MOVES(WARTORTLE$5.name, 'bite', ['water', 'colorless', 'colorless'], 40),
        ],
        name: WARTORTLE$5.name,
        pokemonImagePositionX: 53,
        pokemonImagePositionY: 44,
        pokemonImageSize: 36,
        pokemonImageUrl: WARTORTLE$5.images[0].value,
        pokemonLevel: 22,
        pokemonNumber: WARTORTLE$5.number,
        pokemonType: WARTORTLE$5.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 42,
        stage: WARTORTLE$5.stage,
        weight: 50,
    },
    {
        backgroundImageUrl: '',
        description: 'Using its ability to read minds, it will identify impending danger and teleport to safety.',
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 30,
        id: 'base_043_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 11,
        moves: [MOVES.PSYSHOCK],
        name: ABRA$6.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 42,
        pokemonImageSize: 68,
        pokemonImageUrl: ABRA$6.images[1].value,
        pokemonLevel: 10,
        pokemonNumber: ABRA$6.number,
        pokemonType: ABRA$6.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 43,
        weight: 43,
    },
    {
        backgroundImageUrl: '',
        description: 'A strange seed was planted on its back at birth. Thus, a plant sprouted and now grows with this Pokémon.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        hitPoints: 40,
        id: 'base_044_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 4,
        moves: [MOVES.LEECH_SEED],
        name: BULBASAUR$3.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 42,
        pokemonImageSize: 71,
        pokemonImageUrl: BULBASAUR$3.images[1].value,
        pokemonLevel: 13,
        pokemonNumber: BULBASAUR$3.number,
        pokemonType: BULBASAUR$3.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 44,
        weight: 15,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-caterpie_tcfh1l.jpg',
        description: 'It is covered with a green skin. When it grows, it sheds the skin, covers itself with silk, and becomes a cocoon.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        hitPoints: 40,
        id: 'base_045_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 1,
        lengthInches: 0,
        moves: [MOVES.STRING_SHOT],
        name: CATERPIE$2.name,
        pokemonImagePositionX: 53,
        pokemonImagePositionY: 45,
        pokemonImageSize: 39,
        pokemonImageUrl: CATERPIE$2.images[0].value,
        pokemonLevel: 13,
        pokemonNumber: CATERPIE$2.number,
        pokemonType: CATERPIE$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 45,
        weight: 6,
    },
    {
        backgroundImageUrl: '',
        description: 'Obviously prefers hot places. If it gets caught in the rain, steam is said to spout from the tip of its tail.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: ENERGY_TYPES.WATER,
        hitPoints: 50,
        id: 'base_046_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 2,
        lengthInches: 0,
        moves: [MOVES.SCRATCH, MOVES.EMBER],
        name: CHARMANDER$4.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 43,
        pokemonImageSize: 71,
        pokemonImageUrl: CHARMANDER$4.images[1].value,
        pokemonLevel: 10,
        pokemonNumber: CHARMANDER$4.number,
        pokemonType: CHARMANDER$4.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 46,
        weight: 19,
    },
    {
        backgroundImageUrl: '',
        description: 'Lives about three feet underground, where it feeds on plant roots. It sometimes appears above ground.',
        energyResistance: ENERGY_TYPES.LIGHTNING,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.GRASS,
        hitPoints: 30,
        id: 'base_047_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        lengthFeet: 0,
        lengthInches: 8,
        moves: [MOVES.DIG, MOVES.MUD_SLAP],
        name: DIGLETT$6.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 43,
        pokemonImageSize: 69,
        pokemonImageUrl: DIGLETT$6.images[1].value,
        pokemonLevel: 8,
        pokemonNumber: DIGLETT$6.number,
        pokemonType: DIGLETT$6.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 47,
        weight: 2,
    },
    {
        backgroundImageUrl: '',
        description: 'A bird that makes up for its poor flying with its fast foot speed. Leaves giant footprints.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 50,
        id: 'base_048_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 4,
        lengthInches: 7,
        moves: [MOVES.FURY_ATTACK],
        name: DODUO$2.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 42,
        pokemonImageSize: 68,
        pokemonImageUrl: DODUO$2.images[0].value,
        pokemonLevel: 10,
        pokemonNumber: DODUO$2.number,
        pokemonType: DODUO$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 48,
        weight: 86,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lights-drowzee_yywzks.jpg',
        description: 'Puts enemies to sleep, then eats their dreams. Occasionally gets sick from eating bad dreams.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 50,
        id: 'base_049_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [
            MOVES.POUND,
            SHARED_MOVES(DROWZEE$5.name, 'confuse-ray', ['psychic', 'psychic'], 10),
        ],
        name: DROWZEE$5.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 45,
        pokemonImageSize: 45,
        pokemonImageUrl: DROWZEE$5.images[1].value,
        pokemonLevel: 12,
        pokemonNumber: DROWZEE$5.number,
        pokemonType: DROWZEE$5.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 49,
        weight: 71,
    },
    {
        backgroundImageUrl: '',
        description: 'Almost invisible, this gaseous Pokémon cloaks the target and puts it to sleep without notice.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.PSYCHIC,
        hitPoints: 30,
        id: 'base_050_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        lengthFeet: 4,
        lengthInches: 3,
        moves: [MOVES.SLEEPING_GAS, MOVES.DESTINY_BOND],
        name: GASTLY$7.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 42,
        pokemonImageSize: 68,
        pokemonImageUrl: GASTLY$7.images[1].value,
        pokemonLevel: 8,
        pokemonNumber: GASTLY$7.number,
        pokemonType: GASTLY$7.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 50,
        weight: 0.2,
    },
    {
        backgroundImageUrl: '',
        description: 'Because it stores several kinds of toxic gases in its body, it is prone to exploding without warning.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 50,
        id: 'base_051_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 2,
        lengthInches: 0,
        moves: [MOVES.FOUL_GAS],
        name: KOFFING$6.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 42,
        pokemonImageSize: 68,
        pokemonImageUrl: KOFFING$6.images[1].value,
        pokemonLevel: 13,
        pokemonNumber: KOFFING$6.number,
        pokemonType: KOFFING$6.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 51,
        weight: 2,
    },
    {
        backgroundImageUrl: '',
        description: 'Loves to build its muscles. It trains in all styles of martial arts to become even stronger.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 50,
        id: 'base_052_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [MOVES.LOW_KICK],
        name: MACHOP$5.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 42,
        pokemonImageSize: 68,
        pokemonImageUrl: MACHOP$5.images[1].value,
        pokemonLevel: 20,
        pokemonNumber: MACHOP$5.number,
        pokemonType: MACHOP$5.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 52,
        weight: 43,
    },
    {
        backgroundImageUrl: '',
        description: 'Uses anti-gravity to stay suspended. Appears without warning and uses attacks like Thunder Wave.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 40,
        id: 'base_053_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        lengthFeet: 1,
        lengthInches: 0,
        moves: [
            SHARED_MOVES(MAGNEMITE$9.name, 'thunder-wave', ['lightning'], 10),
            SHARED_MOVES(MAGNEMITE$9.name, 'selfdestruct', ['lightning', 'colorless'], 40, 10),
        ],
        name: MAGNEMITE$9.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 42,
        pokemonImageSize: 68,
        pokemonImageUrl: MAGNEMITE$9.images[1].value,
        pokemonLevel: 13,
        pokemonNumber: MAGNEMITE$9.number,
        pokemonType: MAGNEMITE$9.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 53,
        weight: 13,
    },
    {
        backgroundColor: '#000',
        backgroundImageOpacity: 0.4,
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-arbok_pqj82p.jpg',
        description: 'It is vulnerable to attack because its shell is soft, exposing its weak and tender body.',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        evolvesFrom: CATERPIE$2.name,
        evolutionBoxImageUrl: CATERPIE$2.images[0].value,
        hitPoints: 70,
        id: 'base_054_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 2,
        lengthInches: 4,
        moves: [
            SHARED_MOVES(KAKUNA$5.name, 'stiffen', ['colorless', 'colorless']),
            MOVES.STUN_SPORE,
        ],
        name: METAPOD$4.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 45,
        pokemonImageSize: 32,
        pokemonImageUrl: METAPOD$4.images[0].value,
        pokemonLevel: 21,
        pokemonNumber: METAPOD$4.number,
        pokemonType: METAPOD$4.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 54,
        stage: METAPOD$4.stage,
        weight: 22,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-nidoran_fjwr09.jpg',
        description: 'Stiffens its ears to sense danger. The larger, more powerful of its horns secretes venom.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 40,
        id: 'base_055_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 1,
        lengthInches: 4,
        moves: [MOVES.HORN_HAZARD],
        name: NIDORAN_M$1.name,
        pokemonImagePositionX: 53,
        pokemonImagePositionY: 45,
        pokemonImageSize: 36,
        pokemonImageUrl: NIDORAN_M$1.images[0].value,
        pokemonLevel: 20,
        pokemonNumber: NIDORAN_M$1.number,
        pokemonType: NIDORAN_M$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 55,
        weight: 15,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-onix_xf2mva.jpg',
        description: 'As it grows, the stone portions of its body harden to become similar to a diamond, though colored black.',
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.GRASS,
        hitPoints: 90,
        id: 'base_056_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 28,
        lengthInches: 10,
        moves: [MOVES.ROCK_THROW, MOVES.HARDEN],
        name: ONIX$4.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 45,
        pokemonImageSize: 39,
        pokemonImageUrl: ONIX$4.images[0].value,
        pokemonLevel: 12,
        pokemonNumber: ONIX$4.number,
        pokemonType: ONIX$4.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 56,
        weight: 463,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-pidgey_ggcjcw.jpg',
        description: 'A common sight in forests and woods. It flaps its wings at ground level to kick up blinding sand.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 40,
        id: 'base_057_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 1,
        lengthInches: 0,
        moves: [
            SHARED_MOVES(PIDGEY$2.name, 'whirlwind', ['colorless', 'colorless'], 10),
        ],
        name: PIDGEY$2.name,
        pokemonImagePositionX: 53,
        pokemonImagePositionY: 45,
        pokemonImageSize: 40,
        pokemonImageUrl: PIDGEY$2.images[0].value,
        pokemonLevel: 8,
        pokemonNumber: PIDGEY$2.number,
        pokemonType: PIDGEY$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 57,
        weight: 4,
    },
    {
        backgroundImageUrl: '',
        description: 'It has small electric sacs on both cheeks. If threatened, it looses electric charges from the sacs.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 40,
        id: 'base_058_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 1,
        lengthInches: 4,
        moves: [MOVES.GNAW, MOVES.THUNDER_JOLT],
        name: PIKACHU$d.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 42,
        pokemonImageSize: 68,
        pokemonImageUrl: PIKACHU$d.images[1].value,
        pokemonLevel: 12,
        pokemonNumber: PIKACHU$d.number,
        pokemonType: PIKACHU$d.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 58,
        weight: 13,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-chansey_fmsdky.jpg',
        description: 'Its newly grown legs prevent it from running. It appears to prefer swimming over trying to stand.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.GRASS,
        hitPoints: 40,
        id: 'base_059_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 2,
        lengthInches: 0,
        moves: [SHARED_MOVES(POLIWAG$5.name, 'water-gun', ['water'], 10)],
        name: POLIWAG$5.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 51,
        pokemonImageSize: 56,
        pokemonImageUrl: POLIWAG$5.images[0].value,
        pokemonLevel: 13,
        pokemonNumber: POLIWAG$5.number,
        pokemonType: POLIWAG$5.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 59,
        weight: 27,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/hills-ponyta_bcekdh.jpg',
        description: 'Its hooves are 10 times harder than diamonds. It can trample anything flat in moments.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: ENERGY_TYPES.WATER,
        hitPoints: 40,
        id: 'base_060_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [MOVES.SMASH_KICK, MOVES.FLAME_TAIL],
        name: PONYTA$7.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 43,
        pokemonImageSize: 35,
        pokemonImageUrl: PONYTA$7.images[0].value,
        pokemonLevel: 10,
        pokemonNumber: PONYTA$7.number,
        pokemonType: PONYTA$7.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 60,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        description: 'Bites anything when it attacks. Small and very quick, it is a common sight in many places.',
        energyResistance: ENERGY_TYPES.PSYCHIC,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 30,
        id: 'base_061_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 1,
        lengthInches: 0,
        moves: [SHARED_MOVES(RATTATA$5.name, 'bite', ['colorless'], 20)],
        name: RATTATA$5.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 42,
        pokemonImageSize: 70,
        pokemonImageUrl: RATTATA$5.images[1].value,
        pokemonLevel: 9,
        pokemonNumber: RATTATA$5.number,
        pokemonType: RATTATA$5.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 61,
        weight: 8,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-sandshrew_h02xle.jpg',
        description: 'Burrows deep underground in arid locations far from water. It only emerges to hunt for food.',
        energyResistance: ENERGY_TYPES.LIGHTNING,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.GRASS,
        hitPoints: 40,
        id: 'base_062_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 2,
        lengthInches: 0,
        moves: [MOVES.SAND_ATTACK],
        name: SANDSHREW$4.name,
        pokemonImagePositionX: 53,
        pokemonImagePositionY: 46,
        pokemonImageSize: 37,
        pokemonImageUrl: SANDSHREW$4.images[0].value,
        pokemonLevel: 12,
        pokemonNumber: SANDSHREW$4.number,
        pokemonType: SANDSHREW$4.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 62,
        weight: 26,
    },
    {
        backgroundImageUrl: '',
        description: 'After birth, its back swells and hardens into a shell. It powerfully sprays foam from its mouth.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 40,
        id: 'base_063_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 1,
        lengthInches: 8,
        moves: [
            MOVES.BUBBLE,
            SHARED_MOVES(SQUIRTLE$2.name, 'withdraw', ['water', 'colorless']),
        ],
        name: SQUIRTLE$2.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 42,
        pokemonImageSize: 69,
        pokemonImageUrl: SQUIRTLE$2.images[1].value,
        pokemonLevel: 8,
        pokemonNumber: SQUIRTLE$2.number,
        pokemonType: SQUIRTLE$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 63,
        weight: 20,
    },
    {
        backgroundImageUrl: '',
        description: 'Its central core glows with the seven colors of the rainbow. Some people value this core as a gem.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        evolvesFrom: STARYU$5.name,
        evolutionBoxImageUrl: STARYU$5.images[0].value,
        hitPoints: 40,
        id: 'base_064_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        lengthFeet: 3,
        lengthInches: 7,
        moves: [
            SHARED_MOVES(STARMIE$4.name, 'recover', ['water', 'water'], null, '<W>'),
            MOVES.STAR_FREEZE,
        ],
        name: STARMIE$4.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 42,
        pokemonImageSize: 68,
        pokemonImageUrl: STARMIE$4.images[0].value,
        pokemonLevel: 28,
        pokemonNumber: STARMIE$4.number,
        pokemonType: STARMIE$4.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 64,
        stage: STARMIE$4.stage,
        weight: 176,
    },
    {
        backgroundImageUrl: '',
        description: 'An enigmatic Pokémon that can effortlessly regenerate any appendage it loses in battle.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 40,
        id: 'base_065_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [MOVES.SLAP],
        name: STARYU$5.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 42,
        pokemonImageSize: 68,
        pokemonImageUrl: STARYU$5.images[1].value,
        pokemonLevel: 15,
        pokemonNumber: STARYU$5.number,
        pokemonType: STARYU$5.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 65,
        weight: 76,
    },
    {
        backgroundImageUrl: '',
        description: 'Its whole body is swathed with wide vines that are similar to seaweed. These vines shake as it walks.',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        hitPoints: 50,
        id: 'base_066_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [MOVES.BIND, MOVES.POISONPOWDER],
        name: TANGELA$2.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 42,
        pokemonImageSize: 67,
        pokemonImageUrl: TANGELA$2.images[0].value,
        pokemonLevel: 8,
        pokemonNumber: TANGELA$2.number,
        pokemonType: TANGELA$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 66,
        weight: 77,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/temp-images/voltorb-spark.jpg',
        description: 'Usually found in power plants. Easily mistaken for a Poké Ball, it has zapped many people.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 40,
        id: 'base_067_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        lengthFeet: 1,
        lengthInches: 8,
        moves: [SHARED_MOVES(VOLTORB$5.name, 'tackle', ['colorless'], 10)],
        name: VOLTORB$5.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 44,
        pokemonImageSize: 33,
        pokemonImageUrl: VOLTORB$5.images[1].value,
        pokemonLevel: 10,
        pokemonNumber: VOLTORB$5.number,
        pokemonType: VOLTORB$5.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 67,
        weight: 23,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lights-vulpix_alf7eb.jpg',
        description: 'At the time of birth, it has just one tail. Its tail splits from the tip as it grows older.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: ENERGY_TYPES.WATER,
        hitPoints: 50,
        id: 'base_068_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 2,
        lengthInches: 0,
        moves: [SHARED_MOVES(VULPIX$6.name, 'confuse-ray', ['fire', 'fire'], 10)],
        name: VULPIX$6.name,
        pokemonImagePositionX: 56,
        pokemonImagePositionY: 48,
        pokemonImageSize: 54,
        pokemonImageUrl: VULPIX$6.images[0].value,
        pokemonLevel: 11,
        pokemonNumber: VULPIX$6.number,
        pokemonType: VULPIX$6.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 68,
        weight: 22,
    },
    {
        backgroundImageUrl: '',
        description: 'Often found in forests, eating leaves. It has a sharp, venomous stinger on its head.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        hitPoints: 40,
        id: 'base_069_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 1,
        lengthInches: 0,
        moves: [SHARED_MOVES(WEEDLE$3.name, 'poison-sting', ['grass'], 10)],
        name: WEEDLE$3.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 42,
        pokemonImageSize: 67,
        pokemonImageUrl: WEEDLE$3.images[1].value,
        pokemonLevel: 12,
        pokemonNumber: WEEDLE$3.number,
        pokemonType: WEEDLE$3.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 69,
        weight: 7,
    },
];

const BASE_SET_THEME_DECKS = [
    {
        id: 'two-player-starter',
        name: '2-Player Starter Set',
        energyTypes: ['fire', 'fighting', 'colorless'],
        cards: [
            {
                id: 'base_047_en',
                count: 3,
            },
            {
                id: 'base_052_en',
                count: 4,
            },
            {
                id: 'base_034_en',
                count: 2,
            },
            {
                id: 'base_008_en',
                count: 1,
            },
            {
                id: 'base_060_en',
                count: 4,
            },
            {
                id: 'base_046_en',
                count: 4,
            },
            {
                id: 'base_024_en',
                count: 1,
            },
            {
                id: 'base_061_en',
                count: 2,
            },
            {
                id: 'base_026_en',
                count: 1,
            },
            {
                id: 'base_091_en',
                count: 1,
            },
            {
                id: 'base_092_en',
                count: 1,
            },
            {
                id: 'base_081_en',
                count: 1,
            },
            {
                id: 'base_093_en',
                count: 1,
            },
            {
                id: 'base_094_en',
                count: 2,
            },
            {
                id: 'base_095_en',
                count: 2,
            },
            {
                id: 'base_097_en',
                count: 14,
            },
            {
                id: 'base_098_en',
                count: 14,
            },
        ],
    },
    {
        id: 'overgrowth',
        name: 'Overgrowth',
        energyTypes: ['water', 'grass'],
        cards: [
            {
                id: 'base_006_en',
                count: 1,
            },
            {
                id: 'base_035_en',
                count: 2,
            },
            {
                id: 'base_064_en',
                count: 3,
            },
            {
                id: 'base_065_en',
                count: 4,
            },
            {
                id: 'base_017_en',
                count: 1,
            },
            {
                id: 'base_033_en',
                count: 2,
            },
            {
                id: 'base_030_en',
                count: 2,
            },
            {
                id: 'base_069_en',
                count: 4,
            },
            {
                id: 'base_044_en',
                count: 4,
            },
            {
                id: 'base_094_en',
                count: 1,
            },
            {
                id: 'base_091_en',
                count: 2,
            },
            {
                id: 'base_090_en',
                count: 2,
            },
            {
                id: 'base_095_en',
                count: 2,
            },
            {
                id: 'base_093_en',
                count: 2,
            },
            {
                id: 'base_102_en',
                count: 12,
            },
            {
                id: 'base_099_en',
                count: 16,
            },
        ],
    },
    {
        id: 'zap',
        name: 'Zap!',
        energyTypes: ['lightning', 'psychic'],
        cards: [
            {
                id: 'base_010_en',
                count: 1,
            },
            {
                id: 'base_032_en',
                count: 1,
            },
            {
                id: 'base_031_en',
                count: 2,
            },
            {
                id: 'base_029_en',
                count: 2,
            },
            {
                id: 'base_050_en',
                count: 3,
            },
            {
                id: 'base_049_en',
                count: 2,
            },
            {
                id: 'base_043_en',
                count: 3,
            },
            {
                id: 'base_058_en',
                count: 4,
            },
            {
                id: 'base_053_en',
                count: 3,
            },
            {
                id: 'base_071_en',
                count: 1,
            },
            {
                id: 'base_080_en',
                count: 1,
            },
            {
                id: 'base_090_en',
                count: 1,
            },
            {
                id: 'base_093_en',
                count: 2,
            },
            {
                id: 'base_091_en',
                count: 2,
            },
            {
                id: 'base_100_en',
                count: 16,
            },
        ],
    },
    {
        id: 'brushfire',
        name: 'Brushfire',
        energyTypes: ['fire', 'grass'],
        cards: [
            {
                id: 'base_012_en',
                count: 1,
            },
            {
                id: 'base_069_en',
                count: 4,
            },
            {
                id: 'base_066_en',
                count: 2,
            },
            {
                id: 'base_055_en',
                count: 4,
            },
            {
                id: 'base_023_en',
                count: 1,
            },
            {
                id: 'base_028_en',
                count: 2,
            },
            {
                id: 'base_024_en',
                count: 2,
            },
            {
                id: 'base_068_en',
                count: 2,
            },
            {
                id: 'base_075_en',
                count: 1,
            },
            {
                id: 'base_084_en',
                count: 1,
            },
            {
                id: 'base_081_en',
                count: 2,
            },
            {
                id: 'base_095_en',
                count: 1,
            },
            {
                id: 'base_094_en',
                count: 3,
            },
            {
                id: 'base_093_en',
                count: 1,
            },
            {
                id: 'base_092_en',
                count: 1,
            },
            {
                id: 'base_099_en',
                count: 10,
            },
            {
                id: 'base_098_en',
                count: 18,
            },
        ],
    },
    {
        id: 'blackout',
        name: 'Blackout',
        energyTypes: ['water', 'fighting'],
        cards: [
            {
                id: 'base_007_en',
                count: 1,
            },
            {
                id: 'base_027_en',
                count: 2,
            },
            {
                id: 'base_042_en',
                count: 2,
            },
            {
                id: 'base_063_en',
                count: 4,
            },
            {
                id: 'base_065_en',
                count: 3,
            },
            {
                id: 'base_056_en',
                count: 3,
            },
            {
                id: 'base_062_en',
                count: 3,
            },
            {
                id: 'base_034_en',
                count: 2,
            },
            {
                id: 'base_052_en',
                count: 4,
            },
            {
                id: 'base_079_en',
                count: 1,
            },
            {
                id: 'base_084_en',
                count: 1,
            },
            {
                id: 'base_088_en',
                count: 1,
            },
            {
                id: 'base_093_en',
                count: 1,
            },
            {
                id: 'base_092_en',
                count: 4,
            },
            {
                id: 'base_097_en',
                count: 16,
            },
            {
                id: 'base_102_en',
                count: 12,
            },
        ],
    },
];

const BASE_TRAINERS = {
    BILL: {
        name: 'Bill',
        image: 'https://poketcgshop.s3.amazonaws.com/trainer-card-images/bill.png',
    },
    CLEFAIRY_DOLL: {
        name: 'Clefairy Doll',
        image: 'https://poketcgshop.s3.amazonaws.com/trainer-card-images/clefairy-doll.png',
    },
    COMPUTER_SEARCH: {
        name: 'Computer Search',
        image: 'https://poketcgshop.s3.amazonaws.com/trainer-card-images/computer-search.png',
    },
    DEFENDER: {
        name: 'Defender',
        image: 'https://poketcgshop.s3.amazonaws.com/trainer-card-images/defender.png',
    },
    DEVOLUTION_SPRAY: {
        name: 'Devolution Spray',
        image: 'https://poketcgshop.s3.amazonaws.com/trainer-card-images/devolution-spray.png',
    },
    ENERGY_REMOVAL: {
        name: 'Energy Removal',
        image: 'https://poketcgshop.s3.amazonaws.com/trainer-card-images/energy-removal.png',
    },
    ENERGY_RETRIEVAL: {
        name: 'Energy Retrieval',
        image: 'https://poketcgshop.s3.amazonaws.com/trainer-card-images/energy-retrieval.png',
    },
    FULL_HEAL: {
        name: 'Full Heal',
        image: 'https://poketcgshop.s3.amazonaws.com/trainer-card-images/full-heal.png',
    },
    GUST_OF_WIND: {
        name: 'Gust of Wind',
        image: 'https://poketcgshop.s3.amazonaws.com/trainer-card-images/gust-of-wind.png',
    },
    IMPOSTER_PROFESSOR_OAK: {
        name: 'Imposter Professor Oak',
        image: 'https://poketcgshop.s3.amazonaws.com/trainer-card-images/imposter-professor-oak.png',
    },
    ITEM_FINDER: {
        name: 'Item Finder',
        image: 'https://poketcgshop.s3.amazonaws.com/trainer-card-images/item-finder.png',
    },
    LASS: {
        name: 'Lass',
        image: 'https://poketcgshop.s3.amazonaws.com/trainer-card-images/lass.png',
    },
    MAINTENANCE: {
        name: 'Maintenance',
        image: 'https://poketcgshop.s3.amazonaws.com/trainer-card-images/maintenance.png',
    },
    PLUS_POWER: {
        name: 'PlusPower',
        image: 'https://poketcgshop.s3.amazonaws.com/trainer-card-images/pluspower.png',
    },
    POKEDEX: {
        name: 'Pokédex',
        image: 'https://poketcgshop.s3.amazonaws.com/trainer-card-images/pokedex.png',
    },
    POKEMON_BREEDER: {
        name: 'Pokémon Breeder',
        image: 'https://poketcgshop.s3.amazonaws.com/trainer-card-images/pokemon-breeder.png',
    },
    POKEMON_CENTER: {
        name: 'Pokémon Center',
        image: 'https://poketcgshop.s3.amazonaws.com/trainer-card-images/pokemon-center.png',
    },
    POKEMON_FLUTE: {
        name: 'Pokémon Flute',
        image: 'https://poketcgshop.s3.amazonaws.com/trainer-card-images/pokemon-flute.png',
    },
    POKEMON_TRADER: {
        name: 'Pokémon Trader',
        image: 'https://poketcgshop.s3.amazonaws.com/trainer-card-images/pokemon-trader.png',
    },
    POTION: {
        name: 'Potion',
        image: 'https://poketcgshop.s3.amazonaws.com/trainer-card-images/potion.png',
    },
    PROFESSOR_OAK: {
        name: 'Professor Oak',
        image: 'https://poketcgshop.s3.amazonaws.com/trainer-card-images/professor-oak.png',
    },
    REVIVE: {
        name: 'Revive',
        image: 'https://poketcgshop.s3.amazonaws.com/trainer-card-images/revive.png',
    },
    SCOOP_UP: {
        name: 'Scoop Up',
        image: 'https://poketcgshop.s3.amazonaws.com/trainer-card-images/scoop-up.png',
    },
    SUPER_ENERGY_REMOVAL: {
        name: 'Super Energy Removal',
        image: 'https://poketcgshop.s3.amazonaws.com/trainer-card-images/super-energy-removal.png',
    },
    SUPER_POTION: {
        name: 'Super Potion',
        image: 'https://poketcgshop.s3.amazonaws.com/trainer-card-images/super-potion.png',
    },
    SWITCH: {
        name: 'Switch',
        image: 'https://poketcgshop.s3.amazonaws.com/trainer-card-images/switch.png',
    },
};

const { BILL, CLEFAIRY_DOLL, COMPUTER_SEARCH, DEFENDER, DEVOLUTION_SPRAY, ENERGY_REMOVAL, ENERGY_RETRIEVAL, FULL_HEAL: FULL_HEAL$3, GUST_OF_WIND, IMPOSTER_PROFESSOR_OAK, ITEM_FINDER, LASS, MAINTENANCE, PLUS_POWER, POKEDEX, POKEMON_BREEDER, POKEMON_CENTER, POKEMON_FLUTE, POKEMON_TRADER, POTION: POTION$3, PROFESSOR_OAK, REVIVE, SCOOP_UP, SUPER_ENERGY_REMOVAL, SUPER_POTION, SWITCH: SWITCH$2, } = BASE_TRAINERS;
const BASE_SET_TRAINERS = [
    {
        backgroundImageUrl: CLEFAIRY_DOLL.image,
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: "Play Clefairy Doll as if it were a Basic Pokémon. While in play, Clefairy Doll counts as a Pokémon (instead of a Trainer card). Clefairy Doll has no attacks, can't retreat, and can't be Asleep, Confused, Paralyzed, or Poisoned. If Clefairy Doll is Knocked Out, it doesn't count as a Knocked Out Pokémon. At any time during your turn before your attack, you may discard Clefairy Doll.",
        hitPoints: 10,
        id: 'base_070_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        name: CLEFAIRY_DOLL.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 70,
    },
    {
        backgroundImageUrl: COMPUTER_SEARCH.image,
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: 'Discard 2 of the other cards from your hand in order to search your deck for any card and put it into your hand. Shuffle your deck afterward.',
        id: 'base_071_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        name: COMPUTER_SEARCH.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 71,
    },
    {
        backgroundImageUrl: DEVOLUTION_SPRAY.image,
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: 'Choose 1 of your own Pokémon in play and a Stage of Evolution. Discard all Evolution cards of that Stage or higher attached to that Pokémon. That Pokémon is no longer Asleep, Confused, Paralyzed, Poisoned, or anything else that might be the result of an attack (just as if you had evolved it).',
        id: 'base_072_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        name: DEVOLUTION_SPRAY.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 72,
    },
    {
        backgroundImageUrl: IMPOSTER_PROFESSOR_OAK.image,
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: 'Your opponent shuffles his or her hand into his or her deck, then draws 7 cards.',
        id: 'base_073_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        name: IMPOSTER_PROFESSOR_OAK.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 73,
    },
    {
        backgroundImageUrl: ITEM_FINDER.image,
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: 'Discard 2 of the other cards from your hand in order to put a Trainer card from your discard pile into your hand.',
        id: 'base_074_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        name: ITEM_FINDER.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 74,
    },
    {
        backgroundImageUrl: LASS.image,
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: 'You and your opponent show each other your hands, then shuffle all the Trainer cards from your hands into your decks.',
        id: 'base_075_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        name: LASS.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 75,
    },
    {
        backgroundImageUrl: POKEMON_BREEDER.image,
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: 'Put a Stage 2 Evolution card from your hand on the matching Basic Pokémon. You can only play this card when you would be allowed to evolve that Pokémon anyway.',
        id: 'base_076_en',
        name: POKEMON_BREEDER.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 76,
    },
    {
        backgroundImageUrl: POKEMON_TRADER.image,
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: 'Trade 1 of the Basic Pokémon or Evolution cards in your hand for 1 of the Basic Pokémon or Evolution cards from your deck. Show both cards to your opponent. Shuffle your deck afterward.',
        id: 'base_077_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        name: POKEMON_TRADER.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 77,
    },
    {
        backgroundImageUrl: SCOOP_UP.image,
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: 'Choose 1 of your Pokémon in play and return its Basic Pokémon card to your hand. <em>(Discard all cards attached to that card.)</em>',
        id: 'base_078_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        name: SCOOP_UP.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 78,
    },
    {
        backgroundImageUrl: SUPER_ENERGY_REMOVAL.image,
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: "Discard 1 Energy card attached to 1 of your own Pokémon in order to choose 1 of your opponent's Pokémon and up to 2 Energy cards attached to it. Discard those Energy cards.",
        id: 'base_079_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        name: SUPER_ENERGY_REMOVAL.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 79,
    },
    {
        backgroundImageUrl: DEFENDER.image,
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: "Attach Defender to 1 of your Pokémon. At the end of your opponent's next turn, discard Defender. Damage done to that Pokémon by attacks is reduced by 20 <em>(after applying Weakness and Resistance).</em>",
        id: 'base_080_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        name: DEFENDER.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 80,
    },
    {
        backgroundImageUrl: ENERGY_RETRIEVAL.image,
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: 'Trade 1 of the other cards in your hand for up to 2 basic Energy cards from your discard pile.',
        id: 'base_081_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        name: ENERGY_RETRIEVAL.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 81,
    },
    {
        backgroundImageUrl: FULL_HEAL$3.image,
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: 'Your Active Pokémon is no longer Asleep, Confused, Paralyzed, or Poisoned.',
        id: 'base_082_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        name: FULL_HEAL$3.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 82,
    },
    {
        backgroundImageUrl: MAINTENANCE.image,
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: 'Shuffle 2 of the other cards from your hand into your deck in order to draw a card.',
        id: 'base_083_en',
        illustrators: ILLUSTRATORS.KINEBUCHI,
        name: MAINTENANCE.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 83,
    },
    {
        backgroundImageUrl: PLUS_POWER.image,
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: "Attach PlusPower to your Active Pokémon. At the end of your turn, discard PlusPower. If this Pokémon's attack does damage to the Defending Pokémon (after applying Weakness and Resistance), the attack does 10 more damage to the Defending Pokémon.",
        id: 'base_084_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        name: PLUS_POWER.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 84,
    },
    {
        backgroundImageUrl: POKEMON_CENTER.image,
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: 'Remove all damage counters from all of your own Pokémon with damage counters on them, then discard all Energy cards attached to those Pokémon.',
        id: 'base_085_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        name: POKEMON_CENTER.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 85,
    },
    {
        backgroundImageUrl: POKEMON_FLUTE.image,
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: "Choose 1 Basic Pokémon card from your opponent's discard pile and put it onto his or her Bench. <em>(You can't play Pokémon Flute if your opponent's Bench is full.)</em>",
        id: 'base_086_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        name: POKEMON_FLUTE.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 86,
    },
    {
        backgroundImageUrl: POKEDEX.image,
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: 'Look at up to 5 cards from the top of your deck and rearrange them as you like.',
        id: 'base_087_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        name: POKEDEX.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 87,
    },
    {
        backgroundImageUrl: PROFESSOR_OAK.image,
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: 'Discard your hand, then draw 7 cards.',
        id: 'base_088_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        name: PROFESSOR_OAK.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 88,
    },
    {
        backgroundImageUrl: REVIVE.image,
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: "Put 1 Basic Pokémon card from your discard pile onto your Bench. Put damage counters on that Pokémon equal to half its HP (rounded down to the nearest 10). <em>(You can't play Revive if your Bench is full.)</em>",
        id: 'base_089_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        name: REVIVE.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 89,
    },
    {
        backgroundImageUrl: SUPER_POTION.image,
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: 'Discard 1 Energy card attached to 1 of your own Pokémon in order to remove up to 4 damage counters from that Pokémon.',
        id: 'base_090_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        name: SUPER_POTION.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 90,
    },
    {
        backgroundImageUrl: BILL.image,
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: 'Draw 2 cards.',
        id: 'base_091_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        isDescriptionCentered: true,
        name: BILL.name,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 91,
    },
    {
        backgroundImageUrl: ENERGY_REMOVAL.image,
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: "Choose 1 Energy card attached to 1 of your opponent's Pokémon and discard it.",
        id: 'base_092_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        name: ENERGY_REMOVAL.name,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 92,
    },
    {
        backgroundImageUrl: GUST_OF_WIND.image,
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: "Choose 1 of your opponent's Benched Pokémon and switch it with his or her Active Pokémon.",
        id: 'base_093_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        name: GUST_OF_WIND.name,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 93,
    },
    {
        backgroundImageUrl: POTION$3.image,
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: 'Remove up to 2 damage counters from 1 of your Pokémon.',
        id: 'base_094_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        name: POTION$3.name,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 94,
    },
    {
        backgroundImageUrl: SWITCH$2.image,
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: 'Switch 1 of your Benched Pokémon with your Active Pokémon.',
        id: 'base_095_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        name: SWITCH$2.name,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 95,
    },
];

const { DOUBLE_COLORLESS } = SPECIAL_ENERGIES;
const BASE_SET_ENERGIES = [
    {
        cardTemplate: CARD_TEMPLATES.ENERGY,
        description: "Provides {CO} {CO} energy. Doesn't count as a basic Energy card.",
        id: 'base_096_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        isDoubleEnergyType: true,
        name: DOUBLE_COLORLESS.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 96,
    },
    {
        cardTemplate: CARD_TEMPLATES.ENERGY,
        energyType: ENERGY_TYPES.FIGHTING,
        id: 'base_097_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        setNumber: 97,
    },
    {
        cardTemplate: CARD_TEMPLATES.ENERGY,
        energyType: ENERGY_TYPES.FIRE,
        id: 'base_098_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        setNumber: 98,
    },
    {
        cardTemplate: CARD_TEMPLATES.ENERGY,
        energyType: ENERGY_TYPES.GRASS,
        id: 'base_099_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        setNumber: 99,
    },
    {
        cardTemplate: CARD_TEMPLATES.ENERGY,
        energyType: ENERGY_TYPES.LIGHTNING,
        id: 'base_100_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        setNumber: 100,
    },
    {
        cardTemplate: CARD_TEMPLATES.ENERGY,
        energyType: ENERGY_TYPES.PSYCHIC,
        id: 'base_101_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        setNumber: 101,
    },
    {
        cardTemplate: CARD_TEMPLATES.ENERGY,
        energyType: ENERGY_TYPES.WATER,
        id: 'base_102_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        setNumber: 102,
    },
];

const setId$h = CARD_SETS.BASE.value;
const setName$h = CARD_SETS.BASE.label;
const setTotal$e = BASE_SET_TOTAL;
const BASE_SET = {
    cards: [
        ...BASE_SET_HOLOS,
        ...BASE_SET_NON_HOLOS,
        ...BASE_SET_TRAINERS,
        ...BASE_SET_ENERGIES,
    ],
    cardCounts: {
        holoRares: 16,
        rares: 16,
        uncommons: 32,
        commons: 32,
        energies: 6,
    },
    copyright: COPYRIGHTS.BASE_SET,
    description: SET_DESCRIPTIONS.BASE,
    holoSheetType: CARD_HOLO_SHEETS.STARS,
    id: setId$h,
    imageUrl: 'https://cdn.shopify.com/s/files/1/0840/1659/5249/collections/base-cat-bg.jpg',
    name: setName$h,
    packInfo: BOOSTER_PACKS.BASE,
    releaseDate: RELEASE_DATES.BASE,
    setSymbol: setId$h,
    setTotal: setTotal$e,
    themeDecks: BASE_SET_THEME_DECKS,
};

const { CLEFABLE: CLEFABLE$3, CLEFAIRY: CLEFAIRY$7, EEVEE: EEVEE$a, ELECTRODE: ELECTRODE$3, FLAREON: FLAREON$4, GLOOM: GLOOM$8, JIGGLYPUFF: JIGGLYPUFF$7, JOLTEON: JOLTEON$5, KANGASKHAN: KANGASKHAN$1, MR_MIME: MR_MIME$2, NIDORINA: NIDORINA$4, NIDOQUEEN: NIDOQUEEN$2, PIDGEOT: PIDGEOT$3, PIDGEOTTO: PIDGEOTTO$3, PINSIR: PINSIR$2, SCYTHER: SCYTHER$6, SNORLAX: SNORLAX$3, VAPOREON: VAPOREON$3, VOLTORB: VOLTORB$4, VENOMOTH: VENOMOTH$4, VENONAT: VENONAT$4, VICTREEBEL: VICTREEBEL$1, VILEPLUME: VILEPLUME$4, WEEPINBELL: WEEPINBELL$2, WIGGLYTUFF: WIGGLYTUFF$3, } = GEN_1_POKEMON;
const JUNGLE_HOLOS = [
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/foliage-erikas-gloom_v2u2vs.jpg',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'A timid Fairy Pokémon that is rarely seen. It will run and hide the moment it sees people.',
        energyResistance: ENERGY_TYPES.PSYCHIC,
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: CLEFAIRY$7.name,
        evolutionBoxImageUrl: CLEFAIRY$7.images[0].value,
        hitPoints: 70,
        holo: true,
        holoStrength: 0.7,
        id: 'jungle_01_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 4,
        lengthInches: 3,
        moves: [MOVES.METRONOME_ALT, MOVES.MINIMIZE],
        name: CLEFABLE$3.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 39,
        pokemonImageUrl: CLEFABLE$3.images[0].value,
        pokemonLevel: 34,
        pokemonNumber: CLEFABLE$3.number,
        pokemonType: CLEFABLE$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 1,
        stage: CLEFABLE$3.stage,
        weight: 88,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lightning-surges-raichu_vx4d4b.jpg',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'It stores electrical energy under very high pressure. It often explodes with little or no provocation.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: VOLTORB$4.name,
        evolutionBoxBackgroundImageSize: '60%',
        evolutionBoxImageUrl: VOLTORB$4.images[0].value,
        hitPoints: 90,
        holo: true,
        holoStrength: 0.7,
        id: 'jungle_02_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [
            SHARED_MOVES(ELECTRODE$3.name, 'tackle', ['colorless', 'colorless'], 20),
            MOVES.CHAIN_LIGHTNING,
        ],
        name: ELECTRODE$3.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 43,
        pokemonImageSize: 44,
        pokemonImageUrl: ELECTRODE$3.images[1].value,
        pokemonLevel: 14,
        pokemonNumber: ELECTRODE$3.number,
        pokemonType: ELECTRODE$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 2,
        stage: ELECTRODE$3.stage,
        weight: 147,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lights-jynx_grozno.jpg',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'When storing thermal energy in its body, its temperature could soar to over 1600 degrees.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: ENERGY_TYPES.WATER,
        evolvesFrom: EEVEE$a.name,
        evolutionBoxImageUrl: EEVEE$a.images[0].value,
        hitPoints: 70,
        holo: true,
        holoStrength: 0.7,
        id: 'jungle_03_en',
        illustrator: ILLUSTRATORS.HIMENO,
        lengthFeet: 2,
        lengthInches: 11,
        moves: [
            MOVES.QUICK_ATTACK,
            SHARED_MOVES(FLAREON$4.name, 'flamethrower', ['fire', 'fire', 'colorless', 'colorless'], 60),
        ],
        name: FLAREON$4.name,
        pokemonImagePositionX: 54,
        pokemonImagePositionY: 41,
        pokemonImageSize: 56,
        pokemonImageUrl: FLAREON$4.images[0].value,
        pokemonLevel: 28,
        pokemonNumber: FLAREON$4.number,
        pokemonType: FLAREON$4.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 3,
        stage: FLAREON$4.stage,
        weight: 55,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/electrify-pikachu_monhqm.jpg',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'It accumulates negative ions from the atmosphere to blast out 10,000-volt lightning bolts.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: EEVEE$a.name,
        evolutionBoxImageUrl: EEVEE$a.images[0].value,
        hitPoints: 70,
        holo: true,
        holoStrength: 0.7,
        id: 'jungle_04_en',
        illustrator: ILLUSTRATORS.HIMENO,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [MOVES.QUICK_ATTACK, MOVES.PIN_MISSILE],
        name: JOLTEON$5.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 33,
        pokemonImageSize: 58,
        pokemonImageUrl: JOLTEON$5.images[0].value,
        pokemonLevel: 29,
        pokemonNumber: JOLTEON$5.number,
        pokemonType: JOLTEON$5.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 4,
        stage: JOLTEON$5.stage,
        weight: 54,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-pkmn-trader_soqbah.jpg',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: "The infant rarely ventures out of its mother's protective pouch until it is three years old.",
        energyResistance: ENERGY_TYPES.PSYCHIC,
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 90,
        holo: true,
        holoStrength: 0.7,
        id: 'jungle_05_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 7,
        lengthInches: 3,
        moves: [MOVES.FETCH, MOVES.COMET_PUNCH],
        name: KANGASKHAN$1.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 37,
        pokemonImageUrl: KANGASKHAN$1.images[0].value,
        pokemonLevel: 40,
        pokemonNumber: KANGASKHAN$1.number,
        pokemonType: KANGASKHAN$1.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 5,
        weight: 176,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lights-mr-mime_mccewf.jpg',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'If interrupted while miming, it will slap around the enemy with its broad hands.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 40,
        holo: true,
        holoStrength: 0.7,
        id: 'jungle_06_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 4,
        lengthInches: 3,
        moves: [
            MOVES.INVISIBLE_WALL,
            SHARED_MOVES(MR_MIME$2.name, 'meditate', ['psychic', 'colorless'], 10),
        ],
        name: MR_MIME$2.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 43,
        pokemonImageSize: 33,
        pokemonImageUrl: MR_MIME$2.images[0].value,
        pokemonLevel: 28,
        pokemonNumber: MR_MIME$2.number,
        pokemonType: MR_MIME$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 6,
        weight: 120,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-nidoqueen_sovd2b.jpg',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'Its hard scales provide strong protection. It uses its hefty bulk to execute powerful moves.',
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        evolvesFrom: NIDORINA$4.name,
        evolutionBoxImageUrl: NIDORINA$4.images[0].value,
        hitPoints: 90,
        holo: true,
        holoStrength: 0.7,
        id: 'jungle_07_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 4,
        lengthInches: 3,
        moves: [MOVES.BOYFRIENDS, MOVES.MEGA_PUNCH],
        name: NIDOQUEEN$2.name,
        pokemonImagePositionX: 53,
        pokemonImagePositionY: 43,
        pokemonImageSize: 40,
        pokemonImageUrl: NIDOQUEEN$2.images[0].value,
        pokemonLevel: 43,
        pokemonNumber: NIDOQUEEN$2.number,
        pokemonType: NIDOQUEEN$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 7,
        stage: NIDOQUEEN$2.stage,
        weight: 132,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lights-pichu_y9ivyq.jpg',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'When hunting, it skins the surface of water at high speed to pick off unwary prey such as Magikarp.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        evolvesFrom: PIDGEOTTO$3.name,
        evolutionBoxImageUrl: PIDGEOTTO$3.images[0].value,
        hitPoints: 80,
        holo: true,
        holoStrength: 0.7,
        illustrator: ILLUSTRATORS.HIMENO,
        id: 'jungle_08_en',
        lengthFeet: 4,
        lengthInches: 11,
        moves: [
            SHARED_MOVES('', 'wing-attack', ['colorless', 'colorless'], 20),
            MOVES.HURRICANE,
        ],
        name: PIDGEOT$3.name,
        pokemonImagePositionX: 43,
        pokemonImagePositionY: 46,
        pokemonImageSize: 57,
        pokemonImageUrl: PIDGEOT$3.images[0].value,
        pokemonLevel: 40,
        pokemonNumber: PIDGEOT$3.number,
        pokemonType: PIDGEOT$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 8,
        stage: PIDGEOT$3.stage,
        weight: 87,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-ekans_inxykw.jpg',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'If it fails to crush the victim in its pincers, it will swing its victim around and toss it hard.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        hitPoints: 60,
        holo: true,
        holoStrength: 0.7,
        id: 'jungle_09_en',
        illustrator: ILLUSTRATORS.HIMENO,
        lengthFeet: 4,
        lengthInches: 11,
        moves: [MOVES.IRONGRIP, MOVES.GUILLOTINE],
        name: PINSIR$2.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 45,
        pokemonImageSize: 42,
        pokemonImageUrl: PINSIR$2.images[0].value,
        pokemonLevel: 24,
        pokemonNumber: PINSIR$2.number,
        pokemonType: PINSIR$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 9,
        weight: 121,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-scyther_bffn5q.jpg',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'With ninja-like agility and speed, it can create the illusion that there is more than one of it.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        hitPoints: 70,
        holo: true,
        holoStrength: 0.7,
        id: 'jungle_10_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 4,
        lengthInches: 11,
        moves: [
            MOVES.SWORDS_DANCE,
            SHARED_MOVES(SCYTHER$6.name, 'slash', ['colorless', 'colorless', 'colorless'], 30),
        ],
        name: SCYTHER$6.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 40,
        pokemonImageUrl: SCYTHER$6.images[0].value,
        pokemonLevel: 14,
        pokemonNumber: SCYTHER$6.number,
        pokemonType: SCYTHER$6.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 10,
        weight: 123,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-pkmn-trader_soqbah.jpg',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'Very lazy. Just eats and sleeps. As its rotund bulk builds, it becomes steadily more slothful.',
        energyResistance: ENERGY_TYPES.PSYCHIC,
        energyRetreatCost: 4,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 90,
        holo: true,
        holoStrength: 0.7,
        id: 'jungle_11_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 6,
        lengthInches: 11,
        moves: [MOVES.THICK_SKINNED, MOVES.BODY_SLAM],
        name: SNORLAX$3.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 55,
        pokemonImageUrl: SNORLAX$3.images[0].value,
        pokemonLevel: 20,
        pokemonNumber: SNORLAX$3.number,
        pokemonType: SNORLAX$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 11,
        weight: 1014,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-pkmn-trader_soqbah.jpg',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: "Lives close to water. Its long tail is ridged with a fin that is often mistaken for a mermaid's.",
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        evolvesFrom: EEVEE$a.name,
        evolutionBoxImageUrl: EEVEE$a.images[0].value,
        hitPoints: 80,
        holo: true,
        holoStrength: 0.7,
        id: 'jungle_12_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [
            MOVES.QUICK_ATTACK,
            SHARED_MOVES(VAPOREON$3.name, 'water-gun', ['water', 'water', 'colorless'], 30),
        ],
        name: VAPOREON$3.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 36,
        pokemonImageShadowColor: '#fff',
        pokemonImageSize: 51,
        pokemonImageUrl: VAPOREON$3.images[0].value,
        pokemonLevel: 42,
        pokemonNumber: VAPOREON$3.number,
        pokemonType: VAPOREON$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 12,
        stage: VAPOREON$3.stage,
        weight: 64,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/flowers-venomoth_fujz4e.jpg',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'The dust-like scales covering its wings are color-coded to indicate the kinds of poison it has.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        evolvesFrom: VENONAT$4.name,
        evolutionBoxBackgroundImageSize: '60%',
        evolutionBoxImageUrl: VENONAT$4.images[0].value,
        hitPoints: 70,
        holo: true,
        holoStrength: 0.7,
        id: 'jungle_13_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 4,
        lengthInches: 11,
        moves: [MOVES.SHIFT, MOVES.VENOM_POWDER],
        name: VENOMOTH$4.name,
        pokemonImagePositionX: 53,
        pokemonImagePositionY: 45,
        pokemonImageSize: 42,
        pokemonImageUrl: VENOMOTH$4.images[0].value,
        pokemonLevel: 14,
        pokemonNumber: VENOMOTH$4.number,
        pokemonType: VENOMOTH$4.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 13,
        stage: VENOMOTH$4.stage,
        weight: 28,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-brocks-vulpix_cjhesd.jpg',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'Said to live in huge colonies deep in jungles, although no one has ever returned from there.',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        evolvesFrom: WEEPINBELL$2.name,
        evolutionBoxBackgroundImageSize: '80%',
        evolutionBoxImageUrl: WEEPINBELL$2.images[0].value,
        hitPoints: 80,
        holo: true,
        holoStrength: 0.7,
        id: 'jungle_14_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [SHARED_MOVES('Victreebel', 'lure', ['grass']), MOVES.ACID],
        name: VICTREEBEL$1.name,
        pokemonImagePositionX: 53,
        pokemonImagePositionY: 49,
        pokemonImageSize: 45,
        pokemonImageUrl: VICTREEBEL$1.images[0].value,
        pokemonLevel: 42,
        pokemonNumber: VICTREEBEL$1.number,
        pokemonType: VICTREEBEL$1.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 14,
        stage: VICTREEBEL$1.stage,
        weight: 34,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-ekans_inxykw.jpg',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'The larger its petals, the more toxic pollen it contains. Its big head is heavy and hard to hold up.',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        evolvesFrom: GLOOM$8.name,
        evolutionBoxImageUrl: GLOOM$8.images[0].value,
        hitPoints: 40,
        holo: true,
        holoStrength: 0.7,
        id: 'jungle_15_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [MOVES.HEAL, MOVES.PETAL_DANCE],
        name: VILEPLUME$4.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 50,
        pokemonImageSize: 38,
        pokemonImageUrl: VILEPLUME$4.images[0].value,
        pokemonLevel: 35,
        pokemonNumber: VILEPLUME$4.number,
        pokemonType: VILEPLUME$4.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 15,
        stage: VILEPLUME$4.stage,
        weight: 41,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-pkmn-trader_soqbah.jpg',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'The body is soft and rubbery. When angered, it will suck in air and inflate itself to an enormous size.',
        energyResistance: ENERGY_TYPES.PSYCHIC,
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: JIGGLYPUFF$7.name,
        evolutionBoxBackgroundImageSize: '60%',
        evolutionBoxImageUrl: JIGGLYPUFF$7.images[0].value,
        hitPoints: 80,
        holo: true,
        holoStrength: 0.7,
        id: 'jungle_16_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [MOVES.LULLABY, MOVES.DO_THE_WAVE],
        name: WIGGLYTUFF$3.name,
        pokemonImagePositionX: 54,
        pokemonImagePositionY: 43,
        pokemonImageSize: 40,
        pokemonImageUrl: WIGGLYTUFF$3.images[0].value,
        pokemonLevel: 36,
        pokemonNumber: WIGGLYTUFF$3.number,
        pokemonType: WIGGLYTUFF$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 16,
        stage: WIGGLYTUFF$3.stage,
        weight: 26,
    },
];

const BASE_SET_TWO_HOLOS = [
    {
        ...BASE_SET_HOLOS[0],
        id: 'base_two_001_en',
        setNumber: 1,
    },
    {
        ...BASE_SET_HOLOS[1],
        id: 'base_two_002_en',
        setNumber: 2,
    },
    {
        ...BASE_SET_HOLOS[2],
        id: 'base_two_003_en',
        setNumber: 3,
    },
    {
        ...BASE_SET_HOLOS[3],
        id: 'base_two_004_en',
        setNumber: 4,
    },
    {
        ...JUNGLE_HOLOS[0],
        id: 'base_two_005_en',
        setNumber: 5,
    },
    {
        ...BASE_SET_HOLOS[4],
        id: 'base_two_006_en',
        setNumber: 6,
    },
    {
        ...BASE_SET_HOLOS[5],
        id: 'base_two_007_en',
        setNumber: 7,
    },
    {
        ...BASE_SET_HOLOS[6],
        id: 'base_two_008_en',
        setNumber: 8,
    },
    {
        ...BASE_SET_HOLOS[8],
        id: 'base_two_009_en',
        setNumber: 9,
    },
    {
        ...BASE_SET_HOLOS[9],
        id: 'base_two_010_en',
        setNumber: 10,
    },
    {
        ...BASE_SET_HOLOS[10],
        id: 'base_two_011_en',
        setNumber: 11,
    },
    {
        ...JUNGLE_HOLOS[6],
        id: 'base_two_012_en',
        setNumber: 12,
    },
    {
        ...BASE_SET_HOLOS[11],
        id: 'base_two_013_en',
        setNumber: 13,
    },
    {
        ...JUNGLE_HOLOS[7],
        id: 'base_two_014_en',
        setNumber: 14,
    },
    {
        ...BASE_SET_HOLOS[12],
        id: 'base_two_015_en',
        setNumber: 15,
    },
    {
        ...BASE_SET_HOLOS[13],
        id: 'base_two_016_en',
        setNumber: 16,
    },
    {
        ...JUNGLE_HOLOS[9],
        id: 'base_two_017_en',
        setNumber: 17,
    },
    {
        ...BASE_SET_HOLOS[14],
        id: 'base_two_018_en',
        setNumber: 18,
    },
    {
        ...JUNGLE_HOLOS[15],
        id: 'base_two_019_en',
        setNumber: 19,
    },
    {
        ...BASE_SET_HOLOS[15],
        id: 'base_two_020_en',
        setNumber: 20,
    },
];

const JUNGLE_FOSSIL_TRAINERS = {
    ENERGY_SEARCH: {
        name: 'Energy Search',
        image: '',
    },
    GAMBLER: {
        name: 'Gambler',
        image: '',
    },
    MR_FUJI: {
        name: 'Mr. Fuji',
        image: '',
    },
    MYSTERIOUS_FOSSIL: {
        name: 'Mysterious Fossil',
        image: 'https://poketcgshop.s3.amazonaws.com/pokemon-images/mysterious-fossil/mysterious-fossil-evo-box_ojm1hf.png',
    },
    POKE_BALL: {
        name: 'Poké Ball',
        image: 'https://poketcgshop.s3.amazonaws.com/trainer-card-images/poke-ball.jpg',
    },
    RECYCLE: {
        name: 'Recycle',
        image: '',
    },
};

const { BELLSPROUT: BELLSPROUT$2, BUTTERFREE: BUTTERFREE$4, CUBONE: CUBONE$1, DODRIO: DODRIO$2, DODUO: DODUO$1, EEVEE: EEVEE$9, EXEGGCUTE: EXEGGCUTE$2, EXEGGUTOR: EXEGGUTOR$4, FEAROW: FEAROW$3, GLOOM: GLOOM$7, GOLDEEN: GOLDEEN$3, JIGGLYPUFF: JIGGLYPUFF$6, LICKITUNG: LICKITUNG$3, MANKEY: MANKEY$3, MAROWAK: MAROWAK$1, MEOWTH: MEOWTH$6, METAPOD: METAPOD$3, NIDORAN_F: NIDORAN_F$2, NIDORINA: NIDORINA$3, ODDISH: ODDISH$5, PARAS: PARAS$2, PARASECT: PARASECT$1, PERSIAN: PERSIAN$5, PIKACHU: PIKACHU$c, PONYTA: PONYTA$6, PRIMEAPE: PRIMEAPE$4, RAPIDASH: RAPIDASH$5, RHYDON: RHYDON$3, RHYHORN: RHYHORN$5, SEAKING: SEAKING$2, SPEAROW: SPEAROW$4, TAUROS: TAUROS$3, VENONAT: VENONAT$3, WEEPINBELL: WEEPINBELL$1, } = GEN_1_POKEMON;
const { POKE_BALL } = JUNGLE_FOSSIL_TRAINERS;
const JUNGLE_NON_HOLOS = [
    {
        ...JUNGLE_HOLOS[0],
        holo: false,
        id: 'jungle_17_en',
        setNumber: 17,
    },
    {
        ...JUNGLE_HOLOS[1],
        holo: false,
        id: 'jungle_18_en',
        setNumber: 18,
    },
    {
        ...JUNGLE_HOLOS[2],
        holo: false,
        id: 'jungle_19_en',
        setNumber: 19,
    },
    {
        ...JUNGLE_HOLOS[3],
        holo: false,
        id: 'jungle_20_en',
        setNumber: 20,
    },
    {
        ...JUNGLE_HOLOS[4],
        holo: false,
        id: 'jungle_21_en',
        setNumber: 21,
    },
    {
        ...JUNGLE_HOLOS[5],
        holo: false,
        id: 'jungle_22_en',
        setNumber: 22,
    },
    {
        ...JUNGLE_HOLOS[6],
        holo: false,
        id: 'jungle_23_en',
        setNumber: 23,
    },
    {
        ...JUNGLE_HOLOS[7],
        holo: false,
        id: 'jungle_24_en',
        setNumber: 24,
    },
    {
        ...JUNGLE_HOLOS[8],
        holo: false,
        id: 'jungle_25_en',
        setNumber: 25,
    },
    {
        ...JUNGLE_HOLOS[9],
        holo: false,
        id: 'jungle_26_en',
        setNumber: 26,
    },
    {
        ...JUNGLE_HOLOS[10],
        holo: false,
        id: 'jungle_27_en',
        setNumber: 27,
    },
    {
        ...JUNGLE_HOLOS[11],
        holo: false,
        id: 'jungle_28_en',
        setNumber: 28,
    },
    {
        ...JUNGLE_HOLOS[12],
        holo: false,
        id: 'jungle_29_en',
        setNumber: 29,
    },
    {
        ...JUNGLE_HOLOS[13],
        holo: false,
        id: 'jungle_30_en',
        setNumber: 30,
    },
    {
        ...JUNGLE_HOLOS[14],
        holo: false,
        id: 'jungle_31_en',
        setNumber: 31,
    },
    {
        ...JUNGLE_HOLOS[15],
        holo: false,
        id: 'jungle_32_en',
        setNumber: 32,
    },
    {
        backgroundImageUrl: BUTTERFREE$4.images[0].value,
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        evolvesFrom: METAPOD$3.name,
        evolutionBoxImageUrl: METAPOD$3.images[0].value,
        hitPoints: 80,
        illustrator: ILLUSTRATORS.HIMENO,
        id: 'jungle_33_en',
        lengthFeet: 4,
        lengthInches: 11,
        moves: [],
        name: BUTTERFREE$4.name,
        pokemonImagePositionX: 43,
        pokemonImagePositionY: 46,
        pokemonImageSize: 57,
        pokemonLevel: 40,
        pokemonNumber: BUTTERFREE$4.number,
        pokemonType: BUTTERFREE$4.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 33,
        stage: BUTTERFREE$4.stage,
        weight: 87,
    },
    {
        backgroundImageUrl: DODRIO$2.images[0].value,
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        evolvesFrom: DODUO$1.name,
        evolutionBoxImageUrl: DODUO$1.images[0].value,
        hitPoints: 80,
        illustrator: ILLUSTRATORS.HIMENO,
        id: 'jungle_34_en',
        lengthFeet: 4,
        lengthInches: 11,
        moves: [],
        name: DODRIO$2.name,
        pokemonImagePositionX: 43,
        pokemonImagePositionY: 46,
        pokemonImageSize: 57,
        pokemonLevel: 40,
        pokemonNumber: DODRIO$2.number,
        pokemonType: DODRIO$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 34,
        stage: DODRIO$2.stage,
        weight: 87,
    },
    {
        backgroundImageUrl: EXEGGUTOR$4.images[0].value,
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        evolvesFrom: EXEGGCUTE$2.name,
        evolutionBoxImageUrl: EXEGGCUTE$2.images[0].value,
        hitPoints: 80,
        illustrator: ILLUSTRATORS.HIMENO,
        id: 'jungle_35_en',
        lengthFeet: 4,
        lengthInches: 11,
        moves: [],
        name: EXEGGUTOR$4.name,
        pokemonImagePositionX: 43,
        pokemonImagePositionY: 46,
        pokemonImageSize: 57,
        pokemonLevel: 40,
        pokemonNumber: EXEGGUTOR$4.number,
        pokemonType: EXEGGUTOR$4.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 35,
        stage: EXEGGUTOR$4.stage,
        weight: 87,
    },
    {
        backgroundImageUrl: FEAROW$3.images[0].value,
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        evolvesFrom: SPEAROW$4.name,
        evolutionBoxImageUrl: SPEAROW$4.images[0].value,
        hitPoints: 80,
        illustrator: ILLUSTRATORS.HIMENO,
        id: 'jungle_36_en',
        lengthFeet: 4,
        lengthInches: 11,
        moves: [],
        name: FEAROW$3.name,
        pokemonImagePositionX: 43,
        pokemonImagePositionY: 46,
        pokemonImageSize: 57,
        pokemonLevel: 40,
        pokemonNumber: FEAROW$3.number,
        pokemonType: FEAROW$3.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 36,
        stage: FEAROW$3.stage,
        weight: 87,
    },
    {
        backgroundImageUrl: GLOOM$7.images[1].value,
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        evolvesFrom: ODDISH$5.name,
        evolutionBoxImageUrl: ODDISH$5.images[0].value,
        hitPoints: 80,
        illustrator: ILLUSTRATORS.HIMENO,
        id: 'jungle_37_en',
        lengthFeet: 4,
        lengthInches: 11,
        moves: [],
        name: GLOOM$7.name,
        pokemonImagePositionX: 43,
        pokemonImagePositionY: 46,
        pokemonImageSize: 57,
        pokemonLevel: 40,
        pokemonNumber: GLOOM$7.number,
        pokemonType: GLOOM$7.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 37,
        stage: GLOOM$7.stage,
        weight: 87,
    },
    {
        backgroundImageUrl: LICKITUNG$3.images[0].value,
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 80,
        illustrator: ILLUSTRATORS.HIMENO,
        id: 'jungle_38_en',
        lengthFeet: 4,
        lengthInches: 11,
        moves: [],
        name: LICKITUNG$3.name,
        pokemonImagePositionX: 43,
        pokemonImagePositionY: 46,
        pokemonImageSize: 57,
        pokemonLevel: 40,
        pokemonNumber: LICKITUNG$3.number,
        pokemonType: LICKITUNG$3.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 38,
        weight: 87,
    },
    {
        backgroundImageUrl: MAROWAK$1.images[0].value,
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        evolvesFrom: CUBONE$1.name,
        evolutionBoxImageUrl: CUBONE$1.images[0].value,
        hitPoints: 80,
        illustrator: ILLUSTRATORS.HIMENO,
        id: 'jungle_39_en',
        lengthFeet: 4,
        lengthInches: 11,
        moves: [],
        name: MAROWAK$1.name,
        pokemonImagePositionX: 43,
        pokemonImagePositionY: 46,
        pokemonImageSize: 57,
        pokemonLevel: 40,
        pokemonNumber: MAROWAK$1.number,
        pokemonType: MAROWAK$1.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 39,
        stage: MAROWAK$1.stage,
        weight: 87,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        evolvesFrom: NIDORAN_F$2.name,
        evolutionBoxImageUrl: NIDORAN_F$2.images[0].value,
        hitPoints: 80,
        illustrator: ILLUSTRATORS.HIMENO,
        id: 'jungle_40_en',
        lengthFeet: 4,
        lengthInches: 11,
        moves: [],
        name: NIDORINA$3.name,
        pokemonImagePositionX: 43,
        pokemonImagePositionY: 46,
        pokemonImageSize: 57,
        pokemonImageUrl: NIDORINA$3.images[0].value,
        pokemonLevel: 40,
        pokemonNumber: NIDORINA$3.number,
        pokemonType: NIDORINA$3.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 40,
        stage: NIDORINA$3.stage,
        weight: 87,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        evolvesFrom: PARAS$2.name,
        evolutionBoxImageUrl: PARAS$2.images[0].value,
        hitPoints: 80,
        illustrator: ILLUSTRATORS.HIMENO,
        id: 'jungle_41_en',
        lengthFeet: 4,
        lengthInches: 11,
        moves: [],
        name: PARASECT$1.name,
        pokemonImagePositionX: 43,
        pokemonImagePositionY: 46,
        pokemonImageSize: 57,
        pokemonImageUrl: PARASECT$1.images[0].value,
        pokemonLevel: 40,
        pokemonNumber: PARASECT$1.number,
        pokemonType: PARASECT$1.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 41,
        stage: PARASECT$1.stage,
        weight: 87,
    },
    {
        backgroundImageUrl: PERSIAN$5.images[0].value,
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        evolvesFrom: MEOWTH$6.name,
        evolutionBoxImageUrl: MEOWTH$6.images[0].value,
        hitPoints: 80,
        illustrator: ILLUSTRATORS.HIMENO,
        id: 'jungle_42_en',
        lengthFeet: 4,
        lengthInches: 11,
        moves: [],
        name: PERSIAN$5.name,
        pokemonImagePositionX: 43,
        pokemonImagePositionY: 46,
        pokemonImageSize: 57,
        pokemonLevel: 40,
        pokemonNumber: PERSIAN$5.number,
        pokemonType: PERSIAN$5.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 42,
        stage: PERSIAN$5.stage,
        weight: 87,
    },
    {
        backgroundImageUrl: PRIMEAPE$4.images[0].value,
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        evolvesFrom: MANKEY$3.name,
        evolutionBoxImageUrl: MANKEY$3.images[0].value,
        hitPoints: 80,
        illustrator: ILLUSTRATORS.HIMENO,
        id: 'jungle_43_en',
        lengthFeet: 4,
        lengthInches: 11,
        moves: [],
        name: PRIMEAPE$4.name,
        pokemonImagePositionX: 43,
        pokemonImagePositionY: 46,
        pokemonImageSize: 57,
        pokemonLevel: 40,
        pokemonNumber: PRIMEAPE$4.number,
        pokemonType: PRIMEAPE$4.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 43,
        stage: PRIMEAPE$4.stage,
        weight: 87,
    },
    {
        backgroundImageUrl: RAPIDASH$5.images[0].value,
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        evolvesFrom: PONYTA$6.name,
        evolutionBoxImageUrl: PONYTA$6.images[0].value,
        hitPoints: 80,
        illustrator: ILLUSTRATORS.HIMENO,
        id: 'jungle_44_en',
        lengthFeet: 4,
        lengthInches: 11,
        moves: [],
        name: RAPIDASH$5.name,
        pokemonImagePositionX: 43,
        pokemonImagePositionY: 46,
        pokemonImageSize: 57,
        pokemonLevel: 40,
        pokemonNumber: RAPIDASH$5.number,
        pokemonType: RAPIDASH$5.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 44,
        stage: RAPIDASH$5.stage,
        weight: 87,
    },
    {
        backgroundImageUrl: RHYDON$3.images[0].value,
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        evolvesFrom: RHYHORN$5.name,
        evolutionBoxImageUrl: RHYHORN$5.images[0].value,
        hitPoints: 80,
        illustrator: ILLUSTRATORS.HIMENO,
        id: 'jungle_45_en',
        lengthFeet: 4,
        lengthInches: 11,
        moves: [],
        name: RHYDON$3.name,
        pokemonImagePositionX: 43,
        pokemonImagePositionY: 46,
        pokemonImageSize: 57,
        pokemonLevel: 40,
        pokemonNumber: RHYDON$3.number,
        pokemonType: RHYDON$3.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 45,
        stage: RHYDON$3.stage,
        weight: 87,
    },
    {
        backgroundImageUrl: SEAKING$2.images[0].value,
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        evolvesFrom: GOLDEEN$3.name,
        evolutionBoxImageUrl: GOLDEEN$3.images[0].value,
        hitPoints: 80,
        illustrator: ILLUSTRATORS.HIMENO,
        id: 'jungle_46_en',
        lengthFeet: 4,
        lengthInches: 11,
        moves: [],
        name: SEAKING$2.name,
        pokemonImagePositionX: 43,
        pokemonImagePositionY: 46,
        pokemonImageSize: 57,
        pokemonLevel: 40,
        pokemonNumber: SEAKING$2.number,
        pokemonType: SEAKING$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 46,
        stage: SEAKING$2.stage,
        weight: 87,
    },
    {
        backgroundImageUrl: TAUROS$3.images[0].value,
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 80,
        illustrator: ILLUSTRATORS.HIMENO,
        id: 'jungle_47_en',
        lengthFeet: 4,
        lengthInches: 11,
        moves: [],
        name: TAUROS$3.name,
        pokemonImagePositionX: 43,
        pokemonImagePositionY: 46,
        pokemonImageSize: 57,
        pokemonLevel: 40,
        pokemonNumber: TAUROS$3.number,
        pokemonType: TAUROS$3.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 47,
        weight: 87,
    },
    {
        backgroundImageUrl: WEEPINBELL$1.images[1].value,
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        evolvesFrom: BELLSPROUT$2.name,
        evolutionBoxImageUrl: BELLSPROUT$2.images[0].value,
        hitPoints: 80,
        illustrator: ILLUSTRATORS.HIMENO,
        id: 'jungle_48_en',
        lengthFeet: 4,
        lengthInches: 11,
        moves: [],
        name: WEEPINBELL$1.name,
        pokemonImagePositionX: 43,
        pokemonImagePositionY: 46,
        pokemonImageSize: 57,
        pokemonLevel: 40,
        pokemonNumber: WEEPINBELL$1.number,
        pokemonType: WEEPINBELL$1.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 48,
        stage: WEEPINBELL$1.stage,
        weight: 87,
    },
    {
        backgroundImageUrl: BELLSPROUT$2.images[1].value,
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 80,
        illustrator: ILLUSTRATORS.HIMENO,
        id: 'jungle_49_en',
        lengthFeet: 4,
        lengthInches: 11,
        moves: [],
        name: BELLSPROUT$2.name,
        pokemonImagePositionX: 43,
        pokemonImagePositionY: 46,
        pokemonImageSize: 57,
        pokemonLevel: 40,
        pokemonNumber: BELLSPROUT$2.number,
        pokemonType: BELLSPROUT$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 49,
        weight: 87,
    },
    {
        backgroundImageUrl: CUBONE$1.images[1].value,
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 80,
        illustrator: ILLUSTRATORS.HIMENO,
        id: 'jungle_50_en',
        lengthFeet: 4,
        lengthInches: 11,
        moves: [],
        name: CUBONE$1.name,
        pokemonImagePositionX: 43,
        pokemonImagePositionY: 46,
        pokemonImageSize: 57,
        pokemonLevel: 40,
        pokemonNumber: CUBONE$1.number,
        pokemonType: CUBONE$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 50,
        weight: 87,
    },
    {
        backgroundImageUrl: EEVEE$9.images[1].value,
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 80,
        illustrator: ILLUSTRATORS.HIMENO,
        id: 'jungle_51_en',
        lengthFeet: 4,
        lengthInches: 11,
        moves: [],
        name: EEVEE$9.name,
        pokemonImagePositionX: 43,
        pokemonImagePositionY: 46,
        pokemonImageSize: 57,
        pokemonLevel: 40,
        pokemonNumber: EEVEE$9.number,
        pokemonType: EEVEE$9.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 51,
        weight: 87,
    },
    {
        backgroundImageUrl: EXEGGCUTE$2.images[1].value,
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 80,
        illustrator: ILLUSTRATORS.HIMENO,
        id: 'jungle_52_en',
        lengthFeet: 4,
        lengthInches: 11,
        moves: [],
        name: EXEGGCUTE$2.name,
        pokemonImagePositionX: 43,
        pokemonImagePositionY: 46,
        pokemonImageSize: 57,
        pokemonLevel: 40,
        pokemonNumber: EXEGGCUTE$2.number,
        pokemonType: EXEGGCUTE$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 52,
        weight: 87,
    },
    {
        backgroundImageUrl: GOLDEEN$3.images[1].value,
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 80,
        illustrator: ILLUSTRATORS.HIMENO,
        id: 'jungle_53_en',
        lengthFeet: 4,
        lengthInches: 11,
        moves: [],
        name: GOLDEEN$3.name,
        pokemonImagePositionX: 43,
        pokemonImagePositionY: 46,
        pokemonImageSize: 57,
        pokemonLevel: 40,
        pokemonNumber: GOLDEEN$3.number,
        pokemonType: GOLDEEN$3.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 53,
        weight: 87,
    },
    {
        backgroundImageUrl: JIGGLYPUFF$6.images[1].value,
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 80,
        illustrator: ILLUSTRATORS.HIMENO,
        id: 'jungle_54_en',
        lengthFeet: 4,
        lengthInches: 11,
        moves: [],
        name: JIGGLYPUFF$6.name,
        pokemonImagePositionX: 43,
        pokemonImagePositionY: 46,
        pokemonImageSize: 57,
        pokemonLevel: 40,
        pokemonNumber: JIGGLYPUFF$6.number,
        pokemonType: JIGGLYPUFF$6.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 54,
        weight: 87,
    },
    {
        backgroundImageUrl: MANKEY$3.images[1].value,
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 80,
        illustrator: ILLUSTRATORS.HIMENO,
        id: 'jungle_55_en',
        lengthFeet: 4,
        lengthInches: 11,
        moves: [],
        name: MANKEY$3.name,
        pokemonImagePositionX: 43,
        pokemonImagePositionY: 46,
        pokemonImageSize: 57,
        pokemonLevel: 40,
        pokemonNumber: MANKEY$3.number,
        pokemonType: MANKEY$3.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 55,
        weight: 87,
    },
    {
        backgroundImageUrl: MEOWTH$6.images[1].value,
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 80,
        illustrator: ILLUSTRATORS.HIMENO,
        id: 'jungle_56_en',
        lengthFeet: 4,
        lengthInches: 11,
        moves: [],
        name: MEOWTH$6.name,
        pokemonImagePositionX: 43,
        pokemonImagePositionY: 46,
        pokemonImageSize: 57,
        pokemonLevel: 40,
        pokemonNumber: MEOWTH$6.number,
        pokemonType: MEOWTH$6.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 56,
        weight: 87,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 80,
        illustrator: ILLUSTRATORS.HIMENO,
        id: 'jungle_57_en',
        lengthFeet: 4,
        lengthInches: 11,
        moves: [],
        name: NIDORAN_F$2.name,
        pokemonImagePositionX: 43,
        pokemonImagePositionY: 46,
        pokemonImageSize: 57,
        pokemonImageUrl: NIDORAN_F$2.images[0].value,
        pokemonLevel: 40,
        pokemonNumber: NIDORAN_F$2.number,
        pokemonType: NIDORAN_F$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 57,
        weight: 87,
    },
    {
        backgroundImageUrl: ODDISH$5.images[1].value,
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 80,
        illustrator: ILLUSTRATORS.HIMENO,
        id: 'jungle_58_en',
        lengthFeet: 4,
        lengthInches: 11,
        moves: [],
        name: ODDISH$5.name,
        pokemonImagePositionX: 43,
        pokemonImagePositionY: 46,
        pokemonImageSize: 57,
        pokemonLevel: 40,
        pokemonNumber: ODDISH$5.number,
        pokemonType: ODDISH$5.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 58,
        weight: 87,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 80,
        illustrator: ILLUSTRATORS.HIMENO,
        id: 'jungle_59_en',
        lengthFeet: 4,
        lengthInches: 11,
        moves: [],
        name: PARAS$2.name,
        pokemonImagePositionX: 43,
        pokemonImagePositionY: 46,
        pokemonImageSize: 57,
        pokemonImageUrl: PARAS$2.images[0].value,
        pokemonLevel: 40,
        pokemonNumber: PARAS$2.number,
        pokemonType: PARAS$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 59,
        weight: 87,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 80,
        illustrator: ILLUSTRATORS.HIMENO,
        id: 'jungle_60_en',
        lengthFeet: 4,
        lengthInches: 11,
        moves: [],
        name: PIKACHU$c.name,
        pokemonImagePositionX: 43,
        pokemonImagePositionY: 46,
        pokemonImageSize: 57,
        pokemonImageUrl: PIKACHU$c.images[0].value,
        pokemonLevel: 40,
        pokemonNumber: PIKACHU$c.number,
        pokemonType: PIKACHU$c.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 60,
        weight: 87,
    },
    {
        backgroundImageUrl: RHYHORN$5.images[1].value,
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 80,
        illustrator: ILLUSTRATORS.HIMENO,
        id: 'jungle_61_en',
        lengthFeet: 4,
        lengthInches: 11,
        moves: [],
        name: RHYHORN$5.name,
        pokemonImagePositionX: 43,
        pokemonImagePositionY: 46,
        pokemonImageSize: 57,
        pokemonLevel: 40,
        pokemonNumber: RHYHORN$5.number,
        pokemonType: RHYHORN$5.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 61,
        weight: 87,
    },
    {
        backgroundImageUrl: SPEAROW$4.images[1].value,
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 80,
        illustrator: ILLUSTRATORS.HIMENO,
        id: 'jungle_62_en',
        lengthFeet: 4,
        lengthInches: 11,
        moves: [],
        name: SPEAROW$4.name,
        pokemonImagePositionX: 43,
        pokemonImagePositionY: 46,
        pokemonImageSize: 57,
        pokemonLevel: 40,
        pokemonNumber: SPEAROW$4.number,
        pokemonType: SPEAROW$4.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 62,
        weight: 87,
    },
    {
        backgroundImageUrl: VENONAT$3.images[1].value,
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 80,
        illustrator: ILLUSTRATORS.HIMENO,
        id: 'jungle_63_en',
        lengthFeet: 4,
        lengthInches: 11,
        moves: [],
        name: VENONAT$3.name,
        pokemonImagePositionX: 43,
        pokemonImagePositionY: 46,
        pokemonImageSize: 57,
        pokemonLevel: 40,
        pokemonNumber: VENONAT$3.number,
        pokemonType: VENONAT$3.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 63,
        weight: 87,
    },
    {
        backgroundImageUrl: POKE_BALL.image,
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'jungle_64_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        name: POKE_BALL.name,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 64,
    },
];

const JUNGLE_SET_THEME_DECKS = [
    {
        id: 'water-blast',
        name: 'Water Blast',
        energyTypes: ['water', 'fighting'],
        cards: [
            {
                id: 'jungle_12_en',
                count: 1,
            },
            {
                id: 'jungle_61_en',
                count: 3,
            },
            {
                id: 'jungle_56_en',
                count: 4,
            },
            {
                id: 'jungle_51_en',
                count: 4,
            },
            {
                id: 'jungle_45_en',
                count: 1,
            },
            {
                id: 'jungle_42_en',
                count: 2,
            },
            {
                id: 'base_059_en',
                count: 4,
                setId: BASE_SET.id,
            },
            {
                id: 'base_052_en',
                count: 2,
                setId: BASE_SET.id,
            },
            {
                id: 'base_041_en',
                count: 1,
                setId: BASE_SET.id,
            },
            {
                id: 'base_038_en',
                count: 2,
                setId: BASE_SET.id,
            },
            {
                id: 'base_095_en',
                count: 1,
                setId: BASE_SET.id,
            },
            {
                id: 'base_094_en',
                count: 2,
                setId: BASE_SET.id,
            },
            {
                id: 'base_093_en',
                count: 2,
                setId: BASE_SET.id,
            },
            {
                id: 'base_090_en',
                count: 2,
                setId: BASE_SET.id,
            },
            {
                id: 'base_088_en',
                count: 1,
                setId: BASE_SET.id,
            },
            {
                id: 'base_102_en',
                count: 14,
                setId: BASE_SET.id,
            },
            {
                id: 'base_097_en',
                count: 14,
                setId: BASE_SET.id,
            },
        ],
    },
    {
        id: 'power-reserve',
        name: 'Power Reserve',
        energyTypes: ['psychic', 'grass'],
        cards: [
            {
                id: 'jungle_05_en',
                count: 1,
            },
            {
                id: 'jungle_58_en',
                count: 2,
            },
            {
                id: 'jungle_57_en',
                count: 4,
            },
            {
                id: 'jungle_49_en',
                count: 4,
            },
            {
                id: 'jungle_48_en',
                count: 2,
            },
            {
                id: 'jungle_40_en',
                count: 2,
            },
            {
                id: 'jungle_37_en',
                count: 1,
            },
            {
                id: 'base_043_en',
                count: 4,
                setId: BASE_SET.id,
            },
            {
                id: 'base_032_en',
                count: 2,
                setId: BASE_SET.id,
            },
            {
                id: 'base_031_en',
                count: 1,
                setId: BASE_SET.id,
            },
            {
                id: 'base_095_en',
                count: 1,
                setId: BASE_SET.id,
            },
            {
                id: 'base_094_en',
                count: 3,
                setId: BASE_SET.id,
            },
            {
                id: 'base_093_en',
                count: 2,
                setId: BASE_SET.id,
            },
            {
                id: 'base_091_en',
                count: 2,
                setId: BASE_SET.id,
            },
            {
                id: 'base_087_en',
                count: 1,
                setId: BASE_SET.id,
            },
            {
                id: 'base_101_en',
                count: 11,
                setId: BASE_SET.id,
            },
            {
                id: 'base_099_en',
                count: 17,
                setId: BASE_SET.id,
            },
        ],
    },
];

const setId$g = CARD_SETS.JUNGLE.value;
const setName$g = CARD_SETS.JUNGLE.label;
const setTotal$d = JUNGLE_SET_TOTAL;
const JUNGLE_SET = {
    cardCounts: {
        holoRares: 16,
        rares: 16,
        uncommons: 16,
        commons: 16,
    },
    copyright: COPYRIGHTS.JUNGLE_SET,
    description: SET_DESCRIPTIONS.JUNGLE,
    holoSheetType: CARD_HOLO_SHEETS.STARS,
    id: setId$g,
    imageUrl: 'https://cdn.shopify.com/s/files/1/0840/1659/5249/collections/jungle-cat-bg.jpg',
    name: setName$g,
    packInfo: BOOSTER_PACKS.JUNGLE,
    releaseDate: RELEASE_DATES.JUNGLE,
    setSymbol: setId$g,
    setTotal: setTotal$d,
    cards: [...JUNGLE_HOLOS, ...JUNGLE_NON_HOLOS],
    themeDecks: JUNGLE_SET_THEME_DECKS,
};

const BASE_SET_TWO_NON_HOLOS = [
    {
        ...BASE_SET.cards[16],
        id: 'base_two_021_en',
        setNumber: 21,
    },
    {
        ...BASE_SET.cards[17],
        id: 'base_two_022_en',
        setNumber: 22,
    },
    {
        ...BASE_SET.cards[18],
        id: 'base_two_023_en',
        setNumber: 23,
    },
    {
        ...BASE_SET.cards[19],
        id: 'base_two_024_en',
        setNumber: 24,
    },
    {
        ...BASE_SET.cards[20],
        id: 'base_two_025_en',
        setNumber: 25,
    },
    {
        ...JUNGLE_SET.cards[20],
        id: 'base_two_026_en',
        setNumber: 26,
    },
    {
        ...JUNGLE_SET.cards[21],
        id: 'base_two_027_en',
        setNumber: 27,
    },
    {
        ...BASE_SET.cards[21],
        id: 'base_two_028_en',
        setNumber: 28,
    },
    {
        ...JUNGLE_SET.cards[24],
        id: 'base_two_029_en',
        setNumber: 29,
    },
    {
        ...JUNGLE_SET.cards[26],
        id: 'base_two_030_en',
        setNumber: 30,
    },
    {
        ...JUNGLE_SET.cards[28],
        id: 'base_two_031_en',
        setNumber: 31,
    },
    {
        ...JUNGLE_SET.cards[29],
        id: 'base_two_032_en',
        setNumber: 32,
    },
    {
        ...BASE_SET.cards[22],
        id: 'base_two_033_en',
        setNumber: 33,
    },
    {
        ...JUNGLE_SET.cards[32],
        id: 'base_two_034_en',
        setNumber: 34,
    },
    {
        ...BASE_SET.cards[23],
        id: 'base_two_035_en',
        setNumber: 35,
    },
    {
        ...BASE_SET.cards[24],
        id: 'base_two_036_en',
        setNumber: 36,
    },
    {
        ...JUNGLE_SET.cards[33],
        id: 'base_two_037_en',
        setNumber: 37,
    },
    {
        ...BASE_SET.cards[25],
        id: 'base_two_038_en',
        setNumber: 38,
    },
    {
        ...JUNGLE_SET.cards[34],
        id: 'base_two_039_en',
        setNumber: 39,
    },
    {
        ...BASE_SET.cards[26],
        id: 'base_two_040_en',
        setNumber: 40,
    },
    {
        ...JUNGLE_SET.cards[35],
        id: 'base_two_041_en',
        setNumber: 41,
    },
    {
        ...BASE_SET.cards[27],
        id: 'base_two_042_en',
        setNumber: 42,
    },
    {
        ...BASE_SET.cards[28],
        id: 'base_two_043_en',
        setNumber: 43,
    },
    {
        ...BASE_SET.cards[29],
        id: 'base_two_044_en',
        setNumber: 44,
    },
    {
        ...BASE_SET.cards[30],
        id: 'base_two_045_en',
        setNumber: 45,
    },
    {
        ...BASE_SET.cards[31],
        id: 'base_two_046_en',
        setNumber: 46,
    },
    {
        ...BASE_SET.cards[32],
        id: 'base_two_047_en',
        setNumber: 47,
    },
    {
        ...JUNGLE_SET.cards[37],
        id: 'base_two_048_en',
        setNumber: 48,
    },
    {
        ...BASE_SET.cards[33],
        id: 'base_two_049_en',
        setNumber: 49,
    },
    {
        ...BASE_SET.cards[34],
        id: 'base_two_050_en',
        setNumber: 50,
    },
    {
        ...BASE_SET.cards[35],
        id: 'base_two_051_en',
        setNumber: 51,
    },
    {
        ...JUNGLE_SET.cards[38],
        id: 'base_two_052_en',
        setNumber: 52,
    },
    {
        ...JUNGLE_SET.cards[39],
        id: 'base_two_053_en',
        setNumber: 53,
    },
    {
        ...BASE_SET.cards[36],
        id: 'base_two_054_en',
        setNumber: 54,
    },
    {
        ...JUNGLE_SET.cards[40],
        id: 'base_two_055_en',
        setNumber: 55,
    },
    {
        ...JUNGLE_SET.cards[41],
        id: 'base_two_056_en',
        setNumber: 56,
    },
    {
        ...BASE_SET.cards[37],
        id: 'base_two_057_en',
        setNumber: 57,
    },
    {
        ...BASE_SET.cards[39],
        id: 'base_two_058_en',
        setNumber: 58,
    },
    {
        ...JUNGLE_SET.cards[44],
        id: 'base_two_059_en',
        setNumber: 59,
    },
    {
        ...JUNGLE_SET.cards[45],
        id: 'base_two_060_en',
        setNumber: 60,
    },
    {
        ...BASE_SET.cards[40],
        id: 'base_two_061_en',
        setNumber: 61,
    },
    {
        ...JUNGLE_SET.cards[46],
        id: 'base_two_062_en',
        setNumber: 62,
    },
    {
        ...BASE_SET.cards[41],
        id: 'base_two_063_en',
        setNumber: 63,
    },
    {
        ...JUNGLE_SET.cards[47],
        id: 'base_two_064_en',
        setNumber: 64,
    },
    {
        ...BASE_SET.cards[42],
        id: 'base_two_065_en',
        setNumber: 65,
    },
    {
        ...JUNGLE_SET.cards[48],
        id: 'base_two_066_en',
        setNumber: 66,
    },
    {
        ...BASE_SET.cards[43],
        id: 'base_two_067_en',
        setNumber: 67,
    },
    {
        ...BASE_SET.cards[44],
        id: 'base_two_068_en',
        setNumber: 68,
    },
    {
        ...BASE_SET.cards[45],
        id: 'base_two_069_en',
        setNumber: 69,
    },
    {
        ...JUNGLE_SET.cards[49],
        id: 'base_two_070_en',
        setNumber: 70,
    },
    {
        ...BASE_SET.cards[46],
        id: 'base_two_071_en',
        setNumber: 71,
    },
    {
        ...BASE_SET.cards[47],
        id: 'base_two_072_en',
        setNumber: 72,
    },
    {
        ...BASE_SET.cards[48],
        id: 'base_two_073_en',
        setNumber: 73,
    },
    {
        ...JUNGLE_SET.cards[51],
        id: 'base_two_074_en',
        setNumber: 74,
    },
    {
        ...BASE_SET.cards[49],
        id: 'base_two_075_en',
        setNumber: 75,
    },
    {
        ...JUNGLE_SET.cards[52],
        id: 'base_two_076_en',
        setNumber: 76,
    },
    {
        ...JUNGLE_SET.cards[53],
        id: 'base_two_077_en',
        setNumber: 77,
    },
    {
        ...BASE_SET.cards[51],
        id: 'base_two_078_en',
        setNumber: 78,
    },
    {
        ...BASE_SET.cards[52],
        id: 'base_two_079_en',
        setNumber: 79,
    },
    {
        ...JUNGLE_SET.cards[55],
        id: 'base_two_080_en',
        setNumber: 80,
    },
    {
        ...BASE_SET.cards[53],
        id: 'base_two_081_en',
        setNumber: 81,
    },
    {
        ...JUNGLE_SET.cards[56],
        id: 'base_two_082_en',
        setNumber: 82,
    },
    {
        ...BASE_SET.cards[54],
        id: 'base_two_083_en',
        setNumber: 83,
    },
    {
        ...BASE_SET.cards[55],
        id: 'base_two_084_en',
        setNumber: 84,
    },
    {
        ...JUNGLE_SET.cards[58],
        id: 'base_two_085_en',
        setNumber: 85,
    },
    {
        ...BASE_SET.cards[56],
        id: 'base_two_086_en',
        setNumber: 86,
    },
    {
        ...BASE_SET.cards[57],
        id: 'base_two_087_en',
        setNumber: 87,
    },
    {
        ...BASE_SET.cards[58],
        id: 'base_two_088_en',
        setNumber: 88,
    },
    {
        ...BASE_SET.cards[60],
        id: 'base_two_089_en',
        setNumber: 89,
    },
    {
        ...JUNGLE_SET.cards[60],
        id: 'base_two_090_en',
        setNumber: 90,
    },
    {
        ...BASE_SET.cards[61],
        id: 'base_two_091_en',
        setNumber: 91,
    },
    {
        ...JUNGLE_SET.cards[61],
        id: 'base_two_092_en',
        setNumber: 92,
    },
    {
        ...BASE_SET.cards[62],
        id: 'base_two_093_en',
        setNumber: 93,
    },
    {
        ...BASE_SET.cards[63],
        id: 'base_two_094_en',
        setNumber: 94,
    },
    {
        ...BASE_SET.cards[64],
        id: 'base_two_095_en',
        setNumber: 95,
    },
    {
        ...BASE_SET.cards[65],
        id: 'base_two_096_en',
        setNumber: 96,
    },
    {
        ...JUNGLE_SET.cards[62],
        id: 'base_two_097_en',
        setNumber: 97,
    },
    {
        ...BASE_SET.cards[66],
        id: 'base_two_098_en',
        setNumber: 98,
    },
    {
        ...BASE_SET.cards[67],
        id: 'base_two_099_en',
        setNumber: 99,
    },
    {
        ...BASE_SET.cards[68],
        id: 'base_two_100_en',
        setNumber: 100,
    },
];

const BASE_SET_TWO_TRAINERS = [
    {
        ...BASE_SET.cards[70],
        id: 'base_two_101_en',
        setNumber: 101,
    },
    {
        ...BASE_SET.cards[72],
        id: 'base_two_102_en',
        setNumber: 102,
    },
    {
        ...BASE_SET.cards[73],
        id: 'base_two_103_en',
        setNumber: 103,
    },
    {
        ...BASE_SET.cards[74],
        id: 'base_two_104_en',
        setNumber: 104,
    },
    {
        ...BASE_SET.cards[75],
        id: 'base_two_105_en',
        setNumber: 105,
    },
    {
        ...BASE_SET.cards[76],
        id: 'base_two_106_en',
        setNumber: 106,
    },
    {
        ...BASE_SET.cards[77],
        id: 'base_two_107_en',
        setNumber: 107,
    },
    {
        ...BASE_SET.cards[78],
        id: 'base_two_108_en',
        setNumber: 108,
    },
    {
        ...BASE_SET.cards[79],
        id: 'base_two_109_en',
        setNumber: 109,
    },
    {
        ...BASE_SET.cards[80],
        id: 'base_two_110_en',
        setNumber: 110,
    },
    {
        ...BASE_SET.cards[81],
        id: 'base_two_111_en',
        setNumber: 111,
    },
    {
        ...BASE_SET.cards[82],
        id: 'base_two_112_en',
        setNumber: 112,
    },
    {
        ...BASE_SET.cards[83],
        id: 'base_two_113_en',
        setNumber: 113,
    },
    {
        ...BASE_SET.cards[84],
        id: 'base_two_114_en',
        setNumber: 114,
    },
    {
        ...BASE_SET.cards[86],
        id: 'base_two_115_en',
        setNumber: 115,
    },
    {
        ...BASE_SET.cards[87],
        id: 'base_two_116_en',
        setNumber: 116,
    },
    {
        ...BASE_SET.cards[89],
        id: 'base_two_117_en',
        setNumber: 117,
    },
    {
        ...BASE_SET.cards[90],
        id: 'base_two_118_en',
        setNumber: 118,
    },
    {
        ...BASE_SET.cards[91],
        id: 'base_two_119_en',
        setNumber: 119,
    },
    {
        ...BASE_SET.cards[92],
        id: 'base_two_120_en',
        setNumber: 120,
    },
    {
        ...JUNGLE_SET.cards[63],
        id: 'base_two_121_en',
        setNumber: 121,
    },
    {
        ...BASE_SET.cards[93],
        id: 'base_two_122_en',
        setNumber: 122,
    },
    {
        ...BASE_SET.cards[94],
        id: 'base_two_123_en',
        setNumber: 123,
    },
];

const BASE_SET_TWO_ENERGIES = [
    {
        ...BASE_SET.cards[95],
        id: 'base_two_124_en',
        setNumber: 124,
    },
    {
        ...BASE_SET.cards[96],
        id: 'base_two_125_en',
        setNumber: 125,
    },
    {
        ...BASE_SET.cards[97],
        id: 'base_two_126_en',
        setNumber: 126,
    },
    {
        ...BASE_SET.cards[98],
        id: 'base_two_127_en',
        setNumber: 127,
    },
    {
        ...BASE_SET.cards[99],
        id: 'base_two_128_en',
        setNumber: 128,
    },
    {
        ...BASE_SET.cards[100],
        id: 'base_two_129_en',
        setNumber: 129,
    },
    {
        ...BASE_SET.cards[101],
        id: 'base_two_130_en',
        setNumber: 130,
    },
];

const setId$f = CARD_SETS.BASE_2.value;
const setName$f = CARD_SETS.BASE_2.label;
const setTotal$c = BASE_SET_TWO_TOTAL;
const BASE_SET_TWO = {
    cardCounts: {
        holoRares: 20,
        rares: 20,
        uncommons: 42,
        commons: 42,
        energies: 6,
    },
    copyright: COPYRIGHTS.BASE_2_SET,
    description: SET_DESCRIPTIONS.BASE_2,
    holoSheetType: CARD_HOLO_SHEETS.COSMOS_2,
    id: setId$f,
    imageUrl: 'https://cdn.shopify.com/s/files/1/0840/1659/5249/collections/base2-cat-bg.jpg',
    name: setName$f,
    packInfo: BOOSTER_PACKS.BASE_SET_TWO,
    releaseDate: RELEASE_DATES.BASE_2,
    setSymbol: setId$f,
    setTotal: setTotal$c,
    cards: [
        ...BASE_SET_TWO_HOLOS,
        ...BASE_SET_TWO_NON_HOLOS,
        ...BASE_SET_TWO_TRAINERS,
        ...BASE_SET_TWO_ENERGIES,
    ],
    themeDecks: [],
};

const gymThumbnailLabel = 'Gym Thumbnail';
const gymFullLabel = 'Gym Full';
const vsThumbnailLabel = 'VS Thumbnail';
const GYM_LEADER_IMAGES = {
    AGATHA: [
        {
            label: vsThumbnailLabel,
            value: 'https://poketcgshop.s3.us-east-1.amazonaws.com/trainer-images/agatha-vs-thumb.png',
        },
    ],
    BLAINE: [
        {
            label: gymThumbnailLabel,
            value: 'https://poketcgshop.s3.amazonaws.com/trainer-images/blaine-thumb.png',
        },
        {
            label: gymFullLabel,
            value: 'https://poketcgshop.s3.amazonaws.com/trainer-images/blaine-full.png',
        },
        {
            label: vsThumbnailLabel,
            value: 'https://poketcgshop.s3.amazonaws.com/trainer-images/blaine-vs-thumb.png',
        },
    ],
    BROCK: [
        {
            label: gymThumbnailLabel,
            value: 'https://poketcgshop.s3.amazonaws.com/trainer-images/brock-thumb.png',
        },
        {
            label: gymFullLabel,
            value: 'https://poketcgshop.s3.amazonaws.com/trainer-images/brock-full.png',
        },
        {
            label: vsThumbnailLabel,
            value: 'https://poketcgshop.s3.amazonaws.com/trainer-images/brock-vs-thumb.png',
        },
    ],
    BRUNO: [
        {
            label: vsThumbnailLabel,
            value: 'https://poketcgshop.s3.us-east-1.amazonaws.com/trainer-images/bruno-vs-thumb.png',
        },
    ],
    BUGSY: [
        {
            label: gymThumbnailLabel,
            value: 'https://poketcgshop.s3.amazonaws.com/trainer-images/bugsy-thumb.png',
        },
        {
            label: vsThumbnailLabel,
            value: 'https://poketcgshop.s3.amazonaws.com/trainer-images/bugsy-vs-thumb.png',
        },
    ],
    CHUCK: [
        {
            label: gymThumbnailLabel,
            value: 'https://poketcgshop.s3.amazonaws.com/trainer-images/chuck-thumb.png',
        },
        {
            label: vsThumbnailLabel,
            value: 'https://poketcgshop.s3.amazonaws.com/trainer-images/chuck-vs-thumb.png',
        },
    ],
    CLAIR: [
        {
            label: gymThumbnailLabel,
            value: 'https://poketcgshop.s3.amazonaws.com/trainer-images/clair-thumb.png',
        },
        {
            label: vsThumbnailLabel,
            value: 'https://poketcgshop.s3.amazonaws.com/trainer-images/clair-vs-thumb.png',
        },
    ],
    ERIKA: [
        {
            label: gymThumbnailLabel,
            value: 'https://poketcgshop.s3.amazonaws.com/trainer-images/erika-thumb.png',
        },
        {
            label: gymFullLabel,
            value: 'https://poketcgshop.s3.amazonaws.com/trainer-images/erika-full.png',
        },
        {
            label: vsThumbnailLabel,
            value: 'https://poketcgshop.s3.amazonaws.com/trainer-images/erika-vs-thumb.png',
        },
    ],
    FALKNER: [
        {
            label: gymThumbnailLabel,
            value: 'https://poketcgshop.s3.amazonaws.com/trainer-images/falkner-thumb.png',
        },
        {
            label: vsThumbnailLabel,
            value: 'https://poketcgshop.s3.amazonaws.com/trainer-images/falkner-vs-thumb.png',
        },
    ],
    GIOVANNI: [
        {
            label: gymThumbnailLabel,
            value: 'https://poketcgshop.s3.amazonaws.com/trainer-images/giovanni-thumb.png',
        },
        {
            label: gymFullLabel,
            value: 'https://poketcgshop.s3.amazonaws.com/trainer-images/giovanni-full.png',
        },
        {
            label: vsThumbnailLabel,
            value: 'https://poketcgshop.s3.us-east-1.amazonaws.com/trainer-images/giovanni-vs-thumb.png',
        },
    ],
    JANINE: [
        {
            label: vsThumbnailLabel,
            value: 'https://poketcgshop.s3.us-east-1.amazonaws.com/trainer-images/janine-vs-thumb.png',
        },
    ],
    JASMINE: [
        {
            label: gymThumbnailLabel,
            value: 'https://poketcgshop.s3.amazonaws.com/trainer-images/jasmine-thumb.png',
        },
        {
            label: vsThumbnailLabel,
            value: 'https://poketcgshop.s3.amazonaws.com/trainer-images/jasmine-vs-thumb.png',
        },
    ],
    KAREN: [
        {
            label: vsThumbnailLabel,
            value: 'https://poketcgshop.s3.us-east-1.amazonaws.com/trainer-images/karen-vs-thumb.png',
        },
    ],
    KOGA: [
        {
            label: gymThumbnailLabel,
            value: 'https://poketcgshop.s3.amazonaws.com/trainer-images/koga-thumb.png',
        },
        {
            label: gymFullLabel,
            value: 'https://poketcgshop.s3.amazonaws.com/trainer-images/koga-full.png',
        },
        {
            label: vsThumbnailLabel,
            value: 'https://poketcgshop.s3.amazonaws.com/trainer-images/koga-vs-thumb.png',
        },
    ],
    LANCE: [
        {
            label: vsThumbnailLabel,
            value: 'https://poketcgshop.s3.us-east-1.amazonaws.com/trainer-images/lance-vs-thumb.png',
        },
    ],
    LORELEI: [
        {
            label: vsThumbnailLabel,
            value: 'https://poketcgshop.s3.us-east-1.amazonaws.com/trainer-images/lorelei-vs-thumb.png',
        },
    ],
    LT_SURGE: [
        {
            label: gymThumbnailLabel,
            value: 'https://poketcgshop.s3.amazonaws.com/trainer-images/lt-surge-thumb.png',
        },
        {
            label: gymFullLabel,
            value: 'https://poketcgshop.s3.amazonaws.com/trainer-images/lt-surge-full.png',
        },
        {
            label: vsThumbnailLabel,
            value: 'https://poketcgshop.s3.amazonaws.com/trainer-images/lt-surge-vs-thumb.png',
        },
    ],
    MISTY: [
        {
            label: gymThumbnailLabel,
            value: 'https://poketcgshop.s3.amazonaws.com/trainer-images/misty-thumb.png',
        },
        {
            label: gymFullLabel,
            value: 'https://poketcgshop.s3.amazonaws.com/trainer-images/misty-full.png',
        },
        {
            label: vsThumbnailLabel,
            value: 'https://poketcgshop.s3.amazonaws.com/trainer-images/misty-vs-thumb.png',
        },
    ],
    MORTY: [
        {
            label: gymThumbnailLabel,
            value: 'https://poketcgshop.s3.amazonaws.com/trainer-images/morty-thumb.png',
        },
        {
            label: vsThumbnailLabel,
            value: 'https://poketcgshop.s3.amazonaws.com/trainer-images/morty-vs-thumb.png',
        },
    ],
    OAKLEY: [
        {
            label: vsThumbnailLabel,
            value: 'https://poketcgshop.s3.us-east-1.amazonaws.com/trainer-images/oakley-vs-thumb.png',
        },
    ],
    PRYCE: [
        {
            label: gymThumbnailLabel,
            value: 'https://poketcgshop.s3.amazonaws.com/trainer-images/pryce-thumb.png',
        },
        {
            label: vsThumbnailLabel,
            value: 'https://poketcgshop.s3.amazonaws.com/trainer-images/pryce-vs-thumb.png',
        },
    ],
    ROCKET: [
        {
            label: gymThumbnailLabel,
            value: 'https://poketcgshop.s3.amazonaws.com/trainer-images/rocket-thumb.png',
        },
        {
            label: vsThumbnailLabel,
            value: 'https://poketcgshop.s3.us-east-1.amazonaws.com/trainer-images/rocket-vs-thumb.png',
        },
        {
            label: `${vsThumbnailLabel} (Marauder)`,
            value: 'https://poketcgshop.s3.us-east-1.amazonaws.com/trainer-images/rocket-marauder-vs-thumb.png',
        },
    ],
    ROSS: [
        {
            label: vsThumbnailLabel,
            value: 'https://poketcgshop.s3.us-east-1.amazonaws.com/trainer-images/ross-vs-thumb.png',
        },
    ],
    SABRINA: [
        {
            label: gymThumbnailLabel,
            value: 'https://poketcgshop.s3.amazonaws.com/trainer-images/sabrina-thumb.png',
        },
        {
            label: gymFullLabel,
            value: 'https://poketcgshop.s3.amazonaws.com/trainer-images/sabrina-full.png',
        },
        {
            label: vsThumbnailLabel,
            value: 'https://poketcgshop.s3.amazonaws.com/trainer-images/sabrina-vs-thumb.png',
        },
    ],
    WHITNEY: [
        {
            label: gymThumbnailLabel,
            value: 'https://poketcgshop.s3.amazonaws.com/trainer-images/whitney-thumb.png',
        },
        {
            label: vsThumbnailLabel,
            value: 'https://poketcgshop.s3.amazonaws.com/trainer-images/whitney-vs-thumb.png',
        },
    ],
    WILL: [
        {
            label: vsThumbnailLabel,
            value: 'https://poketcgshop.s3.us-east-1.amazonaws.com/trainer-images/will-vs-thumb.png',
        },
    ],
};

const GYM_LEADERS = {
    AGATHA: {
        name: 'Agatha',
        images: GYM_LEADER_IMAGES.AGATHA,
    },
    BLAINE: {
        name: 'Blaine',
        images: GYM_LEADER_IMAGES.BLAINE,
    },
    BROCK: {
        name: 'Brock',
        images: GYM_LEADER_IMAGES.BROCK,
    },
    BRUNO: {
        name: 'Bruno',
        images: GYM_LEADER_IMAGES.BRUNO,
    },
    BUGSY: {
        name: 'Bugsy',
        images: GYM_LEADER_IMAGES.BUGSY,
    },
    CHUCK: {
        name: 'Chuck',
        images: GYM_LEADER_IMAGES.CHUCK,
    },
    CLAIR: {
        name: 'Clair',
        images: GYM_LEADER_IMAGES.CLAIR,
    },
    ERIKA: {
        name: 'Erika',
        images: GYM_LEADER_IMAGES.ERIKA,
    },
    FALKNER: {
        name: 'Falkner',
        images: GYM_LEADER_IMAGES.FALKNER,
    },
    GIOVANNI: {
        name: 'Giovanni',
        images: GYM_LEADER_IMAGES.GIOVANNI,
    },
    JANINE: {
        name: 'Janine',
        images: GYM_LEADER_IMAGES.JANINE,
    },
    JASMINE: {
        name: 'Jasmine',
        images: GYM_LEADER_IMAGES.JASMINE,
    },
    KAREN: {
        name: 'Karen',
        images: GYM_LEADER_IMAGES.KAREN,
    },
    KOGA: {
        name: 'Koga',
        images: GYM_LEADER_IMAGES.KOGA,
    },
    LANCE: {
        name: 'Lance',
        images: GYM_LEADER_IMAGES.LANCE,
    },
    LORELEI: {
        name: 'Lorelei',
        images: GYM_LEADER_IMAGES.LORELEI,
    },
    LT_SURGE: {
        name: 'Lt. Surge',
        images: GYM_LEADER_IMAGES.LT_SURGE,
    },
    MISTY: {
        name: 'Misty',
        images: GYM_LEADER_IMAGES.MISTY,
    },
    MORTY: {
        name: 'Morty',
        images: GYM_LEADER_IMAGES.MORTY,
    },
    OAKLEY: {
        name: 'Oakley',
        images: GYM_LEADER_IMAGES.OAKLEY,
    },
    PRYCE: {
        name: 'Pryce',
        images: GYM_LEADER_IMAGES.PRYCE,
    },
    ROCKET: {
        name: 'Rocket',
        images: GYM_LEADER_IMAGES.ROCKET,
    },
    ROSS: {
        name: 'Ross',
        images: GYM_LEADER_IMAGES.ROSS,
    },
    SABRINA: {
        name: 'Sabrina',
        images: GYM_LEADER_IMAGES.SABRINA,
    },
    WHITNEY: {
        name: 'Whitney',
        images: GYM_LEADER_IMAGES.WHITNEY,
    },
    WILL: {
        name: 'Will',
        images: GYM_LEADER_IMAGES.WILL,
    },
};

const GYM_TRAINERS = {
    BLAINES_GAMBLE: {
        name: "Blaine's Gamble",
        image: '',
    },
    BLAINES_LAST_RESORT: {
        name: "Blaine's Last Resort",
        image: '',
    },
    BLAINES_QUIZ_1: {
        name: "Blaine's Quiz #1",
        image: '',
    },
    BLAINES_QUIZ_2: {
        name: "Blaine's Quiz #2",
        image: '',
    },
    BLAINES_QUIZ_3: {
        name: "Blaine's Quiz #3",
        image: '',
    },
    BROCKS_PROTECTION: {
        name: "Brock's Protection",
        image: '',
    },
    BROCKS_TRAINING_METHOD: {
        name: "Brock's Training Method",
        image: '',
    },
    CELADON_CITY_GYM: {
        name: 'Celadon City Gym',
        image: '',
    },
    CERULEAN_CITY_GYM: {
        name: 'Cerulean City Gym',
        image: '',
    },
    CHARITY: {
        name: 'Charity',
        image: '',
    },
    CHAOS_GYM: {
        name: 'Chaos Gym',
        image: '',
    },
    CINNABAR_CITY_GYM: {
        name: 'Cinnabar City Gym',
        image: '',
    },
    ENERGY_FLOW: {
        name: 'Energy Flow',
        image: '',
    },
    ERIKAS_KINDNESS: {
        name: "Erika's Kindness",
        image: '',
    },
    ERIKAS_MAIDS: {
        name: "Erika's Maids",
        image: '',
    },
    ERIKAS_PERFUME: {
        name: "Erika's Perfume",
        image: '',
    },
    FERVOR: {
        name: 'Fervor',
        image: '',
    },
    FUCHSIA_CITY_GYM: {
        name: 'Fuchsia City Gym',
        image: '',
    },
    GIOVANNIS_LAST_RESORT: {
        name: "Giovanni's Last Resort",
        image: '',
    },
    GOOD_MANNERS: {
        name: 'Good Manners',
        image: '',
    },
    KOGAS_NINJA_TRICK: {
        name: "Koga's Ninja Trick",
        image: '',
    },
    LT_SURGES_SECRET_PLAN: {
        name: "Lt. Surge's Secret Plan",
        image: '',
    },
    LT_SURGES_TREATY: {
        name: "Lt. Surge's Treaty",
        image: '',
    },
    MASTER_BALL: {
        name: 'Master Ball',
        image: '',
    },
    MAX_REVIVE: {
        name: 'Max Revive',
        image: '',
    },
    MINION_OF_TEAM_ROCKET: {
        name: 'Minion of Team Rocket',
        image: '',
    },
    MISTYS_DUEL: {
        name: "Misty's Duel",
        image: '',
    },
    MISTYS_TEARS: {
        name: "Misty's Tears",
        image: '',
    },
    MISTYS_WISH: {
        name: "Misty's Wish",
        image: '',
    },
    MISTYS_WRATH: {
        name: "Misty's Wrath",
        image: '',
    },
    NARROW_GYM: {
        name: 'Narrow Gym',
        image: '',
    },
    NO_REMOVAL_GYM: {
        name: 'No Removal Gym',
        image: '',
    },
    PEWTER_CITY_GYM: {
        name: 'Pewter City Gym',
        image: '',
    },
    RECALL: {
        name: 'Recall',
        image: '',
    },
    RESISTANCE_GYM: {
        name: 'Resistance Gym',
        image: '',
    },
    ROCKETS_MINEFIELD_GYM: {
        name: "Rocket's Minefield Gym",
        image: '',
    },
    ROCKETS_SECRET_EXPERIMENT: {
        name: "Rocket's Secret Experiment",
        image: '',
    },
    ROCKETS_TRAP: {
        name: "The Rocket's Trap",
        image: 'https://poketcgshop.s3.amazonaws.com/trainer-card-images/rockets-trap-gym-heroes_lk2wjv.png',
    },
    SABRINAS_ESP: {
        name: "Sabrina's ESP",
        image: '',
    },
    SABRINAS_GAZE: {
        name: "Sabrina's Gaze",
        image: '',
    },
    SABRINAS_PSYCHIC_CONTROL: {
        name: "Sabrina's Psychic Control",
        image: '',
    },
    SAFFRON_CITY_GYM: {
        name: 'Saffron City Gym',
        image: '',
    },
    SECRET_MISSION: {
        name: 'Secret Mission',
        image: '',
    },
    TICKLING_MACHINE: {
        name: 'Tickling Machine',
        image: '',
    },
    THE_ROCKETS_TRAINING_GYM: {
        name: "The Rocket's Training Gym",
        image: '',
    },
    TRANSPARENT_WALLS: {
        name: 'Transparent Walls',
        image: '',
    },
    TRASH_EXCHANGE: {
        name: 'Trash Exchange',
        image: '',
    },
    VERMILION_CITY_GYM: {
        name: 'Vermilion City Gym',
        image: '',
    },
    VIRIDIAN_CITY_GYM: {
        name: 'Viridian City Gym',
        image: '',
    },
    WARP_POINT: {
        name: 'Warp Point',
        image: '',
    },
};

const { BLAINE: BLAINE$4, BROCK: BROCK$4, BRUNO, BUGSY, CHUCK, CLAIR, ERIKA: ERIKA$4, FALKNER, GIOVANNI: GIOVANNI$2, JANINE, JASMINE, KAREN, KOGA: KOGA$2, LANCE, LT_SURGE: LT_SURGE$4, MISTY: MISTY$4, MORTY, PRYCE, ROCKET: ROCKET$3, SABRINA: SABRINA$5, WHITNEY, WILL, } = GYM_LEADERS;
const BLAINE_PREFIX = `${BLAINE$4.name}'s`;
const BLAINE_VS_IMAGE = BLAINE$4.images[2].value;
const BROCK_PREFIX = `${BROCK$4.name}'s`;
const BROCK_VS_IMAGE = BROCK$4.images[2].value;
const BRUNO_PREFIX = `${BRUNO.name}'s`;
const BRUNO_VS_IMAGE = BRUNO.images[0].value;
const BUGSY_PREFIX = `${BUGSY.name}'s`;
const BUGSY_VS_IMAGE = BUGSY.images[1].value;
const CHUCK_PREFIX = `${CHUCK.name}'s`;
const CHUCK_VS_IMAGE = CHUCK.images[1].value;
const CLAIR_PREFIX = `${CLAIR.name}'s`;
const CLAIR_VS_IMAGE = CLAIR.images[1].value;
const ERIKA_PREFIX = `${ERIKA$4.name}'s`;
const ERIKA_VS_IMAGE = ERIKA$4.images[2].value;
const FALKNER_PREFIX = `${FALKNER.name}'s`;
const FALKNER_VS_IMAGE = FALKNER.images[1].value;
const GIOVANNI_PREFIX = `${GIOVANNI$2.name}'s`;
const JANINE_PREFIX = `${JANINE.name}'s`;
const JANINE_VS_IMAGE = JANINE.images[0].value;
const JASMINE_PREFIX = `${JASMINE.name}'s`;
const JASMINE_VS_IMAGE = JASMINE.images[1].value;
const KAREN_PREFIX = `${KAREN.name}'s`;
const KAREN_VS_IMAGE = KAREN.images[0].value;
const KOGA_PREFIX = `${KOGA$2.name}'s`;
const KOGA_VS_IMAGE = KOGA$2.images[2].value;
const LANCE_PREFIX = `${LANCE.name}'s`;
const LANCE_VS_IMAGE = LANCE.images[0].value;
const LT_SURGE_PREFIX = `${LT_SURGE$4.name}'s`;
const LT_SURGE_VS_IMAGE = LT_SURGE$4.images[2].value;
const MISTY_PREFIX = `${MISTY$4.name}'s`;
const MISTY_VS_IMAGE = MISTY$4.images[2].value;
const MORTY_PREFIX = `${MORTY.name}'s`;
const MORTY_VS_IMAGE = MORTY.images[1].value;
const PRYCE_PREFIX = `${PRYCE.name}'s`;
const PRYCE_VS_IMAGE = PRYCE.images[1].value;
const ROCKET_PREFIX = `${ROCKET$3.name}'s`;
const ROCKET_VS_IMAGE = ROCKET$3.images[1].value;
const ROCKET_MARAUDER_VS_IMAGE = ROCKET$3.images[2].value;
const SABRINA_PREFIX = `${SABRINA$5.name}'s`;
const SABRINA_VS_IMAGE = SABRINA$5.images[2].value;
const WHITNEY_PREFIX = `${WHITNEY.name}'s`;
const WHITNEY_VS_IMAGE = WHITNEY.images[1].value;
const WILL_PREFIX = `${WILL.name}'s`;
const WILL_VS_IMAGE = WILL.images[0].value;

const { CLEFABLE: CLEFABLE$2, CLEFAIRY: CLEFAIRY$6, DRAGONAIR: DRAGONAIR$8, DRATINI: DRATINI$4, ELECTABUZZ: ELECTABUZZ$5, FEAROW: FEAROW$2, GENGAR: GENGAR$6, GLOOM: GLOOM$6, HAUNTER: HAUNTER$9, HITMONCHAN: HITMONCHAN$2, HORSEA: HORSEA$4, MAGNEMITE: MAGNEMITE$8, MAGNETON: MAGNETON$5, MOLTRES: MOLTRES$3, RHYDON: RHYDON$2, RHYHORN: RHYHORN$4, SCYTHER: SCYTHER$5, SEADRA: SEADRA$3, SPEAROW: SPEAROW$3, TENTACOOL: TENTACOOL$2, TENTACRUEL: TENTACRUEL$2, VILEPLUME: VILEPLUME$3, } = GEN_1_POKEMON;
const { BLAINE: BLAINE$3, BROCK: BROCK$3, ERIKA: ERIKA$3, LT_SURGE: LT_SURGE$3, MISTY: MISTY$3, ROCKET: ROCKET$2, SABRINA: SABRINA$4 } = GYM_LEADERS;
const { ROCKETS_TRAP } = GYM_TRAINERS;
const GYM_HEROES_HOLOS = [
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-charizard-cd_ewdfvb.jpg',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.FIRE,
        hitPoints: 90,
        holo: true,
        holoStrength: 0.7,
        id: 'gym_heroes_001_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 6,
        lengthInches: 7,
        moves: [MOVES.PHOENIX_FLAME],
        name: `${BLAINE_PREFIX} ${MOLTRES$3.name}`,
        pokemonImagePositionX: 64,
        pokemonImagePositionY: 54,
        pokemonImageRotation: -32,
        pokemonImageSize: 31,
        pokemonImageUrl: MOLTRES$3.images[1].value,
        pokemonLevel: 44,
        pokemonNumber: MOLTRES$3.number,
        pokemonType: MOLTRES$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 1,
        trainerImageUrl: BLAINE$3.images[0].value,
        weight: 132,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-pidgey_ggcjcw.jpg',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: ENERGY_TYPES.LIGHTNING,
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.GRASS,
        evolvesFrom: `${BROCK_PREFIX} ${RHYHORN$4.name}`,
        evolutionBoxImageUrl: RHYHORN$4.images[0].value,
        hitPoints: 80,
        holo: true,
        holoStrength: 0.7,
        id: 'gym_heroes_002_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 6,
        lengthInches: 3,
        moves: [MOVES.BENCH_GUARD, MOVES.LARIAT],
        name: `${BROCK_PREFIX} ${RHYDON$2.name}`,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 43,
        pokemonImageSize: 43,
        pokemonImageUrl: RHYDON$2.images[1].value,
        pokemonLevel: 38,
        pokemonNumber: RHYDON$2.number,
        pokemonType: RHYDON$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 2,
        stage: RHYDON$2.stage,
        trainerImageUrl: BROCK$3.images[0].value,
        weight: 265,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-lass_yyfpg2.jpg',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: ENERGY_TYPES.PSYCHIC,
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: `${ERIKA_PREFIX} ${CLEFAIRY$6.name}`,
        evolutionBoxImageUrl: CLEFAIRY$6.images[0].value,
        hitPoints: 70,
        holo: true,
        holoStrength: 0.7,
        id: 'gym_heroes_003_en',
        illustrator: ILLUSTRATORS.NISHIDA,
        lengthFeet: 4,
        lengthInches: 3,
        moves: [MOVES.FAIRY_POWER, MOVES.MOON_IMPACT],
        name: `${ERIKA_PREFIX} ${CLEFABLE$2.name}`,
        pokemonImagePositionX: 56,
        pokemonImagePositionY: 43,
        pokemonImageSize: 41,
        pokemonImageUrl: CLEFABLE$2.images[1].value,
        pokemonLevel: 35,
        pokemonNumber: CLEFABLE$2.number,
        pokemonType: CLEFABLE$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 3,
        stage: CLEFABLE$2.stage,
        trainerImageUrl: ERIKA$3.images[0].value,
        weight: 88,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-dratini_vxrsjo.jpg',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: ENERGY_TYPES.PSYCHIC,
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.COLORLESS,
        evolvesFrom: `${ERIKA_PREFIX} ${DRATINI$4.name}`,
        evolutionBoxImageUrl: DRATINI$4.images[0].value,
        hitPoints: 80,
        holo: true,
        holoStrength: 0.7,
        id: 'gym_heroes_004_en',
        illustrator: ILLUSTRATORS.NISHIDA,
        lengthFeet: 13,
        lengthInches: 1,
        moves: [
            SHARED_MOVES(DRAGONAIR$8.name, 'blizzard', ['colorless', 'colorless', 'colorless'], 30),
            MOVES.TAKE_AWAY,
        ],
        name: `${ERIKA_PREFIX} ${DRAGONAIR$8.name}`,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 43,
        pokemonImageSize: 65,
        pokemonImageUrl: DRAGONAIR$8.images[2].value,
        pokemonLevel: 32,
        pokemonNumber: DRAGONAIR$8.number,
        pokemonType: DRAGONAIR$8.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 4,
        stage: DRAGONAIR$8.stage,
        trainerImageUrl: ERIKA$3.images[0].value,
        weight: 36,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-lass_yyfpg2.jpg',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: ENERGY_TYPES.PSYCHIC,
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        evolvesFrom: `${ERIKA_PREFIX} ${GLOOM$6.name}`,
        evolutionBoxImageUrl: GLOOM$6.images[0].value,
        hitPoints: 80,
        holo: true,
        holoStrength: 0.7,
        id: 'gym_heroes_005_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [
            MOVES.POLLEN_DEFENSE,
            SHARED_MOVES(`${ERIKA_PREFIX} ${VILEPLUME$3.name}`, 'mega-drain', ['grass', 'grass', 'grass'], 30, false, `If ${ERIKA_PREFIX} Vileplume does damage to the Defending Pokémon <em>(after applying Weakness and Resistance)</em>, remove a number of damage counters from ${ERIKA_PREFIX} Vileplume equal to half the damage done to the Defending Pokémon (rounded up to the nearest 10). If ${ERIKA_PREFIX} Vileplume has fewer damage counters than that, remove all of them.`),
        ],
        name: `${ERIKA_PREFIX} ${VILEPLUME$3.name}`,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 48,
        pokemonImageSize: 42,
        pokemonImageUrl: VILEPLUME$3.images[2].value,
        pokemonLevel: 34,
        pokemonNumber: VILEPLUME$3.number,
        pokemonType: VILEPLUME$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 5,
        stage: VILEPLUME$3.stage,
        trainerImageUrl: ERIKA$3.images[0].value,
        weight: 41,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lights-erikas-dratini_e65qcs.jpg',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 70,
        holo: true,
        holoStrength: 0.7,
        id: 'gym_heroes_006_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 3,
        lengthInches: 7,
        moves: [MOVES.CHARGE, MOVES.DISCHARGE],
        name: `${LT_SURGE_PREFIX} ${ELECTABUZZ$5.name}`,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 54,
        pokemonImageSize: 66,
        pokemonImageUrl: ELECTABUZZ$5.images[1].value,
        pokemonLevel: 28,
        pokemonNumber: ELECTABUZZ$5.number,
        pokemonType: ELECTABUZZ$5.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 6,
        trainerImageUrl: LT_SURGE$3.images[0].value,
        weight: 66,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-brocks-diglett_e2hxfq.jpg',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        evolvesFrom: `${LT_SURGE_PREFIX} ${SPEAROW$3.name}`,
        evolutionBoxImageUrl: SPEAROW$3.images[0].value,
        hitPoints: 70,
        holo: true,
        holoStrength: 0.7,
        id: 'gym_heroes_007_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [MOVES.REPEATING_DRILL, MOVES.CLUTCH],
        name: `${LT_SURGE_PREFIX} ${FEAROW$2.name}`,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 40,
        pokemonImageUrl: FEAROW$2.images[1].value,
        pokemonLevel: 30,
        pokemonNumber: FEAROW$2.number,
        pokemonType: FEAROW$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 7,
        stage: FEAROW$2.stage,
        trainerImageUrl: LT_SURGE$3.images[0].value,
        weight: 84,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/metal-surges-raichu_bo84ld.jpg',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: `${LT_SURGE_PREFIX} ${MAGNEMITE$8.name}`,
        evolutionBoxImageUrl: MAGNEMITE$8.images[0].value,
        hitPoints: 70,
        holo: true,
        holoStrength: 0.7,
        id: 'gym_heroes_008_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [MOVES.ENERGY_CHARGE, MOVES.MEGA_SHOCK],
        name: `${LT_SURGE_PREFIX} ${MAGNETON$5.name}`,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 44,
        pokemonImageUrl: MAGNETON$5.images[3].value,
        pokemonLevel: 30,
        pokemonNumber: MAGNETON$5.number,
        pokemonType: MAGNETON$5.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 8,
        stage: MAGNETON$5.stage,
        trainerImageUrl: LT_SURGE$3.images[0].value,
        weight: 132,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/water-seel_psmkpp.jpg',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        evolvesFrom: `${MISTY_PREFIX} ${HORSEA$4.name}`,
        evolutionBoxImageUrl: HORSEA$4.images[0].value,
        hitPoints: 70,
        holo: true,
        holoStrength: 0.7,
        id: 'gym_heroes_009_en',
        illustrator: ILLUSTRATORS.NISHIDA,
        lengthFeet: 3,
        lengthInches: 1,
        moves: [MOVES.TAIL_SNAP, MOVES.KNOCKOUT_NEEDLE],
        name: `${MISTY_PREFIX} ${SEADRA$3.name}`,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 43,
        pokemonImageSize: 35,
        pokemonImageUrl: SEADRA$3.images[1].value,
        pokemonLevel: 30,
        pokemonNumber: SEADRA$3.number,
        pokemonType: SEADRA$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 9,
        stage: SEADRA$3.stage,
        trainerImageUrl: MISTY$3.images[0].value,
        weight: 55,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-rockets-moltres_badehb.jpg',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        evolvesFrom: `${MISTY_PREFIX} ${TENTACOOL$2.name}`,
        evolutionBoxImageUrl: TENTACOOL$2.images[0].value,
        hitPoints: 70,
        holo: true,
        holoStrength: 0.7,
        id: 'gym_heroes_010_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 5,
        lengthInches: 3,
        moves: [MOVES.FLEE, MOVES.JELLYFISH_POISON],
        name: `${MISTY_PREFIX} ${TENTACRUEL$2.name}`,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 43,
        pokemonImageSize: 56,
        pokemonImageUrl: TENTACRUEL$2.images[1].value,
        pokemonLevel: 30,
        pokemonNumber: TENTACRUEL$2.number,
        pokemonType: TENTACRUEL$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 10,
        stage: TENTACRUEL$2.stage,
        trainerImageUrl: MISTY$3.images[0].value,
        weight: 121,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/cool-flames-hitmonchan_uq8mwk.jpg',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 60,
        holo: true,
        holoStrength: 0.7,
        id: 'gym_heroes_011_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        frameMode: 'dark',
        lengthFeet: 4,
        lengthInches: 7,
        moves: [MOVES.CROSSCOUNTER, MOVES.MAGNUM_PUNCH],
        name: `${ROCKET_PREFIX} ${HITMONCHAN$2.name}`,
        pokemonImagePositionX: 47,
        pokemonImagePositionY: 45,
        pokemonImageRotation: -5,
        pokemonImageSize: 31,
        pokemonImageUrl: HITMONCHAN$2.images[1].value,
        pokemonLevel: 29,
        pokemonNumber: HITMONCHAN$2.number,
        pokemonType: HITMONCHAN$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 11,
        trainerImageUrl: ROCKET$2.images[0].value,
        weight: 111,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-rockets-moltres_badehb.jpg',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.FIRE,
        hitPoints: 60,
        holo: true,
        holoStrength: 0.7,
        id: 'gym_heroes_012_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        frameMode: 'dark',
        lengthFeet: 6,
        lengthInches: 7,
        moves: [MOVES.REBIRTH, MOVES.FIRE_WALL],
        name: `${ROCKET_PREFIX} ${MOLTRES$3.name}`,
        pokemonImagePositionX: 47,
        pokemonImagePositionY: 45,
        pokemonImageRotation: 0,
        pokemonImageSize: 50,
        pokemonImageUrl: MOLTRES$3.images[2].value,
        pokemonLevel: 26,
        pokemonNumber: MOLTRES$3.number,
        pokemonType: MOLTRES$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 12,
        trainerImageUrl: ROCKET$2.images[0].value,
        weight: 132,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-kabutops_ox1atw.jpg',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        hitPoints: 60,
        holo: true,
        holoStrength: 0.7,
        id: 'gym_heroes_013_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        frameMode: 'dark',
        lengthFeet: 4,
        lengthInches: 11,
        moves: [MOVES.SHADOW_IMAGES, MOVES.BLINDING_SCYTHE],
        name: `${ROCKET_PREFIX} ${SCYTHER$5.name}`,
        pokemonImagePositionX: 47,
        pokemonImagePositionY: 42,
        pokemonImageRotation: 0,
        pokemonImageSize: 48,
        pokemonImageUrl: SCYTHER$5.images[1].value,
        pokemonLevel: 23,
        pokemonNumber: SCYTHER$5.number,
        pokemonType: SCYTHER$5.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 13,
        trainerImageUrl: ROCKET$2.images[0].value,
        weight: 123,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/hills-ponyta_bcekdh.jpg',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.PSYCHIC,
        evolvesFrom: `${SABRINA_PREFIX} ${HAUNTER$9.name}`,
        evolutionBoxImageUrl: HAUNTER$9.images[0].value,
        hitPoints: 80,
        holo: true,
        holoStrength: 0.7,
        id: 'gym_heroes_014_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 4,
        lengthInches: 11,
        moves: [MOVES.PAIN_AMPLIFIER, MOVES.CALL_OF_THE_NIGHT],
        name: `${SABRINA_PREFIX} ${GENGAR$6.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonImageUrl: GENGAR$6.images[1].value,
        pokemonLevel: 39,
        pokemonNumber: GENGAR$6.number,
        pokemonType: GENGAR$6.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 14,
        stage: GENGAR$6.stage,
        trainerImageUrl: SABRINA$4.images[0].value,
        weight: 89,
    },
    {
        backgroundColor: '#8A5F41',
        backgroundImageBlendMode: BLEND_MODES.SCREEN,
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-kabutops_ox1atw.jpg',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: 'Remove 1 damage counter from each of your Pokémon that has any damage counters in it.',
        holo: true,
        holoStrength: 0.7,
        id: 'gym_heroes_015_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        name: BROCK$3.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: -46,
        pokemonImageSize: 25,
        pokemonImageUrl: BROCK$3.images[1].value,
        rarity: RARITY_TYPES.RARE,
        setNumber: 15,
    },
    {
        backgroundColor: '#2C5A2A',
        backgroundImageBlendMode: BLEND_MODES.SCREEN,
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/leaf-potion-energy_lqofub.jpg',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: 'You may draw up to 3 cards, then your opponent may draw up to 3 cards.',
        holo: true,
        holoStrength: 0.7,
        id: 'gym_heroes_016_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        name: ERIKA$3.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: -32,
        pokemonImageSize: 26,
        pokemonImageUrl: ERIKA$3.images[1].value,
        rarity: RARITY_TYPES.RARE,
        setNumber: 16,
    },
    {
        backgroundColor: '#BEA636',
        backgroundImageBlendMode: BLEND_MODES.SCREEN,
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-ekans_inxykw.jpg',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: "You can play this card only if you have at least 1 Basic Pokémon card in your hand. Put a Basic Pokémon card from your hand into play as your Active Pokémon onto your Bench. <em>You can't play this card if your Bench is full.)</em>",
        holo: true,
        holoStrength: 0.7,
        id: 'gym_heroes_017_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        name: LT_SURGE$3.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: -35,
        pokemonImageSize: 34,
        pokemonImageUrl: LT_SURGE$3.images[1].value,
        rarity: RARITY_TYPES.RARE,
        setNumber: 17,
    },
    {
        backgroundColor: '#66719F',
        backgroundImageBlendMode: BLEND_MODES.SCREEN,
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/water-seel_psmkpp.jpg',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: "Discard 2 of the other cards in your hand in order to play this card. If this turn's attack does damage to the Defending Pokémon <em>(after applying Weakness and Resistance)</em>, and if the attacking Pokémon has Misty in its name, the attack does 20 more damage to the Defending Pokémon.",
        holo: true,
        holoStrength: 0.7,
        id: 'gym_heroes_018_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        name: MISTY$3.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: -36,
        pokemonImageSize: 37,
        pokemonImageUrl: MISTY$3.images[1].value,
        rarity: RARITY_TYPES.RARE,
        setNumber: 18,
    },
    {
        backgroundColor: '#66719F',
        backgroundImageBlendMode: BLEND_MODES.SCREEN,
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lights-kadabra_hrrzpa.jpg',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: "Flip a coin. If heads, choose up to 3 cards at random from your opponent's hand <em>(don't look at them).</em> Your opponent shuffles those cards into his or her deck.",
        holo: true,
        holoStrength: 0.7,
        id: 'gym_heroes_019_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        name: ROCKETS_TRAP.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 46,
        pokemonImageSize: 59,
        pokemonImageUrl: ROCKETS_TRAP.image,
        rarity: RARITY_TYPES.RARE,
        setNumber: 19,
    },
];

const { ABRA: ABRA$5, BELLSPROUT: BELLSPROUT$1, CHARMANDER: CHARMANDER$3, CLEFAIRY: CLEFAIRY$5, CLOYSTER: CLOYSTER$3, DRATINI: DRATINI$3, DROWZEE: DROWZEE$4, ELECTABUZZ: ELECTABUZZ$4, EXEGGCUTE: EXEGGCUTE$1, EXEGGUTOR: EXEGGUTOR$3, GASTLY: GASTLY$6, GEODUDE: GEODUDE$4, GLOOM: GLOOM$5, GOLBAT: GOLBAT$8, GOLDEEN: GOLDEEN$2, GOLEM: GOLEM$3, GRAVELER: GRAVELER$6, GROWLITHE: GROWLITHE$7, HAUNTER: HAUNTER$8, HORSEA: HORSEA$3, JYNX: JYNX$4, KANGASKHAN, LICKITUNG: LICKITUNG$2, MAGMAR: MAGMAR$6, MAGNEMITE: MAGNEMITE$7, MANKEY: MANKEY$2, MR_MIME: MR_MIME$1, ODDISH: ODDISH$4, ONIX: ONIX$3, PIKACHU: PIKACHU$b, POLIWAG: POLIWAG$4, POLIWHIRL: POLIWHIRL$6, POLIWRATH: POLIWRATH$4, PONYTA: PONYTA$5, PSYDUCK: PSYDUCK$6, RAICHU: RAICHU$8, RATICATE: RATICATE$4, RATTATA: RATTATA$4, RHYHORN: RHYHORN$3, SANDSHREW: SANDSHREW$3, SANDSLASH: SANDSLASH$3, SEAKING: SEAKING$1, SEEL: SEEL$4, SHELLDER: SHELLDER$3, SLOWBRO: SLOWBRO$4, SLOWPOKE: SLOWPOKE$5, SNORLAX: SNORLAX$2, SPEAROW: SPEAROW$2, STARMIE: STARMIE$3, STARYU: STARYU$4, TANGELA: TANGELA$1, TAUROS: TAUROS$2, TENTACOOL: TENTACOOL$1, VENOMOTH: VENOMOTH$3, VENONAT: VENONAT$2, VICTREEBEL, VOLTORB: VOLTORB$3, VULPIX: VULPIX$5, WEEPINBELL, ZUBAT: ZUBAT$6, } = GEN_1_POKEMON;
const { BLAINE: BLAINE$2, BROCK: BROCK$2, ERIKA: ERIKA$2, LT_SURGE: LT_SURGE$2, MISTY: MISTY$2, ROCKET: ROCKET$1, SABRINA: SABRINA$3 } = GYM_LEADERS;
const GYM_HEROES_NON_HOLOS = [
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        evolvesFrom: GRAVELER$6.name,
        evolutionBoxImageUrl: GRAVELER$6.images[0].value,
        hitPoints: null,
        id: 'gym_heroes_020_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${BROCK_PREFIX} ${GOLEM$3.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: GOLEM$3.number,
        pokemonType: GOLEM$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 20,
        stage: GOLEM$3.stage,
        trainerImageUrl: BROCK$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        hitPoints: null,
        id: 'gym_heroes_021_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${BROCK_PREFIX} ${ONIX$3.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: ONIX$3.number,
        pokemonType: ONIX$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 21,
        trainerImageUrl: BROCK$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        hitPoints: null,
        id: 'gym_heroes_022_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${BROCK_PREFIX} ${RHYHORN$3.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: RHYHORN$3.number,
        pokemonType: RHYHORN$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 22,
        trainerImageUrl: BROCK$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        evolvesFrom: null,
        evolutionBoxImageUrl: null,
        hitPoints: null,
        id: 'gym_heroes_023_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: SANDSLASH$3.name,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: SANDSLASH$3.number,
        pokemonType: SANDSLASH$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 23,
        stage: SANDSLASH$3.stage,
        trainerImageUrl: BROCK$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        hitPoints: null,
        id: 'gym_heroes_024_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${BROCK_PREFIX} ${ZUBAT$6.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: ZUBAT$6.number,
        pokemonType: ZUBAT$6.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 24,
        trainerImageUrl: BROCK$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        hitPoints: null,
        id: 'gym_heroes_025_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${ERIKA_PREFIX} ${CLEFAIRY$5.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: CLEFAIRY$5.number,
        pokemonType: CLEFAIRY$5.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 25,
        trainerImageUrl: ERIKA$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        evolvesFrom: null,
        evolutionBoxImageUrl: null,
        hitPoints: null,
        id: 'gym_heroes_026_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${ERIKA_PREFIX} ${VICTREEBEL.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: VICTREEBEL.number,
        pokemonType: VICTREEBEL.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 26,
        stage: VICTREEBEL.stage,
        trainerImageUrl: ERIKA$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        hitPoints: null,
        id: 'gym_heroes_027_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${LT_SURGE_PREFIX} ${ELECTABUZZ$4.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: ELECTABUZZ$4.number,
        pokemonType: ELECTABUZZ$4.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 27,
        trainerImageUrl: LT_SURGE$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        evolvesFrom: PIKACHU$b.name,
        evolutionBoxImageUrl: PIKACHU$b.images[0].value,
        hitPoints: null,
        id: 'gym_heroes_028_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${LT_SURGE_PREFIX} ${RAICHU$8.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: RAICHU$8.number,
        pokemonType: RAICHU$8.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 28,
        stage: RAICHU$8.stage,
        trainerImageUrl: SABRINA$3.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        evolvesFrom: SHELLDER$3.name,
        evolutionBoxImageUrl: SHELLDER$3.images[0].value,
        hitPoints: null,
        id: 'gym_heroes_029_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${MISTY_PREFIX} ${CLOYSTER$3.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: CLOYSTER$3.number,
        pokemonType: CLOYSTER$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 29,
        stage: CLOYSTER$3.stage,
        trainerImageUrl: MISTY$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        hitPoints: null,
        id: 'gym_heroes_030_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${MISTY_PREFIX} ${GOLDEEN$2.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: GOLDEEN$2.number,
        pokemonType: GOLDEEN$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 30,
        trainerImageUrl: MISTY$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        evolvesFrom: POLIWHIRL$6.name,
        evolutionBoxImageUrl: POLIWHIRL$6.images[0].value,
        hitPoints: null,
        id: 'gym_heroes_031_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${MISTY_PREFIX} ${POLIWRATH$4.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: POLIWRATH$4.number,
        pokemonType: POLIWRATH$4.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 31,
        stage: POLIWRATH$4.stage,
        trainerImageUrl: MISTY$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        hitPoints: null,
        id: 'gym_heroes_032_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${MISTY_PREFIX} ${TENTACOOL$1.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: TENTACOOL$1.number,
        pokemonType: TENTACOOL$1.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 32,
        trainerImageUrl: MISTY$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        hitPoints: null,
        id: 'gym_heroes_033_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${ROCKET_PREFIX} ${SNORLAX$2.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: SNORLAX$2.number,
        pokemonType: SNORLAX$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 33,
        trainerImageUrl: ROCKET$1.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        evolvesFrom: VENONAT$2.name,
        evolutionBoxImageUrl: VENONAT$2.images[0].value,
        hitPoints: null,
        id: 'gym_heroes_034_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${SABRINA_PREFIX} ${VENOMOTH$3.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: VENOMOTH$3.number,
        pokemonType: VENOMOTH$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 34,
        stage: VENOMOTH$3.stage,
        trainerImageUrl: SABRINA$3.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        hitPoints: null,
        id: 'gym_heroes_035_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${BLAINE_PREFIX} ${GROWLITHE$7.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: GROWLITHE$7.number,
        pokemonType: GROWLITHE$7.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 35,
        trainerImageUrl: BLAINE$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        hitPoints: null,
        id: 'gym_heroes_036_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${BLAINE_PREFIX} ${KANGASKHAN.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: KANGASKHAN.number,
        pokemonType: KANGASKHAN.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 36,
        trainerImageUrl: BLAINE$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        evolvesFrom: null,
        evolutionBoxImageUrl: null,
        hitPoints: null,
        id: 'gym_heroes_037_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${BLAINE_PREFIX} ${MAGMAR$6.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: MAGMAR$6.number,
        pokemonType: MAGMAR$6.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 37,
        trainerImageUrl: BLAINE$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        hitPoints: null,
        id: 'gym_heroes_038_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${BROCK_PREFIX} ${GEODUDE$4.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: GEODUDE$4.number,
        pokemonType: GEODUDE$4.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 38,
        trainerImageUrl: BROCK$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        evolvesFrom: ZUBAT$6.name,
        evolutionBoxImageUrl: ZUBAT$6.images[0].value,
        hitPoints: null,
        id: 'gym_heroes_039_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${BROCK_PREFIX} ${GOLBAT$8.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: GOLBAT$8.number,
        pokemonType: GOLBAT$8.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 39,
        stage: GOLBAT$8.stage,
        trainerImageUrl: BROCK$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        evolvesFrom: GEODUDE$4.name,
        evolutionBoxImageUrl: GEODUDE$4.images[0].value,
        hitPoints: null,
        id: 'gym_heroes_040_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${BROCK_PREFIX} ${GRAVELER$6.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: GRAVELER$6.number,
        pokemonType: GRAVELER$6.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 40,
        stage: GRAVELER$6.stage,
        trainerImageUrl: BROCK$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        hitPoints: null,
        id: 'gym_heroes_041_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${BROCK_PREFIX} ${LICKITUNG$2.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: LICKITUNG$2.number,
        pokemonType: LICKITUNG$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 41,
        trainerImageUrl: BROCK$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        hitPoints: null,
        id: 'gym_heroes_042_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${ERIKA_PREFIX} ${DRATINI$3.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: DRATINI$3.number,
        pokemonType: DRATINI$3.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 42,
        trainerImageUrl: ERIKA$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        hitPoints: null,
        id: 'gym_heroes_043_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${ERIKA_PREFIX} ${EXEGGCUTE$1.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: EXEGGCUTE$1.number,
        pokemonType: EXEGGCUTE$1.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 43,
        trainerImageUrl: ERIKA$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        evolvesFrom: EXEGGCUTE$1.name,
        evolutionBoxImageUrl: EXEGGCUTE$1.images[0].value,
        hitPoints: null,
        id: 'gym_heroes_044_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${ERIKA_PREFIX} ${EXEGGUTOR$3.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: EXEGGUTOR$3.number,
        pokemonType: EXEGGUTOR$3.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 44,
        stage: EXEGGUTOR$3.stage,
        trainerImageUrl: ERIKA$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        evolvesFrom: ODDISH$4.name,
        evolutionBoxImageUrl: ODDISH$4.images[0].value,
        hitPoints: null,
        id: 'gym_heroes_045_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${ERIKA_PREFIX} ${GLOOM$5.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: GLOOM$5.number,
        pokemonType: GLOOM$5.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 45,
        stage: GLOOM$5.stage,
        trainerImageUrl: ERIKA$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        evolvesFrom: null,
        evolutionBoxImageUrl: null,
        hitPoints: null,
        id: 'gym_heroes_046_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${ERIKA_PREFIX} ${GLOOM$5.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: GLOOM$5.number,
        pokemonType: GLOOM$5.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 46,
        stage: GLOOM$5.stage,
        trainerImageUrl: ERIKA$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        hitPoints: null,
        id: 'gym_heroes_047_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${ERIKA_PREFIX} ${ODDISH$4.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: ODDISH$4.number,
        pokemonType: ODDISH$4.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 47,
        trainerImageUrl: ERIKA$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        evolvesFrom: BELLSPROUT$1.name,
        evolutionBoxImageUrl: BELLSPROUT$1.images[0].value,
        hitPoints: null,
        id: 'gym_heroes_048_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${ERIKA_PREFIX} ${WEEPINBELL.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: WEEPINBELL.number,
        pokemonType: WEEPINBELL.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 48,
        stage: WEEPINBELL.stage,
        trainerImageUrl: ERIKA$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        evolvesFrom: BELLSPROUT$1.name,
        evolutionBoxImageUrl: BELLSPROUT$1.images[0].value,
        hitPoints: null,
        id: 'gym_heroes_049_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${ERIKA_PREFIX} ${WEEPINBELL.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: WEEPINBELL.number,
        pokemonType: WEEPINBELL.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 49,
        stage: WEEPINBELL.stage,
        trainerImageUrl: ERIKA$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        hitPoints: null,
        id: 'gym_heroes_050_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${LT_SURGE_PREFIX} ${MAGNEMITE$7.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: MAGNEMITE$7.number,
        pokemonType: MAGNEMITE$7.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 50,
        trainerImageUrl: LT_SURGE$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        evolvesFrom: RATTATA$4.name,
        evolutionBoxImageUrl: RATTATA$4.images[0].value,
        hitPoints: null,
        id: 'gym_heroes_051_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${LT_SURGE_PREFIX} ${RATICATE$4.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: RATICATE$4.number,
        pokemonType: RATICATE$4.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 51,
        stage: RATICATE$4.stage,
        trainerImageUrl: LT_SURGE$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        hitPoints: null,
        id: 'gym_heroes_052_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${LT_SURGE_PREFIX} ${SPEAROW$2.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: SPEAROW$2.number,
        pokemonType: SPEAROW$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 52,
        trainerImageUrl: LT_SURGE$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        evolvesFrom: POLIWAG$4.name,
        evolutionBoxImageUrl: POLIWAG$4.images[0].value,
        hitPoints: null,
        id: 'gym_heroes_053_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${MISTY_PREFIX} ${POLIWHIRL$6.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: POLIWHIRL$6.number,
        pokemonType: POLIWHIRL$6.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 53,
        stage: POLIWHIRL$6.stage,
        trainerImageUrl: MISTY$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        hitPoints: null,
        id: 'gym_heroes_054_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${MISTY_PREFIX} ${PSYDUCK$6.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: PSYDUCK$6.number,
        pokemonType: PSYDUCK$6.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 54,
        trainerImageUrl: MISTY$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        evolvesFrom: GOLDEEN$2.name,
        evolutionBoxImageUrl: GOLDEEN$2.images[0].value,
        hitPoints: null,
        id: 'gym_heroes_055_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${MISTY_PREFIX} ${SEAKING$1.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: SEAKING$1.number,
        pokemonType: SEAKING$1.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 55,
        stage: SEAKING$1.stage,
        trainerImageUrl: MISTY$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        evolvesFrom: STARYU$4.name,
        evolutionBoxImageUrl: STARYU$4.images[0].value,
        hitPoints: null,
        id: 'gym_heroes_056_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${MISTY_PREFIX} ${STARMIE$3.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: STARMIE$3.number,
        pokemonType: STARMIE$3.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 56,
        stage: STARMIE$3.stage,
        trainerImageUrl: MISTY$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        hitPoints: null,
        id: 'gym_heroes_057_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${MISTY_PREFIX} ${TENTACOOL$1.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: TENTACOOL$1.number,
        pokemonType: TENTACOOL$1.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 57,
        trainerImageUrl: MISTY$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        evolvesFrom: GASTLY$6.name,
        evolutionBoxImageUrl: GASTLY$6.images[0].value,
        hitPoints: null,
        id: 'gym_heroes_058_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${SABRINA_PREFIX} ${HAUNTER$8.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: HAUNTER$8.number,
        pokemonType: HAUNTER$8.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 58,
        stage: HAUNTER$8.stage,
        trainerImageUrl: SABRINA$3.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        evolvesFrom: null,
        evolutionBoxImageUrl: null,
        hitPoints: null,
        id: 'gym_heroes_059_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${SABRINA_PREFIX} ${JYNX$4.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: JYNX$4.number,
        pokemonType: JYNX$4.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 59,
        trainerImageUrl: SABRINA$3.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        evolvesFrom: SLOWPOKE$5.name,
        evolutionBoxImageUrl: SLOWPOKE$5.images[0].value,
        hitPoints: null,
        id: 'gym_heroes_060_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: SLOWBRO$4.name,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: SLOWBRO$4.number,
        pokemonType: SLOWBRO$4.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 60,
        stage: SLOWBRO$4.stage,
        trainerImageUrl: SABRINA$3.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        evolvesFrom: null,
        evolutionBoxImageUrl: null,
        hitPoints: null,
        id: 'gym_heroes_061_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${BLAINE_PREFIX} ${CHARMANDER$3.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: CHARMANDER$3.number,
        pokemonType: CHARMANDER$3.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 61,
        trainerImageUrl: BLAINE$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        hitPoints: null,
        id: 'gym_heroes_062_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${BLAINE_PREFIX} ${GROWLITHE$7.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: GROWLITHE$7.number,
        pokemonType: GROWLITHE$7.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 62,
        trainerImageUrl: BLAINE$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        evolvesFrom: null,
        evolutionBoxImageUrl: null,
        hitPoints: null,
        id: 'gym_heroes_063_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${BLAINE_PREFIX} ${PONYTA$5.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: PONYTA$5.number,
        pokemonType: PONYTA$5.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 63,
        trainerImageUrl: BLAINE$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        hitPoints: null,
        id: 'gym_heroes_064_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${BLAINE_PREFIX} ${TAUROS$2.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: TAUROS$2.number,
        pokemonType: TAUROS$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 64,
        trainerImageUrl: BLAINE$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        hitPoints: null,
        id: 'gym_heroes_065_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${BLAINE_PREFIX} ${VULPIX$5.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: VULPIX$5.number,
        pokemonType: VULPIX$5.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 65,
        trainerImageUrl: BLAINE$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        hitPoints: null,
        id: 'gym_heroes_066_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${BROCK_PREFIX} ${GEODUDE$4.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: GEODUDE$4.number,
        pokemonType: GEODUDE$4.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 66,
        trainerImageUrl: BROCK$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        hitPoints: null,
        id: 'gym_heroes_067_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${BROCK_PREFIX} ${MANKEY$2.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: MANKEY$2.number,
        pokemonType: MANKEY$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 67,
        trainerImageUrl: BROCK$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        evolvesFrom: null,
        evolutionBoxImageUrl: null,
        hitPoints: null,
        id: 'gym_heroes_068_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${BROCK_PREFIX} ${MANKEY$2.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: MANKEY$2.number,
        pokemonType: MANKEY$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 68,
        trainerImageUrl: BROCK$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        hitPoints: null,
        id: 'gym_heroes_069_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${BROCK_PREFIX} ${ONIX$3.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: ONIX$3.number,
        pokemonType: ONIX$3.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 69,
        trainerImageUrl: BROCK$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        hitPoints: null,
        id: 'gym_heroes_070_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${BROCK_PREFIX} ${RHYHORN$3.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: RHYHORN$3.number,
        pokemonType: RHYHORN$3.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 70,
        trainerImageUrl: BROCK$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        hitPoints: null,
        id: 'gym_heroes_071_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${BROCK_PREFIX} ${SANDSHREW$3.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: SANDSHREW$3.number,
        pokemonType: SANDSHREW$3.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 71,
        trainerImageUrl: BROCK$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        evolvesFrom: null,
        evolutionBoxImageUrl: null,
        hitPoints: null,
        id: 'gym_heroes_072_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${BROCK_PREFIX} ${SANDSHREW$3.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: SANDSHREW$3.number,
        pokemonType: SANDSHREW$3.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 72,
        trainerImageUrl: BROCK$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        hitPoints: null,
        id: 'gym_heroes_073_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${BROCK_PREFIX} ${VULPIX$5.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: VULPIX$5.number,
        pokemonType: VULPIX$5.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 73,
        trainerImageUrl: BROCK$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        hitPoints: null,
        id: 'gym_heroes_074_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${BROCK_PREFIX} ${ZUBAT$6.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: ZUBAT$6.number,
        pokemonType: ZUBAT$6.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 74,
        trainerImageUrl: BROCK$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        hitPoints: null,
        id: 'gym_heroes_075_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${ERIKA_PREFIX} ${BELLSPROUT$1.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: BELLSPROUT$1.number,
        pokemonType: BELLSPROUT$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 75,
        trainerImageUrl: ERIKA$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        hitPoints: null,
        id: 'gym_heroes_076_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${ERIKA_PREFIX} ${BELLSPROUT$1.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: BELLSPROUT$1.number,
        pokemonType: BELLSPROUT$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 76,
        trainerImageUrl: ERIKA$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        hitPoints: null,
        id: 'gym_heroes_077_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${ERIKA_PREFIX} ${EXEGGCUTE$1.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: EXEGGCUTE$1.number,
        pokemonType: EXEGGCUTE$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 77,
        trainerImageUrl: ERIKA$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        hitPoints: null,
        id: 'gym_heroes_078_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${ERIKA_PREFIX} ${ODDISH$4.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: ODDISH$4.number,
        pokemonType: ODDISH$4.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 78,
        trainerImageUrl: ERIKA$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        hitPoints: null,
        id: 'gym_heroes_079_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${ERIKA_PREFIX} ${TANGELA$1.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: TANGELA$1.number,
        pokemonType: TANGELA$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 79,
        trainerImageUrl: ERIKA$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        hitPoints: null,
        id: 'gym_heroes_080_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${LT_SURGE_PREFIX} ${MAGNEMITE$7.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: MAGNEMITE$7.number,
        pokemonType: MAGNEMITE$7.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 80,
        trainerImageUrl: LT_SURGE$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        hitPoints: null,
        id: 'gym_heroes_081_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${LT_SURGE_PREFIX} ${PIKACHU$b.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: PIKACHU$b.number,
        pokemonType: PIKACHU$b.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 81,
        trainerImageUrl: LT_SURGE$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        hitPoints: null,
        id: 'gym_heroes_082_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${LT_SURGE_PREFIX} ${RATTATA$4.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: RATTATA$4.number,
        pokemonType: RATTATA$4.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 82,
        trainerImageUrl: LT_SURGE$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        evolvesFrom: null,
        evolutionBoxImageUrl: null,
        hitPoints: null,
        id: 'gym_heroes_083_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${LT_SURGE_PREFIX} ${SPEAROW$2.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: SPEAROW$2.number,
        pokemonType: SPEAROW$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 83,
        trainerImageUrl: LT_SURGE$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        hitPoints: null,
        id: 'gym_heroes_084_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${LT_SURGE_PREFIX} ${VOLTORB$3.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: VOLTORB$3.number,
        pokemonType: VOLTORB$3.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 84,
        trainerImageUrl: LT_SURGE$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        hitPoints: null,
        id: 'gym_heroes_085_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${MISTY_PREFIX} ${GOLDEEN$2.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: GOLDEEN$2.number,
        pokemonType: GOLDEEN$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 85,
        trainerImageUrl: MISTY$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        evolvesFrom: null,
        evolutionBoxImageUrl: null,
        hitPoints: null,
        id: 'gym_heroes_086_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${MISTY_PREFIX} ${HORSEA$3.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: HORSEA$3.number,
        pokemonType: HORSEA$3.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 86,
        trainerImageUrl: MISTY$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        hitPoints: null,
        id: 'gym_heroes_087_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${MISTY_PREFIX} ${POLIWAG$4.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: POLIWAG$4.number,
        pokemonType: POLIWAG$4.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 87,
        trainerImageUrl: MISTY$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        evolvesFrom: null,
        evolutionBoxImageUrl: null,
        hitPoints: null,
        id: 'gym_heroes_088_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${MISTY_PREFIX} ${SEEL$4.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: SEEL$4.number,
        pokemonType: SEEL$4.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 88,
        trainerImageUrl: MISTY$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        hitPoints: null,
        id: 'gym_heroes_089_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${MISTY_PREFIX} ${SHELLDER$3.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: SHELLDER$3.number,
        pokemonType: SHELLDER$3.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 89,
        trainerImageUrl: MISTY$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        hitPoints: null,
        id: 'gym_heroes_090_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${MISTY_PREFIX} ${STARYU$4.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: STARYU$4.number,
        pokemonType: STARYU$4.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 90,
        trainerImageUrl: MISTY$2.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        hitPoints: null,
        id: 'gym_heroes_091_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${SABRINA_PREFIX} ${ABRA$5.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: ABRA$5.number,
        pokemonType: ABRA$5.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 91,
        trainerImageUrl: SABRINA$3.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        hitPoints: null,
        id: 'gym_heroes_092_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${SABRINA_PREFIX} ${DROWZEE$4.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: DROWZEE$4.number,
        pokemonType: DROWZEE$4.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 92,
        trainerImageUrl: SABRINA$3.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        hitPoints: null,
        id: 'gym_heroes_093_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${SABRINA_PREFIX} ${GASTLY$6.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: GASTLY$6.number,
        pokemonType: GASTLY$6.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 93,
        trainerImageUrl: SABRINA$3.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        hitPoints: null,
        id: 'gym_heroes_094_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${SABRINA_PREFIX} ${MR_MIME$1.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: MR_MIME$1.number,
        pokemonType: MR_MIME$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 94,
        trainerImageUrl: SABRINA$3.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        hitPoints: null,
        id: 'gym_heroes_095_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${SABRINA_PREFIX} ${SLOWPOKE$5.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: SLOWPOKE$5.number,
        pokemonType: SLOWPOKE$5.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 95,
        trainerImageUrl: SABRINA$3.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        hitPoints: null,
        id: 'gym_heroes_096_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${SABRINA_PREFIX} ${VENONAT$2.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: VENONAT$2.number,
        pokemonType: VENONAT$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 96,
        trainerImageUrl: SABRINA$3.images[0].value,
        weight: null,
    },
];

const { BLAINES_GAMBLE, BLAINES_LAST_RESORT, BLAINES_QUIZ_1, BROCKS_TRAINING_METHOD, CELADON_CITY_GYM, CERULEAN_CITY_GYM, CHARITY, ENERGY_FLOW: ENERGY_FLOW$1, ERIKAS_MAIDS, ERIKAS_PERFUME, GOOD_MANNERS, LT_SURGES_TREATY, MINION_OF_TEAM_ROCKET, MISTYS_DUEL, MISTYS_WRATH, NARROW_GYM, NO_REMOVAL_GYM, PEWTER_CITY_GYM, RECALL, SABRINAS_ESP, SABRINAS_GAZE, SECRET_MISSION, TICKLING_MACHINE, THE_ROCKETS_TRAINING_GYM, TRASH_EXCHANGE, VERMILION_CITY_GYM, } = GYM_TRAINERS;
const GYM_HEROES_TRAINERS = [
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_heroes_097_en',
        illustrator: null,
        name: BLAINES_QUIZ_1.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 97,
    },
    {
        ...GYM_HEROES_HOLOS[14],
        holo: false,
        id: 'gym_heroes_098_en',
        setNumber: 98,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_heroes_099_en',
        illustrator: null,
        name: CHARITY.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 99,
    },
    {
        ...GYM_HEROES_HOLOS[15],
        holo: false,
        id: 'gym_heroes_100_en',
        setNumber: 100,
    },
    {
        ...GYM_HEROES_HOLOS[16],
        holo: false,
        id: 'gym_heroes_101_en',
        setNumber: 101,
    },
    {
        ...GYM_HEROES_HOLOS[17],
        holo: false,
        id: 'gym_heroes_102_en',
        setNumber: 102,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_heroes_103_en',
        illustrator: null,
        name: NO_REMOVAL_GYM.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 103,
        subtitle: TRAINER_CARD_SUBTITLES.STADIUM_CARD,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_heroes_104_en',
        illustrator: null,
        name: THE_ROCKETS_TRAINING_GYM.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 104,
        subtitle: TRAINER_CARD_SUBTITLES.STADIUM_CARD,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_heroes_105_en',
        illustrator: null,
        name: BLAINES_LAST_RESORT.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 105,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_heroes_106_en',
        illustrator: null,
        name: BROCKS_TRAINING_METHOD.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 106,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_heroes_107_en',
        illustrator: null,
        name: CELADON_CITY_GYM.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 107,
        subtitle: TRAINER_CARD_SUBTITLES.STADIUM_CARD,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_heroes_108_en',
        illustrator: null,
        name: CERULEAN_CITY_GYM.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 108,
        subtitle: TRAINER_CARD_SUBTITLES.STADIUM_CARD,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_heroes_109_en',
        illustrator: null,
        name: ERIKAS_MAIDS.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 109,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_heroes_110_en',
        illustrator: null,
        name: ERIKAS_PERFUME.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 110,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_heroes_111_en',
        illustrator: null,
        name: GOOD_MANNERS.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 111,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_heroes_112_en',
        illustrator: null,
        name: LT_SURGES_TREATY.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 112,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_heroes_113_en',
        illustrator: null,
        name: MINION_OF_TEAM_ROCKET.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 113,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_heroes_114_en',
        illustrator: null,
        name: MISTYS_WRATH.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 114,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_heroes_115_en',
        illustrator: null,
        name: PEWTER_CITY_GYM.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 115,
        subtitle: TRAINER_CARD_SUBTITLES.STADIUM_CARD,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_heroes_116_en',
        illustrator: null,
        name: RECALL.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 116,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_heroes_117_en',
        illustrator: null,
        name: SABRINAS_ESP.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 117,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_heroes_118_en',
        illustrator: null,
        name: SECRET_MISSION.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 118,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_heroes_119_en',
        illustrator: null,
        name: TICKLING_MACHINE.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 119,
        subtitle: TRAINER_CARD_SUBTITLES.ROCKETS_SECRET_ROBOT,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_heroes_120_en',
        illustrator: null,
        name: VERMILION_CITY_GYM.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 120,
        subtitle: TRAINER_CARD_SUBTITLES.STADIUM_CARD,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_heroes_121_en',
        illustrator: null,
        name: BLAINES_GAMBLE.name,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 121,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_heroes_122_en',
        illustrator: null,
        name: ENERGY_FLOW$1.name,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 122,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_heroes_123_en',
        illustrator: null,
        name: MISTYS_DUEL.name,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 123,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_heroes_124_en',
        illustrator: null,
        name: NARROW_GYM.name,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 124,
        subtitle: TRAINER_CARD_SUBTITLES.STADIUM_CARD,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_heroes_125_en',
        illustrator: null,
        name: SABRINAS_GAZE.name,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 125,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_heroes_126_en',
        illustrator: null,
        name: TRASH_EXCHANGE.name,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 126,
    },
];

const GYM_HEROES_ENERGIES = [
    {
        cardTemplate: CARD_TEMPLATES.ENERGY,
        energyType: ENERGY_TYPES.FIGHTING,
        id: 'gym_heroes_127_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        setNumber: 127,
    },
    {
        cardTemplate: CARD_TEMPLATES.ENERGY,
        energyType: ENERGY_TYPES.FIRE,
        id: 'gym_heroes_128_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        setNumber: 128,
    },
    {
        cardTemplate: CARD_TEMPLATES.ENERGY,
        energyType: ENERGY_TYPES.GRASS,
        id: 'gym_heroes_129_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        setNumber: 129,
    },
    {
        cardTemplate: CARD_TEMPLATES.ENERGY,
        energyType: ENERGY_TYPES.LIGHTNING,
        id: 'gym_heroes_130_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        setNumber: 130,
    },
    {
        cardTemplate: CARD_TEMPLATES.ENERGY,
        energyType: ENERGY_TYPES.PSYCHIC,
        id: 'gym_heroes_131_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        setNumber: 131,
    },
    {
        cardTemplate: CARD_TEMPLATES.ENERGY,
        energyType: ENERGY_TYPES.WATER,
        id: 'gym_heroes_132_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        setNumber: 132,
    },
];

const setId$e = CARD_SETS.GYM_HEROES.value;
const setName$e = CARD_SETS.GYM_HEROES.label;
const setTotal$b = GYM_SET_TOTAL;
const GYM_HEROES_SET = {
    cardCounts: {
        holoRares: 19,
        rares: 23,
        uncommons: 42,
        commons: 42,
        energies: 6,
    },
    copyright: COPYRIGHTS.GYM_SET,
    description: SET_DESCRIPTIONS.GYM_HEROES,
    holoSheetType: CARD_HOLO_SHEETS.COSMOS_2,
    id: setId$e,
    imageUrl: 'https://cdn.shopify.com/s/files/1/0840/1659/5249/collections/gym-heroes-cat-bg.jpg',
    name: setName$e,
    packInfo: BOOSTER_PACKS.GYM_HEROES,
    releaseDate: RELEASE_DATES.GYM_HEROES,
    reverseHoloSheetType: CARD_HOLO_SHEETS.COSMOS_2,
    setSymbol: setId$e,
    setTotal: setTotal$b,
    cards: [
        ...GYM_HEROES_HOLOS,
        ...GYM_HEROES_NON_HOLOS,
        ...GYM_HEROES_TRAINERS,
        ...GYM_HEROES_ENERGIES,
    ],
    themeDecks: [],
};

const { ALAKAZAM: ALAKAZAM$3, ARCANINE: ARCANINE$3, BEEDRILL: BEEDRILL$3, CHARIZARD: CHARIZARD$6, CHARMELEON: CHARMELEON$6, DITTO: DITTO$2, GOLDUCK: GOLDUCK$4, GROWLITHE: GROWLITHE$6, GYARADOS: GYARADOS$4, IVYSAUR: IVYSAUR$6, KADABRA: KADABRA$7, KAKUNA: KAKUNA$4, MACHAMP: MACHAMP$6, MACHOKE: MACHOKE$9, MAGIKARP: MAGIKARP$7, MEOWTH: MEOWTH$5, MEWTWO: MEWTWO$3, NIDOKING, NIDORINO: NIDORINO$1, NINETALES: NINETALES$4, PERSIAN: PERSIAN$4, PIKACHU: PIKACHU$a, PSYDUCK: PSYDUCK$5, RAICHU: RAICHU$7, VENUSAUR: VENUSAUR$4, VULPIX: VULPIX$4, ZAPDOS: ZAPDOS$2, } = GEN_1_POKEMON;
const { BLAINE: BLAINE$1, BROCK: BROCK$1, ERIKA: ERIKA$1, GIOVANNI: GIOVANNI$1, KOGA: KOGA$1, LT_SURGE: LT_SURGE$1, MISTY: MISTY$1, ROCKET, SABRINA: SABRINA$2 } = GYM_LEADERS;
const GYM_CHALLENGE_HOLOS = [
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lights-kadabra_hrrzpa.jpg',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: ENERGY_TYPES.WATER,
        evolvesFrom: `${BLAINE_PREFIX} ${GROWLITHE$6.name}`,
        evolutionBoxImageUrl: GROWLITHE$6.images[0].value,
        hitPoints: 90,
        holo: true,
        holoStrength: 0.7,
        id: 'gym_challenge_001_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 6,
        lengthInches: 3,
        moves: [MOVES.HEAT_TACKLE, MOVES.FIRESTORM],
        name: `${BLAINE_PREFIX} ${ARCANINE$3.name}`,
        pokemonImagePositionX: 53,
        pokemonImagePositionY: 42,
        pokemonImageSize: 66,
        pokemonImageUrl: ARCANINE$3.images[1].value,
        pokemonLevel: 42,
        pokemonNumber: ARCANINE$3.number,
        pokemonType: ARCANINE$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 1,
        stage: ARCANINE$3.stage,
        trainerImageUrl: BLAINE$1.images[0].value,
        weight: 342,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lights-kadabra_hrrzpa.jpg',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: ENERGY_TYPES.WATER,
        evolvesFrom: `${BLAINE_PREFIX} ${CHARMELEON$6.name}`,
        evolutionBoxImageUrl: CHARMELEON$6.images[0].value,
        hitPoints: 100,
        holo: true,
        holoStrength: 0.7,
        id: 'gym_challenge_002_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [MOVES.ROARING_FLAMES, MOVES.FLAME_JET],
        name: `${BLAINE_PREFIX} ${CHARIZARD$6.name}`,
        pokemonImagePositionX: 98,
        pokemonImagePositionY: 12,
        pokemonImageSize: 74,
        pokemonImageUrl: CHARIZARD$6.images[2].value,
        pokemonLevel: 50,
        pokemonNumber: CHARIZARD$6.number,
        pokemonType: CHARIZARD$6.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 2,
        stage: CHARIZARD$6.stage,
        trainerImageUrl: BLAINE$1.images[0].value,
        weight: 200,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/sunset-oddish_oynkri.jpg',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: ENERGY_TYPES.WATER,
        evolvesFrom: `${BROCK_PREFIX} ${VULPIX$4.name}`,
        evolutionBoxImageUrl: VULPIX$4.images[0].value,
        hitPoints: 70,
        holo: true,
        holoStrength: 0.7,
        id: 'gym_challenge_003_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 3,
        lengthInches: 7,
        moves: [MOVES.SHAPESHIFT, MOVES.WILL_O_THE_WISP],
        name: `${BROCK_PREFIX} ${NINETALES$4.name}`,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 41,
        pokemonImageSize: 47,
        pokemonImageUrl: NINETALES$4.images[1].value,
        pokemonLevel: 30,
        pokemonNumber: NINETALES$4.number,
        pokemonType: NINETALES$4.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 3,
        stage: NINETALES$4.stage,
        trainerImageUrl: BROCK$1.images[0].value,
        weight: 44,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/foliage-erikas-gloom_v2u2vs.jpg',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        evolvesFrom: `${ERIKA_PREFIX} ${IVYSAUR$6.name}`,
        evolutionBoxImageUrl: IVYSAUR$6.images[0].value,
        hitPoints: 90,
        holo: true,
        holoStrength: 0.7,
        id: 'gym_challenge_004_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 6,
        lengthInches: 7,
        moves: [MOVES.GROWTH, MOVES.WIDE_SOLARBEAM],
        name: `${ERIKA_PREFIX} ${VENUSAUR$4.name}`,
        pokemonImagePositionX: 88,
        pokemonImagePositionY: 47,
        pokemonImageSize: 54,
        pokemonImageUrl: VENUSAUR$4.images[1].value,
        pokemonLevel: 45,
        pokemonNumber: VENUSAUR$4.number,
        pokemonType: VENUSAUR$4.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 4,
        stage: VENUSAUR$4.stage,
        trainerImageUrl: ERIKA$1.images[0].value,
        weight: 221,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/foliage-erikas-gloom_v2u2vs.jpg',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.GRASS,
        evolvesFrom: `${GIOVANNI_PREFIX} ${MAGIKARP$7.name}`,
        evolutionBoxImageUrl: MAGIKARP$7.images[0].value,
        hitPoints: 90,
        holo: true,
        holoStrength: 0.7,
        id: 'gym_challenge_005_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        isNameExtraCondensed: true,
        lengthFeet: 21,
        lengthInches: 4,
        moves: [MOVES.SUMMON_STORM, MOVES.DRAGON_TORNADO],
        name: `${GIOVANNI_PREFIX} ${GYARADOS$4.name}`,
        pokemonImageRotation: 4,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 38,
        pokemonImageSize: 42,
        pokemonImageUrl: GYARADOS$4.images[2].value,
        pokemonLevel: 40,
        pokemonNumber: GYARADOS$4.number,
        pokemonType: GYARADOS$4.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 5,
        stage: GYARADOS$4.stage,
        trainerImageUrl: GIOVANNI$1.images[0].value,
        weight: 518,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lights-rocket-machop_w8x73u.jpg',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        evolvesFrom: `${GIOVANNI_PREFIX} ${MACHOKE$9.name}`,
        evolutionBoxImageUrl: MACHOKE$9.images[0].value,
        hitPoints: 100,
        holo: true,
        holoStrength: 0.7,
        id: 'gym_challenge_006_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        isNameExtraCondensed: true,
        lengthFeet: 5,
        lengthInches: 3,
        moves: [MOVES.FORTITUDE, MOVES.HURRICANE_PUNCH],
        name: `${GIOVANNI_PREFIX} ${MACHAMP$6.name}`,
        pokemonImagePositionX: 52,
        pokemonImagePositionY: 45,
        pokemonImageSize: 69,
        pokemonImageUrl: MACHAMP$6.images[2].value,
        pokemonLevel: 50,
        pokemonNumber: MACHAMP$6.number,
        pokemonType: MACHAMP$6.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 6,
        stage: MACHAMP$6.stage,
        trainerImageUrl: GIOVANNI$1.images[0].value,
        weight: 287,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-growlithe_nyginj.jpg',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        evolvesFrom: `${GIOVANNI_PREFIX} ${NIDORINO$1.name}`,
        evolutionBoxImageUrl: NIDORINO$1.images[0].value,
        hitPoints: 120,
        holo: true,
        holoStrength: 0.7,
        id: 'gym_challenge_007_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        isNameExtraCondensed: true,
        lengthFeet: 4,
        lengthInches: 7,
        moves: [MOVES.INTIMIDATE, MOVES.TUMBLING_ATTACK],
        name: `${GIOVANNI_PREFIX} ${NIDOKING.name}`,
        pokemonImagePositionX: 227,
        pokemonImagePositionY: 71,
        pokemonImageSize: 91,
        pokemonImageUrl: NIDOKING.images[1].value,
        pokemonLevel: 58,
        pokemonNumber: NIDOKING.number,
        pokemonType: NIDOKING.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 7,
        stage: NIDOKING.stage,
        trainerImageUrl: GIOVANNI$1.images[0].value,
        weight: 137,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-brocks-vulpix-alt_dymiuc.png',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: ENERGY_TYPES.PSYCHIC,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: `${GIOVANNI_PREFIX} ${MEOWTH$5.name}`,
        evolutionBoxImageUrl: MEOWTH$5.images[0].value,
        hitPoints: 60,
        holo: true,
        holoStrength: 0.7,
        id: 'gym_challenge_008_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [MOVES.CALL_THE_BOSS, MOVES.AMBUSH],
        name: `${GIOVANNI_PREFIX} ${PERSIAN$4.name}`,
        pokemonImagePositionX: 57,
        pokemonImagePositionY: 54,
        pokemonImageRotation: -8,
        pokemonImageSize: 33,
        pokemonImageUrl: PERSIAN$4.images[1].value,
        pokemonLevel: 23,
        pokemonNumber: PERSIAN$4.number,
        pokemonType: PERSIAN$4.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 8,
        stage: PERSIAN$4.stage,
        trainerImageUrl: GIOVANNI$1.images[0].value,
        weight: 71,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-hitmonlee_xqc8ip.jpg',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        evolvesFrom: `${KOGA_PREFIX} ${KAKUNA$4.name}`,
        evolutionBoxImageUrl: KAKUNA$4.images[0].value,
        hitPoints: 80,
        holo: true,
        holoStrength: 0.7,
        id: 'gym_challenge_009_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [MOVES.NERVE_POISON, MOVES.HYPER_NEEDLE],
        name: `${KOGA_PREFIX} ${BEEDRILL$3.name}`,
        pokemonImagePositionX: 136,
        pokemonImagePositionY: -10,
        pokemonImageRotation: 28,
        pokemonImageSize: 75,
        pokemonImageUrl: BEEDRILL$3.images[1].value,
        pokemonLevel: 34,
        pokemonNumber: BEEDRILL$3.number,
        pokemonType: BEEDRILL$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 9,
        stage: BEEDRILL$3.stage,
        trainerImageUrl: KOGA$1.images[0].value,
        weight: 65,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-chansey_fmsdky.jpg',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: ENERGY_TYPES.PSYCHIC,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 40,
        holo: true,
        holoStrength: 0.7,
        id: 'gym_challenge_010_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 1,
        lengthInches: 0,
        moves: [MOVES.GIANT_GROWTH, MOVES.POUND],
        name: `${KOGA_PREFIX} ${DITTO$2.name}`,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 40,
        pokemonImageSize: 68,
        pokemonImageUrl: DITTO$2.images[1].value,
        pokemonLevel: 12,
        pokemonNumber: DITTO$2.number,
        pokemonType: DITTO$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 10,
        trainerImageUrl: KOGA$1.images[0].value,
        weight: 9,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-brocks-zubat_jyfmxr.jpg',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: `${LT_SURGE_PREFIX} ${PIKACHU$a.name}`,
        evolutionBoxImageUrl: PIKACHU$a.images[0].value,
        hitPoints: 80,
        holo: true,
        holoStrength: 0.7,
        id: 'gym_challenge_011_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [MOVES.KERZAP, MOVES.THUNDERTACKLE],
        name: `${LT_SURGE_PREFIX} ${RAICHU$7.name}`,
        pokemonImagePositionX: 35,
        pokemonImagePositionY: -145,
        pokemonImageSize: 69,
        pokemonImageUrl: RAICHU$7.images[4].value,
        pokemonLevel: 38,
        pokemonNumber: RAICHU$7.number,
        pokemonType: RAICHU$7.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 11,
        stage: RAICHU$7.stage,
        trainerImageUrl: LT_SURGE$1.images[0].value,
        weight: 66,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/water-poliwhirl_oxfvdh.jpg',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.GRASS,
        evolvesFrom: `${MISTY_PREFIX} ${PSYDUCK$5.name}`,
        evolutionBoxImageUrl: PSYDUCK$5.images[0].value,
        hitPoints: 70,
        holo: true,
        holoStrength: 0.7,
        id: 'gym_challenge_012_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [MOVES.ELECTRO_BEAM, MOVES.SUPER_REMOVAL],
        name: `${MISTY_PREFIX} ${GOLDUCK$4.name}`,
        pokemonImagePositionX: 38,
        pokemonImagePositionY: 44,
        pokemonImageSize: 42,
        pokemonImageUrl: GOLDUCK$4.images[3].value,
        pokemonLevel: 32,
        pokemonNumber: GOLDUCK$4.number,
        pokemonType: GOLDUCK$4.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 12,
        stage: GOLDUCK$4.stage,
        trainerImageUrl: MISTY$1.images[0].value,
        weight: 169,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/water-poliwhirl_oxfvdh.jpg',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.GRASS,
        evolvesFrom: `${MISTY_PREFIX} ${MAGIKARP$7.name}`,
        evolutionBoxImageUrl: MAGIKARP$7.images[0].value,
        hitPoints: 100,
        holo: true,
        holoStrength: 0.7,
        id: 'gym_challenge_013_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 21,
        lengthInches: 4,
        moves: [MOVES.REBELLION, MOVES.TIDAL_WAVE],
        name: `${MISTY_PREFIX} ${GYARADOS$4.name}`,
        pokemonImagePositionX: 25,
        pokemonImagePositionY: 32,
        pokemonImageSize: 76,
        pokemonImageUrl: GYARADOS$4.images[3].value,
        pokemonLevel: 42,
        pokemonNumber: GYARADOS$4.number,
        pokemonType: GYARADOS$4.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 13,
        stage: GYARADOS$4.stage,
        trainerImageUrl: MISTY$1.images[0].value,
        weight: 518,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-rockets-moltres_badehb.jpg',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 70,
        holo: true,
        holoStrength: 0.7,
        id: 'gym_challenge_014_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        frameMode: 'dark',
        lengthFeet: 6,
        lengthInches: 7,
        moves: [MOVES.JUXTAPOSE, MOVES.HYPNOBLAST, MOVES.PSYBURN],
        name: `${ROCKET_PREFIX} ${MEWTWO$3.name}`,
        pokemonImagePositionX: 54,
        pokemonImagePositionY: 42,
        pokemonImageSize: 44,
        pokemonImageUrl: MEWTWO$3.images[1].value,
        pokemonLevel: 35,
        pokemonNumber: MEWTWO$3.number,
        pokemonType: MEWTWO$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 14,
        trainerImageUrl: ROCKET.images[0].value,
        weight: 269,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-rockets-moltres_badehb.jpg',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.LIGHTNING,
        hitPoints: 70,
        holo: true,
        holoStrength: 0.7,
        id: 'gym_challenge_015_en',
        illustrator: ILLUSTRATORS.YOSHIDA,
        frameMode: 'dark',
        lengthFeet: 5,
        lengthInches: 3,
        moves: [MOVES.PLASMA, MOVES.ELECTROBURN],
        name: `${ROCKET_PREFIX} ${ZAPDOS$2.name}`,
        pokemonImagePositionX: 54,
        pokemonImagePositionY: 45,
        pokemonImageSize: 64,
        pokemonImageUrl: ZAPDOS$2.images[2].value,
        pokemonLevel: 34,
        pokemonNumber: ZAPDOS$2.number,
        pokemonType: ZAPDOS$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 14,
        trainerImageUrl: ROCKET.images[0].value,
        weight: 116,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lights-jynx_grozno.jpg',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        evolvesFrom: `${SABRINA_PREFIX} ${KADABRA$7.name}`,
        evolutionBoxImageUrl: KADABRA$7.images[0].value,
        hitPoints: 80,
        holo: true,
        holoStrength: 0.7,
        id: 'gym_challenge_016_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 4,
        lengthInches: 11,
        moves: [MOVES.PSYLINK, MOVES.MEGA_BURN],
        name: `${SABRINA_PREFIX} ${ALAKAZAM$3.name}`,
        pokemonImagePositionX: 65,
        pokemonImagePositionY: 32,
        pokemonImageSize: 57,
        pokemonImageUrl: ALAKAZAM$3.images[2].value,
        pokemonLevel: 44,
        pokemonNumber: ALAKAZAM$3.number,
        pokemonType: ALAKAZAM$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 16,
        stage: ALAKAZAM$3.stage,
        trainerImageUrl: SABRINA$2.images[0].value,
        weight: 106,
    },
    {
        backgroundColor: '#b5492e',
        backgroundImageBlendMode: BLEND_MODES.SCREEN,
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/flames-magmar_s5ibam.jpg',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: 'During this turn, instead of attaching your free Energy card, you may instead attach 2 {FR} Energy cards to 1 of your Pokémon with Blaine in its name. <em>(Playing additional copies of this card this turn has no effect.)</em>',
        holo: true,
        holoStrength: 0.7,
        id: 'gym_challenge_017_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        name: BLAINE$1.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: -39,
        pokemonImageSize: 27,
        pokemonImageUrl: BLAINE$1.images[1].value,
        rarity: RARITY_TYPES.RARE,
        setNumber: 17,
    },
    {
        backgroundColor: '#254425',
        backgroundImageBlendMode: BLEND_MODES.SCREEN,
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/rust-erikas-gloom_rludho.jpg',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: 'Choose 1 of your Pokémon in play with Giovanni in its name. For the rest of your turn, you may evolve that Pokémon even if you just played or evolved it this turn or if this is your first turn. This effect also applies to the Pokémon it evolves into.',
        holo: true,
        holoStrength: 0.7,
        id: 'gym_challenge_018_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        name: GIOVANNI$1.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: -32,
        pokemonImageSize: 34,
        pokemonImageUrl: GIOVANNI$1.images[1].value,
        rarity: RARITY_TYPES.RARE,
        setNumber: 18,
    },
    {
        backgroundColor: '#95a639',
        backgroundImageBlendMode: BLEND_MODES.SCREEN,
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-ekans_inxykw.jpg',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: 'If an attack from a Pokémon with Koga in its name does damage to a Defending Pokémon this turn, that Pokémon is then Poisoned.',
        holo: true,
        holoStrength: 0.7,
        id: 'gym_challenge_019_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        name: KOGA$1.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: -24,
        pokemonImageSize: 44,
        pokemonImageUrl: KOGA$1.images[1].value,
        rarity: RARITY_TYPES.RARE,
        setNumber: 19,
    },
    {
        backgroundColor: '#502f68',
        backgroundImageBlendMode: BLEND_MODES.SCREEN,
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/leather-bgpng_f6jkdb.png',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: 'Take all Energy cards attached to 1 of your Pokémon with Sabrina in its name and attach them to another 1 of your Pokémon with Sabrina in its name.',
        holo: true,
        holoStrength: 0.7,
        id: 'gym_challenge_020_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        name: SABRINA$2.name,
        pokemonImagePositionX: 47,
        pokemonImagePositionY: -28,
        pokemonImageSize: 44,
        pokemonImageUrl: SABRINA$2.images[1].value,
        rarity: RARITY_TYPES.RARE,
        setNumber: 20,
    },
];

const { ABRA: ABRA$4, ARBOK: ARBOK$4, BELLSPROUT, BULBASAUR: BULBASAUR$2, CHARMANDER: CHARMANDER$2, CHARMELEON: CHARMELEON$5, CLEFAIRY: CLEFAIRY$4, DEWGONG: DEWGONG$3, DIGLETT: DIGLETT$5, DODUO, DODRIO: DODRIO$1, DROWZEE: DROWZEE$3, DUGTRIO: DUGTRIO$3, EEVEE: EEVEE$8, EKANS: EKANS$5, ELECTRODE: ELECTRODE$2, GASTLY: GASTLY$5, GENGAR: GENGAR$5, GEODUDE: GEODUDE$3, GOLBAT: GOLBAT$7, GOLDUCK: GOLDUCK$3, GRAVELER: GRAVELER$5, GRIMER: GRIMER$3, GROWLITHE: GROWLITHE$5, HAUNTER: HAUNTER$7, HORSEA: HORSEA$2, HYPNO: HYPNO$3, IVYSAUR: IVYSAUR$5, JIGGLYPUFF: JIGGLYPUFF$5, JOLTEON: JOLTEON$4, JYNX: JYNX$3, KADABRA: KADABRA$6, KAKUNA: KAKUNA$3, KOFFING: KOFFING$5, MACHOKE: MACHOKE$8, MACHOP: MACHOP$4, MAGIKARP: MAGIKARP$6, MANKEY: MANKEY$1, MEOWTH: MEOWTH$4, MR_MIME, MUK: MUK$2, NIDOQUEEN: NIDOQUEEN$1, NIDORAN_F: NIDORAN_F$1, NIDORAN_M, NIDORINA: NIDORINA$2, NIDORINO, NINETALES: NINETALES$3, ODDISH: ODDISH$3, PARAS: PARAS$1, PIDGEOTTO: PIDGEOTTO$2, PIDGEY: PIDGEY$1, PIKACHU: PIKACHU$9, PINSIR: PINSIR$1, POLIWAG: POLIWAG$3, PONYTA: PONYTA$4, PORYGON: PORYGON$5, PRIMEAPE: PRIMEAPE$3, PSYDUCK: PSYDUCK$4, RAPIDASH: RAPIDASH$4, RATICATE: RATICATE$3, RATTATA: RATTATA$3, RHYHORN: RHYHORN$2, SANDSHREW: SANDSHREW$2, SANDSLASH: SANDSLASH$2, SEEL: SEEL$3, STARYU: STARYU$3, TANGELA, VOLTORB: VOLTORB$2, VULPIX: VULPIX$3, WEEDLE: WEEDLE$2, WEEZING: WEEZING$4, ZUBAT: ZUBAT$5, } = GEN_1_POKEMON;
const { BLAINE, BROCK, ERIKA, GIOVANNI, KOGA, LT_SURGE, MISTY, SABRINA: SABRINA$1 } = GYM_LEADERS;
const GYM_CHALLENGE_NON_HOLOS = [
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        evolvesFrom: `${BLAINE_PREFIX} ${VULPIX$3.name}`,
        evolutionBoxImageUrl: VULPIX$3.images[0].value,
        hitPoints: null,
        id: 'gym_challenge_021_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${BLAINE_PREFIX} ${NINETALES$3.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: NINETALES$3.number,
        pokemonType: NINETALES$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 21,
        stage: NINETALES$3.stage,
        trainerImageUrl: BLAINE.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        evolvesFrom: `${BROCK_PREFIX} ${DIGLETT$5.name}`,
        evolutionBoxImageUrl: null,
        hitPoints: null,
        id: 'gym_challenge_022_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${BROCK_PREFIX} ${DUGTRIO$3.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: DUGTRIO$3.number,
        pokemonType: DUGTRIO$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 22,
        stage: DUGTRIO$3.stage,
        trainerImageUrl: BROCK.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        evolvesFrom: `${GIOVANNI_PREFIX} ${NIDORINA$2.name}`,
        evolutionBoxImageUrl: NIDORINA$2.images[0].value,
        hitPoints: null,
        id: 'gym_challenge_023_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${GIOVANNI_PREFIX} ${NIDOQUEEN$1.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: NIDOQUEEN$1.number,
        pokemonType: NIDOQUEEN$1.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 23,
        stage: NIDOQUEEN$1.stage,
        trainerImageUrl: GIOVANNI.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        hitPoints: null,
        id: 'gym_challenge_024_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${GIOVANNI_PREFIX} ${PINSIR$1.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: PINSIR$1.number,
        pokemonType: PINSIR$1.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 24,
        trainerImageUrl: GIOVANNI.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        evolvesFrom: `${KOGA_PREFIX} ${EKANS$5.name}`,
        evolutionBoxImageUrl: EKANS$5.images[0].value,
        hitPoints: null,
        id: 'gym_challenge_025_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${KOGA_PREFIX} ${ARBOK$4.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: ARBOK$4.number,
        pokemonType: ARBOK$4.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 25,
        stage: ARBOK$4.stage,
        trainerImageUrl: KOGA.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        evolvesFrom: `${KOGA_PREFIX} ${GRIMER$3.name}`,
        evolutionBoxImageUrl: GRIMER$3.images[0].value,
        hitPoints: null,
        id: 'gym_challenge_026_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${KOGA_PREFIX} ${MUK$2.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: MUK$2.number,
        pokemonType: MUK$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 26,
        stage: MUK$2.stage,
        trainerImageUrl: KOGA.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        evolvesFrom: `${KOGA_PREFIX} ${PIDGEY$1.name}`,
        evolutionBoxImageUrl: PIDGEY$1.images[0].value,
        hitPoints: null,
        id: 'gym_challenge_027_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${KOGA_PREFIX} ${PIDGEOTTO$2.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: PIDGEOTTO$2.number,
        pokemonType: PIDGEOTTO$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 27,
        stage: PIDGEOTTO$2.stage,
        trainerImageUrl: KOGA.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        evolvesFrom: `${LT_SURGE_PREFIX} ${EEVEE$8.name}`,
        evolutionBoxImageUrl: null,
        hitPoints: null,
        id: 'gym_challenge_028_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${LT_SURGE_PREFIX} ${JOLTEON$4.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: JOLTEON$4.number,
        pokemonType: JOLTEON$4.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 28,
        stage: JOLTEON$4.stage,
        trainerImageUrl: LT_SURGE.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        evolvesFrom: `${SABRINA_PREFIX} ${HAUNTER$7.name}`,
        evolutionBoxImageUrl: HAUNTER$7.images[0].value,
        hitPoints: null,
        id: 'gym_challenge_029_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${SABRINA_PREFIX} ${GENGAR$5.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: GENGAR$5.number,
        pokemonType: GENGAR$5.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 29,
        stage: GENGAR$5.stage,
        trainerImageUrl: SABRINA$1.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        evolvesFrom: `${SABRINA_PREFIX} ${PSYDUCK$4.name}`,
        evolutionBoxImageUrl: PSYDUCK$4.images[0].value,
        hitPoints: null,
        id: 'gym_challenge_030_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${SABRINA_PREFIX} ${GOLDUCK$3.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: GOLDUCK$3.number,
        pokemonType: GOLDUCK$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 30,
        stage: GOLDUCK$3.stage,
        trainerImageUrl: SABRINA$1.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        evolvesFrom: `${BLAINE_PREFIX} ${CHARMANDER$2.name}`,
        evolutionBoxImageUrl: CHARMANDER$2.images[0].value,
        hitPoints: null,
        id: 'gym_challenge_031_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${BLAINE_PREFIX} ${CHARMELEON$5.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: CHARMELEON$5.number,
        pokemonType: CHARMELEON$5.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 31,
        stage: CHARMELEON$5.stage,
        trainerImageUrl: BLAINE.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        evolvesFrom: `${BLAINE_PREFIX} ${DODUO.name}`,
        evolutionBoxImageUrl: DODUO.images[0].value,
        hitPoints: null,
        id: 'gym_challenge_032_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${BLAINE_PREFIX} ${DODRIO$1.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: DODRIO$1.number,
        pokemonType: DODRIO$1.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 32,
        stage: DODRIO$1.stage,
        trainerImageUrl: BLAINE.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        evolvesFrom: `${BLAINE_PREFIX} ${PONYTA$4.name}`,
        evolutionBoxImageUrl: PONYTA$4.images[0].value,
        hitPoints: null,
        id: 'gym_challenge_033_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${BLAINE_PREFIX} ${RAPIDASH$4.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: RAPIDASH$4.number,
        pokemonType: RAPIDASH$4.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 33,
        stage: RAPIDASH$4.stage,
        trainerImageUrl: BLAINE.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        evolvesFrom: `${BROCK_PREFIX} ${GEODUDE$3.name}`,
        evolutionBoxImageUrl: GEODUDE$3.images[0].value,
        hitPoints: null,
        id: 'gym_challenge_034_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${BROCK_PREFIX} ${GRAVELER$5.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: GRAVELER$5.number,
        pokemonType: GRAVELER$5.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 34,
        stage: GRAVELER$5.stage,
        trainerImageUrl: BROCK.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        evolvesFrom: `${BROCK_PREFIX} ${MANKEY$1.name}`,
        evolutionBoxImageUrl: MANKEY$1.images[0].value,
        hitPoints: null,
        id: 'gym_challenge_035_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${BROCK_PREFIX} ${PRIMEAPE$3.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: PRIMEAPE$3.number,
        pokemonType: PRIMEAPE$3.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 35,
        stage: PRIMEAPE$3.stage,
        trainerImageUrl: BROCK.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        evolvesFrom: `${BROCK_PREFIX} ${SANDSHREW$2.name}`,
        evolutionBoxImageUrl: SANDSHREW$2.images[0].value,
        hitPoints: null,
        id: 'gym_challenge_036_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${BROCK_PREFIX} ${SANDSLASH$2.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: SANDSLASH$2.number,
        pokemonType: SANDSLASH$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 36,
        stage: SANDSLASH$2.stage,
        trainerImageUrl: BROCK.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        hitPoints: null,
        id: 'gym_challenge_037_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${BROCK_PREFIX} ${VULPIX$3.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: VULPIX$3.number,
        pokemonType: VULPIX$3.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 37,
        trainerImageUrl: BROCK.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        hitPoints: null,
        id: 'gym_challenge_038_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${ERIKA_PREFIX} ${BELLSPROUT.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: BELLSPROUT.number,
        pokemonType: BELLSPROUT.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 38,
        trainerImageUrl: ERIKA.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        hitPoints: null,
        id: 'gym_challenge_039_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${ERIKA_PREFIX} ${BULBASAUR$2.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: BULBASAUR$2.number,
        pokemonType: BULBASAUR$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 39,
        trainerImageUrl: ERIKA.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        hitPoints: null,
        id: 'gym_challenge_040_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${ERIKA_PREFIX} ${CLEFAIRY$4.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: CLEFAIRY$4.number,
        pokemonType: CLEFAIRY$4.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 40,
        trainerImageUrl: ERIKA.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        evolvesFrom: `${ERIKA_PREFIX} ${BULBASAUR$2.name}`,
        evolutionBoxImageUrl: BULBASAUR$2.images[0].value,
        hitPoints: null,
        id: 'gym_challenge_041_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${ERIKA_PREFIX} ${IVYSAUR$5.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: IVYSAUR$5.number,
        pokemonType: IVYSAUR$5.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 41,
        stage: IVYSAUR$5.stage,
        trainerImageUrl: ERIKA.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        evolvesFrom: `${GIOVANNI_PREFIX} ${MACHOP$4.name}`,
        evolutionBoxImageUrl: MACHOP$4.images[0].value,
        hitPoints: null,
        id: 'gym_challenge_042_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${GIOVANNI_PREFIX} ${MACHOKE$8.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: MACHOKE$8.number,
        pokemonType: MACHOKE$8.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 42,
        stage: MACHOKE$8.stage,
        trainerImageUrl: GIOVANNI.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        hitPoints: null,
        id: 'gym_challenge_043_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${GIOVANNI_PREFIX} ${MEOWTH$4.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: MEOWTH$4.number,
        pokemonType: MEOWTH$4.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 43,
        trainerImageUrl: GIOVANNI.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        evolvesFrom: `${GIOVANNI_PREFIX} ${NIDORAN_F$1.name}`,
        evolutionBoxImageUrl: NIDORAN_F$1.images[0].value,
        hitPoints: null,
        id: 'gym_challenge_044_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Giovanno's ${NIDORINA$2.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: NIDORINA$2.number,
        pokemonType: NIDORINA$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 44,
        stage: NIDORINA$2.stage,
        trainerImageUrl: GIOVANNI.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        evolvesFrom: `${GIOVANNI_PREFIX} ${NIDORAN_M.name}`,
        evolutionBoxImageUrl: NIDORAN_M.images[0].value,
        hitPoints: null,
        id: 'gym_challenge_045_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${GIOVANNI_PREFIX} ${NIDORINO.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: NIDORINO.number,
        pokemonType: NIDORINO.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 45,
        stage: NIDORINO.stage,
        trainerImageUrl: GIOVANNI.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        evolvesFrom: `${KOGA_PREFIX} ${ZUBAT$5.name}`,
        evolutionBoxImageUrl: ZUBAT$5.images[0].value,
        hitPoints: null,
        id: 'gym_challenge_046_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${KOGA_PREFIX} ${GOLBAT$7.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: GOLBAT$7.number,
        pokemonType: GOLBAT$7.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 46,
        stage: GOLBAT$7.stage,
        trainerImageUrl: KOGA.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        evolvesFrom: `${KOGA_PREFIX} ${WEEDLE$2.name}`,
        evolutionBoxImageUrl: WEEDLE$2.images[0].value,
        hitPoints: null,
        id: 'gym_challenge_047_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${KOGA_PREFIX} ${KAKUNA$3.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: KAKUNA$3.number,
        pokemonType: KAKUNA$3.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 47,
        stage: KAKUNA$3.stage,
        trainerImageUrl: KOGA.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        hitPoints: null,
        id: 'gym_challenge_048_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${KOGA_PREFIX} ${KOFFING$5.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: KOFFING$5.number,
        pokemonType: KOFFING$5.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 48,
        trainerImageUrl: KOGA.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        hitPoints: null,
        id: 'gym_challenge_049_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${KOGA_PREFIX} ${PIDGEY$1.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: PIDGEY$1.number,
        pokemonType: PIDGEY$1.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 49,
        trainerImageUrl: KOGA.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        evolvesFrom: `${KOGA_PREFIX} ${KOFFING$5.name}`,
        evolutionBoxImageUrl: KOFFING$5.images[0].value,
        hitPoints: null,
        id: 'gym_challenge_050_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${KOGA_PREFIX} ${WEEZING$4.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: WEEZING$4.number,
        pokemonType: WEEZING$4.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 50,
        stage: WEEZING$4.stage,
        trainerImageUrl: KOGA.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        hitPoints: null,
        id: 'gym_challenge_051_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${LT_SURGE_PREFIX} ${EEVEE$8.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: EEVEE$8.number,
        pokemonType: EEVEE$8.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 51,
        trainerImageUrl: LT_SURGE.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        evolvesFrom: `${LT_SURGE_PREFIX} ${VOLTORB$2.name}`,
        evolutionBoxImageUrl: null,
        hitPoints: null,
        id: 'gym_challenge_052_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${LT_SURGE_PREFIX} ${ELECTRODE$2.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: ELECTRODE$2.number,
        pokemonType: ELECTRODE$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 52,
        stage: ELECTRODE$2.stage,
        trainerImageUrl: LT_SURGE.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        evolvesFrom: `${LT_SURGE_PREFIX} ${RATTATA$3.name}`,
        evolutionBoxImageUrl: RATTATA$3.images[0].value,
        hitPoints: null,
        id: 'gym_challenge_053_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: RATICATE$3.name,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: RATICATE$3.number,
        pokemonType: RATICATE$3.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 53,
        stage: RATICATE$3.stage,
        trainerImageUrl: LT_SURGE.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        evolvesFrom: `${MISTY_PREFIX} ${SEEL$3.name}`,
        evolutionBoxImageUrl: SEEL$3.images[0].value,
        hitPoints: null,
        id: 'gym_challenge_054_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${MISTY_PREFIX} ${DEWGONG$3.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: DEWGONG$3.number,
        pokemonType: DEWGONG$3.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 54,
        stage: DEWGONG$3.stage,
        trainerImageUrl: MISTY.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        evolvesFrom: `${SABRINA_PREFIX} ${GASTLY$5.name}`,
        evolutionBoxImageUrl: GASTLY$5.images[0].value,
        hitPoints: null,
        id: 'gym_challenge_055_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${SABRINA_PREFIX} ${HAUNTER$7.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: HAUNTER$7.number,
        pokemonType: HAUNTER$7.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 55,
        stage: HAUNTER$7.stage,
        trainerImageUrl: SABRINA$1.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        evolvesFrom: `${SABRINA_PREFIX} ${DROWZEE$3.name}`,
        evolutionBoxImageUrl: DROWZEE$3.images[0].value,
        hitPoints: null,
        id: 'gym_challenge_056_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${SABRINA_PREFIX} ${HYPNO$3.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: HYPNO$3.number,
        pokemonType: HYPNO$3.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 56,
        stage: HYPNO$3.stage,
        trainerImageUrl: SABRINA$1.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        hitPoints: null,
        id: 'gym_challenge_057_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${SABRINA_PREFIX} ${JYNX$3.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: JYNX$3.number,
        pokemonType: JYNX$3.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 57,
        trainerImageUrl: SABRINA$1.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        evolvesFrom: `${SABRINA_PREFIX} ${ABRA$4.name}`,
        evolutionBoxImageUrl: ABRA$4.images[0].value,
        hitPoints: null,
        id: 'gym_challenge_058_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${SABRINA_PREFIX} ${KADABRA$6.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: KADABRA$6.number,
        pokemonType: KADABRA$6.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 58,
        stage: KADABRA$6.stage,
        trainerImageUrl: SABRINA$1.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        hitPoints: null,
        id: 'gym_challenge_059_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${SABRINA_PREFIX} ${MR_MIME.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: MR_MIME.number,
        pokemonType: MR_MIME.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 59,
        trainerImageUrl: SABRINA$1.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        hitPoints: null,
        id: 'gym_challenge_060_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${BLAINE_PREFIX} ${CHARMANDER$2.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: CHARMANDER$2.number,
        pokemonType: CHARMANDER$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 60,
        trainerImageUrl: BLAINE.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        evolvesFrom: null,
        evolutionBoxImageUrl: null,
        hitPoints: null,
        id: 'gym_challenge_061_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${BLAINE_PREFIX} ${DODUO.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: DODUO.number,
        pokemonType: DODUO.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 61,
        trainerImageUrl: BLAINE.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        hitPoints: null,
        id: 'gym_challenge_062_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${BLAINE_PREFIX} ${GROWLITHE$5.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: GROWLITHE$5.number,
        pokemonType: GROWLITHE$5.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 62,
        trainerImageUrl: BLAINE.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        hitPoints: null,
        id: 'gym_challenge_063_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${BLAINE_PREFIX} ${MANKEY$1.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: MANKEY$1.number,
        pokemonType: MANKEY$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 63,
        trainerImageUrl: BLAINE.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        evolvesFrom: null,
        evolutionBoxImageUrl: null,
        hitPoints: null,
        id: 'gym_challenge_064_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${BLAINE_PREFIX} ${PONYTA$4.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: PONYTA$4.number,
        pokemonType: PONYTA$4.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 64,
        trainerImageUrl: BLAINE.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        hitPoints: null,
        id: 'gym_challenge_065_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${BLAINE_PREFIX} ${RHYHORN$2.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: RHYHORN$2.number,
        pokemonType: RHYHORN$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 65,
        trainerImageUrl: BLAINE.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        hitPoints: null,
        id: 'gym_challenge_066_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${BLAINE_PREFIX} ${VULPIX$3.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: VULPIX$3.number,
        pokemonType: VULPIX$3.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 66,
        trainerImageUrl: BLAINE.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        hitPoints: null,
        id: 'gym_challenge_067_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${BROCK_PREFIX} ${DIGLETT$5.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: DIGLETT$5.number,
        pokemonType: DIGLETT$5.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 67,
        trainerImageUrl: BROCK.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        hitPoints: null,
        id: 'gym_challenge_068_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${BROCK_PREFIX} ${GEODUDE$3.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: GEODUDE$3.number,
        pokemonType: GEODUDE$3.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 68,
        trainerImageUrl: BROCK.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        hitPoints: null,
        id: 'gym_challenge_069_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${ERIKA_PREFIX} ${JIGGLYPUFF$5.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: JIGGLYPUFF$5.number,
        pokemonType: JIGGLYPUFF$5.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 69,
        trainerImageUrl: ERIKA.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        hitPoints: null,
        id: 'gym_challenge_070_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${ERIKA_PREFIX} ${ODDISH$3.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: ODDISH$3.number,
        pokemonType: ODDISH$3.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 70,
        trainerImageUrl: ERIKA.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        hitPoints: null,
        id: 'gym_challenge_071_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${ERIKA_PREFIX} ${PARAS$1.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: PARAS$1.number,
        pokemonType: PARAS$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 71,
        trainerImageUrl: ERIKA.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        hitPoints: null,
        id: 'gym_challenge_072_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${GIOVANNI_PREFIX} ${MACHOP$4.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: MACHOP$4.number,
        pokemonType: MACHOP$4.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 72,
        trainerImageUrl: GIOVANNI.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        hitPoints: null,
        id: 'gym_challenge_073_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${GIOVANNI_PREFIX} ${MAGIKARP$6.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: MAGIKARP$6.number,
        pokemonType: MAGIKARP$6.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 73,
        trainerImageUrl: GIOVANNI.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        hitPoints: null,
        id: 'gym_challenge_074_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${GIOVANNI_PREFIX} ${MEOWTH$4.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: MEOWTH$4.number,
        pokemonType: MEOWTH$4.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 74,
        trainerImageUrl: GIOVANNI.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        hitPoints: null,
        id: 'gym_challenge_075_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${GIOVANNI_PREFIX} ${NIDORAN_F$1.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: NIDORAN_F$1.number,
        pokemonType: NIDORAN_F$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 75,
        trainerImageUrl: GIOVANNI.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        hitPoints: null,
        id: 'gym_challenge_076_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${GIOVANNI_PREFIX} ${NIDORAN_M.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: NIDORAN_M.number,
        pokemonType: NIDORAN_M.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 76,
        trainerImageUrl: GIOVANNI.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        evolvesFrom: null,
        evolutionBoxImageUrl: null,
        hitPoints: null,
        id: 'gym_challenge_077_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${KOGA_PREFIX} ${EKANS$5.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: EKANS$5.number,
        pokemonType: EKANS$5.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 77,
        trainerImageUrl: KOGA.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        evolvesFrom: null,
        evolutionBoxImageUrl: null,
        hitPoints: null,
        id: 'gym_challenge_078_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${KOGA_PREFIX} ${GRIMER$3.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: GRIMER$3.number,
        pokemonType: GRIMER$3.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 78,
        trainerImageUrl: KOGA.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        hitPoints: null,
        id: 'gym_challenge_079_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${KOGA_PREFIX} ${KOFFING$5.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: KOFFING$5.number,
        pokemonType: KOFFING$5.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 79,
        trainerImageUrl: KOGA.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        hitPoints: null,
        id: 'gym_challenge_080_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${KOGA_PREFIX} ${PIDGEY$1.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: PIDGEY$1.number,
        pokemonType: PIDGEY$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 80,
        trainerImageUrl: KOGA.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        hitPoints: null,
        id: 'gym_challenge_081_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${KOGA_PREFIX} ${TANGELA.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: TANGELA.number,
        pokemonType: TANGELA.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 81,
        trainerImageUrl: KOGA.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        hitPoints: null,
        id: 'gym_challenge_082_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${KOGA_PREFIX} ${WEEDLE$2.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: WEEDLE$2.number,
        pokemonType: WEEDLE$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 82,
        trainerImageUrl: KOGA.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        hitPoints: null,
        id: 'gym_challenge_083_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${KOGA_PREFIX} ${ZUBAT$5.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: ZUBAT$5.number,
        pokemonType: ZUBAT$5.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 83,
        trainerImageUrl: KOGA.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        hitPoints: null,
        id: 'gym_challenge_084_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${LT_SURGE_PREFIX} ${PIKACHU$9.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: PIKACHU$9.number,
        pokemonType: PIKACHU$9.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 84,
        trainerImageUrl: LT_SURGE.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        hitPoints: null,
        id: 'gym_challenge_085_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${LT_SURGE_PREFIX} ${RATTATA$3.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: RATTATA$3.number,
        pokemonType: RATTATA$3.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 85,
        trainerImageUrl: LT_SURGE.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        hitPoints: null,
        id: 'gym_challenge_086_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${LT_SURGE_PREFIX} ${VOLTORB$2.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: VOLTORB$2.number,
        pokemonType: VOLTORB$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 86,
        trainerImageUrl: LT_SURGE.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        hitPoints: null,
        id: 'gym_challenge_087_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${MISTY_PREFIX} ${HORSEA$2.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: HORSEA$2.number,
        pokemonType: HORSEA$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 87,
        trainerImageUrl: MISTY.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        hitPoints: null,
        id: 'gym_challenge_088_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${MISTY_PREFIX} ${MAGIKARP$6.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: MAGIKARP$6.number,
        pokemonType: MAGIKARP$6.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 88,
        trainerImageUrl: MISTY.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        hitPoints: null,
        id: 'gym_challenge_089_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${MISTY_PREFIX} ${POLIWAG$3.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: POLIWAG$3.number,
        pokemonType: POLIWAG$3.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 89,
        trainerImageUrl: MISTY.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        hitPoints: null,
        id: 'gym_challenge_090_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${MISTY_PREFIX} ${PSYDUCK$4.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: PSYDUCK$4.number,
        pokemonType: PSYDUCK$4.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 90,
        trainerImageUrl: MISTY.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        hitPoints: null,
        id: 'gym_challenge_091_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${MISTY_PREFIX} ${SEEL$3.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: SEEL$3.number,
        pokemonType: SEEL$3.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 91,
        trainerImageUrl: MISTY.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        hitPoints: null,
        id: 'gym_challenge_092_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${MISTY_PREFIX} ${STARYU$3.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: STARYU$3.number,
        pokemonType: STARYU$3.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 92,
        trainerImageUrl: MISTY.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        hitPoints: null,
        id: 'gym_challenge_093_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${SABRINA_PREFIX} ${ABRA$4.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: ABRA$4.number,
        pokemonType: ABRA$4.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 93,
        trainerImageUrl: SABRINA$1.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        hitPoints: null,
        id: 'gym_challenge_094_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${SABRINA_PREFIX} ${ABRA$4.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: ABRA$4.number,
        pokemonType: ABRA$4.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 94,
        trainerImageUrl: SABRINA$1.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        hitPoints: null,
        id: 'gym_challenge_095_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${SABRINA_PREFIX} ${DROWZEE$3.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: DROWZEE$3.number,
        pokemonType: DROWZEE$3.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 95,
        trainerImageUrl: SABRINA$1.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        hitPoints: null,
        id: 'gym_challenge_096_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${SABRINA_PREFIX} ${GASTLY$5.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: GASTLY$5.number,
        pokemonType: GASTLY$5.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 96,
        trainerImageUrl: SABRINA$1.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        hitPoints: null,
        id: 'gym_challenge_097_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${SABRINA_PREFIX} ${GASTLY$5.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: GASTLY$5.number,
        pokemonType: GASTLY$5.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 97,
        trainerImageUrl: SABRINA$1.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        hitPoints: null,
        id: 'gym_challenge_098_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${SABRINA_PREFIX} ${PORYGON$5.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: PORYGON$5.number,
        pokemonType: PORYGON$5.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 98,
        trainerImageUrl: SABRINA$1.images[0].value,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        hitPoints: null,
        id: 'gym_challenge_099_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `${SABRINA_PREFIX} ${PSYDUCK$4.name}`,
        pokemonImagePositionX: 70,
        pokemonImagePositionY: 52,
        pokemonImageSize: 33,
        pokemonLevel: 39,
        pokemonNumber: PSYDUCK$4.number,
        pokemonType: PSYDUCK$4.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 99,
        trainerImageUrl: SABRINA$1.images[0].value,
        weight: null,
    },
];

const { BLAINES_QUIZ_2, BLAINES_QUIZ_3, BROCKS_PROTECTION, CHAOS_GYM, CINNABAR_CITY_GYM, ERIKAS_KINDNESS, FERVOR, FUCHSIA_CITY_GYM, GIOVANNIS_LAST_RESORT, KOGAS_NINJA_TRICK, LT_SURGES_SECRET_PLAN, MASTER_BALL: MASTER_BALL$2, MAX_REVIVE, MISTYS_TEARS, MISTYS_WISH, RESISTANCE_GYM, ROCKETS_MINEFIELD_GYM, ROCKETS_SECRET_EXPERIMENT, SABRINAS_PSYCHIC_CONTROL, SAFFRON_CITY_GYM, TRANSPARENT_WALLS, VIRIDIAN_CITY_GYM, WARP_POINT: WARP_POINT$2, } = GYM_TRAINERS;
const GYM_CHALLENGE_TRAINERS = [
    {
        ...GYM_CHALLENGE_HOLOS[16],
        holo: false,
        id: 'gym_heroes_100_en',
        setNumber: 100,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_challenge_101_en',
        illustrator: null,
        name: BROCKS_PROTECTION.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 101,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_challenge_102_en',
        illustrator: null,
        name: CHAOS_GYM.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 102,
        subtitle: TRAINER_CARD_SUBTITLES.STADIUM_CARD,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_challenge_103_en',
        illustrator: null,
        name: ERIKAS_KINDNESS.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 103,
    },
    {
        ...GYM_CHALLENGE_HOLOS[17],
        holo: false,
        id: 'gym_heroes_104_en',
        setNumber: 104,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_challenge_105_en',
        illustrator: null,
        name: GIOVANNIS_LAST_RESORT.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 105,
    },
    {
        ...GYM_CHALLENGE_HOLOS[18],
        holo: false,
        id: 'gym_heroes_106_en',
        setNumber: 106,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_challenge_107_en',
        illustrator: null,
        name: LT_SURGES_SECRET_PLAN.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 107,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_challenge_108_en',
        illustrator: null,
        name: MISTYS_WISH.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 108,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_challenge_109_en',
        illustrator: null,
        name: RESISTANCE_GYM.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 109,
        subtitle: TRAINER_CARD_SUBTITLES.STADIUM_CARD,
    },
    {
        ...GYM_CHALLENGE_HOLOS[19],
        holo: false,
        id: 'gym_heroes_110_en',
        setNumber: 110,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_challenge_111_en',
        illustrator: null,
        name: BLAINES_QUIZ_2.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 111,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_challenge_112_en',
        illustrator: null,
        name: BLAINES_QUIZ_3.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 112,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_challenge_113_en',
        illustrator: null,
        name: CINNABAR_CITY_GYM.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 113,
        subtitle: TRAINER_CARD_SUBTITLES.STADIUM_CARD,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_challenge_114_en',
        illustrator: null,
        name: FUCHSIA_CITY_GYM.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 114,
        subtitle: TRAINER_CARD_SUBTITLES.STADIUM_CARD,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_challenge_115_en',
        illustrator: null,
        name: KOGAS_NINJA_TRICK.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 115,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_challenge_116_en',
        illustrator: null,
        name: MASTER_BALL$2.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 116,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_challenge_117_en',
        illustrator: null,
        name: MAX_REVIVE.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 117,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_challenge_118_en',
        illustrator: null,
        name: MISTYS_TEARS.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 118,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_challenge_119_en',
        illustrator: null,
        name: ROCKETS_MINEFIELD_GYM.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 119,
        subtitle: TRAINER_CARD_SUBTITLES.STADIUM_CARD,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_challenge_120_en',
        illustrator: null,
        name: ROCKETS_SECRET_EXPERIMENT.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 120,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_challenge_121_en',
        illustrator: null,
        name: SABRINAS_PSYCHIC_CONTROL.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 121,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_challenge_122_en',
        illustrator: null,
        name: SAFFRON_CITY_GYM.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 122,
        subtitle: TRAINER_CARD_SUBTITLES.STADIUM_CARD,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_challenge_123_en',
        illustrator: null,
        name: VIRIDIAN_CITY_GYM.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 123,
        subtitle: TRAINER_CARD_SUBTITLES.STADIUM_CARD,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_challenge_124_en',
        illustrator: null,
        name: FERVOR.name,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 124,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_challenge_125_en',
        illustrator: null,
        name: TRANSPARENT_WALLS.name,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 125,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'gym_challenge_126_en',
        illustrator: null,
        name: WARP_POINT$2.name,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 126,
    },
];

const GYM_CHALLENGE_ENERGIES = [
    {
        cardTemplate: CARD_TEMPLATES.ENERGY,
        energyType: ENERGY_TYPES.FIGHTING,
        id: 'gym_challenge_127_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        setNumber: 127,
    },
    {
        cardTemplate: CARD_TEMPLATES.ENERGY,
        energyType: ENERGY_TYPES.FIRE,
        id: 'gym_challenge_128_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        setNumber: 128,
    },
    {
        cardTemplate: CARD_TEMPLATES.ENERGY,
        energyType: ENERGY_TYPES.GRASS,
        id: 'gym_challenge_129_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        setNumber: 129,
    },
    {
        cardTemplate: CARD_TEMPLATES.ENERGY,
        energyType: ENERGY_TYPES.LIGHTNING,
        id: 'gym_challenge_130_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        setNumber: 130,
    },
    {
        cardTemplate: CARD_TEMPLATES.ENERGY,
        energyType: ENERGY_TYPES.PSYCHIC,
        id: 'gym_challenge_131_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        setNumber: 131,
    },
    {
        cardTemplate: CARD_TEMPLATES.ENERGY,
        energyType: ENERGY_TYPES.WATER,
        id: 'gym_challenge_132_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        setNumber: 132,
    },
];

const setId$d = CARD_SETS.GYM_CHALLENGE.value;
const setName$d = CARD_SETS.GYM_CHALLENGE.label;
const setTotal$a = GYM_SET_TOTAL;
const GYM_CHALLENGE_SET = {
    cardCounts: {
        holoRares: 20,
        rares: 21,
        uncommons: 42,
        commons: 43,
        energies: 6,
    },
    copyright: COPYRIGHTS.GYM_SET,
    description: SET_DESCRIPTIONS.GYM_CHALLENGE,
    holoSheetType: CARD_HOLO_SHEETS.COSMOS_2,
    id: setId$d,
    imageUrl: 'https://cdn.shopify.com/s/files/1/0840/1659/5249/collections/gym-challenge-cat-bg.jpg',
    name: setName$d,
    packInfo: BOOSTER_PACKS.GYM_CHALLENGE,
    releaseDate: RELEASE_DATES.GYM_CHALLENGE,
    reverseHoloSheetType: CARD_HOLO_SHEETS.COSMOS_2,
    setSymbol: setId$d,
    setTotal: setTotal$a,
    cards: [
        ...GYM_CHALLENGE_HOLOS,
        ...GYM_CHALLENGE_NON_HOLOS,
        ...GYM_CHALLENGE_TRAINERS,
        ...GYM_CHALLENGE_ENERGIES,
    ],
    themeDecks: [],
};

const holoStrength$7 = 0.7;
const { AMPHAROS: AMPHAROS$4, AZUMARILL: AZUMARILL$1, BELLOSSOM: BELLOSSOM$1, FERALIGATR: FERALIGATR$3, HERACROSS: HERACROSS$2, JUMPLUFF: JUMPLUFF$2, KINGDRA: KINGDRA$2, LUGIA: LUGIA$1, MEGANIUM: MEGANIUM$2, PICHU: PICHU$2, SKARMORY: SKARMORY$4, SLOWKING: SLOWKING$3, STEELIX: STEELIX$3, TOGETIC: TOGETIC$2, TYPHLOSION: TYPHLOSION$4, } = GEN_2_POKEMON;
const { METAL } = SPECIAL_ENERGIES;
const NEO_GENESIS_HOLOS = [
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: "The tail's tip shines brightly and can be seen from far away. It acts as a beacon for lost people.",
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 80,
        holo: true,
        holoStrength: holoStrength$7,
        id: 'neo_gen_001_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 4,
        lengthInches: 7,
        moves: [],
        name: AMPHAROS$4.name,
        pokemonImagePositionX: 56,
        pokemonImagePositionY: 44,
        pokemonImageSize: 34,
        pokemonImageUrl: AMPHAROS$4.images[0].value,
        pokemonLevel: 40,
        pokemonNumber: AMPHAROS$4.number,
        pokemonType: AMPHAROS$4.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 1,
        stage: AMPHAROS$4.stage,
        weight: 136,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'By keeping still and listening intently, it can tell what is in even wild, fast-moving rivers.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 70,
        holo: true,
        holoStrength: holoStrength$7,
        id: 'neo_gen_002_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: AZUMARILL$1.name,
        pokemonImagePositionX: 54,
        pokemonImagePositionY: 43,
        pokemonImageSize: 46,
        pokemonImageUrl: AZUMARILL$1.images[0].value,
        pokemonLevel: 29,
        pokemonNumber: AZUMARILL$1.number,
        pokemonType: AZUMARILL$1.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 2,
        stage: AZUMARILL$1.stage,
        weight: 63,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'Plentiful in the tropics. When it dances, its petals rub together and make a pleasant ringing sound.',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        hitPoints: 70,
        holo: true,
        holoStrength: holoStrength$7,
        id: 'neo_gen_003_en',
        illustrator: ILLUSTRATORS.NISHIDA,
        lengthFeet: 1,
        lengthInches: 4,
        moves: [],
        name: BELLOSSOM$1.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 41,
        pokemonImageSize: 66,
        pokemonImageUrl: BELLOSSOM$1.images[0].value,
        pokemonLevel: 36,
        pokemonNumber: BELLOSSOM$1.number,
        pokemonType: BELLOSSOM$1.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 3,
        stage: BELLOSSOM$1.stage,
        weight: 13,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'When it bites with its massive and powerful jaws, it shakes its head and savagely tears its victim up.',
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.GRASS,
        hitPoints: 100,
        holo: true,
        holoStrength: holoStrength$7,
        id: 'neo_gen_004_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 7,
        lengthInches: 7,
        moves: [],
        name: FERALIGATR$3.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 87,
        pokemonImageSize: 58,
        pokemonImageUrl: FERALIGATR$3.images[0].value,
        pokemonLevel: 56,
        pokemonNumber: FERALIGATR$3.number,
        pokemonType: FERALIGATR$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 4,
        stage: FERALIGATR$3.stage,
        weight: 196,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'It is hard for it to support its own weight out of water, so it gets down on all fours. But it moves fast.',
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.GRASS,
        hitPoints: 120,
        holo: true,
        holoStrength: holoStrength$7,
        id: 'neo_gen_005_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 7,
        lengthInches: 7,
        moves: [],
        name: FERALIGATR$3.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 44,
        pokemonImageShadowColor: '#ffffff',
        pokemonImageShadowSize: '0.86',
        pokemonImageSize: 55,
        pokemonImageUrl: FERALIGATR$3.images[1].value,
        pokemonLevel: 69,
        pokemonNumber: FERALIGATR$3.number,
        pokemonType: FERALIGATR$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 5,
        stage: FERALIGATR$3.stage,
        weight: 196,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: "This powerful Pokémon thrusts its prized horn under its enemies' bellies, then lifts and throws them.",
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        hitPoints: 60,
        holo: true,
        holoStrength: holoStrength$7,
        id: 'neo_gen_006_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 4,
        lengthInches: 11,
        moves: [],
        name: HERACROSS$2.name,
        pokemonImagePositionX: 65,
        pokemonImagePositionY: 53,
        pokemonImageSize: 44,
        pokemonImageUrl: HERACROSS$2.images[0].value,
        pokemonLevel: 28,
        pokemonNumber: HERACROSS$2.number,
        pokemonImageRotation: -5,
        pokemonType: HERACROSS$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 6,
        weight: 119,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'Once it catches the wind, it deftly controls its cotton-puff spores to float, even around the world.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        hitPoints: 70,
        holo: true,
        holoStrength: holoStrength$7,
        id: 'neo_gen_007_en',
        illustrator: ILLUSTRATORS.NISHIDA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: JUMPLUFF$2.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 44,
        pokemonImageSize: 34,
        pokemonImageUrl: JUMPLUFF$2.images[0].value,
        pokemonLevel: 35,
        pokemonNumber: JUMPLUFF$2.number,
        pokemonType: JUMPLUFF$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 7,
        stage: JUMPLUFF$2.stage,
        weight: 7,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'It is said that it usually hides in underwater caves. It can create whirlpools by yawning.',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.WATER,
        hitPoints: 90,
        holo: true,
        holoStrength: holoStrength$7,
        id: 'neo_gen_008_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 5,
        lengthInches: 11,
        moves: [],
        name: KINGDRA$2.name,
        pokemonImagePositionX: 36,
        pokemonImagePositionY: 34,
        pokemonImageRotation: -26,
        pokemonImageSize: 45,
        pokemonImageUrl: KINGDRA$2.images[0].value,
        pokemonLevel: 50,
        pokemonNumber: KINGDRA$2.number,
        pokemonType: KINGDRA$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 8,
        stage: KINGDRA$2.stage,
        weight: 335,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'It is said that it quietly spends its time deep at the bottom of the sea because its powers are too strong.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 90,
        holo: true,
        holoStrength: holoStrength$7,
        id: 'neo_gen_009_en',
        illustrator: ILLUSTRATORS.HIRONOBU,
        lengthFeet: 17,
        lengthInches: 1,
        moves: [],
        name: LUGIA$1.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageShadowColor: '#ffffff',
        pokemonImageShadowSize: 0.66,
        pokemonImageSize: 66,
        pokemonImageUrl: LUGIA$1.images[0].value,
        pokemonLevel: 45,
        pokemonNumber: LUGIA$1.number,
        pokemonType: LUGIA$1.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 9,
        weight: 476,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: "Meganium's breath has the power to revive dead grass and plants. It can make them healthy again.",
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        hitPoints: 100,
        holo: true,
        holoStrength: holoStrength$7,
        id: 'neo_gen_010_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 5,
        lengthInches: 11,
        moves: [],
        name: MEGANIUM$2.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 42,
        pokemonImageSize: 41,
        pokemonImageUrl: MEGANIUM$2.images[0].value,
        pokemonLevel: 54,
        pokemonNumber: MEGANIUM$2.number,
        pokemonType: MEGANIUM$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 10,
        stage: MEGANIUM$2.stage,
        weight: 222,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'The aroma that rises from its petals contains a substance that calms aggressive feelings.',
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        hitPoints: 100,
        holo: true,
        holoStrength: holoStrength$7,
        id: 'neo_gen_011_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 5,
        lengthInches: 11,
        moves: [],
        name: MEGANIUM$2.name,
        pokemonImagePositionX: 54,
        pokemonImagePositionY: 64,
        pokemonImageSize: 36,
        pokemonImageUrl: MEGANIUM$2.images[1].value,
        pokemonLevel: 57,
        pokemonNumber: MEGANIUM$2.number,
        pokemonType: MEGANIUM$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 11,
        stage: MEGANIUM$2.stage,
        weight: 222,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'Despite its small size, it can zap even adult humans. However, if it does so, it also surprises itself.',
        energyType: ENERGY_TYPES.LIGHTNING,
        hitPoints: 30,
        holo: true,
        holoStrength: holoStrength$7,
        id: 'neo_gen_012_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 1,
        lengthInches: 0,
        moves: [],
        name: PICHU$2.name,
        pokemonImagePositionX: 56,
        pokemonImagePositionY: 43,
        pokemonImageShadowColor: '#f5ba00',
        pokemonImageShadowSize: 1,
        pokemonImageSize: 33,
        pokemonImageUrl: PICHU$2.images[0].value,
        pokemonLevel: 5,
        pokemonNumber: PICHU$2.number,
        pokemonType: PICHU$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 12,
        weight: 4,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'Its sturdy wings look heavy, but they are actually hollow and light, allowing it to fly freely in the sky.',
        energyResistance: ENERGY_TYPES.GRASS,
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.METAL,
        energyWeakness: ENERGY_TYPES.FIRE,
        hitPoints: 60,
        holo: true,
        holoStrength: holoStrength$7,
        id: 'neo_gen_013_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: SKARMORY$4.name,
        pokemonImagePositionX: 52,
        pokemonImagePositionY: 44,
        pokemonImageSize: 40,
        pokemonImageUrl: SKARMORY$4.images[0].value,
        pokemonLevel: 30,
        pokemonNumber: SKARMORY$4.number,
        pokemonType: SKARMORY$4.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 13,
        weight: 111,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'When its head was bitten, toxins entered Slowpoke’s head and unlocked an extraordinary power.',
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 80,
        holo: true,
        holoStrength: holoStrength$7,
        id: 'neo_gen_014_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 6,
        lengthInches: 7,
        moves: [],
        name: SLOWKING$3.name,
        pokemonImagePositionX: 72,
        pokemonImagePositionY: 36,
        pokemonImageSize: 25,
        pokemonImageUrl: SLOWKING$3.images[0].value,
        pokemonLevel: 39,
        pokemonNumber: SLOWKING$3.number,
        pokemonType: SLOWKING$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 14,
        stage: SLOWKING$3.stage,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'Its body has been compressed deep under the ground. As a result, it is even harder than a diamond.',
        energyResistance: ENERGY_TYPES.GRASS,
        energyRetreatCost: 4,
        energyType: ENERGY_TYPES.METAL,
        energyWeakness: ENERGY_TYPES.FIRE,
        hitPoints: 110,
        holo: true,
        holoStrength: holoStrength$7,
        id: 'neo_gen_015_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 30,
        lengthInches: 2,
        moves: [],
        name: STEELIX$3.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 47,
        pokemonImageSize: 58,
        pokemonImageUrl: STEELIX$3.images[0].value,
        pokemonLevel: 64,
        pokemonNumber: STEELIX$3.number,
        pokemonType: STEELIX$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 15,
        stage: STEELIX$3.stage,
        weight: 882,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'They say that it will appear before kindhearted, caring people and shower them with happiness.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.COLORLESS,
        hitPoints: 60,
        holo: true,
        holoStrength: holoStrength$7,
        id: 'neo_gen_016_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 2,
        lengthInches: 0,
        moves: [],
        name: TOGETIC$2.name,
        pokemonImagePositionX: 53,
        pokemonImagePositionY: 43,
        pokemonImageSize: 27,
        pokemonImageUrl: TOGETIC$2.images[0].value,
        pokemonLevel: 31,
        pokemonNumber: TOGETIC$2.number,
        pokemonType: TOGETIC$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 16,
        stage: TOGETIC$2.stage,
        weight: 7,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'They say that it will appear before kindhearted, caring people and shower them with happiness.',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: ENERGY_TYPES.WATER,
        hitPoints: 100,
        holo: true,
        holoStrength: holoStrength$7,
        id: 'neo_gen_017_en',
        illustrator: ILLUSTRATORS.YOSHIDA,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: TYPHLOSION$4.name,
        pokemonImagePositionX: 46,
        pokemonImagePositionY: 39,
        pokemonImageSize: 39,
        pokemonImageUrl: TYPHLOSION$4.images[0].value,
        pokemonLevel: 55,
        pokemonNumber: TYPHLOSION$4.number,
        pokemonType: TYPHLOSION$4.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 17,
        stage: TYPHLOSION$4.stage,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'It has a secret, devastating move. It rubs its blazing fur together to cause huge explosions.',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: ENERGY_TYPES.WATER,
        hitPoints: 100,
        holo: true,
        holoStrength: holoStrength$7,
        id: 'neo_gen_018_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: TYPHLOSION$4.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: TYPHLOSION$4.images[1].value,
        pokemonLevel: 57,
        pokemonNumber: TYPHLOSION$4.number,
        pokemonType: TYPHLOSION$4.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 18,
        stage: TYPHLOSION$4.stage,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.ENERGY,
        description: "Damage done to the Pokémon Metal Energy is attached to is reduced by 10 (after applying Weakness and Resistance). If the Pokémon Metal Energy is attached to isn't Metal, whenever it damages a Pokémon, reduce that damage by 10 (before applying Weakness and Resistance). Metal Energy provides Metal Energy. (Doesn't count as a basic Energy card.)",
        energyType: ENERGY_TYPES.METAL,
        holo: true,
        holoStrength: holoStrength$7,
        id: 'neo_gen_019_en',
        name: METAL.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 19,
        weight: null,
    },
];

const { CLEFAIRY: CLEFAIRY$3, ELECTABUZZ: ELECTABUZZ$3, GLOOM: GLOOM$4, HORSEA: HORSEA$1, ODDISH: ODDISH$2, ONIX: ONIX$2, MAGMAR: MAGMAR$5, PIKACHU: PIKACHU$8, SEADRA: SEADRA$2, SLOWPOKE: SLOWPOKE$4, } = GEN_1_POKEMON;
const { AIPOM: AIPOM$1, ARIADOS: ARIADOS$2, BAYLEEF: BAYLEEF$2, CHIKORITA: CHIKORITA$1, CHINCHOU: CHINCHOU$2, CLEFFA: CLEFFA$2, CROCONAW: CROCONAW$4, CYNDAQUIL: CYNDAQUIL$2, DONPHAN: DONPHAN$2, ELEKID, FLAAFFY: FLAAFFY$6, FURRET: FURRET$1, GIRAFARIG: GIRAFARIG$3, GLIGAR: GLIGAR$2, GRANBULL: GRANBULL$2, HOOTHOOT: HOOTHOOT$1, HOPPIP: HOPPIP$3, LANTURN: LANTURN$3, LEDIAN: LEDIAN$3, LEDYBA: LEDYBA$4, MAGBY: MAGBY$1, MANTINE: MANTINE$3, MAREEP: MAREEP$4, MARILL: MARILL$4, MILTANK: MILTANK$1, MURKROW: MURKROW$3, NATU: NATU$3, NOCTOWL: NOCTOWL$3, PHANPY: PHANPY$2, PILOSWINE: PILOSWINE$5, QUAGSIRE: QUAGSIRE$2, QUILAVA: QUILAVA$4, SENTRET: SENTRET$1, SHUCKLE: SHUCKLE$3, SKIPLOOM: SKIPLOOM$2, SNEASEL: SNEASEL$3, SNUBBULL: SNUBBULL$2, SPINARAK: SPINARAK$2, STANTLER: STANTLER$2, SUDOWOODO: SUDOWOODO$1, SUNFLORA: SUNFLORA$2, SUNKERN: SUNKERN$2, SWINUB: SWINUB$4, TOGEPI: TOGEPI$4, TOTODILE: TOTODILE$2, WOOPER: WOOPER$2, XATU: XATU$3, } = GEN_2_POKEMON;
const NEO_GENESIS_NON_HOLOS = [
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.BABY,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        evolvesTo: CLEFAIRY$3.name,
        hitPoints: 100,
        id: 'neo_gen_020_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: CLEFFA$2.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: CLEFFA$2.images[0].value,
        pokemonLevel: 57,
        pokemonNumber: CLEFFA$2.number,
        pokemonType: CLEFFA$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 20,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        evolvesFrom: PHANPY$2.name,
        evolutionBoxImageUrl: PHANPY$2.images[0].value,
        hitPoints: 100,
        id: 'neo_gen_021_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: DONPHAN$2.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: DONPHAN$2.images[0].value,
        pokemonLevel: 57,
        pokemonNumber: DONPHAN$2.number,
        pokemonType: DONPHAN$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 21,
        stage: DONPHAN$2.stage,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.BABY,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        evolvesTo: ELECTABUZZ$3.name,
        hitPoints: 100,
        id: 'neo_gen_022_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: ELEKID.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: ELEKID.images[0].value,
        pokemonLevel: 57,
        pokemonNumber: ELEKID.number,
        pokemonType: ELEKID.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 22,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.BABY,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        evolvesTo: MAGMAR$5.name,
        hitPoints: 100,
        id: 'neo_gen_023_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: MAGBY$1.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: MAGBY$1.images[0].value,
        pokemonLevel: 57,
        pokemonNumber: MAGBY$1.number,
        pokemonType: MAGBY$1.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 23,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.DARKNESS,
        energyWeakness: null,
        hitPoints: 100,
        id: 'neo_gen_024_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: MURKROW$3.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: MURKROW$3.images[0].value,
        pokemonLevel: 57,
        pokemonNumber: MURKROW$3.number,
        pokemonType: MURKROW$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 24,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.DARKNESS,
        energyWeakness: null,
        hitPoints: 100,
        id: 'neo_gen_025_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: SNEASEL$3.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: SNEASEL$3.images[0].value,
        pokemonLevel: 57,
        pokemonNumber: SNEASEL$3.number,
        pokemonType: SNEASEL$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 25,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: 100,
        id: 'neo_gen_026_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: AIPOM$1.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: AIPOM$1.images[0].value,
        pokemonLevel: 57,
        pokemonNumber: AIPOM$1.number,
        pokemonType: AIPOM$1.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 26,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: SPINARAK$2.name,
        evolutionBoxImageUrl: SPINARAK$2.images[0].value,
        hitPoints: 100,
        id: 'neo_gen_027_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: ARIADOS$2.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: ARIADOS$2.images[0].value,
        pokemonLevel: 57,
        pokemonNumber: ARIADOS$2.number,
        pokemonType: ARIADOS$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 27,
        stage: ARIADOS$2.stage,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: CHIKORITA$1.name,
        evolutionBoxImageUrl: CHIKORITA$1.images[0].value,
        hitPoints: 100,
        id: 'neo_gen_028_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: BAYLEEF$2.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: BAYLEEF$2.images[0].value,
        pokemonLevel: 57,
        pokemonNumber: BAYLEEF$2.number,
        pokemonType: BAYLEEF$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 28,
        stage: BAYLEEF$2.stage,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: CHIKORITA$1.name,
        evolutionBoxImageUrl: CHIKORITA$1.images[0].value,
        hitPoints: 100,
        id: 'neo_gen_029_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: BAYLEEF$2.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: BAYLEEF$2.images[1].value,
        pokemonLevel: 57,
        pokemonNumber: BAYLEEF$2.number,
        pokemonType: BAYLEEF$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 29,
        stage: BAYLEEF$2.stage,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: 100,
        id: 'neo_gen_030_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: CLEFAIRY$3.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: CLEFAIRY$3.images[3].value,
        pokemonLevel: 57,
        pokemonNumber: CLEFAIRY$3.number,
        pokemonType: CLEFAIRY$3.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 30,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: TOTODILE$2.name,
        evolutionBoxImageUrl: TOTODILE$2.images[0].value,
        hitPoints: 100,
        id: 'neo_gen_031_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: CROCONAW$4.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: CROCONAW$4.images[0].value,
        pokemonLevel: 57,
        pokemonNumber: CROCONAW$4.number,
        pokemonType: CROCONAW$4.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 31,
        stage: CROCONAW$4.stage,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: TOTODILE$2.name,
        evolutionBoxImageUrl: TOTODILE$2.images[0].value,
        hitPoints: 100,
        id: 'neo_gen_032_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: CROCONAW$4.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: CROCONAW$4.images[1].value,
        pokemonLevel: 57,
        pokemonNumber: CROCONAW$4.number,
        pokemonType: CROCONAW$4.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 32,
        stage: CROCONAW$4.stage,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        hitPoints: 100,
        id: 'neo_gen_033_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: ELECTABUZZ$3.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: ELECTABUZZ$3.images[3].value,
        pokemonLevel: 57,
        pokemonNumber: ELECTABUZZ$3.number,
        pokemonType: ELECTABUZZ$3.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 33,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        evolvesFrom: MAREEP$4.name,
        evolutionBoxImageUrl: MAREEP$4.images[0].value,
        hitPoints: 100,
        id: 'neo_gen_034_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: FLAAFFY$6.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: FLAAFFY$6.images[0].value,
        pokemonLevel: 57,
        pokemonNumber: FLAAFFY$6.number,
        pokemonType: FLAAFFY$6.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 34,
        stage: FLAAFFY$6.stage,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        evolvesFrom: SENTRET$1.name,
        evolutionBoxImageUrl: SENTRET$1.images[0].value,
        hitPoints: 100,
        id: 'neo_gen_035_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: FURRET$1.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: FURRET$1.images[0].value,
        pokemonLevel: 57,
        pokemonNumber: FURRET$1.number,
        pokemonType: FURRET$1.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 35,
        stage: FURRET$1.stage,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: ODDISH$2.name,
        evolutionBoxImageUrl: ODDISH$2.images[0].value,
        hitPoints: 100,
        id: 'neo_gen_036_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: GLOOM$4.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: GLOOM$4.images[5].value,
        pokemonLevel: 57,
        pokemonNumber: GLOOM$4.number,
        pokemonType: GLOOM$4.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 36,
        stage: GLOOM$4.stage,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        evolvesFrom: SNUBBULL$2.name,
        evolutionBoxImageUrl: SNUBBULL$2.images[0].value,
        hitPoints: 100,
        id: 'neo_gen_037_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: GRANBULL$2.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: GRANBULL$2.images[0].value,
        pokemonLevel: 57,
        pokemonNumber: GRANBULL$2.number,
        pokemonType: GRANBULL$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 37,
        stage: GRANBULL$2.stage,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        evolvesFrom: CHINCHOU$2.name,
        evolutionBoxImageUrl: CHINCHOU$2.images[0].value,
        hitPoints: 100,
        id: 'neo_gen_038_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: LANTURN$3.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: LANTURN$3.images[0].value,
        pokemonLevel: 57,
        pokemonNumber: LANTURN$3.number,
        pokemonType: LANTURN$3.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 38,
        stage: LANTURN$3.stage,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: LEDYBA$4.name,
        evolutionBoxImageUrl: LEDYBA$4.images[0].value,
        hitPoints: 100,
        id: 'neo_gen_039_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: LEDIAN$3.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: LEDIAN$3.images[0].value,
        pokemonLevel: 57,
        pokemonNumber: LEDIAN$3.number,
        pokemonType: LEDIAN$3.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 39,
        stage: LEDIAN$3.stage,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        hitPoints: 100,
        id: 'neo_gen_040_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: MAGMAR$5.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: MAGMAR$5.images[3].value,
        pokemonLevel: 57,
        pokemonNumber: MAGMAR$5.number,
        pokemonType: MAGMAR$5.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 40,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: 100,
        id: 'neo_gen_041_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: MILTANK$1.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: MILTANK$1.images[0].value,
        pokemonLevel: 57,
        pokemonNumber: MILTANK$1.number,
        pokemonType: MILTANK$1.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 41,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        evolvesFrom: HOOTHOOT$1.name,
        evolutionBoxImageUrl: HOOTHOOT$1.images[0].value,
        hitPoints: 100,
        id: 'neo_gen_042_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: NOCTOWL$3.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: NOCTOWL$3.images[0].value,
        pokemonLevel: 57,
        pokemonNumber: NOCTOWL$3.number,
        pokemonType: NOCTOWL$3.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 42,
        stage: NOCTOWL$3.stage,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: 100,
        id: 'neo_gen_043_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: PHANPY$2.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: PHANPY$2.images[0].value,
        pokemonLevel: 57,
        pokemonNumber: PHANPY$2.number,
        pokemonType: PHANPY$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 43,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: SWINUB$4.name,
        evolutionBoxImageUrl: SWINUB$4.images[0].value,
        hitPoints: 100,
        id: 'neo_gen_044_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: PILOSWINE$5.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: PILOSWINE$5.images[0].value,
        pokemonLevel: 57,
        pokemonNumber: PILOSWINE$5.number,
        pokemonType: PILOSWINE$5.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 44,
        stage: PILOSWINE$5.stage,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: WOOPER$2.name,
        evolutionBoxImageUrl: WOOPER$2.images[0].value,
        hitPoints: 100,
        id: 'neo_gen_045_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: QUAGSIRE$2.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: QUAGSIRE$2.images[0].value,
        pokemonLevel: 57,
        pokemonNumber: QUAGSIRE$2.number,
        pokemonType: QUAGSIRE$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 45,
        stage: QUAGSIRE$2.stage,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        evolvesFrom: CYNDAQUIL$2.name,
        evolutionBoxImageUrl: CYNDAQUIL$2.images[0].value,
        hitPoints: 100,
        id: 'neo_gen_046_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: QUILAVA$4.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: QUILAVA$4.images[0].value,
        pokemonLevel: 57,
        pokemonNumber: QUILAVA$4.number,
        pokemonType: QUILAVA$4.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 46,
        stage: QUILAVA$4.stage,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        evolvesFrom: CYNDAQUIL$2.name,
        evolutionBoxImageUrl: CYNDAQUIL$2.images[0].value,
        hitPoints: 100,
        id: 'neo_gen_047_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: QUILAVA$4.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: QUILAVA$4.images[1].value,
        pokemonLevel: 57,
        pokemonNumber: QUILAVA$4.number,
        pokemonType: QUILAVA$4.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 47,
        stage: QUILAVA$4.stage,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: HORSEA$1.name,
        evolutionBoxImageUrl: HORSEA$1.images[0].value,
        hitPoints: 100,
        id: 'neo_gen_048_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: SEADRA$2.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: SEADRA$2.images[2].value,
        pokemonLevel: 57,
        pokemonNumber: SEADRA$2.number,
        pokemonType: SEADRA$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 48,
        stage: SEADRA$2.stage,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: HOPPIP$3.name,
        evolutionBoxImageUrl: HOPPIP$3.images[0].value,
        hitPoints: 100,
        id: 'neo_gen_049_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: SKIPLOOM$2.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: SKIPLOOM$2.images[0].value,
        pokemonLevel: 57,
        pokemonNumber: SKIPLOOM$2.number,
        pokemonType: SKIPLOOM$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 49,
        stage: SKIPLOOM$2.stage,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: SUNKERN$2.name,
        evolutionBoxImageUrl: SUNKERN$2.images[0].value,
        hitPoints: 100,
        id: 'neo_gen_050_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: SUNFLORA$2.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: SUNFLORA$2.images[0].value,
        pokemonLevel: 57,
        pokemonNumber: SUNFLORA$2.number,
        pokemonType: SUNFLORA$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 50,
        stage: SUNFLORA$2.stage,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: 100,
        id: 'neo_gen_051_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: TOGEPI$4.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: TOGEPI$4.images[2].value,
        pokemonLevel: 57,
        pokemonNumber: TOGEPI$4.number,
        pokemonType: TOGEPI$4.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 51,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        evolvesFrom: NATU$3.name,
        evolutionBoxImageUrl: NATU$3.images[0].value,
        hitPoints: 100,
        id: 'neo_gen_052_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: XATU$3.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: XATU$3.images[0].value,
        pokemonLevel: 57,
        pokemonNumber: XATU$3.number,
        pokemonType: XATU$3.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 52,
        stage: XATU$3.stage,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: 100,
        id: 'neo_gen_053_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: CHIKORITA$1.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: CHIKORITA$1.images[0].value,
        pokemonLevel: 57,
        pokemonNumber: CHIKORITA$1.number,
        pokemonType: CHIKORITA$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 53,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: 100,
        id: 'neo_gen_054_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: CHIKORITA$1.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: CHIKORITA$1.images[1].value,
        pokemonLevel: 57,
        pokemonNumber: CHIKORITA$1.number,
        pokemonType: CHIKORITA$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 54,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        hitPoints: 100,
        id: 'neo_gen_055_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: CHINCHOU$2.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: CHINCHOU$2.images[0].value,
        pokemonLevel: 57,
        pokemonNumber: CHINCHOU$2.number,
        pokemonType: CHINCHOU$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 55,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        hitPoints: 100,
        id: 'neo_gen_056_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: CYNDAQUIL$2.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: CYNDAQUIL$2.images[0].value,
        pokemonLevel: 57,
        pokemonNumber: CYNDAQUIL$2.number,
        pokemonType: CYNDAQUIL$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 56,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        hitPoints: 100,
        id: 'neo_gen_057_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: CYNDAQUIL$2.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: CYNDAQUIL$2.images[1].value,
        pokemonLevel: 57,
        pokemonNumber: CYNDAQUIL$2.number,
        pokemonType: CYNDAQUIL$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 57,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: 100,
        id: 'neo_gen_058_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: GIRAFARIG$3.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: GIRAFARIG$3.images[0].value,
        pokemonLevel: 57,
        pokemonNumber: GIRAFARIG$3.number,
        pokemonType: GIRAFARIG$3.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 58,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: 100,
        id: 'neo_gen_059_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: GLIGAR$2.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: GLIGAR$2.images[0].value,
        pokemonLevel: 57,
        pokemonNumber: GLIGAR$2.number,
        pokemonType: GLIGAR$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 59,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: 100,
        id: 'neo_gen_060_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: HOOTHOOT$1.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: HOOTHOOT$1.images[0].value,
        pokemonLevel: 57,
        pokemonNumber: HOOTHOOT$1.number,
        pokemonType: HOOTHOOT$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 60,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: 100,
        id: 'neo_gen_061_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: HOPPIP$3.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: HOPPIP$3.images[0].value,
        pokemonLevel: 57,
        pokemonNumber: HOPPIP$3.number,
        pokemonType: HOPPIP$3.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 61,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: 100,
        id: 'neo_gen_062_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: HORSEA$1.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: HORSEA$1.images[4].value,
        pokemonLevel: 57,
        pokemonNumber: HORSEA$1.number,
        pokemonType: HORSEA$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 62,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: 100,
        id: 'neo_gen_063_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: LEDYBA$4.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: LEDYBA$4.images[0].value,
        pokemonLevel: 57,
        pokemonNumber: LEDYBA$4.number,
        pokemonType: LEDYBA$4.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 63,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: 100,
        id: 'neo_gen_064_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: MANTINE$3.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: MANTINE$3.images[0].value,
        pokemonLevel: 57,
        pokemonNumber: MANTINE$3.number,
        pokemonType: MANTINE$3.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 64,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        hitPoints: 100,
        id: 'neo_gen_065_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: MAREEP$4.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: MAREEP$4.images[0].value,
        pokemonLevel: 57,
        pokemonNumber: MAREEP$4.number,
        pokemonType: MAREEP$4.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 65,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: 100,
        id: 'neo_gen_066_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: MARILL$4.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: MARILL$4.images[1].value,
        pokemonLevel: 57,
        pokemonNumber: MARILL$4.number,
        pokemonType: MARILL$4.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 66,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: 100,
        id: 'neo_gen_067_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: NATU$3.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: NATU$3.images[0].value,
        pokemonLevel: 57,
        pokemonNumber: NATU$3.number,
        pokemonType: NATU$3.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 67,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: 100,
        id: 'neo_gen_068_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: ODDISH$2.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: ODDISH$2.images[4].value,
        pokemonLevel: 57,
        pokemonNumber: ODDISH$2.number,
        pokemonType: ODDISH$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 68,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        hitPoints: 100,
        id: 'neo_gen_069_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: ONIX$2.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: ONIX$2.images[3].value,
        pokemonLevel: 57,
        pokemonNumber: ONIX$2.number,
        pokemonType: ONIX$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 69,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        hitPoints: 100,
        id: 'neo_gen_070_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: PIKACHU$8.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: PIKACHU$8.images[3].value,
        pokemonLevel: 57,
        pokemonNumber: PIKACHU$8.number,
        pokemonType: PIKACHU$8.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 70,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: 100,
        id: 'neo_gen_071_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: SENTRET$1.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: SENTRET$1.images[0].value,
        pokemonLevel: 57,
        pokemonNumber: SENTRET$1.number,
        pokemonType: SENTRET$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 71,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: 100,
        id: 'neo_gen_072_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: SHUCKLE$3.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: SHUCKLE$3.images[0].value,
        pokemonLevel: 57,
        pokemonNumber: SHUCKLE$3.number,
        pokemonType: SHUCKLE$3.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 72,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: 100,
        id: 'neo_gen_073_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: SLOWPOKE$4.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: SLOWPOKE$4.images[4].value,
        pokemonLevel: 57,
        pokemonNumber: SLOWPOKE$4.number,
        pokemonType: SLOWPOKE$4.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 73,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: 100,
        id: 'neo_gen_074_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: SNUBBULL$2.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: SNUBBULL$2.images[1].value,
        pokemonLevel: 57,
        pokemonNumber: SNUBBULL$2.number,
        pokemonType: SNUBBULL$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 74,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: 100,
        id: 'neo_gen_075_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: SPINARAK$2.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: SPINARAK$2.images[0].value,
        pokemonLevel: 57,
        pokemonNumber: SPINARAK$2.number,
        pokemonType: SPINARAK$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 75,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: 100,
        id: 'neo_gen_076_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: STANTLER$2.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: STANTLER$2.images[0].value,
        pokemonLevel: 57,
        pokemonNumber: STANTLER$2.number,
        pokemonType: STANTLER$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 76,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        hitPoints: 100,
        id: 'neo_gen_077_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: SUDOWOODO$1.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: SUDOWOODO$1.images[0].value,
        pokemonLevel: 57,
        pokemonNumber: SUDOWOODO$1.number,
        pokemonType: SUDOWOODO$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 77,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: 100,
        id: 'neo_gen_078_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: SUNKERN$2.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: SUNKERN$2.images[0].value,
        pokemonLevel: 57,
        pokemonNumber: SUNKERN$2.number,
        pokemonType: SUNKERN$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 78,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: 100,
        id: 'neo_gen_079_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: SWINUB$4.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: SWINUB$4.images[0].value,
        pokemonLevel: 57,
        pokemonNumber: SWINUB$4.number,
        pokemonType: SWINUB$4.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 79,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: 100,
        id: 'neo_gen_080_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: TOTODILE$2.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: TOTODILE$2.images[0].value,
        pokemonLevel: 57,
        pokemonNumber: TOTODILE$2.number,
        pokemonType: TOTODILE$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 80,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: 100,
        id: 'neo_gen_081_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: TOTODILE$2.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: TOTODILE$2.images[1].value,
        pokemonLevel: 57,
        pokemonNumber: TOTODILE$2.number,
        pokemonType: TOTODILE$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 81,
        weight: 175,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: 100,
        id: 'neo_gen_082_en',
        illustrator: null,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: WOOPER$2.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: WOOPER$2.images[0].value,
        pokemonLevel: 57,
        pokemonNumber: WOOPER$2.number,
        pokemonType: WOOPER$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 82,
        weight: 175,
    },
];

const NEO_TRAINERS = {
    ARCADE_GAME: {
        name: 'Arcade Game',
        image: '',
    },
    BALLOON_BERRY: {
        name: 'Balloon Berry',
        image: '',
    },
    BERRY: {
        name: 'Berry',
        image: '',
    },
    BILLS_TELEPORTER: {
        name: "Bill's Teleporter",
        image: '',
    },
    BROKEN_GROUND_GYM: {
        name: 'Broken Ground Gym',
        image: '',
    },
    CARD_FLIP_GAME: {
        name: 'Card-Flip Game',
        image: '',
    },
    COUNTERATTACK_CLAWS: {
        name: 'Counterattack Claws',
        image: '',
    },
    DOUBLE_GUST: {
        name: 'Double Gust',
        image: '',
    },
    ECOGYM: {
        name: 'Ecogym',
        image: '',
    },
    ENERGY_AMPLIFIER: {
        name: 'Energy Amplifier',
        image: '',
    },
    ENERGY_ARK: {
        name: 'Energy Ark',
        image: '',
    },
    ENERGY_CHARGE: {
        name: 'Energy Charge',
        image: '',
    },
    ENERGY_STADIUM: {
        name: 'Energy Stadium',
        image: '',
    },
    EXP_ALL: {
        name: 'EXP.ALL',
        image: '',
    },
    FOCUS_BAND: {
        name: 'Focus Band',
        image: '',
    },
    FOSSIL_EGG: {
        name: 'Fossil Egg',
        image: '',
    },
    GOLD_BERRY: {
        name: 'Gold Berry',
        image: '',
    },
    HEAL_POWDER: {
        name: 'Heal Powder',
        image: '',
    },
    HEALING_FIELD: {
        name: 'Healing Field',
        image: '',
    },
    HYPER_DEVOLUTION_SPRAY: {
        name: 'Hyper Devolution Spray',
        image: '',
    },
    IMPOSTOR_PROFESSOR_OAKS_INVENTION: {
        name: "Impostor Professor Oak's Invention",
        image: '',
    },
    LUCKY_STADIUM: {
        name: 'Lucky Stadium',
        image: '',
    },
    MAGNIFIER: {
        name: 'Magnifier',
        image: '',
    },
    MAIL_FROM_BILL: {
        name: 'Mail from Bill',
        image: '',
    },
    MARY: {
        name: 'Mary',
        image: '',
    },
    MIRACLE_BERRY: {
        name: 'Miracle Berry',
        image: '',
    },
    MOO_MOO_MILK: {
        name: 'Moo-Moo Milk',
        image: '',
    },
    NEW_POKEDEX: {
        name: 'New Pokédex',
        image: '',
    },
    OLD_ROD: {
        name: 'Old Rod',
        image: '',
    },
    POKEGEAR: {
        name: 'PokéGear',
        image: '',
    },
    POKEMON_BREEDER_FIELDS: {
        name: 'Pokémon Breeder Fields',
        image: '',
    },
    POKEMON_MARCH: {
        name: 'Pokémon March',
        image: '',
    },
    POKEMON_PERSONALITY_TEST: {
        name: 'Pokémon Personality Test',
    },
    PROFESSOR_ELM: {
        name: 'Professor Elm',
        image: 'https://poketcgshop.s3.amazonaws.com/trainer-card-images/professor-elm-genesis.jpg',
    },
    RADIO_TOWER: {
        name: 'Radio Tower',
        image: '',
    },
    ROCKETS_HIDEOUT: {
        name: "Rocket's Hideout",
        image: '',
    },
    RUIN_WALL: {
        name: 'Ruin Wall',
        image: '',
    },
    SPROUT_TOWER: {
        name: 'Sprout Tower',
        image: '',
    },
    SUPER_ENERGY_RETRIEVAL: {
        name: 'Super Energy Retrieval',
        image: '',
    },
    SUPER_ROD: {
        name: 'Super Rod',
        image: '',
    },
    SUPER_SCOOP_UP: {
        name: 'Super Scoop Up',
        image: '',
    },
    TEAM_ROCKETS_EVIL_DEEDS: {
        name: "Team Rocket's Evil Deeds",
        image: '',
    },
    THOUGHT_WAVE_MACHINE: {
        name: 'Thought Wave Machine',
        image: '',
    },
    TIME_CAPSULE: {
        name: 'Time Capsule',
        image: '',
    },
};

const { ARCADE_GAME, BERRY, BILLS_TELEPORTER, CARD_FLIP_GAME, DOUBLE_GUST, ECOGYM, ENERGY_CHARGE: ENERGY_CHARGE$1, FOCUS_BAND, GOLD_BERRY, MARY, MIRACLE_BERRY, MOO_MOO_MILK: MOO_MOO_MILK$2, NEW_POKEDEX, POKEGEAR, POKEMON_MARCH, PROFESSOR_ELM, SPROUT_TOWER, SUPER_ENERGY_RETRIEVAL, SUPER_ROD, SUPER_SCOOP_UP: SUPER_SCOOP_UP$2, TIME_CAPSULE, } = NEO_TRAINERS;
const NEO_GENESIS_TRAINERS = [
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'neo_gen_083_en',
        illustrator: null,
        isBoldName: true,
        name: ARCADE_GAME.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 83,
        subtitle: TRAINER_CARD_SUBTITLES.GOLDENROD_GAME_CORNER,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'neo_gen_084_en',
        illustrator: null,
        isBoldName: true,
        name: ECOGYM.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 84,
        subtitle: TRAINER_CARD_SUBTITLES.STADIUM_CARD,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'neo_gen_085_en',
        illustrator: null,
        isBoldName: true,
        name: ENERGY_CHARGE$1.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 85,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'neo_gen_086_en',
        illustrator: null,
        isBoldName: true,
        name: FOCUS_BAND.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 86,
        subtitle: TRAINER_CARD_SUBTITLES.POKEMON_TOOL,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'neo_gen_087_en',
        illustrator: null,
        isBoldName: true,
        name: MARY.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 87,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'neo_gen_088_en',
        illustrator: null,
        isBoldName: true,
        name: POKEGEAR.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 88,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'neo_gen_089_en',
        illustrator: null,
        isBoldName: true,
        name: SUPER_ENERGY_RETRIEVAL.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 89,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'neo_gen_090_en',
        illustrator: null,
        isBoldName: true,
        name: TIME_CAPSULE.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 90,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'neo_gen_091_en',
        illustrator: null,
        isBoldName: true,
        name: BILLS_TELEPORTER.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 91,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'neo_gen_092_en',
        illustrator: null,
        isBoldName: true,
        name: CARD_FLIP_GAME.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 92,
        subtitle: TRAINER_CARD_SUBTITLES.GOLDENROD_GAME_CORNER,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'neo_gen_093_en',
        illustrator: null,
        isBoldName: true,
        name: GOLD_BERRY.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 93,
        subtitle: TRAINER_CARD_SUBTITLES.POKEMON_TOOL,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'neo_gen_094_en',
        illustrator: null,
        isBoldName: true,
        name: MIRACLE_BERRY.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 94,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'neo_gen_095_en',
        illustrator: null,
        isBoldName: true,
        name: NEW_POKEDEX.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 95,
    },
    {
        backgroundImageUrl: PROFESSOR_ELM.image,
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: "Shuffle your hand into your deck. Then, draw 7 cards. You can't play any more Trainer cards this turn.",
        name: PROFESSOR_ELM.name,
        id: 'neo_gen_095_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        isBoldName: true,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 96,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'neo_gen_097_en',
        illustrator: null,
        isBoldName: true,
        name: SPROUT_TOWER.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 97,
        subtitle: TRAINER_CARD_SUBTITLES.STADIUM_CARD,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'neo_gen_098_en',
        illustrator: null,
        isBoldName: true,
        name: SUPER_SCOOP_UP$2.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 98,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'neo_gen_099_en',
        illustrator: null,
        isBoldName: true,
        name: BERRY.name,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 99,
        subtitle: TRAINER_CARD_SUBTITLES.POKEMON_TOOL,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'neo_gen_100_en',
        illustrator: null,
        isBoldName: true,
        name: DOUBLE_GUST.name,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 100,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'neo_gen_101_en',
        illustrator: null,
        isBoldName: true,
        name: MOO_MOO_MILK$2.name,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 101,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'neo_gen_102_en',
        illustrator: null,
        isBoldName: true,
        name: POKEMON_MARCH.name,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 102,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'neo_gen_103_en',
        illustrator: null,
        isBoldName: true,
        name: SUPER_ROD.name,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 103,
    },
];

const { DARKNESS, RECYCLE: RECYCLE$1 } = SPECIAL_ENERGIES;
const NEO_GENESIS_ENERGIES = [
    {
        cardTemplate: CARD_TEMPLATES.ENERGY,
        description: DARKNESS.descriptions.default,
        energyType: ENERGY_TYPES.DARKNESS,
        id: 'neo_gen_104_en',
        name: DARKNESS.name,
        illustrator: null,
        rarity: RARITY_TYPES.RARE,
        setNumber: 104,
    },
    {
        cardTemplate: CARD_TEMPLATES.ENERGY,
        description: RECYCLE$1.descriptions.default,
        id: 'neo_gen_105_en',
        name: RECYCLE$1.name,
        illustrator: null,
        rarity: RARITY_TYPES.RARE,
        setNumber: 105,
    },
    {
        cardTemplate: CARD_TEMPLATES.ENERGY,
        energyType: ENERGY_TYPES.FIGHTING,
        id: 'neo_gen_106_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        setNumber: 106,
    },
    {
        cardTemplate: CARD_TEMPLATES.ENERGY,
        energyType: ENERGY_TYPES.FIRE,
        id: 'neo_gen_107_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        setNumber: 107,
    },
    {
        cardTemplate: CARD_TEMPLATES.ENERGY,
        energyType: ENERGY_TYPES.GRASS,
        id: 'neo_gen_108_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        setNumber: 108,
    },
    {
        cardTemplate: CARD_TEMPLATES.ENERGY,
        energyType: ENERGY_TYPES.LIGHTNING,
        id: 'neo_gen_109_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        setNumber: 109,
    },
    {
        cardTemplate: CARD_TEMPLATES.ENERGY,
        energyType: ENERGY_TYPES.PSYCHIC,
        id: 'neo_gen_110_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        setNumber: 110,
    },
    {
        cardTemplate: CARD_TEMPLATES.ENERGY,
        energyType: ENERGY_TYPES.WATER,
        id: 'neo_gen_111_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        setNumber: 111,
    },
];

const setId$c = CARD_SETS.NEO_GENESIS.value;
const setName$c = CARD_SETS.NEO_GENESIS.label;
const setTotal$9 = NEO_GENESIS_SET_TOTAL;
const NEO_GENESIS_SET = {
    cardCounts: {
        holoRares: 19,
        rares: 16,
        uncommons: 35,
        commons: 35,
        energies: 6,
    },
    copyright: COPYRIGHTS.NEO_SET,
    description: SET_DESCRIPTIONS.NEO_GENESIS,
    holoSheetType: CARD_HOLO_SHEETS.COSMOS_2,
    id: setId$c,
    imageUrl: 'https://cdn.shopify.com/s/files/1/0840/1659/5249/collections/neo-genesis-cat-bg.jpg',
    name: setName$c,
    packInfo: BOOSTER_PACKS.NEO_GENESIS,
    releaseDate: RELEASE_DATES.NEO_GENESIS,
    reverseHoloSheetType: CARD_HOLO_SHEETS.COSMOS_2,
    setSymbol: setId$c,
    setTotal: setTotal$9,
    cards: [
        ...NEO_GENESIS_HOLOS,
        ...NEO_GENESIS_NON_HOLOS,
        ...NEO_GENESIS_TRAINERS,
        ...NEO_GENESIS_ENERGIES,
    ],
    themeDecks: [],
};

const { BULBASAUR: BULBASAUR$1, IVYSAUR: IVYSAUR$4, VENUSAUR: VENUSAUR$3 } = GEN_1_POKEMON;
const { SCIZOR: SCIZOR$4, SNEASEL: SNEASEL$2 } = GEN_2_POKEMON;
const setId$b = CARD_SETS.BEST_OF_GAME.value;
const setName$b = CARD_SETS.BEST_OF_GAME.label;
const BEST_OF_GAME_SET = {
    copyright: COPYRIGHTS.BEST_OF_GAME_SET,
    description: SET_DESCRIPTIONS.BEST_OF_GAME,
    holoSheetType: CARD_HOLO_SHEETS.COSMOS_2,
    id: setId$b,
    imageUrl: 'https://cdn.shopify.com/s/files/1/0840/1659/5249/collections/best-of-game.jpg',
    name: setName$b,
    releaseDate: RELEASE_DATES.BEST_OF_GAME,
    reverseHoloSheetType: CARD_HOLO_SHEETS.COSMOS_2,
    setSymbol: setId$b,
    cards: [
        {
            ...BASE_SET.cards[19],
            holo: 'reverse',
            id: 'bog_01_en',
            rarity: null,
            setNumber: 1,
            stamp: STAMP_TYPES.WINNER,
        },
        {
            ...BASE_SET.cards[6],
            holo: 'reverse',
            id: 'bog_02_en',
            rarity: null,
            setNumber: 2,
            stamp: STAMP_TYPES.WINNER,
        },
        {
            ...NEO_GENESIS_SET.cards[95],
            holo: 'reverse',
            id: 'bog_03_en',
            rarity: null,
            setNumber: 3,
            stamp: STAMP_TYPES.WINNER,
        },
        {
            cardTemplate: CARD_TEMPLATES.E_SERIES,
            energyResistance: ENERGY_TYPES.GRASS,
            energyRetreatCost: 2,
            energyType: ENERGY_TYPES.METAL,
            energyWeakness: ENERGY_TYPES.FIRE,
            hitPoints: 60,
            id: 'bog_04_en',
            illustrator: ILLUSTRATORS.HOSHIBA,
            lengthFeet: 3,
            lengthInches: 11,
            name: `Rocket's ${SCIZOR$4.name}`,
            moves: [
                MOVES.FOCUS,
                SHARED_MOVES(SCIZOR$4.name, 'agility', ['metal', 'colorless', 'colorless'], 20),
            ],
            pokemonImageSize: 53,
            pokemonImagePositionX: 50,
            pokemonImagePositionY: 45,
            pokemonImageUrl: SCIZOR$4.images[0].value,
            pokemonType: SCIZOR$4.pokemonType,
            setNumber: 4,
            stamp: STAMP_TYPES.WINNER,
            weight: 260,
        },
        {
            cardTemplate: CARD_TEMPLATES.E_SERIES,
            energyResistance: ENERGY_TYPES.PSYCHIC,
            energyRetreatCost: 1,
            energyType: ENERGY_TYPES.DARKNESS,
            energyWeakness: ENERGY_TYPES.FIGHTING,
            hitPoints: 60,
            id: 'bog_05_en',
            illustrator: ILLUSTRATORS.TABATA,
            lengthFeet: 2,
            lengthInches: 11,
            name: `Rocket's ${SNEASEL$2.name}`,
            moves: [MOVES.ENTRAP, MOVES.CONTINUOUS_STRETCH],
            pokemonImageUrl: SNEASEL$2.images[0].value,
            pokemonType: SNEASEL$2.pokemonType,
            setNumber: 5,
            stamp: STAMP_TYPES.WINNER,
            weight: 62,
        },
        {
            backgroundImageUrl: IVYSAUR$4.images[2].value,
            cardTemplate: CARD_TEMPLATES.E_SERIES,
            energyRetreatCost: 2,
            energyType: ENERGY_TYPES.GRASS,
            energyWeakness: ENERGY_TYPES.FIRE,
            eReaderId: 'Y - 02',
            evolutionBoxImageUrl: BULBASAUR$1.images[0].value,
            evolvesFrom: BULBASAUR$1.name,
            hitPoints: 60,
            id: 'bog_06_en',
            illustrator: ILLUSTRATORS.YOSHIDA,
            lengthFeet: 3,
            lengthInches: 3,
            moves: [MOVES.VINE_PULL, MOVES.FURY_STRIKES],
            name: `Dark ${IVYSAUR$4.name}`,
            pokemonType: IVYSAUR$4.pokemonType,
            setNumber: 6,
            stage: IVYSAUR$4.stage,
            stamp: STAMP_TYPES.WINNER,
            weight: 29,
        },
        {
            backgroundImageUrl: VENUSAUR$3.images[2].value,
            cardTemplate: CARD_TEMPLATES.E_SERIES,
            energyRetreatCost: 2,
            energyType: ENERGY_TYPES.GRASS,
            energyWeakness: ENERGY_TYPES.FIRE,
            eReaderId: 'Y - 03 - #',
            evolutionBoxImageUrl: IVYSAUR$4.images[0].value,
            evolvesFrom: `Dark ${IVYSAUR$4.name}`,
            hitPoints: 70,
            id: 'bog_07_en',
            illustrator: ILLUSTRATORS.YOSHIDA,
            lengthFeet: 6,
            lengthInches: 7,
            name: `Dark ${VENUSAUR$3.name}`,
            moves: [MOVES.HORRID_POLLEN],
            pokemonType: VENUSAUR$3.pokemonType,
            setNumber: 7,
            stage: VENUSAUR$3.stage,
            stamp: STAMP_TYPES.WINNER,
            weight: 221,
        },
        {
            ...GYM_CHALLENGE_SET.cards[13],
            holo: 'reverse',
            id: 'bog_08_en',
            rarity: null,
            setNumber: 8,
            stamp: STAMP_TYPES.WINNER,
        },
        {
            ...GYM_HEROES_SET.cards[10],
            holo: 'reverse',
            id: 'bog_09_en',
            rarity: null,
            setNumber: 9,
            stamp: STAMP_TYPES.WINNER,
        },
    ],
};

const BLACK_STAR_PROMO_TRAINERS = {
    COMPUTER_ERROR: {
        name: 'Computer Error',
        image: '',
    },
    LUCKY_STADIUM: {
        name: 'Lucky Stadium',
        image: '',
    },
    POKEMON_CENTER_PROMO: {
        name: 'Pokémon Center',
        image: '',
    },
    POKEMON_TOWER_PROMO: {
        name: 'Pokémon Tower',
        image: '',
    },
};

const { ABRA: ABRA$3, ARCANINE: ARCANINE$2, ARTICUNO: ARTICUNO$3, DRAGONAIR: DRAGONAIR$7, DRAGONITE: DRAGONITE$5, EEVEE: EEVEE$7, ELECTABUZZ: ELECTABUZZ$2, GROWLITHE: GROWLITHE$4, IVYSAUR: IVYSAUR$3, JIGGLYPUFF: JIGGLYPUFF$4, MACHAMP: MACHAMP$5, MACHOKE: MACHOKE$7, MAGMAR: MAGMAR$4, MEW: MEW$2, MEWTWO: MEWTWO$2, MEOWTH: MEOWTH$3, MOLTRES: MOLTRES$2, PERSIAN: PERSIAN$3, PIKACHU: PIKACHU$7, PONYTA: PONYTA$3, PORYGON: PORYGON$4, PSYDUCK: PSYDUCK$3, RAPIDASH: RAPIDASH$3, SCYTHER: SCYTHER$4, SNORLAX: SNORLAX$1, VENUSAUR: VENUSAUR$2, ZAPDOS: ZAPDOS$1, } = GEN_1_POKEMON;
const { COMPUTER_ERROR, LUCKY_STADIUM: LUCKY_STADIUM$1, POKEMON_CENTER_PROMO, POKEMON_TOWER_PROMO, } = BLACK_STAR_PROMO_TRAINERS;
const { SABRINA } = GYM_LEADERS;
const { CELEBI: CELEBI$4, CLEFFA: CLEFFA$1, ENTEI: ENTEI$3, HITMONTOP: HITMONTOP$2, HO_OH: HO_OH$3, IGGLYBUFF: IGGLYBUFF$2, MARILL: MARILL$3, MISDREAVUS: MISDREAVUS$3, PICHU: PICHU$1, SCIZOR: SCIZOR$3, SMEARGLE: SMEARGLE$1, SUICUNE: SUICUNE$3, TOGEPI: TOGEPI$3, UNOWN_J, } = GEN_2_POKEMON;
const MEW_CARD = {
    backgroundImageUrl: '',
    cardTemplate: CARD_TEMPLATES.BASE,
    copyright: WOTC_LATE_ERA_COPYRIGHT,
    description: 'So rare that it is still said to be a mirage by many experts. Only a few people have seen it worldwide.',
    energyRetreatCost: 1,
    energyType: ENERGY_TYPES.PSYCHIC,
    energyWeakness: ENERGY_TYPES.PSYCHIC,
    hitPoints: 50,
    illustrator: ILLUSTRATORS.SUGIMORI,
    lengthFeet: 1,
    lengthInches: 4,
    moves: [],
    name: MEW$2.name,
    pokemonImagePositionX: 60,
    pokemonImagePositionY: 52,
    pokemonImageSize: 31,
    pokemonLevel: 23,
    pokemonNumber: MEW$2.number,
    pokemonType: MEW$2.pokemonType,
    weight: 9,
};
const MEWTWO_CARD = {
    backgroundImageUrl: '',
    cardTemplate: CARD_TEMPLATES.BASE,
    description: 'Years of genetic experiments resulted in the creation of this never-before-seen violent Pokémon.',
    energyRetreatCost: 2,
    energyType: ENERGY_TYPES.PSYCHIC,
    energyWeakness: ENERGY_TYPES.PSYCHIC,
    hitPoints: 70,
    illustrator: ILLUSTRATORS.SUGIMORI,
    lengthFeet: 6,
    lengthInches: 7,
    moves: [],
    name: MEWTWO$2.name,
    pokemonImagePositionX: 60,
    pokemonImagePositionY: 52,
    pokemonImageSize: 31,
    pokemonLevel: 60,
    pokemonNumber: MEWTWO$2.number,
    pokemonType: MEWTWO$2.pokemonType,
    weight: 269,
};
const BLACK_STAR_PROMO_CARDS = [
    {
        backgroundImageUrl: PIKACHU$7.images[4].value,
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'When several of these Pokémon gather, their electricity could build and cause lightning storms.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 60,
        id: 'bs_promo_01_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        lengthFeet: 1,
        lengthInches: 4,
        moves: [
            MOVES.GROWL,
            SHARED_MOVES(PIKACHU$7.name, 'thundershock', ['lightning', 'lightning'], 20),
        ],
        name: PIKACHU$7.name,
        pokemonImagePositionX: 60,
        pokemonImagePositionY: 52,
        pokemonImageSize: 31,
        pokemonLevel: 16,
        pokemonNumber: PIKACHU$7.number,
        pokemonType: PIKACHU$7.pokemonType,
        setNumber: 1,
        weight: 13,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'A wild Pokémon with a short temper. It is able to distinguish colors, and likes the color red.',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 60,
        id: 'bs_promo_02_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 3,
        lengthInches: 7,
        moves: [],
        name: ELECTABUZZ$2.name,
        pokemonImagePositionX: 60,
        pokemonImagePositionY: 52,
        pokemonImageSize: 31,
        pokemonLevel: 20,
        pokemonNumber: ELECTABUZZ$2.number,
        pokemonType: ELECTABUZZ$2.pokemonType,
        setNumber: 2,
        weight: 66,
    },
    {
        ...MEWTWO_CARD,
        copyright: WOTC_LATE_ERA_COPYRIGHT,
        id: 'bs_promo_03_en',
        setNumber: 3,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'When several of these Pokémon gather, they attract so much electricity that they can cause lightning to strike.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 50,
        id: 'bs_promo_04_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 1,
        lengthInches: 4,
        moves: [],
        name: PIKACHU$7.name,
        pokemonImagePositionX: 60,
        pokemonImagePositionY: 52,
        pokemonImageSize: 31,
        pokemonLevel: 13,
        pokemonNumber: PIKACHU$7.number,
        pokemonType: PIKACHU$7.pokemonType,
        setNumber: 4,
        weight: 13,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'This Pokémon can fly in spite of its large bulk. It is said to be able to circumnavigate the earth in just 16 hours.',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.COLORLESS,
        evolvesFrom: DRAGONAIR$7.name,
        evolutionBoxImageUrl: DRAGONAIR$7.images[0].value,
        hitPoints: 90,
        id: 'bs_promo_05_en',
        illustrator: ILLUSTRATORS.AOKI,
        lengthFeet: 7,
        lengthInches: 3,
        moves: [],
        name: DRAGONITE$5.name,
        pokemonImagePositionX: 60,
        pokemonImagePositionY: 52,
        pokemonImageSize: 31,
        pokemonLevel: 13,
        pokemonNumber: DRAGONITE$5.number,
        pokemonType: DRAGONITE$5.pokemonType,
        setNumber: 5,
        stage: DRAGONITE$5.stage,
        weight: 463,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        copyright: WOTC_LATE_ERA_COPYRIGHT,
        description: 'A legendary Pokémon famous for its beauty. It looks almost as if it flies when it runs.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: ENERGY_TYPES.WATER,
        evolvesFrom: GROWLITHE$4.name,
        evolutionBoxImageUrl: GROWLITHE$4.images[0].value,
        hitPoints: 70,
        id: 'bs_promo_06_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 6,
        lengthInches: 3,
        moves: [],
        name: ARCANINE$2.name,
        pokemonImagePositionX: 60,
        pokemonImagePositionY: 52,
        pokemonImageSize: 31,
        pokemonLevel: 13,
        pokemonNumber: ARCANINE$2.number,
        pokemonType: ARCANINE$2.pokemonType,
        setNumber: 6,
        stage: ARCANINE$2.stage,
        weight: 342,
    },
    {
        backgroundImageUrl: 'https://thumbs.gfycat.com/AchingSoggyCur-size_restricted.gif',
        cardTemplate: CARD_TEMPLATES.BASE,
        copyright: WOTC_LATE_ERA_COPYRIGHT,
        description: 'When its huge eyes light up, it sings a mysteriously soothing melody that lulls its enemies to sleep.',
        energyResistance: ENERGY_TYPES.PSYCHIC,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 50,
        id: 'bs_promo_07_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        lengthFeet: 1,
        lengthInches: 8,
        moves: [
            MOVES.FIRST_AID,
            SHARED_MOVES(JIGGLYPUFF$4.name, 'double-edge', ['colorless', 'colorless', 'colorless'], 40, 20),
        ],
        name: JIGGLYPUFF$4.name,
        pokemonImagePositionX: 60,
        pokemonImagePositionY: 52,
        pokemonImageSize: 31,
        pokemonImageUrl: JIGGLYPUFF$4.images[3].value,
        pokemonLevel: 12,
        pokemonNumber: JIGGLYPUFF$4.number,
        pokemonType: JIGGLYPUFF$4.pokemonType,
        setNumber: 7,
        weight: 12,
    },
    {
        ...MEW_CARD,
        id: 'bs_promo_08_en',
        setNumber: 8,
    },
    {
        ...MEW_CARD,
        holo: true,
        holoStrength: 0.7,
        id: 'bs_promo_09_en',
        setNumber: 9,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        copyright: WOTC_LATE_ERA_COPYRIGHT,
        description: "Appears to be more active at night. It loves round and shiny things, so it can't stop from picking them up.",
        energyResistance: ENERGY_TYPES.PSYCHIC,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 50,
        holo: true,
        holoStrength: 0.7,
        id: 'bs_promo_10_en',
        illustrator: ILLUSTRATORS.HIMENO,
        lengthFeet: 1,
        lengthInches: 4,
        moves: [],
        name: MEOWTH$3.name,
        pokemonImagePositionX: 60,
        pokemonImagePositionY: 52,
        pokemonImageSize: 31,
        pokemonLevel: 13,
        pokemonNumber: MEOWTH$3.number,
        pokemonType: MEOWTH$3.pokemonType,
        setNumber: 10,
        weight: 9,
    },
    {
        backgroundImageUrl: 'https://giffiles.alphacoders.com/916/91665.gif',
        cardTemplate: CARD_TEMPLATES.BASE,
        copyright: WOTC_LATE_ERA_COPYRIGHT,
        description: 'Its genetic code is irregular. It may mutate if it is exposed to radiation from elemental stones.',
        energyResistance: ENERGY_TYPES.PSYCHIC,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 30,
        holo: true,
        holoStrength: 0.7,
        id: 'bs_promo_11_en',
        illustrator: ILLUSTRATORS.HIMENO,
        lengthFeet: 1,
        lengthInches: 0,
        moves: [
            MOVES.CHAIN_REACTION,
            SHARED_MOVES(EEVEE$7.name, 'bite', ['colorless'], 20),
        ],
        name: EEVEE$7.name,
        pokemonImagePositionX: 45,
        pokemonImagePositionY: 42,
        pokemonImageSize: 49,
        pokemonImageUrl: EEVEE$7.images[4].value,
        pokemonLevel: 7,
        pokemonNumber: EEVEE$7.number,
        pokemonType: EEVEE$7.pokemonType,
        setNumber: 11,
        weight: 14,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        copyright: WOTC_LATE_ERA_COPYRIGHT,
        description: 'A scientist created this Pokémon after years of horrific gene-splicing and DNA engineering experiments.',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 60,
        id: 'bs_promo_12_en',
        illustrator: ILLUSTRATORS.RUSH,
        lengthFeet: 6,
        lengthInches: 7,
        moves: [],
        name: MEWTWO$2.name,
        pokemonImagePositionX: 60,
        pokemonImagePositionY: 52,
        pokemonImageSize: 31,
        pokemonLevel: 30,
        pokemonNumber: MEWTWO$2.number,
        pokemonType: MEWTWO$2.pokemonType,
        setNumber: 12,
        weight: 269,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        copyright: WOTC_LATE_ERA_COPYRIGHT,
        description: 'This plant blooms when it is absorbing solar energy. It stays on the move to seek sunlight.',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        evolutionBoxImageUrl: IVYSAUR$3.images[0].value,
        evolvesFrom: IVYSAUR$3.name,
        hitPoints: 100,
        holo: true,
        holoStrength: 0.7,
        id: 'bs_promo_13_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 6,
        lengthInches: 7,
        moves: [],
        name: VENUSAUR$2.name,
        pokemonImagePositionX: 60,
        pokemonImagePositionY: 52,
        pokemonImageSize: 31,
        pokemonLevel: 64,
        pokemonNumber: VENUSAUR$2.number,
        pokemonType: VENUSAUR$2.pokemonType,
        setNumber: 13,
        stage: VENUSAUR$2.stage,
        weight: 221,
    },
    {
        ...MEWTWO_CARD,
        id: 'bs_promo_14_en',
        setNumber: 14,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        copyright: WOTC_LATE_ERA_COPYRIGHT,
        description: 'A Pokémon that consists entirely of programming code. Capable of moving freely in cyberspace.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 50,
        holo: true,
        holoStrength: 0.7,
        id: 'bs_promo_15_en',
        illustrator: ILLUSTRATORS.SUGIYAMA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: `Cool ${PORYGON$4.name}`,
        pokemonImagePositionX: 60,
        pokemonImagePositionY: 52,
        pokemonImageSize: 31,
        pokemonLevel: 30,
        pokemonNumber: PORYGON$4.number,
        pokemonType: PORYGON$4.pokemonType,
        setNumber: 15,
        weight: 80,
    },
    {
        backgroundImageUrl: COMPUTER_ERROR.image,
        cardTemplate: CARD_TEMPLATES.TRAINER,
        copyright: WOTC_LATE_ERA_COPYRIGHT,
        description: "You may draw up to 5 cards, then your opponent may draw up to 5 cards. Your turn is over now (you don't get to attack).",
        id: 'bs_promo_16_en',
        illustrator: ILLUSTRATORS.KIZUKI,
        name: COMPUTER_ERROR.name,
        setNumber: 16,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        copyright: WOTC_LATE_ERA_COPYRIGHT,
        description: 'Popular with women because of its beautiful fur. The leader of the Rockets keeps one as a pet.',
        energyResistance: ENERGY_TYPES.PSYCHIC,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolutionBoxImageUrl: MEOWTH$3.images[0].value,
        evolvesFrom: MEOWTH$3.name,
        frameMode: 'dark',
        hitPoints: 60,
        holo: true,
        holoStrength: 0.7,
        id: 'bs_promo_17_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: `Dark ${PERSIAN$3.name}`,
        pokemonImagePositionX: 60,
        pokemonImagePositionY: 52,
        pokemonImageSize: 31,
        pokemonLevel: 28,
        pokemonNumber: PERSIAN$3.number,
        pokemonType: PERSIAN$3.pokemonType,
        setNumber: 17,
        stage: PERSIAN$3.stage,
        weight: 71,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        copyright: WOTC_LATE_ERA_COPYRIGHT,
        description: 'This Pokémon is more active at night. It likes bright, shiny things and cannot resist taking them and adding them to its collection.',
        energyResistance: ENERGY_TYPES.PSYCHIC,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 40,
        id: 'bs_promo_18_en',
        illustrator: ILLUSTRATORS.YUYAMA,
        lengthFeet: 1,
        lengthInches: 4,
        moves: [],
        name: `Team Rocket's ${MEOWTH$3.name}`,
        pokemonImagePositionX: 60,
        pokemonImagePositionY: 52,
        pokemonImageSize: 31,
        pokemonLevel: 13,
        pokemonNumber: MEOWTH$3.number,
        pokemonType: MEOWTH$3.pokemonType,
        setNumber: 18,
        weight: 9,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.GYM,
        copyright: WOTC_LATE_ERA_COPYRIGHT,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 40,
        id: 'bs_promo_19_en',
        illustrator: ILLUSTRATORS.NISHIDA,
        lengthFeet: 2,
        lengthInches: 11,
        moves: [],
        name: `Sabrina's ${ABRA$3.name}`,
        pokemonImagePositionX: 60,
        pokemonImagePositionY: 52,
        pokemonImageSize: 31,
        pokemonLevel: 12,
        pokemonNumber: ABRA$3.number,
        pokemonType: ABRA$3.pokemonType,
        setNumber: 19,
        trainerImageUrl: SABRINA.images[0].value,
        weight: 43,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        copyright: WOTC_LATE_ERA_COPYRIGHT,
        description: 'While lulling its enemies with its vacant look, this wily Pokémon will use psychokinetic powers.',
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 50,
        id: 'bs_promo_20_en',
        illustrator: ILLUSTRATORS.HIMENO,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: PSYDUCK$3.name,
        pokemonImagePositionX: 60,
        pokemonImagePositionY: 52,
        pokemonImageSize: 31,
        pokemonLevel: 15,
        pokemonNumber: PSYDUCK$3.number,
        pokemonType: PSYDUCK$3.pokemonType,
        setNumber: 20,
        weight: 43,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        copyright: WOTC_LATE_ERA_COPYRIGHT,
        description: "The flames on this legendary Pokémon's wings burn so brightly that they can make night seem like day.",
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.FIRE,
        hitPoints: 70,
        id: 'bs_promo_21_en',
        illustrator: ILLUSTRATORS.KIMURA,
        lengthFeet: 6,
        lengthInches: 7,
        moves: [],
        name: MOLTRES$2.name,
        pokemonImagePositionX: 60,
        pokemonImagePositionY: 52,
        pokemonImageSize: 31,
        pokemonLevel: 33,
        pokemonNumber: MOLTRES$2.number,
        pokemonType: MOLTRES$2.pokemonType,
        setNumber: 21,
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        copyright: WOTC_LATE_ERA_COPYRIGHT,
        description: 'This legendary Pokémon is said to freeze the water in the air during winter, causing snow.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.WATER,
        hitPoints: 70,
        id: 'bs_promo_22_en',
        illustrator: ILLUSTRATORS.AOKI,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: ARTICUNO$3.name,
        pokemonImagePositionX: 60,
        pokemonImagePositionY: 52,
        pokemonImageSize: 31,
        pokemonLevel: 34,
        pokemonNumber: ARTICUNO$3.number,
        pokemonType: ARTICUNO$3.pokemonType,
        setNumber: 22,
        weight: 122,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        copyright: WOTC_LATE_ERA_COPYRIGHT,
        description: 'This legendary Pokémon is said to be present wherever there is a lightning storm.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.LIGHTNING,
        hitPoints: 70,
        id: 'bs_promo_23_en',
        illustrator: ILLUSTRATORS.KIMURA,
        lengthFeet: 5,
        lengthInches: 3,
        moves: [],
        name: ZAPDOS$1.name,
        pokemonImagePositionX: 60,
        pokemonImagePositionY: 52,
        pokemonImageSize: 31,
        pokemonLevel: 34,
        pokemonNumber: ZAPDOS$1.number,
        pokemonType: ZAPDOS$1.pokemonType,
        setNumber: 23,
        weight: 116,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        copyright: WOTC_LATE_ERA_COPYRIGHT,
        description: 'Your Birthdate:__________',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 50,
        id: 'bs_promo_24_en',
        illustrator: ILLUSTRATORS.HIMENO,
        lengthFeet: 1,
        lengthInches: 4,
        moves: [],
        name: `________'s ${PIKACHU$7.name}`,
        pokemonImagePositionX: 60,
        pokemonImagePositionY: 52,
        pokemonImageSize: 31,
        pokemonLevel: 17,
        pokemonNumber: PIKACHU$7.number,
        pokemonType: PIKACHU$7.pokemonType,
        setNumber: 24,
        weight: 13,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        copyright: WOTC_1995_2001_COPYRIGHT,
        description: 'By learning how to fly, Pikachu overcame its weakness to Fighting Pokémon.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.LIGHTNING,
        hitPoints: 40,
        id: 'bs_promo_25_en',
        illustrator: ILLUSTRATORS.AOKI,
        lengthFeet: 1,
        lengthInches: 4,
        moves: [],
        name: `Flying ${PIKACHU$7.name}`,
        pokemonImagePositionX: 60,
        pokemonImagePositionY: 52,
        pokemonImageSize: 31,
        pokemonLevel: 12,
        pokemonNumber: PIKACHU$7.number,
        pokemonType: PIKACHU$7.pokemonType,
        setNumber: 25,
        weight: 13,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        copyright: WOTC_1995_2001_COPYRIGHT,
        description: 'It uses its sensitive tail to sense its environment and has been known to react violently if its tail is grabbed.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.LIGHTNING,
        hitPoints: 40,
        id: 'bs_promo_26_en',
        illustrator: ILLUSTRATORS.NOMOTO,
        lengthFeet: 1,
        lengthInches: 4,
        moves: [],
        name: PIKACHU$7.name,
        pokemonImagePositionX: 60,
        pokemonImagePositionY: 52,
        pokemonImageSize: 31,
        pokemonLevel: 9,
        pokemonNumber: PIKACHU$7.number,
        pokemonType: PIKACHU$7.pokemonType,
        setNumber: 26,
        weight: 13,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        copyright: WOTC_LATE_ERA_COPYRIGHT,
        description: 'When several of these Pokémon gather, their electricity can cause lightning storms.',
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 30,
        id: 'bs_promo_27_en',
        illustrator: ILLUSTRATORS.NISHIDA,
        lengthFeet: 1,
        lengthInches: 4,
        moves: [],
        name: PIKACHU$7.name,
        pokemonImagePositionX: 60,
        pokemonImagePositionY: 52,
        pokemonImageSize: 31,
        pokemonLevel: 5,
        pokemonNumber: PIKACHU$7.number,
        pokemonType: PIKACHU$7.pokemonType,
        setNumber: 27,
        weight: 13,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        copyright: WOTC_1995_2001_COPYRIGHT,
        description: 'One summer, a group of Pikachus was found riding the waves at the local beach.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 50,
        id: 'bs_promo_28_en',
        illustrator: ILLUSTRATORS.AOKI,
        lengthFeet: 1,
        lengthInches: 4,
        moves: [],
        name: `Surfing ${PIKACHU$7.name}`,
        pokemonImagePositionX: 60,
        pokemonImagePositionY: 52,
        pokemonImageSize: 31,
        pokemonLevel: 13,
        pokemonNumber: PIKACHU$7.number,
        pokemonType: PIKACHU$7.pokemonType,
        setNumber: 28,
        weight: 13,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        copyright: WOTC_1995_2000_COPYRIGHT,
        description: 'The tip of its tail, which contains oil that is lighter than water, lets it swim without drowning.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 50,
        id: 'bs_promo_29_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 1,
        lengthInches: 4,
        moves: [],
        name: MARILL$3.name,
        pokemonImagePositionX: 60,
        pokemonImagePositionY: 52,
        pokemonImageSize: 31,
        pokemonLevel: 17,
        pokemonNumber: MARILL$3.number,
        pokemonType: MARILL$3.pokemonType,
        setNumber: 29,
        weight: 19,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        copyright: WOTC_1995_2000_COPYRIGHT,
        description: 'Still only a hatchling, it uses poison to chase off its enemies when threatened.',
        energyResistance: ENERGY_TYPES.PSYCHIC,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.COLORLESS,
        hitPoints: 50,
        id: 'bs_promo_30_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 1,
        lengthInches: 0,
        moves: [],
        name: TOGEPI$3.name,
        pokemonImagePositionX: 60,
        pokemonImagePositionY: 52,
        pokemonImageSize: 31,
        pokemonLevel: 8,
        pokemonNumber: TOGEPI$3.number,
        pokemonType: TOGEPI$3.pokemonType,
        setNumber: 30,
        weight: 3,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        copyright: WOTC_1995_2000_COPYRIGHT,
        description: 'Because of its unusual, star-like silhouette, people believe that it came here on a meteor.',
        energyResistance: ENERGY_TYPES.PSYCHIC,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.COLORLESS,
        hitPoints: 30,
        id: 'bs_promo_31_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 1,
        lengthInches: 0,
        moves: [],
        name: CLEFFA$1.name,
        pokemonImagePositionX: 60,
        pokemonImagePositionY: 52,
        pokemonImageSize: 31,
        pokemonLevel: 5,
        pokemonNumber: CLEFFA$1.number,
        pokemonType: CLEFFA$1.pokemonType,
        setNumber: 31,
        weight: 7,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        copyright: WOTC_1995_2001_COPYRIGHT,
        description: 'Once it becomes an adult, it has a tendency to let its comrades plant footprints on its back.',
        energyResistance: ENERGY_TYPES.PSYCHIC,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 40,
        id: 'bs_promo_32_en',
        illustrator: ILLUSTRATORS.KOMIYA,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [],
        name: SMEARGLE$1.name,
        pokemonImagePositionX: 60,
        pokemonImagePositionY: 52,
        pokemonImageSize: 31,
        pokemonLevel: 21,
        pokemonNumber: SMEARGLE$1.number,
        pokemonType: SMEARGLE$1.pokemonType,
        setNumber: 32,
        weight: 128,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        copyright: WOTC_1995_2001_COPYRIGHT,
        description: 'Its wings are not used for flying. They are flapped at high speed to adjust its body temperature.',
        energyResistance: ENERGY_TYPES.GRASS,
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.METAL,
        energyWeakness: ENERGY_TYPES.FIRE,
        evolvesFrom: SCYTHER$4.name,
        evolutionBoxImageUrl: SCYTHER$4.images[0].value,
        hitPoints: 70,
        id: 'bs_promo_33_en',
        illustrator: ILLUSTRATORS.HIRONOBU,
        lengthFeet: 5,
        lengthInches: 11,
        moves: [],
        name: SCIZOR$3.name,
        pokemonImagePositionX: 60,
        pokemonImagePositionY: 52,
        pokemonImageSize: 31,
        pokemonLevel: 36,
        pokemonNumber: SCIZOR$3.number,
        pokemonType: SCIZOR$3.pokemonType,
        setNumber: 33,
        stage: SCIZOR$3.stage,
        weight: 260,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        copyright: WOTC_1995_2001_COPYRIGHT,
        description: 'Volcanoes erupt when it barks. Unable to restrain its extreme power, it races headlong around the land.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: ENERGY_TYPES.WATER,
        hitPoints: 80,
        holo: 'reverse',
        holoStrength: 0.7,
        id: 'bs_promo_34_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 6,
        lengthInches: 11,
        moves: [],
        name: ENTEI$3.name,
        pokemonImagePositionX: 60,
        pokemonImagePositionY: 52,
        pokemonImageSize: 31,
        pokemonLevel: 37,
        pokemonNumber: ENTEI$3.number,
        pokemonType: ENTEI$3.pokemonType,
        setNumber: 34,
        weight: 437,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        copyright: WOTC_1995_2001_COPYRIGHT,
        description: 'It is not yet skilled at storing electricity. It may send out a jolt if amused or startled.',
        energyType: ENERGY_TYPES.LIGHTNING,
        hitPoints: 30,
        holo: 'reverse',
        holoStrength: 0.7,
        id: 'bs_promo_35_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 1,
        lengthInches: 0,
        moves: [],
        name: PICHU$1.name,
        pokemonImagePositionX: 60,
        pokemonImagePositionY: 52,
        pokemonImageSize: 31,
        pokemonLevel: 4,
        pokemonNumber: PICHU$1.number,
        pokemonType: PICHU$1.pokemonType,
        setNumber: 35,
        weight: 4,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        copyright: WOTC_1995_2001_COPYRIGHT,
        description: 'Its extremely flexible and elastic body makes it bounce continuously – anytime, anywhere.',
        energyType: ENERGY_TYPES.COLORLESS,
        hitPoints: 30,
        id: 'bs_promo_36_en',
        illustrator: ILLUSTRATORS.HIMENO,
        lengthFeet: 1,
        lengthInches: 0,
        moves: [],
        name: IGGLYBUFF$2.name,
        pokemonImagePositionX: 60,
        pokemonImagePositionY: 52,
        pokemonImageSize: 31,
        pokemonLevel: 4,
        pokemonNumber: IGGLYBUFF$2.number,
        pokemonType: IGGLYBUFF$2.pokemonType,
        setNumber: 36,
        weight: 2,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        copyright: WOTC_1995_2001_COPYRIGHT,
        description: 'It launches kicks while spinning. If it spins at high speed, it may bore its way into the ground.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 60,
        id: 'bs_promo_37_en',
        illustrator: ILLUSTRATORS.NISHIDA,
        lengthFeet: 4,
        lengthInches: 7,
        moves: [],
        name: HITMONTOP$2.name,
        pokemonImagePositionX: 60,
        pokemonImagePositionY: 52,
        pokemonImageSize: 31,
        pokemonLevel: 29,
        pokemonNumber: HITMONTOP$2.number,
        pokemonType: HITMONTOP$2.pokemonType,
        setNumber: 37,
        weight: 106,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        copyright: WOTC_1995_2001_COPYRIGHT,
        description: 'Their shapes look like hieroglyphs on ancient tablets. It is said the two are somehow related.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 40,
        id: 'bs_promo_38_en',
        illustrator: ILLUSTRATORS.KAZAMA,
        lengthFeet: 1,
        lengthInches: 8,
        moves: [],
        name: UNOWN_J.name,
        pokemonImagePositionX: 60,
        pokemonImagePositionY: 52,
        pokemonImageSize: 31,
        pokemonLevel: 16,
        pokemonNumber: UNOWN_J.number,
        pokemonType: UNOWN_J.pokemonType,
        setNumber: 38,
        weight: 11,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        copyright: WOTC_1995_2001_COPYRIGHT,
        description: "It loves to bite and yank people's hair from behind without warning, just to see their shocked reactions.",
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 50,
        id: 'bs_promo_39_en',
        illustrator: ILLUSTRATORS.KAZAMA,
        lengthFeet: 2,
        lengthInches: 4,
        moves: [],
        name: MISDREAVUS$3.name,
        pokemonImagePositionX: 60,
        pokemonImagePositionY: 52,
        pokemonImageSize: 31,
        pokemonLevel: 23,
        pokemonNumber: MISDREAVUS$3.number,
        pokemonType: MISDREAVUS$3.pokemonType,
        setNumber: 39,
        weight: 2,
    },
    {
        backgroundImageUrl: POKEMON_CENTER_PROMO.image,
        cardTemplate: CARD_TEMPLATES.TRAINER,
        copyright: WOTC_1995_2000_COPYRIGHT,
        description: 'Remove all damage counters from all of your own Pokémon with damage counters on them, then discard all Energy cards attached to those Pokémon.',
        id: 'bs_promo_40_en',
        illustrator: ILLUSTRATORS.TAGAWA,
        name: POKEMON_CENTER_PROMO.name,
        setNumber: 40,
    },
    {
        backgroundImageUrl: LUCKY_STADIUM$1.image,
        cardTemplate: CARD_TEMPLATES.TRAINER,
        copyright: WOTC_1995_2000_COPYRIGHT,
        description: "Once during each player's turn (before attacking), that player may flip a coin. If heads, that player draws a card.",
        id: 'bs_promo_41_en',
        illustrator: ILLUSTRATORS.TAGAWA,
        name: LUCKY_STADIUM$1.name,
        setNumber: 41,
        subtitle: 'Stadium Card',
    },
    {
        backgroundImageUrl: POKEMON_TOWER_PROMO.image,
        cardTemplate: CARD_TEMPLATES.TRAINER,
        copyright: WOTC_1995_2000_COPYRIGHT,
        description: "If the effect of a Pokémon Power, attack, Energy card or Trainer card would put a card in a discard pile into its owner's hand, that card stays in that discard pile instead.",
        id: 'bs_promo_42_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        name: POKEMON_TOWER_PROMO.name,
        setNumber: 42,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        copyright: WOTC_1995_2000_COPYRIGHT,
        description: 'Using its amazing muscles, it throws powerful punches that can knock its victim clear over the horizon.',
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        evolutionBoxImageUrl: MACHOKE$7.images[0].value,
        evolvesFrom: MACHOKE$7.name,
        hitPoints: 90,
        id: 'bs_promo_43_en',
        illustrator: ILLUSTRATORS.KOMIYA,
        lengthFeet: 5,
        lengthInches: 3,
        moves: [],
        name: MACHAMP$5.name,
        pokemonImagePositionX: 60,
        pokemonImagePositionY: 52,
        pokemonImageSize: 31,
        pokemonLevel: 54,
        pokemonNumber: MACHAMP$5.number,
        pokemonType: MACHAMP$5.pokemonType,
        setNumber: 43,
        stage: MACHAMP$5.stage,
        weight: 287,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        copyright: WOTC_1995_2000_COPYRIGHT,
        description: 'Its body always burns with an orange glow that enables it to hide perfectly among flames.',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: ENERGY_TYPES.WATER,
        hitPoints: 60,
        id: 'bs_promo_44_en',
        illustrator: ILLUSTRATORS.NISHIDA,
        lengthFeet: 4,
        lengthInches: 3,
        moves: [],
        name: MAGMAR$4.name,
        pokemonImagePositionX: 60,
        pokemonImagePositionY: 52,
        pokemonImageSize: 31,
        pokemonLevel: 27,
        pokemonNumber: MAGMAR$4.number,
        pokemonType: MAGMAR$4.pokemonType,
        setNumber: 44,
        weight: 98,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        copyright: WOTC_1995_2000_COPYRIGHT,
        description: 'With ninja-like agility and speed, it can create the illusion that there is more than one.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        hitPoints: 60,
        id: 'bs_promo_45_en',
        illustrator: ILLUSTRATORS.HIRONOBU,
        lengthFeet: 4,
        lengthInches: 11,
        moves: [],
        name: SCYTHER$4.name,
        pokemonImagePositionX: 60,
        pokemonImagePositionY: 52,
        pokemonImageSize: 31,
        pokemonLevel: 23,
        pokemonNumber: SCYTHER$4.number,
        pokemonType: SCYTHER$4.pokemonType,
        setNumber: 45,
        weight: 123,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        copyright: WOTC_1995_2000_COPYRIGHT,
        description: 'Normally found near power plants, it can wander away and cause major blackouts in cities.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 60,
        id: 'bs_promo_46_en',
        illustrator: ILLUSTRATORS.TANAKA,
        lengthFeet: 3,
        lengthInches: 7,
        moves: [],
        name: ELECTABUZZ$2.name,
        pokemonImagePositionX: 60,
        pokemonImagePositionY: 52,
        pokemonImageSize: 31,
        pokemonLevel: 22,
        pokemonNumber: ELECTABUZZ$2.number,
        pokemonType: ELECTABUZZ$2.pokemonType,
        setNumber: 46,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        copyright: WOTC_1995_2000_COPYRIGHT,
        description: 'So rare that it is still said to be a mirage by many experts. Only a few people have seen it worldwide.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 40,
        id: 'bs_promo_47_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 1,
        lengthInches: 4,
        moves: [],
        name: MEW$2.name,
        pokemonImagePositionX: 60,
        pokemonImagePositionY: 52,
        pokemonImageSize: 31,
        pokemonLevel: 8,
        pokemonNumber: MEW$2.number,
        pokemonType: MEW$2.pokemonType,
        setNumber: 47,
        weight: 9,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        copyright: WOTC_E_2002_COPYRIGHT,
        description: 'A legendary bird Pokémon that is said to appear to doomed people who are lost in icy mountains.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.WATER,
        hitPoints: 80,
        id: 'bs_promo_48_en',
        illustrator: ILLUSTRATORS.NISHIDA,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [],
        name: ARTICUNO$3.name,
        pokemonImagePositionX: 60,
        pokemonImagePositionY: 52,
        pokemonImageSize: 31,
        pokemonLevel: 34,
        pokemonNumber: ARTICUNO$3.number,
        pokemonType: ARTICUNO$3.pokemonType,
        setNumber: 48,
        weight: 122,
    },
    {
        backgroundImageUrl: 'https://c.tenor.com/6rqQ2_esOXoAAAAM/letter-z.gif',
        cardTemplate: CARD_TEMPLATES[3],
        copyright: WOTC_E_2002_COPYRIGHT,
        description: 'Very lazy, just eats and sleeps. As its rotund bulk builds, it becomes steadily more slothful.',
        energyResistance: ENERGY_TYPES.PSYCHIC,
        energyRetreatCost: 4,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hasStatsBarShadow: true,
        hitPoints: 90,
        id: 'bs_promo_49_en',
        illustrator: ILLUSTRATORS.TURVEY,
        lengthFeet: 6,
        lengthInches: 11,
        moves: [MOVES.GUARD, MOVES.ROLL_OVER],
        name: SNORLAX$1.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 71,
        pokemonImageSize: 62,
        pokemonImageUrl: SNORLAX$1.images[2].value,
        pokemonLevel: 35,
        pokemonNumber: SNORLAX$1.number,
        pokemonType: SNORLAX$1.pokemonType,
        setNumber: 49,
        weight: 1014,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        copyright: WOTC_E_2002_COPYRIGHT,
        description: 'Revered as the guardian of the forest, Celebi appears wherever beautiful forests exist.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        eReaderId: 'Z - 04 - a',
        hitPoints: 50,
        id: 'bs_promo_50_en',
        illustrator: ILLUSTRATORS.KUSAJIMA,
        lengthFeet: 2,
        lengthInches: 0,
        moves: [],
        name: CELEBI$4.name,
        pokemonImagePositionX: 60,
        pokemonImagePositionY: 52,
        pokemonImageSize: 31,
        pokemonLevel: 34,
        pokemonNumber: CELEBI$4.number,
        pokemonType: CELEBI$4.pokemonType,
        setNumber: 50,
        weight: 11,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        copyright: WOTC_E_2002_COPYRIGHT,
        description: 'It just loves to gallop. The faster it goes, the longer the swaying flames of its mane will become.',
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: ENERGY_TYPES.WATER,
        eReaderId: 'Z - 07',
        evolvesFrom: PONYTA$3.name,
        evolutionBoxImageUrl: PONYTA$3.images[0].value,
        hitPoints: 60,
        id: 'bs_promo_51_en',
        illustrator: ILLUSTRATORS.ARITA,
        moves: [],
        name: RAPIDASH$3.name,
        pokemonImagePositionX: 60,
        pokemonImagePositionY: 52,
        pokemonImageSize: 31,
        pokemonNumber: RAPIDASH$3.number,
        pokemonType: RAPIDASH$3.pokemonType,
        setNumber: 51,
        stage: RAPIDASH$3.stage,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        copyright: WOTC_E_2002_COPYRIGHT,
        description: 'It will reveal itself before a pure-hearted trainer by shining its bright rainbow-colored wings.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: ENERGY_TYPES.WATER,
        eReaderId: 'Z - 06',
        hitPoints: 80,
        id: 'bs_promo_52_en',
        illustrator: ILLUSTRATORS.ARITA,
        moves: [],
        name: HO_OH$3.name,
        pokemonImagePositionX: 60,
        pokemonImagePositionY: 52,
        pokemonImageSize: 31,
        pokemonNumber: HO_OH$3.number,
        pokemonType: HO_OH$3.pokemonType,
        setNumber: 52,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        copyright: WOTC_E_2002_COPYRIGHT,
        description: 'This divine Pokémon blows around the world, always in search of a pure reservoir.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        eReaderId: 'Z - 14',
        hitPoints: 80,
        id: 'bs_promo_53_en',
        illustrator: ILLUSTRATORS.NISHIDA,
        moves: [],
        name: SUICUNE$3.name,
        pokemonImagePositionX: 60,
        pokemonImagePositionY: 52,
        pokemonImageSize: 31,
        pokemonNumber: SUICUNE$3.number,
        pokemonType: SUICUNE$3.pokemonType,
        setNumber: 53,
    },
];

const setId$a = CARD_SETS.BLACK_STAR_PROMO.value;
const setName$a = CARD_SETS.BLACK_STAR_PROMO.label;
const BLACK_STAR_PROMO_SET = {
    copyright: WOTC_EARLY_ERA_COPYRIGHT,
    description: SET_DESCRIPTIONS.BLACK_STAR_PROMO,
    holoSheetType: CARD_HOLO_SHEETS.COSMOS_2,
    id: setId$a,
    imageUrl: 'https://cdn.shopify.com/s/files/1/0840/1659/5249/collections/bs-promo.jpg',
    name: setName$a,
    releaseDate: RELEASE_DATES.BLACK_STAR_PROMO,
    setSymbol: setId$a,
    cards: [...BLACK_STAR_PROMO_CARDS],
};

const { ALAKAZAM: ALAKAZAM$2, ARBOK: ARBOK$3, BLASTOISE: BLASTOISE$3, BUTTERFREE: BUTTERFREE$3, CHARIZARD: CHARIZARD$5, CHARMELEON: CHARMELEON$4, CLEFABLE: CLEFABLE$1, CLEFAIRY: CLEFAIRY$2, CLOYSTER: CLOYSTER$2, DIGLETT: DIGLETT$4, DRAGONAIR: DRAGONAIR$6, DRAGONITE: DRAGONITE$4, DUGTRIO: DUGTRIO$2, EKANS: EKANS$4, FEAROW: FEAROW$1, GENGAR: GENGAR$4, GLOOM: GLOOM$3, GOLEM: GOLEM$2, GRAVELER: GRAVELER$4, HAUNTER: HAUNTER$6, IVYSAUR: IVYSAUR$2, KADABRA: KADABRA$5, KINGLER: KINGLER$1, KOFFING: KOFFING$4, KRABBY: KRABBY$2, MACHAMP: MACHAMP$4, MACHOKE: MACHOKE$6, MAGMAR: MAGMAR$3, METAPOD: METAPOD$2, MEW: MEW$1, MEWTWO: MEWTWO$1, NINETALES: NINETALES$2, PIDGEOT: PIDGEOT$2, PIDGEOTTO: PIDGEOTTO$1, PIKACHU: PIKACHU$6, POLIWHIRL: POLIWHIRL$5, POLIWRATH: POLIWRATH$3, PONYTA: PONYTA$2, RAICHU: RAICHU$6, RAPIDASH: RAPIDASH$2, SHELLDER: SHELLDER$2, SPEAROW: SPEAROW$1, VENUSAUR: VENUSAUR$1, VILEPLUME: VILEPLUME$2, VULPIX: VULPIX$2, WARTORTLE: WARTORTLE$4, WEEZING: WEEZING$3, } = GEN_1_POKEMON;
const { AMPHAROS: AMPHAROS$3, BAYLEEF: BAYLEEF$1, CROCONAW: CROCONAW$3, FERALIGATR: FERALIGATR$2, FLAAFFY: FLAAFFY$5, MAGBY, MEGANIUM: MEGANIUM$1, PICHU, PUPITAR: PUPITAR$5, QUILAVA: QUILAVA$3, SKARMORY: SKARMORY$3, TYPHLOSION: TYPHLOSION$3, TYRANITAR: TYRANITAR$5, } = GEN_2_POKEMON;
const holoStrength$6 = 0.7;
const EXPEDITION_HOLOS = [
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        evolvesFrom: KADABRA$5.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$6,
        id: 'expedition_001_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: ALAKAZAM$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 1,
        stage: ALAKAZAM$2.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        evolvesFrom: FLAAFFY$5.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$6,
        id: 'expedition_002_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: AMPHAROS$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 2,
        stage: AMPHAROS$3.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: EKANS$4.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$6,
        id: 'expedition_003_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: ARBOK$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 3,
        stage: ARBOK$3.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: WARTORTLE$4.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$6,
        id: 'expedition_004_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: BLASTOISE$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 4,
        stage: BLASTOISE$3.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: METAPOD$2.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$6,
        id: 'expedition_005_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: BUTTERFREE$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 5,
        stage: BUTTERFREE$3.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        evolvesFrom: CHARMELEON$4.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$6,
        id: 'expedition_006_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: CHARIZARD$5.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 6,
        stage: CHARIZARD$5.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        evolvesFrom: CLEFAIRY$2.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$6,
        id: 'expedition_007_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: CLEFABLE$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 7,
        stage: CLEFABLE$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: SHELLDER$2.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$6,
        id: 'expedition_008_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: CLOYSTER$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 8,
        stage: CLOYSTER$2.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        evolvesFrom: DRAGONAIR$6.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$6,
        id: 'expedition_009_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: DRAGONITE$4.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 9,
        stage: DRAGONITE$4.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        evolvesFrom: DIGLETT$4.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$6,
        id: 'expedition_010_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: DUGTRIO$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 10,
        stage: DUGTRIO$2.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        evolvesFrom: SPEAROW$1.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$6,
        id: 'expedition_011_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: FEAROW$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 11,
        stage: FEAROW$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: CROCONAW$3.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$6,
        id: 'expedition_012_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: FERALIGATR$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 12,
        stage: FERALIGATR$2.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        evolvesFrom: HAUNTER$6.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$6,
        id: 'expedition_013_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: GENGAR$4.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 13,
        stage: GENGAR$4.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        evolvesFrom: GRAVELER$4.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$6,
        id: 'expedition_014_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: GOLEM$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 14,
        stage: GOLEM$2.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: KRABBY$2.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$6,
        id: 'expedition_015_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: KINGLER$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 15,
        stage: KINGLER$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        evolvesFrom: MACHOKE$6.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$6,
        id: 'expedition_016_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: MACHAMP$4.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 16,
        stage: MACHAMP$4.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.BABY,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        evolvesTo: MAGMAR$3.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$6,
        id: 'expedition_017_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: MAGBY.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 17,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: BAYLEEF$1.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$6,
        id: 'expedition_018_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: MEGANIUM$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 18,
        stage: MEGANIUM$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$6,
        id: 'expedition_019_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: MEW$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 19,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$6,
        id: 'expedition_020_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: MEWTWO$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 20,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        evolvesFrom: VULPIX$2.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$6,
        id: 'expedition_021_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: NINETALES$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 21,
        stage: NINETALES$2.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.BABY,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        evolvesTo: PIKACHU$6.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$6,
        id: 'expedition_022_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: PICHU.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 22,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        evolvesFrom: PIDGEOTTO$1.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$6,
        id: 'expedition_023_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: PIDGEOT$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 23,
        stage: PIDGEOT$2.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: POLIWHIRL$5.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$6,
        id: 'expedition_024_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: POLIWRATH$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 24,
        stage: POLIWRATH$3.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        evolvesFrom: PIKACHU$6.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$6,
        id: 'expedition_025_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: RAICHU$6.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 25,
        stage: RAICHU$6.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        evolvesFrom: PONYTA$2.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$6,
        id: 'expedition_026_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: RAPIDASH$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 26,
        stage: RAPIDASH$2.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.METAL,
        energyWeakness: null,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$6,
        id: 'expedition_027_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: SKARMORY$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 27,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        evolvesFrom: QUILAVA$3.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$6,
        id: 'expedition_028_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: TYPHLOSION$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 28,
        stage: TYPHLOSION$3.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.DARKNESS,
        energyWeakness: null,
        evolvesFrom: PUPITAR$5.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$6,
        id: 'expedition_029_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: TYRANITAR$5.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 29,
        stage: TYRANITAR$5.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: IVYSAUR$2.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$6,
        id: 'expedition_030_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: VENUSAUR$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 30,
        stage: VENUSAUR$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: GLOOM$3.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$6,
        id: 'expedition_031_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: VILEPLUME$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 31,
        stage: VILEPLUME$2.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: KOFFING$4.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$6,
        id: 'expedition_032_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: WEEZING$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 32,
        stage: WEEZING$3.stage,
        weight: null,
    },
];

const EXPEDITION_ENERGIES = [
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.ENERGY_E_SERIES,
        description: SPECIAL_ENERGIES.DARKNESS.descriptions.default,
        energyType: ENERGY_TYPES.DARKNESS,
        id: 'expedition_158_en',
        name: SPECIAL_ENERGIES.DARKNESS.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 158,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.ENERGY_E_SERIES,
        description: SPECIAL_ENERGIES.METAL.descriptions.expedition,
        id: 'expedition_159_en',
        name: SPECIAL_ENERGIES.METAL.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 159,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.ENERGY_E_SERIES,
        energyType: ENERGY_TYPES.FIGHTING,
        id: 'expedition_160_en',
        setNumber: 160,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.ENERGY_E_SERIES,
        energyType: ENERGY_TYPES.FIRE,
        id: 'expedition_161_en',
        setNumber: 161,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.ENERGY_E_SERIES,
        energyType: ENERGY_TYPES.GRASS,
        id: 'expedition_162_en',
        setNumber: 162,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.ENERGY_E_SERIES,
        energyType: ENERGY_TYPES.LIGHTNING,
        id: 'expedition_163_en',
        setNumber: 163,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.ENERGY_E_SERIES,
        energyType: ENERGY_TYPES.PSYCHIC,
        id: 'expedition_164_en',
        setNumber: 164,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.ENERGY_E_SERIES,
        energyType: ENERGY_TYPES.WATER,
        id: 'expedition_165_en',
        setNumber: 165,
    },
];

const { BILLS_MAINTENANCE, COPYCAT, DUAL_BALL, ENERGY_REMOVAL_2, ENERGY_RESTORE: ENERGY_RESTORE$1, ENERGY_SEARCH: ENERGY_SEARCH$1, FULL_HEAL: FULL_HEAL$2, MARYS_IMPULSE, MULTI_TECHNICAL_MACHINE_01, POKEMON_NURSE, POKEMON_REVERSAL: POKEMON_REVERSAL$1, POTION: POTION$2, POWER_CHARGE, PROFESSOR_ELMS_TRAINING_METHOD, PROFESSOR_OAKS_RESEARCH, STRENGTH_CHARM, SWITCH: SWITCH$1, } = E_SERIES_TRAINERS;
const { MASTER_BALL: MASTER_BALL$1, WARP_POINT: WARP_POINT$1 } = GYM_TRAINERS;
const { MOO_MOO_MILK: MOO_MOO_MILK$1, SUPER_SCOOP_UP: SUPER_SCOOP_UP$1 } = NEO_TRAINERS;
const EXPEDITION_TRAINERS = [
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'expedition_137_en',
        illustrator: null,
        name: BILLS_MAINTENANCE.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 137,
        subtitle: TRAINER_CARD_SUBTITLES.SUPPORTER,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'expedition_138_en',
        illustrator: null,
        name: COPYCAT.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 138,
        subtitle: TRAINER_CARD_SUBTITLES.SUPPORTER,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'expedition_139_en',
        illustrator: null,
        name: DUAL_BALL.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 139,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'expedition_140_en',
        illustrator: null,
        name: ENERGY_REMOVAL_2.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 140,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'expedition_141_en',
        illustrator: null,
        name: ENERGY_RESTORE$1.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 141,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'expedition_142_en',
        illustrator: null,
        name: MARYS_IMPULSE.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 142,
        subtitle: TRAINER_CARD_SUBTITLES.SUPPORTER,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'expedition_143_en',
        illustrator: null,
        name: MASTER_BALL$1.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 143,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'expedition_144_en',
        illustrator: null,
        name: MULTI_TECHNICAL_MACHINE_01.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 144,
        subtitle: TRAINER_CARD_SUBTITLES.TECHNICAL_MACHINE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'expedition_145_en',
        illustrator: null,
        name: POKEMON_NURSE.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 145,
        subtitle: TRAINER_CARD_SUBTITLES.SUPPORTER,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'expedition_146_en',
        illustrator: null,
        name: POKEMON_REVERSAL$1.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 146,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'expedition_147_en',
        illustrator: null,
        name: POWER_CHARGE.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 147,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'expedition_148_en',
        illustrator: null,
        name: PROFESSOR_ELMS_TRAINING_METHOD.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 148,
        subtitle: TRAINER_CARD_SUBTITLES.SUPPORTER,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'expedition_149_en',
        illustrator: null,
        name: PROFESSOR_OAKS_RESEARCH.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 149,
        subtitle: TRAINER_CARD_SUBTITLES.SUPPORTER,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'expedition_150_en',
        illustrator: null,
        name: STRENGTH_CHARM.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 150,
        subtitle: TRAINER_CARD_SUBTITLES.POKEMON_TOOL,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'expedition_151_en',
        illustrator: null,
        name: SUPER_SCOOP_UP$1.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 151,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'expedition_152_en',
        illustrator: null,
        name: WARP_POINT$1.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 152,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'expedition_153_en',
        illustrator: null,
        name: ENERGY_SEARCH$1.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 153,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'expedition_154_en',
        illustrator: null,
        name: FULL_HEAL$2.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 154,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'expedition_155_en',
        illustrator: null,
        name: MOO_MOO_MILK$1.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 155,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'expedition_156_en',
        illustrator: null,
        name: POTION$2.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 156,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'expedition_157_en',
        illustrator: null,
        name: SWITCH$1.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 157,
    },
];

const { ABRA: ABRA$2, BULBASAUR, CATERPIE: CATERPIE$1, CHANSEY: CHANSEY$2, CHARMANDER: CHARMANDER$1, CHARMELEON: CHARMELEON$3, CLEFAIRY: CLEFAIRY$1, CUBONE, DIGLETT: DIGLETT$3, DRAGONAIR: DRAGONAIR$5, DRATINI: DRATINI$2, EKANS: EKANS$3, ELECTABUZZ: ELECTABUZZ$1, GASTLY: GASTLY$4, GEODUDE: GEODUDE$2, GLOOM: GLOOM$2, GOLDEEN: GOLDEEN$1, GRAVELER: GRAVELER$3, HAUNTER: HAUNTER$5, HITMONLEE: HITMONLEE$3, IVYSAUR: IVYSAUR$1, JYNX: JYNX$2, KADABRA: KADABRA$4, KOFFING: KOFFING$3, KRABBY: KRABBY$1, MACHOKE: MACHOKE$5, MACHOP: MACHOP$3, MAGIKARP: MAGIKARP$5, MAGMAR: MAGMAR$2, MEOWTH: MEOWTH$2, METAPOD: METAPOD$1, ODDISH: ODDISH$1, PIDGEOTTO, PIDGEY, PIKACHU: PIKACHU$5, POLIWAG: POLIWAG$2, POLIWHIRL: POLIWHIRL$4, PONYTA: PONYTA$1, RATTATA: RATTATA$2, SHELLDER: SHELLDER$1, SPEAROW, SQUIRTLE: SQUIRTLE$1, TAUROS: TAUROS$1, VULPIX: VULPIX$1, WARTORTLE: WARTORTLE$3, } = GEN_1_POKEMON;
const { BAYLEEF, CHIKORITA, CORSOLA: CORSOLA$1, CROCONAW: CROCONAW$2, CYNDAQUIL: CYNDAQUIL$1, FLAAFFY: FLAAFFY$4, HOPPIP: HOPPIP$2, HOUNDOUR: HOUNDOUR$7, LARVITAR: LARVITAR$2, MAREEP: MAREEP$3, MARILL: MARILL$2, PUPITAR: PUPITAR$4, QUILAVA: QUILAVA$2, QWILFISH: QWILFISH$1, TOTODILE: TOTODILE$1, } = GEN_2_POKEMON;
const EXPEDITION_NON_HOLOS = [
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: CHIKORITA.name,
        evolutionBoxImageUrl: CHIKORITA.images[0].value,
        hitPoints: null,
        id: 'expedition_071_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: BAYLEEF.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 71,
        stage: BAYLEEF.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_072_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: CHANSEY$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 72,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        evolvesFrom: CHARMANDER$1.name,
        evolutionBoxImageUrl: CHARMANDER$1.images[0].value,
        hitPoints: null,
        id: 'expedition_073_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: CHARMELEON$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 73,
        stage: CHARMELEON$3.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: TOTODILE$1.name,
        evolutionBoxImageUrl: TOTODILE$1.images[0].value,
        hitPoints: null,
        id: 'expedition_074_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: CROCONAW$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 74,
        stage: CROCONAW$2.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        evolvesFrom: DRATINI$2.name,
        evolutionBoxImageUrl: DRATINI$2.images[0].value,
        hitPoints: null,
        id: 'expedition_075_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: DRAGONAIR$5.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 75,
        stage: DRAGONAIR$5.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_076_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: ELECTABUZZ$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 76,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        evolvesFrom: MAREEP$3.name,
        evolutionBoxImageUrl: MAREEP$3.images[0].value,
        hitPoints: null,
        id: 'expedition_077_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: FLAAFFY$4.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 77,
        stage: FLAAFFY$4.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: ODDISH$1.name,
        evolutionBoxImageUrl: ODDISH$1.images[0].value,
        hitPoints: null,
        id: 'expedition_078_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: GLOOM$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 78,
        stage: GLOOM$2.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        evolvesFrom: GEODUDE$2.name,
        evolutionBoxImageUrl: GEODUDE$2.images[0].value,
        hitPoints: null,
        id: 'expedition_079_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: GRAVELER$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 79,
        stage: GRAVELER$3.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        evolvesFrom: GASTLY$4.name,
        evolutionBoxImageUrl: GASTLY$4.images[0].value,
        hitPoints: null,
        id: 'expedition_080_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: HAUNTER$5.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 80,
        stage: HAUNTER$5.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_081_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: HITMONLEE$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 81,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: BULBASAUR.name,
        evolutionBoxImageUrl: BULBASAUR.images[0].value,
        hitPoints: null,
        id: 'expedition_082_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: IVYSAUR$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 82,
        stage: IVYSAUR$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_083_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: JYNX$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 83,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        evolvesFrom: ABRA$2.name,
        evolutionBoxImageUrl: ABRA$2.images[0].value,
        hitPoints: null,
        id: 'expedition_084_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: KADABRA$4.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 84,
        stage: KADABRA$4.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        evolvesFrom: MACHOP$3.name,
        evolutionBoxImageUrl: MACHOP$3.images[0].value,
        hitPoints: null,
        id: 'expedition_085_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: MACHOKE$5.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 85,
        stage: MACHOKE$5.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_086_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: MAGMAR$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 86,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: CATERPIE$1.name,
        evolutionBoxImageUrl: CATERPIE$1.images[0].value,
        hitPoints: null,
        id: 'expedition_087_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: METAPOD$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 87,
        stage: METAPOD$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        evolvesFrom: PIDGEY.name,
        evolutionBoxImageUrl: PIDGEY.images[0].value,
        hitPoints: null,
        id: 'expedition_088_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: PIDGEOTTO.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 88,
        stage: PIDGEOTTO.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: POLIWAG$2.name,
        evolutionBoxImageUrl: POLIWAG$2.images[0].value,
        hitPoints: null,
        id: 'expedition_089_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: POLIWHIRL$4.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 89,
        stage: POLIWHIRL$4.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        evolvesFrom: LARVITAR$2.name,
        evolutionBoxImageUrl: LARVITAR$2.images[0].value,
        hitPoints: null,
        id: 'expedition_090_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: PUPITAR$4.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 90,
        stage: PUPITAR$4.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        evolvesFrom: CYNDAQUIL$1.name,
        evolutionBoxImageUrl: CYNDAQUIL$1.images[0].value,
        hitPoints: null,
        id: 'expedition_091_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: QUILAVA$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 91,
        stage: QUILAVA$2.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: SQUIRTLE$1.name,
        evolutionBoxImageUrl: SQUIRTLE$1.images[0].value,
        hitPoints: null,
        id: 'expedition_092_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: WARTORTLE$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 92,
        stage: WARTORTLE$3.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_093_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: ABRA$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 93,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_094_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: BULBASAUR.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 94,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_095_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: BULBASAUR.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 95,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_096_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: CATERPIE$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 96,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_097_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: CHARMANDER$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 97,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_098_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: CHARMANDER$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 98,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_099_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: CHIKORITA.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 99,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_100_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: CHIKORITA.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 100,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_101_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: CLEFAIRY$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 101,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_102_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: CORSOLA$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 102,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_103_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: CUBONE.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 103,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_104_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: CYNDAQUIL$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 104,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_105_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: CYNDAQUIL$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 105,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_106_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: DIGLETT$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 106,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_107_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: DRATINI$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 107,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_108_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: EKANS$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 108,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_109_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: GASTLY$4.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 109,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_110_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: GEODUDE$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 110,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_111_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: GOLDEEN$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 111,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_112_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: HOPPIP$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 112,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.DARKNESS,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_113_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: HOUNDOUR$7.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 113,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_114_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: KOFFING$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 114,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_115_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: KRABBY$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 115,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_116_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: LARVITAR$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 116,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_117_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: MACHOP$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 117,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_118_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: MAGIKARP$5.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 118,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_119_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: MAREEP$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 119,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_120_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: MARILL$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 120,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_121_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: MEOWTH$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 121,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_122_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: ODDISH$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 122,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_123_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: PIDGEY.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 123,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_124_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: PIKACHU$5.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 124,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_125_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: POLIWAG$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 125,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_126_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: PONYTA$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 126,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_127_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: QWILFISH$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 127,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_128_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: RATTATA$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 128,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_129_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: SHELLDER$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 129,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_130_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: SPEAROW.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 130,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_131_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: SQUIRTLE$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 131,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_132_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: SQUIRTLE$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 132,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_133_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: TAUROS$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 133,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_134_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: TOTODILE$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 134,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_135_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: TOTODILE$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 135,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        hitPoints: null,
        id: 'expedition_136_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: VULPIX$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 136,
        weight: null,
    },
    ...EXPEDITION_TRAINERS,
    ...EXPEDITION_ENERGIES,
];

const { BLASTOISE: BLASTOISE$2, CHARIZARD: CHARIZARD$4, VENUSAUR } = GEN_1_POKEMON;
const { FERALIGATR: FERALIGATR$1, MEGANIUM, TYPHLOSION: TYPHLOSION$2 } = GEN_2_POKEMON;
const EXPEDITION_CARDS = [
    {
        ...EXPEDITION_HOLOS[0],
        holo: false,
        id: 'expedition_033_en',
        setNumber: 33,
    },
    {
        ...EXPEDITION_HOLOS[0],
        holo: 'reverse',
        id: 'expedition_033_en_rh',
        setNumber: 33,
    },
    {
        ...EXPEDITION_HOLOS[1],
        holo: false,
        id: 'expedition_034_en',
        setNumber: 34,
    },
    {
        ...EXPEDITION_HOLOS[1],
        holo: 'reverse',
        id: 'expedition_034_en_rh',
        setNumber: 34,
    },
    {
        ...EXPEDITION_HOLOS[2],
        holo: false,
        id: 'expedition_035_en',
        setNumber: 35,
    },
    {
        ...EXPEDITION_HOLOS[2],
        holo: 'reverse',
        id: 'expedition_035_en_rh',
        setNumber: 35,
    },
    {
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        energyType: ENERGY_TYPES.WATER,
        id: 'expedition_036_en',
        name: BLASTOISE$2.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 36,
        stage: BLASTOISE$2.stage,
    },
    {
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        energyType: ENERGY_TYPES.WATER,
        holo: 'reverse',
        id: 'expedition_036_en_rh',
        name: BLASTOISE$2.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 36,
        stage: BLASTOISE$2.stage,
    },
    {
        ...EXPEDITION_HOLOS[3],
        holo: false,
        id: 'expedition_037_en',
        setNumber: 37,
    },
    {
        ...EXPEDITION_HOLOS[3],
        holo: 'reverse',
        id: 'expedition_037_en_rh',
        setNumber: 37,
    },
    {
        ...EXPEDITION_HOLOS[4],
        holo: false,
        id: 'expedition_038_en',
        setNumber: 38,
    },
    {
        ...EXPEDITION_HOLOS[4],
        holo: 'reverse',
        id: 'expedition_038_en_rh',
        setNumber: 38,
    },
    {
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        energyType: ENERGY_TYPES.FIRE,
        id: 'expedition_039_en',
        name: CHARIZARD$4.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 39,
        stage: CHARIZARD$4.stage,
    },
    {
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        energyType: ENERGY_TYPES.FIRE,
        holo: 'reverse',
        id: 'expedition_039_en_rh',
        name: CHARIZARD$4.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 39,
        stage: CHARIZARD$4.stage,
    },
    {
        ...EXPEDITION_HOLOS[5],
        holo: false,
        id: 'expedition_040_en',
        setNumber: 40,
    },
    {
        ...EXPEDITION_HOLOS[5],
        holo: 'reverse',
        id: 'expedition_040_en_rh',
        setNumber: 40,
    },
    {
        ...EXPEDITION_HOLOS[6],
        holo: false,
        id: 'expedition_041_en',
        setNumber: 41,
    },
    {
        ...EXPEDITION_HOLOS[6],
        holo: 'reverse',
        id: 'expedition_041_en_rh',
        setNumber: 41,
    },
    {
        ...EXPEDITION_HOLOS[7],
        holo: false,
        id: 'expedition_042_en',
        setNumber: 42,
    },
    {
        ...EXPEDITION_HOLOS[7],
        holo: 'reverse',
        id: 'expedition_042_en_rh',
        setNumber: 42,
    },
    {
        ...EXPEDITION_HOLOS[8],
        holo: false,
        id: 'expedition_043_en',
        setNumber: 43,
    },
    {
        ...EXPEDITION_HOLOS[8],
        holo: 'reverse',
        id: 'expedition_043_en_rh',
        setNumber: 43,
    },
    {
        ...EXPEDITION_HOLOS[9],
        holo: false,
        id: 'expedition_044_en',
        setNumber: 44,
    },
    {
        ...EXPEDITION_HOLOS[9],
        holo: 'reverse',
        id: 'expedition_044_en_rh',
        setNumber: 44,
    },
    {
        ...EXPEDITION_HOLOS[10],
        holo: false,
        id: 'expedition_045_en',
        setNumber: 45,
    },
    {
        ...EXPEDITION_HOLOS[10],
        holo: 'reverse',
        id: 'expedition_045_en_rh',
        setNumber: 45,
    },
    {
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        energyType: ENERGY_TYPES.WATER,
        id: 'expedition_046_en',
        name: FERALIGATR$1.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 46,
        stage: FERALIGATR$1.stage,
    },
    {
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        energyType: ENERGY_TYPES.WATER,
        holo: 'reverse',
        id: 'expedition_046_en_rh',
        name: FERALIGATR$1.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 46,
        stage: FERALIGATR$1.stage,
    },
    {
        ...EXPEDITION_HOLOS[11],
        holo: false,
        id: 'expedition_047_en',
        setNumber: 47,
    },
    {
        ...EXPEDITION_HOLOS[11],
        holo: 'reverse',
        id: 'expedition_047_en_rh',
        setNumber: 47,
    },
    {
        ...EXPEDITION_HOLOS[12],
        holo: false,
        id: 'expedition_048_en',
        setNumber: 48,
    },
    {
        ...EXPEDITION_HOLOS[12],
        holo: 'reverse',
        id: 'expedition_048_en_rh',
        setNumber: 48,
    },
    {
        ...EXPEDITION_HOLOS[13],
        holo: false,
        id: 'expedition_049_en',
        setNumber: 49,
    },
    {
        ...EXPEDITION_HOLOS[13],
        holo: 'reverse',
        id: 'expedition_049_en_rh',
        setNumber: 49,
    },
    {
        ...EXPEDITION_HOLOS[14],
        holo: false,
        id: 'expedition_050_en',
        setNumber: 50,
    },
    {
        ...EXPEDITION_HOLOS[14],
        holo: 'reverse',
        id: 'expedition_050_en_rh',
        setNumber: 50,
    },
    {
        ...EXPEDITION_HOLOS[15],
        holo: false,
        id: 'expedition_051_en',
        setNumber: 51,
    },
    {
        ...EXPEDITION_HOLOS[15],
        holo: 'reverse',
        id: 'expedition_051_en_rh',
        setNumber: 51,
    },
    {
        ...EXPEDITION_HOLOS[16],
        holo: false,
        id: 'expedition_052_en',
        setNumber: 52,
    },
    {
        ...EXPEDITION_HOLOS[16],
        holo: 'reverse',
        id: 'expedition_052_en_rh',
        setNumber: 52,
    },
    {
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        energyType: ENERGY_TYPES.GRASS,
        id: 'expedition_053_en',
        name: MEGANIUM.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 53,
        stage: MEGANIUM.stage,
    },
    {
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        energyType: ENERGY_TYPES.GRASS,
        holo: 'reverse',
        id: 'expedition_053_en_rh',
        name: MEGANIUM.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 53,
        stage: MEGANIUM.stage,
    },
    {
        ...EXPEDITION_HOLOS[17],
        holo: false,
        id: 'expedition_054_en',
        setNumber: 54,
    },
    {
        ...EXPEDITION_HOLOS[17],
        holo: 'reverse',
        id: 'expedition_054_en_rh',
        setNumber: 54,
    },
    {
        ...EXPEDITION_HOLOS[18],
        holo: false,
        id: 'expedition_055_en',
        setNumber: 55,
    },
    {
        ...EXPEDITION_HOLOS[18],
        holo: 'reverse',
        id: 'expedition_055_en_rh',
        setNumber: 55,
    },
    {
        ...EXPEDITION_HOLOS[19],
        holo: false,
        id: 'expedition_056_en',
        setNumber: 56,
    },
    {
        ...EXPEDITION_HOLOS[19],
        holo: 'reverse',
        id: 'expedition_056_en_rh',
        setNumber: 56,
    },
    {
        ...EXPEDITION_HOLOS[20],
        holo: false,
        id: 'expedition_057_en',
        setNumber: 57,
    },
    {
        ...EXPEDITION_HOLOS[20],
        holo: 'reverse',
        id: 'expedition_057_en_rh',
        setNumber: 57,
    },
    {
        ...EXPEDITION_HOLOS[21],
        holo: false,
        id: 'expedition_058_en',
        setNumber: 58,
    },
    {
        ...EXPEDITION_HOLOS[21],
        holo: 'reverse',
        id: 'expedition_058_en_rh',
        setNumber: 58,
    },
    {
        ...EXPEDITION_HOLOS[22],
        holo: false,
        id: 'expedition_059_en',
        setNumber: 59,
    },
    {
        ...EXPEDITION_HOLOS[22],
        holo: 'reverse',
        id: 'expedition_059_en_rh',
        setNumber: 59,
    },
    {
        ...EXPEDITION_HOLOS[23],
        holo: false,
        id: 'expedition_060_en',
        setNumber: 60,
    },
    {
        ...EXPEDITION_HOLOS[23],
        holo: 'reverse',
        id: 'expedition_060_en_rh',
        setNumber: 60,
    },
    {
        ...EXPEDITION_HOLOS[24],
        holo: false,
        id: 'expedition_061_en',
        setNumber: 61,
    },
    {
        ...EXPEDITION_HOLOS[24],
        holo: 'reverse',
        id: 'expedition_061_en_rh',
        setNumber: 61,
    },
    {
        ...EXPEDITION_HOLOS[25],
        holo: false,
        id: 'expedition_062_en',
        setNumber: 62,
    },
    {
        ...EXPEDITION_HOLOS[25],
        holo: 'reverse',
        id: 'expedition_062_en_rh',
        setNumber: 62,
    },
    {
        ...EXPEDITION_HOLOS[26],
        holo: false,
        id: 'expedition_063_en',
        setNumber: 63,
    },
    {
        ...EXPEDITION_HOLOS[26],
        holo: 'reverse',
        id: 'expedition_063_en_rh',
        setNumber: 63,
    },
    {
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        energyType: ENERGY_TYPES.FIRE,
        id: 'expedition_064_en',
        name: TYPHLOSION$2.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 64,
        stage: TYPHLOSION$2.stage,
    },
    {
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        energyType: ENERGY_TYPES.FIRE,
        holo: 'reverse',
        id: 'expedition_064_en_rh',
        name: TYPHLOSION$2.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 64,
        stage: TYPHLOSION$2.stage,
    },
    {
        ...EXPEDITION_HOLOS[27],
        holo: false,
        id: 'expedition_065_en',
        setNumber: 65,
    },
    {
        ...EXPEDITION_HOLOS[27],
        holo: 'reverse',
        id: 'expedition_065_en_rh',
        setNumber: 65,
    },
    {
        ...EXPEDITION_HOLOS[28],
        holo: false,
        id: 'expedition_066_en',
        setNumber: 66,
    },
    {
        ...EXPEDITION_HOLOS[28],
        holo: 'reverse',
        id: 'expedition_066_en_rh',
        setNumber: 66,
    },
    {
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        energyType: ENERGY_TYPES.GRASS,
        id: 'expedition_067_en',
        name: VENUSAUR.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 67,
        stage: VENUSAUR.stage,
    },
    {
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        energyType: ENERGY_TYPES.GRASS,
        holo: 'reverse',
        id: 'expedition_067_en_rh',
        name: VENUSAUR.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 67,
        stage: VENUSAUR.stage,
    },
    {
        ...EXPEDITION_HOLOS[29],
        holo: false,
        id: 'expedition_068_en',
        setNumber: 68,
    },
    {
        ...EXPEDITION_HOLOS[29],
        holo: 'reverse',
        id: 'expedition_068_en_rh',
        setNumber: 68,
    },
    {
        ...EXPEDITION_HOLOS[30],
        holo: false,
        id: 'expedition_069_en',
        setNumber: 69,
    },
    {
        ...EXPEDITION_HOLOS[30],
        holo: 'reverse',
        id: 'expedition_069_en_rh',
        setNumber: 69,
    },
    {
        ...EXPEDITION_HOLOS[31],
        holo: false,
        id: 'expedition_070_en',
        setNumber: 70,
    },
    {
        ...EXPEDITION_HOLOS[31],
        holo: 'reverse',
        id: 'expedition_070_en_rh',
        setNumber: 70,
    },
    {
        ...EXPEDITION_NON_HOLOS[0],
    },
    {
        ...EXPEDITION_NON_HOLOS[0],
        holo: 'reverse',
        id: 'expedition_071_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[1],
    },
    {
        ...EXPEDITION_NON_HOLOS[1],
        holo: 'reverse',
        id: 'expedition_072_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[2],
    },
    {
        ...EXPEDITION_NON_HOLOS[2],
        holo: 'reverse',
        id: 'expedition_073_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[3],
    },
    {
        ...EXPEDITION_NON_HOLOS[3],
        holo: 'reverse',
        id: 'expedition_074_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[4],
    },
    {
        ...EXPEDITION_NON_HOLOS[4],
        holo: 'reverse',
        id: 'expedition_075_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[5],
    },
    {
        ...EXPEDITION_NON_HOLOS[5],
        holo: 'reverse',
        id: 'expedition_076_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[6],
    },
    {
        ...EXPEDITION_NON_HOLOS[6],
        holo: 'reverse',
        id: 'expedition_077_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[7],
    },
    {
        ...EXPEDITION_NON_HOLOS[7],
        holo: 'reverse',
        id: 'expedition_078_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[8],
    },
    {
        ...EXPEDITION_NON_HOLOS[8],
        holo: 'reverse',
        id: 'expedition_079_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[9],
    },
    {
        ...EXPEDITION_NON_HOLOS[9],
        holo: 'reverse',
        id: 'expedition_080_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[10],
    },
    {
        ...EXPEDITION_NON_HOLOS[10],
        holo: 'reverse',
        id: 'expedition_081en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[11],
    },
    {
        ...EXPEDITION_NON_HOLOS[11],
        holo: 'reverse',
        id: 'expedition_082_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[12],
    },
    {
        ...EXPEDITION_NON_HOLOS[12],
        holo: 'reverse',
        id: 'expedition_083_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[13],
    },
    {
        ...EXPEDITION_NON_HOLOS[13],
        holo: 'reverse',
        id: 'expedition_084_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[14],
    },
    {
        ...EXPEDITION_NON_HOLOS[14],
        holo: 'reverse',
        id: 'expedition_085_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[15],
    },
    {
        ...EXPEDITION_NON_HOLOS[15],
        holo: 'reverse',
        id: 'expedition_086_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[16],
    },
    {
        ...EXPEDITION_NON_HOLOS[16],
        holo: 'reverse',
        id: 'expedition_087_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[17],
    },
    {
        ...EXPEDITION_NON_HOLOS[17],
        holo: 'reverse',
        id: 'expedition_088_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[18],
    },
    {
        ...EXPEDITION_NON_HOLOS[18],
        holo: 'reverse',
        id: 'expedition_089_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[19],
    },
    {
        ...EXPEDITION_NON_HOLOS[19],
        holo: 'reverse',
        id: 'expedition_090_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[20],
    },
    {
        ...EXPEDITION_NON_HOLOS[20],
        holo: 'reverse',
        id: 'expedition_091_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[21],
    },
    {
        ...EXPEDITION_NON_HOLOS[21],
        holo: 'reverse',
        id: 'expedition_092_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[22],
    },
    {
        ...EXPEDITION_NON_HOLOS[22],
        holo: 'reverse',
        id: 'expedition_093_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[23],
    },
    {
        ...EXPEDITION_NON_HOLOS[23],
        holo: 'reverse',
        id: 'expedition_094_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[24],
    },
    {
        ...EXPEDITION_NON_HOLOS[24],
        holo: 'reverse',
        id: 'expedition_095_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[25],
    },
    {
        ...EXPEDITION_NON_HOLOS[25],
        holo: 'reverse',
        id: 'expedition_096_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[26],
    },
    {
        ...EXPEDITION_NON_HOLOS[26],
        holo: 'reverse',
        id: 'expedition_097_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[27],
    },
    {
        ...EXPEDITION_NON_HOLOS[27],
        holo: 'reverse',
        id: 'expedition_098_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[28],
    },
    {
        ...EXPEDITION_NON_HOLOS[28],
        holo: 'reverse',
        id: 'expedition_099_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[29],
    },
    {
        ...EXPEDITION_NON_HOLOS[29],
        holo: 'reverse',
        id: 'expedition_100_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[30],
    },
    {
        ...EXPEDITION_NON_HOLOS[30],
        holo: 'reverse',
        id: 'expedition_101_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[31],
    },
    {
        ...EXPEDITION_NON_HOLOS[31],
        holo: 'reverse',
        id: 'expedition_102_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[32],
    },
    {
        ...EXPEDITION_NON_HOLOS[32],
        holo: 'reverse',
        id: 'expedition_103_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[33],
    },
    {
        ...EXPEDITION_NON_HOLOS[33],
        holo: 'reverse',
        id: 'expedition_104_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[34],
    },
    {
        ...EXPEDITION_NON_HOLOS[34],
        holo: 'reverse',
        id: 'expedition_105_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[35],
    },
    {
        ...EXPEDITION_NON_HOLOS[35],
        holo: 'reverse',
        id: 'expedition_106_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[36],
    },
    {
        ...EXPEDITION_NON_HOLOS[36],
        holo: 'reverse',
        id: 'expedition_107_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[37],
    },
    {
        ...EXPEDITION_NON_HOLOS[37],
        holo: 'reverse',
        id: 'expedition_108_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[38],
    },
    {
        ...EXPEDITION_NON_HOLOS[38],
        holo: 'reverse',
        id: 'expedition_109_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[39],
    },
    {
        ...EXPEDITION_NON_HOLOS[39],
        holo: 'reverse',
        id: 'expedition_110_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[40],
    },
    {
        ...EXPEDITION_NON_HOLOS[40],
        holo: 'reverse',
        id: 'expedition_111_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[41],
    },
    {
        ...EXPEDITION_NON_HOLOS[41],
        holo: 'reverse',
        id: 'expedition_112_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[42],
    },
    {
        ...EXPEDITION_NON_HOLOS[42],
        holo: 'reverse',
        id: 'expedition_113_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[43],
    },
    {
        ...EXPEDITION_NON_HOLOS[43],
        holo: 'reverse',
        id: 'expedition_114_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[44],
    },
    {
        ...EXPEDITION_NON_HOLOS[44],
        holo: 'reverse',
        id: 'expedition_115_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[45],
    },
    {
        ...EXPEDITION_NON_HOLOS[45],
        holo: 'reverse',
        id: 'expedition_116_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[46],
    },
    {
        ...EXPEDITION_NON_HOLOS[46],
        holo: 'reverse',
        id: 'expedition_117_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[47],
    },
    {
        ...EXPEDITION_NON_HOLOS[47],
        holo: 'reverse',
        id: 'expedition_118_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[48],
    },
    {
        ...EXPEDITION_NON_HOLOS[48],
        holo: 'reverse',
        id: 'expedition_119_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[49],
    },
    {
        ...EXPEDITION_NON_HOLOS[49],
        holo: 'reverse',
        id: 'expedition_120_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[50],
    },
    {
        ...EXPEDITION_NON_HOLOS[50],
        holo: 'reverse',
        id: 'expedition_121_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[51],
    },
    {
        ...EXPEDITION_NON_HOLOS[51],
        holo: 'reverse',
        id: 'expedition_122_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[52],
    },
    {
        ...EXPEDITION_NON_HOLOS[52],
        holo: 'reverse',
        id: 'expedition_123_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[53],
    },
    {
        ...EXPEDITION_NON_HOLOS[53],
        holo: 'reverse',
        id: 'expedition_124_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[54],
    },
    {
        ...EXPEDITION_NON_HOLOS[54],
        holo: 'reverse',
        id: 'expedition_125_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[55],
    },
    {
        ...EXPEDITION_NON_HOLOS[55],
        holo: 'reverse',
        id: 'expedition_126_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[56],
    },
    {
        ...EXPEDITION_NON_HOLOS[56],
        holo: 'reverse',
        id: 'expedition_127_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[57],
    },
    {
        ...EXPEDITION_NON_HOLOS[57],
        holo: 'reverse',
        id: 'expedition_128_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[58],
    },
    {
        ...EXPEDITION_NON_HOLOS[58],
        holo: 'reverse',
        id: 'expedition_129_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[59],
    },
    {
        ...EXPEDITION_NON_HOLOS[59],
        holo: 'reverse',
        id: 'expedition_130_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[60],
    },
    {
        ...EXPEDITION_NON_HOLOS[60],
        holo: 'reverse',
        id: 'expedition_131_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[61],
    },
    {
        ...EXPEDITION_NON_HOLOS[61],
        holo: 'reverse',
        id: 'expedition_132_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[62],
    },
    {
        ...EXPEDITION_NON_HOLOS[62],
        holo: 'reverse',
        id: 'expedition_133_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[63],
    },
    {
        ...EXPEDITION_NON_HOLOS[63],
        holo: 'reverse',
        id: 'expedition_134_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[64],
    },
    {
        ...EXPEDITION_NON_HOLOS[64],
        holo: 'reverse',
        id: 'expedition_135_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[65],
    },
    {
        ...EXPEDITION_NON_HOLOS[65],
        holo: 'reverse',
        id: 'expedition_136_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[66],
    },
    {
        ...EXPEDITION_NON_HOLOS[66],
        holo: 'reverse',
        id: 'expedition_137_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[67],
    },
    {
        ...EXPEDITION_NON_HOLOS[67],
        holo: 'reverse',
        id: 'expedition_138_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[68],
    },
    {
        ...EXPEDITION_NON_HOLOS[68],
        holo: 'reverse',
        id: 'expedition_139_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[69],
    },
    {
        ...EXPEDITION_NON_HOLOS[69],
        holo: 'reverse',
        id: 'expedition_140_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[70],
    },
    {
        ...EXPEDITION_NON_HOLOS[70],
        holo: 'reverse',
        id: 'expedition_141_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[71],
    },
    {
        ...EXPEDITION_NON_HOLOS[71],
        holo: 'reverse',
        id: 'expedition_142_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[72],
    },
    {
        ...EXPEDITION_NON_HOLOS[72],
        holo: 'reverse',
        id: 'expedition_143_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[73],
    },
    {
        ...EXPEDITION_NON_HOLOS[73],
        holo: 'reverse',
        id: 'expedition_144_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[74],
    },
    {
        ...EXPEDITION_NON_HOLOS[74],
        holo: 'reverse',
        id: 'expedition_145_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[75],
    },
    {
        ...EXPEDITION_NON_HOLOS[75],
        holo: 'reverse',
        id: 'expedition_146_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[76],
    },
    {
        ...EXPEDITION_NON_HOLOS[76],
        holo: 'reverse',
        id: 'expedition_147_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[77],
    },
    {
        ...EXPEDITION_NON_HOLOS[77],
        holo: 'reverse',
        id: 'expedition_148_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[78],
    },
    {
        ...EXPEDITION_NON_HOLOS[78],
        holo: 'reverse',
        id: 'expedition_149_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[79],
    },
    {
        ...EXPEDITION_NON_HOLOS[79],
        holo: 'reverse',
        id: 'expedition_150_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[80],
    },
    {
        ...EXPEDITION_NON_HOLOS[80],
        holo: 'reverse',
        id: 'expedition_151_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[81],
    },
    {
        ...EXPEDITION_NON_HOLOS[81],
        holo: 'reverse',
        id: 'expedition_152_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[82],
    },
    {
        ...EXPEDITION_NON_HOLOS[82],
        holo: 'reverse',
        id: 'expedition_153_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[83],
    },
    {
        ...EXPEDITION_NON_HOLOS[83],
        holo: 'reverse',
        id: 'expedition_154_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[84],
    },
    {
        ...EXPEDITION_NON_HOLOS[84],
        holo: 'reverse',
        id: 'expedition_155_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[85],
    },
    {
        ...EXPEDITION_NON_HOLOS[85],
        holo: 'reverse',
        id: 'expedition_156_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[86],
    },
    {
        ...EXPEDITION_NON_HOLOS[86],
        holo: 'reverse',
        id: 'expedition_157_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[87],
    },
    {
        ...EXPEDITION_NON_HOLOS[87],
        holo: 'reverse',
        id: 'expedition_158_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[88],
    },
    {
        ...EXPEDITION_NON_HOLOS[88],
        holo: 'reverse',
        id: 'expedition_159_en_rh',
    },
    {
        ...EXPEDITION_NON_HOLOS[89],
    },
    {
        ...EXPEDITION_NON_HOLOS[90],
    },
    {
        ...EXPEDITION_NON_HOLOS[91],
    },
    {
        ...EXPEDITION_NON_HOLOS[92],
    },
    {
        ...EXPEDITION_NON_HOLOS[93],
    },
    {
        ...EXPEDITION_NON_HOLOS[94],
    },
];

const setId$9 = CARD_SETS.EXPEDITION.value;
const setName$9 = CARD_SETS.EXPEDITION.label;
const setTotal$8 = EXPEDITION_SET_TOTAL;
const EXPEDITION_SET = {
    cardCounts: {
        holoRares: 32,
        rares: 40,
        uncommons: 38,
        commons: 49,
        energies: 6,
        reverseHolos: 165,
    },
    copyright: COPYRIGHTS.EXPEDITION_SET,
    description: SET_DESCRIPTIONS.EXPEDITION,
    holoSheetType: CARD_HOLO_SHEETS.COSMOS_3,
    id: setId$9,
    imageUrl: 'https://cdn.shopify.com/s/files/1/0840/1659/5249/collections/expedition-cat-bg.jpg',
    name: setName$9,
    packInfo: BOOSTER_PACKS.EXPEDITION,
    releaseDate: RELEASE_DATES.EXPEDITION,
    reverseHoloSheetType: CARD_HOLO_SHEETS.RIPPLE,
    setSymbol: setId$9,
    setTotal: setTotal$8,
    cards: [...EXPEDITION_HOLOS, ...EXPEDITION_CARDS],
    themeDecks: [],
};

const { AERODACTYL: AERODACTYL$3, ARTICUNO: ARTICUNO$2, DITTO: DITTO$1, DRAGONAIR: DRAGONAIR$4, DRAGONITE: DRAGONITE$3, DROWZEE: DROWZEE$2, GASTLY: GASTLY$3, GENGAR: GENGAR$3, GRIMER: GRIMER$2, HAUNTER: HAUNTER$4, HITMONLEE: HITMONLEE$2, HYPNO: HYPNO$2, KABUTO: KABUTO$5, KABUTOPS: KABUTOPS$4, LAPRAS: LAPRAS$3, MAGNEMITE: MAGNEMITE$6, MAGNETON: MAGNETON$4, MOLTRES: MOLTRES$1, MUK: MUK$1, PIKACHU: PIKACHU$4, RAICHU: RAICHU$5, ZAPDOS, } = GEN_1_POKEMON;
const { MYSTERIOUS_FOSSIL: MYSTERIOUS_FOSSIL$5 } = JUNGLE_FOSSIL_TRAINERS;
const FOSSIL_HOLOS = [
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-caterpie_tcfh1l.jpg',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: "A ferocious prehistoric Pokémon that goes for the enemy's throat with its serrated saw-like fangs.",
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.GRASS,
        evolvesFrom: MYSTERIOUS_FOSSIL$5.name,
        evolutionBoxBackgroundImageSize: 'cover',
        evolutionBoxImageUrl: MYSTERIOUS_FOSSIL$5.image,
        hitPoints: 60,
        holo: true,
        holoStrength: 0.7,
        id: 'fossil_01_en',
        illustrator: ILLUSTRATORS.HIMENO,
        lengthFeet: 5,
        lengthInches: 11,
        moves: [
            MOVES.PREHISTORIC_POWER,
            SHARED_MOVES('', 'wing-attack', ['colorless', 'colorless'], 20),
        ],
        name: AERODACTYL$3.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 43,
        pokemonImageSize: 75,
        pokemonImageUrl: AERODACTYL$3.images[0].value,
        pokemonLevel: 28,
        pokemonNumber: AERODACTYL$3.number,
        pokemonType: AERODACTYL$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 1,
        stage: AERODACTYL$3.stage,
        weight: 130,
    },
    {
        backgroundColor: '#81B793',
        backgroundImageBlendMode: BLEND_MODES.LIGHTEN,
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/water-seel_psmkpp.jpg',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'A legendary bird Pokémon that is said to appear to doomed people who are lost in icy mountains.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.WATER,
        hitPoints: 70,
        holo: true,
        holoStrength: 0.7,
        id: 'fossil_02_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 5,
        lengthInches: 7,
        moves: [
            MOVES.FREEZE_DRY,
            SHARED_MOVES(ARTICUNO$2.name, 'blizzard', ['water', 'water', 'water', 'water'], 50),
        ],
        name: ARTICUNO$2.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 48,
        pokemonImageSize: 58,
        pokemonImageUrl: ARTICUNO$2.images[0].value,
        pokemonLevel: 35,
        pokemonNumber: ARTICUNO$2.number,
        pokemonType: ARTICUNO$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 2,
        weight: 122,
    },
    {
        backgroundImagePositionX: 52,
        backgroundImagePositionY: 5,
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lights-gb-moltres_wdkt8g.jpg',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: "Capable of copying an enemy's genetic code to instantly transform itself into a duplicate of the enemy.",
        energyResistance: ENERGY_TYPES.PSYCHIC,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 50,
        holo: true,
        holoStrength: 0.7,
        id: 'fossil_03_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        lengthFeet: 1,
        lengthInches: 0,
        moves: [MOVES.TRANSFORM],
        name: DITTO$1.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 50,
        pokemonImageSize: 50,
        pokemonImageUrl: DITTO$1.images[0].value,
        pokemonLevel: 20,
        pokemonNumber: DITTO$1.number,
        pokemonType: DITTO$1.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 3,
        weight: 9,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-sabrinas-abra_he95ft.jpg',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'An extremely rarely seen marine Pokémon. Its intelligence is said to match that of humans.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.COLORLESS,
        evolvesFrom: DRAGONAIR$4.name,
        evolutionBoxImageUrl: DRAGONAIR$4.images[0].value,
        hitPoints: 100,
        holo: true,
        holoStrength: 0.7,
        id: 'fossil_04_en',
        illustrator: ILLUSTRATORS.HIMENO,
        lengthFeet: 7,
        lengthInches: 3,
        moves: [
            MOVES.STEP_IN,
            SHARED_MOVES(DRAGONITE$3.name, 'slam', ['colorless', 'colorless', 'colorless', 'colorless'], 40),
        ],
        name: DRAGONITE$3.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 43,
        pokemonImageSize: 50,
        pokemonImageUrl: DRAGONITE$3.images[0].value,
        pokemonLevel: 45,
        pokemonNumber: DRAGONITE$3.number,
        pokemonType: DRAGONITE$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 4,
        stage: DRAGONITE$3.stage,
        weight: 463,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/walls-professor-oak2_ckudat.jpg',
        description: 'Under a full moon, this Pokémon likes to mimic the shadows of people and laugh at their fright.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.PSYCHIC,
        evolvesFrom: HAUNTER$4.name,
        evolutionBoxImageUrl: HAUNTER$4.images[0].value,
        hitPoints: 80,
        holo: true,
        holoStrength: 0.7,
        id: 'fossil_05_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        lengthFeet: 4,
        lengthInches: 11,
        moves: [MOVES.CURSE, MOVES.DARK_MIND],
        name: GENGAR$3.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: GENGAR$3.images[0].value,
        pokemonLevel: 38,
        pokemonNumber: GENGAR$3.number,
        pokemonType: GENGAR$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 5,
        stage: GENGAR$3.stage,
        weight: 89,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-rockets-moltres_badehb.jpg',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'Because of its ability to slip through block walls, it is said to be from another dimension.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.PSYCHIC,
        evolvesFrom: GASTLY$3.name,
        evolutionBoxImageUrl: GASTLY$3.images[0].value,
        hitPoints: 50,
        holo: true,
        holoStrength: 0.7,
        id: 'fossil_06_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 5,
        lengthInches: 3,
        moves: [MOVES.TRANSPARENCY, MOVES.NIGHTMARE],
        name: HAUNTER$4.name,
        pokemonImagePositionX: 55,
        pokemonImagePositionY: 44,
        pokemonImageSize: 39,
        pokemonImageUrl: HAUNTER$4.images[0].value,
        pokemonLevel: 17,
        pokemonNumber: HAUNTER$4.number,
        pokemonType: HAUNTER$4.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 6,
        stage: HAUNTER$4.stage,
        weight: 0.2,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-hitmonlee2_iiyl9x.jpg',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'When in a hurry, its legs lengthen progressively. It runs smoothly with extra long, loping strides.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 60,
        holo: true,
        holoStrength: 0.7,
        id: 'fossil_07_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 4,
        lengthInches: 11,
        moves: [MOVES.STRETCH_KICK, MOVES.HIGH_JUMP_KICK],
        name: HITMONLEE$2.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 45,
        pokemonImageSize: 43,
        pokemonImageUrl: HITMONLEE$2.images[0].value,
        pokemonLevel: 30,
        pokemonNumber: HITMONLEE$2.number,
        pokemonType: HITMONLEE$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 7,
        weight: 110,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-rockets-moltres_badehb.jpg',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'When it locks eyes with an enemy, it will use a mix of psi moves such as Hypnosis and Confusion.',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        evolvesFrom: DROWZEE$2.name,
        evolutionBoxImageUrl: DROWZEE$2.images[0].value,
        hitPoints: 90,
        holo: true,
        holoStrength: 0.7,
        id: 'fossil_08_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 5,
        lengthInches: 3,
        moves: [MOVES.PROPHECY, MOVES.DARK_MIND],
        name: HYPNO$2.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 44,
        pokemonImageSize: 36,
        pokemonImageUrl: HYPNO$2.images[0].value,
        pokemonLevel: 36,
        pokemonNumber: HYPNO$2.number,
        pokemonType: HYPNO$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 8,
        stage: HYPNO$2.stage,
        weight: 167,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-kabutops2_wuiag5.jpg',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'Its sleek shape is perfect for swimming. It slashes prey with its claws and drains the body fluids.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.GRASS,
        evolvesFrom: KABUTO$5.name,
        evolutionBoxImageUrl: KABUTO$5.images[0].value,
        hitPoints: 60,
        holo: true,
        holoStrength: 0.7,
        id: 'fossil_09_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 4,
        lengthInches: 3,
        moves: [MOVES.SHARP_SICKLE, MOVES.ABSORB],
        name: KABUTOPS$4.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 44,
        pokemonImageSize: 47,
        pokemonImageUrl: KABUTOPS$4.images[0].value,
        pokemonLevel: 30,
        pokemonNumber: KABUTOPS$4.number,
        pokemonType: KABUTOPS$4.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 9,
        stage: KABUTOPS$4.stage,
        weight: 89,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-dratini_vxrsjo.jpg',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'A Pokémon that has been overhunted almost to extinction. It can ferry people across water.',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 80,
        holo: true,
        holoStrength: 0.7,
        id: 'fossil_10_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 8,
        lengthInches: 2,
        moves: [
            SHARED_MOVES(LAPRAS$3.name, 'water-gun', ['water'], 10, true),
            SHARED_MOVES(LAPRAS$3.name, 'confuse-ray', ['water', 'water'], 10),
        ],
        name: LAPRAS$3.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 40,
        pokemonImageUrl: LAPRAS$3.images[0].value,
        pokemonLevel: 31,
        pokemonNumber: LAPRAS$3.number,
        pokemonType: LAPRAS$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 10,
        weight: 485,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/circuit-board-porygon_b9fu5g.jpg',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'Formed by several Magnemites linked together. They frequently appear when sunspots flare up.',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: MAGNEMITE$6.name,
        evolutionBoxImageUrl: MAGNEMITE$6.images[0].value,
        hitPoints: 80,
        holo: true,
        holoStrength: 0.7,
        id: 'fossil_11_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [
            SHARED_MOVES(MAGNETON$4.name, 'sonicboom', ['lightning', 'colorless']),
            SHARED_MOVES(MAGNETON$4.name, 'selfdestruct', ['lightning', 'lightning', 'lightning', 'lightning'], 100, 20),
        ],
        name: MAGNETON$4.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 43,
        pokemonImageSize: 56,
        pokemonImageUrl: MAGNETON$4.images[1].value,
        pokemonLevel: 35,
        pokemonNumber: MAGNETON$4.number,
        pokemonType: MAGNETON$4.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 11,
        stage: MAGNETON$4.stage,
        weight: 132,
    },
    {
        backgroundColor: '#C05808',
        backgroundImageBlendMode: BLEND_MODES.MULTIPLY,
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/flames-magmar_s5ibam.jpg',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'Known as the legendary bird of fire. Every flap of its wings creates a dazzling flash of flames.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.FIRE,
        hitPoints: 70,
        holo: true,
        holoStrength: 0.7,
        id: 'fossil_12_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 6,
        lengthInches: 7,
        moves: [MOVES.WILDFIRE, MOVES.DIVE_BOMB],
        name: MOLTRES$1.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 41,
        pokemonImageSize: 53,
        pokemonImageUrl: MOLTRES$1.images[0].value,
        pokemonLevel: 35,
        pokemonNumber: MOLTRES$1.number,
        pokemonType: MOLTRES$1.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 12,
        weight: 132,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lights-jynx_grozno.jpg',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'Thickly covered with a filthy, vile sludge. It is so toxic, even its footprints contain poison.',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        evolvesFrom: GRIMER$2.name,
        evolutionBoxImageUrl: GRIMER$2.images[0].value,
        hitPoints: 70,
        holo: true,
        holoStrength: 0.7,
        id: 'fossil_13_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [MOVES.TOXIC_GAS, MOVES.SLUDGE],
        name: MUK$1.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 43,
        pokemonImageSize: 55,
        pokemonImageUrl: MUK$1.images[0].value,
        pokemonLevel: 34,
        pokemonNumber: MUK$1.number,
        pokemonType: MUK$1.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 13,
        stage: MUK$1.stage,
        weight: 66,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-pkmn-trader_soqbah.jpg',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'Its long tail serves as a ground to protect itself from its own high voltage power.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: PIKACHU$4.name,
        evolutionBoxImageUrl: PIKACHU$4.images[0].value,
        hitPoints: 90,
        holo: true,
        holoStrength: 0.7,
        id: 'fossil_14_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [MOVES.GIGASHOCK],
        name: RAICHU$5.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonImageUrl: RAICHU$5.images[1].value,
        pokemonLevel: 45,
        pokemonNumber: RAICHU$5.number,
        pokemonType: RAICHU$5.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 14,
        stage: RAICHU$5.stage,
        weight: 66,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lightning-electabuzz_a0idex.jpg',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'A legendary thunderbird Pokémon whose anger is said to cause storms. Some say it has lived above the clouds for thousands of years.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.LIGHTNING,
        hitPoints: 80,
        holo: true,
        holoStrength: 0.7,
        id: 'fossil_15_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 5,
        lengthInches: 3,
        moves: [MOVES.THUNDERSTORM],
        name: ZAPDOS.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 50,
        pokemonImageSize: 58,
        pokemonImageUrl: ZAPDOS.images[1].value,
        pokemonLevel: 40,
        pokemonNumber: ZAPDOS.number,
        pokemonType: ZAPDOS.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 15,
        weight: 116,
    },
];

const { ARBOK: ARBOK$2, CLOYSTER: CLOYSTER$1, EKANS: EKANS$2, GASTLY: GASTLY$2, GEODUDE: GEODUDE$1, GOLBAT: GOLBAT$6, GOLDUCK: GOLDUCK$2, GOLEM: GOLEM$1, GRAVELER: GRAVELER$2, GRIMER: GRIMER$1, HORSEA, KABUTO: KABUTO$4, KINGLER, KOFFING: KOFFING$2, KRABBY, MAGMAR: MAGMAR$1, OMANYTE: OMANYTE$3, OMASTAR: OMASTAR$4, PSYDUCK: PSYDUCK$2, SANDSHREW: SANDSHREW$1, SANDSLASH: SANDSLASH$1, SEADRA: SEADRA$1, SHELLDER, SLOWBRO: SLOWBRO$3, SLOWPOKE: SLOWPOKE$3, TENTACOOL, TENTACRUEL: TENTACRUEL$1, WEEZING: WEEZING$2, ZUBAT: ZUBAT$4, } = GEN_1_POKEMON;
const FOSSIL_NON_HOLOS = [
    {
        ...FOSSIL_HOLOS[0],
        holo: false,
        id: 'fossil_16_en',
        setNumber: 16,
    },
    {
        ...FOSSIL_HOLOS[1],
        holo: false,
        id: 'fossil_17_en',
        setNumber: 17,
    },
    {
        ...FOSSIL_HOLOS[2],
        holo: false,
        id: 'fossil_18_en',
        setNumber: 18,
    },
    {
        ...FOSSIL_HOLOS[3],
        holo: false,
        id: 'fossil_19_en',
        setNumber: 19,
    },
    {
        ...FOSSIL_HOLOS[4],
        holo: false,
        id: 'fossil_20_en',
        setNumber: 20,
    },
    {
        ...FOSSIL_HOLOS[5],
        holo: false,
        id: 'fossil_21_en',
        setNumber: 21,
    },
    {
        ...FOSSIL_HOLOS[6],
        holo: false,
        id: 'fossil_22_en',
        setNumber: 22,
    },
    {
        ...FOSSIL_HOLOS[7],
        holo: false,
        id: 'fossil_23_en',
        setNumber: 23,
    },
    {
        ...FOSSIL_HOLOS[8],
        holo: false,
        id: 'fossil_24_en',
        setNumber: 24,
    },
    {
        ...FOSSIL_HOLOS[9],
        holo: false,
        id: 'fossil_25_en',
        setNumber: 25,
    },
    {
        ...FOSSIL_HOLOS[10],
        holo: false,
        id: 'fossil_26_en',
        setNumber: 26,
    },
    {
        ...FOSSIL_HOLOS[11],
        holo: false,
        id: 'fossil_27_en',
        setNumber: 27,
    },
    {
        ...FOSSIL_HOLOS[12],
        holo: false,
        id: 'fossil_28_en',
        setNumber: 28,
    },
    {
        ...FOSSIL_HOLOS[13],
        holo: false,
        id: 'fossil_29_en',
        setNumber: 29,
    },
    {
        ...FOSSIL_HOLOS[14],
        holo: false,
        id: 'fossil_30_en',
        setNumber: 30,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: EKANS$2.name,
        evolutionBoxImageUrl: EKANS$2.images[0].value,
        hitPoints: 90,
        id: 'fossil_31_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: ARBOK$2.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: ARBOK$2.number,
        pokemonType: ARBOK$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 31,
        stage: ARBOK$2.stage,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: SHELLDER.name,
        evolutionBoxImageUrl: SHELLDER.images[0].value,
        hitPoints: 90,
        id: 'fossil_32_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: CLOYSTER$1.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: CLOYSTER$1.number,
        pokemonType: CLOYSTER$1.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 32,
        stage: CLOYSTER$1.stage,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 90,
        id: 'fossil_33_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: GASTLY$2.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: GASTLY$2.number,
        pokemonType: GASTLY$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 33,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: ZUBAT$4.name,
        evolutionBoxImageUrl: ZUBAT$4.images[0].value,
        hitPoints: 90,
        id: 'fossil_34_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: GOLBAT$6.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: GOLBAT$6.number,
        pokemonType: GOLBAT$6.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 34,
        stage: GOLBAT$6.stage,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: PSYDUCK$2.name,
        evolutionBoxImageUrl: PSYDUCK$2.images[0].value,
        hitPoints: 90,
        id: 'fossil_35_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: GOLDUCK$2.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: GOLDUCK$2.number,
        pokemonType: GOLDUCK$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 35,
        stage: GOLDUCK$2.stage,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: GRAVELER$2.name,
        evolutionBoxImageUrl: GRAVELER$2.images[0].value,
        hitPoints: 90,
        id: 'fossil_36_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: GOLEM$1.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: GOLEM$1.number,
        pokemonType: GOLEM$1.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 36,
        stage: GOLEM$1.stage,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: GEODUDE$1.name,
        evolutionBoxImageUrl: GEODUDE$1.images[0].value,
        hitPoints: 90,
        id: 'fossil_37_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: GRAVELER$2.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: GRAVELER$2.number,
        pokemonType: GRAVELER$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 37,
        stage: GRAVELER$2.stage,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: KRABBY.name,
        evolutionBoxImageUrl: KRABBY.images[0].value,
        hitPoints: 90,
        id: 'fossil_38_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: KINGLER.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: KINGLER.number,
        pokemonType: KINGLER.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 38,
        stage: KINGLER.stage,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 90,
        id: 'fossil_39_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: MAGMAR$1.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: MAGMAR$1.number,
        pokemonType: MAGMAR$1.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 39,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: OMANYTE$3.name,
        evolutionBoxImageUrl: OMANYTE$3.images[0].value,
        hitPoints: 90,
        id: 'fossil_40_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: OMASTAR$4.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: OMASTAR$4.number,
        pokemonType: OMASTAR$4.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 40,
        stage: OMASTAR$4.stage,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: SANDSHREW$1.name,
        evolutionBoxImageUrl: SANDSHREW$1.images[0].value,
        hitPoints: 90,
        id: 'fossil_41_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: SANDSLASH$1.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: SANDSLASH$1.number,
        pokemonType: SANDSLASH$1.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 41,
        stage: SANDSLASH$1.stage,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: HORSEA.name,
        evolutionBoxImageUrl: HORSEA.images[0].value,
        hitPoints: 90,
        id: 'fossil_42_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: SEADRA$1.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: SEADRA$1.number,
        pokemonType: SEADRA$1.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 42,
        stage: SEADRA$1.stage,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: SLOWPOKE$3.name,
        evolutionBoxImageUrl: SLOWPOKE$3.images[0].value,
        hitPoints: 90,
        id: 'fossil_43_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: SLOWBRO$3.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: SLOWBRO$3.number,
        pokemonType: SLOWBRO$3.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 43,
        stage: SLOWBRO$3.stage,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: TENTACOOL.name,
        evolutionBoxImageUrl: TENTACOOL.images[0].value,
        hitPoints: 90,
        id: 'fossil_44_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: TENTACRUEL$1.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: TENTACRUEL$1.number,
        pokemonType: TENTACRUEL$1.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 44,
        stage: TENTACRUEL$1.stage,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: KOFFING$2.name,
        evolutionBoxImageUrl: KOFFING$2.images[0].value,
        hitPoints: 90,
        id: 'fossil_45_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: WEEZING$2.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: WEEZING$2.number,
        pokemonType: WEEZING$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 45,
        stage: WEEZING$2.stage,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 90,
        id: 'fossil_46_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: EKANS$2.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: EKANS$2.number,
        pokemonType: EKANS$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 46,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 90,
        id: 'fossil_47_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: GEODUDE$1.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: GEODUDE$1.number,
        pokemonType: GEODUDE$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 47,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 90,
        id: 'fossil_48_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: GRIMER$1.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 41,
        pokemonNumber: GRIMER$1.number,
        pokemonType: GRIMER$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 48,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 90,
        id: 'fossil_49_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: HORSEA.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: HORSEA.number,
        pokemonType: HORSEA.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 49,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 90,
        id: 'fossil_50_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: KABUTO$4.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: KABUTO$4.number,
        pokemonType: KABUTO$4.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 50,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 90,
        id: 'fossil_51_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: KRABBY.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: KRABBY.number,
        pokemonType: KRABBY.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 51,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 90,
        id: 'fossil_52_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: OMANYTE$3.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: OMANYTE$3.number,
        pokemonType: OMANYTE$3.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 52,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 90,
        id: 'fossil_53_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: PSYDUCK$2.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: PSYDUCK$2.number,
        pokemonType: PSYDUCK$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 53,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 90,
        id: 'fossil_54_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: SHELLDER.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: SHELLDER.number,
        pokemonType: SHELLDER.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 54,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 90,
        id: 'fossil_55_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: SLOWPOKE$3.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: SLOWPOKE$3.number,
        pokemonType: SLOWPOKE$3.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 55,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 90,
        id: 'fossil_56_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: TENTACOOL.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: TENTACOOL.number,
        pokemonType: TENTACOOL.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 56,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 90,
        id: 'fossil_57_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: ZUBAT$4.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: ZUBAT$4.number,
        pokemonType: ZUBAT$4.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 57,
        weight: 66,
    },
];

const FOSSIL_SET_THEME_DECKS = [
    {
        id: 'lockdown',
        name: 'LockDown',
        energyTypes: ['fire', 'water'],
        cards: [
            {
                id: 'fossil_10_en',
                count: 1,
            },
            {
                id: 'fossil_39_en',
                count: 2,
            },
            {
                id: 'fossil_49_en',
                count: 4,
            },
            {
                id: 'fossil_42_en',
                count: 2,
            },
            {
                id: 'fossil_51_en',
                count: 4,
            },
            {
                id: 'fossil_38_en',
                count: 2,
            },
            {
                id: 'base_068_en',
                count: 3,
                setId: BASE_SET.id,
            },
            {
                id: 'base_060_en',
                count: 3,
                setId: BASE_SET.id,
            },
            {
                id: 'fossil_60_en',
                count: 1,
            },
            {
                id: 'fossil_59_en',
                count: 1,
            },
            {
                id: 'base_091_en',
                count: 2,
                setId: BASE_SET.id,
            },
            {
                id: 'base_095_en',
                count: 2,
                setId: BASE_SET.id,
            },
            {
                id: 'base_094_en',
                count: 2,
                setId: BASE_SET.id,
            },
            {
                id: 'base_090_en',
                count: 2,
                setId: BASE_SET.id,
            },
            {
                id: 'base_082_en',
                count: 1,
                setId: BASE_SET.id,
            },
            {
                id: 'base_098_en',
                count: 14,
                setId: BASE_SET.id,
            },
            {
                id: 'base_102_en',
                count: 14,
                setId: BASE_SET.id,
            },
        ],
    },
    {
        id: 'bodyguard',
        name: 'BodyGuard',
        energyTypes: ['grass', 'fighting'],
        cards: [
            {
                id: 'fossil_13_en',
                count: 1,
            },
            {
                id: 'fossil_47_en',
                count: 3,
            },
            {
                id: 'fossil_37_en',
                count: 2,
            },
            {
                id: 'fossil_48_en',
                count: 4,
            },
            {
                id: 'fossil_57_en',
                count: 2,
            },
            {
                id: 'fossil_34_en',
                count: 2,
            },
            {
                id: 'base_056_en',
                count: 1,
                setId: BASE_SET.id,
            },
            {
                id: 'base_044_en',
                count: 2,
                setId: BASE_SET.id,
            },
            {
                id: 'base_051_en',
                count: 4,
                setId: BASE_SET.id,
            },
            {
                id: 'base_094_en',
                count: 4,
                setId: BASE_SET.id,
            },
            {
                id: 'base_088_en',
                count: 2,
                setId: BASE_SET.id,
            },
            {
                id: 'base_085_en',
                count: 1,
                setId: BASE_SET.id,
            },
            {
                id: 'base_090_en',
                count: 2,
                setId: BASE_SET.id,
            },
            {
                id: 'base_099_en',
                count: 16,
                setId: BASE_SET.id,
            },
            {
                id: 'base_097_en',
                count: 12,
                setId: BASE_SET.id,
            },
        ],
    },
];

const { ENERGY_SEARCH, GAMBLER, MR_FUJI, MYSTERIOUS_FOSSIL: MYSTERIOUS_FOSSIL$4, RECYCLE } = JUNGLE_FOSSIL_TRAINERS;
const FOSSIL_TRAINERS = [
    {
        backgroundImageUrl: MR_FUJI.image,
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'fossil_58_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        name: MR_FUJI.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 58,
    },
    {
        backgroundImageUrl: ENERGY_SEARCH.image,
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'fossil_59_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        name: ENERGY_SEARCH.name,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 59,
    },
    {
        backgroundImageUrl: GAMBLER.image,
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'fossil_60_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        name: GAMBLER.name,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 60,
    },
    {
        backgroundImageUrl: RECYCLE.image,
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'fossil_61_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        name: RECYCLE.name,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 61,
    },
    {
        backgroundImageUrl: MYSTERIOUS_FOSSIL$4.image,
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        hitPoints: 10,
        id: 'fossil_62_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        name: MYSTERIOUS_FOSSIL$4.name,
        rarity: RARITY_TYPES.COMMON,
        subtitle: '10 HP',
    },
];

const setId$8 = CARD_SETS.FOSSIL.value;
const setName$8 = CARD_SETS.FOSSIL.label;
const setTotal$7 = FOSSIL_SET_TOTAL;
const FOSSIL_SET = {
    cardCounts: {
        holoRares: 15,
        rares: 15,
        uncommons: 16,
        commons: 16,
    },
    copyright: COPYRIGHTS.FOSSIL_SET,
    description: SET_DESCRIPTIONS.FOSSIL,
    holoSheetType: CARD_HOLO_SHEETS.STARS,
    id: setId$8,
    imageUrl: 'https://cdn.shopify.com/s/files/1/0840/1659/5249/collections/fossil-cat-bg.jpg',
    name: setName$8,
    packInfo: BOOSTER_PACKS.FOSSIL,
    releaseDate: RELEASE_DATES.FOSSIL,
    setSymbol: setId$8,
    setTotal: setTotal$7,
    cards: [...FOSSIL_HOLOS, ...FOSSIL_NON_HOLOS, ...FOSSIL_TRAINERS],
    themeDecks: FOSSIL_SET_THEME_DECKS,
};

const ROCKET_TRAINERS = {
    CHALLENGE: {
        name: 'Challenge!',
        image: '',
    },
    DIGGER: {
        name: 'Digger',
        image: '',
    },
    GOOP_GAS_ATTACK: {
        name: 'Goop Gas Attack',
        image: '',
    },
    HERE_COMES_TEAM_ROCKET: {
        name: 'Here Comes Team Rocket!',
        image: 'https://poketcgshop.s3.amazonaws.com/trainer-card-images/hctr-full_u6zm4o.png',
    },
    IMPOSTER_OAKS_REVENGE: {
        name: "Imposter Oak's Revenge",
        image: '',
    },
    NIGHTLY_GARBAGE_RUN: {
        name: 'Nightly Garbage Run',
        image: '',
    },
    ROCKETS_SNEAK_ATTACK: {
        name: "Rocket's Sneak Attack",
        image: 'https://poketcgshop.s3.amazonaws.com/trainer-card-images/rockets-sneak-attack_tcoroq.png',
    },
    SLEEP: {
        name: 'Sleep!',
        image: '',
    },
    THE_BOSS_WAY: {
        name: "The Boss's Way",
        image: '',
    },
};

const { ALAKAZAM: ALAKAZAM$1, ARBOK: ARBOK$1, BLASTOISE: BLASTOISE$1, CHARIZARD: CHARIZARD$3, CHARMELEON: CHARMELEON$2, DIGLETT: DIGLETT$2, DRAGONAIR: DRAGONAIR$3, DRAGONITE: DRAGONITE$2, DROWZEE: DROWZEE$1, DUGTRIO: DUGTRIO$1, EKANS: EKANS$1, GLOOM: GLOOM$1, GOLBAT: GOLBAT$5, GYARADOS: GYARADOS$3, HYPNO: HYPNO$1, KADABRA: KADABRA$3, KOFFING: KOFFING$1, MACHAMP: MACHAMP$3, MACHOKE: MACHOKE$4, MAGIKARP: MAGIKARP$4, MAGNEMITE: MAGNEMITE$5, MAGNETON: MAGNETON$3, PIKACHU: PIKACHU$3, RAICHU: RAICHU$4, SLOWBRO: SLOWBRO$2, SLOWPOKE: SLOWPOKE$2, VILEPLUME: VILEPLUME$1, WARTORTLE: WARTORTLE$2, WEEZING: WEEZING$1, ZUBAT: ZUBAT$3, } = GEN_1_POKEMON;
const { HERE_COMES_TEAM_ROCKET, ROCKETS_SNEAK_ATTACK } = ROCKET_TRAINERS;
const { RAINBOW } = SPECIAL_ENERGIES;
const ROCKET_MAIN_HOLOS = [
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lights-rocket-alakazam_oytsc1.jpg',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'Almost as if it were being controlled by something else, it never changes expressions, even in the middle of battle.',
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        evolvesFrom: `Dark ${KADABRA$3.name}`,
        evolutionBoxImageUrl: KADABRA$3.images[0].value,
        hitPoints: 60,
        holo: true,
        holoStrength: 0.7,
        id: 'rocket_01_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        frameMode: 'dark',
        lengthFeet: 4,
        lengthInches: 11,
        moves: [MOVES.TELEPORT_BLAST, MOVES.MIND_SHOCK],
        name: `Dark ${ALAKAZAM$1.name}`,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 44,
        pokemonImageSize: 42,
        pokemonImageUrl: ALAKAZAM$1.images[1].value,
        pokemonLevel: 30,
        pokemonNumber: ALAKAZAM$1.number,
        pokemonType: ALAKAZAM$1.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 1,
        stage: ALAKAZAM$1.stage,
        weight: 106,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-arbok_pqj82p.jpg',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'Its magical and cute appeal has many admirers. It is rare and found only in certain areas.',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        evolvesFrom: EKANS$1.name,
        evolutionBoxImageUrl: EKANS$1.images[0].value,
        hitPoints: 60,
        holo: true,
        holoStrength: 0.7,
        id: 'rocket_02_en',
        illustrator: ILLUSTRATORS.ARITA,
        frameMode: 'dark',
        lengthFeet: 11,
        lengthInches: 6,
        moves: [MOVES.STARE, MOVES.POISON_VAPOR],
        name: `Dark ${ARBOK$1.name}`,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 45,
        pokemonImageSize: 45,
        pokemonImageUrl: ARBOK$1.images[1].value,
        pokemonLevel: 25,
        pokemonNumber: ARBOK$1.number,
        pokemonType: ARBOK$1.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 2,
        stage: ARBOK$1.stage,
        weight: 143,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/water-seel_psmkpp.jpg',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'An aggressive Pokémon that tackles anything it sees.',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        evolvesFrom: `Dark ${WARTORTLE$2.name}`,
        evolutionBoxImageUrl: WARTORTLE$2.images[0].value,
        hitPoints: 70,
        holo: true,
        holoStrength: 0.7,
        id: 'rocket_03_en',
        illustrator: ILLUSTRATORS.ARITA,
        frameMode: 'dark',
        lengthFeet: 5,
        lengthInches: 3,
        moves: [MOVES.HYDROCANNON, MOVES.ROCKET_TACKLE],
        name: `Dark ${BLASTOISE$1.name}`,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 43,
        pokemonImageSize: 38,
        pokemonImageUrl: BLASTOISE$1.images[1].value,
        pokemonLevel: 28,
        pokemonNumber: BLASTOISE$1.number,
        pokemonType: BLASTOISE$1.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 3,
        stage: BLASTOISE$1.stage,
        weight: 189,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-brocks-zubat_jyfmxr.jpg',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'Seemingly possessed, it spews fire like a volcano, trying to burn all it sees.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: ENERGY_TYPES.WATER,
        evolvesFrom: `Dark ${CHARMELEON$2.name}`,
        evolutionBoxImageUrl: CHARMELEON$2.images[0].value,
        hitPoints: 80,
        holo: true,
        holoStrength: 0.7,
        id: 'rocket_04_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        frameMode: 'dark',
        lengthFeet: 5,
        lengthInches: 7,
        moves: [MOVES.NAIL_FLICK, MOVES.CONTINUOUS_FIREBALL],
        name: `Dark ${CHARIZARD$3.name}`,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 52,
        pokemonImageSize: 72,
        pokemonImageUrl: CHARIZARD$3.images[1].value,
        pokemonLevel: 38,
        pokemonNumber: CHARIZARD$3.number,
        pokemonType: CHARIZARD$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 4,
        stage: CHARIZARD$3.stage,
        weight: 200,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lights-gb-moltres_wdkt8g.jpg',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'Sometimes called "The God of Destruction." Its wings are able to support it in spite of its massive weight.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.COLORLESS,
        evolvesFrom: `Dark ${DRAGONAIR$3.name}`,
        evolutionBoxImageUrl: DRAGONAIR$3.images[0].value,
        hitPoints: 70,
        holo: true,
        holoStrength: 0.7,
        id: 'rocket_05_en',
        illustrator: ILLUSTRATORS.ARITA,
        frameMode: 'dark',
        lengthFeet: 7,
        lengthInches: 3,
        moves: [MOVES.SUMMON_MINIONS, MOVES.GIANT_TAIL],
        name: `Dark ${DRAGONITE$2.name}`,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 41,
        pokemonImageSize: 57,
        pokemonImageUrl: DRAGONITE$2.images[1].value,
        pokemonLevel: 33,
        pokemonNumber: DRAGONITE$2.number,
        pokemonType: DRAGONITE$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 5,
        stage: DRAGONITE$2.stage,
        weight: 463,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-brocks-vulpix_cjhesd.jpg',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'Digs large sinkholes in the ground and tries to trap its enemies in them.',
        energyResistance: ENERGY_TYPES.LIGHTNING,
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.GRASS,
        evolvesFrom: DIGLETT$2.name,
        evolutionBoxImageUrl: DIGLETT$2.images[0].value,
        hitPoints: 50,
        holo: true,
        holoStrength: 0.7,
        id: 'rocket_06_en',
        illustrator: ILLUSTRATORS.HIMENO,
        frameMode: 'dark',
        lengthFeet: 2,
        lengthInches: 4,
        moves: [MOVES.SINKHOLE, MOVES.KNOCK_DOWN],
        name: `Dark ${DUGTRIO$1.name}`,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 52,
        pokemonImageSize: 49,
        pokemonImageUrl: DUGTRIO$1.images[1].value,
        pokemonLevel: 18,
        pokemonNumber: DUGTRIO$1.number,
        pokemonType: DUGTRIO$1.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 6,
        stage: DUGTRIO$1.stage,
        weight: 73,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/foliage-erikas-gloom_v2u2vs.jpg',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'Sneaks up silently on its prey and attacks it from behind, sometimes killing it with one bite.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        evolvesFrom: ZUBAT$3.name,
        evolutionBoxImageUrl: ZUBAT$3.images[0].value,
        hitPoints: 50,
        holo: true,
        holoStrength: 0.7,
        id: 'rocket_07_en',
        illustrator: ILLUSTRATORS.ARITA,
        frameMode: 'dark',
        lengthFeet: 5,
        lengthInches: 3,
        moves: [MOVES.SNEAK_ATTACK, MOVES.FLITTER],
        name: `Dark ${GOLBAT$5.name}`,
        pokemonImagePositionX: 59,
        pokemonImagePositionY: 25,
        pokemonImageSize: 52,
        pokemonImageUrl: GOLBAT$5.images[1].value,
        pokemonLevel: 25,
        pokemonNumber: GOLBAT$5.number,
        pokemonType: GOLBAT$5.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 7,
        stage: GOLBAT$5.stage,
        weight: 121,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-rockets-moltres_badehb.jpg',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'Normally found only in the deep ocean, it has recently been seen in shallow waters as well.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.GRASS,
        evolvesFrom: MAGIKARP$4.name,
        evolutionBoxImageUrl: MAGIKARP$4.images[0].value,
        hitPoints: 70,
        holo: true,
        holoStrength: 0.7,
        id: 'rocket_08_en',
        illustrator: ILLUSTRATORS.HIMENO,
        frameMode: 'dark',
        lengthFeet: 21,
        lengthInches: 4,
        moves: [
            MOVES.FINAL_BEAM,
            SHARED_MOVES(GYARADOS$3.name, 'ice-beam', ['water', 'water', 'water'], 30),
        ],
        name: `Dark ${GYARADOS$3.name}`,
        pokemonImagePositionX: 55,
        pokemonImagePositionY: 40,
        pokemonImageSize: 67,
        pokemonImageUrl: GYARADOS$3.images[1].value,
        pokemonLevel: 31,
        pokemonNumber: GYARADOS$3.number,
        pokemonType: GYARADOS$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 8,
        stage: GYARADOS$3.stage,
        weight: 518,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/leather-bgpng_f6jkdb.png',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'Carries a pendulum with it always. Sometimes appears near less-traveled roads and schools at dusk.',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        evolvesFrom: DROWZEE$1.name,
        evolutionBoxImageUrl: DROWZEE$1.images[0].value,
        hitPoints: 60,
        holo: true,
        holoStrength: 0.7,
        id: 'rocket_09_en',
        illustrator: ILLUSTRATORS.HIMENO,
        frameMode: 'dark',
        lengthFeet: 5,
        lengthInches: 3,
        moves: [MOVES.PSYPUNCH, MOVES.BENCH_MANIPULATION],
        name: `Dark ${HYPNO$1.name}`,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 57,
        pokemonImageSize: 66,
        pokemonImageUrl: HYPNO$1.images[1].value,
        pokemonLevel: 26,
        pokemonNumber: HYPNO$1.number,
        pokemonType: HYPNO$1.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 9,
        stage: HYPNO$1.stage,
        weight: 167,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/trainer_ej24q6.jpg',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: "It is almost impossible to defend against a Machamp's four powerful arms.",
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        evolvesFrom: `Dark ${MACHOKE$4.name}`,
        evolutionBoxImageUrl: MACHOKE$4.images[0].value,
        hitPoints: 70,
        holo: true,
        holoStrength: 0.7,
        id: 'rocket_10_en',
        illustrator: ILLUSTRATORS.ARITA,
        frameMode: 'dark',
        lengthFeet: 5,
        lengthInches: 3,
        moves: [MOVES.MEGA_PUNCH_30, MOVES.FLING],
        name: `Dark ${MACHAMP$3.name}`,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 52,
        pokemonImageSize: 60,
        pokemonImageUrl: MACHAMP$3.images[1].value,
        pokemonLevel: 30,
        pokemonNumber: MACHAMP$3.number,
        pokemonType: MACHAMP$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 10,
        stage: MACHAMP$3.stage,
        weight: 287,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels/6056561261_184b13332b_kregcm.jpg',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'The number of incidents of hackers using Magnetons to damage computer systems is steadily increasing.',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: MAGNEMITE$5.name,
        evolutionBoxImageUrl: MAGNEMITE$5.images[0].value,
        hitPoints: 60,
        holo: true,
        holoStrength: 0.7,
        id: 'rocket_11_en',
        illustrator: ILLUSTRATORS.TANAKA,
        frameMode: 'dark',
        lengthFeet: 3,
        lengthInches: 3,
        moves: [
            SHARED_MOVES(MAGNETON$3.name, 'sonicboom', ['colorless', 'colorless']),
            MOVES.MAGNETIC_LINES,
        ],
        name: `Dark ${MAGNETON$3.name}`,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 45,
        pokemonImageSize: 42,
        pokemonImageUrl: MAGNETON$3.images[2].value,
        pokemonLevel: 26,
        pokemonNumber: MAGNETON$3.number,
        pokemonType: MAGNETON$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 11,
        stage: MAGNETON$3.stage,
        weight: 132,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-pkmn-trader_soqbah.jpg',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'It loves nothing better than to be left alone, and so sometimes ends up being manipulated by unscrupulous people.',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        evolvesFrom: SLOWPOKE$2.name,
        evolutionBoxImageUrl: SLOWPOKE$2.images[0].value,
        hitPoints: 60,
        holo: true,
        holoStrength: 0.7,
        id: 'rocket_12_en',
        illustrator: ILLUSTRATORS.ARITA,
        frameMode: 'dark',
        lengthFeet: 5,
        lengthInches: 3,
        moves: [MOVES.REEL_IN, MOVES.FICKLE_ATTACK],
        name: `Dark ${SLOWBRO$2.name}`,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 53,
        pokemonImageUrl: SLOWBRO$2.images[1].value,
        pokemonLevel: 27,
        pokemonNumber: SLOWBRO$2.number,
        pokemonType: SLOWBRO$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 12,
        stage: SLOWBRO$2.stage,
        weight: 173,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-kabutops_ox1atw.jpg',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'Perhaps because of their strong-smelling pollen, other Pokémon do not approach areas where Vileplumes live.',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        evolvesFrom: `Dark ${GLOOM$1.name}`,
        evolutionBoxImageUrl: GLOOM$1.images[0].value,
        hitPoints: 60,
        holo: true,
        holoStrength: 0.7,
        id: 'rocket_13_en',
        illustrator: ILLUSTRATORS.HIMENO,
        frameMode: 'dark',
        lengthFeet: 3,
        lengthInches: 11,
        moves: [MOVES.HAY_FEVER, MOVES.PETAL_WHIRLWIND],
        name: `Dark ${VILEPLUME$1.name}`,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 45,
        pokemonImageSize: 42,
        pokemonImageUrl: VILEPLUME$1.images[1].value,
        pokemonLevel: 29,
        pokemonNumber: VILEPLUME$1.number,
        pokemonType: VILEPLUME$1.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 13,
        stage: VILEPLUME$1.stage,
        weight: 41,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lights-kadabra_hrrzpa.jpg',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'Researchers have observed these Pokémon reproducing in industrial waste sites.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        evolvesFrom: KOFFING$1.name,
        evolutionBoxImageUrl: KOFFING$1.images[0].value,
        hitPoints: 60,
        holo: true,
        holoStrength: 0.7,
        id: 'rocket_14_en',
        illustrator: ILLUSTRATORS.YOSHIDA,
        frameMode: 'dark',
        lengthFeet: 3,
        lengthInches: 11,
        moves: [MOVES.MASS_EXPLOSION, MOVES.STUN_GAS],
        name: `Dark ${WEEZING$1.name}`,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 43,
        pokemonImageSize: 61,
        pokemonImageUrl: WEEZING$1.images[1].value,
        pokemonLevel: 24,
        pokemonNumber: WEEZING$1.number,
        pokemonType: WEEZING$1.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 14,
        stage: WEEZING$1.stage,
        weight: 21,
    },
];
const ROCKET_TRAINER_HOLOS = [
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lights-drowzee_yywzks.jpg',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: 'Each player plays with his or her Prize cards face up for the rest of the game.',
        holo: true,
        holoStrength: 0.7,
        id: 'rocket_15_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        name: HERE_COMES_TEAM_ROCKET.name,
        pokemonImagePositionX: -83,
        pokemonImagePositionY: 33,
        pokemonImageSize: 110,
        pokemonImageUrl: HERE_COMES_TEAM_ROCKET.image,
        rarity: RARITY_TYPES.RARE,
        setNumber: 15,
    },
    {
        backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lights-drowzee_yywzks.jpg',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: "Look at your opponent's hand. If he or she has any Trainer cards, choose 1 of them. Your opponent shuffles that card into his or her deck.",
        holo: true,
        holoStrength: 0.7,
        id: 'rocket_16_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        name: ROCKETS_SNEAK_ATTACK.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 40,
        pokemonImageSize: 68,
        pokemonImageUrl: ROCKETS_SNEAK_ATTACK.image,
        rarity: RARITY_TYPES.RARE,
        setNumber: 16,
    },
];
const RAINBOW_ENERGY_HOLO = {
    backgroundImageUrl: RAINBOW.images[0].value,
    cardTemplate: CARD_TEMPLATES.ENERGY,
    description: `Attach Rainbow Energy to 1 of your Pokémon. While in play, Rainbow Energy counts as every type of basic Energy but only provides 1 Energy at a time. <em>(Doesn't count as a basic Energy card when not in play.)</em> When you attach this card from your hand to 1 of your Pokémon, it does 10 damage to that Pokémon. ${DONT_APPLY_WEAKNESS}`,
    energyType: SPECIAL_ENERGY_TYPES.RAINBOW,
    holo: true,
    holoStrength: 0.7,
    id: 'rocket_17_en',
    illustrator: ILLUSTRATORS.AKABANE,
    name: RAINBOW.name,
    pokemonImagePositionX: 51,
    pokemonImagePositionY: 40,
    pokemonImageSize: 68,
    rarity: RARITY_TYPES.RARE,
    setNumber: 17,
};
const DARK_RAICHU_SECRET = {
    backgroundImageUrl: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-hitmonlee2_iiyl9x.jpg',
    cardTemplate: CARD_TEMPLATES.BASE,
    description: 'Stores up electricity in its body, then suddenly releases it to surprise and shock everyone.',
    energyRetreatCost: 1,
    energyType: ENERGY_TYPES.LIGHTNING,
    energyWeakness: ENERGY_TYPES.FIGHTING,
    evolvesFrom: PIKACHU$3.name,
    evolutionBoxImageUrl: PIKACHU$3.images[0].value,
    hitPoints: 70,
    holo: true,
    holoStrength: 0.7,
    id: 'rocket_83_en',
    illustrator: ILLUSTRATORS.ARITA,
    frameMode: 'dark',
    lengthFeet: 2,
    lengthInches: 7,
    moves: [MOVES.SURPRISE_THUNDER],
    name: `Dark ${RAICHU$4.name}`,
    pokemonImagePositionX: 51,
    pokemonImagePositionY: 38,
    pokemonImageSize: 66,
    pokemonImageUrl: RAICHU$4.images[2].value,
    pokemonLevel: 24,
    pokemonNumber: RAICHU$4.number,
    pokemonType: RAICHU$4.pokemonType,
    rarity: RARITY_TYPES.RARE,
    setNumber: 83,
    stage: RAICHU$4.stage,
    weight: 66,
};

const { ABRA: ABRA$1, CHARMANDER, CHARMELEON: CHARMELEON$1, DIGLETT: DIGLETT$1, DRAGONAIR: DRAGONAIR$2, DRATINI: DRATINI$1, DROWZEE, EEVEE: EEVEE$6, EKANS, ELECTRODE: ELECTRODE$1, FLAREON: FLAREON$3, GLOOM, GOLDUCK: GOLDUCK$1, GRIMER, JOLTEON: JOLTEON$3, KADABRA: KADABRA$2, KOFFING, MACHOKE: MACHOKE$3, MACHOP: MACHOP$2, MAGIKARP: MAGIKARP$3, MAGNEMITE: MAGNEMITE$4, MANKEY, MEOWTH: MEOWTH$1, MUK, ODDISH, PERSIAN: PERSIAN$2, PONYTA, PORYGON: PORYGON$3, PRIMEAPE: PRIMEAPE$2, PSYDUCK: PSYDUCK$1, RAPIDASH: RAPIDASH$1, RATICATE: RATICATE$2, RATTATA: RATTATA$1, SLOWPOKE: SLOWPOKE$1, SQUIRTLE, VAPOREON: VAPOREON$2, VOLTORB: VOLTORB$1, WARTORTLE: WARTORTLE$1, ZUBAT: ZUBAT$2, } = GEN_1_POKEMON;
const ROCKET_NON_HOLOS = [
    {
        ...ROCKET_MAIN_HOLOS[0],
        holo: false,
        id: 'rocket_18_en',
        setNumber: 18,
    },
    {
        ...ROCKET_MAIN_HOLOS[1],
        holo: false,
        id: 'rocket_19_en',
        setNumber: 19,
    },
    {
        ...ROCKET_MAIN_HOLOS[2],
        holo: false,
        id: 'rocket_20_en',
        setNumber: 20,
    },
    {
        ...ROCKET_MAIN_HOLOS[3],
        holo: false,
        id: 'rocket_21_en',
        setNumber: 21,
    },
    {
        ...ROCKET_MAIN_HOLOS[4],
        holo: false,
        id: 'rocket_22_en',
        setNumber: 22,
    },
    {
        ...ROCKET_MAIN_HOLOS[5],
        holo: false,
        id: 'rocket_23_en',
        setNumber: 23,
    },
    {
        ...ROCKET_MAIN_HOLOS[6],
        holo: false,
        id: 'rocket_24_en',
        setNumber: 24,
    },
    {
        ...ROCKET_MAIN_HOLOS[7],
        holo: false,
        id: 'rocket_25_en',
        setNumber: 25,
    },
    {
        ...ROCKET_MAIN_HOLOS[8],
        holo: false,
        id: 'rocket_26_en',
        setNumber: 26,
    },
    {
        ...ROCKET_MAIN_HOLOS[9],
        holo: false,
        id: 'rocket_27_en',
        setNumber: 27,
    },
    {
        ...ROCKET_MAIN_HOLOS[10],
        holo: false,
        id: 'rocket_28_en',
        setNumber: 28,
    },
    {
        ...ROCKET_MAIN_HOLOS[11],
        holo: false,
        id: 'rocket_29_en',
        setNumber: 29,
    },
    {
        ...ROCKET_MAIN_HOLOS[12],
        holo: false,
        id: 'rocket_30_en',
        setNumber: 30,
    },
    {
        ...ROCKET_MAIN_HOLOS[13],
        holo: false,
        id: 'rocket_31_en',
        setNumber: 31,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: CHARMANDER.name,
        evolutionBoxImageUrl: CHARMANDER.images[0].value,
        frameMode: 'dark',
        hitPoints: 90,
        id: 'rocket_32_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: `Dark ${CHARMELEON$1.name}`,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: CHARMELEON$1.number,
        pokemonType: CHARMELEON$1.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 32,
        stage: CHARMELEON$1.stage,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: DRATINI$1.name,
        evolutionBoxImageUrl: DRATINI$1.images[0].value,
        frameMode: 'dark',
        hitPoints: 90,
        id: 'rocket_33_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: `Dark ${DRAGONAIR$2.name}`,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: DRAGONAIR$2.number,
        pokemonType: DRAGONAIR$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 33,
        stage: DRAGONAIR$2.stage,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: VOLTORB$1.name,
        evolutionBoxImageUrl: VOLTORB$1.images[0].value,
        frameMode: 'dark',
        hitPoints: 90,
        id: 'rocket_34_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: `Dark ${ELECTRODE$1.name}`,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: ELECTRODE$1.number,
        pokemonType: ELECTRODE$1.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 34,
        stage: ELECTRODE$1.stage,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: EEVEE$6.name,
        evolutionBoxImageUrl: EEVEE$6.images[0].value,
        frameMode: 'dark',
        hitPoints: 90,
        id: 'rocket_35_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: `Dark ${FLAREON$3.name}`,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: FLAREON$3.number,
        pokemonType: FLAREON$3.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 35,
        stage: FLAREON$3.stage,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: ODDISH.name,
        evolutionBoxImageUrl: ODDISH.images[0].value,
        frameMode: 'dark',
        hitPoints: 90,
        id: 'rocket_36_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: `Dark ${GLOOM.name}`,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: GLOOM.number,
        pokemonType: GLOOM.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 36,
        stage: GLOOM.stage,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: PSYDUCK$1.name,
        evolutionBoxImageUrl: PSYDUCK$1.images[0].value,
        frameMode: 'dark',
        hitPoints: 90,
        id: 'rocket_37_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: `Dark ${GOLDUCK$1.name}`,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: GOLDUCK$1.number,
        pokemonType: GOLDUCK$1.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 37,
        stage: GOLDUCK$1.stage,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: EEVEE$6.name,
        evolutionBoxImageUrl: EEVEE$6.images[0].value,
        frameMode: 'dark',
        hitPoints: 90,
        id: 'rocket_38_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: `Dark ${JOLTEON$3.name}`,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: JOLTEON$3.number,
        pokemonType: JOLTEON$3.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 38,
        stage: JOLTEON$3.stage,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: ABRA$1.name,
        evolutionBoxImageUrl: ABRA$1.images[0].value,
        frameMode: 'dark',
        hitPoints: 90,
        id: 'rocket_39_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: `Dark ${KADABRA$2.name}`,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: KADABRA$2.number,
        pokemonType: KADABRA$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 39,
        stage: KADABRA$2.stage,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: MACHOP$2.name,
        evolutionBoxImageUrl: MACHOP$2.images[0].value,
        frameMode: 'dark',
        hitPoints: 90,
        id: 'rocket_40_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: `Dark ${MACHOKE$3.name}`,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: MACHOKE$3.number,
        pokemonType: MACHOKE$3.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 40,
        stage: MACHOKE$3.stage,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: GRIMER.name,
        evolutionBoxImageUrl: GRIMER.images[0].value,
        frameMode: 'dark',
        hitPoints: 90,
        id: 'rocket_41_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: `Dark ${MUK.name}`,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: MUK.number,
        pokemonType: MUK.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 41,
        stage: MUK.stage,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'Popular with women because of its beautiful fur. The leader of the Rockets keeps one as a pet.',
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: MEOWTH$1.name,
        evolutionBoxImageUrl: MEOWTH$1.images[0].value,
        frameMode: 'dark',
        hitPoints: 60,
        id: 'rocket_42_en',
        illustrator: ILLUSTRATORS.YOSHIDA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: `Dark ${PERSIAN$2.name}`,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonImageUrl: PERSIAN$2.images[2].value,
        pokemonLevel: 45,
        pokemonNumber: PERSIAN$2.number,
        pokemonType: PERSIAN$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 42,
        stage: PERSIAN$2.stage,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: MANKEY.name,
        evolutionBoxImageUrl: MANKEY.images[0].value,
        frameMode: 'dark',
        hitPoints: 90,
        id: 'rocket_43_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: `Dark ${PRIMEAPE$2.name}`,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: PRIMEAPE$2.number,
        pokemonType: PRIMEAPE$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 43,
        stage: PRIMEAPE$2.stage,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: PONYTA.name,
        evolutionBoxImageUrl: PONYTA.images[0].value,
        frameMode: 'dark',
        hitPoints: 90,
        id: 'rocket_44_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: `Dark ${RAPIDASH$1.name}`,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: RAPIDASH$1.number,
        pokemonType: RAPIDASH$1.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 44,
        stage: RAPIDASH$1.stage,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: 'A Pokémon capable of controlling water, so it is capable of creating giant whirlpools.',
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: EEVEE$6.name,
        evolutionBoxImageUrl: EEVEE$6.images[0].value,
        frameMode: 'dark',
        hitPoints: 60,
        id: 'rocket_45_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: `Dark ${VAPOREON$2.name}`,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonImageUrl: VAPOREON$2.images[1].value,
        pokemonLevel: 45,
        pokemonNumber: VAPOREON$2.number,
        pokemonType: VAPOREON$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 45,
        stage: VAPOREON$2.stage,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: SQUIRTLE.name,
        evolutionBoxImageUrl: SQUIRTLE.images[0].value,
        frameMode: 'dark',
        hitPoints: 90,
        id: 'rocket_46_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: `Dark ${WARTORTLE$1.name}`,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: WARTORTLE$1.number,
        pokemonType: WARTORTLE$1.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 46,
        stage: WARTORTLE$1.stage,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 90,
        id: 'rocket_47_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: MAGIKARP$3.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: MAGIKARP$3.number,
        pokemonType: MAGIKARP$3.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 47,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 90,
        id: 'rocket_48_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: PORYGON$3.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: PORYGON$3.number,
        pokemonType: PORYGON$3.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 48,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 90,
        id: 'rocket_49_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: ABRA$1.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: ABRA$1.number,
        pokemonType: ABRA$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 49,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 90,
        id: 'rocket_50_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: CHARMANDER.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: CHARMANDER.number,
        pokemonType: CHARMANDER.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 50,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: RATTATA$1.name,
        evolutionBoxImageUrl: RATTATA$1.images[0].value,
        frameMode: 'dark',
        hitPoints: 90,
        id: 'rocket_51_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: `Dark ${RATICATE$2.name}`,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: RATICATE$2.number,
        pokemonType: RATICATE$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 51,
        stage: RATICATE$2.stage,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 90,
        id: 'rocket_52_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: DIGLETT$1.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: DIGLETT$1.number,
        pokemonType: DIGLETT$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 52,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 90,
        id: 'rocket_53_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: DRATINI$1.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: DRATINI$1.number,
        pokemonType: DRATINI$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 53,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 90,
        id: 'rocket_54_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: DROWZEE.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: DROWZEE.number,
        pokemonType: DROWZEE.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 54,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 90,
        id: 'rocket_55_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: EEVEE$6.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: EEVEE$6.number,
        pokemonType: EEVEE$6.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 55,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 90,
        id: 'rocket_56_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: EKANS.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: EKANS.number,
        pokemonType: EKANS.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 56,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 90,
        id: 'rocket_57_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: GRIMER.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: GRIMER.number,
        pokemonType: GRIMER.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 57,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 90,
        id: 'rocket_58_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: KOFFING.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: KOFFING.number,
        pokemonType: KOFFING.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 58,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 90,
        id: 'rocket_59_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: MACHOP$2.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: MACHOP$2.number,
        pokemonType: MACHOP$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 59,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 90,
        id: 'rocket_60_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: MAGNEMITE$4.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: MAGNEMITE$4.number,
        pokemonType: MAGNEMITE$4.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 60,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 90,
        id: 'rocket_61_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: MANKEY.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: MANKEY.number,
        pokemonType: MANKEY.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 61,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 90,
        id: 'rocket_62_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: MEOWTH$1.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: MEOWTH$1.number,
        pokemonType: MEOWTH$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 62,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 90,
        id: 'rocket_63_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: ODDISH.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: ODDISH.number,
        pokemonType: ODDISH.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 63,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 90,
        id: 'rocket_64_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: PONYTA.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: PONYTA.number,
        pokemonType: PONYTA.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 64,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 90,
        id: 'rocket_65_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: PSYDUCK$1.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: PSYDUCK$1.number,
        pokemonType: PSYDUCK$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 65,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 90,
        id: 'rocket_66_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: RATTATA$1.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: RATTATA$1.number,
        pokemonType: RATTATA$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 66,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 90,
        id: 'rocket_67_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: SLOWPOKE$1.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: SLOWPOKE$1.number,
        pokemonType: SLOWPOKE$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 67,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 90,
        id: 'rocket_68_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: SQUIRTLE.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: SQUIRTLE.number,
        pokemonType: SQUIRTLE.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 68,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 90,
        id: 'rocket_69_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: VOLTORB$1.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: VOLTORB$1.number,
        pokemonType: VOLTORB$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 69,
        weight: 66,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.BASE,
        description: '',
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 90,
        id: 'rocket_70_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: ZUBAT$2.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 39,
        pokemonImageSize: 50,
        pokemonLevel: 45,
        pokemonNumber: ZUBAT$2.number,
        pokemonType: ZUBAT$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 70,
        weight: 66,
    },
];

const { FULL_HEAL: FULL_HEAL$1, POTION: POTION$1 } = SPECIAL_ENERGIES;
const ROCKET_ENERGIES = [
    {
        ...RAINBOW_ENERGY_HOLO,
        holo: false,
        id: 'rocket_80_en',
        setNumber: 80,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.ENERGY,
        description: '',
        id: 'rocket_81_en',
        illustrator: '',
        name: FULL_HEAL$1.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 81,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.ENERGY,
        description: '',
        id: 'rocket_82_en',
        illustrator: '',
        name: POTION$1.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 82,
    },
];

const { CHALLENGE, DIGGER, GOOP_GAS_ATTACK, IMPOSTER_OAKS_REVENGE, NIGHTLY_GARBAGE_RUN, SLEEP, THE_BOSS_WAY, } = ROCKET_TRAINERS;
const ROCKET_SET_TRAINERS = [
    {
        ...ROCKET_TRAINER_HOLOS[0],
        holo: false,
        id: 'rocket_71_en',
        setNumber: 71,
    },
    {
        ...ROCKET_TRAINER_HOLOS[1],
        holo: false,
        id: 'rocket_72_en',
        setNumber: 72,
    },
    {
        backgroundImageUrl: THE_BOSS_WAY.image,
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'rocket_73_en',
        illustrator: '',
        name: THE_BOSS_WAY.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 73,
    },
    {
        backgroundImageUrl: CHALLENGE.image,
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'rocket_74_en',
        illustrator: '',
        name: CHALLENGE.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 74,
    },
    {
        backgroundImageUrl: DIGGER.image,
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'rocket_75_en',
        illustrator: '',
        name: DIGGER.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 75,
        subtitle: TRAINER_CARD_SUBTITLES.ROCKETS_SECRET_MACHINE,
    },
    {
        backgroundImageUrl: IMPOSTER_OAKS_REVENGE.image,
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'rocket_76_en',
        illustrator: '',
        name: IMPOSTER_OAKS_REVENGE.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 76,
    },
    {
        backgroundImageUrl: NIGHTLY_GARBAGE_RUN.image,
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'rocket_77_en',
        illustrator: '',
        name: NIGHTLY_GARBAGE_RUN.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 77,
        subtitle: TRAINER_CARD_SUBTITLES.ROCKETS_SECRET_MACHINE,
    },
    {
        backgroundImageUrl: GOOP_GAS_ATTACK.image,
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'rocket_78_en',
        illustrator: '',
        name: GOOP_GAS_ATTACK.name,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 78,
    },
    {
        backgroundImageUrl: SLEEP.image,
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'rocket_79_en',
        illustrator: '',
        name: SLEEP.name,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 79,
        subtitle: TRAINER_CARD_SUBTITLES.ROCKETS_SECRET_MACHINE,
    },
];

const setId$7 = CARD_SETS.TEAM_ROCKET.value;
const setName$7 = CARD_SETS.TEAM_ROCKET.label;
const setTotal$6 = ROCKET_SET_TOTAL;
const ROCKET_SET = {
    cardCounts: {
        secretRares: 1,
        holoRares: 17,
        rares: 17,
        uncommons: 24,
        commons: 24,
    },
    copyright: COPYRIGHTS.ROCKET_SET,
    description: SET_DESCRIPTIONS.ROCKET,
    holoSheetType: CARD_HOLO_SHEETS.COSMOS,
    id: setId$7,
    imageUrl: 'https://cdn.shopify.com/s/files/1/0840/1659/5249/collections/team-rocket-cat-bg.jpg',
    name: setName$7,
    packInfo: BOOSTER_PACKS.ROCKET,
    releaseDate: RELEASE_DATES.ROCKET,
    setSymbol: setId$7,
    setTotal: setTotal$6,
    cards: [
        ...ROCKET_MAIN_HOLOS,
        ...ROCKET_TRAINER_HOLOS,
        RAINBOW_ENERGY_HOLO,
        ...ROCKET_NON_HOLOS,
        ...ROCKET_SET_TRAINERS,
        ...ROCKET_ENERGIES,
        DARK_RAICHU_SECRET,
    ],
    themeDecks: [],
};

const legendaryReverseTemplate = CARD_TEMPLATES.LEGENDARY_REVERSE;
const MAIN_CARDS = [
    {
        ...BASE_SET.cards[16],
        holo: false,
        id: 'lc_020_en',
        setNumber: 20,
    },
    {
        ...JUNGLE_SET.cards[32],
        id: 'lc_021_en',
        rarity: RARITY_TYPES.RARE,
        setNumber: 21,
    },
    {
        ...JUNGLE_SET.cards[17],
        id: 'lc_022_en',
        setNumber: 22,
    },
    {
        ...JUNGLE_SET.cards[34],
        id: 'lc_023_en',
        rarity: RARITY_TYPES.RARE,
        setNumber: 23,
    },
    {
        ...FOSSIL_SET.cards[35],
        id: 'lc_024_en',
        rarity: RARITY_TYPES.RARE,
        setNumber: 24,
    },
    {
        ...FOSSIL_SET.cards[22],
        id: 'lc_025_en',
        setNumber: 25,
    },
    {
        ...BASE_SET.cards[30],
        rarity: RARITY_TYPES.RARE,
        id: 'lc_026_en',
        setNumber: 26,
    },
    {
        ...FOSSIL_SET.cards[23],
        id: 'lc_027_en',
        setNumber: 27,
    },
    {
        ...FOSSIL_SET.cards[25],
        id: 'lc_028_en',
        setNumber: 28,
    },
    {
        ...BLACK_STAR_PROMO_SET.cards[11],
        copyright: COPYRIGHTS.LEGENDARY_COLLECTION_SET,
        id: 'lc_029_en',
        rarity: RARITY_TYPES.RARE,
        setNumber: 29,
    },
    {
        ...FOSSIL_SET.cards[26],
        id: 'lc_030_en',
        setNumber: 30,
    },
    {
        ...BASE_SET.cards[10],
        holo: false,
        id: 'lc_031_en',
        setNumber: 31,
    },
    {
        ...JUNGLE_SET.cards[22],
        id: 'lc_032_en',
        setNumber: 32,
    },
    {
        ...JUNGLE_SET.cards[23],
        id: 'lc_033_en',
        setNumber: 33,
    },
    {
        ...BASE_SET.cards[21],
        id: 'lc_034_en',
        setNumber: 34,
    },
    {
        ...JUNGLE_SET.cards[44],
        id: 'lc_035_en',
        rarity: RARITY_TYPES.RARE,
        setNumber: 35,
    },
    {
        ...BASE_SET.cards[22],
        id: 'lc_036_en',
        setNumber: 36,
    },
    {
        ...BASE_SET.cards[23],
        id: 'lc_037_en',
        setNumber: 37,
    },
    {
        ...ROCKET_SET.cards[32],
        id: 'lc_038_en',
        setNumber: 38,
    },
    {
        ...ROCKET_SET.cards[45],
        id: 'lc_039_en',
        setNumber: 39,
    },
    {
        ...BASE_SET.cards[24],
        id: 'lc_040_en',
        setNumber: 40,
    },
    {
        ...JUNGLE_SET.cards[33],
        id: 'lc_041_en',
        setNumber: 41,
    },
    {
        ...JUNGLE_SET.cards[35],
        id: 'lc_042_en',
        setNumber: 42,
    },
    {
        ...FOSSIL_SET.cards[34],
        id: 'lc_043_en',
        setNumber: 43,
    },
    {
        ...FOSSIL_SET.cards[36],
        id: 'lc_044_en',
        setNumber: 44,
    },
    {
        ...BASE_SET.cards[27],
        id: 'lc_045_en',
        setNumber: 45,
    },
    {
        ...BASE_SET.cards[28],
        id: 'lc_046_en',
        setNumber: 46,
    },
    {
        ...BASE_SET.cards[29],
        id: 'lc_047_en',
        setNumber: 47,
    },
    {
        ...FOSSIL_SET.cards[49],
        id: 'lc_048_en',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 48,
    },
    {
        ...BASE_SET.cards[31],
        id: 'lc_049_en',
        setNumber: 49,
    },
    {
        ...BASE_SET.cards[32],
        id: 'lc_050_en',
        setNumber: 50,
    },
    {
        ...BASE_SET.cards[33],
        id: 'lc_051_en',
        setNumber: 51,
    },
    {
        ...BASE_SET.cards[34],
        id: 'lc_052_en',
        setNumber: 52,
    },
    {
        ...JUNGLE_SET.cards[55],
        id: 'lc_053_en',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 53,
    },
    {
        ...BASE_SET.cards[53],
        id: 'lc_054_en',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 54,
    },
    {
        ...JUNGLE_SET.cards[39],
        id: 'lc_055_en',
        setNumber: 55,
    },
    {
        ...BASE_SET.cards[36],
        id: 'lc_056_en',
        setNumber: 56,
    },
    {
        ...FOSSIL_SET.cards[51],
        id: 'lc_057_en',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 57,
    },
    {
        ...FOSSIL_SET.cards[39],
        id: 'lc_058_en',
        setNumber: 58,
    },
    {
        ...JUNGLE_SET.cards[42],
        id: 'lc_059_en',
        setNumber: 59,
    },
    {
        ...JUNGLE_SET.cards[43],
        id: 'lc_060_en',
        setNumber: 60,
    },
    {
        ...BASE_SET.cards[39],
        id: 'lc_061_en',
        setNumber: 61,
    },
    {
        ...FOSSIL_SET.cards[40],
        id: 'lc_062_en',
        setNumber: 62,
    },
    {
        ...FOSSIL_SET.cards[41],
        id: 'lc_063_en',
        setNumber: 63,
    },
    {
        ...JUNGLE_SET.cards[26],
        id: 'lc_064_en',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 64,
    },
    {
        ...JUNGLE_SET.cards[46],
        id: 'lc_065_en',
        setNumber: 65,
    },
    {
        ...FOSSIL_SET.cards[43],
        id: 'lc_066_en',
        setNumber: 66,
    },
    {
        ...BASE_SET.cards[42],
        id: 'lc_067_en',
        setNumber: 67,
    },
    {
        ...BASE_SET.cards[43],
        id: 'lc_068_en',
        setNumber: 68,
    },
    {
        ...BASE_SET.cards[44],
        id: 'lc_069_en',
        setNumber: 69,
    },
    {
        ...BASE_SET.cards[45],
        id: 'lc_070_en',
        setNumber: 70,
    },
    {
        ...BASE_SET.cards[47],
        id: 'lc_071_en',
        setNumber: 71,
    },
    {
        ...BASE_SET.cards[25],
        id: 'lc_072_en',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 72,
    },
    {
        ...BASE_SET.cards[48],
        id: 'lc_073_en',
        setNumber: 73,
    },
    {
        ...JUNGLE_SET.cards[50],
        id: 'lc_074_en',
        setNumber: 74,
    },
    {
        ...JUNGLE_SET.cards[51],
        id: 'lc_075_en',
        setNumber: 75,
    },
    {
        ...FOSSIL_SET.cards[32],
        id: 'lc_076_en',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 76,
    },
    {
        ...FOSSIL_SET.cards[46],
        id: 'lc_077_en',
        setNumber: 77,
    },
    {
        ...FOSSIL_SET.cards[47],
        id: 'lc_078_en',
        setNumber: 78,
    },
    {
        ...BASE_SET.cards[51],
        id: 'lc_079_en',
        setNumber: 79,
    },
    {
        ...BASE_SET.cards[52],
        id: 'lc_080_en',
        setNumber: 80,
    },
    {
        ...JUNGLE_SET.cards[54],
        id: 'lc_081_en',
        setNumber: 81,
    },
    {
        ...JUNGLE_SET.cards[56],
        id: 'lc_082_en',
        setNumber: 82,
    },
    {
        ...BASE_SET.cards[54],
        id: 'lc_083_en',
        setNumber: 83,
    },
    {
        ...BASE_SET.cards[55],
        id: 'lc_084_en',
        setNumber: 84,
    },
    {
        ...BASE_SET.cards[56],
        id: 'lc_085_en',
        setNumber: 85,
    },
    {
        ...JUNGLE_SET.cards[59],
        id: 'lc_086_en',
        setNumber: 86,
    },
    {
        ...BASE_SET.cards[59],
        id: 'lc_087_en',
        setNumber: 87,
    },
    {
        ...FOSSIL_SET.cards[52],
        id: 'lc_088_en',
        setNumber: 88,
    },
    {
        ...BASE_SET.cards[60],
        id: 'lc_089_en',
        setNumber: 89,
    },
    {
        ...JUNGLE_SET.cards[60],
        id: 'lc_090_en',
        setNumber: 90,
    },
    {
        ...BASE_SET.cards[61],
        id: 'lc_091_en',
        setNumber: 91,
    },
    {
        ...BASE_SET.cards[40],
        id: 'lc_092_en',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 92,
    },
    {
        ...FOSSIL_SET.cards[54],
        id: 'lc_093_en',
        setNumber: 93,
    },
    {
        ...JUNGLE_SET.cards[61],
        id: 'lc_094_en',
        setNumber: 94,
    },
    {
        ...BASE_SET.cards[62],
        id: 'lc_095_en',
        setNumber: 95,
    },
    {
        ...FOSSIL_SET.cards[55],
        id: 'lc_096_en',
        setNumber: 96,
    },
    {
        ...BASE_SET.cards[66],
        id: 'lc_097_en',
        setNumber: 97,
    },
    {
        ...BASE_SET.cards[67],
        id: 'lc_098_en',
        setNumber: 98,
    },
    {
        ...BASE_SET.cards[68],
        id: 'lc_099_en',
        setNumber: 99,
    },
    {
        ...ROCKET_SET.cards[80],
        id: 'lc_100_en',
        setNumber: 100,
    },
    {
        ...ROCKET_SET.cards[81],
        id: 'lc_101_en',
        setNumber: 101,
    },
    {
        ...BASE_SET.cards[75],
        id: 'lc_102_en',
        setNumber: 102,
    },
    {
        ...BASE_SET.cards[76],
        id: 'lc_103_en',
        setNumber: 103,
    },
    {
        ...BASE_SET.cards[77],
        id: 'lc_104_en',
        setNumber: 104,
    },
    {
        ...ROCKET_SET.cards[72],
        id: 'lc_105_en',
        setNumber: 105,
    },
    {
        ...ROCKET_SET.cards[73],
        id: 'lc_106_en',
        setNumber: 106,
    },
    {
        ...BASE_SET.cards[80],
        id: 'lc_107_en',
        setNumber: 107,
    },
    {
        ...BASE_SET.cards[90],
        id: 'lc_108_en',
        setNumber: 108,
    },
    {
        ...FOSSIL_SET.cards[61],
        id: 'lc_109_en',
        setNumber: 109,
    },
    {
        ...BASE_SET.cards[93],
        id: 'lc_110_en',
        setNumber: 110,
    },
];
const LEGENDARY_COLLECTION_SET_CARDS = [
    {
        ...BASE_SET.cards[0],
        id: 'lc_001_en_h',
        setNumber: 1,
    },
    {
        ...BASE_SET.cards[0],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_001_en_rh',
        isFullReverseHolo: true,
        setNumber: 1,
    },
    {
        ...FOSSIL_SET.cards[1],
        id: 'lc_002_en_h',
        setNumber: 2,
    },
    {
        ...FOSSIL_SET.cards[1],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_002_en_rh',
        isFullReverseHolo: true,
        setNumber: 2,
    },
    {
        ...BASE_SET.cards[3],
        id: 'lc_003_en_h',
        setNumber: 3,
    },
    {
        ...BASE_SET.cards[3],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_003_en_rh',
        isFullReverseHolo: true,
        setNumber: 3,
    },
    {
        ...BASE_SET.cards[3],
        holo: false,
        id: 'lc_003_en',
        setNumber: 3,
    },
    {
        ...ROCKET_SET.cards[2],
        id: 'lc_004_en_h',
        setNumber: 4,
    },
    {
        ...ROCKET_SET.cards[2],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_004_en_rh',
        isFullReverseHolo: true,
        setNumber: 4,
    },
    {
        ...ROCKET_SET.cards[2],
        holo: false,
        id: 'lc_004_en',
        setNumber: 4,
    },
    {
        ...ROCKET_SET.cards[4],
        id: 'lc_005_en_h',
        setNumber: 5,
    },
    {
        ...ROCKET_SET.cards[4],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_005_en_rh',
        isFullReverseHolo: true,
        setNumber: 5,
    },
    {
        ...ROCKET_SET.cards[41],
        holo: true,
        id: 'lc_006_en_h',
        rarity: RARITY_TYPES.RARE,
        setNumber: 6,
    },
    {
        ...ROCKET_SET.cards[41],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_006_en_rh',
        isFullReverseHolo: true,
        rarity: RARITY_TYPES.RARE,
        setNumber: 6,
    },
    {
        ...ROCKET_SET.cards[82],
        id: 'lc_007_en_h',
        setNumber: 7,
    },
    {
        ...ROCKET_SET.cards[82],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_007_en_rh',
        isFullReverseHolo: true,
        setNumber: 7,
    },
    {
        ...ROCKET_SET.cards[82],
        holo: false,
        id: 'lc_007_en',
        setNumber: 7,
    },
    {
        ...ROCKET_SET.cards[11],
        id: 'lc_008_en_h',
        setNumber: 8,
    },
    {
        ...ROCKET_SET.cards[11],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_008_en_rh',
        isFullReverseHolo: true,
        setNumber: 8,
    },
    {
        ...ROCKET_SET.cards[44],
        holo: true,
        id: 'lc_009_en_h',
        rarity: RARITY_TYPES.RARE,
        setNumber: 9,
    },
    {
        ...ROCKET_SET.cards[44],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_009_en_rh',
        isFullReverseHolo: true,
        rarity: RARITY_TYPES.RARE,
        setNumber: 9,
    },
    {
        ...JUNGLE_SET.cards[2],
        id: 'lc_010_en_h',
        setNumber: 10,
    },
    {
        ...JUNGLE_SET.cards[2],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_010_en_rh',
        isFullReverseHolo: true,
        setNumber: 10,
    },
    {
        ...FOSSIL_SET.cards[4],
        id: 'lc_011_en_h',
        setNumber: 11,
    },
    {
        ...FOSSIL_SET.cards[4],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_011_en_rh',
        isFullReverseHolo: true,
        setNumber: 11,
    },
    {
        ...BASE_SET.cards[5],
        id: 'lc_012_en_h',
        setNumber: 12,
    },
    {
        ...BASE_SET.cards[5],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_012_en_rh',
        isFullReverseHolo: true,
        setNumber: 12,
    },
    {
        ...FOSSIL_SET.cards[6],
        id: 'lc_013_en_h',
        setNumber: 13,
    },
    {
        ...FOSSIL_SET.cards[6],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_013_en_rh',
        isFullReverseHolo: true,
        setNumber: 13,
    },
    {
        ...JUNGLE_SET.cards[3],
        id: 'lc_014_en_h',
        setNumber: 14,
    },
    {
        ...JUNGLE_SET.cards[3],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_014_en_rh',
        isFullReverseHolo: true,
        setNumber: 14,
    },
    {
        ...BASE_SET.cards[7],
        id: 'lc_015_en_h',
        setNumber: 15,
    },
    {
        ...BASE_SET.cards[7],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_015_en_rh',
        isFullReverseHolo: true,
        setNumber: 15,
    },
    {
        ...FOSSIL_SET.cards[12],
        id: 'lc_016_en_h',
        setNumber: 16,
    },
    {
        ...FOSSIL_SET.cards[12],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_016_en_rh',
        isFullReverseHolo: true,
        setNumber: 16,
    },
    {
        ...BASE_SET.cards[11],
        id: 'lc_017_en_h',
        setNumber: 17,
    },
    {
        ...BASE_SET.cards[11],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_017_en_rh',
        isFullReverseHolo: true,
        setNumber: 17,
    },
    {
        ...BASE_SET.cards[14],
        id: 'lc_018_en_h',
        setNumber: 18,
    },
    {
        ...BASE_SET.cards[14],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_018_en_rh',
        isFullReverseHolo: true,
        setNumber: 18,
    },
    {
        ...BASE_SET.cards[15],
        id: 'lc_019_en_h',
        setNumber: 19,
    },
    {
        ...BASE_SET.cards[15],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_019_en_rh',
        isFullReverseHolo: true,
        setNumber: 19,
    },
    {
        ...MAIN_CARDS[0],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_020_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[0],
    {
        ...MAIN_CARDS[1],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_021_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[1],
    {
        ...MAIN_CARDS[2],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_022_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[2],
    {
        ...MAIN_CARDS[3],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_023_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[3],
    {
        ...MAIN_CARDS[4],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_024_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[4],
    {
        ...MAIN_CARDS[5],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_025_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[5],
    {
        ...MAIN_CARDS[6],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_026_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[6],
    {
        ...MAIN_CARDS[7],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_027_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[7],
    {
        ...MAIN_CARDS[8],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_028_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[8],
    {
        ...MAIN_CARDS[9],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_029_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[9],
    {
        ...MAIN_CARDS[10],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_030_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[10],
    {
        ...MAIN_CARDS[11],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_031_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[11],
    {
        ...MAIN_CARDS[12],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_032_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[12],
    {
        ...MAIN_CARDS[13],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_033_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[13],
    {
        ...MAIN_CARDS[14],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_034_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[14],
    {
        ...MAIN_CARDS[15],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_035_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[15],
    {
        ...MAIN_CARDS[16],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_036_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[16],
    {
        ...MAIN_CARDS[17],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_037_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[17],
    {
        ...MAIN_CARDS[18],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_038_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[18],
    {
        ...MAIN_CARDS[19],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_039_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[19],
    {
        ...MAIN_CARDS[20],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_040_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[20],
    {
        ...MAIN_CARDS[21],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_041_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[21],
    {
        ...MAIN_CARDS[22],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_042_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[22],
    {
        ...MAIN_CARDS[23],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_043_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[23],
    {
        ...MAIN_CARDS[24],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_044_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[24],
    {
        ...MAIN_CARDS[25],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_045_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[25],
    {
        ...MAIN_CARDS[26],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_046_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[26],
    {
        ...MAIN_CARDS[27],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_047_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[27],
    {
        ...MAIN_CARDS[28],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_048_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[28],
    {
        ...MAIN_CARDS[29],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_049_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[29],
    {
        ...MAIN_CARDS[30],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_050_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[30],
    {
        ...MAIN_CARDS[31],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_051_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[31],
    {
        ...MAIN_CARDS[32],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_052_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[32],
    {
        ...MAIN_CARDS[33],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_053_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[33],
    {
        ...MAIN_CARDS[34],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_054_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[34],
    {
        ...MAIN_CARDS[35],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_055_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[35],
    {
        ...MAIN_CARDS[36],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_056_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[36],
    {
        ...MAIN_CARDS[37],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_057_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[37],
    {
        ...MAIN_CARDS[38],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_058_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[38],
    {
        ...MAIN_CARDS[39],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_059_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[39],
    {
        ...MAIN_CARDS[40],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_060_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[40],
    {
        ...MAIN_CARDS[41],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_061_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[41],
    {
        ...MAIN_CARDS[42],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_062_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[42],
    {
        ...MAIN_CARDS[43],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_063_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[43],
    {
        ...MAIN_CARDS[44],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_064_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[44],
    {
        ...MAIN_CARDS[45],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_065_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[45],
    {
        ...MAIN_CARDS[46],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_066_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[46],
    {
        ...MAIN_CARDS[47],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_067_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[47],
    {
        ...MAIN_CARDS[48],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_068_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[48],
    {
        ...MAIN_CARDS[49],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_069_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[49],
    {
        ...MAIN_CARDS[50],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_070_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[50],
    {
        ...MAIN_CARDS[51],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_071_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[51],
    {
        ...MAIN_CARDS[52],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_072_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[52],
    {
        ...MAIN_CARDS[53],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_073_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[53],
    {
        ...MAIN_CARDS[54],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_074_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[54],
    {
        ...MAIN_CARDS[55],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_075_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[55],
    {
        ...MAIN_CARDS[56],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_076_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[56],
    {
        ...MAIN_CARDS[57],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_077_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[57],
    {
        ...MAIN_CARDS[58],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_078_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[58],
    {
        ...MAIN_CARDS[59],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_079_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[59],
    {
        ...MAIN_CARDS[60],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_080_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[60],
    {
        ...MAIN_CARDS[61],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_081_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[61],
    {
        ...MAIN_CARDS[62],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_082_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[62],
    {
        ...MAIN_CARDS[63],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_083_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[63],
    {
        ...MAIN_CARDS[64],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_084_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[64],
    {
        ...MAIN_CARDS[65],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_085_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[65],
    {
        ...MAIN_CARDS[66],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_086_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[66],
    {
        ...MAIN_CARDS[67],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_087_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[67],
    {
        ...MAIN_CARDS[68],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_088_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[68],
    {
        ...MAIN_CARDS[69],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_089_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[69],
    {
        ...MAIN_CARDS[70],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_090_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[70],
    {
        ...MAIN_CARDS[71],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_091_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[71],
    {
        ...MAIN_CARDS[72],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_092_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[72],
    {
        ...MAIN_CARDS[73],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_093_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[73],
    {
        ...MAIN_CARDS[74],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_094_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[74],
    {
        ...MAIN_CARDS[75],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_095_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[75],
    {
        ...MAIN_CARDS[76],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_096_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[76],
    {
        ...MAIN_CARDS[77],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_097_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[77],
    {
        ...MAIN_CARDS[78],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_098_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[78],
    {
        ...MAIN_CARDS[79],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_099_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[79],
    {
        ...MAIN_CARDS[80],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_100_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[80],
    {
        ...MAIN_CARDS[81],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_101_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[81],
    {
        ...MAIN_CARDS[82],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_102_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[82],
    {
        ...MAIN_CARDS[83],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_103_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[83],
    {
        ...MAIN_CARDS[84],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_104_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[84],
    {
        ...MAIN_CARDS[85],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_105_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[85],
    {
        ...MAIN_CARDS[86],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_106_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[86],
    {
        ...MAIN_CARDS[87],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_107_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[87],
    {
        ...MAIN_CARDS[88],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_108_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[88],
    {
        ...MAIN_CARDS[89],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_109_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[89],
    {
        ...MAIN_CARDS[90],
        cardTemplate: legendaryReverseTemplate,
        holo: 'reverse',
        id: 'lc_110_en_rh',
        isFullReverseHolo: true,
    },
    MAIN_CARDS[90],
];

const setId$6 = CARD_SETS.LEGENDARY_COLLECTION.value;
const setName$6 = CARD_SETS.LEGENDARY_COLLECTION.label;
const setTotal$5 = LEGENDARY_COLLECTION_SET_TOTAL;
const LEGENDARY_COLLECTION_SET = {
    cardCounts: {
        holoRares: 16,
        rares: 16,
        uncommons: 32,
        commons: 32,
        energies: 6,
    },
    copyright: COPYRIGHTS.LEGENDARY_COLLECTION_SET,
    description: SET_DESCRIPTIONS.LEGENDARY_COLLECTION,
    holoSheetType: CARD_HOLO_SHEETS.STARS,
    id: setId$6,
    imageUrl: 'https://cdn.shopify.com/s/files/1/0840/1659/5249/collections/legendary-collection-cat-bg.jpg',
    name: setName$6,
    packInfo: BOOSTER_PACKS.LEGENDARY_COLLECTION,
    releaseDate: RELEASE_DATES.LEGENDARY_COLLECTION,
    reverseHoloSheetType: CARD_HOLO_SHEETS.FIREWORKS,
    setSymbol: setId$6,
    setTotal: setTotal$5,
    cards: [...LEGENDARY_COLLECTION_SET_CARDS],
    themeDecks: [],
};

const holoStrength$5 = 0.7;
const { ARCANINE: ARCANINE$1, DRAGONAIR: DRAGONAIR$1, DRAGONITE: DRAGONITE$1, EEVEE: EEVEE$5, GENGAR: GENGAR$2, GOLBAT: GOLBAT$4, GROWLITHE: GROWLITHE$3, HAUNTER: HAUNTER$3, PORYGON: PORYGON$2, SCYTHER: SCYTHER$3, } = GEN_1_POKEMON;
const { AMPHAROS: AMPHAROS$2, AZUMARILL, CROCONAW: CROCONAW$1, CROBAT: CROBAT$3, DONPHAN: DONPHAN$1, ESPEON: ESPEON$3, FERALIGATR, FLAAFFY: FLAAFFY$3, HOUNDOUR: HOUNDOUR$6, HOUNDOOM: HOUNDOOM$4, MARILL: MARILL$1, PHANPY: PHANPY$1, PORYGON2: PORYGON2$1, PUPITAR: PUPITAR$3, QUILAVA: QUILAVA$1, SCIZOR: SCIZOR$2, TOGEPI: TOGEPI$2, TOGETIC: TOGETIC$1, TYPHLOSION: TYPHLOSION$1, TYRANITAR: TYRANITAR$4, } = GEN_2_POKEMON;
const { MIRACLE } = SPECIAL_ENERGIES;
const NEO_DESTINY_HOLOS = [
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        evolvesFrom: FLAAFFY$3.name,
        evolutionBoxImageUrl: FLAAFFY$3.images[0].value,
        frameMode: 'dark',
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$5,
        id: 'neo_dest_001_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Dark ${AMPHAROS$2.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: AMPHAROS$2.images[2].value,
        pokemonLevel: null,
        pokemonNumber: AMPHAROS$2.number,
        pokemonType: AMPHAROS$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 1,
        stage: AMPHAROS$2.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: GOLBAT$4.name,
        evolutionBoxImageUrl: GOLBAT$4.images[0].value,
        frameMode: 'dark',
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$5,
        id: 'neo_dest_002_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Dark ${CROBAT$3.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: CROBAT$3.images[1].value,
        pokemonLevel: null,
        pokemonNumber: CROBAT$3.number,
        pokemonType: CROBAT$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 2,
        stage: CROBAT$3.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        evolvesFrom: PHANPY$1.name,
        evolutionBoxImageUrl: PHANPY$1.images[0].value,
        frameMode: 'dark',
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$5,
        id: 'neo_dest_003_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Dark ${DONPHAN$1.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: DONPHAN$1.images[1].value,
        pokemonLevel: null,
        pokemonNumber: DONPHAN$1.number,
        pokemonType: DONPHAN$1.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 3,
        stage: DONPHAN$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        evolvesFrom: EEVEE$5.name,
        evolutionBoxImageUrl: EEVEE$5.images[0].value,
        frameMode: 'dark',
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$5,
        id: 'neo_dest_004_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Dark ${ESPEON$3.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: ESPEON$3.images[2].value,
        pokemonLevel: null,
        pokemonNumber: ESPEON$3.number,
        pokemonType: ESPEON$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 4,
        stage: ESPEON$3.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: CROCONAW$1.name,
        evolutionBoxImageUrl: CROCONAW$1.images[0].value,
        frameMode: 'dark',
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$5,
        id: 'neo_dest_005_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Dark ${FERALIGATR.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: FERALIGATR.images[2].value,
        pokemonLevel: null,
        pokemonNumber: FERALIGATR.number,
        pokemonType: FERALIGATR.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 5,
        stage: FERALIGATR.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        evolvesFrom: HAUNTER$3.name,
        evolutionBoxImageUrl: HAUNTER$3.images[0].value,
        frameMode: 'dark',
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$5,
        id: 'neo_dest_006_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Dark ${GENGAR$2.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: GENGAR$2.images[3].value,
        pokemonLevel: null,
        pokemonNumber: GENGAR$2.number,
        pokemonType: GENGAR$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 6,
        stage: GENGAR$2.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        evolvesFrom: HOUNDOUR$6.name,
        evolutionBoxImageUrl: HOUNDOUR$6.images[0].value,
        frameMode: 'dark',
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$5,
        id: 'neo_dest_007_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Dark ${HOUNDOOM$4.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: HOUNDOOM$4.images[2].value,
        pokemonLevel: null,
        pokemonNumber: HOUNDOOM$4.number,
        pokemonType: HOUNDOOM$4.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 7,
        stage: HOUNDOOM$4.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        evolvesFrom: PORYGON$2.name,
        evolutionBoxImageUrl: PORYGON$2.images[1].value,
        frameMode: 'dark',
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$5,
        id: 'neo_dest_008_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Dark ${PORYGON2$1.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: PORYGON2$1.images[1].value,
        pokemonLevel: null,
        pokemonNumber: PORYGON2$1.number,
        pokemonType: PORYGON2$1.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 8,
        stage: PORYGON2$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.METAL,
        energyWeakness: null,
        evolvesFrom: SCYTHER$3.name,
        evolutionBoxImageUrl: SCYTHER$3.images[0].value,
        frameMode: 'dark',
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$5,
        id: 'neo_dest_009_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Dark ${SCIZOR$2.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: SCIZOR$2.images[2].value,
        pokemonLevel: null,
        pokemonNumber: SCIZOR$2.number,
        pokemonType: SCIZOR$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 9,
        stage: SCIZOR$2.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        evolvesFrom: QUILAVA$1.name,
        evolutionBoxImageUrl: QUILAVA$1.images[0].value,
        frameMode: 'dark',
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$5,
        id: 'neo_dest_010_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Dark ${TYPHLOSION$1.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: TYPHLOSION$1.images[2].value,
        pokemonLevel: null,
        pokemonNumber: TYPHLOSION$1.number,
        pokemonType: TYPHLOSION$1.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 10,
        stage: TYPHLOSION$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        evolvesFrom: PUPITAR$3.name,
        evolutionBoxImageUrl: PUPITAR$3.images[0].value,
        frameMode: 'dark',
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$5,
        id: 'neo_dest_011_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Dark ${TYRANITAR$4.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: TYRANITAR$4.images[1].value,
        pokemonLevel: null,
        pokemonNumber: TYRANITAR$4.number,
        pokemonType: TYRANITAR$4.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 11,
        stage: TYRANITAR$4.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        evolvesFrom: GROWLITHE$3.name,
        evolutionBoxImageUrl: GROWLITHE$3.images[0].value,
        frameMode: 'light',
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$5,
        id: 'neo_dest_012_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Light ${ARCANINE$1.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: ARCANINE$1.images[2].value,
        pokemonLevel: null,
        pokemonNumber: ARCANINE$1.number,
        pokemonType: ARCANINE$1.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 12,
        stage: ARCANINE$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        evolvesFrom: MARILL$1.name,
        evolutionBoxImageUrl: MARILL$1.images[0].value,
        frameMode: 'light',
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$5,
        id: 'neo_dest_013_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Light ${AZUMARILL.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: AZUMARILL.images[1].value,
        pokemonLevel: null,
        pokemonNumber: AZUMARILL.number,
        pokemonType: AZUMARILL.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 13,
        stage: AZUMARILL.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        evolvesFrom: DRAGONAIR$1.name,
        evolutionBoxImageUrl: DRAGONAIR$1.images[0].value,
        frameMode: 'light',
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$5,
        id: 'neo_dest_014_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Light ${DRAGONITE$1.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: DRAGONITE$1.images[2].value,
        pokemonLevel: null,
        pokemonNumber: DRAGONITE$1.number,
        pokemonType: DRAGONITE$1.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 14,
        stage: DRAGONITE$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        evolvesFrom: TOGEPI$2.name,
        evolutionBoxImageUrl: TOGEPI$2.images[0].value,
        frameMode: 'light',
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength$5,
        id: 'neo_dest_014_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Light ${TOGETIC$1.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: TOGETIC$1.images[1].value,
        pokemonLevel: null,
        pokemonNumber: TOGETIC$1.number,
        pokemonType: TOGETIC$1.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 14,
        stage: TOGETIC$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.ENERGY,
        description: MIRACLE.descriptions.default,
        holo: true,
        holoStrength: holoStrength$5,
        id: 'neo_dest_016_en',
        name: MIRACLE.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 16,
        weight: null,
    },
];

const { CHANSEY: CHANSEY$1, DEWGONG: DEWGONG$2, DRAGONAIR, DRATINI, EEVEE: EEVEE$4, EXEGGCUTE, EXEGGUTOR: EXEGGUTOR$2, FLAREON: FLAREON$2, GASTLY: GASTLY$1, GOLDUCK, GROWLITHE: GROWLITHE$2, HAUNTER: HAUNTER$2, HITMONCHAN: HITMONCHAN$1, HITMONLEE: HITMONLEE$1, JIGGLYPUFF: JIGGLYPUFF$3, JOLTEON: JOLTEON$2, MACHAMP: MACHAMP$2, MACHOKE: MACHOKE$2, MACHOP: MACHOP$1, NINETALES: NINETALES$1, OMANYTE: OMANYTE$2, OMASTAR: OMASTAR$3, PORYGON: PORYGON$1, PSYDUCK, SCYTHER: SCYTHER$2, SEEL: SEEL$2, SLOWBRO: SLOWBRO$1, SLOWPOKE, VAPOREON: VAPOREON$1, VENOMOTH: VENOMOTH$2, VENONAT: VENONAT$1, VULPIX, WIGGLYTUFF: WIGGLYTUFF$2, } = GEN_1_POKEMON;
const { MYSTERIOUS_FOSSIL: MYSTERIOUS_FOSSIL$3 } = JUNGLE_FOSSIL_TRAINERS;
const { ARIADOS: ARIADOS$1, CHINCHOU: CHINCHOU$1, CROCONAW, CYNDAQUIL, FLAAFFY: FLAAFFY$2, FORRETRESS: FORRETRESS$4, GIRAFARIG: GIRAFARIG$2, GLIGAR: GLIGAR$1, HERACROSS: HERACROSS$1, HOUNDOUR: HOUNDOUR$5, LANTURN: LANTURN$2, LARVITAR: LARVITAR$1, LEDIAN: LEDIAN$2, LEDYBA: LEDYBA$3, MAGCARGO: MAGCARGO$3, MANTINE: MANTINE$2, MAREEP: MAREEP$2, OCTILLERY: OCTILLERY$1, PHANPY, PILOSWINE: PILOSWINE$4, PINECO: PINECO$4, PUPITAR: PUPITAR$2, REMORAID: REMORAID$1, QUILAVA, SLOWKING: SLOWKING$2, SLUGMA: SLUGMA$3, SPINARAK: SPINARAK$1, SUNFLORA: SUNFLORA$1, SUNKERN: SUNKERN$1, SWINUB: SWINUB$3, TEDDIURSA: TEDDIURSA$3, TOGEPI: TOGEPI$1, TOTODILE, UNOWN_C, UNOWN_G, UNOWN_H, UNOWN_L, UNOWN_P, UNOWN_Q, UNOWN_S, UNOWN_T, UNOWN_V, UNOWN_W, UNOWN_X, UNOWN_Z, URSARING: URSARING$3, } = GEN_2_POKEMON;
const NEO_DESTINY_NON_HOLOS = [
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: SPINARAK$1.name,
        evolutionBoxImageUrl: SPINARAK$1.images[0].value,
        frameMode: 'dark',
        hitPoints: null,
        id: 'neo_dest_017_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Dark ${ARIADOS$1.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: ARIADOS$1.images[1].value,
        pokemonLevel: null,
        pokemonNumber: ARIADOS$1.number,
        pokemonType: ARIADOS$1.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 17,
        stage: ARIADOS$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        evolvesFrom: SLUGMA$3.name,
        evolutionBoxImageUrl: SLUGMA$3.images[0].value,
        frameMode: 'dark',
        hitPoints: null,
        id: 'neo_dest_018_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Dark ${MAGCARGO$3.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: MAGCARGO$3.images[1].value,
        pokemonLevel: null,
        pokemonNumber: MAGCARGO$3.number,
        pokemonType: MAGCARGO$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 18,
        stage: MAGCARGO$3.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: OMANYTE$2.name,
        evolutionBoxImageUrl: OMANYTE$2.images[0].value,
        frameMode: 'dark',
        hitPoints: null,
        id: 'neo_dest_019_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Dark ${OMASTAR$3.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: OMASTAR$3.images[2].value,
        pokemonLevel: null,
        pokemonNumber: OMASTAR$3.number,
        pokemonType: OMASTAR$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 19,
        stage: OMASTAR$3.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        evolvesFrom: SLOWPOKE.name,
        evolutionBoxImageUrl: SLOWPOKE.images[0].value,
        frameMode: 'dark',
        hitPoints: null,
        id: 'neo_dest_020_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Dark ${SLOWKING$2.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: SLOWKING$2.images[2].value,
        pokemonLevel: null,
        pokemonNumber: SLOWKING$2.number,
        pokemonType: SLOWKING$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 20,
        stage: SLOWKING$2.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        evolvesFrom: TEDDIURSA$3.name,
        evolutionBoxImageUrl: TEDDIURSA$3.images[0].value,
        frameMode: 'dark',
        hitPoints: null,
        id: 'neo_dest_021_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Dark ${URSARING$3.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: URSARING$3.images[1].value,
        pokemonLevel: null,
        pokemonNumber: URSARING$3.number,
        pokemonType: URSARING$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 21,
        stage: URSARING$3.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        evolvesFrom: DRATINI.name,
        evolutionBoxImageUrl: DRATINI.images[0].value,
        frameMode: 'light',
        hitPoints: null,
        id: 'neo_dest_022_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Light ${DRAGONAIR.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: DRAGONAIR.images[3].value,
        pokemonLevel: null,
        pokemonNumber: DRAGONAIR.number,
        pokemonType: DRAGONAIR.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 22,
        stage: DRAGONAIR.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        evolvesFrom: CHINCHOU$1.name,
        evolutionBoxImageUrl: CHINCHOU$1.images[0].value,
        frameMode: 'light',
        hitPoints: null,
        id: 'neo_dest_023_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Light ${LANTURN$2.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: LANTURN$2.images[2].value,
        pokemonLevel: null,
        pokemonNumber: LANTURN$2.number,
        pokemonType: LANTURN$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 23,
        stage: LANTURN$2.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: LEDYBA$3.name,
        evolutionBoxImageUrl: LEDYBA$3.images[0].value,
        frameMode: 'light',
        hitPoints: null,
        id: 'neo_dest_024_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Light ${LEDIAN$2.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: LEDIAN$2.images[1].value,
        pokemonLevel: null,
        pokemonNumber: LEDIAN$2.number,
        pokemonType: LEDIAN$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 24,
        stage: LEDIAN$2.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        evolvesFrom: MACHOKE$2.name,
        evolutionBoxImageUrl: MACHOKE$2.images[0].value,
        frameMode: 'light',
        hitPoints: null,
        id: 'neo_dest_025_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Light ${MACHAMP$2.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: MACHAMP$2.images[3].value,
        pokemonLevel: null,
        pokemonNumber: MACHAMP$2.number,
        pokemonType: MACHAMP$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 25,
        stage: MACHAMP$2.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: SWINUB$3.name,
        evolutionBoxImageUrl: SWINUB$3.images[0].value,
        frameMode: 'light',
        hitPoints: null,
        id: 'neo_dest_026_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Light ${PILOSWINE$4.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: PILOSWINE$4.images[1].value,
        pokemonLevel: null,
        pokemonNumber: PILOSWINE$4.number,
        pokemonType: PILOSWINE$4.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 26,
        stage: PILOSWINE$4.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.UNOWN,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: null,
        id: 'neo_dest_027_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: UNOWN_G.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: UNOWN_G.images[0].value,
        pokemonLevel: null,
        pokemonNumber: UNOWN_G.number,
        pokemonType: UNOWN_G.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 27,
        unownLetter: 'G',
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.UNOWN,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: null,
        id: 'neo_dest_028_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: UNOWN_H.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: UNOWN_H.images[0].value,
        pokemonLevel: null,
        pokemonNumber: UNOWN_H.number,
        pokemonType: UNOWN_H.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 28,
        unownLetter: 'H',
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.UNOWN,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: null,
        id: 'neo_dest_029_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: UNOWN_W.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: UNOWN_W.images[0].value,
        pokemonLevel: null,
        pokemonNumber: UNOWN_W.number,
        pokemonType: UNOWN_W.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 29,
        unownLetter: 'W',
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.UNOWN,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: null,
        id: 'neo_dest_030_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: UNOWN_X.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: UNOWN_X.images[0].value,
        pokemonLevel: null,
        pokemonNumber: UNOWN_X.number,
        pokemonType: UNOWN_X.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 30,
        unownLetter: 'X',
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: null,
        id: 'neo_dest_031_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: CHANSEY$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: CHANSEY$1.images[1].value,
        pokemonLevel: null,
        pokemonNumber: CHANSEY$1.number,
        pokemonType: CHANSEY$1.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 31,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: TOTODILE.name,
        evolutionBoxImageUrl: TOTODILE.images[0].value,
        frameMode: 'dark',
        hitPoints: null,
        id: 'neo_dest_032_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Dark ${CROCONAW.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: CROCONAW.images[2].value,
        pokemonLevel: null,
        pokemonNumber: CROCONAW.number,
        pokemonType: CROCONAW.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 32,
        stage: CROCONAW.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        evolvesFrom: EXEGGCUTE.name,
        evolutionBoxImageUrl: EXEGGCUTE.images[0].value,
        frameMode: 'dark',
        hitPoints: null,
        id: 'neo_dest_033_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Dark ${EXEGGUTOR$2.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: EXEGGUTOR$2.images[3].value,
        pokemonLevel: null,
        pokemonNumber: EXEGGUTOR$2.number,
        pokemonType: EXEGGUTOR$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 33,
        stage: EXEGGUTOR$2.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        evolvesFrom: MAREEP$2.name,
        evolutionBoxImageUrl: MAREEP$2.images[0].value,
        frameMode: 'dark',
        hitPoints: null,
        id: 'neo_dest_034_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Dark ${FLAAFFY$2.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: FLAAFFY$2.images[2].value,
        pokemonLevel: null,
        pokemonNumber: FLAAFFY$2.number,
        pokemonType: FLAAFFY$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 34,
        stage: FLAAFFY$2.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: PINECO$4.name,
        evolutionBoxImageUrl: PINECO$4.images[0].value,
        frameMode: 'dark',
        hitPoints: null,
        id: 'neo_dest_035_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Dark ${FORRETRESS$4.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: FORRETRESS$4.images[1].value,
        pokemonLevel: null,
        pokemonNumber: FORRETRESS$4.number,
        pokemonType: FORRETRESS$4.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 35,
        stage: FORRETRESS$4.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        evolvesFrom: GASTLY$1.name,
        evolutionBoxImageUrl: GASTLY$1.images[0].value,
        frameMode: 'dark',
        hitPoints: null,
        id: 'neo_dest_036_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Dark ${HAUNTER$2.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: HAUNTER$2.images[4].value,
        pokemonLevel: null,
        pokemonNumber: HAUNTER$2.number,
        pokemonType: HAUNTER$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 36,
        stage: HAUNTER$2.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: MYSTERIOUS_FOSSIL$3.name,
        evolutionBoxImageUrl: MYSTERIOUS_FOSSIL$3.image,
        frameMode: 'dark',
        hitPoints: null,
        id: 'neo_dest_037_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Dark ${OMANYTE$2.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: OMANYTE$2.images[2].value,
        pokemonLevel: null,
        pokemonNumber: OMANYTE$2.number,
        pokemonType: OMANYTE$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 37,
        stage: OMANYTE$2.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        evolvesFrom: LARVITAR$1.name,
        evolutionBoxImageUrl: LARVITAR$1.images[0].value,
        frameMode: 'dark',
        hitPoints: null,
        id: 'neo_dest_038_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Dark ${PUPITAR$2.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: PUPITAR$2.images[1].value,
        pokemonLevel: null,
        pokemonNumber: PUPITAR$2.number,
        pokemonType: PUPITAR$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 38,
        stage: PUPITAR$2.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        evolvesFrom: CYNDAQUIL.name,
        evolutionBoxImageUrl: CYNDAQUIL.images[0].value,
        frameMode: 'dark',
        hitPoints: null,
        id: 'neo_dest_039_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Dark ${QUILAVA.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: QUILAVA.images[2].value,
        pokemonLevel: null,
        pokemonNumber: QUILAVA.number,
        pokemonType: QUILAVA.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 39,
        stage: QUILAVA.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        evolvesFrom: JIGGLYPUFF$3.name,
        evolutionBoxImageUrl: JIGGLYPUFF$3.images[0].value,
        frameMode: 'dark',
        hitPoints: null,
        id: 'neo_dest_040_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Dark ${WIGGLYTUFF$2.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: WIGGLYTUFF$2.images[1].value,
        pokemonLevel: null,
        pokemonNumber: WIGGLYTUFF$2.number,
        pokemonType: WIGGLYTUFF$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 40,
        stage: WIGGLYTUFF$2.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'neo_dest_041_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: HERACROSS$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: HERACROSS$1.images[1].value,
        pokemonLevel: null,
        pokemonNumber: HERACROSS$1.number,
        pokemonType: HERACROSS$1.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 41,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        hitPoints: null,
        id: 'neo_dest_042_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: HITMONLEE$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: HITMONLEE$1.images[1].value,
        pokemonLevel: null,
        pokemonNumber: HITMONLEE$1.number,
        pokemonType: HITMONLEE$1.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 42,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.DARKNESS,
        energyWeakness: null,
        hitPoints: null,
        id: 'neo_dest_043_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: HOUNDOUR$5.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: HOUNDOUR$5.images[3].value,
        pokemonLevel: null,
        pokemonNumber: HOUNDOUR$5.number,
        pokemonType: HOUNDOUR$5.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 43,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: null,
        id: 'neo_dest_044_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: JIGGLYPUFF$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: JIGGLYPUFF$3.images[5].value,
        pokemonLevel: null,
        pokemonNumber: JIGGLYPUFF$3.number,
        pokemonType: JIGGLYPUFF$3.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 44,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: SEEL$2.name,
        evolutionBoxImageUrl: SEEL$2.images[0].value,
        frameMode: 'light',
        hitPoints: null,
        id: 'neo_dest_045_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Light ${DEWGONG$2.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: DEWGONG$2.images[1].value,
        pokemonLevel: null,
        pokemonNumber: DEWGONG$2.number,
        pokemonType: DEWGONG$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 45,
        stage: DEWGONG$2.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        evolvesFrom: EEVEE$4.name,
        evolutionBoxImageUrl: EEVEE$4.images[0].value,
        frameMode: 'light',
        hitPoints: null,
        id: 'neo_dest_046_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Light ${FLAREON$2.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: FLAREON$2.images[1].value,
        pokemonLevel: null,
        pokemonNumber: FLAREON$2.number,
        pokemonType: FLAREON$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 46,
        stage: FLAREON$2.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        evolvesFrom: PSYDUCK.name,
        evolutionBoxImageUrl: PSYDUCK.images[0].value,
        frameMode: 'light',
        hitPoints: null,
        id: 'neo_dest_047_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Light ${GOLDUCK.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: GOLDUCK.images[4].value,
        pokemonLevel: null,
        pokemonNumber: GOLDUCK.number,
        pokemonType: GOLDUCK.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 47,
        stage: GOLDUCK.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        evolvesFrom: EEVEE$4.name,
        evolutionBoxImageUrl: EEVEE$4.images[0].value,
        frameMode: 'light',
        hitPoints: null,
        id: 'neo_dest_048_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Light ${JOLTEON$2.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: JOLTEON$2.images[1].value,
        pokemonLevel: null,
        pokemonNumber: JOLTEON$2.number,
        pokemonType: JOLTEON$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 48,
        stage: JOLTEON$2.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        evolvesFrom: MACHOP$1.name,
        evolutionBoxImageUrl: MACHOP$1.images[0].value,
        frameMode: 'light',
        hitPoints: null,
        id: 'neo_dest_049_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Light ${MACHOKE$2.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: MACHOKE$2.images[3].value,
        pokemonLevel: null,
        pokemonNumber: MACHOKE$2.number,
        pokemonType: MACHOKE$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 49,
        stage: MACHOKE$2.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        evolvesFrom: VULPIX.name,
        evolutionBoxImageUrl: VULPIX.images[0].value,
        frameMode: 'light',
        hitPoints: null,
        id: 'neo_dest_050_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Light ${NINETALES$1.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: NINETALES$1.images[2].value,
        pokemonLevel: null,
        pokemonNumber: NINETALES$1.number,
        pokemonType: NINETALES$1.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 50,
        stage: NINETALES$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        evolvesFrom: SLOWPOKE.name,
        evolutionBoxImageUrl: SLOWPOKE.images[0].value,
        frameMode: 'light',
        hitPoints: null,
        id: 'neo_dest_051_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Light ${SLOWBRO$1.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: SLOWBRO$1.images[3].value,
        pokemonLevel: null,
        pokemonNumber: SLOWBRO$1.number,
        pokemonType: SLOWBRO$1.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 51,
        stage: SLOWBRO$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: EEVEE$4.name,
        evolutionBoxImageUrl: EEVEE$4.images[0].value,
        frameMode: 'light',
        hitPoints: null,
        id: 'neo_dest_052_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Light ${VAPOREON$1.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: VAPOREON$1.images[2].value,
        pokemonLevel: null,
        pokemonNumber: VAPOREON$1.number,
        pokemonType: VAPOREON$1.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 52,
        stage: VAPOREON$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: VENONAT$1.name,
        evolutionBoxImageUrl: VENONAT$1.images[0].value,
        frameMode: 'light',
        hitPoints: null,
        id: 'neo_dest_053_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Light ${VENOMOTH$2.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: VENOMOTH$2.images[2].value,
        pokemonLevel: null,
        pokemonNumber: VENOMOTH$2.number,
        pokemonType: VENOMOTH$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 53,
        stage: VENOMOTH$2.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        evolvesFrom: JIGGLYPUFF$3.name,
        evolutionBoxImageUrl: JIGGLYPUFF$3.images[0].value,
        frameMode: 'light',
        hitPoints: null,
        id: 'neo_dest_054_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Light ${WIGGLYTUFF$2.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: WIGGLYTUFF$2.images[1].value,
        pokemonLevel: null,
        pokemonNumber: WIGGLYTUFF$2.number,
        pokemonType: WIGGLYTUFF$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 54,
        stage: WIGGLYTUFF$2.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'neo_dest_055_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: SCYTHER$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: SCYTHER$2.images[3].value,
        pokemonLevel: null,
        pokemonNumber: SCYTHER$2.number,
        pokemonType: SCYTHER$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 55,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: null,
        id: 'neo_dest_056_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: TOGEPI$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: TOGEPI$1.images[3].value,
        pokemonLevel: null,
        pokemonNumber: TOGEPI$1.number,
        pokemonType: TOGEPI$1.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 56,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.UNOWN,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: null,
        id: 'neo_dest_057_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: UNOWN_C.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: UNOWN_C.images[0].value,
        pokemonLevel: null,
        pokemonNumber: UNOWN_C.number,
        pokemonType: UNOWN_C.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 57,
        unownLetter: 'C',
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.UNOWN,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: null,
        id: 'neo_dest_058_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: UNOWN_P.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: UNOWN_P.images[0].value,
        pokemonLevel: null,
        pokemonNumber: UNOWN_P.number,
        pokemonType: UNOWN_P.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 58,
        unownLetter: 'P',
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.UNOWN,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: null,
        id: 'neo_dest_059_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: UNOWN_Q.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: UNOWN_Q.images[0].value,
        pokemonLevel: null,
        pokemonNumber: UNOWN_Q.number,
        pokemonType: UNOWN_Q.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 59,
        unownLetter: 'Q',
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.UNOWN,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: null,
        id: 'neo_dest_060_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: UNOWN_Z.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: UNOWN_Z.images[0].value,
        pokemonLevel: null,
        pokemonNumber: UNOWN_Z.number,
        pokemonType: UNOWN_Z.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 60,
        unownLetter: 'Z',
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        hitPoints: null,
        id: 'neo_dest_061_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: CYNDAQUIL.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: CYNDAQUIL.images[0].value,
        pokemonLevel: null,
        pokemonNumber: CYNDAQUIL.number,
        pokemonType: CYNDAQUIL.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 61,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: REMORAID$1.name,
        evolutionBoxImageUrl: REMORAID$1.images[0].value,
        frameMode: 'dark',
        hitPoints: null,
        id: 'neo_dest_062_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Dark ${OCTILLERY$1.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: OCTILLERY$1.images[1].value,
        pokemonLevel: null,
        pokemonNumber: OCTILLERY$1.number,
        pokemonType: OCTILLERY$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 62,
        stage: OCTILLERY$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: null,
        id: 'neo_dest_063_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: DRATINI.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: DRATINI.images[2].value,
        pokemonLevel: null,
        pokemonNumber: DRATINI.number,
        pokemonType: DRATINI.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 63,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: null,
        id: 'neo_dest_064_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: EXEGGCUTE.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: EXEGGCUTE.images[4].value,
        pokemonLevel: null,
        pokemonNumber: EXEGGCUTE.number,
        pokemonType: EXEGGCUTE.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 64,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: null,
        id: 'neo_dest_065_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: GASTLY$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: GASTLY$1.images[5].value,
        pokemonLevel: null,
        pokemonNumber: GASTLY$1.number,
        pokemonType: GASTLY$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 65,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: null,
        id: 'neo_dest_066_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: GIRAFARIG$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: GIRAFARIG$2.images[1].value,
        pokemonLevel: null,
        pokemonNumber: GIRAFARIG$2.number,
        pokemonType: GIRAFARIG$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 66,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'neo_dest_067_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: GLIGAR$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: GLIGAR$1.images[1].value,
        pokemonLevel: null,
        pokemonNumber: GLIGAR$1.number,
        pokemonType: GLIGAR$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 67,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        hitPoints: null,
        id: 'neo_dest_068_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: GROWLITHE$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: GROWLITHE$2.images[4].value,
        pokemonLevel: null,
        pokemonNumber: GROWLITHE$2.number,
        pokemonType: GROWLITHE$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 68,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        hitPoints: null,
        id: 'neo_dest_069_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: HITMONCHAN$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: HITMONCHAN$1.images[2].value,
        pokemonLevel: null,
        pokemonNumber: HITMONCHAN$1.number,
        pokemonType: HITMONCHAN$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 69,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        hitPoints: null,
        id: 'neo_dest_070_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: LARVITAR$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: LARVITAR$1.images[2].value,
        pokemonLevel: null,
        pokemonNumber: LARVITAR$1.number,
        pokemonType: LARVITAR$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 70,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'neo_dest_071_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: LEDYBA$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: LEDYBA$3.images[1].value,
        pokemonLevel: null,
        pokemonNumber: LEDYBA$3.number,
        pokemonType: LEDYBA$3.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 71,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: SUNKERN$1.name,
        evolutionBoxImageUrl: SUNKERN$1.images[0].value,
        frameMode: 'light',
        hitPoints: null,
        id: 'neo_dest_072_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: `Light ${SUNFLORA$1.name}`,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: SUNFLORA$1.images[1].value,
        pokemonLevel: null,
        pokemonNumber: SUNFLORA$1.number,
        pokemonType: SUNFLORA$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 72,
        stage: SUNFLORA$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        hitPoints: null,
        id: 'neo_dest_073_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: MACHOP$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: MACHOP$1.images[3].value,
        pokemonLevel: null,
        pokemonNumber: MACHOP$1.number,
        pokemonType: MACHOP$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 73,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: null,
        id: 'neo_dest_074_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: MANTINE$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: MANTINE$2.images[1].value,
        pokemonLevel: null,
        pokemonNumber: MANTINE$2.number,
        pokemonType: MANTINE$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 74,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        hitPoints: null,
        id: 'neo_dest_075_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: MAREEP$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: MAREEP$2.images[2].value,
        pokemonLevel: null,
        pokemonNumber: MAREEP$2.number,
        pokemonType: MAREEP$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 75,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        hitPoints: null,
        id: 'neo_dest_076_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: PHANPY.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: PHANPY.images[1].value,
        pokemonLevel: null,
        pokemonNumber: PHANPY.number,
        pokemonType: PHANPY.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 76,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'neo_dest_077_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: PINECO$4.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: PINECO$4.images[2].value,
        pokemonLevel: null,
        pokemonNumber: PINECO$4.number,
        pokemonType: PINECO$4.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 77,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: null,
        id: 'neo_dest_078_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: PORYGON$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: PORYGON$1.images[3].value,
        pokemonLevel: null,
        pokemonNumber: PORYGON$1.number,
        pokemonType: PORYGON$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 78,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: null,
        id: 'neo_dest_079_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: PSYDUCK.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: PSYDUCK.images[3].value,
        pokemonLevel: null,
        pokemonNumber: PSYDUCK.number,
        pokemonType: PSYDUCK.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 79,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: null,
        id: 'neo_dest_080_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: REMORAID$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: REMORAID$1.images[2].value,
        pokemonLevel: null,
        pokemonNumber: REMORAID$1.number,
        pokemonType: REMORAID$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 80,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: null,
        id: 'neo_dest_081_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: SEEL$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: SEEL$2.images[3].value,
        pokemonLevel: null,
        pokemonNumber: SEEL$2.number,
        pokemonType: SEEL$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 81,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        hitPoints: null,
        id: 'neo_dest_082_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: SLUGMA$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: SLUGMA$3.images[1].value,
        pokemonLevel: null,
        pokemonNumber: SLUGMA$3.number,
        pokemonType: SLUGMA$3.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 82,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'neo_dest_083_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: SUNKERN$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: SUNKERN$1.images[1].value,
        pokemonLevel: null,
        pokemonNumber: SUNKERN$1.number,
        pokemonType: SUNKERN$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 83,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: null,
        id: 'neo_dest_084_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: SWINUB$3.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: SWINUB$3.images[2].value,
        pokemonLevel: null,
        pokemonNumber: SWINUB$3.number,
        pokemonType: SWINUB$3.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 84,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: null,
        id: 'neo_dest_085_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: TOTODILE.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: TOTODILE.images[2].value,
        pokemonLevel: null,
        pokemonNumber: TOTODILE.number,
        pokemonType: TOTODILE.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 85,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.UNOWN,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: null,
        id: 'neo_dest_086_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: UNOWN_L.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: UNOWN_L.images[0].value,
        pokemonLevel: null,
        pokemonNumber: UNOWN_L.number,
        pokemonType: UNOWN_L.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 86,
        unownLetter: 'L',
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.UNOWN,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: null,
        id: 'neo_dest_087_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: UNOWN_S.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: UNOWN_S.images[0].value,
        pokemonLevel: null,
        pokemonNumber: UNOWN_S.number,
        pokemonType: UNOWN_S.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 87,
        unownLetter: 'S',
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.UNOWN,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: null,
        id: 'neo_dest_088_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: UNOWN_T.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: UNOWN_T.images[0].value,
        pokemonLevel: null,
        pokemonNumber: UNOWN_T.number,
        pokemonType: UNOWN_T.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 88,
        unownLetter: 'T',
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.UNOWN,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: null,
        id: 'neo_dest_089_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: UNOWN_V.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: UNOWN_V.images[0].value,
        pokemonLevel: null,
        pokemonNumber: UNOWN_V.number,
        pokemonType: UNOWN_V.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 89,
        unownLetter: 'V',
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'neo_dest_090_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: VENONAT$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: VENONAT$1.images[3].value,
        pokemonLevel: null,
        pokemonNumber: VENONAT$1.number,
        pokemonType: VENONAT$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 90,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        hitPoints: null,
        id: 'neo_dest_091_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: VULPIX.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: VULPIX.images[3].value,
        pokemonLevel: null,
        pokemonNumber: VULPIX.number,
        pokemonType: VULPIX.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 91,
        weight: null,
    },
];

const { CHARIZARD: CHARIZARD$2, KABUTOPS: KABUTOPS$3, MEWTWO, RAICHU: RAICHU$3 } = GEN_1_POKEMON;
const { CELEBI: CELEBI$3, NOCTOWL: NOCTOWL$2, STEELIX: STEELIX$2, TYRANITAR: TYRANITAR$3 } = GEN_2_POKEMON;
const NEO_DESTINY_SHININGS = [
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.SHINING,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: 40,
        holo: true,
        holoSheetType: CARD_HOLO_SHEETS.SHINING,
        holoStrength: 0.2,
        id: 'neo_dest_106_en',
        illustrator: null,
        isShining: true,
        lengthFeet: 2,
        lengthInches: 0,
        moves: [],
        name: `Shining ${CELEBI$3.name}`,
        pokemonImagePositionX: 10,
        pokemonImagePositionY: 99,
        pokemonImageSize: 66,
        pokemonImageUrl: CELEBI$3.images[2].value,
        pokemonLevel: 14,
        pokemonNumber: CELEBI$3.number,
        pokemonType: CELEBI$3.pokemonType,
        rarity: RARITY_TYPES.SHINING,
        setNumber: 106,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.SHINING,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        hitPoints: 40,
        holo: true,
        holoSheetType: CARD_HOLO_SHEETS.SHINING,
        holoStrength: 0.2,
        id: 'neo_dest_107_en',
        illustrator: null,
        isShining: true,
        lengthFeet: 2,
        lengthInches: 0,
        moves: [],
        name: `Shining ${CHARIZARD$2.name}`,
        pokemonImagePositionX: 10,
        pokemonImagePositionY: 99,
        pokemonImageSize: 66,
        pokemonImageUrl: CHARIZARD$2.images[3].value,
        pokemonLevel: 14,
        pokemonNumber: CHARIZARD$2.number,
        pokemonType: CHARIZARD$2.pokemonType,
        rarity: RARITY_TYPES.SHINING,
        setNumber: 107,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.SHINING,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        hitPoints: 40,
        holo: true,
        holoSheetType: CARD_HOLO_SHEETS.SHINING,
        holoStrength: 0.2,
        id: 'neo_dest_108_en',
        illustrator: null,
        isShining: true,
        lengthFeet: 2,
        lengthInches: 0,
        moves: [],
        name: `Shining ${KABUTOPS$3.name}`,
        pokemonImagePositionX: 10,
        pokemonImagePositionY: 99,
        pokemonImageSize: 66,
        pokemonImageUrl: KABUTOPS$3.images[2].value,
        pokemonLevel: 14,
        pokemonNumber: KABUTOPS$3.number,
        pokemonType: KABUTOPS$3.pokemonType,
        rarity: RARITY_TYPES.SHINING,
        setNumber: 108,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.SHINING,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: 40,
        holo: true,
        holoSheetType: CARD_HOLO_SHEETS.SHINING,
        holoStrength: 0.2,
        id: 'neo_dest_109_en',
        illustrator: null,
        isShining: true,
        lengthFeet: 2,
        lengthInches: 0,
        moves: [],
        name: `Shining ${MEWTWO.name}`,
        pokemonImagePositionX: 10,
        pokemonImagePositionY: 99,
        pokemonImageSize: 66,
        pokemonImageUrl: MEWTWO.images[2].value,
        pokemonLevel: 14,
        pokemonNumber: MEWTWO.number,
        pokemonType: MEWTWO.pokemonType,
        rarity: RARITY_TYPES.SHINING,
        setNumber: 109,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.SHINING,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: 40,
        holo: true,
        holoSheetType: CARD_HOLO_SHEETS.SHINING,
        holoStrength: 0.2,
        id: 'neo_dest_110_en',
        illustrator: null,
        isShining: true,
        lengthFeet: 2,
        lengthInches: 0,
        moves: [],
        name: `Shining ${NOCTOWL$2.name}`,
        pokemonImagePositionX: 10,
        pokemonImagePositionY: 99,
        pokemonImageSize: 66,
        pokemonImageUrl: NOCTOWL$2.images[1].value,
        pokemonLevel: 14,
        pokemonNumber: NOCTOWL$2.number,
        pokemonType: NOCTOWL$2.pokemonType,
        rarity: RARITY_TYPES.SHINING,
        setNumber: 110,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.SHINING,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        hitPoints: 40,
        holo: true,
        holoSheetType: CARD_HOLO_SHEETS.SHINING,
        holoStrength: 0.2,
        id: 'neo_dest_111_en',
        illustrator: null,
        isShining: true,
        lengthFeet: 2,
        lengthInches: 0,
        moves: [],
        name: `Shining ${RAICHU$3.name}`,
        pokemonImagePositionX: 10,
        pokemonImagePositionY: 99,
        pokemonImageSize: 66,
        pokemonImageUrl: RAICHU$3.images[6].value,
        pokemonLevel: 14,
        pokemonNumber: RAICHU$3.number,
        pokemonType: RAICHU$3.pokemonType,
        rarity: RARITY_TYPES.SHINING,
        setNumber: 111,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.SHINING,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.METAL,
        energyWeakness: null,
        hitPoints: 40,
        holo: true,
        holoSheetType: CARD_HOLO_SHEETS.SHINING,
        holoStrength: 0.2,
        id: 'neo_dest_112_en',
        illustrator: null,
        isShining: true,
        lengthFeet: 2,
        lengthInches: 0,
        moves: [],
        name: `Shining ${STEELIX$2.name}`,
        pokemonImagePositionX: 10,
        pokemonImagePositionY: 99,
        pokemonImageSize: 66,
        pokemonImageUrl: STEELIX$2.images[1].value,
        pokemonLevel: 14,
        pokemonNumber: STEELIX$2.number,
        pokemonType: STEELIX$2.pokemonType,
        rarity: RARITY_TYPES.SHINING,
        setNumber: 112,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.SHINING,
        description: '',
        energyResistance: ENERGY_TYPES.PSYCHIC,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.DARKNESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 40,
        holo: true,
        holoSheetType: CARD_HOLO_SHEETS.SHINING,
        holoStrength: 0.2,
        id: 'neo_dest_113_en',
        illustrator: null,
        lengthFeet: 2,
        lengthInches: 0,
        moves: [],
        name: `Shining ${TYRANITAR$3.name}`,
        pokemonImagePositionX: 10,
        pokemonImagePositionY: 99,
        pokemonImageSize: 66,
        pokemonImageUrl: TYRANITAR$3.images[2].value,
        pokemonLevel: 14,
        pokemonNumber: TYRANITAR$3.number,
        pokemonType: TYRANITAR$3.pokemonType,
        rarity: RARITY_TYPES.SHINING,
        setNumber: 113,
        weight: null,
    },
];

const { BROKEN_GROUND_GYM, COUNTERATTACK_CLAWS, ENERGY_AMPLIFIER, ENERGY_STADIUM, EXP_ALL, HEAL_POWDER, IMPOSTOR_PROFESSOR_OAKS_INVENTION, LUCKY_STADIUM, MAGNIFIER, MAIL_FROM_BILL, POKEMON_PERSONALITY_TEST, RADIO_TOWER, TEAM_ROCKETS_EVIL_DEEDS, THOUGHT_WAVE_MACHINE, } = NEO_TRAINERS;
const NEO_DESTINY_TRAINERS = [
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'neo_dest_092_en',
        illustrator: null,
        name: BROKEN_GROUND_GYM.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 92,
        subtitle: TRAINER_CARD_SUBTITLES.STADIUM_CARD,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'neo_dest_093_en',
        illustrator: null,
        name: EXP_ALL.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 93,
        subtitle: TRAINER_CARD_SUBTITLES.POKEMON_TOOL,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'neo_dest_094_en',
        illustrator: null,
        name: IMPOSTOR_PROFESSOR_OAKS_INVENTION.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 94,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'neo_dest_095_en',
        illustrator: null,
        name: RADIO_TOWER.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 95,
        subtitle: TRAINER_CARD_SUBTITLES.STADIUM_CARD,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'neo_dest_096_en',
        illustrator: null,
        name: THOUGHT_WAVE_MACHINE.name,
        rarity: RARITY_TYPES.RARE,
        setNumber: 96,
        subtitle: TRAINER_CARD_SUBTITLES.ROCKETS_SECRET_MACHINE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'neo_dest_097_en',
        illustrator: null,
        name: COUNTERATTACK_CLAWS.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 97,
        subtitle: TRAINER_CARD_SUBTITLES.POKEMON_TOOL,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'neo_dest_098_en',
        illustrator: null,
        name: ENERGY_AMPLIFIER.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 98,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'neo_dest_099_en',
        illustrator: null,
        name: ENERGY_STADIUM.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 99,
        subtitle: TRAINER_CARD_SUBTITLES.STADIUM_CARD,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'neo_dest_100_en',
        illustrator: null,
        name: LUCKY_STADIUM.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 100,
        subtitle: TRAINER_CARD_SUBTITLES.STADIUM_CARD,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'neo_dest_101_en',
        illustrator: null,
        name: MAGNIFIER.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 101,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'neo_dest_102_en',
        illustrator: null,
        name: POKEMON_PERSONALITY_TEST.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 102,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'neo_dest_103_en',
        illustrator: null,
        name: TEAM_ROCKETS_EVIL_DEEDS.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 103,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'neo_dest_104_en',
        illustrator: null,
        name: HEAL_POWDER.name,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 104,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'neo_dest_105_en',
        illustrator: null,
        name: MAIL_FROM_BILL.name,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 105,
    },
];

const setId$5 = CARD_SETS.NEO_DESTINY.value;
const setName$5 = CARD_SETS.NEO_DESTINY.label;
const setTotal$4 = NEO_DESTINY_SET_TOTAL;
const NEO_DESTINY_SET = {
    cardCounts: {
        secretRares: 8,
        holoRares: 16,
        rares: 19,
        uncommons: 37,
        commons: 33,
    },
    copyright: COPYRIGHTS.NEO_SET,
    description: SET_DESCRIPTIONS.NEO_DESTINY,
    holoSheetType: CARD_HOLO_SHEETS.COSMOS_2,
    id: setId$5,
    imageUrl: 'https://cdn.shopify.com/s/files/1/0840/1659/5249/collections/neo-destiny-cat-bg.jpg',
    name: setName$5,
    packInfo: BOOSTER_PACKS.NEO_DESTINY,
    releaseDate: RELEASE_DATES.NEO_DESTINY,
    reverseHoloSheetType: CARD_HOLO_SHEETS.COSMOS_2,
    setSymbol: setId$5,
    setTotal: setTotal$4,
    cards: [
        ...NEO_DESTINY_HOLOS,
        ...NEO_DESTINY_NON_HOLOS,
        ...NEO_DESTINY_TRAINERS,
        ...NEO_DESTINY_SHININGS,
    ],
    themeDecks: [],
};

const { EEVEE: EEVEE$3, KABUTOPS: KABUTOPS$2, KABUTO: KABUTO$3, MAGNEMITE: MAGNEMITE$3, POLIWHIRL: POLIWHIRL$3, POLIWRATH: POLIWRATH$2, SCYTHER: SCYTHER$1 } = GEN_1_POKEMON;
const { ESPEON: ESPEON$2, FORRETRESS: FORRETRESS$3, HITMONTOP: HITMONTOP$1, HOUNDOOM: HOUNDOOM$3, HOUNDOUR: HOUNDOUR$4, PINECO: PINECO$3, POLITOED: POLITOED$2, PUPITAR: PUPITAR$1, SCIZOR: SCIZOR$1, SMEARGLE, TEDDIURSA: TEDDIURSA$2, TYRANITAR: TYRANITAR$2, UMBREON: UMBREON$3, UNOWN_A, URSARING: URSARING$2, WOBBUFFET: WOBBUFFET$2, YANMA: YANMA$2, } = GEN_2_POKEMON;
const holoStrength$4 = 0.7;
const NEO_DISCOVERY_HOLOS = [
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: "It uses the fine hair that covers its body to sense air currents and predict its enemy's actions.",
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        evolvesFrom: EEVEE$3.name,
        evolutionBoxImageUrl: EEVEE$3.images[0].value,
        hitPoints: 80,
        holo: true,
        holoStrength: holoStrength$4,
        id: 'neo_disc_01_en',
        illustrator: ILLUSTRATORS.NISHIDA,
        lengthFeet: 2,
        lengthInches: 11,
        moves: [],
        name: ESPEON$2.name,
        pokemonImagePositionX: 40,
        pokemonImagePositionY: 39,
        pokemonImageSize: 33,
        pokemonImageUrl: ESPEON$2.images[0].value,
        pokemonLevel: 45,
        pokemonNumber: ESPEON$2.number,
        pokemonType: ESPEON$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 1,
        stage: ESPEON$2.stage,
        weight: 58,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'Its entire body is shielded by a steel-hard shell. What lurks inside the armor is a total mystery.',
        energyResistance: ENERGY_TYPES.GRASS,
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.METAL,
        energyWeakness: ENERGY_TYPES.FIRE,
        evolvesFrom: PINECO$3.name,
        evolutionBoxImageUrl: PINECO$3.images[0].value,
        hitPoints: 80,
        holo: true,
        holoStrength: holoStrength$4,
        id: 'neo_disc_02_en',
        illustrator: ILLUSTRATORS.CR_CG_GANGS,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [],
        name: FORRETRESS$3.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 45,
        pokemonImageSize: 49,
        pokemonImageUrl: FORRETRESS$3.images[0].value,
        pokemonLevel: 40,
        pokemonNumber: FORRETRESS$3.number,
        pokemonType: FORRETRESS$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 2,
        stage: FORRETRESS$3.stage,
        weight: 277,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'If you become enchanted by its smooth, elegant, dancelike kicks, you may get drilled hard.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 60,
        holo: true,
        holoStrength: holoStrength$4,
        id: 'neo_disc_03_en',
        illustrator: ILLUSTRATORS.KIZUKI,
        lengthFeet: 4,
        lengthInches: 7,
        moves: [],
        name: HITMONTOP$1.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 42,
        pokemonImageSize: 68,
        pokemonImageUrl: HITMONTOP$1.images[0].value,
        pokemonLevel: 31,
        pokemonNumber: HITMONTOP$1.number,
        pokemonType: HITMONTOP$1.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 3,
        weight: 105,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'Upon hearing its eerie howls, other Pokémon get the shivers and head straight back to their nests.',
        energyResistance: ENERGY_TYPES.PSYCHIC,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.DARKNESS,
        evolvesFrom: HOUNDOUR$4.name,
        evolutionBoxImageUrl: HOUNDOUR$4.images[0].value,
        hitPoints: 70,
        holo: true,
        holoStrength: holoStrength$4,
        id: 'neo_disc_04_en',
        illustrator: ILLUSTRATORS.YOSHIDA,
        lengthFeet: 4,
        lengthInches: 7,
        moves: [],
        name: HOUNDOOM$3.name,
        pokemonImagePositionX: 47,
        pokemonImagePositionY: 38,
        pokemonImageSize: 46,
        pokemonImageUrl: HOUNDOOM$3.images[0].value,
        pokemonLevel: 37,
        pokemonNumber: HOUNDOOM$3.number,
        pokemonType: HOUNDOOM$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 4,
        stage: HOUNDOOM$3.stage,
        weight: 77,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: "To corner prey, they check each other's location using barks that only they can understand.",
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: ENERGY_TYPES.WATER,
        hitPoints: 50,
        holo: true,
        holoStrength: holoStrength$4,
        id: 'neo_disc_05_en',
        illustrator: ILLUSTRATORS.KUSUBE,
        lengthFeet: 2,
        lengthInches: 0,
        moves: [],
        name: HOUNDOUR$4.name,
        pokemonImagePositionX: 59,
        pokemonImagePositionY: 54,
        pokemonImageSize: 47,
        pokemonImageUrl: HOUNDOUR$4.images[1].value,
        pokemonLevel: 22,
        pokemonNumber: HOUNDOUR$4.number,
        pokemonType: HOUNDOUR$4.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 5,
        weight: 24,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'In the water, it tucks in its limbs to become more compact, then it wiggles its shell to swim fast.',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.GRASS,
        evolvesFrom: KABUTO$3.name,
        evolutionBoxImageUrl: KABUTO$3.images[0].value,
        hitPoints: 90,
        holo: true,
        holoStrength: holoStrength$4,
        id: 'neo_disc_06_en',
        illustrator: ILLUSTRATORS.MASAGO,
        lengthFeet: 4,
        lengthInches: 3,
        moves: [],
        name: KABUTOPS$2.name,
        pokemonImagePositionX: 53,
        pokemonImagePositionY: 41,
        pokemonImageSize: 63,
        pokemonImageUrl: KABUTOPS$2.images[1].value,
        pokemonLevel: 42,
        pokemonNumber: KABUTOPS$2.number,
        pokemonType: KABUTOPS$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 6,
        stage: KABUTOPS$2.stage,
        weight: 89,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'These Pokémon are attracted to electrical emissions and will often follow people using PokéGear.',
        energyResistance: ENERGY_TYPES.GRASS,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.METAL,
        energyWeakness: ENERGY_TYPES.FIRE,
        hitPoints: 40,
        holo: true,
        holoStrength: holoStrength$4,
        id: 'neo_disc_07_en',
        illustrator: ILLUSTRATORS_TEAMS.HOSHIBA_GANGS,
        lengthFeet: 1,
        lengthInches: 0,
        moves: [],
        name: MAGNEMITE$3.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 44,
        pokemonImageUrl: MAGNEMITE$3.images[5].value,
        pokemonLevel: 16,
        pokemonNumber: MAGNEMITE$3.number,
        pokemonType: MAGNEMITE$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 7,
        weight: 13,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'Whenever three or more of these get together, they sing in a loud voice that sounds like bellowing.',
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.GRASS,
        evolvesFrom: POLIWHIRL$3.name,
        evolutionBoxImageUrl: POLIWHIRL$3.images[0].value,
        hitPoints: 100,
        holo: true,
        holoStrength: holoStrength$4,
        id: 'neo_disc_08_en',
        illustrator: ILLUSTRATORS.KOMIYA,
        lengthFeet: 3,
        lengthInches: 7,
        moves: [],
        name: POLITOED$2.name,
        pokemonImagePositionX: 68,
        pokemonImagePositionY: 43,
        pokemonImageSize: 49,
        pokemonImageUrl: POLITOED$2.images[0].value,
        pokemonLevel: 53,
        pokemonNumber: POLITOED$2.number,
        pokemonType: POLITOED$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 8,
        stage: POLITOED$2.stage,
        weight: 75,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'Although an energetic, skilled swimmer that uses all of its muscles, it lives on dry land.',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        evolvesFrom: POLIWHIRL$3.name,
        evolutionBoxImageUrl: POLIWHIRL$3.images[0].value,
        hitPoints: 90,
        holo: true,
        holoStrength: holoStrength$4,
        id: 'neo_disc_09_en',
        illustrator: ILLUSTRATORS.YOSHIDA,
        lengthFeet: 4,
        lengthInches: 3,
        moves: [],
        name: POLIWRATH$2.name,
        pokemonImagePositionX: 47,
        pokemonImagePositionY: 38,
        pokemonImageSize: 31,
        pokemonImageUrl: POLIWRATH$2.images[2].value,
        pokemonLevel: 45,
        pokemonNumber: POLIWRATH$2.number,
        pokemonType: POLIWRATH$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 9,
        stage: POLIWRATH$2.stage,
        weight: 119,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'It swings its eye patterned pincers up to scare its foes. This makes it look like it has three heads.',
        energyResistance: ENERGY_TYPES.GRASS,
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.METAL,
        energyWeakness: ENERGY_TYPES.FIRE,
        evolvesFrom: SCYTHER$1.name,
        evolutionBoxImageUrl: SCYTHER$1.images[0].value,
        hitPoints: 80,
        holo: true,
        holoStrength: holoStrength$4,
        id: 'neo_disc_10_en',
        illustrator: ILLUSTRATORS.MASAGO,
        lengthFeet: 5,
        lengthInches: 11,
        moves: [],
        name: SCIZOR$1.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 41,
        pokemonImageSize: 67,
        pokemonImageUrl: SCIZOR$1.images[1].value,
        pokemonLevel: 43,
        pokemonNumber: SCIZOR$1.number,
        pokemonType: SCIZOR$1.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 10,
        stage: SCIZOR$1.stage,
        weight: 260,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'A special fluid oozes from the tip of its tail. It paints the fluid everywhere to mark its territory.',
        energyResistance: ENERGY_TYPES.PSYCHIC,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 50,
        holo: true,
        holoStrength: holoStrength$4,
        id: 'neo_disc_11_en',
        illustrator: ILLUSTRATORS.HIRONOBU,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [],
        name: SMEARGLE.name,
        pokemonImagePositionX: 37,
        pokemonImagePositionY: 43,
        pokemonImageSize: 44,
        pokemonImageUrl: SMEARGLE.images[0].value,
        pokemonLevel: 27,
        pokemonNumber: SMEARGLE.number,
        pokemonType: SMEARGLE.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 11,
        weight: 128,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: "Its body can't be harmed by any sort of attack, so it is very eager to make challenges against enemies.",
        energyResistance: ENERGY_TYPES.PSYCHIC,
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.DARKNESS,
        energyWeakness: null,
        evolvesFrom: PUPITAR$1.name,
        evolutionBoxImageUrl: PUPITAR$1.images[0].value,
        hitPoints: 100,
        holo: true,
        holoStrength: holoStrength$4,
        id: 'neo_disc_12_en',
        illustrator: ILLUSTRATORS.HIRONOBU,
        lengthFeet: 6,
        lengthInches: 7,
        moves: [],
        name: TYRANITAR$2.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 46,
        pokemonImageShadowColor: '#ffffff',
        pokemonImageShadowSize: '0.86',
        pokemonImageSize: 51,
        pokemonImageUrl: TYRANITAR$2.images[0].value,
        pokemonLevel: 54,
        pokemonNumber: TYRANITAR$2.number,
        pokemonType: TYRANITAR$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 12,
        stage: TYRANITAR$2.stage,
        weight: 445,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'When darkness falls, the rings on its body begin to glow, striking fear in the hearts of anyone nearby.',
        energyResistance: ENERGY_TYPES.PSYCHIC,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.DARKNESS,
        evolvesFrom: EEVEE$3.name,
        evolutionBoxImageUrl: EEVEE$3.images[0].value,
        hitPoints: 80,
        holo: true,
        holoStrength: holoStrength$4,
        id: 'neo_disc_13_en',
        illustrator: ILLUSTRATORS.MASAGO,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: UMBREON$3.name,
        pokemonImagePositionX: 54,
        pokemonImagePositionY: 46,
        pokemonImageSize: 38,
        pokemonImageUrl: UMBREON$3.images[0].value,
        pokemonLevel: 40,
        pokemonNumber: UMBREON$3.number,
        pokemonType: UMBREON$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 13,
        stage: UMBREON$3.stage,
        weight: 60,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.UNOWN,
        description: 'Their shapes look like hieroglyphs on ancient tablets. It is said the two are somehow related.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 40,
        holo: true,
        holoStrength: holoStrength$4,
        id: 'neo_disc_14_en',
        illustrator: ILLUSTRATORS.CR_CG_GANGS,
        lengthFeet: 1,
        lengthInches: 8,
        moves: [],
        name: UNOWN_A.name,
        pokemonImagePositionX: 45,
        pokemonImagePositionY: 42,
        pokemonImageShadowColor: '#7f9563',
        pokemonImageShadowSize: 0.78,
        pokemonImageSize: 22,
        pokemonImageUrl: UNOWN_A.images[0].value,
        pokemonLevel: 15,
        pokemonNumber: UNOWN_A.number,
        pokemonType: UNOWN_A.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 14,
        unownLetter: 'A',
        weight: 11,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'Although it is a good climber, it prefers to snap trees with its forelegs and eat fallen berries.',
        energyResistance: ENERGY_TYPES.PSYCHIC,
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: TEDDIURSA$2.name,
        evolutionBoxImageUrl: TEDDIURSA$2.images[0].value,
        hitPoints: 80,
        holo: true,
        holoStrength: holoStrength$4,
        id: 'neo_disc_15_en',
        illustrator: ILLUSTRATORS.KIMURA,
        lengthFeet: 5,
        lengthInches: 11,
        moves: [],
        name: URSARING$2.name,
        pokemonImagePositionX: 58,
        pokemonImagePositionY: 42,
        pokemonImageSize: 55,
        pokemonImageUrl: URSARING$2.images[0].value,
        pokemonLevel: 42,
        pokemonNumber: URSARING$2.number,
        pokemonType: URSARING$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 15,
        stage: URSARING$2.stage,
        weight: 277,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'To keep its pitch-black tail hidden, it lives quietly in the darkness. It is never first to attack.',
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 90,
        holo: true,
        holoStrength: holoStrength$4,
        id: 'neo_disc_16_en',
        illustrator: ILLUSTRATORS.HIRONOBU,
        lengthFeet: 4,
        lengthInches: 3,
        moves: [],
        name: WOBBUFFET$2.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 43,
        pokemonImageSize: 40,
        pokemonImageUrl: WOBBUFFET$2.images[0].value,
        pokemonLevel: 46,
        pokemonNumber: WOBBUFFET$2.number,
        pokemonType: WOBBUFFET$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 16,
        weight: 63,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'If it flaps its wings really fast, it can generate shock waves that will shatter windows in the area.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        hitPoints: 60,
        holo: true,
        holoStrength: holoStrength$4,
        id: 'neo_disc_17_en',
        illustrator: ILLUSTRATORS.NISHIDA,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [],
        name: YANMA$2.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 38,
        pokemonImageSize: 51,
        pokemonImageUrl: YANMA$2.images[0].value,
        pokemonLevel: 32,
        pokemonNumber: YANMA$2.number,
        pokemonType: YANMA$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 17,
        weight: 84,
    },
];

const { BEEDRILL: BEEDRILL$2, BUTTERFREE: BUTTERFREE$2, CATERPIE, EEVEE: EEVEE$2, JIGGLYPUFF: JIGGLYPUFF$2, KABUTO: KABUTO$2, KAKUNA: KAKUNA$2, METAPOD, OMANYTE: OMANYTE$1, OMASTAR: OMASTAR$2, POLIWAG: POLIWAG$1, POLIWHIRL: POLIWHIRL$2, SCYTHER, WEEDLE: WEEDLE$1, } = GEN_1_POKEMON;
const { MYSTERIOUS_FOSSIL: MYSTERIOUS_FOSSIL$2 } = JUNGLE_FOSSIL_TRAINERS;
const { CORSOLA, DUNSPARCE: DUNSPARCE$1, ESPEON: ESPEON$1, HOPPIP: HOPPIP$1, HOUNDOUR: HOUNDOUR$3, IGGLYBUFF: IGGLYBUFF$1, LARVITAR, MAREEP: MAREEP$1, NATU: NATU$2, PINECO: PINECO$2, PUPITAR, SENTRET, SPINARAK, TEDDIURSA: TEDDIURSA$1, TYROGUE, UMBREON: UMBREON$2, UNOWN_D, UNOWN_E, UNOWN_F, UNOWN_I, UNOWN_M, UNOWN_N, UNOWN_O, UNOWN_U, WOOPER: WOOPER$1, XATU: XATU$2, } = GEN_2_POKEMON;
const NEO_DISCOVERY_NON_HOLOS = [
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        evolvesFrom: KAKUNA$2.name,
        evolutionBoxImageUrl: KAKUNA$2.images[0].value,
        hitPoints: 60,
        id: 'neo_disc_18_en',
        illustrator: ILLUSTRATORS.NISHIDA,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [],
        name: BEEDRILL$2.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 38,
        pokemonImageSize: 51,
        pokemonImageUrl: BEEDRILL$2.images[2].value,
        pokemonLevel: 32,
        pokemonNumber: BEEDRILL$2.number,
        pokemonType: BEEDRILL$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 18,
        stage: BEEDRILL$2.stage,
        weight: 84,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'If it flaps its wings really fast, it can generate shock waves that will shatter windows in the area.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        evolvesFrom: METAPOD.name,
        evolutionBoxImageUrl: METAPOD.images[0].value,
        hitPoints: 60,
        id: 'neo_disc_19_en',
        illustrator: ILLUSTRATORS.NISHIDA,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [],
        name: BUTTERFREE$2.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 38,
        pokemonImageSize: 51,
        pokemonImageUrl: BUTTERFREE$2.images[1].value,
        pokemonLevel: 32,
        pokemonNumber: BUTTERFREE$2.number,
        pokemonType: BUTTERFREE$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 19,
        stage: BUTTERFREE$2.stage,
        weight: 84,
    },
    {
        ...NEO_DISCOVERY_HOLOS[0],
        description: '',
        holo: false,
        id: 'neo_disc_20_en',
        pokemonImageUrl: ESPEON$1.images[1].value,
        setNumber: 20,
    },
    {
        ...NEO_DISCOVERY_HOLOS[1],
        holo: false,
        id: 'neo_disc_21_en',
        setNumber: 21,
    },
    {
        ...NEO_DISCOVERY_HOLOS[2],
        holo: false,
        id: 'neo_disc_22_en',
        setNumber: 22,
    },
    {
        ...NEO_DISCOVERY_HOLOS[3],
        holo: false,
        id: 'neo_disc_23_en',
        setNumber: 23,
    },
    {
        ...NEO_DISCOVERY_HOLOS[4],
        holo: false,
        id: 'neo_disc_24_en',
        setNumber: 24,
    },
    {
        ...NEO_DISCOVERY_HOLOS[5],
        holo: false,
        id: 'neo_disc_25_en',
        setNumber: 25,
    },
    {
        ...NEO_DISCOVERY_HOLOS[6],
        holo: false,
        id: 'neo_disc_26_en',
        setNumber: 26,
    },
    {
        ...NEO_DISCOVERY_HOLOS[7],
        holo: false,
        id: 'neo_disc_27_en',
        setNumber: 27,
    },
    {
        ...NEO_DISCOVERY_HOLOS[8],
        holo: false,
        id: 'neo_disc_28_en',
        setNumber: 28,
    },
    {
        ...NEO_DISCOVERY_HOLOS[9],
        holo: false,
        id: 'neo_disc_29_en',
        setNumber: 29,
    },
    {
        ...NEO_DISCOVERY_HOLOS[10],
        holo: false,
        id: 'neo_disc_30_en',
        setNumber: 30,
    },
    {
        ...NEO_DISCOVERY_HOLOS[11],
        holo: false,
        id: 'neo_disc_31_en',
        setNumber: 31,
    },
    {
        ...NEO_DISCOVERY_HOLOS[12],
        description: '',
        holo: false,
        id: 'neo_disc_32_en',
        pokemonImageUrl: UMBREON$2.images[1].value,
        setNumber: 32,
    },
    {
        ...NEO_DISCOVERY_HOLOS[13],
        holo: false,
        id: 'neo_disc_33_en',
        setNumber: 33,
    },
    {
        ...NEO_DISCOVERY_HOLOS[14],
        holo: false,
        id: 'neo_disc_34_en',
        setNumber: 34,
    },
    {
        ...NEO_DISCOVERY_HOLOS[15],
        holo: false,
        id: 'neo_disc_35_en',
        setNumber: 35,
    },
    {
        ...NEO_DISCOVERY_HOLOS[16],
        holo: false,
        id: 'neo_disc_36_en',
        setNumber: 36,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: 60,
        id: 'neo_disc_37_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [],
        name: CORSOLA.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 38,
        pokemonImageSize: 51,
        pokemonImageUrl: CORSOLA.images[0].value,
        pokemonLevel: 32,
        pokemonNumber: CORSOLA.number,
        pokemonType: CORSOLA.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 37,
        weight: 84,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: 60,
        id: 'neo_disc_38_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [],
        name: EEVEE$2.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 38,
        pokemonImageSize: 51,
        pokemonImageUrl: EEVEE$2.images[3].value,
        pokemonLevel: 32,
        pokemonNumber: EEVEE$2.number,
        pokemonType: EEVEE$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 38,
        weight: 84,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        hitPoints: 60,
        id: 'neo_disc_39_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [],
        name: HOUNDOUR$3.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 38,
        pokemonImageSize: 51,
        pokemonImageUrl: HOUNDOUR$3.images[2].value,
        pokemonLevel: 32,
        pokemonNumber: HOUNDOUR$3.number,
        pokemonType: HOUNDOUR$3.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 39,
        weight: 84,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.BABY,
        description: '',
        energyResistance: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        evolvesTo: JIGGLYPUFF$2.name,
        hitPoints: 60,
        id: 'neo_disc_40_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [],
        name: IGGLYBUFF$1.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 38,
        pokemonImageSize: 51,
        pokemonImageUrl: IGGLYBUFF$1.images[0].value,
        pokemonLevel: 32,
        pokemonNumber: IGGLYBUFF$1.number,
        pokemonType: IGGLYBUFF$1.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 40,
        weight: 84,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: WEEDLE$1.name,
        evolutionBoxImageUrl: WEEDLE$1.images[0].value,
        hitPoints: 60,
        id: 'neo_disc_41_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [],
        name: KAKUNA$2.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 38,
        pokemonImageSize: 51,
        pokemonImageUrl: KAKUNA$2.images[2].value,
        pokemonLevel: 32,
        pokemonNumber: KAKUNA$2.number,
        pokemonType: KAKUNA$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 41,
        stage: KAKUNA$2.stage,
        weight: 84,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: CATERPIE.name,
        evolutionBoxImageUrl: CATERPIE.images[0].value,
        hitPoints: 60,
        id: 'neo_disc_42_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [],
        name: METAPOD.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 38,
        pokemonImageSize: 51,
        pokemonImageUrl: METAPOD.images[1].value,
        pokemonLevel: 32,
        pokemonNumber: METAPOD.number,
        pokemonType: METAPOD.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 42,
        stage: METAPOD.stage,
        weight: 84,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: OMANYTE$1.name,
        evolutionBoxImageUrl: OMANYTE$1.images[0].value,
        hitPoints: 60,
        id: 'neo_disc_43_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [],
        name: OMASTAR$2.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 38,
        pokemonImageSize: 51,
        pokemonImageUrl: OMASTAR$2.images[1].value,
        pokemonLevel: 32,
        pokemonNumber: OMASTAR$2.number,
        pokemonType: OMASTAR$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 43,
        stage: OMASTAR$2.stage,
        weight: 84,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: POLIWAG$1.name,
        evolutionBoxImageUrl: POLIWAG$1.images[0].value,
        hitPoints: 60,
        id: 'neo_disc_44_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [],
        name: POLIWHIRL$2.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 38,
        pokemonImageSize: 51,
        pokemonImageUrl: POLIWHIRL$2.images[2].value,
        pokemonLevel: 32,
        pokemonNumber: POLIWHIRL$2.number,
        pokemonType: POLIWHIRL$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 44,
        stage: POLIWHIRL$2.stage,
        weight: 84,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        evolvesFrom: LARVITAR.name,
        evolutionBoxImageUrl: LARVITAR.images[0].value,
        hitPoints: 60,
        id: 'neo_disc_45_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [],
        name: PUPITAR.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 38,
        pokemonImageSize: 51,
        pokemonImageUrl: PUPITAR.images[0].value,
        pokemonLevel: 32,
        pokemonNumber: PUPITAR.number,
        pokemonType: PUPITAR.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 45,
        stage: PUPITAR.stage,
        weight: 84,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: 60,
        id: 'neo_disc_46_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [],
        name: SCYTHER.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 38,
        pokemonImageSize: 51,
        pokemonImageUrl: SCYTHER.images[2].value,
        pokemonLevel: 32,
        pokemonNumber: SCYTHER.number,
        pokemonType: SCYTHER.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 46,
        weight: 84,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.UNOWN,
        description: '',
        energyResistance: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: 60,
        id: 'neo_disc_47_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [],
        name: UNOWN_D.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 38,
        pokemonImageSize: 51,
        pokemonImageUrl: UNOWN_D.images[0].value,
        pokemonLevel: 32,
        pokemonNumber: UNOWN_D.number,
        pokemonType: UNOWN_D.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 47,
        unownLetter: 'D',
        weight: 84,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.UNOWN,
        description: '',
        energyResistance: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: 60,
        id: 'neo_disc_48_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [],
        name: UNOWN_F.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 38,
        pokemonImageSize: 51,
        pokemonImageUrl: UNOWN_F.images[0].value,
        pokemonLevel: 32,
        pokemonNumber: UNOWN_F.number,
        pokemonType: UNOWN_F.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 48,
        unownLetter: 'F',
        weight: 84,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.UNOWN,
        description: '',
        energyResistance: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: 60,
        id: 'neo_disc_49_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [],
        name: UNOWN_M.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 38,
        pokemonImageSize: 51,
        pokemonImageUrl: UNOWN_M.images[0].value,
        pokemonLevel: 32,
        pokemonNumber: UNOWN_M.number,
        pokemonType: UNOWN_M.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 49,
        unownLetter: 'M',
        weight: 84,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.UNOWN,
        description: '',
        energyResistance: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: 60,
        id: 'neo_disc_50_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [],
        name: UNOWN_N.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 38,
        pokemonImageSize: 51,
        pokemonImageUrl: UNOWN_N.images[0].value,
        pokemonLevel: 32,
        pokemonNumber: UNOWN_N.number,
        pokemonType: UNOWN_N.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 50,
        unownLetter: 'N',
        weight: 84,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.UNOWN,
        description: '',
        energyResistance: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: 60,
        id: 'neo_disc_51_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [],
        name: UNOWN_U.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 38,
        pokemonImageSize: 51,
        pokemonImageUrl: UNOWN_U.images[0].value,
        pokemonLevel: 32,
        pokemonNumber: UNOWN_U.number,
        pokemonType: UNOWN_U.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 51,
        unownLetter: 'U',
        weight: 84,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        evolvesFrom: NATU$2.name,
        evolutionBoxImageUrl: NATU$2.images[0].value,
        hitPoints: 60,
        id: 'neo_disc_52_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [],
        name: XATU$2.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 38,
        pokemonImageSize: 51,
        pokemonImageUrl: XATU$2.images[1].value,
        pokemonLevel: 32,
        pokemonNumber: XATU$2.number,
        pokemonType: XATU$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 52,
        stage: XATU$2.stage,
        weight: 84,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: 60,
        id: 'neo_disc_53_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [],
        name: CATERPIE.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 38,
        pokemonImageSize: 51,
        pokemonImageUrl: CATERPIE.images[1].value,
        pokemonLevel: 32,
        pokemonNumber: CATERPIE.number,
        pokemonType: CATERPIE.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 53,
        weight: 84,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: 60,
        id: 'neo_disc_54_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [],
        name: DUNSPARCE$1.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 38,
        pokemonImageSize: 51,
        pokemonImageUrl: DUNSPARCE$1.images[0].value,
        pokemonLevel: 32,
        pokemonNumber: DUNSPARCE$1.number,
        pokemonType: DUNSPARCE$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 54,
        weight: 84,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: 60,
        id: 'neo_disc_55_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [],
        name: HOPPIP$1.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 38,
        pokemonImageSize: 51,
        pokemonImageUrl: HOPPIP$1.images[1].value,
        pokemonLevel: 32,
        pokemonNumber: HOPPIP$1.number,
        pokemonType: HOPPIP$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 55,
        weight: 84,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: 60,
        id: 'neo_disc_56_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [],
        name: KABUTO$2.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 38,
        pokemonImageSize: 51,
        pokemonImageUrl: KABUTO$2.images[2].value,
        pokemonLevel: 32,
        pokemonNumber: KABUTO$2.number,
        pokemonType: KABUTO$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 56,
        weight: 84,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        hitPoints: 60,
        id: 'neo_disc_57_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [],
        name: LARVITAR.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 38,
        pokemonImageSize: 51,
        pokemonImageUrl: LARVITAR.images[1].value,
        pokemonLevel: 32,
        pokemonNumber: LARVITAR.number,
        pokemonType: LARVITAR.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 57,
        weight: 84,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        hitPoints: 60,
        id: 'neo_disc_58_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [],
        name: MAREEP$1.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 38,
        pokemonImageSize: 51,
        pokemonImageUrl: MAREEP$1.images[1].value,
        pokemonLevel: 32,
        pokemonNumber: MAREEP$1.number,
        pokemonType: MAREEP$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 58,
        weight: 84,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: 60,
        id: 'neo_disc_59_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [],
        name: NATU$2.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 38,
        pokemonImageSize: 51,
        pokemonImageUrl: NATU$2.images[1].value,
        pokemonLevel: 32,
        pokemonNumber: NATU$2.number,
        pokemonType: NATU$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 59,
        weight: 84,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        evolvesFrom: MYSTERIOUS_FOSSIL$2.name,
        evolutionBoxBackgroundImageSize: 'cover',
        evolutionBoxImageUrl: MYSTERIOUS_FOSSIL$2.image,
        hitPoints: 60,
        id: 'neo_disc_60_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [],
        name: OMANYTE$1.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 38,
        pokemonImageSize: 51,
        pokemonImageUrl: OMANYTE$1.images[1].value,
        pokemonLevel: 32,
        pokemonNumber: OMANYTE$1.number,
        pokemonType: OMANYTE$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 60,
        stage: OMANYTE$1.stage,
        weight: 84,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: 60,
        id: 'neo_disc_61_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [],
        name: PINECO$2.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 38,
        pokemonImageSize: 51,
        pokemonImageUrl: PINECO$2.images[1].value,
        pokemonLevel: 32,
        pokemonNumber: PINECO$2.number,
        pokemonType: PINECO$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 61,
        weight: 84,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: 60,
        id: 'neo_disc_62_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [],
        name: POLIWAG$1.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 38,
        pokemonImageSize: 51,
        pokemonImageUrl: POLIWAG$1.images[3].value,
        pokemonLevel: 32,
        pokemonNumber: POLIWAG$1.number,
        pokemonType: POLIWAG$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 62,
        weight: 84,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: 60,
        id: 'neo_disc_63_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [],
        name: SENTRET.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 38,
        pokemonImageSize: 51,
        pokemonImageUrl: SENTRET.images[1].value,
        pokemonLevel: 32,
        pokemonNumber: SENTRET.number,
        pokemonType: SENTRET.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 63,
        weight: 84,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: 60,
        id: 'neo_disc_64_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [],
        name: SPINARAK.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 38,
        pokemonImageSize: 51,
        pokemonImageUrl: SPINARAK.images[1].value,
        pokemonLevel: 32,
        pokemonNumber: SPINARAK.number,
        pokemonType: SPINARAK.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 64,
        weight: 84,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: 60,
        id: 'neo_disc_65_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [],
        name: TEDDIURSA$1.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 38,
        pokemonImageSize: 51,
        pokemonImageUrl: TEDDIURSA$1.images[1].value,
        pokemonLevel: 32,
        pokemonNumber: TEDDIURSA$1.number,
        pokemonType: TEDDIURSA$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 65,
        weight: 84,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.BABY,
        description: '',
        energyResistance: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        hitPoints: 60,
        id: 'neo_disc_66_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [],
        name: TYROGUE.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 38,
        pokemonImageSize: 51,
        pokemonImageUrl: TYROGUE.images[0].value,
        pokemonLevel: 32,
        pokemonNumber: TYROGUE.number,
        pokemonType: TYROGUE.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 66,
        weight: 84,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.UNOWN,
        description: '',
        energyResistance: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: 60,
        id: 'neo_disc_67_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [],
        name: UNOWN_E.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 38,
        pokemonImageSize: 51,
        pokemonImageUrl: UNOWN_E.images[0].value,
        pokemonLevel: 32,
        pokemonNumber: UNOWN_E.number,
        pokemonType: UNOWN_E.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 67,
        unownLetter: 'E',
        weight: 84,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.UNOWN,
        description: '',
        energyResistance: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: 60,
        id: 'neo_disc_68_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [],
        name: UNOWN_I.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 38,
        pokemonImageSize: 51,
        pokemonImageUrl: UNOWN_I.images[0].value,
        pokemonLevel: 32,
        pokemonNumber: UNOWN_I.number,
        pokemonType: UNOWN_I.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 68,
        unownLetter: 'I',
        weight: 84,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.UNOWN,
        description: '',
        energyResistance: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: 60,
        id: 'neo_disc_69_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [],
        name: UNOWN_O.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 38,
        pokemonImageSize: 51,
        pokemonImageUrl: UNOWN_O.images[0].value,
        pokemonLevel: 32,
        pokemonNumber: UNOWN_O.number,
        pokemonType: UNOWN_O.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 69,
        unownLetter: 'O',
        weight: 84,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: 60,
        id: 'neo_disc_70_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [],
        name: WEEDLE$1.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 38,
        pokemonImageSize: 51,
        pokemonImageUrl: WEEDLE$1.images[2].value,
        pokemonLevel: 32,
        pokemonNumber: WEEDLE$1.number,
        pokemonType: WEEDLE$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 70,
        weight: 84,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: 60,
        id: 'neo_disc_71_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [],
        name: WOOPER$1.name,
        pokemonImagePositionX: 49,
        pokemonImagePositionY: 38,
        pokemonImageSize: 51,
        pokemonImageUrl: WOOPER$1.images[2].value,
        pokemonLevel: 32,
        pokemonNumber: WOOPER$1.number,
        pokemonType: WOOPER$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 71,
        weight: 84,
    },
];

const { FOSSIL_EGG, HYPER_DEVOLUTION_SPRAY, RUIN_WALL, ENERGY_ARK: ENERGY_ARK$1 } = NEO_TRAINERS;
const NEO_DISCOVERY_TRAINERS = [
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'neo_disc_72_en',
        illustrator: null,
        isBoldName: true,
        name: FOSSIL_EGG.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 72,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'neo_disc_73_en',
        illustrator: null,
        isBoldName: true,
        name: HYPER_DEVOLUTION_SPRAY.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 73,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'neo_disc_74_en',
        illustrator: null,
        isBoldName: true,
        name: RUIN_WALL.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 74,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'neo_disc_75_en',
        illustrator: null,
        isBoldName: true,
        name: ENERGY_ARK$1.name,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 75,
    },
];

const setId$4 = CARD_SETS.NEO_DISCOVERY.value;
const setName$4 = CARD_SETS.NEO_DISCOVERY.label;
const setTotal$3 = NEO_DISCOVERY_SET_TOTAL;
const NEO_DISCOVERY_SET = {
    cardCounts: {
        holoRares: 17,
        rares: 19,
        uncommons: 19,
        commons: 20,
    },
    copyright: COPYRIGHTS.NEO_SET,
    description: SET_DESCRIPTIONS.NEO_DISCOVERY,
    holoSheetType: CARD_HOLO_SHEETS.COSMOS_2,
    id: setId$4,
    imageUrl: 'https://cdn.shopify.com/s/files/1/0840/1659/5249/collections/neo-discovery-cat-bg.jpg',
    name: setName$4,
    packInfo: BOOSTER_PACKS.NEO_DISCOVERY,
    releaseDate: RELEASE_DATES.NEO_DISCOVERY,
    reverseHoloSheetType: CARD_HOLO_SHEETS.COSMOS_2,
    setSymbol: setId$4,
    setTotal: setTotal$3,
    cards: [
        ...NEO_DISCOVERY_HOLOS,
        ...NEO_DISCOVERY_NON_HOLOS,
        ...NEO_DISCOVERY_TRAINERS,
    ],
    themeDecks: [],
};

const holoStrength$3 = 0.7;
const { CHANSEY, GOLBAT: GOLBAT$3, MAGNEMITE: MAGNEMITE$2, MAGNETON: MAGNETON$2, PORYGON } = GEN_1_POKEMON;
const { AMPHAROS: AMPHAROS$1, BLISSEY, CELEBI: CELEBI$2, CROBAT: CROBAT$2, DELIBIRD: DELIBIRD$2, ENTEI: ENTEI$2, FLAAFFY: FLAAFFY$1, HO_OH: HO_OH$2, HOUNDOOM: HOUNDOOM$2, HOUNDOUR: HOUNDOUR$2, JUMPLUFF: JUMPLUFF$1, MISDREAVUS: MISDREAVUS$2, PORYGON2, RAIKOU: RAIKOU$3, SKIPLOOM: SKIPLOOM$1, SUICUNE: SUICUNE$2, } = GEN_2_POKEMON;
const NEO_REVELATION_HOLOS = [
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'The bright light on its tail can be seen far away. It has been treasured since ancient times as a beacon.',
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: FLAAFFY$1.name,
        evolutionBoxImageUrl: FLAAFFY$1.images[0].value,
        hitPoints: 90,
        holo: true,
        holoStrength: holoStrength$3,
        id: 'neo_rev_01_en',
        illustrator: ILLUSTRATORS.AOKI,
        lengthFeet: 4,
        lengthInches: 7,
        moves: [],
        name: AMPHAROS$1.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 47,
        pokemonImageSize: 49,
        pokemonImageUrl: AMPHAROS$1.images[1].value,
        pokemonLevel: 46,
        pokemonNumber: AMPHAROS$1.number,
        pokemonType: AMPHAROS$1.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 1,
        stage: AMPHAROS$1.stage,
        weight: 136,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: "Anyone who takes even one bite of Blissey's egg becomes unfailingly caring and pleasant to everyone.",
        energyResistance: ENERGY_TYPES.PSYCHIC,
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: CHANSEY.name,
        evolutionBoxImageUrl: CHANSEY.images[0].value,
        hitPoints: 120,
        holo: true,
        holoStrength: holoStrength$3,
        id: 'neo_rev_02_en',
        illustrator: ILLUSTRATORS.MORII,
        lengthFeet: 4,
        lengthInches: 11,
        moves: [],
        name: BLISSEY.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 44,
        pokemonImageShadowColor: '#ffffff',
        pokemonImageShadowSize: 0.66,
        pokemonImageSize: 39,
        pokemonImageUrl: BLISSEY.images[0].value,
        pokemonLevel: 62,
        pokemonNumber: BLISSEY.number,
        pokemonType: BLISSEY.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 2,
        stage: BLISSEY.stage,
        weight: 103,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'This Pokémon wanders across time. Grass and trees flourish in the forests in which it has appeared.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 50,
        holo: true,
        holoStrength: holoStrength$3,
        id: 'neo_rev_03_en',
        illustrator: ILLUSTRATORS.HIRONOBU,
        lengthFeet: 2,
        lengthInches: 0,
        moves: [],
        name: CELEBI$2.name,
        pokemonImagePositionX: 47,
        pokemonImagePositionY: 45,
        pokemonImageSize: 36,
        pokemonImageUrl: CELEBI$2.images[0].value,
        pokemonLevel: 16,
        pokemonNumber: CELEBI$2.number,
        pokemonType: CELEBI$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 3,
        weight: 11,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'It flies so silently through the dark on its four wings that it may not be noticed even when nearby.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        evolvesFrom: GOLBAT$3.name,
        evolutionBoxImageUrl: GOLBAT$3.images[0].value,
        hitPoints: 90,
        holo: true,
        holoStrength: holoStrength$3,
        id: 'neo_rev_04_en',
        illustrator: ILLUSTRATORS.YOSHIDA,
        lengthFeet: 5,
        lengthInches: 11,
        moves: [],
        name: CROBAT$2.name,
        pokemonImagePositionX: 47,
        pokemonImagePositionY: 44,
        pokemonImageSize: 50,
        pokemonImageUrl: CROBAT$2.images[0].value,
        pokemonLevel: 51,
        pokemonNumber: CROBAT$2.number,
        pokemonType: CROBAT$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 4,
        stage: CROBAT$2.stage,
        weight: 165,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'It carries food all day long. There are tales about lost people who were saved by the food it had.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 60,
        holo: true,
        holoStrength: holoStrength$3,
        id: 'neo_rev_05_en',
        illustrator: ILLUSTRATORS.KOMIYA,
        lengthFeet: 2,
        lengthInches: 11,
        moves: [],
        name: DELIBIRD$2.name,
        pokemonImagePositionX: 42,
        pokemonImagePositionY: 42,
        pokemonImageSize: 52,
        pokemonImageUrl: DELIBIRD$2.images[0].value,
        pokemonLevel: 34,
        pokemonNumber: DELIBIRD$2.number,
        pokemonType: DELIBIRD$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 5,
        weight: 35,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'Volcanoes erupt when it barks. Unable to restrain its extreme power, it races headlong around the land.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: ENERGY_TYPES.WATER,
        hitPoints: 80,
        holo: true,
        holoStrength: holoStrength$3,
        id: 'neo_rev_06_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 6,
        lengthInches: 11,
        moves: [],
        name: ENTEI$2.name,
        pokemonImagePositionX: 57,
        pokemonImagePositionY: 44,
        pokemonImageSize: 56,
        pokemonImageUrl: ENTEI$2.images[0].value,
        pokemonLevel: 38,
        pokemonNumber: ENTEI$2.number,
        pokemonType: ENTEI$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 6,
        weight: 437,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: "Legends claim this Pokémon flies the world's skies continuously on its magnificent seven colored wings.",
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: ENERGY_TYPES.WATER,
        hitPoints: 90,
        holo: true,
        holoStrength: holoStrength$3,
        id: 'neo_rev_07_en',
        illustrator: ILLUSTRATORS.MASAGO,
        lengthFeet: 12,
        lengthInches: 6,
        moves: [],
        name: HO_OH$2.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 44,
        pokemonImageSize: 67,
        pokemonImageUrl: HO_OH$2.images[0].value,
        pokemonLevel: 45,
        pokemonNumber: HO_OH$2.number,
        pokemonType: HO_OH$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 7,
        weight: 439,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'Upon hearing its eerie howls, other Pokémon get the shivers and head straight back to their nests.',
        energyResistance: ENERGY_TYPES.PSYCHIC,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.DARKNESS,
        evolvesFrom: HOUNDOUR$2.name,
        evolutionBoxImageUrl: HOUNDOUR$2.images[0].value,
        hitPoints: 70,
        holo: true,
        holoStrength: holoStrength$3,
        id: 'neo_rev_08_en',
        illustrator: ILLUSTRATORS.ARITA,
        lengthFeet: 4,
        lengthInches: 7,
        moves: [],
        name: HOUNDOOM$2.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 48,
        pokemonImageSize: 67,
        pokemonImageUrl: HOUNDOOM$2.images[1].value,
        pokemonLevel: 35,
        pokemonNumber: HOUNDOOM$2.number,
        pokemonType: HOUNDOOM$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 8,
        stage: HOUNDOOM$2.stage,
        weight: 77,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'Drifts on seasonal winds and spreads its cotton-like spores all over the world to make more offspring.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        evolvesFrom: SKIPLOOM$1.name,
        evolutionBoxImageUrl: SKIPLOOM$1.images[0].value,
        hitPoints: 70,
        holo: true,
        holoStrength: holoStrength$3,
        id: 'neo_rev_09_en',
        illustrator: ILLUSTRATORS.HIMENO,
        lengthFeet: 2,
        lengthInches: 7,
        moves: [],
        name: JUMPLUFF$1.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 43,
        pokemonImageSize: 68,
        pokemonImageUrl: JUMPLUFF$1.images[1].value,
        pokemonLevel: 37,
        pokemonNumber: JUMPLUFF$1.number,
        pokemonType: JUMPLUFF$1.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 9,
        stage: JUMPLUFF$1.stage,
        weight: 7,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'Three Magnemites are linked by a strong magnetic force. Earaches will occur if you get too close.',
        energyResistance: ENERGY_TYPES.GRASS,
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.METAL,
        energyWeakness: ENERGY_TYPES.FIRE,
        evolvesFrom: MAGNEMITE$2.name,
        evolutionBoxImageUrl: MAGNEMITE$2.images[0].value,
        hitPoints: 80,
        holo: true,
        holoStrength: holoStrength$3,
        id: 'neo_rev_10_en',
        illustrator: ILLUSTRATORS_TEAMS.TAGAWA_GANGS,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: MAGNETON$2.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: MAGNETON$2.images[4].value,
        pokemonLevel: 37,
        pokemonNumber: MAGNETON$2.number,
        pokemonType: MAGNETON$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 10,
        stage: MAGNETON$2.stage,
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'It likes playing mischievous tricks such as screaming and wailing to startle people at night.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.PSYCHIC,
        hitPoints: 50,
        holo: true,
        holoStrength: holoStrength$3,
        id: 'neo_rev_11_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 2,
        lengthInches: 4,
        moves: [],
        name: MISDREAVUS$2.name,
        pokemonImagePositionX: 46,
        pokemonImagePositionY: 42,
        pokemonImageSize: 43,
        pokemonImageUrl: MISDREAVUS$2.images[0].value,
        pokemonLevel: 25,
        pokemonNumber: MISDREAVUS$2.number,
        pokemonType: MISDREAVUS$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 11,
        weight: 2,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: "This upgraded version of Porygon is designed for space exploration. It can't fly, though.",
        energyResistance: ENERGY_TYPES.PSYCHIC,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        evolvesFrom: PORYGON.name,
        evolutionBoxImageUrl: PORYGON.images[0].value,
        hitPoints: 70,
        holo: true,
        holoStrength: holoStrength$3,
        id: 'neo_rev_12_en',
        illustrator: ILLUSTRATORS.KINEBUCHI,
        lengthFeet: 2,
        lengthInches: 0,
        moves: [],
        name: PORYGON2.name,
        pokemonImagePositionX: 65,
        pokemonImagePositionY: 60,
        pokemonImageSize: 47,
        pokemonImageUrl: PORYGON2.images[0].value,
        pokemonLevel: 33,
        pokemonNumber: PORYGON2.number,
        pokemonType: PORYGON2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 12,
        stage: PORYGON2.stage,
        weight: 72,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'The rain clouds it carries let it fire thunderbolts at will. They say that it descended with lightning.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 80,
        holo: true,
        holoStrength: holoStrength$3,
        id: 'neo_rev_13_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 6,
        lengthInches: 3,
        moves: [],
        name: RAIKOU$3.name,
        pokemonImagePositionX: 50,
        pokemonImagePositionY: 58,
        pokemonImageSize: 66,
        pokemonImageUrl: RAIKOU$3.images[0].value,
        pokemonLevel: 40,
        pokemonNumber: RAIKOU$3.number,
        pokemonType: RAIKOU$3.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 13,
        weight: 392,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'Said to be the reincarnation of north winds, it can instantly purify filthy, murky water.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 70,
        holo: true,
        holoStrength: holoStrength$3,
        id: 'neo_rev_14_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        lengthFeet: 6,
        lengthInches: 7,
        moves: [],
        name: SUICUNE$2.name,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 42,
        pokemonImageSize: 51,
        pokemonImageUrl: SUICUNE$2.images[0].value,
        pokemonLevel: 33,
        pokemonNumber: SUICUNE$2.number,
        pokemonType: SUICUNE$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 14,
        weight: 412,
    },
];

const { AERODACTYL: AERODACTYL$2, FARFETCHD: FARFETCHD$2, GEODUDE, GOLBAT: GOLBAT$2, GOLDEEN, GRAVELER: GRAVELER$1, JYNX: JYNX$1, PARAS, PARASECT, PIKACHU: PIKACHU$2, RAICHU: RAICHU$2, SEADRA, SEAKING, STARMIE: STARMIE$2, STARYU: STARYU$2, ZUBAT: ZUBAT$1, } = GEN_1_POKEMON;
const { MYSTERIOUS_FOSSIL: MYSTERIOUS_FOSSIL$1 } = JUNGLE_FOSSIL_TRAINERS;
const { AIPOM, CELEBI: CELEBI$1, CHINCHOU, ENTEI: ENTEI$1, FLAAFFY, HO_OH: HO_OH$1, HOPPIP, KINGDRA: KINGDRA$1, LANTURN: LANTURN$1, LUGIA, MAGCARGO: MAGCARGO$2, MAREEP, MURKROW: MURKROW$2, OCTILLERY, PILOSWINE: PILOSWINE$3, QUAGSIRE: QUAGSIRE$1, QWILFISH, RAIKOU: RAIKOU$2, REMORAID, SHUCKLE: SHUCKLE$2, SKARMORY: SKARMORY$2, SKIPLOOM, SLUGMA: SLUGMA$2, SMOOCHUM, SNEASEL: SNEASEL$1, SNUBBULL: SNUBBULL$1, STANTLER: STANTLER$1, SUDOWOODO, SUICUNE: SUICUNE$1, SWINUB: SWINUB$2, UNOWN_B, UNOWN_K, UNOWN_Y, WOOPER, } = GEN_2_POKEMON;
const NEO_REVELATION_NON_HOLOS = [
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        evolvesFrom: MYSTERIOUS_FOSSIL$1.name,
        evolutionBoxImageUrl: MYSTERIOUS_FOSSIL$1.image,
        hitPoints: 80,
        id: 'neo_rev_15_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: AERODACTYL$2.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: AERODACTYL$2.images[1].value,
        pokemonLevel: 37,
        pokemonNumber: AERODACTYL$2.number,
        pokemonType: AERODACTYL$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 15,
        stage: AERODACTYL$2.stage,
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: 80,
        id: 'neo_rev_16_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: CELEBI$1.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: CELEBI$1.images[1].value,
        pokemonLevel: 37,
        pokemonNumber: CELEBI$1.number,
        pokemonType: CELEBI$1.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 16,
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        hitPoints: 80,
        id: 'neo_rev_17_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: ENTEI$1.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: ENTEI$1.images[1].value,
        pokemonLevel: 37,
        pokemonNumber: ENTEI$1.number,
        pokemonType: ENTEI$1.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 17,
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        hitPoints: 80,
        id: 'neo_rev_18_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: HO_OH$1.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: HO_OH$1.images[1].value,
        pokemonLevel: 37,
        pokemonNumber: HO_OH$1.number,
        pokemonType: HO_OH$1.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 18,
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: SEADRA.name,
        evolutionBoxImageUrl: SEADRA.images[0].value,
        hitPoints: 80,
        id: 'neo_rev_19_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: KINGDRA$1.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: KINGDRA$1.images[1].value,
        pokemonLevel: 37,
        pokemonNumber: KINGDRA$1.number,
        pokemonType: KINGDRA$1.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 19,
        stage: KINGDRA$1.stage,
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: 80,
        id: 'neo_rev_20_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: LUGIA.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: LUGIA.images[1].value,
        pokemonLevel: 37,
        pokemonNumber: LUGIA.number,
        pokemonType: LUGIA.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 20,
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        evolvesFrom: PIKACHU$2.name,
        evolutionBoxImageUrl: PIKACHU$2.images[0].value,
        hitPoints: 80,
        id: 'neo_rev_21_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: RAICHU$2.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: RAICHU$2.images[4].value,
        pokemonLevel: 37,
        pokemonNumber: RAICHU$2.number,
        pokemonType: RAICHU$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 21,
        stage: RAICHU$2.stage,
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        hitPoints: 80,
        id: 'neo_rev_22_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: RAIKOU$2.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: RAIKOU$2.images[1].value,
        pokemonLevel: 37,
        pokemonNumber: RAIKOU$2.number,
        pokemonType: RAIKOU$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 22,
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.METAL,
        energyWeakness: null,
        hitPoints: 80,
        id: 'neo_rev_23_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: SKARMORY$2.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: SKARMORY$2.images[2].value,
        pokemonLevel: 37,
        pokemonNumber: SKARMORY$2.number,
        pokemonType: SKARMORY$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 23,
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.DARKNESS,
        energyWeakness: null,
        hitPoints: 80,
        id: 'neo_rev_24_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: SNEASEL$1.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: SNEASEL$1.images[2].value,
        pokemonLevel: 37,
        pokemonNumber: SNEASEL$1.number,
        pokemonType: SNEASEL$1.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 24,
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: STARYU$2.name,
        evolutionBoxImageUrl: STARYU$2.images[0].value,
        hitPoints: 80,
        id: 'neo_rev_25_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: STARMIE$2.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: STARMIE$2.images[2].value,
        pokemonLevel: 37,
        pokemonNumber: STARMIE$2.number,
        pokemonType: STARMIE$2.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 25,
        stage: STARMIE$2.stage,
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        hitPoints: 80,
        id: 'neo_rev_26_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: SUDOWOODO.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: SUDOWOODO.images[1].value,
        pokemonLevel: 37,
        pokemonNumber: SUDOWOODO.number,
        pokemonType: SUDOWOODO.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 26,
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: 80,
        id: 'neo_rev_27_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: SUICUNE$1.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: SUICUNE$1.images[1].value,
        pokemonLevel: 37,
        pokemonNumber: SUICUNE$1.number,
        pokemonType: SUICUNE$1.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 27,
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        evolvesFrom: MAREEP.name,
        evolutionBoxImageUrl: MAREEP.images[0].value,
        hitPoints: 80,
        id: 'neo_rev_28_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: FLAAFFY.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: FLAAFFY.images[1].value,
        pokemonLevel: 37,
        pokemonNumber: FLAAFFY.number,
        pokemonType: FLAAFFY.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 28,
        stage: FLAAFFY.stage,
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: ZUBAT$1.name,
        evolutionBoxImageUrl: ZUBAT$1.images[0].value,
        hitPoints: 80,
        id: 'neo_rev_29_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: GOLBAT$2.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: GOLBAT$2.images[2].value,
        pokemonLevel: 37,
        pokemonNumber: GOLBAT$2.number,
        pokemonType: GOLBAT$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 29,
        stage: GOLBAT$2.stage,
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        evolvesFrom: GEODUDE.name,
        evolutionBoxImageUrl: GEODUDE.images[0].value,
        hitPoints: 80,
        id: 'neo_rev_30_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: GRAVELER$1.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: GRAVELER$1.images[4].value,
        pokemonLevel: 37,
        pokemonNumber: GRAVELER$1.number,
        pokemonType: GRAVELER$1.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 30,
        stage: GRAVELER$1.stage,
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: 80,
        id: 'neo_rev_31_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: JYNX$1.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: JYNX$1.images[2].value,
        pokemonLevel: 37,
        pokemonNumber: JYNX$1.number,
        pokemonType: JYNX$1.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 31,
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        evolvesFrom: CHINCHOU.name,
        evolutionBoxImageUrl: CHINCHOU.images[0].value,
        hitPoints: 80,
        id: 'neo_rev_32_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: LANTURN$1.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: LANTURN$1.images[1].value,
        pokemonLevel: 37,
        pokemonNumber: LANTURN$1.number,
        pokemonType: LANTURN$1.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 32,
        stage: LANTURN$1.stage,
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        evolvesFrom: SLUGMA$2.name,
        evolutionBoxImageUrl: SLUGMA$2.images[0].value,
        hitPoints: 80,
        id: 'neo_rev_33_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: MAGCARGO$2.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: MAGCARGO$2.images[1].value,
        pokemonLevel: 37,
        pokemonNumber: MAGCARGO$2.number,
        pokemonType: MAGCARGO$2.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 33,
        stage: MAGCARGO$2.stage,
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: REMORAID.name,
        evolutionBoxImageUrl: REMORAID.images[0].value,
        hitPoints: 80,
        id: 'neo_rev_34_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: OCTILLERY.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: OCTILLERY.images[0].value,
        pokemonLevel: 37,
        pokemonNumber: OCTILLERY.number,
        pokemonType: OCTILLERY.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 34,
        stage: OCTILLERY.stage,
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: PARAS.name,
        evolutionBoxImageUrl: PARAS.images[0].value,
        hitPoints: 80,
        id: 'neo_rev_35_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: PARASECT.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: PARASECT.images[1].value,
        pokemonLevel: 37,
        pokemonNumber: PARASECT.number,
        pokemonType: PARASECT.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 35,
        stage: PARASECT.stage,
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        evolvesFrom: SWINUB$2.name,
        evolutionBoxImageUrl: SWINUB$2.images[0].value,
        hitPoints: 80,
        id: 'neo_rev_36_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: PILOSWINE$3.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: PILOSWINE$3.images[1].value,
        pokemonLevel: 37,
        pokemonNumber: PILOSWINE$3.number,
        pokemonType: PILOSWINE$3.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 36,
        stage: PILOSWINE$3.stage,
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: GOLDEEN.name,
        evolutionBoxImageUrl: GOLDEEN.images[0].value,
        hitPoints: 80,
        id: 'neo_rev_37_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: SEAKING.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: SEAKING.images[2].value,
        pokemonLevel: 37,
        pokemonNumber: SEAKING.number,
        pokemonType: SEAKING.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 37,
        stage: SEAKING.stage,
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: 80,
        id: 'neo_rev_38_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: STANTLER$1.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: STANTLER$1.images[1].value,
        pokemonLevel: 37,
        pokemonNumber: STANTLER$1.number,
        pokemonType: STANTLER$1.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 38,
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.UNOWN,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: 80,
        id: 'neo_rev_39_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: UNOWN_B.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: UNOWN_B.images[0].value,
        pokemonLevel: 37,
        pokemonNumber: UNOWN_B.number,
        pokemonType: UNOWN_B.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 39,
        unownLetter: 'B',
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.UNOWN,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: 80,
        id: 'neo_rev_40_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: UNOWN_Y.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: UNOWN_Y.images[0].value,
        pokemonLevel: 37,
        pokemonNumber: UNOWN_Y.number,
        pokemonType: UNOWN_Y.pokemonType,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 40,
        unownLetter: 'Y',
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: 80,
        id: 'neo_rev_41_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: AIPOM.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: AIPOM.images[1].value,
        pokemonLevel: 37,
        pokemonNumber: AIPOM.number,
        pokemonType: AIPOM.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 41,
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        hitPoints: 80,
        id: 'neo_rev_42_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: CHINCHOU.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: CHINCHOU.images[1].value,
        pokemonLevel: 37,
        pokemonNumber: CHINCHOU.number,
        pokemonType: CHINCHOU.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 42,
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: 80,
        id: 'neo_rev_43_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: FARFETCHD$2.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: FARFETCHD$2.images[1].value,
        pokemonLevel: 37,
        pokemonNumber: FARFETCHD$2.number,
        pokemonType: FARFETCHD$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 43,
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        hitPoints: 80,
        id: 'neo_rev_44_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: GEODUDE.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: GEODUDE.images[5].value,
        pokemonLevel: 37,
        pokemonNumber: GEODUDE.number,
        pokemonType: GEODUDE.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 44,
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: 80,
        id: 'neo_rev_45_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: GOLDEEN.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: GOLDEEN.images[4].value,
        pokemonLevel: 37,
        pokemonNumber: GOLDEEN.number,
        pokemonType: GOLDEEN.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 45,
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.DARKNESS,
        energyWeakness: null,
        hitPoints: 80,
        id: 'neo_rev_46_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: MURKROW$2.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: MURKROW$2.images[1].value,
        pokemonLevel: 37,
        pokemonNumber: MURKROW$2.number,
        pokemonType: MURKROW$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 46,
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: 80,
        id: 'neo_rev_47_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: PARAS.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: PARAS.images[2].value,
        pokemonLevel: 37,
        pokemonNumber: PARAS.number,
        pokemonType: PARAS.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 47,
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: WOOPER.name,
        evolutionBoxImageUrl: WOOPER.images[0].value,
        hitPoints: 80,
        id: 'neo_rev_48_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: QUAGSIRE$1.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: QUAGSIRE$1.images[1].value,
        pokemonLevel: 37,
        pokemonNumber: QUAGSIRE$1.number,
        pokemonType: QUAGSIRE$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 48,
        stage: QUAGSIRE$1.stage,
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: 80,
        id: 'neo_rev_49_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: QWILFISH.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: QWILFISH.images[0].value,
        pokemonLevel: 37,
        pokemonNumber: QWILFISH.number,
        pokemonType: QWILFISH.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 49,
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: 80,
        id: 'neo_rev_50_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: REMORAID.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: REMORAID.images[1].value,
        pokemonLevel: 37,
        pokemonNumber: REMORAID.number,
        pokemonType: REMORAID.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 50,
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        hitPoints: 80,
        id: 'neo_rev_51_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: SHUCKLE$2.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: SHUCKLE$2.images[1].value,
        pokemonLevel: 37,
        pokemonNumber: SHUCKLE$2.number,
        pokemonType: SHUCKLE$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 51,
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: HOPPIP.name,
        evolutionBoxImageUrl: HOPPIP.images[0].value,
        hitPoints: 80,
        id: 'neo_rev_52_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: SKIPLOOM.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: SKIPLOOM.images[1].value,
        pokemonLevel: 37,
        pokemonNumber: SKIPLOOM.number,
        pokemonType: SKIPLOOM.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 52,
        stage: SKIPLOOM.stage,
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        hitPoints: 80,
        id: 'neo_rev_53_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: SLUGMA$2.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: SLUGMA$2.images[0].value,
        pokemonLevel: 37,
        pokemonNumber: SLUGMA$2.number,
        pokemonType: SLUGMA$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 53,
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: 80,
        id: 'neo_rev_54_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: SMOOCHUM.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: SMOOCHUM.images[0].value,
        pokemonLevel: 37,
        pokemonNumber: SMOOCHUM.number,
        pokemonType: SMOOCHUM.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 54,
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: 80,
        id: 'neo_rev_55_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: SNUBBULL$1.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: SNUBBULL$1.images[2].value,
        pokemonLevel: 37,
        pokemonNumber: SNUBBULL$1.number,
        pokemonType: SNUBBULL$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 55,
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: 80,
        id: 'neo_rev_56_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: STARYU$2.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: STARYU$2.images[3].value,
        pokemonLevel: 37,
        pokemonNumber: STARYU$2.number,
        pokemonType: STARYU$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 56,
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        hitPoints: 80,
        id: 'neo_rev_57_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: SWINUB$2.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: SWINUB$2.images[1].value,
        pokemonLevel: 37,
        pokemonNumber: SWINUB$2.number,
        pokemonType: SWINUB$2.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 57,
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.UNOWN,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: 80,
        id: 'neo_rev_58_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: UNOWN_K.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: UNOWN_K.images[0].value,
        pokemonLevel: 37,
        pokemonNumber: UNOWN_K.number,
        pokemonType: UNOWN_K.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 58,
        unownLetter: 'K',
        weight: 132,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: 80,
        id: 'neo_rev_59_en',
        illustrator: null,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: ZUBAT$1.name,
        pokemonImagePositionX: 48,
        pokemonImagePositionY: 41,
        pokemonImageSize: 48,
        pokemonImageUrl: ZUBAT$1.images[4].value,
        pokemonLevel: 37,
        pokemonNumber: ZUBAT$1.number,
        pokemonType: ZUBAT$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 59,
        weight: 132,
    },
];

const holoStrength$2 = 0.7;
const { GYARADOS: GYARADOS$2, MAGIKARP: MAGIKARP$2 } = GEN_1_POKEMON;
const NEO_REVELATION_SHININGS = [
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.SHINING,
        description: 'Once it appears, it goes on a rampage. It remains enraged until it demolishes everything around it.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.GRASS,
        hitPoints: 100,
        holo: true,
        holoStrength: holoStrength$2,
        id: 'neo_rev_65_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        isShining: true,
        lengthFeet: 21,
        lengthInches: 4,
        moves: [],
        name: `Shining ${GYARADOS$2.name}`,
        pokemonImagePositionX: 40,
        pokemonImagePositionY: 47,
        pokemonImageSize: 59,
        pokemonImageUrl: GYARADOS$2.images[4].value,
        pokemonLevel: 44,
        pokemonNumber: GYARADOS$2.number,
        pokemonType: GYARADOS$2.pokemonType,
        rarity: RARITY_TYPES.SHINING,
        setNumber: 65,
        weight: 518,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.NEO,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.SHINING,
        description: 'An underpowered, pathetic Pokémon. It may jump high on rare occasions, but never more than seven feet.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 30,
        holo: true,
        holoStrength: holoStrength$2,
        id: 'neo_rev_66_en',
        illustrator: ILLUSTRATORS.SUGIMORI,
        isShining: true,
        lengthFeet: 2,
        lengthInches: 11,
        moves: [],
        name: `Shining ${MAGIKARP$2.name}`,
        pokemonImagePositionX: 65,
        pokemonImagePositionY: 42,
        pokemonImageSize: 35,
        pokemonImageUrl: MAGIKARP$2.images[4].value,
        pokemonLevel: 11,
        pokemonNumber: MAGIKARP$2.number,
        pokemonType: MAGIKARP$2.pokemonType,
        rarity: RARITY_TYPES.SHINING,
        setNumber: 66,
        weight: 22,
    },
];

const { BALLOON_BERRY, HEALING_FIELD, POKEMON_BREEDER_FIELDS, ROCKETS_HIDEOUT, OLD_ROD, } = NEO_TRAINERS;
const NEO_REVELATION_TRAINERS = [
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'neo_rev_60_en',
        illustrator: null,
        name: BALLOON_BERRY.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 60,
        subtitle: TRAINER_CARD_SUBTITLES.POKEMON_TOOL,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'neo_rev_61_en',
        illustrator: null,
        name: HEALING_FIELD.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 61,
        subtitle: TRAINER_CARD_SUBTITLES.STADIUM_CARD,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'neo_rev_62_en',
        illustrator: null,
        name: POKEMON_BREEDER_FIELDS.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 62,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'neo_rev_63_en',
        illustrator: null,
        name: ROCKETS_HIDEOUT.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 63,
        subtitle: TRAINER_CARD_SUBTITLES.STADIUM_CARD,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER,
        description: '',
        id: 'neo_rev_64_en',
        illustrator: null,
        name: OLD_ROD.name,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 64,
    },
];

const setId$3 = CARD_SETS.NEO_REVELATION.value;
const setName$3 = CARD_SETS.NEO_REVELATION.label;
const setTotal$2 = NEO_REVELATION_SET_TOTAL;
const NEO_REVELATION_SET = {
    cardCounts: {
        secretRares: 2,
        holoRares: 14,
        rares: 13,
        uncommons: 17,
        commons: 20,
    },
    copyright: COPYRIGHTS.NEO_SET,
    description: SET_DESCRIPTIONS.NEO_REVELATION,
    holoSheetType: CARD_HOLO_SHEETS.COSMOS_2,
    id: setId$3,
    imageUrl: 'https://cdn.shopify.com/s/files/1/0840/1659/5249/collections/neo-revelation-cat-bg.jpg',
    name: setName$3,
    packInfo: BOOSTER_PACKS.NEO_REVELATION,
    releaseDate: RELEASE_DATES.NEO_REVELATION,
    reverseHoloSheetType: CARD_HOLO_SHEETS.COSMOS_2,
    setSymbol: setId$3,
    setTotal: setTotal$2,
    cards: [
        ...NEO_REVELATION_HOLOS,
        ...NEO_REVELATION_NON_HOLOS,
        ...NEO_REVELATION_TRAINERS,
        ...NEO_REVELATION_SHININGS,
    ],
    themeDecks: [],
};

const holoStrength$1 = 0.7;
const { BUTTERFREE: BUTTERFREE$1, EXEGGUTOR: EXEGGUTOR$1, IVYSAUR, JIGGLYPUFF: JIGGLYPUFF$1, LAPRAS: LAPRAS$2, LICKITUNG: LICKITUNG$1, MEW, ONIX: ONIX$1, PIDGEOT: PIDGEOT$1, PRIMEAPE: PRIMEAPE$1, RATICATE: RATICATE$1, TENTACRUEL, VILEPLUME, WARTORTLE, } = GEN_1_POKEMON;
const { LEDYBA: LEDYBA$2, MARILL, SLOWKING: SLOWKING$1, TOGEPI } = GEN_2_POKEMON;
const SOUTHERN_ISLANDS_CARDS = [
    {
        backgroundImageUrl: MEW.images[1].value,
        cardTemplate: CARD_TEMPLATES.NEO,
        description: "This Pokémon's body is covered by fine hairs that can be seen only under a microscope.",
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 30,
        holo: 'reverse',
        holoStrength: holoStrength$1,
        id: 'southern_islands_1_en',
        illustrator: ILLUSTRATORS.FUKUYAMA,
        lengthFeet: 1,
        lengthInches: 4,
        moves: [],
        name: MEW.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: 5,
        pokemonNumber: MEW.number,
        pokemonType: MEW.pokemonType,
        setNumber: 1,
        weight: 8.8,
    },
    {
        backgroundImageUrl: PIDGEOT$1.images[1].value,
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'This Pokémon searches for food while flying at Mach 2. Its large claws make fearsome weapons.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 70,
        holoStrength: holoStrength$1,
        id: 'southern_islands_2_en',
        illustrator: ILLUSTRATORS.FUKUYAMA,
        lengthFeet: 4,
        lengthInches: 11,
        moves: [],
        name: PIDGEOT$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: 39,
        pokemonNumber: PIDGEOT$1.number,
        pokemonType: PIDGEOT$1.pokemonType,
        setNumber: 2,
        stage: PIDGEOT$1.stage,
        weight: 87,
    },
    {
        backgroundImageUrl: ONIX$1.images[4].value,
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'This Pokémon burrows through the earth at high speed, looking for food. The tunnels it digs are used by Diglett as nests.',
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.GRASS,
        hitPoints: 90,
        holoStrength: holoStrength$1,
        id: 'southern_islands_3_en',
        illustrator: ILLUSTRATORS.FUKUYAMA,
        lengthFeet: 28,
        lengthInches: 10,
        moves: [],
        name: ONIX$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: 40,
        pokemonNumber: ONIX$1.number,
        pokemonType: ONIX$1.pokemonType,
        setNumber: 3,
        weight: 463,
    },
    {
        backgroundImageUrl: TOGEPI.images[2].value,
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'This Pokémon is still immature. When threatened, it releases poison from its head and tries to drive its enemies away.',
        energyResistance: ENERGY_TYPES.PSYCHIC,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.COLORLESS,
        hitPoints: 40,
        holo: 'reverse',
        holoStrength: holoStrength$1,
        id: 'southern_islands_4_en',
        illustrator: ILLUSTRATORS.FUKUYAMA,
        lengthFeet: 1,
        lengthInches: 0,
        moves: [],
        name: TOGEPI.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: 10,
        pokemonNumber: TOGEPI.number,
        pokemonType: TOGEPI.pokemonType,
        setNumber: 4,
        weight: 3,
    },
    {
        backgroundImageUrl: IVYSAUR.images[3].value,
        cardTemplate: CARD_TEMPLATES.NEO,
        description: "A sure sign spring is on its way is when the seed on this Pokémon's back flowers.",
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        hitPoints: 60,
        holoStrength: holoStrength$1,
        id: 'southern_islands_5_en',
        illustrator: ILLUSTRATORS.FUKUYAMA,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: IVYSAUR.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: 23,
        pokemonNumber: IVYSAUR.number,
        pokemonType: IVYSAUR.pokemonType,
        setNumber: 5,
        stage: IVYSAUR.stage,
        weight: 29,
    },
    {
        backgroundImageUrl: RATICATE$1.images[3].value,
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'This Pokémon sometimes hunts for food in rivers, swimming using the small webs between the toes on its rear legs.',
        energyResistance: ENERGY_TYPES.PSYCHIC,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 60,
        holoStrength: holoStrength$1,
        id: 'southern_islands_6_en',
        illustrator: ILLUSTRATORS.FUKUYAMA,
        lengthFeet: 2,
        lengthInches: 4,
        moves: [],
        name: RATICATE$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: 25,
        pokemonNumber: RATICATE$1.number,
        pokemonType: RATICATE$1.pokemonType,
        setNumber: 6,
        stage: RATICATE$1.stage,
        weight: 41,
    },
    {
        backgroundImageUrl: LEDYBA$2.images[2].value,
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'When it senses enemies approaching, this Pokémon releases an orange fluid from the joints in its legs and flees.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        hitPoints: 40,
        holo: 'reverse',
        holoStrength: holoStrength$1,
        id: 'southern_islands_7_en',
        illustrator: ILLUSTRATORS.FUKUYAMA,
        isReverseHolo: true,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: LEDYBA$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: 12,
        pokemonNumber: LEDYBA$2.number,
        pokemonType: LEDYBA$2.pokemonType,
        setNumber: 7,
        weight: 24,
    },
    {
        backgroundImageUrl: JIGGLYPUFF$1.images[4].value,
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'After lulling its enemies with its large eyes, this Pokémon sings them to sleep with a relaxing melody.',
        energyResistance: ENERGY_TYPES.PSYCHIC,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 50,
        holoStrength: holoStrength$1,
        id: 'southern_islands_8_en',
        illustrator: ILLUSTRATORS.FUKUYAMA,
        lengthFeet: 1,
        lengthInches: 8,
        moves: [],
        name: JIGGLYPUFF$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: 10,
        pokemonNumber: JIGGLYPUFF$1.number,
        pokemonType: JIGGLYPUFF$1.pokemonType,
        setNumber: 8,
        weight: 12,
    },
    {
        backgroundImageUrl: BUTTERFREE$1.images[2].value,
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'The poison scales on its wings are waterproof, allowing this Pokémon to be active even on rainy days.',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        hitPoints: 80,
        holoStrength: holoStrength$1,
        id: 'southern_islands_9_en',
        illustrator: ILLUSTRATORS.FUKUYAMA,
        lengthFeet: 3,
        lengthInches: 7,
        moves: [],
        name: BUTTERFREE$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: 37,
        pokemonNumber: BUTTERFREE$1.number,
        pokemonType: BUTTERFREE$1.pokemonType,
        setNumber: 9,
        stage: BUTTERFREE$1.stage,
        weight: 71,
    },
    {
        backgroundImageUrl: TENTACRUEL.images[2].value,
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'This Pokémon attacks its prey with its eighty toxin-producing tentacles.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 60,
        holoStrength: holoStrength$1,
        id: 'southern_islands_10_en',
        illustrator: ILLUSTRATORS.KIMURA,
        lengthFeet: 5,
        lengthInches: 3,
        moves: [],
        name: TENTACRUEL.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: 30,
        pokemonNumber: TENTACRUEL.number,
        pokemonType: TENTACRUEL.pokemonType,
        setNumber: 10,
        stage: TENTACRUEL.stage,
        weight: 121,
    },
    {
        backgroundImageUrl: MARILL.images[2].value,
        cardTemplate: CARD_TEMPLATES.NEO,
        description: "This Pokémon's fur repels water like a duck's feathers, allowing it to stay dry and fluffy even in water.",
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 40,
        holo: 'reverse',
        holoStrength: holoStrength$1,
        id: 'southern_islands_11_en',
        illustrator: ILLUSTRATORS.KIMURA,
        lengthFeet: 1,
        lengthInches: 4,
        moves: [],
        name: MARILL.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: 10,
        pokemonNumber: MARILL.number,
        pokemonType: MARILL.pokemonType,
        setNumber: 11,
        weight: 19,
    },
    {
        backgroundImageUrl: LAPRAS$2.images[1].value,
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'This gentle Pokémon can understand human language and allows people to ride on its back.',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 70,
        holoStrength: holoStrength$1,
        id: 'southern_islands_12_en',
        illustrator: ILLUSTRATORS.KIMURA,
        lengthFeet: 8,
        lengthInches: 2,
        moves: [],
        name: LAPRAS$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: 30,
        pokemonNumber: LAPRAS$2.number,
        pokemonType: LAPRAS$2.pokemonType,
        setNumber: 12,
        weight: 485,
    },
    {
        backgroundImageUrl: EXEGGUTOR$1.images[2].value,
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'This Pokémon has a unique cry, as all three of its heads are always talking independently of one another.',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        hitPoints: 70,
        holoStrength: holoStrength$1,
        id: 'southern_islands_13_en',
        illustrator: ILLUSTRATORS.KIMURA,
        lengthFeet: 6,
        lengthInches: 7,
        moves: [],
        name: EXEGGUTOR$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: 27,
        pokemonNumber: EXEGGUTOR$1.number,
        pokemonType: EXEGGUTOR$1.pokemonType,
        setNumber: 13,
        stage: EXEGGUTOR$1.stage,
        weight: 265,
    },
    {
        backgroundImageUrl: SLOWKING$1.images[1].value,
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'Its nonchalant reaction to everything somehow gives this Pokémon an imposing presence.',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 70,
        holo: 'reverse',
        holoStrength: holoStrength$1,
        id: 'southern_islands_14_en',
        illustrator: ILLUSTRATORS.KIMURA,
        lengthFeet: 6,
        lengthInches: 8,
        moves: [],
        name: SLOWKING$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: 36,
        pokemonNumber: SLOWKING$1.number,
        pokemonType: SLOWKING$1.pokemonType,
        setNumber: 14,
        stage: SLOWKING$1.stage,
        weight: 175,
    },
    {
        backgroundImageUrl: WARTORTLE.images[2].value,
        cardTemplate: CARD_TEMPLATES.NEO,
        description: "When attacked, this Pokémon withdraws into its shell, although it can't quite pull in all of its long tail.",
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 60,
        holoStrength: holoStrength$1,
        id: 'southern_islands_15_en',
        illustrator: ILLUSTRATORS.KIMURA,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: WARTORTLE.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: 20,
        pokemonNumber: WARTORTLE.number,
        pokemonType: WARTORTLE.pokemonType,
        setNumber: 15,
        stage: WARTORTLE.stage,
        weight: 50,
    },
    {
        backgroundImageUrl: LICKITUNG$1.images[2].value,
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'This Pokémon uses its six-foot-long tongue as if it were a hand. The origin of its anaesthetic properties is still a mystery.',
        energyResistance: ENERGY_TYPES.PSYCHIC,
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 70,
        holoStrength: holoStrength$1,
        id: 'southern_islands_16_en',
        illustrator: ILLUSTRATORS.KIMURA,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [],
        name: LICKITUNG$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: 25,
        pokemonNumber: LICKITUNG$1.number,
        pokemonType: LICKITUNG$1.pokemonType,
        setNumber: 16,
        weight: 144,
    },
    {
        backgroundImageUrl: VILEPLUME.images[3].value,
        cardTemplate: CARD_TEMPLATES.NEO,
        description: 'This Pokémon makes a loud jangling noise when it shakes its petals to spread poison powder.',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        hitPoints: 70,
        holo: 'reverse',
        holoStrength: holoStrength$1,
        id: 'southern_islands_17_en',
        illustrator: ILLUSTRATORS.KIMURA,
        lengthFeet: 3,
        lengthInches: 11,
        moves: [],
        name: VILEPLUME.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: 30,
        pokemonNumber: VILEPLUME.number,
        pokemonType: VILEPLUME.pokemonType,
        setNumber: 17,
        stage: VILEPLUME.stage,
        weight: 41,
    },
    {
        backgroundImageUrl: PRIMEAPE$1.images[2].value,
        cardTemplate: CARD_TEMPLATES.NEO,
        description: "This Pokémon only calms down when there are no other animals or people around - which means no one has ever seen it when it's not angry.",
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 60,
        holoStrength: holoStrength$1,
        id: 'southern_islands_18_en',
        illustrator: ILLUSTRATORS.KIMURA,
        lengthFeet: 3,
        lengthInches: 3,
        moves: [],
        name: PRIMEAPE$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: 26,
        pokemonNumber: PRIMEAPE$1.number,
        pokemonType: PRIMEAPE$1.pokemonType,
        setNumber: 18,
        stage: PRIMEAPE$1.stage,
        weight: 70.5,
    },
];

const setId$2 = CARD_SETS.SOUTHERN_ISLANDS.value;
const setName$2 = CARD_SETS.SOUTHERN_ISLANDS.label;
const SOUTHERN_ISLANDS_SET = {
    copyright: COPYRIGHTS.NEO_SET,
    description: SET_DESCRIPTIONS.SOUTHERN_ISLANDS,
    holoSheetType: CARD_HOLO_SHEETS.SWIRL,
    id: setId$2,
    imageUrl: 'https://cdn.shopify.com/s/files/1/0840/1659/5249/collections/southern-islands-cat-bg.jpg',
    name: setName$2,
    releaseDate: RELEASE_DATES.SOUTHERN_ISLANDS,
    reverseHoloSheetType: CARD_HOLO_SHEETS.SWIRL,
    setSymbol: setId$2,
    cards: [...SOUTHERN_ISLANDS_CARDS],
};

const { ALAKAZAM, ARCANINE, ARTICUNO: ARTICUNO$1, BEEDRILL: BEEDRILL$1, CHARIZARD: CHARIZARD$1, CHARMELEON, DEWGONG: DEWGONG$1, EEVEE: EEVEE$1, FLAREON: FLAREON$1, GENGAR: GENGAR$1, GOLBAT: GOLBAT$1, GOLEM, GRAVELER, GROWLITHE: GROWLITHE$1, GYARADOS: GYARADOS$1, HAUNTER: HAUNTER$1, JOLTEON: JOLTEON$1, KABUTO: KABUTO$1, KABUTOPS: KABUTOPS$1, KADABRA: KADABRA$1, KAKUNA: KAKUNA$1, MACHAMP: MACHAMP$1, MACHOKE: MACHOKE$1, MAGIKARP: MAGIKARP$1, MAGNEMITE: MAGNEMITE$1, MAGNETON: MAGNETON$1, MOLTRES, NIDORINA: NIDORINA$1, NIDOQUEEN, ONIX, PIKACHU: PIKACHU$1, POLIWHIRL: POLIWHIRL$1, POLIWRATH: POLIWRATH$1, RAICHU: RAICHU$1, RHYDON: RHYDON$1, RHYHORN: RHYHORN$1, SEEL: SEEL$1, STARMIE: STARMIE$1, STARYU: STARYU$1, VAPOREON, } = GEN_1_POKEMON;
const { CELEBI, CROBAT: CROBAT$1, FORRETRESS: FORRETRESS$2, HO_OH, HOUNDOOM: HOUNDOOM$1, HOUNDOUR: HOUNDOUR$1, LEDIAN: LEDIAN$1, LEDYBA: LEDYBA$1, MAGCARGO: MAGCARGO$1, NATU: NATU$1, PILOSWINE: PILOSWINE$2, PINECO: PINECO$1, POLITOED: POLITOED$1, RAIKOU: RAIKOU$1, SLUGMA: SLUGMA$1, STEELIX: STEELIX$1, SWINUB: SWINUB$1, UMBREON: UMBREON$1, XATU: XATU$1, } = GEN_2_POKEMON;
const holoStrength = 0.7;
const SKYRIDGE_HOLOS = [
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        evolvesFrom: KADABRA$1.name,
        energyWeakness: null,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength,
        id: 'skyridge_H1_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: ALAKAZAM.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H1',
        setTotal: E_HOLO_SET_TOTAL,
        stage: ALAKAZAM.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        evolvesFrom: GROWLITHE$1.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength,
        id: 'skyridge_H2_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: ARCANINE.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H2',
        setTotal: E_HOLO_SET_TOTAL,
        stage: ARCANINE.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength,
        id: 'skyridge_H3_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: ARTICUNO$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H3',
        setTotal: E_HOLO_SET_TOTAL,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: KAKUNA$1.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength,
        id: 'skyridge_H4_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: BEEDRILL$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H4',
        setTotal: E_HOLO_SET_TOTAL,
        stage: BEEDRILL$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: GOLBAT$1.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength,
        id: 'skyridge_H5_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: CROBAT$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H5',
        setTotal: E_HOLO_SET_TOTAL,
        stage: CROBAT$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: SEEL$1.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength,
        id: 'skyridge_H6_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: DEWGONG$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H6',
        setTotal: E_HOLO_SET_TOTAL,
        stage: DEWGONG$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        evolvesFrom: EEVEE$1.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength,
        id: 'skyridge_H7_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: FLAREON$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H7',
        setTotal: E_HOLO_SET_TOTAL,
        stage: FLAREON$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.METAL,
        energyWeakness: null,
        evolvesFrom: PINECO$1.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength,
        id: 'skyridge_H8_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: FORRETRESS$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H8',
        setTotal: E_HOLO_SET_TOTAL,
        stage: FORRETRESS$2.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        evolvesFrom: HAUNTER$1.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength,
        id: 'skyridge_H9_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: GENGAR$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H9',
        setTotal: E_HOLO_SET_TOTAL,
        stage: GENGAR$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: MAGIKARP$1.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength,
        id: 'skyridge_H10_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: GYARADOS$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H10',
        setTotal: E_HOLO_SET_TOTAL,
        stage: GYARADOS$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.DARKNESS,
        energyWeakness: null,
        evolvesFrom: HOUNDOUR$1.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength,
        id: 'skyridge_H11_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: HOUNDOOM$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H11',
        setTotal: E_HOLO_SET_TOTAL,
        stage: HOUNDOOM$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        evolvesFrom: EEVEE$1.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength,
        id: 'skyridge_H12_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: JOLTEON$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H12',
        setTotal: E_HOLO_SET_TOTAL,
        stage: JOLTEON$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        evolvesFrom: KABUTO$1.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength,
        id: 'skyridge_H13_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: KABUTOPS$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H13',
        setTotal: E_HOLO_SET_TOTAL,
        stage: KABUTOPS$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: LEDYBA$1.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength,
        id: 'skyridge_H14_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: LEDIAN$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H14',
        setTotal: E_HOLO_SET_TOTAL,
        stage: LEDIAN$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        evolvesFrom: MACHOKE$1.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength,
        id: 'skyridge_H15_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: MACHAMP$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H15',
        setTotal: E_HOLO_SET_TOTAL,
        stage: MACHAMP$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        evolvesFrom: SLUGMA$1.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength,
        id: 'skyridge_H16_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: MAGCARGO$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H16',
        setTotal: E_HOLO_SET_TOTAL,
        stage: MAGCARGO$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        evolvesFrom: SLUGMA$1.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength,
        id: 'skyridge_H17_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: MAGCARGO$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H17',
        setTotal: E_HOLO_SET_TOTAL,
        stage: MAGCARGO$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        evolvesFrom: MAGNEMITE$1.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength,
        id: 'skyridge_H18_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: MAGNETON$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H18',
        setTotal: E_HOLO_SET_TOTAL,
        stage: MAGNETON$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.METAL,
        energyWeakness: null,
        evolvesFrom: MAGNEMITE$1.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength,
        id: 'skyridge_H19_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: MAGNETON$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H19',
        setTotal: E_HOLO_SET_TOTAL,
        stage: MAGNETON$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength,
        id: 'skyridge_H20_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: MOLTRES.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H20',
        setTotal: E_HOLO_SET_TOTAL,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: NIDORINA$1.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength,
        id: 'skyridge_H21_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: NIDOQUEEN.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H21',
        setTotal: E_HOLO_SET_TOTAL,
        stage: NIDOQUEEN.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: SWINUB$1.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength,
        id: 'skyridge_H22_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: PILOSWINE$2.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H22',
        setTotal: E_HOLO_SET_TOTAL,
        stage: PILOSWINE$2.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: POLIWHIRL$1.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength,
        id: 'skyridge_H23_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: POLITOED$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H23',
        setTotal: E_HOLO_SET_TOTAL,
        stage: POLITOED$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        evolvesFrom: POLIWHIRL$1.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength,
        id: 'skyridge_H24_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: POLIWRATH$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H24',
        setTotal: E_HOLO_SET_TOTAL,
        stage: POLIWRATH$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        evolvesFrom: PIKACHU$1.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength,
        id: 'skyridge_H25_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: RAICHU$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H25',
        setTotal: E_HOLO_SET_TOTAL,
        stage: RAICHU$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength,
        id: 'skyridge_H26_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: RAIKOU$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H26',
        setTotal: E_HOLO_SET_TOTAL,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        evolvesFrom: RHYHORN$1.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength,
        id: 'skyridge_H27_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: RHYDON$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H27',
        setTotal: E_HOLO_SET_TOTAL,
        stage: RHYDON$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        evolvesFrom: STARYU$1.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength,
        id: 'skyridge_H28_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: STARMIE$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H28',
        setTotal: E_HOLO_SET_TOTAL,
        stage: STARMIE$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.METAL,
        energyWeakness: null,
        evolvesFrom: ONIX.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength,
        id: 'skyridge_H29_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: STEELIX$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H29',
        setTotal: E_HOLO_SET_TOTAL,
        stage: STEELIX$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.DARKNESS,
        energyWeakness: null,
        evolvesFrom: EEVEE$1.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength,
        id: 'skyridge_H30_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: UMBREON$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H30',
        setTotal: E_HOLO_SET_TOTAL,
        stage: UMBREON$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: EEVEE$1.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength,
        id: 'skyridge_H31_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: VAPOREON.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H31',
        setTotal: E_HOLO_SET_TOTAL,
        stage: VAPOREON.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        evolvesFrom: NATU$1.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength,
        id: 'skyridge_H32_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: XATU$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 'H32',
        setTotal: E_HOLO_SET_TOTAL,
        stage: XATU$1.stage,
        weight: null,
    },
];
const SKYRIDGE_CRYSTAL_HOLOS = [
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength,
        id: 'skyridge_145_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: CELEBI.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 145,
        specialTemplateType: SPECIAL_CARD_TEMPLATES.CRYSTAL,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        evolvesFrom: CHARMELEON.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength,
        id: 'skyridge_146_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: CHARIZARD$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 146,
        specialTemplateType: SPECIAL_CARD_TEMPLATES.CRYSTAL,
        stage: CHARIZARD$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        evolvesFrom: GOLBAT$1.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength,
        id: 'skyridge_147_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: CROBAT$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 147,
        specialTemplateType: SPECIAL_CARD_TEMPLATES.CRYSTAL,
        stage: CROBAT$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        evolvesFrom: GRAVELER.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength,
        id: 'skyridge_148_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: GOLEM.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 148,
        specialTemplateType: SPECIAL_CARD_TEMPLATES.CRYSTAL,
        stage: GOLEM.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength,
        id: 'skyridge_149_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: HO_OH.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 149,
        specialTemplateType: SPECIAL_CARD_TEMPLATES.CRYSTAL,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        evolvesFrom: KABUTO$1.name,
        hitPoints: null,
        holo: true,
        holoStrength: holoStrength,
        id: 'skyridge_150_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: KABUTOPS$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 150,
        specialTemplateType: SPECIAL_CARD_TEMPLATES.CRYSTAL,
        stage: KABUTOPS$1.stage,
        weight: null,
    },
];
const SKYRIDGE_CRYSTALS = [
    {
        ...SKYRIDGE_CRYSTAL_HOLOS[0],
    },
    {
        ...SKYRIDGE_CRYSTAL_HOLOS[0],
        holo: 'reverse',
        id: `${SKYRIDGE_CRYSTAL_HOLOS[0].id}_rh`,
    },
    {
        ...SKYRIDGE_CRYSTAL_HOLOS[1],
    },
    {
        ...SKYRIDGE_CRYSTAL_HOLOS[1],
        holo: 'reverse',
        id: `${SKYRIDGE_CRYSTAL_HOLOS[1].id}_rh`,
    },
    {
        ...SKYRIDGE_CRYSTAL_HOLOS[2],
    },
    {
        ...SKYRIDGE_CRYSTAL_HOLOS[2],
        holo: 'reverse',
        id: `${SKYRIDGE_CRYSTAL_HOLOS[2].id}_rh`,
    },
    {
        ...SKYRIDGE_CRYSTAL_HOLOS[3],
    },
    {
        ...SKYRIDGE_CRYSTAL_HOLOS[3],
        holo: 'reverse',
        id: `${SKYRIDGE_CRYSTAL_HOLOS[3].id}_rh`,
    },
    {
        ...SKYRIDGE_CRYSTAL_HOLOS[4],
    },
    {
        ...SKYRIDGE_CRYSTAL_HOLOS[4],
        holo: 'reverse',
        id: `${SKYRIDGE_CRYSTAL_HOLOS[4].id}_rh`,
    },
    {
        ...SKYRIDGE_CRYSTAL_HOLOS[5],
    },
    {
        ...SKYRIDGE_CRYSTAL_HOLOS[5],
        holo: 'reverse',
        id: `${SKYRIDGE_CRYSTAL_HOLOS[5].id}_rh`,
    },
];

const SPECIAL_POKEMON = {
    BURIED_FOSSIL: {
        name: 'Buried Fossil',
        images: [],
    },
};

const { MYSTERIOUS_FOSSIL } = JUNGLE_FOSSIL_TRAINERS;
const { ABRA, AERODACTYL: AERODACTYL$1, CLEFAIRY, DIGLETT, DITTO, DUGTRIO, EEVEE, ELECTRODE, FARFETCHD: FARFETCHD$1, GASTLY, GOLBAT, GROWLITHE, HAUNTER, JIGGLYPUFF, KABUTO, KADABRA, KAKUNA, LAPRAS: LAPRAS$1, MACHOKE, MACHOP, MAGIKARP, MAGNEMITE, MEOWTH, NIDORAN_F, NIDORINA, OMANYTE, OMASTAR: OMASTAR$1, PERSIAN: PERSIAN$1, PIKACHU, POLIWAG, POLIWHIRL, RATICATE, RATTATA, RHYHORN, SANDSHREW, SANDSLASH, SEEL, SNORLAX, STARMIE, STARYU, VENOMOTH: VENOMOTH$1, VENONAT, VOLTORB, WEEDLE, WIGGLYTUFF: WIGGLYTUFF$1, ZUBAT, } = GEN_1_POKEMON;
const { CLEFFA, DELIBIRD: DELIBIRD$1, DUNSPARCE, FORRETRESS: FORRETRESS$1, GIRAFARIG: GIRAFARIG$1, GLIGAR, GRANBULL: GRANBULL$1, HERACROSS, HOOTHOOT, HOUNDOUR, IGGLYBUFF, LEDYBA, MANTINE: MANTINE$1, MISDREAVUS: MISDREAVUS$1, MURKROW: MURKROW$1, NATU, NOCTOWL: NOCTOWL$1, PILOSWINE: PILOSWINE$1, PINECO, SHUCKLE: SHUCKLE$1, SKARMORY: SKARMORY$1, SLUGMA, SNUBBULL, STANTLER, SUNFLORA, SUNKERN, SWINUB, TEDDIURSA, URSARING: URSARING$1, WOBBUFFET: WOBBUFFET$1, YANMA: YANMA$1, } = GEN_2_POKEMON;
const { BURIED_FOSSIL } = SPECIAL_POKEMON;
const SKYRIDGE_NON_HOLOS = [
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        evolvesFrom: MYSTERIOUS_FOSSIL.name,
        evolutionBoxImageUrl: MYSTERIOUS_FOSSIL.image,
        hitPoints: null,
        id: 'skyridge_001_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: AERODACTYL$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 1,
        stage: AERODACTYL$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: OMANYTE.name,
        evolutionBoxImageUrl: '',
        hitPoints: null,
        id: 'skyridge_023_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: OMASTAR$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 23,
        stage: OMASTAR$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        evolvesFrom: JIGGLYPUFF.name,
        evolutionBoxImageUrl: '',
        hitPoints: null,
        id: 'skyridge_034_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: WIGGLYTUFF$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.RARE,
        setNumber: 34,
        stage: WIGGLYTUFF$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        evolvesFrom: VOLTORB.name,
        evolutionBoxImageUrl: '',
        hitPoints: null,
        id: 'skyridge_036_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: ELECTRODE.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 36,
        stage: ELECTRODE.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_037_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: KABUTO.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 37,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        evolvesFrom: MACHOP.name,
        evolutionBoxImageUrl: '',
        hitPoints: null,
        id: 'skyridge_038_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: MACHOKE.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 38,
        stage: MACHOKE.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_039_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: MISDREAVUS$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 39,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        evolvesFrom: HOOTHOOT.name,
        evolutionBoxImageUrl: '',
        hitPoints: null,
        id: 'skyridge_040_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: NOCTOWL$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 40,
        stage: NOCTOWL$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_041_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: OMANYTE.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 41,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        evolvesFrom: MEOWTH.name,
        evolutionBoxImageUrl: '',
        hitPoints: null,
        id: 'skyridge_042_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: PERSIAN$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 42,
        stage: PERSIAN$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        evolvesFrom: SWINUB.name,
        evolutionBoxImageUrl: '',
        hitPoints: null,
        id: 'skyridge_043_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: PILOSWINE$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 43,
        stage: PILOSWINE$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: STARYU.name,
        evolutionBoxImageUrl: '',
        hitPoints: null,
        id: 'skyridge_044_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: STARMIE.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 44,
        stage: STARMIE.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_045_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: WOBBUFFET$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 45,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_046_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: ABRA.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 46,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_047_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: BURIED_FOSSIL.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 47,
        specialTemplateType: SPECIAL_CARD_TEMPLATES.FOSSIL,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.BABY,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        evolvesTo: CLEFAIRY.name,
        hitPoints: null,
        id: 'skyridge_048_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: CLEFFA.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 48,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_049_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: DELIBIRD$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 49,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_050_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: DIGLETT.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 50,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_051_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: DITTO.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 51,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        evolvesFrom: DIGLETT.name,
        evolutionBoxImageUrl: '',
        hitPoints: null,
        id: 'skyridge_052_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: DUGTRIO.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 52,
        stage: DUGTRIO.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_053_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: DUNSPARCE.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 53,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_054_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: EEVEE.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 54,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_055_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: FARFETCHD$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 55,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: PINECO.name,
        evolutionBoxImageUrl: '',
        hitPoints: null,
        id: 'skyridge_056_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: FORRETRESS$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 56,
        stage: FORRETRESS$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_057_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: GASTLY.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 57,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_058_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: GIRAFARIG$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 58,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_059_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: GLIGAR.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 59,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: ZUBAT.name,
        evolutionBoxImageUrl: '',
        hitPoints: null,
        id: 'skyridge_060_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: GOLBAT.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 60,
        stage: GOLBAT.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: SNUBBULL.name,
        evolutionBoxImageUrl: '',
        hitPoints: null,
        id: 'skyridge_061_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: GRANBULL$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 61,
        stage: GRANBULL$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_062_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: GROWLITHE.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 62,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        evolvesFrom: GASTLY.name,
        evolutionBoxImageUrl: '',
        hitPoints: null,
        id: 'skyridge_063_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: HAUNTER.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 63,
        stage: HAUNTER.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_064_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: HERACROSS.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 64,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_065_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: HOOTHOOT.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 65,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_066_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: HOUNDOUR.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 66,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        cardTemplateSubtype: CARD_TEMPLATE_SUBTYPES.BABY,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        evolvesTo: JIGGLYPUFF.name,
        hitPoints: null,
        id: 'skyridge_067_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: IGGLYBUFF.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 67,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_068_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: JIGGLYPUFF.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 68,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        evolvesFrom: ABRA.name,
        evolutionBoxImageUrl: '',
        hitPoints: null,
        id: 'skyridge_069_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: KADABRA.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 69,
        stage: KADABRA.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: WEEDLE.name,
        evolutionBoxImageUrl: '',
        hitPoints: null,
        id: 'skyridge_070_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: KAKUNA.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 70,
        stage: KAKUNA.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_071_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: LAPRAS$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 71,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_072_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: LEDYBA.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 72,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_073_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: LEDYBA.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 73,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_074_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: MACHOP.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 74,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_075_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: MAGIKARP.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 75,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_076_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: MAGNEMITE.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 76,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_077_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: MANTINE$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 77,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_078_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: MEOWTH.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 78,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.DARKNESS,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_079_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: MURKROW$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 79,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_080_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: NATU.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 80,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_081_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: NIDORAN_F.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 81,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_082_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: NIDORAN_F.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 82,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: NIDORAN_F.name,
        evolutionBoxImageUrl: '',
        hitPoints: null,
        id: 'skyridge_083_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: NIDORINA.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 83,
        stage: NIDORINA.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_084_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: PIKACHU.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 84,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_085_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: PINECO.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 85,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_086_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: PINECO.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 86,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_087_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: POLIWAG.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 87,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        evolvesFrom: POLIWAG.name,
        evolutionBoxImageUrl: '',
        hitPoints: null,
        id: 'skyridge_088_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: POLIWHIRL.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 88,
        stage: POLIWHIRL.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        evolvesFrom: RATTATA.name,
        evolutionBoxImageUrl: '',
        hitPoints: null,
        id: 'skyridge_089_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: RATICATE.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 89,
        stage: RATICATE.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_090_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: RATTATA.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 90,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_091_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: RHYHORN.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 91,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_092_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: SANDSHREW.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 92,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        evolvesFrom: SANDSHREW.name,
        evolutionBoxImageUrl: '',
        hitPoints: null,
        id: 'skyridge_093_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: SANDSLASH.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 93,
        stage: SANDSLASH.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_094_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: SEEL.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 94,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_095_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: SEEL.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 95,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_096_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: SHUCKLE$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 96,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.METAL,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_097_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: SKARMORY$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 97,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_098_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: SLUGMA.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 98,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_099_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: SLUGMA.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 99,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_100_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: SNORLAX.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 100,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_101_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: SNUBBULL.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 101,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_102_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: STANTLER.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 102,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_103_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: STARYU.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 103,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_104_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: STARYU.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 104,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: SUNKERN.name,
        evolutionBoxImageUrl: '',
        hitPoints: null,
        id: 'skyridge_105_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: SUNFLORA.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 105,
        stage: SUNFLORA.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_106_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: SUNKERN.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 106,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_107_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: SWINUB.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 107,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_108_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: SWINUB.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 108,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_109_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: TEDDIURSA.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 109,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: null,
        evolvesFrom: TEDDIURSA.name,
        evolutionBoxImageUrl: '',
        hitPoints: null,
        id: 'skyridge_110_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: URSARING$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 110,
        stage: URSARING$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        evolvesFrom: VENONAT.name,
        evolutionBoxImageUrl: '',
        hitPoints: null,
        id: 'skyridge_111_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: VENOMOTH$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 111,
        stage: VENOMOTH$1.stage,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_112_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: VENONAT.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 112,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_113_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: VOLTORB.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 113,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_114_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: WEEDLE.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 114,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_115_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: WEEDLE.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 115,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_116_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: YANMA$1.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 116,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_117_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: ZUBAT.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 117,
        weight: null,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.E_SERIES,
        description: '',
        energyResistance: null,
        energyRetreatCost: null,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: null,
        hitPoints: null,
        id: 'skyridge_118_en',
        illustrator: null,
        lengthFeet: null,
        lengthInches: null,
        moves: [],
        name: ZUBAT.name,
        pokemonImagePositionX: null,
        pokemonImagePositionY: null,
        pokemonImageSize: null,
        pokemonImageUrl: '',
        pokemonLevel: null,
        pokemonNumber: null,
        pokemonType: '',
        rarity: RARITY_TYPES.COMMON,
        setNumber: 118,
        weight: null,
    },
];

const { ANCIENT_RUINS, APRICORN_MAKER, CRYSTAL_SHARD, DESERT_SHAMAN, FAST_BALL, FISHERMAN, FRIEND_BALL, HYPER_POTION, LURE_BALL, MIRACLE_SPHERE_ALPHA, MIRACLE_SPHERE_BETA, MIRACLE_SPHERE_GAMMA, MIRAGE_STADIUM, MYSTERY_PLATE_ALPHA, MYSTERY_PLATE_BETA, MYSTERY_PLATE_DELTA, MYSTERY_PLATE_GAMMA, MYSTERY_ZONE, ORACLE, RELIC_HUNTER, STAR_PIECE, UNDERGROUND_EXPEDITION, UNDERGROUND_LAKE, } = E_SERIES_TRAINERS;
const SKYRIDGE_TRAINERS = [
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'skyridge_119_en',
        illustrator: null,
        name: ANCIENT_RUINS.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 119,
        subtitle: TRAINER_CARD_SUBTITLES.STADIUM_CARD,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'skyridge_120_en',
        illustrator: null,
        name: RELIC_HUNTER.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 120,
        subtitle: TRAINER_CARD_SUBTITLES.SUPPORTER,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'skyridge_121_en',
        illustrator: null,
        name: APRICORN_MAKER.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 121,
        subtitle: TRAINER_CARD_SUBTITLES.SUPPORTER,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'skyridge_122_en',
        illustrator: null,
        name: CRYSTAL_SHARD.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 122,
        subtitle: TRAINER_CARD_SUBTITLES.POKEMON_TOOL,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'skyridge_123_en',
        illustrator: null,
        name: DESERT_SHAMAN.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 123,
        subtitle: TRAINER_CARD_SUBTITLES.SUPPORTER,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'skyridge_124_en',
        illustrator: null,
        name: FAST_BALL.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 124,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'skyridge_125_en',
        illustrator: null,
        name: FISHERMAN.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 125,
        subtitle: TRAINER_CARD_SUBTITLES.SUPPORTER,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'skyridge_126_en',
        illustrator: null,
        name: FRIEND_BALL.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 126,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'skyridge_127_en',
        illustrator: null,
        name: HYPER_POTION.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 127,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'skyridge_128_en',
        illustrator: null,
        name: LURE_BALL.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 128,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'skyridge_129_en',
        illustrator: null,
        name: MIRACLE_SPHERE_ALPHA.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 129,
        subtitle: TRAINER_CARD_SUBTITLES.TECHNICAL_MACHINE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'skyridge_130_en',
        illustrator: null,
        name: MIRACLE_SPHERE_BETA.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 130,
        subtitle: TRAINER_CARD_SUBTITLES.TECHNICAL_MACHINE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'skyridge_131_en',
        illustrator: null,
        name: MIRACLE_SPHERE_GAMMA.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 131,
        subtitle: TRAINER_CARD_SUBTITLES.TECHNICAL_MACHINE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'skyridge_132_en',
        illustrator: null,
        name: MIRAGE_STADIUM.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 132,
        subtitle: TRAINER_CARD_SUBTITLES.STADIUM_CARD,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'skyridge_133_en',
        illustrator: null,
        name: MYSTERY_PLATE_ALPHA.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 133,
        subtitle: TRAINER_CARD_SUBTITLES.TECHNICAL_MACHINE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'skyridge_134_en',
        illustrator: null,
        name: MYSTERY_PLATE_BETA.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 134,
        subtitle: TRAINER_CARD_SUBTITLES.TECHNICAL_MACHINE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'skyridge_135_en',
        illustrator: null,
        name: MYSTERY_PLATE_GAMMA.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 135,
        subtitle: TRAINER_CARD_SUBTITLES.TECHNICAL_MACHINE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'skyridge_136_en',
        illustrator: null,
        name: MYSTERY_PLATE_DELTA.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 136,
        subtitle: TRAINER_CARD_SUBTITLES.TECHNICAL_MACHINE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'skyridge_137_en',
        illustrator: null,
        name: MYSTERY_ZONE.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 137,
        subtitle: TRAINER_CARD_SUBTITLES.STADIUM_CARD,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'skyridge_138_en',
        illustrator: null,
        name: ORACLE.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 138,
        subtitle: TRAINER_CARD_SUBTITLES.SUPPORTER,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'skyridge_139_en',
        illustrator: null,
        name: STAR_PIECE.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 139,
        subtitle: TRAINER_CARD_SUBTITLES.POKEMON_TOOL,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'skyridge_140_en',
        illustrator: null,
        name: UNDERGROUND_EXPEDITION.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 140,
        subtitle: TRAINER_CARD_SUBTITLES.SUPPORTER,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_E_SERIES,
        description: '',
        id: 'skyridge_141_en',
        illustrator: null,
        name: UNDERGROUND_LAKE.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 141,
        subtitle: TRAINER_CARD_SUBTITLES.STADIUM_CARD,
    },
];

const SKYRIDGE_SPECIAL_ENERGIES = [
    {
        cardTemplate: CARD_TEMPLATES.ENERGY_E_SERIES,
        description: SPECIAL_ENERGIES.BOUNCE.descriptions.default,
        energyType: ENERGY_TYPES.COLORLESS,
        id: 'skyridge_142_en',
        name: SPECIAL_ENERGIES.BOUNCE.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 142,
    },
    {
        cardTemplate: CARD_TEMPLATES.ENERGY_E_SERIES,
        description: SPECIAL_ENERGIES.CYCLONE.descriptions.default,
        energyType: ENERGY_TYPES.COLORLESS,
        id: 'skyridge_143_en',
        name: SPECIAL_ENERGIES.CYCLONE.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 143,
    },
    {
        cardTemplate: CARD_TEMPLATES.ENERGY_E_SERIES,
        description: SPECIAL_ENERGIES.RETRO.descriptions.default,
        energyType: ENERGY_TYPES.COLORLESS,
        id: 'skyridge_144_en',
        name: SPECIAL_ENERGIES.RETRO.name,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 144,
    },
];

const SKYRIDGE_CARDS = [
    {
        ...SKYRIDGE_NON_HOLOS[0],
    },
    {
        ...SKYRIDGE_NON_HOLOS[0],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[0].id}_rh`,
    },
    {
        ...SKYRIDGE_HOLOS[0],
        holo: false,
        id: 'skyridge_002_en',
        setNumber: 2,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[0],
        holo: 'reverse',
        id: 'skyridge_002_en_rh',
        setNumber: 2,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[1],
        holo: false,
        id: 'skyridge_003_en',
        setNumber: 3,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[1],
        holo: 'reverse',
        id: 'skyridge_003_en_rh',
        setNumber: 3,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[2],
        holo: false,
        id: 'skyridge_004_en',
        setNumber: 4,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[2],
        holo: 'reverse',
        id: 'skyridge_004_en_rh',
        setNumber: 4,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[3],
        holo: false,
        id: 'skyridge_005_en',
        setNumber: 5,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[3],
        holo: 'reverse',
        id: 'skyridge_005_en_rh',
        setNumber: 5,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[4],
        holo: false,
        id: 'skyridge_006_en',
        setNumber: 6,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[4],
        holo: 'reverse',
        id: 'skyridge_006_en_rh',
        setNumber: 6,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[5],
        holo: false,
        id: 'skyridge_007_en',
        setNumber: 7,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[5],
        holo: 'reverse',
        id: 'skyridge_007_en_rh',
        setNumber: 7,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[6],
        holo: false,
        id: 'skyridge_008_en',
        setNumber: 8,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[6],
        holo: 'reverse',
        id: 'skyridge_008_en_rh',
        setNumber: 8,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[7],
        holo: false,
        id: 'skyridge_009_en',
        setNumber: 9,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[7],
        holo: 'reverse',
        id: 'skyridge_009_en_rh',
        setNumber: 9,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[8],
        holo: false,
        id: 'skyridge_010_en',
        setNumber: 10,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[8],
        holo: 'reverse',
        id: 'skyridge_010_en_rh',
        setNumber: 10,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[9],
        holo: false,
        id: 'skyridge_011_en',
        setNumber: 11,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[9],
        holo: 'reverse',
        id: 'skyridge_011_en_rh',
        setNumber: 11,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[10],
        holo: false,
        id: 'skyridge_012_en',
        setNumber: 12,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[10],
        holo: 'reverse',
        id: 'skyridge_012_en_rh',
        setNumber: 12,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[11],
        holo: false,
        id: 'skyridge_013_en',
        setNumber: 13,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[11],
        holo: 'reverse',
        id: 'skyridge_013_en_rh',
        setNumber: 13,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[12],
        holo: false,
        id: 'skyridge_014_en',
        setNumber: 14,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[12],
        holo: 'reverse',
        id: 'skyridge_014_en_rh',
        setNumber: 14,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[13],
        holo: false,
        id: 'skyridge_015_en',
        setNumber: 15,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[13],
        holo: 'reverse',
        id: 'skyridge_015_en_rh',
        setNumber: 15,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[14],
        holo: false,
        id: 'skyridge_016_en',
        setNumber: 16,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[14],
        holo: 'reverse',
        id: 'skyridge_016_en_rh',
        setNumber: 16,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[15],
        holo: false,
        id: 'skyridge_017_en',
        setNumber: 17,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[15],
        holo: 'reverse',
        id: 'skyridge_017_en_rh',
        setNumber: 17,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[16],
        holo: false,
        id: 'skyridge_018_en',
        setNumber: 18,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[16],
        holo: 'reverse',
        id: 'skyridge_018_en_rh',
        setNumber: 18,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[17],
        holo: false,
        id: 'skyridge_019_en',
        setNumber: 19,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[17],
        holo: 'reverse',
        id: 'skyridge_019_en_rh',
        setNumber: 19,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[18],
        holo: false,
        id: 'skyridge_020_en',
        setNumber: 20,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[18],
        holo: 'reverse',
        id: 'skyridge_020_en_rh',
        setNumber: 20,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[19],
        holo: false,
        id: 'skyridge_021_en',
        setNumber: 21,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[19],
        holo: 'reverse',
        id: 'skyridge_021_en_rh',
        setNumber: 21,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[20],
        holo: false,
        id: 'skyridge_022_en',
        setNumber: 22,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[20],
        holo: 'reverse',
        id: 'skyridge_022_en_rh',
        setNumber: 22,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_NON_HOLOS[1],
    },
    {
        ...SKYRIDGE_NON_HOLOS[1],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[1].id}_rh`,
    },
    {
        ...SKYRIDGE_HOLOS[21],
        holo: false,
        id: 'skyridge_024_en',
        setNumber: 24,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[21],
        holo: 'reverse',
        id: 'skyridge_024_en_rh',
        setNumber: 24,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[22],
        holo: false,
        id: 'skyridge_025_en',
        setNumber: 25,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[22],
        holo: 'reverse',
        id: 'skyridge_025_en_rh',
        setNumber: 25,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[23],
        holo: false,
        id: 'skyridge_026_en',
        setNumber: 26,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[23],
        holo: 'reverse',
        id: 'skyridge_026_en_rh',
        setNumber: 26,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[24],
        holo: false,
        id: 'skyridge_027_en',
        setNumber: 27,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[24],
        holo: 'reverse',
        id: 'skyridge_027_en_rh',
        setNumber: 27,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[25],
        holo: false,
        id: 'skyridge_028_en',
        setNumber: 28,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[25],
        holo: 'reverse',
        id: 'skyridge_028_en_rh',
        setNumber: 28,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[26],
        holo: false,
        id: 'skyridge_029_en',
        setNumber: 29,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[26],
        holo: 'reverse',
        id: 'skyridge_029_en_rh',
        setNumber: 29,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[27],
        holo: false,
        id: 'skyridge_030_en',
        setNumber: 30,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[27],
        holo: 'reverse',
        id: 'skyridge_030_en_rh',
        setNumber: 30,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[28],
        holo: false,
        id: 'skyridge_031_en',
        setNumber: 31,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[28],
        holo: 'reverse',
        id: 'skyridge_031_en_rh',
        setNumber: 31,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[29],
        holo: false,
        id: 'skyridge_032_en',
        setNumber: 32,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[29],
        holo: 'reverse',
        id: 'skyridge_032_en_rh',
        setNumber: 32,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[30],
        holo: false,
        id: 'skyridge_033_en',
        setNumber: 33,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[30],
        holo: 'reverse',
        id: 'skyridge_033_en_rh',
        setNumber: 33,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_NON_HOLOS[2],
    },
    {
        ...SKYRIDGE_NON_HOLOS[2],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[2].id}_rh`,
    },
    {
        ...SKYRIDGE_HOLOS[31],
        holo: false,
        id: 'skyridge_035_en',
        setNumber: 35,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_HOLOS[31],
        holo: 'reverse',
        id: 'skyridge_035_en_rh',
        setNumber: 35,
        setTotal: SKYRIDGE_SET_TOTAL,
    },
    {
        ...SKYRIDGE_NON_HOLOS[3],
    },
    {
        ...SKYRIDGE_NON_HOLOS[3],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[3].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[4],
    },
    {
        ...SKYRIDGE_NON_HOLOS[4],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[4].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[5],
    },
    {
        ...SKYRIDGE_NON_HOLOS[5],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[5].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[6],
    },
    {
        ...SKYRIDGE_NON_HOLOS[6],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[6].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[7],
    },
    {
        ...SKYRIDGE_NON_HOLOS[7],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[7].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[8],
    },
    {
        ...SKYRIDGE_NON_HOLOS[8],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[8].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[9],
    },
    {
        ...SKYRIDGE_NON_HOLOS[9],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[9].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[10],
    },
    {
        ...SKYRIDGE_NON_HOLOS[10],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[10].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[11],
    },
    {
        ...SKYRIDGE_NON_HOLOS[11],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[11].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[12],
    },
    {
        ...SKYRIDGE_NON_HOLOS[12],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[12].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[13],
    },
    {
        ...SKYRIDGE_NON_HOLOS[13],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[13].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[14],
    },
    {
        ...SKYRIDGE_NON_HOLOS[14],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[14].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[15],
    },
    {
        ...SKYRIDGE_NON_HOLOS[15],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[15].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[16],
    },
    {
        ...SKYRIDGE_NON_HOLOS[16],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[16].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[17],
    },
    {
        ...SKYRIDGE_NON_HOLOS[17],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[17].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[18],
    },
    {
        ...SKYRIDGE_NON_HOLOS[18],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[18].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[19],
    },
    {
        ...SKYRIDGE_NON_HOLOS[19],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[19].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[20],
    },
    {
        ...SKYRIDGE_NON_HOLOS[20],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[20].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[21],
    },
    {
        ...SKYRIDGE_NON_HOLOS[21],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[21].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[22],
    },
    {
        ...SKYRIDGE_NON_HOLOS[22],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[22].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[23],
    },
    {
        ...SKYRIDGE_NON_HOLOS[23],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[23].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[24],
    },
    {
        ...SKYRIDGE_NON_HOLOS[24],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[24].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[25],
    },
    {
        ...SKYRIDGE_NON_HOLOS[25],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[25].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[26],
    },
    {
        ...SKYRIDGE_NON_HOLOS[26],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[26].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[27],
    },
    {
        ...SKYRIDGE_NON_HOLOS[27],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[27].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[28],
    },
    {
        ...SKYRIDGE_NON_HOLOS[28],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[28].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[29],
    },
    {
        ...SKYRIDGE_NON_HOLOS[29],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[29].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[30],
    },
    {
        ...SKYRIDGE_NON_HOLOS[30],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[30].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[31],
    },
    {
        ...SKYRIDGE_NON_HOLOS[31],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[31].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[32],
    },
    {
        ...SKYRIDGE_NON_HOLOS[32],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[32].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[33],
    },
    {
        ...SKYRIDGE_NON_HOLOS[33],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[33].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[34],
    },
    {
        ...SKYRIDGE_NON_HOLOS[34],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[34].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[35],
    },
    {
        ...SKYRIDGE_NON_HOLOS[35],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[35].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[36],
    },
    {
        ...SKYRIDGE_NON_HOLOS[36],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[36].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[37],
    },
    {
        ...SKYRIDGE_NON_HOLOS[37],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[37].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[38],
    },
    {
        ...SKYRIDGE_NON_HOLOS[38],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[38].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[39],
    },
    {
        ...SKYRIDGE_NON_HOLOS[39],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[39].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[40],
    },
    {
        ...SKYRIDGE_NON_HOLOS[40],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[40].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[41],
    },
    {
        ...SKYRIDGE_NON_HOLOS[41],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[41].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[42],
    },
    {
        ...SKYRIDGE_NON_HOLOS[42],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[42].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[43],
    },
    {
        ...SKYRIDGE_NON_HOLOS[43],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[43].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[44],
    },
    {
        ...SKYRIDGE_NON_HOLOS[44],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[44].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[45],
    },
    {
        ...SKYRIDGE_NON_HOLOS[45],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[45].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[46],
    },
    {
        ...SKYRIDGE_NON_HOLOS[46],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[46].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[47],
    },
    {
        ...SKYRIDGE_NON_HOLOS[47],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[47].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[48],
    },
    {
        ...SKYRIDGE_NON_HOLOS[48],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[48].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[49],
    },
    {
        ...SKYRIDGE_NON_HOLOS[49],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[49].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[50],
    },
    {
        ...SKYRIDGE_NON_HOLOS[50],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[50].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[51],
    },
    {
        ...SKYRIDGE_NON_HOLOS[51],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[51].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[52],
    },
    {
        ...SKYRIDGE_NON_HOLOS[52],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[52].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[53],
    },
    {
        ...SKYRIDGE_NON_HOLOS[53],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[53].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[54],
    },
    {
        ...SKYRIDGE_NON_HOLOS[54],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[54].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[55],
    },
    {
        ...SKYRIDGE_NON_HOLOS[55],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[55].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[56],
    },
    {
        ...SKYRIDGE_NON_HOLOS[56],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[56].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[57],
    },
    {
        ...SKYRIDGE_NON_HOLOS[57],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[57].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[58],
    },
    {
        ...SKYRIDGE_NON_HOLOS[58],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[58].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[59],
    },
    {
        ...SKYRIDGE_NON_HOLOS[59],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[59].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[60],
    },
    {
        ...SKYRIDGE_NON_HOLOS[60],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[60].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[61],
    },
    {
        ...SKYRIDGE_NON_HOLOS[61],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[61].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[62],
    },
    {
        ...SKYRIDGE_NON_HOLOS[62],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[62].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[63],
    },
    {
        ...SKYRIDGE_NON_HOLOS[63],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[63].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[64],
    },
    {
        ...SKYRIDGE_NON_HOLOS[64],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[64].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[65],
    },
    {
        ...SKYRIDGE_NON_HOLOS[65],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[65].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[66],
    },
    {
        ...SKYRIDGE_NON_HOLOS[66],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[66].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[67],
    },
    {
        ...SKYRIDGE_NON_HOLOS[67],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[67].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[68],
    },
    {
        ...SKYRIDGE_NON_HOLOS[68],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[68].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[69],
    },
    {
        ...SKYRIDGE_NON_HOLOS[69],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[69].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[70],
    },
    {
        ...SKYRIDGE_NON_HOLOS[70],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[70].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[71],
    },
    {
        ...SKYRIDGE_NON_HOLOS[71],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[71].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[72],
    },
    {
        ...SKYRIDGE_NON_HOLOS[72],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[72].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[73],
    },
    {
        ...SKYRIDGE_NON_HOLOS[73],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[73].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[74],
    },
    {
        ...SKYRIDGE_NON_HOLOS[74],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[74].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[75],
    },
    {
        ...SKYRIDGE_NON_HOLOS[75],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[75].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[76],
    },
    {
        ...SKYRIDGE_NON_HOLOS[76],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[76].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[77],
    },
    {
        ...SKYRIDGE_NON_HOLOS[77],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[77].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[78],
    },
    {
        ...SKYRIDGE_NON_HOLOS[78],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[78].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[79],
    },
    {
        ...SKYRIDGE_NON_HOLOS[79],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[79].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[80],
    },
    {
        ...SKYRIDGE_NON_HOLOS[80],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[80].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[81],
    },
    {
        ...SKYRIDGE_NON_HOLOS[81],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[81].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[82],
    },
    {
        ...SKYRIDGE_NON_HOLOS[82],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[82].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[83],
    },
    {
        ...SKYRIDGE_NON_HOLOS[83],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[83].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[84],
    },
    {
        ...SKYRIDGE_NON_HOLOS[84],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[84].id}_rh`,
    },
    {
        ...SKYRIDGE_NON_HOLOS[85],
    },
    {
        ...SKYRIDGE_NON_HOLOS[85],
        holo: 'reverse',
        id: `${SKYRIDGE_NON_HOLOS[85].id}_rh`,
    },
    {
        ...SKYRIDGE_TRAINERS[0],
    },
    {
        ...SKYRIDGE_TRAINERS[0],
        holo: 'reverse',
        id: `${SKYRIDGE_TRAINERS[0].id}_rh`,
    },
    {
        ...SKYRIDGE_TRAINERS[1],
    },
    {
        ...SKYRIDGE_TRAINERS[1],
        holo: 'reverse',
        id: `${SKYRIDGE_TRAINERS[1].id}_rh`,
    },
    {
        ...SKYRIDGE_TRAINERS[2],
    },
    {
        ...SKYRIDGE_TRAINERS[2],
        holo: 'reverse',
        id: `${SKYRIDGE_TRAINERS[2].id}_rh`,
    },
    {
        ...SKYRIDGE_TRAINERS[3],
    },
    {
        ...SKYRIDGE_TRAINERS[3],
        holo: 'reverse',
        id: `${SKYRIDGE_TRAINERS[3].id}_rh`,
    },
    {
        ...SKYRIDGE_TRAINERS[4],
    },
    {
        ...SKYRIDGE_TRAINERS[4],
        holo: 'reverse',
        id: `${SKYRIDGE_TRAINERS[4].id}_rh`,
    },
    {
        ...SKYRIDGE_TRAINERS[5],
    },
    {
        ...SKYRIDGE_TRAINERS[5],
        holo: 'reverse',
        id: `${SKYRIDGE_TRAINERS[5].id}_rh`,
    },
    {
        ...SKYRIDGE_TRAINERS[6],
    },
    {
        ...SKYRIDGE_TRAINERS[6],
        holo: 'reverse',
        id: `${SKYRIDGE_TRAINERS[6].id}_rh`,
    },
    {
        ...SKYRIDGE_TRAINERS[7],
    },
    {
        ...SKYRIDGE_TRAINERS[7],
        holo: 'reverse',
        id: `${SKYRIDGE_TRAINERS[7].id}_rh`,
    },
    {
        ...SKYRIDGE_TRAINERS[8],
    },
    {
        ...SKYRIDGE_TRAINERS[8],
        holo: 'reverse',
        id: `${SKYRIDGE_TRAINERS[8].id}_rh`,
    },
    {
        ...SKYRIDGE_TRAINERS[9],
    },
    {
        ...SKYRIDGE_TRAINERS[9],
        holo: 'reverse',
        id: `${SKYRIDGE_TRAINERS[9].id}_rh`,
    },
    {
        ...SKYRIDGE_TRAINERS[10],
    },
    {
        ...SKYRIDGE_TRAINERS[10],
        holo: 'reverse',
        id: `${SKYRIDGE_TRAINERS[10].id}_rh`,
    },
    {
        ...SKYRIDGE_TRAINERS[11],
    },
    {
        ...SKYRIDGE_TRAINERS[11],
        holo: 'reverse',
        id: `${SKYRIDGE_TRAINERS[11].id}_rh`,
    },
    {
        ...SKYRIDGE_TRAINERS[12],
    },
    {
        ...SKYRIDGE_TRAINERS[12],
        holo: 'reverse',
        id: `${SKYRIDGE_TRAINERS[12].id}_rh`,
    },
    {
        ...SKYRIDGE_TRAINERS[13],
    },
    {
        ...SKYRIDGE_TRAINERS[13],
        holo: 'reverse',
        id: `${SKYRIDGE_TRAINERS[13].id}_rh`,
    },
    {
        ...SKYRIDGE_TRAINERS[14],
    },
    {
        ...SKYRIDGE_TRAINERS[14],
        holo: 'reverse',
        id: `${SKYRIDGE_TRAINERS[14].id}_rh`,
    },
    {
        ...SKYRIDGE_TRAINERS[15],
    },
    {
        ...SKYRIDGE_TRAINERS[15],
        holo: 'reverse',
        id: `${SKYRIDGE_TRAINERS[15].id}_rh`,
    },
    {
        ...SKYRIDGE_TRAINERS[16],
    },
    {
        ...SKYRIDGE_TRAINERS[16],
        holo: 'reverse',
        id: `${SKYRIDGE_TRAINERS[16].id}_rh`,
    },
    {
        ...SKYRIDGE_TRAINERS[17],
    },
    {
        ...SKYRIDGE_TRAINERS[17],
        holo: 'reverse',
        id: `${SKYRIDGE_TRAINERS[17].id}_rh`,
    },
    {
        ...SKYRIDGE_TRAINERS[18],
    },
    {
        ...SKYRIDGE_TRAINERS[18],
        holo: 'reverse',
        id: `${SKYRIDGE_TRAINERS[18].id}_rh`,
    },
    {
        ...SKYRIDGE_TRAINERS[19],
    },
    {
        ...SKYRIDGE_TRAINERS[19],
        holo: 'reverse',
        id: `${SKYRIDGE_TRAINERS[19].id}_rh`,
    },
    {
        ...SKYRIDGE_TRAINERS[20],
    },
    {
        ...SKYRIDGE_TRAINERS[20],
        holo: 'reverse',
        id: `${SKYRIDGE_TRAINERS[20].id}_rh`,
    },
    {
        ...SKYRIDGE_TRAINERS[21],
    },
    {
        ...SKYRIDGE_TRAINERS[21],
        holo: 'reverse',
        id: `${SKYRIDGE_TRAINERS[21].id}_rh`,
    },
    {
        ...SKYRIDGE_TRAINERS[22],
    },
    {
        ...SKYRIDGE_TRAINERS[22],
        holo: 'reverse',
        id: `${SKYRIDGE_TRAINERS[22].id}_rh`,
    },
    {
        ...SKYRIDGE_SPECIAL_ENERGIES[0],
    },
    {
        ...SKYRIDGE_SPECIAL_ENERGIES[0],
        holo: 'reverse',
        id: `${SKYRIDGE_SPECIAL_ENERGIES[0].id}_rh`,
    },
    {
        ...SKYRIDGE_SPECIAL_ENERGIES[1],
    },
    {
        ...SKYRIDGE_SPECIAL_ENERGIES[1],
        holo: 'reverse',
        id: `${SKYRIDGE_SPECIAL_ENERGIES[1].id}_rh`,
    },
    {
        ...SKYRIDGE_SPECIAL_ENERGIES[2],
    },
    {
        ...SKYRIDGE_SPECIAL_ENERGIES[2],
        holo: 'reverse',
        id: `${SKYRIDGE_SPECIAL_ENERGIES[2].id}_rh`,
    },
];

const setId$1 = CARD_SETS.SKYRIDGE.value;
const setName$1 = CARD_SETS.SKYRIDGE.label;
const setTotal$1 = SKYRIDGE_SET_TOTAL;
const SKYRIDGE_SET = {
    cardCounts: {
        secretRares: 6,
        holoRares: 32,
        rares: 35,
        uncommons: 36,
        commons: 73,
    },
    copyright: COPYRIGHTS.SKYRIDGE_SET,
    description: SET_DESCRIPTIONS.SKYRIDGE,
    holoSheetType: CARD_HOLO_SHEETS.COSMOS_2,
    id: setId$1,
    imageUrl: 'https://cdn.shopify.com/s/files/1/0840/1659/5249/collections/skyridge-cat-bg.jpg',
    name: setName$1,
    packInfo: BOOSTER_PACKS.SKYRIDGE,
    releaseDate: RELEASE_DATES.SKYRIDGE,
    reverseHoloSheetType: CARD_HOLO_SHEETS.RIPPLE,
    setSymbol: setId$1,
    setTotal: setTotal$1,
    cards: [...SKYRIDGE_HOLOS, ...SKYRIDGE_CARDS, ...SKYRIDGE_CRYSTALS],
    themeDecks: [],
};

const { AERODACTYL, ARBOK, ARTICUNO, BEEDRILL, BLASTOISE, BUTTERFREE, CHARIZARD, CLEFABLE, CLOYSTER, DEWGONG, DODRIO, DRAGONITE, ELECTABUZZ, EXEGGUTOR, FARFETCHD, FEAROW, FLAREON, GENGAR, GYARADOS, HITMONCHAN, HITMONLEE, HYPNO, JOLTEON, JYNX, KABUTOPS, LAPRAS, LICKITUNG, MACHAMP, MAGMAR, MAGNETON, MAROWAK, NINETALES, OMASTAR, PERSIAN, PIDGEOT, PINSIR, POLIWRATH, PRIMEAPE, RAICHU, RAPIDASH, RHYDON, SLOWBRO, TAUROS, VENOMOTH, WEEZING, WIGGLYTUFF, } = GEN_1_POKEMON;
const { AMPHAROS, ARIADOS, BELLOSSOM, CROBAT, DELIBIRD, DONPHAN, ENTEI, ESPEON, FORRETRESS, FURRET, GIRAFARIG, GRANBULL, HITMONTOP, HOUNDOOM, JUMPLUFF, KINGDRA, LANTURN, LEDIAN, MAGCARGO, MANTINE, MILTANK, MISDREAVUS, MURKROW, NOCTOWL, PILOSWINE, POLITOED, QUAGSIRE, RAIKOU, SCIZOR, SHUCKLE, SKARMORY, SLOWKING, SNEASEL, STEELIX, SUICUNE, TOGETIC, TYPHLOSION, TYRANITAR: TYRANITAR$1, UMBREON, URSARING, WOBBUFFET, XATU, YANMA, } = GEN_2_POKEMON;
const VS_NAME_CONDENSE_LEVEL = 2;
const VS_SET_CARDS = [
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 60,
        id: 'vs_001_en',
        illustrator: '',
        moves: [],
        name: `${FALKNER_PREFIX} ${PIDGEOT.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: PIDGEOT.number,
        pokemonType: PIDGEOT.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 1,
        trainerImageUrl: FALKNER_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 60,
        id: 'vs_002_en',
        illustrator: '',
        moves: [],
        name: `${FALKNER_PREFIX} ${FEAROW.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: FEAROW.number,
        pokemonType: FEAROW.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 2,
        trainerImageUrl: FALKNER_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 50,
        id: 'vs_003_en',
        illustrator: '',
        moves: [],
        name: `${FALKNER_PREFIX} ${FARFETCHD.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: FARFETCHD.number,
        pokemonType: FARFETCHD.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 3,
        trainerImageUrl: FALKNER_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 60,
        id: 'vs_004_en',
        illustrator: '',
        moves: [],
        name: `${FALKNER_PREFIX} ${DODRIO.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: DODRIO.number,
        pokemonType: DODRIO.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 4,
        trainerImageUrl: FALKNER_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 60,
        id: 'vs_005_en',
        illustrator: '',
        moves: [],
        name: `${FALKNER_PREFIX} ${TOGETIC.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: TOGETIC.number,
        pokemonType: TOGETIC.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 5,
        trainerImageUrl: FALKNER_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 50,
        id: 'vs_006_en',
        illustrator: '',
        moves: [],
        name: `${FALKNER_PREFIX} ${DELIBIRD.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: DELIBIRD.number,
        pokemonType: DELIBIRD.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 6,
        trainerImageUrl: FALKNER_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.METAL,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 50,
        holo: true,
        holoStrength: 0.7,
        id: 'vs_007_en',
        illustrator: '',
        moves: [],
        name: `${FALKNER_PREFIX} ${SKARMORY.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: SKARMORY.number,
        pokemonType: SKARMORY.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 7,
        trainerImageUrl: FALKNER_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        hitPoints: 60,
        id: 'vs_008_en',
        illustrator: '',
        moves: [],
        name: `${BUGSY_PREFIX} ${BUTTERFREE.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: BUTTERFREE.number,
        pokemonType: BUTTERFREE.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 8,
        trainerImageUrl: BUGSY_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        hitPoints: 60,
        id: 'vs_009_en',
        illustrator: '',
        moves: [],
        name: `${BUGSY_PREFIX} ${BEEDRILL.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: BEEDRILL.number,
        pokemonType: BEEDRILL.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 9,
        trainerImageUrl: BUGSY_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        hitPoints: 60,
        id: 'vs_010_en',
        illustrator: '',
        moves: [],
        name: `${BUGSY_PREFIX} ${PINSIR.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: PINSIR.number,
        pokemonType: PINSIR.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 10,
        trainerImageUrl: BUGSY_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        hitPoints: 60,
        id: 'vs_011_en',
        illustrator: '',
        moves: [],
        name: `${BUGSY_PREFIX} ${LEDIAN.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: LEDIAN.number,
        pokemonType: LEDIAN.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 11,
        trainerImageUrl: BUGSY_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        hitPoints: 50,
        id: 'vs_012_en',
        illustrator: '',
        moves: [],
        name: `${BUGSY_PREFIX} ${YANMA.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: YANMA.number,
        pokemonType: YANMA.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 12,
        trainerImageUrl: BUGSY_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyResistance: ENERGY_TYPES.GRASS,
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.METAL,
        energyWeakness: ENERGY_TYPES.FIRE,
        hitPoints: 60,
        holo: true,
        holoStrength: 0.7,
        id: 'vs_013_en',
        illustrator: '',
        moves: [],
        name: `${BUGSY_PREFIX} ${SCIZOR.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: SCIZOR.number,
        pokemonType: SCIZOR.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 13,
        trainerImageUrl: BUGSY_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 60,
        id: 'vs_014_en',
        illustrator: '',
        moves: [],
        name: `${WHITNEY_PREFIX} ${CLEFABLE.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: CLEFABLE.number,
        pokemonType: CLEFABLE.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 14,
        trainerImageUrl: WHITNEY_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 60,
        id: 'vs_015_en',
        illustrator: '',
        moves: [],
        name: `${WHITNEY_PREFIX} ${WIGGLYTUFF.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: WIGGLYTUFF.number,
        pokemonType: WIGGLYTUFF.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 15,
        trainerImageUrl: WHITNEY_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 60,
        id: 'vs_016_en',
        illustrator: '',
        moves: [],
        name: `${WHITNEY_PREFIX} ${PERSIAN.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: PERSIAN.number,
        pokemonType: PERSIAN.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 16,
        trainerImageUrl: WHITNEY_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 70,
        id: 'vs_017_en',
        illustrator: '',
        moves: [],
        name: `${WHITNEY_PREFIX} ${LICKITUNG.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: LICKITUNG.number,
        pokemonType: LICKITUNG.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 17,
        trainerImageUrl: WHITNEY_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 60,
        id: 'vs_018_en',
        illustrator: '',
        moves: [],
        name: `${WHITNEY_PREFIX} ${FURRET.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: FURRET.number,
        pokemonType: FURRET.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 18,
        trainerImageUrl: WHITNEY_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 70,
        id: 'vs_019_en',
        illustrator: '',
        moves: [],
        name: `${WHITNEY_PREFIX} ${MILTANK.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: MILTANK.number,
        pokemonType: MILTANK.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 19,
        trainerImageUrl: WHITNEY_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: ENERGY_TYPES.WATER,
        hitPoints: 60,
        id: 'vs_020_en',
        illustrator: '',
        moves: [],
        name: `${MORTY_PREFIX} ${NINETALES.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: NINETALES.number,
        pokemonType: NINETALES.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 20,
        trainerImageUrl: MORTY_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.DARKNESS,
        hitPoints: 70,
        id: 'vs_021_en',
        illustrator: '',
        moves: [],
        name: `${MORTY_PREFIX} ${GENGAR.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: GENGAR.number,
        pokemonType: GENGAR.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 21,
        trainerImageUrl: MORTY_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 60,
        id: 'vs_022_en',
        illustrator: '',
        moves: [],
        name: `${MORTY_PREFIX} ${HYPNO.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: HYPNO.number,
        pokemonType: HYPNO.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 22,
        trainerImageUrl: MORTY_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyResistance: ENERGY_TYPES.LIGHTNING,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.GRASS,
        hitPoints: 60,
        id: 'vs_023_en',
        illustrator: '',
        moves: [],
        name: `${MORTY_PREFIX} ${MAROWAK.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: MAROWAK.number,
        pokemonType: MAROWAK.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 23,
        trainerImageUrl: MORTY_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 60,
        id: 'vs_024_en',
        illustrator: '',
        moves: [],
        name: `${MORTY_PREFIX} ${NOCTOWL.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: NOCTOWL.number,
        pokemonType: NOCTOWL.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 24,
        trainerImageUrl: MORTY_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyResistance: ENERGY_TYPES.PSYCHIC,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.DARKNESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 50,
        holo: true,
        holoStrength: 0.7,
        id: 'vs_025_en',
        illustrator: '',
        moves: [],
        name: `${MORTY_PREFIX} ${MURKROW.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: MURKROW.number,
        pokemonType: MURKROW.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 25,
        trainerImageUrl: MORTY_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.DARKNESS,
        hitPoints: 50,
        id: 'vs_026_en',
        illustrator: '',
        moves: [],
        name: `${MORTY_PREFIX} ${MISDREAVUS.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: MISDREAVUS.number,
        pokemonType: MISDREAVUS.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 26,
        trainerImageUrl: MORTY_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 60,
        id: 'vs_027_en',
        illustrator: '',
        moves: [],
        name: `${JASMINE_PREFIX} ${RAICHU.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: RAICHU.number,
        pokemonType: RAICHU.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 27,
        trainerImageUrl: JASMINE_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 60,
        id: 'vs_028_en',
        illustrator: '',
        moves: [],
        name: `${JASMINE_PREFIX} ${MAGNETON.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: MAGNETON.number,
        pokemonType: MAGNETON.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 28,
        trainerImageUrl: JASMINE_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 50,
        id: 'vs_029_en',
        illustrator: '',
        moves: [],
        name: `${JASMINE_PREFIX} ${ELECTABUZZ.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: ELECTABUZZ.number,
        pokemonType: ELECTABUZZ.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 29,
        trainerImageUrl: JASMINE_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 60,
        id: 'vs_030_en',
        illustrator: '',
        moves: [],
        name: `${JASMINE_PREFIX} ${JOLTEON.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: JOLTEON.number,
        pokemonType: JOLTEON.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 30,
        trainerImageUrl: JASMINE_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 70,
        id: 'vs_031_en',
        illustrator: '',
        moves: [],
        name: `${JASMINE_PREFIX} ${AMPHAROS.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: AMPHAROS.number,
        pokemonType: AMPHAROS.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 31,
        trainerImageUrl: JASMINE_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyResistance: ENERGY_TYPES.GRASS,
        energyRetreatCost: 4,
        energyType: ENERGY_TYPES.METAL,
        energyWeakness: ENERGY_TYPES.FIRE,
        hitPoints: 80,
        holo: true,
        holoStrength: 0.7,
        id: 'vs_032_en',
        illustrator: '',
        moves: [],
        name: `${JASMINE_PREFIX} ${STEELIX.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: STEELIX.number,
        pokemonType: STEELIX.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 32,
        trainerImageUrl: JASMINE_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 60,
        id: 'vs_033_en',
        illustrator: '',
        moves: [],
        name: `${CHUCK_PREFIX} ${PRIMEAPE.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: PRIMEAPE.number,
        pokemonType: PRIMEAPE.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 33,
        trainerImageUrl: CHUCK_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 70,
        id: 'vs_034_en',
        illustrator: '',
        moves: [],
        name: `${CHUCK_PREFIX} ${POLIWRATH.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: POLIWRATH.number,
        pokemonType: POLIWRATH.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 34,
        trainerImageUrl: CHUCK_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyResistance: ENERGY_TYPES.LIGHTNING,
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.GRASS,
        hitPoints: 60,
        id: 'vs_035_en',
        illustrator: '',
        moves: [],
        name: `${CHUCK_PREFIX} ${RHYDON.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: RHYDON.number,
        pokemonType: RHYDON.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 35,
        trainerImageUrl: CHUCK_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 60,
        id: 'vs_036_en',
        illustrator: '',
        moves: [],
        name: `${CHUCK_PREFIX} ${TAUROS.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: TAUROS.number,
        pokemonType: TAUROS.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 36,
        trainerImageUrl: CHUCK_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 60,
        id: 'vs_037_en',
        illustrator: '',
        moves: [],
        name: `${CHUCK_PREFIX} ${GRANBULL.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: GRANBULL.number,
        pokemonType: GRANBULL.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 37,
        trainerImageUrl: CHUCK_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyResistance: ENERGY_TYPES.LIGHTNING,
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.GRASS,
        hitPoints: 60,
        id: 'vs_038_en',
        illustrator: '',
        moves: [],
        name: `${CHUCK_PREFIX} ${DONPHAN.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: DONPHAN.number,
        pokemonType: DONPHAN.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 38,
        trainerImageUrl: CHUCK_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.METAL,
        hitPoints: 60,
        id: 'vs_039_en',
        illustrator: '',
        moves: [],
        name: `${PRYCE_PREFIX} ${DEWGONG.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: DEWGONG.number,
        pokemonType: DEWGONG.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 39,
        trainerImageUrl: PRYCE_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.METAL,
        hitPoints: 60,
        id: 'vs_040_en',
        illustrator: '',
        moves: [],
        name: `${PRYCE_PREFIX} ${CLOYSTER.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: CLOYSTER.number,
        pokemonType: CLOYSTER.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 40,
        trainerImageUrl: PRYCE_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.METAL,
        hitPoints: 60,
        id: 'vs_041_en',
        illustrator: '',
        moves: [],
        name: `${PRYCE_PREFIX} ${LAPRAS.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: LAPRAS.number,
        pokemonType: LAPRAS.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 41,
        trainerImageUrl: PRYCE_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.METAL,
        hitPoints: 70,
        id: 'vs_042_en',
        illustrator: '',
        moves: [],
        name: `${PRYCE_PREFIX} ${ARTICUNO.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: ARTICUNO.number,
        pokemonType: ARTICUNO.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 42,
        trainerImageUrl: PRYCE_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyResistance: ENERGY_TYPES.PSYCHIC,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.DARKNESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 50,
        id: 'vs_043_en',
        illustrator: '',
        moves: [],
        name: `${PRYCE_PREFIX} ${SNEASEL.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: SNEASEL.number,
        pokemonType: SNEASEL.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 43,
        trainerImageUrl: PRYCE_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.METAL,
        hitPoints: 60,
        id: 'vs_044_en',
        illustrator: '',
        moves: [],
        name: `${PRYCE_PREFIX} ${PILOSWINE.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: PILOSWINE.number,
        pokemonType: PILOSWINE.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 44,
        trainerImageUrl: PRYCE_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.METAL,
        hitPoints: 50,
        id: 'vs_045_en',
        illustrator: '',
        moves: [],
        name: `${PRYCE_PREFIX} ${DELIBIRD.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: DELIBIRD.number,
        pokemonType: DELIBIRD.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 45,
        trainerImageUrl: PRYCE_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 70,
        id: 'vs_046_en',
        illustrator: '',
        moves: [],
        name: `${CLAIR_PREFIX} ${BLASTOISE.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: BLASTOISE.number,
        pokemonType: BLASTOISE.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 46,
        trainerImageUrl: CLAIR_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.METAL,
        hitPoints: 50,
        id: 'vs_047_en',
        illustrator: '',
        moves: [],
        name: `${CLAIR_PREFIX} ${JYNX.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: JYNX.number,
        pokemonType: JYNX.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 47,
        trainerImageUrl: CLAIR_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 70,
        id: 'vs_048_en',
        illustrator: '',
        moves: [],
        name: `${CLAIR_PREFIX} ${GYARADOS.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: GYARADOS.number,
        pokemonType: GYARADOS.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 48,
        trainerImageUrl: CLAIR_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.COLORLESS,
        hitPoints: 70,
        id: 'vs_049_en',
        illustrator: '',
        moves: [],
        name: `${CLAIR_PREFIX} ${DRAGONITE.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: DRAGONITE.number,
        pokemonType: DRAGONITE.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 49,
        trainerImageUrl: CLAIR_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 60,
        id: 'vs_050_en',
        illustrator: '',
        moves: [],
        name: `${CLAIR_PREFIX} ${POLITOED.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: POLITOED.number,
        pokemonType: POLITOED.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 50,
        trainerImageUrl: CLAIR_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 60,
        id: 'vs_051_en',
        illustrator: '',
        moves: [],
        name: `${CLAIR_PREFIX} ${MANTINE.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: MANTINE.number,
        pokemonType: MANTINE.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 51,
        trainerImageUrl: CLAIR_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 70,
        id: 'vs_052_en',
        illustrator: '',
        moves: [],
        name: `${CLAIR_PREFIX} ${KINGDRA.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: KINGDRA.number,
        pokemonType: KINGDRA.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 52,
        trainerImageUrl: CLAIR_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 60,
        id: 'vs_053_en',
        illustrator: '',
        moves: [],
        name: `${LT_SURGE_PREFIX} ${RAICHU.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: RAICHU.number,
        pokemonType: RAICHU.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 53,
        trainerImageUrl: LT_SURGE_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 60,
        id: 'vs_054_en',
        illustrator: '',
        moves: [],
        name: `${LT_SURGE_PREFIX} ${LANTURN.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: LANTURN.number,
        pokemonType: LANTURN.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 54,
        trainerImageUrl: LT_SURGE_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 70,
        id: 'vs_055_en',
        illustrator: '',
        moves: [],
        name: `${SABRINA_PREFIX} ${XATU.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: XATU.number,
        pokemonType: XATU.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 55,
        trainerImageUrl: SABRINA_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 60,
        id: 'vs_056_en',
        illustrator: '',
        moves: [],
        name: `${SABRINA_PREFIX} ${ESPEON.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: ESPEON.number,
        pokemonType: ESPEON.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 56,
        trainerImageUrl: SABRINA_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.METAL,
        hitPoints: 60,
        id: 'vs_057_en',
        illustrator: '',
        moves: [],
        name: `${MISTY_PREFIX} ${LAPRAS.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: LAPRAS.number,
        pokemonType: LAPRAS.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 57,
        trainerImageUrl: MISTY_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.GRASS,
        hitPoints: 60,
        id: 'vs_058_en',
        illustrator: '',
        moves: [],
        name: `${MISTY_PREFIX} ${QUAGSIRE.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: QUAGSIRE.number,
        pokemonType: QUAGSIRE.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 58,
        trainerImageUrl: MISTY_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyResistance: ENERGY_TYPES.WATER,
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        hitPoints: 70,
        id: 'vs_059_en',
        illustrator: '',
        moves: [],
        name: `${ERIKA_PREFIX} ${BELLOSSOM.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: BELLOSSOM.number,
        pokemonType: BELLOSSOM.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 59,
        trainerImageUrl: ERIKA_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        hitPoints: 60,
        id: 'vs_060_en',
        illustrator: '',
        moves: [],
        name: `${ERIKA_PREFIX} ${JUMPLUFF.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: JUMPLUFF.number,
        pokemonType: JUMPLUFF.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 60,
        trainerImageUrl: ERIKA_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        hitPoints: 60,
        id: 'vs_061_en',
        illustrator: '',
        moves: [],
        name: `${JANINE_PREFIX} ${BEEDRILL.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: BEEDRILL.number,
        pokemonType: BEEDRILL.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 61,
        trainerImageUrl: JANINE_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 60,
        id: 'vs_062_en',
        illustrator: '',
        moves: [],
        name: `${JANINE_PREFIX} ${ARBOK.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: ARBOK.number,
        pokemonType: ARBOK.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 62,
        trainerImageUrl: JANINE_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        hitPoints: 60,
        id: 'vs_063_en',
        illustrator: '',
        moves: [],
        name: `${JANINE_PREFIX} ${VENOMOTH.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: VENOMOTH.number,
        pokemonType: VENOMOTH.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 63,
        trainerImageUrl: JANINE_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 60,
        id: 'vs_064_en',
        illustrator: '',
        moves: [],
        name: `${JANINE_PREFIX} ${WEEZING.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: WEEZING.number,
        pokemonType: WEEZING.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 64,
        trainerImageUrl: JANINE_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        hitPoints: 60,
        id: 'vs_065_en',
        illustrator: '',
        moves: [],
        name: `${JANINE_PREFIX} ${ARIADOS.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: ARIADOS.number,
        pokemonType: ARIADOS.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 65,
        trainerImageUrl: JANINE_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 60,
        id: 'vs_066_en',
        illustrator: '',
        moves: [],
        name: `${JANINE_PREFIX} ${CROBAT.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: CROBAT.number,
        pokemonType: CROBAT.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 66,
        trainerImageUrl: JANINE_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        hitPoints: 50,
        id: 'vs_067_en',
        illustrator: '',
        moves: [],
        name: `${JANINE_PREFIX} ${SHUCKLE.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: SHUCKLE.number,
        pokemonType: SHUCKLE.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 67,
        trainerImageUrl: JANINE_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.GRASS,
        hitPoints: 70,
        id: 'vs_068_en',
        illustrator: '',
        moves: [],
        name: `${BROCK_PREFIX} ${OMASTAR.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: OMASTAR.number,
        pokemonType: OMASTAR.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 68,
        trainerImageUrl: BROCK_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.GRASS,
        hitPoints: 60,
        id: 'vs_069_en',
        illustrator: '',
        moves: [],
        name: `${BROCK_PREFIX} ${KABUTOPS.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: KABUTOPS.number,
        pokemonType: KABUTOPS.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 69,
        trainerImageUrl: BROCK_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: ENERGY_TYPES.WATER,
        hitPoints: 70,
        id: 'vs_070_en',
        illustrator: '',
        moves: [],
        name: `${BLAINE_PREFIX} ${TYPHLOSION.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: TYPHLOSION.number,
        pokemonType: TYPHLOSION.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 70,
        trainerImageUrl: BLAINE_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: ENERGY_TYPES.WATER,
        hitPoints: 60,
        id: 'vs_071_en',
        illustrator: '',
        moves: [],
        name: `${BLAINE_PREFIX} ${MAGCARGO.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: MAGCARGO.number,
        pokemonType: MAGCARGO.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 71,
        trainerImageUrl: BLAINE_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 60,
        id: 'vs_072_en',
        illustrator: '',
        moves: [],
        name: `${WILL_PREFIX} ${SLOWBRO.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: SLOWBRO.number,
        pokemonType: SLOWBRO.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 72,
        trainerImageUrl: WILL_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 60,
        id: 'vs_073_en',
        illustrator: '',
        moves: [],
        name: `${WILL_PREFIX} ${EXEGGUTOR.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: EXEGGUTOR.number,
        pokemonType: EXEGGUTOR.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 73,
        trainerImageUrl: WILL_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 50,
        id: 'vs_074_en',
        illustrator: '',
        moves: [],
        name: `${WILL_PREFIX} ${JYNX.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: JYNX.number,
        pokemonType: JYNX.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 74,
        trainerImageUrl: WILL_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 60,
        id: 'vs_075_en',
        illustrator: '',
        moves: [],
        name: `${WILL_PREFIX} ${XATU.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: XATU.number,
        pokemonType: XATU.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 75,
        trainerImageUrl: WILL_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 60,
        id: 'vs_076_en',
        illustrator: '',
        moves: [],
        name: `${WILL_PREFIX} ${ESPEON.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: ESPEON.number,
        pokemonType: ESPEON.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 76,
        trainerImageUrl: WILL_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 70,
        id: 'vs_077_en',
        illustrator: '',
        moves: [],
        name: `${WILL_PREFIX} ${SLOWKING.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: SLOWKING.number,
        pokemonType: SLOWKING.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 77,
        trainerImageUrl: WILL_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 50,
        id: 'vs_078_en',
        illustrator: '',
        moves: [],
        name: `${WILL_PREFIX} ${GIRAFARIG.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: GIRAFARIG.number,
        pokemonType: GIRAFARIG.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 78,
        trainerImageUrl: WILL_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 60,
        id: 'vs_079_en',
        illustrator: '',
        moves: [],
        name: `${KOGA_PREFIX} ${CROBAT.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: CROBAT.number,
        pokemonType: CROBAT.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 79,
        trainerImageUrl: KOGA_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.GRASS,
        energyWeakness: ENERGY_TYPES.FIRE,
        hitPoints: 60,
        id: 'vs_080_en',
        illustrator: '',
        moves: [],
        name: `${KOGA_PREFIX} ${FORRETRESS.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: FORRETRESS.number,
        pokemonType: FORRETRESS.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 80,
        trainerImageUrl: KOGA_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 80,
        id: 'vs_081_en',
        illustrator: '',
        moves: [],
        name: `${BRUNO_PREFIX} ${MACHAMP.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: MACHAMP.number,
        pokemonType: MACHAMP.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 81,
        trainerImageUrl: BRUNO_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 60,
        id: 'vs_082_en',
        illustrator: '',
        moves: [],
        name: `${BRUNO_PREFIX} ${HITMONLEE.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: HITMONLEE.number,
        pokemonType: HITMONLEE.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 82,
        trainerImageUrl: BRUNO_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 60,
        id: 'vs_083_en',
        illustrator: '',
        moves: [],
        name: `${BRUNO_PREFIX} ${HITMONCHAN.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: HITMONCHAN.number,
        pokemonType: HITMONCHAN.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 83,
        trainerImageUrl: BRUNO_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyResistance: ENERGY_TYPES.GRASS,
        energyRetreatCost: 4,
        energyType: ENERGY_TYPES.METAL,
        energyWeakness: ENERGY_TYPES.FIRE,
        hitPoints: 80,
        holo: true,
        holoStrength: 0.7,
        id: 'vs_084_en',
        illustrator: '',
        moves: [],
        name: `${BRUNO_PREFIX} ${STEELIX.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: STEELIX.number,
        pokemonType: STEELIX.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 84,
        trainerImageUrl: BRUNO_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.COLORLESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 60,
        id: 'vs_085_en',
        illustrator: '',
        moves: [],
        name: `${BRUNO_PREFIX} ${URSARING.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: URSARING.number,
        pokemonType: URSARING.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 85,
        trainerImageUrl: BRUNO_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 60,
        id: 'vs_086_en',
        illustrator: '',
        moves: [],
        name: `${BRUNO_PREFIX} ${HITMONTOP.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: HITMONTOP.number,
        pokemonType: HITMONTOP.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 86,
        trainerImageUrl: BRUNO_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: ENERGY_TYPES.WATER,
        hitPoints: 60,
        id: 'vs_087_en',
        illustrator: '',
        moves: [],
        name: `${KAREN_PREFIX} ${RAPIDASH.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: RAPIDASH.number,
        pokemonType: RAPIDASH.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 87,
        trainerImageUrl: KAREN_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: ENERGY_TYPES.WATER,
        hitPoints: 50,
        id: 'vs_088_en',
        illustrator: '',
        moves: [],
        name: `${KAREN_PREFIX} ${MAGMAR.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: MAGMAR.number,
        pokemonType: MAGMAR.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 88,
        trainerImageUrl: KAREN_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: ENERGY_TYPES.WATER,
        hitPoints: 60,
        id: 'vs_089_en',
        illustrator: '',
        moves: [],
        name: `${KAREN_PREFIX} ${FLAREON.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: FLAREON.number,
        pokemonType: FLAREON.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 89,
        trainerImageUrl: KAREN_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyResistance: ENERGY_TYPES.PSYCHIC,
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.DARKNESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 70,
        id: 'vs_090_en',
        illustrator: '',
        moves: [],
        name: `${KAREN_PREFIX} ${TYRANITAR$1.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: TYRANITAR$1.number,
        pokemonType: TYRANITAR$1.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 90,
        trainerImageUrl: KAREN_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyResistance: ENERGY_TYPES.PSYCHIC,
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.DARKNESS,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 60,
        holo: true,
        holoStrength: 0.7,
        id: 'vs_091_en',
        illustrator: '',
        moves: [],
        name: `${KAREN_PREFIX} ${UMBREON.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: UMBREON.number,
        pokemonType: UMBREON.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 91,
        trainerImageUrl: KAREN_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: ENERGY_TYPES.WATER,
        hitPoints: 60,
        id: 'vs_092_en',
        illustrator: '',
        moves: [],
        name: `${KAREN_PREFIX} ${HOUNDOOM.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: HOUNDOOM.number,
        pokemonType: HOUNDOOM.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 92,
        trainerImageUrl: KAREN_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.PSYCHIC,
        energyWeakness: ENERGY_TYPES.PSYCHIC,
        hitPoints: 70,
        holo: true,
        holoStrength: 0.7,
        id: 'vs_093_en',
        illustrator: '',
        moves: [],
        name: `${ROCKET_PREFIX} ${WOBBUFFET.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: WOBBUFFET.number,
        pokemonType: WOBBUFFET.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 93,
        trainerImageUrl: ROCKET_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 60,
        holo: true,
        holoStrength: 0.7,
        id: 'vs_094_en',
        illustrator: '',
        moves: [],
        name: `${ROCKET_PREFIX} ${RAIKOU.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: RAIKOU.number,
        pokemonType: RAIKOU.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 94,
        trainerImageUrl: ROCKET_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: ENERGY_TYPES.WATER,
        hitPoints: 70,
        holo: true,
        holoStrength: 0.7,
        id: 'vs_095_en',
        illustrator: '',
        moves: [],
        name: `${ROCKET_PREFIX} ${ENTEI.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: ENTEI.number,
        pokemonType: ENTEI.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 95,
        trainerImageUrl: ROCKET_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 1,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 60,
        holo: true,
        holoStrength: 0.7,
        id: 'vs_096_en',
        illustrator: '',
        moves: [],
        name: `${ROCKET_PREFIX} ${SUICUNE.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: SUICUNE.number,
        pokemonType: SUICUNE.pokemonType,
        rarity: RARITY_TYPES.RARE,
        setNumber: 96,
        trainerImageUrl: ROCKET_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.FIRE,
        energyWeakness: ENERGY_TYPES.WATER,
        hitPoints: 80,
        id: 'vs_097_en',
        illustrator: '',
        moves: [],
        name: `${LANCE_PREFIX} ${CHARIZARD.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: CHARIZARD.number,
        pokemonType: CHARIZARD.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 97,
        trainerImageUrl: LANCE_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 70,
        id: 'vs_098_en',
        illustrator: '',
        moves: [],
        name: `${LANCE_PREFIX} ${GYARADOS.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: GYARADOS.number,
        pokemonType: GYARADOS.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 98,
        trainerImageUrl: LANCE_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyResistance: ENERGY_TYPES.FIGHTING,
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.FIGHTING,
        energyWeakness: ENERGY_TYPES.GRASS,
        hitPoints: 60,
        id: 'vs_099_en',
        illustrator: '',
        moves: [],
        name: `${LANCE_PREFIX} ${AERODACTYL.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: AERODACTYL.number,
        pokemonType: AERODACTYL.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 99,
        trainerImageUrl: LANCE_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.COLORLESS,
        hitPoints: 70,
        id: 'vs_100_en',
        illustrator: '',
        moves: [],
        name: `${LANCE_PREFIX} ${DRAGONITE.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: DRAGONITE.number,
        pokemonType: DRAGONITE.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 100,
        trainerImageUrl: LANCE_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 3,
        energyType: ENERGY_TYPES.LIGHTNING,
        energyWeakness: ENERGY_TYPES.FIGHTING,
        hitPoints: 80,
        id: 'vs_101_en',
        illustrator: '',
        moves: [],
        name: `${LANCE_PREFIX} ${AMPHAROS.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: AMPHAROS.number,
        pokemonType: AMPHAROS.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 101,
        trainerImageUrl: LANCE_VS_IMAGE,
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.VS,
        description: '',
        energyRetreatCost: 2,
        energyType: ENERGY_TYPES.WATER,
        energyWeakness: ENERGY_TYPES.LIGHTNING,
        hitPoints: 70,
        id: 'vs_102_en',
        illustrator: '',
        moves: [],
        name: `${LANCE_PREFIX} ${KINGDRA.name}`,
        nameCondenseLevel: VS_NAME_CONDENSE_LEVEL,
        pokemonImagePositionX: 51,
        pokemonImagePositionY: 46,
        pokemonImageSize: 42,
        pokemonImageUrl: '',
        pokemonNumber: KINGDRA.number,
        pokemonType: KINGDRA.pokemonType,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 102,
        trainerImageUrl: LANCE_VS_IMAGE,
    },
];

const { FULL_HEAL, POTION, SWITCH } = BASE_TRAINERS;
const { ENERGY_FLOW, MASTER_BALL, WARP_POINT } = GYM_TRAINERS;
const { ENERGY_ARK, ENERGY_CHARGE, MOO_MOO_MILK, SUPER_SCOOP_UP } = NEO_TRAINERS;
const { ENERGY_RESTORE, POKEMON_REVERSAL } = E_SERIES_TRAINERS;
const VS_TRAINERS = [
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_VS,
        description: '',
        id: 'vs_103_en',
        illustrator: null,
        name: `${FALKNER_PREFIX} TM 01`,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 103,
        subtitle: '',
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_VS,
        description: '',
        id: 'vs_104_en',
        illustrator: null,
        name: `${FALKNER_PREFIX} TM 02`,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 104,
        subtitle: '',
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_VS,
        description: '',
        id: 'vs_105_en',
        illustrator: null,
        name: `${BUGSY_PREFIX} TM 01`,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 105,
        subtitle: '',
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_VS,
        description: '',
        id: 'vs_106_en',
        illustrator: null,
        name: `${BUGSY_PREFIX} TM 02`,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 106,
        subtitle: '',
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_VS,
        description: '',
        id: 'vs_107_en',
        illustrator: null,
        name: `${WHITNEY_PREFIX} TM 01`,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 107,
        subtitle: '',
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_VS,
        description: '',
        id: 'vs_108_en',
        illustrator: null,
        name: `${WHITNEY_PREFIX} TM 02`,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 108,
        subtitle: '',
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_VS,
        description: '',
        id: 'vs_109_en',
        illustrator: null,
        name: `${MORTY_PREFIX} TM 01`,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 109,
        subtitle: '',
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_VS,
        description: '',
        id: 'vs_110_en',
        illustrator: null,
        name: `${MORTY_PREFIX} TM 02`,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 110,
        subtitle: '',
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_VS,
        description: '',
        id: 'vs_111_en',
        illustrator: null,
        name: `${JASMINE_PREFIX} TM 01`,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 111,
        subtitle: '',
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_VS,
        description: '',
        id: 'vs_112_en',
        illustrator: null,
        name: `${JASMINE_PREFIX} TM 02`,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 112,
        subtitle: '',
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_VS,
        description: '',
        id: 'vs_113_en',
        illustrator: null,
        name: `${CHUCK_PREFIX} TM 01`,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 113,
        subtitle: '',
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_VS,
        description: '',
        id: 'vs_114_en',
        illustrator: null,
        name: `${CHUCK_PREFIX} TM 02`,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 114,
        subtitle: '',
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_VS,
        description: '',
        id: 'vs_115_en',
        illustrator: null,
        name: `${PRYCE_PREFIX} TM 01`,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 115,
        subtitle: '',
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_VS,
        description: '',
        id: 'vs_116_en',
        illustrator: null,
        name: `${PRYCE_PREFIX} TM 02`,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 116,
        subtitle: '',
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_VS,
        description: '',
        id: 'vs_117_en',
        illustrator: null,
        name: `${CLAIR_PREFIX} TM 01`,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 117,
        subtitle: '',
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_VS,
        description: '',
        id: 'vs_118_en',
        illustrator: null,
        name: `${CLAIR_PREFIX} TM 02`,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 118,
        subtitle: '',
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_VS,
        description: '',
        id: 'vs_119_en',
        illustrator: null,
        name: `${JANINE_PREFIX} TM 01`,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 119,
        subtitle: '',
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_VS,
        description: '',
        id: 'vs_120_en',
        illustrator: null,
        name: `${JANINE_PREFIX} TM 02`,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 120,
        subtitle: '',
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_VS,
        description: '',
        id: 'vs_121_en',
        illustrator: null,
        name: `${WILL_PREFIX} TM 01`,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 121,
        subtitle: '',
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_VS,
        description: '',
        id: 'vs_122_en',
        illustrator: null,
        name: `${WILL_PREFIX} TM 02`,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 122,
        subtitle: '',
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_VS,
        description: '',
        id: 'vs_123_en',
        illustrator: null,
        name: `${BRUNO_PREFIX} TM 01`,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 123,
        subtitle: '',
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_VS,
        description: '',
        id: 'vs_124_en',
        illustrator: null,
        name: `${BRUNO_PREFIX} TM 02`,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 124,
        subtitle: '',
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_VS,
        description: '',
        id: 'vs_125_en',
        illustrator: null,
        name: `${KAREN_PREFIX} TM 01`,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 125,
        subtitle: '',
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_VS,
        description: '',
        id: 'vs_126_en',
        illustrator: null,
        name: `${KAREN_PREFIX} TM 02`,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 126,
        subtitle: '',
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_VS,
        description: '',
        id: 'vs_127_en',
        illustrator: null,
        name: `${ROCKET_PREFIX} TM 01`,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 127,
        subtitle: '',
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_VS,
        description: '',
        id: 'vs_128_en',
        illustrator: null,
        name: `${LANCE_PREFIX} TM 01`,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 128,
        subtitle: '',
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_VS,
        description: '',
        id: 'vs_129_en',
        illustrator: null,
        name: `${LANCE_PREFIX} TM 02`,
        rarity: RARITY_TYPES.UNCOMMON,
        setNumber: 129,
        subtitle: '',
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_VS,
        description: '',
        id: 'vs_130_en',
        illustrator: null,
        name: POTION.name,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 130,
        subtitle: '',
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_VS,
        description: '',
        id: 'vs_131_en',
        illustrator: null,
        name: MOO_MOO_MILK.name,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 131,
        subtitle: '',
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_VS,
        description: '',
        id: 'vs_132_en',
        illustrator: null,
        name: FULL_HEAL.name,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 132,
        subtitle: '',
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_VS,
        description: '',
        id: 'vs_133_en',
        illustrator: null,
        name: POKEMON_REVERSAL.name,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 133,
        subtitle: '',
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_VS,
        description: '',
        id: 'vs_134_en',
        illustrator: null,
        name: SWITCH.name,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 134,
        subtitle: '',
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_VS,
        description: '',
        id: 'vs_135_en',
        illustrator: null,
        name: WARP_POINT.name,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 135,
        subtitle: '',
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_VS,
        description: '',
        id: 'vs_136_en',
        illustrator: null,
        name: SUPER_SCOOP_UP.name,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 136,
        subtitle: '',
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_VS,
        description: '',
        id: 'vs_137_en',
        illustrator: null,
        name: ENERGY_FLOW.name,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 137,
        subtitle: '',
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_VS,
        description: '',
        id: 'vs_138_en',
        illustrator: null,
        name: ENERGY_CHARGE.name,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 138,
        subtitle: '',
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_VS,
        description: '',
        id: 'vs_139_en',
        illustrator: null,
        name: ENERGY_ARK.name,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 139,
        subtitle: '',
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_VS,
        description: '',
        id: 'vs_140_en',
        illustrator: null,
        name: ENERGY_RESTORE.name,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 140,
        subtitle: '',
    },
    {
        backgroundImageUrl: '',
        cardTemplate: CARD_TEMPLATES.TRAINER_VS,
        description: '',
        id: 'vs_141_en',
        illustrator: null,
        name: MASTER_BALL.name,
        rarity: RARITY_TYPES.COMMON,
        setNumber: 141,
        subtitle: '',
    },
];

const { TYRANITAR } = GEN_2_POKEMON;
const VS_SECRET = {
    backgroundImageUrl: '',
    cardTemplate: CARD_TEMPLATES.VS,
    description: '',
    energyResistance: ENERGY_TYPES.PSYCHIC,
    energyRetreatCost: 3,
    energyType: ENERGY_TYPES.DARKNESS,
    energyWeakness: ENERGY_TYPES.FIGHTING,
    hitPoints: 80,
    holo: true,
    holoStrength: 0.7,
    id: 'vs_142_en',
    illustrator: '',
    moves: [],
    name: `${ROCKET_PREFIX} ${TYRANITAR.name}`,
    nameCondenseLevel: 2,
    pokemonImagePositionX: 51,
    pokemonImagePositionY: 46,
    pokemonImageSize: 42,
    pokemonImageUrl: '',
    pokemonNumber: TYRANITAR.number,
    pokemonType: TYRANITAR.pokemonType,
    rarity: RARITY_TYPES.RARE,
    setNumber: 142,
    trainerImageUrl: ROCKET_MARAUDER_VS_IMAGE,
};

const setId = CARD_SETS_JPN.VS.value;
const setTotal = VS_SET_TOTAL;
const setName = CARD_SETS_JPN.VS.label;
const VS_SET = {
    cardTemplate: CARD_TEMPLATES.VS,
    copyright: COPYRIGHTS.VS_SET,
    description: SET_DESCRIPTIONS.VS,
    firstEdition: true,
    holoSheetType: CARD_HOLO_SHEETS.COSMOS_4,
    id: setId,
    imageUrl: 'https://cdn.shopify.com/s/files/1/0840/1659/5249/collections/vs-cat-bg.jpg',
    name: setName,
    releaseDate: RELEASE_DATES.VS,
    reverseHoloSheetType: CARD_HOLO_SHEETS.COSMOS_2,
    setSymbol: setId,
    setTotal: setTotal,
    cards: [...VS_SET_CARDS, ...VS_TRAINERS, VS_SECRET],
};

const getCardSetIdsArray = () => {
    const stringArr = [];
    Object.values(CARD_SETS).map((set) => {
        stringArr.push(set.value);
    });
    return stringArr;
};
const getTcgSetById = (setId) => {
    if (!setId)
        return null;
    switch (setId) {
        case CARD_SETS.BASE.value:
            return BASE_SET;
        case CARD_SETS.JUNGLE.value:
            return JUNGLE_SET;
        case CARD_SETS.FOSSIL.value:
            return FOSSIL_SET;
        case CARD_SETS.TEAM_ROCKET.value:
            return ROCKET_SET;
        case CARD_SETS.BASE_2.value:
            return BASE_SET_TWO;
        case CARD_SETS.GYM_HEROES.value:
            return GYM_HEROES_SET;
        case CARD_SETS.GYM_CHALLENGE.value:
            return GYM_CHALLENGE_SET;
        case CARD_SETS.LEGENDARY_COLLECTION.value:
            return LEGENDARY_COLLECTION_SET;
        case CARD_SETS.NEO_GENESIS.value:
            return NEO_GENESIS_SET;
        case CARD_SETS.NEO_DISCOVERY.value:
            return NEO_DISCOVERY_SET;
        case CARD_SETS.NEO_REVELATION.value:
            return NEO_REVELATION_SET;
        case CARD_SETS.NEO_DESTINY.value:
            return NEO_DESTINY_SET;
        case CARD_SETS.SOUTHERN_ISLANDS.value:
            return SOUTHERN_ISLANDS_SET;
        case CARD_SETS.BLACK_STAR_PROMO.value:
            return BLACK_STAR_PROMO_SET;
        case CARD_SETS.BEST_OF_GAME.value:
            return BEST_OF_GAME_SET;
        case CARD_SETS.EXPEDITION.value:
            return EXPEDITION_SET;
        case CARD_SETS.AQUAPOLIS.value:
            return AQUAPOLIS_SET;
        case CARD_SETS.SKYRIDGE.value:
            return SKYRIDGE_SET;
    }
};
const getTcgCardById = (setId, cardId) => {
    if (!setId || !cardId)
        return;
    const cardSet = getTcgSetById(setId);
    const cardSetCards = cardSet && cardSet.cards;
    if (cardSetCards && cardSetCards.length) {
        return cardSetCards.find((card) => {
            return card.id === cardId;
        });
    }
};
const isEnglishFirstEditionAvailable = (setId) => {
    if (!setId)
        return false;
    return ENGLISH_FIRST_EDITION_SETS.includes(setId);
};
const isEnglishPromoSet = (setId) => {
    if (!setId)
        return false;
    return ENGLISH_PROMO_SETS.includes(setId);
};
const isESeriesSet = (setId) => {
    const eSeriesSets = [EXPEDITION_SET.id, AQUAPOLIS_SET.id, SKYRIDGE_SET.id];
    return setId && eSeriesSets.includes(setId);
};
const getThemeDeckCards = (setId, themeDeckCards) => {
    if (!themeDeckCards || !themeDeckCards.length)
        return [];
    return themeDeckCards.map((themeDeckCard) => {
        const card = getTcgCardById(themeDeckCard.setId || setId, themeDeckCard.id);
        return {
            ...card,
            count: themeDeckCard.count,
            setSymbol: themeDeckCard.setId || setId,
        };
    });
};

const CARD_LABELS = {
    en: {
        baby: 'Baby Pokémon',
        babyRule: 'Baby Pokémon counts as a Basic Pokémon',
        basic: 'Basic Pokémon',
        energy: 'Energy',
        evolvesFrom: 'Evolves from',
        evolvesTo: 'Evolves to',
        hp: '<HP> HP',
        length: 'Length',
        level: 'LV.',
        measurements: 'standard',
        number: '#',
        pokemonType: '<TYPE> Pokémon.',
        put: 'Put <PKMN> on the',
        putBaby: 'Put <PKMN> on the Baby Pokémon',
        resistance: 'resistance',
        retreatCost: 'retreat cost',
        shiningRule: `You can't have more than 1 <PKMN> in your deck.`,
        stage: 'Stage <STAGENUM>',
        stageCard: 'Stage <STAGENUM> card',
        stagePokemon: 'Stage <STAGENUM> Pokémon',
        trainer: 'Trainer',
        unownRule: 'You may have up to 4 Basic Pokémon cards in your deck with Unown in their names.',
        weakness: 'weakness',
        weight: 'Weight',
    },
    jp: {
        baby: 'ベイビーポケモン',
        babyRule: 'ベビーポケモンはベーシックポケモンとしてカウントされます',
        basic: 'たね',
        energy: 'Energy',
        evolvesFrom: 'から進化する',
        evolvesTo: 'に進化します',
        hp: 'HP<HP>',
        length: '長さ',
        level: 'LV.',
        measurements: 'metric',
        number: 'NO',
        pokemonType: '<TYPE> ポケモン.',
        put: '置く <PKMN> で',
        putBaby: 'ベビーポケモンに <PKMN> を付ける',
        resistance: '抵抗力',
        retreatCost: 'にげる',
        shiningRule: `デッキには <PKMN> を 1 枚以上入れることはできません。`,
        stage: '<STAGENUM>進化',
        stageCard: '<STAGENUM>進化',
        stagePokemon: '<STAGENUM>進化ポケモン',
        trainer: 'Trainer',
        unownRule: 'デッキには、名前に「アンノーン」を含む基本ポケモンカードを最大 4 枚まで入れることができます。',
        weakness: '弱点',
        weight: '重さ',
    },
    gr: {
        baby: 'Baby-Pokémon',
        babyRule: 'Das Baby-Pokémon zählt als Basis-Pokémon',
        basic: 'Basis-Pokémon',
        energy: 'Energie',
        evolvesFrom: 'Entsteht aus',
        evolvesTo: 'Entwickelt sich zu',
        hp: '<HP> KP',
        length: 'Größe',
        level: 'LV.',
        measurements: 'metric',
        number: 'Nr.',
        pokemonType: '<TYPE>-Pokémon.',
        put: 'Lege <PKMN> auf die',
        putBaby: 'Lege <PKMN> auf das Baby-Pokémon',
        resistance: 'Resistenz',
        retreatCost: 'Rückzugskosten',
        shiningRule: `Du kannst nicht mehr als ein <PKMN> in deinem Deck haben.`,
        stage: 'Phase <STAGENUM>',
        stageCard: 'Karte der Phase <STAGENUM>',
        stagePokemon: 'Pokémon der Phase <STAGENUM> ',
        trainer: 'Trainer',
        unownRule: 'Du kannst bis zu 4 Basis-Pokémonkarten in deinem Deck haben, die „Icognito“ in ihrem Namen haben.',
        weakness: 'Schwäche',
        weight: 'Gewicht',
    },
    fr: {
        baby: 'Bébé Pokémon',
        babyRule: 'Les Bébés Pokémon sont considérés comme des Pokémon de base',
        basic: 'Pokémon de base',
        energy: 'Énergie',
        evolvesFrom: 'Évolution de',
        evolvesTo: 'Évolue en',
        hp: '<HP> PV',
        length: 'Taille',
        level: 'NIV.',
        measurements: 'metric',
        number: 'No.',
        pokemonType: 'Pokémon <TYPE>.',
        put: 'Placez <PKMN> sur la',
        putBaby: 'Placez <PKMN> sur le Bébé Pokémon',
        resistance: 'Résistance',
        retreatCost: 'Coût de retraite',
        shiningRule: 'Vous ne pouvez pas avoir plus de 1 <PKMN> dans votre deck.',
        stage: 'Niveau <STAGENUM>',
        stageCard: 'carte Niveau <STAGENUM>',
        stagePokemon: 'Pokémon de Niveau <STAGENUM>',
        trainer: 'Dresseur',
        unownRule: 'Votre deck peut comporter jusqu a 4 cartes Pokémon de base Zarbi différentes.',
        weakness: 'Faiblesse',
        weight: 'poids',
    },
    it: {
        baby: 'Baby Pokémon',
        babyRule: 'Un Baby Pokémon conta come un Pokémon Base',
        basic: 'Pokémon Base',
        energy: 'Energia',
        evolvesFrom: 'Evolve da',
        evolvesTo: 'Evolve in',
        hp: '<HP> PV',
        length: 'Lunghezza',
        level: 'LV.',
        measurements: 'metric',
        number: '#',
        pokemonType: 'Pokémon <TYPE>.',
        put: 'Metti <PKMN> sulla',
        putBaby: 'Metti <PKMN> sul Baby Pokémon',
        resistance: 'resistenza',
        retreatCost: 'costo di ritirata',
        shiningRule: `Non puoi avere più di 1 <PKMN> nel tuo mazzo.`,
        stage: 'Fase <STAGENUM>',
        stageCard: 'carta di Fase <STAGENUM>',
        stagePokemon: 'Pokémon di Fase <STAGENUM>',
        trainer: 'Addestramento',
        unownRule: 'Puoi avere nel tuo mazzo fino a 4 carte Pokémon Base con la parola Unown nel loro nome.',
        weakness: 'debolezza',
        weight: 'Peso',
    },
    sp: {
        baby: 'Pokémon Bebé',
        babyRule: 'El Pokémon Bebé cuenta como Pokémon Básico',
        basic: 'Pokémon Básico',
        energy: 'Energía',
        evolvesFrom: 'Evoluciona de',
        evolvesTo: 'Evoluciona en',
        hp: '<HP> PI',
        length: 'Longitud',
        level: 'Ni.',
        measurements: 'metric',
        number: 'Nº',
        pokemonType: 'Pokémon <TYPE>.',
        put: 'Poner a <PKMN> sobre la',
        putBaby: 'Poner a <PKMN> sobre el Pokémon Bebé',
        resistance: 'Resistencia',
        retreatCost: 'Coste de retirada',
        shiningRule: 'No puedes tener más de 1 <PKMN> en tu deck.',
        stage: 'Etapa <STAGENUM>',
        stageCard: 'la carta de ETAPA <STAGENUM>',
        stagePokemon: 'Pokémon de ETAPA <STAGENUM>',
        trainer: 'Entrenador',
        unownRule: 'Puedes tener hasta 4 cartas de Pokémon Básico en tu mazo con Unown en sus nombres.',
        weakness: 'Debilidad',
        weight: 'peso',
    },
    ko: {
        baby: '아기 포켓몬',
        babyRule: '아기 포켓몬은 기본 포켓몬으로 간주됩니다',
        basic: '기본 포켓몬',
        energy: 'Energy',
        evolvesFrom: '에서 진화',
        evolvesTo: '에서 진화',
        hp: '<HP> HP',
        length: '키',
        level: 'LV.',
        measurements: 'metric',
        number: 'NO.',
        pokemonType: '<TYPE> 포켓몬.',
        put: '1단계 카드에 <PKMN> 를 넣으세요',
        putBaby: '아기 포켓몬에 <PKMN> 를 넣어주세요',
        resistance: '저항력',
        retreatCost: '후퇴 비용',
        shiningRule: `덱에는 <PKMN> 가 1개 이상 들어갈 수 없습니다.`,
        stage: '<STAGENUM>진화',
        stageCard: '<STAGENUM>단계 카드',
        stagePokemon: '<STAGENUM>단계 포켓몬',
        trainer: 'Trainer',
        unownRule: "덱에는 이름에 '안농'이 포함된 기본 포켓몬 카드를 최대 4장까지 넣을 수 있습니다.",
        weakness: '약점',
        weight: '뭄무게',
    },
    pt: {
        baby: 'Pokémon Bebê',
        babyRule: 'Pokémon bebê conta como Pokémon básico',
        basic: 'Pokémon Básico',
        energy: 'Energia',
        evolvesFrom: 'Evolui do',
        evolvesTo: 'Evolui para',
        hp: '<HP> PS',
        length: 'Altura',
        level: 'NV.',
        measurements: 'metric',
        number: 'Nº',
        pokemonType: 'Pokémon <TYPE>.',
        put: 'Coloque <PKMN> sobre o',
        putBaby: 'Coloque <PKMN> no Pokémon bebê',
        resistance: 'Resistência',
        retreatCost: 'Custo para Recuar',
        shiningRule: `Você não pode ter mais de 1 <PKMN> no seu deck.`,
        stage: 'Estágio <STAGENUM>',
        stageCard: 'carta do Estágio <STAGENUM>',
        stagePokemon: 'Pokémon do Estágio <STAGENUM>',
        trainer: 'Treinador',
        unownRule: 'Você pode ter até 4 cards de Pokémon Básicos no seu deck com Unown no nome.',
        weakness: 'Fraqueza',
        weight: 'Peso',
    },
};

const CARD_FRAME_IMAGES = [
    {
        label: 'Leather (Hypno)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/leather-bgpng_f6jkdb.png',
    },
    {
        label: 'Lights (Kadabra)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lights-kadabra_hrrzpa.jpg',
    },
    {
        label: 'Water (Seel)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/water-seel_psmkpp.jpg',
    },
    {
        label: 'Water (Seaking)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/water-seaking_tanzgv.jpg',
    },
    {
        label: 'Water (Poliwhirl)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/water-poliwhirl_oxfvdh.jpg',
    },
    {
        label: 'Water (Seel)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/water-mistys-seel_cwlkjb.jpg',
    },
    {
        label: 'Walls (Oak)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/walls-professor-oak2_ckudat.jpg',
    },
    {
        label: 'Walls (Oak) Alt',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/walls-professor-oak_scqksk.jpg',
    },
    {
        label: 'Walls (Impostor)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/walls-impostor-oak_px3lzq.jpg',
    },
    {
        label: 'Walls (Bill)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/walls-bill_y8j4zv.jpg',
    },
    {
        label: 'Nature (Tangela)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/tangela-gym_hfn1ly.jpg',
    },
    {
        label: 'Metal (Trainer)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/trainer_ej24q6.jpg',
    },
    {
        label: 'Lights (Mr. Mime)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lights-mr-mime_mccewf.jpg',
    },
    {
        label: 'Sunset (Oddish)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/sunset-oddish_oynkri.jpg',
    },
    {
        label: 'Rust (Gloom)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/rust-erikas-gloom_rludho.jpg',
    },
    {
        label: 'Lights (Zapdos)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lights-gb-zapdos_pz23dz.jpg',
    },
    {
        label: 'Pastels (Snorlax)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-snorlax_r7bnvv.jpg',
    },
    {
        label: 'Pastels (Abra)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-sabrinas-abra_he95ft.jpg',
    },
    {
        label: 'Lights (Moltres)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lights-gb-moltres_wdkt8g.jpg',
    },
    {
        label: 'Pastels (Moltres)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-rockets-moltres_badehb.jpg',
    },
    {
        label: 'Lights (Magnemite)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lights-gb-magnemite_l0aclw.jpg',
    },
    {
        label: 'Lights (Magby)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lights-magby_eanl2m.jpg',
    },
    {
        label: 'Lights (Jynx)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lights-jynx_grozno.jpg',
    },
    {
        label: 'Pastels (Raticate)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-raticate_af09tb.jpg',
    },
    {
        label: 'Pastels (PKMN Trader)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-pkmn-trader_soqbah.jpg',
    },
    {
        label: 'Pastels (Mew)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-mew_shnlml.jpg',
    },
    {
        label: 'Pastels (Lass)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-lass_yyfpg2.jpg',
    },
    {
        label: 'Pastels (Kabutops)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-kabutops_ox1atw.jpg',
    },
    {
        label: 'Pastels (Kabutops) Alt',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-kabutops2_wuiag5.jpg',
    },
    {
        label: 'Lights (Dratini)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lights-erikas-dratini_e65qcs.jpg',
    },
    {
        label: 'Pastels (Hitmonlee)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-hitmonlee_xqc8ip.jpg',
    },
    {
        label: 'Pastels (Hitmonlee) Alt',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-hitmonlee2_iiyl9x.jpg',
    },
    {
        label: 'Nature (Energy)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/leaf-potion-energy_lqofub.jpg',
    },
    {
        label: 'Foliage (Gloom)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/foliage-erikas-gloom_v2u2vs.jpg',
    },
    {
        label: 'Lights (Drowzee)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lights-drowzee_yywzks.jpg',
    },
    {
        label: 'Lightning (Raichu)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lightning-surges-raichu_vx4d4b.jpg',
    },
    {
        label: 'Lightning (Electabuzz)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lightning-electabuzz_a0idex.jpg',
    },
    {
        label: 'Pastels (Ekans)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-ekans_inxykw.jpg',
    },
    {
        label: 'Nature (Parasect)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-parasect_w8vbg8.jpg',
    },
    {
        label: 'Pastels (Chansey)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-chansey_fmsdky.jpg',
    },
    {
        label: 'Pastels (Articuno)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-articuno_gydb54.jpg',
    },
    {
        label: 'Pastels (Arbok)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/pastels-arbok_pqj82p.jpg',
    },
    {
        label: 'Nature (Scyther)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-scyther_bffn5q.jpg',
    },
    {
        label: 'Nature (Sandshrew)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-sandshrew_h02xle.jpg',
    },
    {
        label: 'Nature (Pidgey)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-pidgey_ggcjcw.jpg',
    },
    {
        label: 'Nature (Breeder)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-pkmn-breeder_htdred.jpg',
    },
    {
        label: 'Nature (Onix)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-onix_xf2mva.jpg',
    },
    {
        label: 'Nature (Pidgeotto)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-pidgeotto_ej6gms.jpg',
    },
    {
        label: 'Nature (Nidoran)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-nidoran_fjwr09.jpg',
    },
    {
        label: 'Nature (Nidoqueen)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-nidoqueen_sovd2b.jpg',
    },
    {
        label: 'Nature (Poliwrath)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-mistys-poliwrath_xn8wfw.jpg',
    },
    {
        label: 'Nature (Miltank)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-miltank_umnk8w.jpg',
    },
    {
        label: 'Nature (Growlithe)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-growlithe_nyginj.jpg',
    },
    {
        label: 'Nature (Bulbasaur)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-erikas-bulbasaur_zmljnk.jpg',
    },
    {
        label: 'Nature (Dratini)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-dratini_vxrsjo.jpg',
    },
    {
        label: 'Nature (Caterpie)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-caterpie_tcfh1l.jpg',
    },
    {
        label: 'Nature (Charizard)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-charizard-cd_ewdfvb.jpg',
    },
    {
        label: 'Nature (Vulpix)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-brocks-vulpix_cjhesd.jpg',
    },
    {
        label: 'Nature (Zubat)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-brocks-zubat_jyfmxr.jpg',
    },
    {
        label: 'Nature (Graveler)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-brocks-graveler_n4un3i.jpg',
    },
    {
        label: 'Pastels (Lass) Alt',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/blotchy-lass_ngz0br.jpg',
    },
    {
        label: 'Nature (Diglett)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/nature-brocks-diglett_e2hxfq.jpg',
    },
    {
        label: 'Flowers (Venomoth)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/flowers-venomoth_fujz4e.jpg',
    },
    {
        label: 'Metal (Raichu)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/metal-surges-raichu_bo84ld.jpg',
    },
    {
        label: 'Hills (Ponyta)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/hills-ponyta_bcekdh.jpg',
    },
    {
        label: 'Lights (Vulpix)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lights-vulpix_alf7eb.jpg',
    },
    {
        label: 'Flames (Magmar)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/flames-magmar_s5ibam.jpg',
    },
    {
        label: 'Bubbles (Mew)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lights-vending-mew_jl3mdi.jpg',
    },
    {
        label: 'Flowers (Ivysaur)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/flowers-erikas-ivysaur_avy6wo.jpg',
    },
    {
        label: 'Lights (Skarmory)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lights-skarmory_sakiwh.jpg',
    },
    {
        label: 'Lights (Slowbro)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lights-sabrinas-slowbro_njzic9.jpg',
    },
    {
        label: 'Lights (Slowbro) Alt',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lights-sabrinas-slowbro2_teytxx.jpg',
    },
    {
        label: 'Lights (Alakazam)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lights-rocket-alakazam_oytsc1.jpg',
    },
    {
        label: 'Cool Flames (Machop)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/cool-flames-machop_gyjqak.jpg',
    },
    {
        label: 'Lights (Machop)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lights-rocket-machop_w8x73u.jpg',
    },
    {
        label: 'Lightning (Pikachu)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/electrify-pikachu_monhqm.jpg',
    },
    {
        label: 'Lights (Pichu)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lights-pichu_y9ivyq.jpg',
    },
    {
        label: 'Circuits (Porygon)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/circuit-board-porygon_b9fu5g.jpg',
    },
    {
        label: 'Beach (Wartortle)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/beach-wartortle_evqwrg.jpg',
    },
    {
        label: 'Lights (Persian)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/lights-promo-persian_xe7fcr.jpg',
    },
    {
        label: 'Cool Flames (Hitmonchan)',
        value: 'https://poketcgshop.s3.amazonaws.com/card-frame-bgs/cool-flames-hitmonchan_uq8mwk.jpg',
    },
];

const MASAKI_MOVES = {
    PAY_HORROR: {
        name: 'Pay Horror',
        damage: 30,
        description: 'Flip a coin. If heads, the Defending Pokémon is now Asleep. If tails, the Defending Pokémon is now Confused.',
        energyCost: ['psychic', 'psychic', 'psychic'],
    },
    POWER_OF_DARKNESS: {
        name: 'Power Of Darkness',
        description: "When you play Gengar from your hand, you may flip a coin. If heads, choose 1 of your opponent's Pokémon. Your opponent returns that Pokémon and all cards attached to it to his or her hand.",
        specialMoveType: POKE_SPECIAL_MOVE_TYPES.POKE_POWER,
    },
};

exports.AQUAPOLIS_1_JP_SET_TOTAL = AQUAPOLIS_1_JP_SET_TOTAL;
exports.AQUAPOLIS_2_JP_SET_TOTAL = AQUAPOLIS_2_JP_SET_TOTAL;
exports.AQUAPOLIS_SET = AQUAPOLIS_SET;
exports.AQUAPOLIS_SET_TOTAL = AQUAPOLIS_SET_TOTAL;
exports.BASE_SET = BASE_SET;
exports.BASE_SET_TOTAL = BASE_SET_TOTAL;
exports.BASE_SET_TWO = BASE_SET_TWO;
exports.BASE_SET_TWO_TOTAL = BASE_SET_TWO_TOTAL;
exports.BASIC_PKMN_LABEL = BASIC_PKMN_LABEL;
exports.BEST_OF_GAME_SET = BEST_OF_GAME_SET;
exports.BLACK_STAR_PROMO_SET = BLACK_STAR_PROMO_SET;
exports.BLEND_MODES = BLEND_MODES;
exports.BOOSTER_PACKS = BOOSTER_PACKS;
exports.CARD_FRAME_IMAGES = CARD_FRAME_IMAGES;
exports.CARD_HOLO_SHEETS = CARD_HOLO_SHEETS;
exports.CARD_LABELS = CARD_LABELS;
exports.CARD_SETS = CARD_SETS;
exports.CARD_SETS_JPN = CARD_SETS_JPN;
exports.CARD_TEMPLATES = CARD_TEMPLATES;
exports.CARD_TEMPLATE_SUBTYPES = CARD_TEMPLATE_SUBTYPES;
exports.COPYRIGHTS = COPYRIGHTS;
exports.DAMAGE_MODIFIER_VALUES = DAMAGE_MODIFIER_VALUES;
exports.DONT_APPLY_WEAKNESS = DONT_APPLY_WEAKNESS;
exports.DONT_APPLY_WEAKNESS_BENCHED = DONT_APPLY_WEAKNESS_BENCHED;
exports.DOT_MATRIX_POSITIONS = DOT_MATRIX_POSITIONS;
exports.ENERGY_TYPES = ENERGY_TYPES;
exports.ENGLISH_FIRST_EDITION_SETS = ENGLISH_FIRST_EDITION_SETS;
exports.ENGLISH_PROMO_SETS = ENGLISH_PROMO_SETS;
exports.EXPEDITION_JP_SET_TOTAL = EXPEDITION_JP_SET_TOTAL;
exports.EXPEDITION_SET = EXPEDITION_SET;
exports.EXPEDITION_SET_TOTAL = EXPEDITION_SET_TOTAL;
exports.E_HOLO_SET_TOTAL = E_HOLO_SET_TOTAL;
exports.FOSSIL_SET = FOSSIL_SET;
exports.FOSSIL_SET_TOTAL = FOSSIL_SET_TOTAL;
exports.GEN_1_POKEMON = GEN_1_POKEMON;
exports.GEN_2_POKEMON = GEN_2_POKEMON;
exports.GEN_2_POKEMON_IMAGES = GEN_2_POKEMON_IMAGES;
exports.GYM_CHALLENGE_SET = GYM_CHALLENGE_SET;
exports.GYM_HEROES_SET = GYM_HEROES_SET;
exports.GYM_LEADERS = GYM_LEADERS;
exports.GYM_LEADER_IMAGES = GYM_LEADER_IMAGES;
exports.GYM_SET_TOTAL = GYM_SET_TOTAL;
exports.ILLUSTRATORS = ILLUSTRATORS;
exports.ILLUSTRATORS_TEAMS = ILLUSTRATORS_TEAMS;
exports.JUNGLE_SET = JUNGLE_SET;
exports.JUNGLE_SET_TOTAL = JUNGLE_SET_TOTAL;
exports.LEGENDARY_COLLECTION_SET = LEGENDARY_COLLECTION_SET;
exports.LEGENDARY_COLLECTION_SET_TOTAL = LEGENDARY_COLLECTION_SET_TOTAL;
exports.MASAKI_MOVES = MASAKI_MOVES;
exports.MEDIA_FACTORY_E_COPYRIGHT = MEDIA_FACTORY_E_COPYRIGHT;
exports.MOVES = MOVES;
exports.NEO_DESTINY_SET = NEO_DESTINY_SET;
exports.NEO_DESTINY_SET_TOTAL = NEO_DESTINY_SET_TOTAL;
exports.NEO_DISCOVERY_SET = NEO_DISCOVERY_SET;
exports.NEO_DISCOVERY_SET_TOTAL = NEO_DISCOVERY_SET_TOTAL;
exports.NEO_ERA_COPYRIGHT = NEO_ERA_COPYRIGHT;
exports.NEO_GENESIS_SET = NEO_GENESIS_SET;
exports.NEO_GENESIS_SET_TOTAL = NEO_GENESIS_SET_TOTAL;
exports.NEO_REVELATION_SET = NEO_REVELATION_SET;
exports.NEO_REVELATION_SET_TOTAL = NEO_REVELATION_SET_TOTAL;
exports.PACK_CARD_KEYS = PACK_CARD_KEYS;
exports.POKEMON_IMAGES = POKEMON_IMAGES;
exports.POKE_BODY_LABEL = POKE_BODY_LABEL;
exports.POKE_POWER_LABEL = POKE_POWER_LABEL;
exports.POKE_SPECIAL_MOVE_TYPES = POKE_SPECIAL_MOVE_TYPES;
exports.RARITY_TYPES = RARITY_TYPES;
exports.RELEASE_DATES = RELEASE_DATES;
exports.ROCKET_SET = ROCKET_SET;
exports.ROCKET_SET_TOTAL = ROCKET_SET_TOTAL;
exports.SET_DESCRIPTIONS = SET_DESCRIPTIONS;
exports.SKYRIDGE_1_JP_SET_TOTAL = SKYRIDGE_1_JP_SET_TOTAL;
exports.SKYRIDGE_2_JP_SET_TOTAL = SKYRIDGE_2_JP_SET_TOTAL;
exports.SKYRIDGE_SET = SKYRIDGE_SET;
exports.SKYRIDGE_SET_TOTAL = SKYRIDGE_SET_TOTAL;
exports.SOUTHERN_ISLANDS_SET = SOUTHERN_ISLANDS_SET;
exports.SPECIAL_CARD_TEMPLATES = SPECIAL_CARD_TEMPLATES;
exports.SPECIAL_ENERGIES = SPECIAL_ENERGIES;
exports.SPECIAL_ENERGY_TYPES = SPECIAL_ENERGY_TYPES;
exports.STAMP_TYPES = STAMP_TYPES;
exports.TRAINER_CARD_SUBTITLES = TRAINER_CARD_SUBTITLES;
exports.VS_SET = VS_SET;
exports.VS_SET_TOTAL = VS_SET_TOTAL;
exports.WEB_SET_TOTAL = WEB_SET_TOTAL;
exports.WOTC_1995_2000_COPYRIGHT = WOTC_1995_2000_COPYRIGHT;
exports.WOTC_1995_2001_COPYRIGHT = WOTC_1995_2001_COPYRIGHT;
exports.WOTC_2002_COPYRIGHT = WOTC_2002_COPYRIGHT;
exports.WOTC_EARLY_ERA_COPYRIGHT = WOTC_EARLY_ERA_COPYRIGHT;
exports.WOTC_E_2002_COPYRIGHT = WOTC_E_2002_COPYRIGHT;
exports.WOTC_E_2003_COPYRIGHT = WOTC_E_2003_COPYRIGHT;
exports.WOTC_LATE_ERA_COPYRIGHT = WOTC_LATE_ERA_COPYRIGHT;
exports.WOTC_SHADOWLESS_COPYRIGHT = WOTC_SHADOWLESS_COPYRIGHT;
exports.getCardSetIdsArray = getCardSetIdsArray;
exports.getTcgCardById = getTcgCardById;
exports.getTcgSetById = getTcgSetById;
exports.getThemeDeckCards = getThemeDeckCards;
exports.isESeriesSet = isESeriesSet;
exports.isEnglishFirstEditionAvailable = isEnglishFirstEditionAvailable;
exports.isEnglishPromoSet = isEnglishPromoSet;
exports.renderPkmnPowerDisclaimer = renderPkmnPowerDisclaimer;
//# sourceMappingURL=index.js.map
